webpackJsonp([0],Array(113).concat([
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/file-name,angular/module-name */
angular.module('zc.zenclerkS', ['ngResource', 'ui.bootstrap', 'zc.commonApi', 'zc.core']);

/***/ }),
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// TODO: move this file to common api!
angular.module('zc.commonApi').factory('Agency', Agency);

Agency.$inject = ['$q', 'Api'];
function Agency($q, Api) {
  var service = {
    all: all,
    get: get,
    update: update,
    getAgencyColor: getAgencyColor,
    getAgencyName: getAgencyName
  };

  return service;

  function all() {
    return Api.get('/api/agencies', {}, { cache: false }).then(function (res) {
      if (!res.data.success) {
        return $q.reject(res);
      }
      return res.data.agencies;
    });
  }

  function get(name) {
    return Api.get('/api/agencies/' + name, {}, { cache: false }).then(function (res) {
      if (!res.data.success) {
        return $q.reject(res);
      }
      return res.data.agency;
    });
  }

  function update(params) {
    return Api.patch('/api/agencies/name:' + params.name, params, { cache: false });
  }

  function getAgencyColor(id) {
    return 'list-item-avatar' + id % 15;
  }

  function getAgencyName(agencyName) {
    return agencyName;
  }
}

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.commonApi').factory('DashboardChartPositions', DashboardChartPositions);

DashboardChartPositions.$inject = ['$q', '$state', 'Api'];
function DashboardChartPositions($q, $state, Api) {
  var projectId = $state.params.projectId;

  var API_URL = '/api/projects/' + projectId + '/dashboard_chart_positions';
  return {
    create: create,
    get: get,
    update: update
  };

  function get() {
    return Api.get(API_URL, {}, { cache: false }).then(function (res) {
      if (!res.data.success) {
        return $q.reject(res);
      }
      return res.data;
    });
  }

  function create(positions) {
    return Api.post(API_URL, { positions: positions }, { cache: false });
  }

  function update(positions) {
    return Api.patch(API_URL, { positions: positions }, { cache: false });
  }
}

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable no-undef */
// import { ApolloClient } from 'apollo-client';
// import { ApolloLink } from 'apollo-link';
// import { onError } from 'apollo-link-error';
// import { HttpLink } from 'apollo-link-http';
// import { InMemoryCache } from 'apollo-cache-inmemory';

// const ApolloClient = require('apollo-client');
// const ApolloLink = require('apollo-link');
// const ApolloOnError = require('apollo-link-error');
// const HttpLink = require('apollo-link-http');
// const InMemoryCache = require('apollo-cache-inmemory');

var ApolloClient = __webpack_require__(567).ApolloClient;
var ApolloLink = __webpack_require__(39).ApolloLink;
var ApolloOnError = __webpack_require__(576).onError;
var HttpLink = __webpack_require__(579).HttpLink;
var InMemoryCache = __webpack_require__(560).InMemoryCache;
var setContext = __webpack_require__(570).setContext;

angular.module('zc.commonApi').factory('Apollo', Apollo);

Apollo.$inject = ['$q', 'Devise'];
function Apollo($q, Devise) {
  var service = {
    query: query,
    masterQuery: masterQuery,
    mutate: mutate
  };

  function createGraphQLClientForUrl(uri) {
    var httpLink = new HttpLink({
      uri: uri,
      batchInterval: 5,
      batchMax: 5,
      credentials: 'same-origin',
      mode: 'cors'
    });

    var authLink = setContext(function () {
      return Devise.getCurrentUser().then(function () {
        if (!Devise.currentUser) return;

        return {
          headers: {
            'X-LOGIN-TOKEN': Devise.currentUser.login_token
          }
        };
      });
    });

    var errorLink = ApolloOnError(function (_ref) {
      var graphQLErrors = _ref.graphQLErrors,
          networkError = _ref.networkError;

      if (graphQLErrors) {
        graphQLErrors.map(function (_ref2) {
          var message = _ref2.message,
              locations = _ref2.locations,
              path = _ref2.path;

          alertify.error(message, 0);
          // eslint-disable-next-line
          console.error('[GraphQL error]: Message: ' + message + ', Location: ' + JSON.stringify(locations, null, 2) + ', Path: ' + path);
          return null;
        });
      }

      if (networkError) {
        // eslint-disable-next-line
        console.error('[Network error]: ' + networkError);
      }
    });

    var link = ApolloLink.from([authLink, errorLink, httpLink]);

    // Create the apollo client
    var apolloClient = new ApolloClient({
      link: link,
      cache: new InMemoryCache(),
      connectToDevTools: true
    });
    return apolloClient;
  }

  var apolloClient = createGraphQLClientForUrl(ZC_CONFIG.GRAPHQL_URL_APP);
  var masterApolloClient = createGraphQLClientForUrl(ZC_CONFIG.GRAPHQL_URL_MASTER);

  return service;

  function query(_query, _variables) {
    var q = { query: _query };
    if (_variables) {
      q.variables = _variables;
    }

    return $q(function (resolve, reject) {
      apolloClient.query(q).then(function (res) {
        return void resolve(res.data);
      }).catch(function (error) {
        return void reject(error);
      });
    });
  }

  function masterQuery(_query, _variables) {
    return $q(function (resolve, reject) {
      if (Devise.isCommonUser()) return resolve(null);

      var q = { query: _query };
      if (_variables) {
        q.variables = _variables;
      }

      masterApolloClient.query(q).then(function (res) {
        return void resolve(res.data);
      }).catch(function (error) {
        return void reject(error);
      });
    });
  }

  function mutate(mutationOptions) {
    return $q(function (resolve, reject) {
      apolloClient.mutate(mutationOptions).then(function (res) {
        return void resolve(res.data);
      }).catch(function (error) {
        return void reject(error);
      });
    });
  }
}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('zc.commonApi').factory('CampaignConversionData', campaignConversionDataFactory);

function campaignConversionDataFactory(FacadeV2) {
  return function () {
    function CampaignConversionData() {
      _classCallCheck(this, CampaignConversionData);
    }

    _createClass(CampaignConversionData, null, [{
      key: 'find',
      value: function find(paths, params) {
        return FacadeV2.request('/apikeys/' + paths.apikey + '/campaign_conversion_data/find', { params: params }).then(function (res) {
          return res.data;
        });
      }
    }]);

    return CampaignConversionData;
  }();
}
campaignConversionDataFactory.$inject = ['FacadeV2'];

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.commonApi').factory('CampaignSegmentStats', CampaignSegmentStatsService);

CampaignSegmentStatsService.$inject = ['$q', 'FacadeV2'];
function CampaignSegmentStatsService($q, FacadeV2) {
  return {
    find: find,
    aggregate: aggregate
  };

  function find() {
    var paths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return $q(function (resolve, reject) {
      if (!paths.apikey) {
        var errorMsg = 'No apikey';
        console.error(errorMsg);
        return reject(errorMsg);
      }

      if (!paths.dimension) {
        var _errorMsg = 'No dimension';
        console.error(_errorMsg);
        return reject(_errorMsg);
      }

      return FacadeV2.request('/apikeys/' + paths.apikey + '/campaign_segment_stats/' + paths.dimension + '/find', {
        params: {
          match: query,
          sort: options.sort,
          limit: options.limit || 10000
        },
        cache: false
      }).then(function (res) {
        if (res.status !== 200 || res.data.error) {
          reject(_.get(res.data, 'error', 'Error fetching campaign segment stats'));
        } else {
          resolve(transformData(res.data));
        }
      });
    });
  }

  function aggregate() {
    var paths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return $q(function (resolve, reject) {
      if (!paths.apikey) {
        var errorMsg = 'No apikey';
        console.error(errorMsg);
        return reject(errorMsg);
      }

      if (!paths.dimension) {
        var _errorMsg2 = 'No dimension';
        console.error(_errorMsg2);
        return reject(_errorMsg2);
      }

      return FacadeV2.request('/apikeys/' + paths.apikey + '/campaign_segment_stats/' + paths.dimension + '/aggregate', {
        params: {
          match: query.match,
          pipeline: query.pipeline
        },
        cache: false
      }).then(function (res) {
        if (res.status !== 200 || res.data.error) {
          reject(_.get(res.data, 'error', 'Error fetching campaign segment stats'));
        } else {
          resolve(res.data);
        }
      });
    });
  }

  function transformData(campaignSegmentStats) {
    _.each(campaignSegmentStats, function (stats) {
      if (stats.start_at) {
        stats.start_at = new Date(stats.start_at).valueOf();
      }
      if (stats.end_at) {
        stats.end_at = new Date(stats.end_at).valueOf();
      }
    });
    return _.sortBy(campaignSegmentStats, function (stats) {
      return stats.start_at;
    });
  }
}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.commonApi').factory('CampaignStatsV2', CampaignStatsV2Service);

CampaignStatsV2Service.$inject = ['$q', 'FacadeV2'];
function CampaignStatsV2Service($q, FacadeV2) {
  var service = {
    find: find
  };

  return service;

  function find() {
    var paths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return $q(function (resolve, reject) {
      if (!paths.apikey) {
        var errorMsg = 'No apikey';
        console.error(errorMsg);
        return reject(errorMsg);
      }

      if (!paths.dimension) {
        var _errorMsg = 'No dimension';
        console.error(_errorMsg);
        return reject(_errorMsg);
      }

      var promise = FacadeV2.request('/apikeys/' + paths.apikey + '/campaign_stats/' + paths.dimension + '/find', {
        params: {
          match: query,
          sort: options.sort,
          limit: options.limit || 10000
        },
        cache: false
      }).then(function (res) {
        if (res.status !== 200 || res.data.error) {
          reject(_.get(res.data, 'error', 'Error fetching campaign stats'));
        } else {
          resolve(res.data);
        }
      });

      return promise;
    });
  }
}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.commonApi').factory('InterestWidgetItem', InterestWidgetItem);

var ITEM_COUNT_THRESHOLD = 5;
var ITEM_AGGREGATION_LIMIT = 5000;

InterestWidgetItem.$inject = ['FacadeV2'];
function InterestWidgetItem(FacadeV2) {
  return { aggregate: aggregate, aggregateByFilters: aggregateByFilters, rankByFilters: rankByFilters };

  function aggregate(paths, params) {
    return FacadeV2.request('/apikeys/' + paths.apikey + '/interest_widget_items/daily/aggregate', { params: params }).then(function (res) {
      return res.data;
    });
  }

  function aggregateByFilters(apikey, filters, pipeline) {
    return aggregate({ apikey: apikey }, {
      match: {
        device: filters.device,
        campaign_segment_id: filters.campaign_segment_id,
        start_at: {
          $gte: moment(filters.start_at).toDate(),
          $lt: moment(filters.end_at).endOf('day').toDate()
        }
      },
      pipeline: pipeline,
      limit: ITEM_AGGREGATION_LIMIT
    });
  }

  function rankByFilters(apikey, filters) {
    return aggregateByFilters(apikey, filters, [{
      $group: {
        _id: '$url',
        thumbnail_url: { $last: '$thumbnail_url' },
        title: { $last: '$title' },
        price: { $last: '$price' },
        item_count: { $sum: '$item_count' },
        iw_item_count: { $sum: '$iw_item_count' }
      }
    }, {
      $match: {
        item_count: { $gte: ITEM_COUNT_THRESHOLD }
      }
    }, {
      $project: {
        _id: 0,
        url: '$_id',
        thumbnail_url: 1,
        title: 1,
        price: 1,
        item_count: 1,
        iw_item_count: 1,
        iw_item_rate: { $divide: ['$iw_item_count', '$item_count'] }
      }
    }, {
      $sort: {
        iw_item_rate: -1,
        item_count: -1
      }
    }]);
  }
}

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.commonApi').factory('InterestWidgetStats', InterestWidgetStats);

var FIELD_NAMES = ['all', 'iw_click_item', 'iw_started', 'iw_use', 'no_iw_use'];

InterestWidgetStats.$inject = ['FacadeV2', 'lib'];
function InterestWidgetStats(FacadeV2, lib) {
  return { find: find, findByFilters: findByFilters, transform: transform };

  function find(paths, params) {
    return FacadeV2.request('/apikeys/' + paths.apikey + '/interest_widget_stats/daily/find', { params: params }).then(function (res) {
      return res.data;
    }).then(function (stats) {
      return _sumByStartAt(stats);
    });
  }

  function findByFilters(apikey, filters) {
    return find({ apikey: apikey }, {
      match: {
        device: filters.device,
        campaign_segment_id: null,
        start_at: {
          $gte: moment(filters.start_at).toDate(),
          $lt: moment(filters.end_at).endOf('day').toDate()
        }
      }
    });
  }

  function transform(stat) {
    if (_.keys(stat).length === 0) return stat;
    FIELD_NAMES.forEach(function (fieldName) {
      var field = stat[fieldName];
      if (field.session_count !== 0) {
        field.conversion_rate = field.conversion_count / field.session_count * 100;
        field.cart_button_click_rate = field.cart_button_click_count / field.session_count * 100;
        field.nocv_session_rate = field.nocv_session_count / field.session_count * 100;
        field.onecv_session_rate = field.onecv_session_count / field.session_count * 100;
        field.loyal_session_rate = field.loyal_session_count / field.session_count * 100;
        field.average_item_count = field.item_count / field.session_count;
      } else {
        field.conversion_rate = field.cart_button_click_rate = field.nocv_session_rate = field.onecv_session_rate = field.loyal_session_rate = field.average_item_count = 0;
      }
      field.average_conversion_price = field.conversion_count !== 0 ? field.conversion_price / field.conversion_count : 0;
      field.conversion_price_with_campaign_rate = field.conversion_price !== 0 ? field.conversion_price_with_campaign / field.conversion_price * 100 : 0;
      field.utm_medium_rate_map = {};
      _.keys(field.utm_medium_count_map).forEach(function (key) {
        field.utm_medium_rate_map[key] = field.session_count !== 0 ? field.utm_medium_count_map[key] / field.session_count * 100 : 0;
      });
    });
    stat.sales_rate = stat.all.conversion_price !== 0 ? stat.iw_click_item.conversion_price / stat.all.conversion_price * 100 : 0;
    stat.iw_started_rate = stat.all.session_count !== 0 ? stat.iw_started.session_count / stat.all.session_count * 100 : 0;
    stat.iw_use_rate = stat.iw_started.session_count !== 0 ? stat.iw_use.session_count / stat.iw_started.session_count * 100 : 0;
    stat.conversion_up_rate = stat.no_iw_use.conversion_rate !== 0 ? stat.iw_use.conversion_rate / stat.no_iw_use.conversion_rate * 100 : 0;
    return stat;
  }

  // NOTE:
  // combine the counts per day
  // because there might be results for multiple devices per day (PC+tablet)
  function _sumByStartAt(stats) {
    return _.chain(stats).groupBy('start_at').map(function (val) {
      return lib.sumCountMap(val);
    }).value();
  }
}

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.commonApi').factory('MongoCampaignInterestWidgetStatsWithoutBounces', MongoCampaignInterestWidgetStatsWithoutBounces);

MongoCampaignInterestWidgetStatsWithoutBounces.$inject = ['$q', 'FacadeV2'];
function MongoCampaignInterestWidgetStatsWithoutBounces($q, FacadeV2) {
  var service = {
    find: find
  };

  return service;

  function find(paths) {
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!paths.apikey) {
      console.error('No apikey in query');
      return $q.reject('No apikey in query');
    }

    if (!paths.dimension) {
      console.error('No dimension defined');
      return $q.reject('No dimension defined');
    }

    if (!query.start_at) {
      console.error('No start_at in query');
      return $q.reject('No start_at in query');
    }

    var promise = FacadeV2.request('/apikeys/' + paths.apikey + '/campaign_interest_widget_stats_without_bounces/' + paths.dimension + '/find', {
      params: {
        match: query,
        sort: options.sort,
        limit: options.limit || 1000
      }
    }).then(function (res) {
      if (res.status !== 200 || res.data.error) {
        $q.reject(res.data.error);
      } else {
        return res.data;
      }
    });

    return promise;
  }
}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/file-name */
angular.module('zc.commonApi').factory('ZcsCampaignStats', ZcsCampaignStats);

ZcsCampaignStats.$inject = ['$q', 'FacadeV2'];
function ZcsCampaignStats($q, FacadeV2) {
  var service = {
    find: find
  };

  return service;

  function find() {
    var paths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return $q(function (resolve, reject) {
      if (!paths.apikey) {
        var errorMsg = 'No apikey';
        console.error(errorMsg);
        return reject(errorMsg);
      }

      if (!paths.dimension) {
        var _errorMsg = 'No dimension';
        console.error(_errorMsg);
        return reject(_errorMsg);
      }

      var promise = FacadeV2.request('/apikeys/' + paths.apikey + '/zcs_campaign_stats/' + paths.dimension + '/find', {
        params: {
          match: query,
          sort: options.sort,
          limit: options.limit || 10000
        },
        cache: false
      }).then(function (res) {
        if (res.status !== 200 || res.data.error) {
          reject(_.get(res.data, 'error', 'Error fetching zcs campaign stats'));
        } else {
          resolve(res.data);
        }
      });

      return promise;
    });
  }
}

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.commonApi').filter('overallCampaignCvrIncreaseRate', function () {
  return function (campaigns, includeHiddenAb) {
    campaigns = _.filter(campaigns, function (campaign) {
      return (!campaign.is_secret_ab || includeHiddenAb) && !campaign.is_information_campaign && !!campaign.campaign_control_percent;
    });

    var totalExperimentalConversionCount = _.sumBy(campaigns, 'stats.experimental.conversion_count');
    var weightedDenominator = _.sumBy(campaigns, function (campaign) {
      var experimentalDeliveryCount = _.get(campaign, 'stats.experimental.delivery_count', 0);
      var controlConversionCount = _.get(campaign, 'stats.control.conversion_count', 0);
      var controlDeliveryCount = _.get(campaign, 'stats.control.delivery_count', 0);
      var controlCVR = controlDeliveryCount === 0 ? 0 : controlConversionCount / controlDeliveryCount;
      return experimentalDeliveryCount * controlCVR;
    });

    if (weightedDenominator === 0) return null;

    return totalExperimentalConversionCount / weightedDenominator;
  };
});

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.commonApi').factory('Services', Services);

Services.$inject = ['$q', 'AccessStats', 'Campaign', 'MongoHistory', 'MongoRaw', 'MongoSession', 'Project', 'Report'];
function Services($q, AccessStats, Campaign, MongoHistory, MongoRaw, MongoSession, Project, Report) {
  var service = {
    $q: $q,
    AccessStats: AccessStats,
    Campaign: Campaign,
    MongoHistory: MongoHistory,
    MongoRaw: MongoRaw,
    MongoSession: MongoSession,
    Project: Project,
    Report: Report
  };

  return service;
}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').component('zcApiPublicFileDownloader', {
  templateUrl: '/templates/core/components/api_public_file_downloader/api_public_file_downloader.html',
  bindings: {
    text: '=',
    filepath: '='
  },
  controller: clearanceSampleSetDownloader,
  controllerAs: 'vm'
});

clearanceSampleSetDownloader.$inject = ['Api'];
function clearanceSampleSetDownloader(Api) {
  var _this = this;

  var vm = this;

  vm.$onInit = function () {
    vm.text = _this.text;
    vm.href = Api.path(_this.filepath);
  };
}

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/file-name */
angular.module('zc.core').component('zcBillingRepresentatives', {
  templateUrl: '/templates/core/components/billing_representatives/billing_representatives.html',
  bindings: {
    representatives: '='
  },
  controller: billingRepresentatives,
  controllerAs: 'vm'
});

billingRepresentatives.$inject = ['Devise'];
function billingRepresentatives(Devise) {
  var vm = this;
  var REPRESENTATIVE_LIMIT = 5;
  var REPRESENTATIVE_FIELDS = ['full_name', 'email'];

  function isRepresentativesObjectCompletelyEmpty() {
    // has more than one representative field
    if (vm.representatives.length > 1) {
      return false;
    }

    var theOnlyRepresentative = vm.representatives[0];
    var isAllFieldsEmpty = !_.some(theOnlyRepresentative);
    return isAllFieldsEmpty;
  }

  function isRepresentativeLimitReached() {
    return vm.representatives.length >= REPRESENTATIVE_LIMIT;
  }

  function addNewRepresentative(representativeIndex) {
    if (isRepresentativeLimitReached()) {
      return;
    }

    vm.representatives.push(_.zipObject(REPRESENTATIVE_FIELDS));
  }

  function removeRepresentative(representativeIndex) {
    var representative = vm.representatives[representativeIndex];
    if (!representative) {
      return;
    }

    if (vm.representatives.length === 1) {
      vm.representatives = [_.zipObject(REPRESENTATIVE_FIELDS)];
      return;
    }

    vm.representatives.splice(representativeIndex, 1);
  }

  vm.$onInit = function () {
    // Create empty representative object array
    // from representative fields if there's no representatives
    if (!vm.representatives || vm.representatives.length === 0) {
      vm.representatives = [_.zipObject(REPRESENTATIVE_FIELDS)];
    }

    vm.isRepresentativesObjectCompletelyEmpty = isRepresentativesObjectCompletelyEmpty;
    vm.isRepresentativeLimitReached = isRepresentativeLimitReached;
    vm.addNewRepresentative = addNewRepresentative;
    vm.removeRepresentative = removeRepresentative;
  };
}

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/file-name */
angular.module('zc.core').component('zcIncreaseOrDecreasePercentage', {
  templateUrl: '/templates/core/components/increase_or_decrease_percentage/increase_or_decrease_percentage.html',
  bindings: {
    from: '<',
    to: '<'
  },
  controller: IncreaseOrDecreasePercentageController
});

IncreaseOrDecreasePercentageController.$inject = ['$filter'];
function IncreaseOrDecreasePercentageController($filter) {
  var vm = this;

  vm.$onInit = function () {
    vm.percentage = null;
    vm.showValue = null;
    showValue();
  };

  function showValue() {
    if (!vm.from) {
      vm.percentage = null;
      vm.showValue = null;
      return;
    }
    vm.percentage = (vm.to / vm.from - 1) * 100;
    if (vm.percentage === 0) {
      vm.showValue = '±0';
    } else if (vm.percentage > 0) {
      vm.showValue = '+' + $filter('number')(vm.percentage, 0) + '%';
    } else {
      vm.showValue = '-' + $filter('number')(-vm.percentage, 0) + '%';
    }
  }
}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/file-name */
angular.module('zc.core').component('zcMonthChooser', {
  // <zc-month-chooser> assumes that the month is handled by $stateParams
  // and the state parameter's format should be 'YYYY-MM'
  templateUrl: '/templates/core/components/month_chooser/month_chooser.html',
  bindings: {
    // stateParam can be used to overwrite which $stateParam is used.
    // Default value is 'month'
    stateParam: '@',
    // minDate should be date and can be any day of month.
    // If it's for example 2016-09-15, 2016-09 will be allowed month
    minDate: '<'
  },
  controller: monthChooserController
});

monthChooserController.$inject = ['$location', '$state', '$stateParams'];
function monthChooserController($location, $state, $stateParams) {
  var vm = this;
  var currentState = $state.current.name;

  // variables
  vm.$state = $state;

  // actions
  vm.goToNext = goToNext;
  vm.goToPrev = goToPrev;

  this.$onInit = function () {
    vm.currentMonth = moment(getStateParam(), 'YYYY-MM').toDate();

    if (nextMonthExists()) {
      vm.nextMonth = moment(getStateParam(), 'YYYY-MM').add(1, 'month').format('YYYY-MM');
    } else {
      vm.nextMonth = null;
    }

    if (prevMonthExists()) {
      vm.prevMonth = moment(getStateParam(), 'YYYY-MM').subtract(1, 'month').format('YYYY-MM');
    } else {
      vm.prevMonth = null;
    }
  };

  function goToNext() {
    if (nextMonthExists()) {
      $state.go(currentState, getNextMonthParams());
    }
  }

  function goToPrev() {
    if (prevMonthExists()) {
      $state.go(currentState, getPrevMonthParams());
    }
  }

  function nextMonthExists() {
    var currentParamMonth = moment(getStateParam(), 'YYYY-MM').startOf('month');
    var currentMonth = moment().startOf('month');
    if (moment(currentParamMonth).isAfter(currentMonth) || moment(currentParamMonth).isSame(currentMonth)) {
      return false;
    }
    return true;
  }

  function prevMonthExists() {
    if (!vm.minDate) return true;

    var currentParamMonth = moment(getStateParam(), 'YYYY-MM').startOf('month');
    var minMonth = moment(vm.minDate).startOf('month');
    if (moment(currentParamMonth).isBefore(minMonth) || moment(currentParamMonth).isSame(minMonth)) {
      return false;
    }
    return true;
  }

  function getNextMonthParams() {
    var newParams = {};
    newParams[getParamName()] = vm.nextMonth;
    return _.merge({}, $stateParams, newParams);
  }

  function getPrevMonthParams() {
    var newParams = {};
    newParams[getParamName()] = vm.prevMonth;
    return _.merge({}, $stateParams, newParams);
  }

  function getParamName() {
    return vm.stateParam || 'month';
  }

  function getStateParam() {
    return $stateParams[getParamName()];
  }
}

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').component('zcSessionPredictionDistribution', {
  templateUrl: '/templates/core/components/session_prediction_distribution/session_prediction_distribution.html',
  bindings: {
    campaign: '<',
    sessions: '<',
    disabled: '<',
    field: '@'
  },
  controller: sessionPredictionDistributionController
});

sessionPredictionDistributionController.$inject = ['$rootScope', '$scope', '$translate', 'ChartV2', 'columnChartV2Config'];
function sessionPredictionDistributionController($rootScope, $scope, $translate, ChartV2, columnChartV2Config) {
  var vm = this;

  var RANDOM_DIGIT = 10;
  var MIN = 0;
  var MAX = 100;
  var STEP = 1;
  var PLOT_BANDS_COLOR = 'rgba(68, 170, 213, .2)';

  var ranges = _.range(MIN, MAX, STEP);
  var chart = new ChartV2(columnChartV2Config, {
    xAxis: {
      categories: getCategories(),
      labels: { enabled: false },
      tickLength: 0,
      crosshair: true
    },
    yAxis: {
      min: 0,
      labels: { enabled: false }
    },
    options: {
      plotOptions: {
        column: { stacking: 'normal' }
      },
      tooltip: {
        valueSuffix: ' %',
        valueDecimals: 1,
        shared: true
      }
    }
  });

  var deregisterStateChangeStart = void 0;

  vm.$onInit = function () {
    if (vm.field === 'predictions_max_before_cart.global_conversion_rate') {
      vm.threshold = 'predictions_max_threshold';
    } else {
      vm.threshold = 'predictions_min_threshold';
    }
    vm.chartConfig = chart.getConfig();
    vm.sliderConfig = {
      floor: MIN,
      ceil: MAX,
      step: STEP,
      disabled: vm.disabled,
      showSelectionBar: true,
      translate: function translate(value) {
        return value + '%';
      }
    };
    vm.modalId = 'modal-' + Math.floor(Math.random() * RANDOM_DIGIT);
    vm.resizeFull = resizeFull;
    vm.resizeSmall = resizeSmall;
    plotBands(vm.campaign[vm.threshold]);
    $scope.$watch('$ctrl.sessions', addSeries);
    $scope.$watch('$ctrl.campaign.' + vm.threshold, plotBands);
    deregisterStateChangeStart = $rootScope.$on('$stateChangeSuccess', fixResizeProblem);
  };

  vm.$onDestroy = function () {
    if (deregisterStateChangeStart) deregisterStateChangeStart();
  };

  function addSeries(sessions) {
    var totalSessionCount = sessions.length;
    var nocvSessions = _.filter(sessions, function (session) {
      return session.conversion_count === 0;
    });
    var cvSessions = _.filter(sessions, function (session) {
      return session.conversion_count >= 1;
    });
    chart.resetSeries();
    chart.addSeries({
      name: $translate.instant('sharedModules.core.components.sessionPredictionDistribution.konbaajonnashi_no_wariai'),
      data: getDistributions(nocvSessions, totalSessionCount)
    });
    chart.addSeries({
      name: $translate.instant('sharedModules.core.components.sessionPredictionDistribution.konbaajonari_no_wariai'),
      data: getDistributions(cvSessions, totalSessionCount)
    });
  }

  function getCategories() {
    return _.map(ranges, function (range) {
      return range + '-' + (range + STEP) + '%';
    });
  }

  function getDistributions(sessions, totalSessionCount) {
    var countByMin = _.countBy(sessions, function (session) {
      return Math.floor(_.get(session, vm.field) * 100);
    });
    return _.map(ranges, function (range) {
      var count = countByMin[range] || 0;
      return count / totalSessionCount * 100;
    });
  }

  function plotBands(threshold) {
    if (vm.threshold === 'predictions_max_threshold') {
      vm.chartConfig.xAxis.plotBands = [{
        from: MIN,
        to: threshold,
        color: PLOT_BANDS_COLOR
      }];
    } else {
      vm.chartConfig.xAxis.plotBands = [{
        from: threshold,
        to: MAX,
        color: PLOT_BANDS_COLOR
      }];
    }
  }

  function resizeFull() {
    var $modal = $('#' + vm.modalId);
    $modal.modal('show');
    // NOTE:
    // Need to call fixResizeProblem once modal has been shown.
    // It does not work before the modal is completely shown.
    $modal.on('shown.bs.modal', function () {
      fixResizeProblem();
    });
  }

  function resizeSmall() {
    var $modal = $('#' + vm.modalId);
    $modal.modal('hide');
  }

  function fixResizeProblem() {
    // NOTE:
    // There is a bug that Highcharts is not sizing correctly when dynamically changing the screen.
    // Calling the highchartsng.reflow event solves the problem.
    // See https://github.com/pablojim/highcharts-ng/issues/550
    $scope.$broadcast('highchartsng.reflow');
    // NOTE:
    // There is a bug that Angularjs-Slider is not sizing correctly when dynamically changing the screen
    // (OMG, don't give me the same SPA shit in a one day...).
    // Calling the rzSliderForceRender event solves the problem.
    // See https://github.com/angular-slider/angularjs-slider/issues/79
    $scope.$broadcast('rzSliderForceRender');
  }
}

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

angular.module('zc.core').component('zcSessionPriceDistribution', {
  templateUrl: '/templates/core/components/session_price_distribution/session_price_distribution.html',
  bindings: {
    project: '<',
    campaign: '<',
    sessions: '<',
    disabled: '<',
    field: '@'
  },
  controller: sessionPriceDistributionController
});

sessionPriceDistributionController.$inject = ['$rootScope', '$scope', '$timeout', '$translate', 'ChartV2', 'columnChartV2Config', 'currencies'];
function sessionPriceDistributionController($rootScope, $scope, $timeout, $translate, ChartV2, columnChartV2Config, currencies) {
  var vm = this;

  var RANDOM_DIGIT = 10;
  var MIN = 0;
  var STEP = 1000;
  var NORMAL_RANGE = 0.95;
  var PLOT_BANDS_COLOR = 'rgba(68, 170, 213, .2)';

  var ranges = [];
  var deregisterStateChangeStart = null;

  var chart = new ChartV2(columnChartV2Config, {
    xAxis: {
      categories: getCategories(),
      labels: { enabled: false },
      tickLength: 0,
      tickWidth: 0,
      crosshair: true
    },
    yAxis: {
      min: 0,
      labels: { enabled: false }
    },
    options: {
      plotOptions: {
        column: {
          stacking: 'normal'
        }
      },
      tooltip: {
        valueSuffix: ' %',
        valueDecimals: 1,
        shared: true
      }
    }
  });

  vm.$onInit = function () {
    vm.currency = currencies[vm.project.currency];
    vm.chartConfig = chart.getConfig();
    vm.sliderConfig = {
      disabled: vm.disabled,
      floor: MIN,
      step: STEP,
      translate: function translate(value) {
        return '' + vm.currency.symbol + value + vm.currency.suffix;
      }
    };
    vm.modalId = 'modal-' + Math.floor(Math.random() * RANDOM_DIGIT);
    vm.resizeFull = resizeFull;
    vm.resizeSmall = resizeSmall;
    $scope.$watch('$ctrl.sessions', addSeries);
    $scope.$watchGroup(['$ctrl.campaign.price_max_threshold', '$ctrl.campaign.price_min_threshold'], plotBands);
    deregisterStateChangeStart = $rootScope.$on('$stateChangeSuccess', fixResizeProblem);
  };

  vm.$onDestroy = function () {
    deregisterStateChangeStart();
  };

  function addSeries(sessions) {
    var totalSessionCount = sessions.length;
    var prices = getPrices(sessions);
    var max = _.max(prices);
    ranges = _.range(MIN, max, STEP);
    vm.chartConfig.xAxis.categories = getCategories();
    chart.resetSeries();
    chart.addSeries({
      name: $translate.instant('sharedModules.core.components.sessionPriceDistribution.wariai'),
      data: getDistributions(prices, totalSessionCount)
    });
    $timeout(function () {
      vm.sliderConfig.ceil = _.last(ranges);
      plotBands([vm.campaign.price_max_threshold, vm.campaign.price_min_threshold]);
    }, 0);
  }

  function getPrices(conversions) {
    var prices = _.chain(conversions).map(vm.field).compact().sortBy().value();
    return prices.slice(0, prices.length * NORMAL_RANGE);
  }

  function getCategories() {
    return _.map(ranges, function (range) {
      return '' + vm.currency.symbol + range + '-' + (range + STEP) + vm.currency.suffix;
    });
  }

  function getDistributions(prices, totalConversionCount) {
    var countByMin = _.countBy(prices, function (price) {
      return Math.floor(price / 1000) * 1000;
    });
    return _.map(ranges, function (range) {
      var count = countByMin[range] || 0;
      return count / totalConversionCount * 100;
    });
  }

  function plotBands(_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        min = _ref2[0],
        max = _ref2[1];

    vm.chartConfig.xAxis.plotBands = [{
      from: _.indexOf(ranges, min),
      to: _.indexOf(ranges, max),
      color: PLOT_BANDS_COLOR
    }];
  }

  function resizeFull() {
    var $modal = $('#' + vm.modalId);
    $modal.modal('show');
    // NOTE:
    // Need to call fixResizeProblem once modal has been shown.
    // It does not work before the modal is completely shown.
    $modal.on('shown.bs.modal', function () {
      fixResizeProblem();
    });
  }

  function resizeSmall() {
    var $modal = $('#' + vm.modalId);
    $modal.modal('hide');
  }

  function fixResizeProblem() {
    // NOTE:
    // There is a bug that Highcharts is not sizing correctly
    // when dynamically changing the screen size until calling reflow.
    // See https://github.com/pablojim/highcharts-ng/issues/550
    $scope.$broadcast('highchartsng.reflow');
    // NOTE:
    // There is a bug that Angularjs-Slider is not sizing correctly when dynamically changing the screen
    // (OMG, don't give me the same SPA shit in a one day...).
    // Calling the rzSliderForceRender event solves the problem.
    // See https://github.com/angular-slider/angularjs-slider/issues/79
    $scope.$broadcast('rzSliderForceRender');
  }
}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').component('zcSessionUpliftModelingClassification', {
  templateUrl: '/templates/core/components/session_uplift_modeling_classification/session_uplift_modeling_classification.html',
  bindings: {
    campaign: '<',
    sessions: '<',
    field: '@'
  },
  controller: sessionUpliftModelingClassificationController
});

sessionUpliftModelingClassificationController.$inject = ['$scope'];
function sessionUpliftModelingClassificationController($scope) {
  var vm = this;

  var DELAY_MS = 500;

  vm.$onInit = function () {
    vm.totalSessionCount = 0;
    vm.noConversionAnywaySessionCount = 0;
    vm.conversionAnywaySessionCount = 0;
    vm.negativeImpactSessionCount = 0;
    vm.positiveImpactSessionCount = 0;
    vm.totalConversionCount = 0;
    vm.noConversionAnywayConversionCount = 0;
    vm.conversionAnywayConversionCount = 0;
    vm.negativeImpactConversionCount = 0;
    vm.positiveImpactConversionCount = 0;
    $scope.$watchGroup(['$ctrl.campaign.predictions_max_threshold', '$ctrl.campaign.predictions_min_threshold', '$ctrl.campaign.price_max_threshold', '$ctrl.campaign.price_min_threshold', '$ctrl.campaign.exclude_no_price', '$ctrl.sessions'], _.debounce(calculateSimulation, DELAY_MS), true);
  };

  function calculateSimulation() {
    if (!vm.sessions.length) return;
    var noConversionAnyway = [];
    var conversionAnyway = [];
    var negativeImpact = [];
    var positiveImpact = [];
    vm.sessions.forEach(function (session) {
      if (isNoConversionAnyway(session)) {
        noConversionAnyway.push(session);
      } else if (isConversionAnyway(session)) {
        conversionAnyway.push(session);
      } else if (isNegativeImpact(session)) {
        negativeImpact.push(session);
      } else {
        positiveImpact.push(session);
      }
    });
    vm.totalSessionCount = vm.sessions.length;
    vm.noConversionAnywaySessionCount = noConversionAnyway.length;
    vm.conversionAnywaySessionCount = conversionAnyway.length;
    vm.negativeImpactSessionCount = negativeImpact.length;
    vm.positiveImpactSessionCount = positiveImpact.length;
    vm.totalConversionCount = _.filter(vm.sessions, 'conversion_count').length;
    vm.noConversionAnywayConversionCount = _.filter(noConversionAnyway, 'conversion_count').length;
    vm.conversionAnywayConversionCount = _.filter(conversionAnyway, 'conversion_count').length;
    vm.negativeImpactConversionCount = _.filter(negativeImpact, 'conversion_count').length;
    vm.positiveImpactConversionCount = _.filter(positiveImpact, 'conversion_count').length;
  }

  function isNoConversionAnyway(session) {
    var prediction = _.get(session, 'predictions_max_before_cart.global_conversion_rate') * 100;
    if (prediction < vm.campaign.predictions_max_threshold) return true;
    return false;
  }

  function isConversionAnyway(session) {
    var prediction = _.get(session, 'predictions_min_before_cart.global_conversion_rate') * 100;
    if (prediction > vm.campaign.predictions_min_threshold) return true;
    return false;
  }

  function isNegativeImpact(session) {
    var price = _.get(session, 'average_recent5_item_price');
    if (!price && vm.campaign.exclude_no_price) return true;
    if (price && vm.campaign.price_max_threshold < price && price < vm.campaign.price_min_threshold) return true;
    return false;
  }
}

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/file-name */
angular.module('zc.core').component('zcSyncContractInfoButton', {
  templateUrl: '/templates/core/components/sync_contract_info_button/sync_contract_info_button.html',
  bindings: {
    source: '=',
    syncTargetName: '@'
  },
  controller: SyncContractInfoButtonController,
  controllerAs: 'vm'
});

SyncContractInfoButtonController.$inject = ['$translate'];
function SyncContractInfoButtonController($translate) {
  var _this = this;

  var SYNC_TARGET_NAME = $translate.instant('sharedModules.core.components.syncContractInfoButton.kaisha_jouhou');

  // contractInfoField: billingInfoField
  var FIELDS_TO_BE_SYNCED = {
    company_name: 'billing_company_name',
    address: 'billing_address',
    postal_code: 'billing_postal_code',
    phone_number: 'billing_phone_number'
  };

  var ALIAS_FIELDS = {
    // agency's title field equals company_name
    company_name: 'title'
  };

  var vm = this;

  // Loop the above FIELDS_TO_BE_SYNCED and assign
  // billingInfoField's value to contractInfoField
  function syncContractInfoWithBillingInfo() {
    _.forEach(FIELDS_TO_BE_SYNCED, function (billingInfoField, contractInfoField) {

      if (!isSourceHasField(contractInfoField)) {
        var aliasField = _.get(ALIAS_FIELDS, contractInfoField);
        if (!isSourceHasField(aliasField)) {
          console.error('Source missing a field: ' + contractInfoField + '.');
          return;
        }

        contractInfoField = aliasField;
      }

      vm.source[billingInfoField] = vm.source[contractInfoField];
    });
  }

  function isSourceHasField(field) {
    return _.has(vm.source, field);
  }

  vm.$onInit = function () {
    vm.syncContractInfoWithBillingInfo = syncContractInfoWithBillingInfo;

    if (!_this.syncTargetName) {
      vm.syncTargetName = SYNC_TARGET_NAME;
    }
  };
}

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').component('zcTosNotification', {
  templateUrl: '/templates/core/components/tos_notification/tos_notification.html',
  bindings: {
    serviceName: '@',
    tosUrl: '@',
    updatedAt: '@'
  },
  controller: zcTosNotification,
  controllerAs: 'vm'
});

zcTosNotification.$inject = ['Devise'];
function zcTosNotification(Devise) {
  var vm = this;

  vm.$onInit = function () {
    vm.isTosSigned = true;
    vm.user = {};

    Devise.getCurrentUser().then(function (user) {
      vm.user = user;
      vm.isTosSigned = user.agreement_2020_signed_at !== null;
    });
  };

  vm.signAgreements = function () {
    Devise.getCurrentUser().then(function (user) {
      Devise.signAgreements(user).then(function () {
        vm.isTosSigned = true;
      });
    });
  };
}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').config(exceptionHandler);

exceptionHandler.$inject = ['$provide'];
function exceptionHandler($provide) {
  // exceptionHandler can also be overwritten, but
  // decorating is more future proof.
  $provide.decorator('$exceptionHandler', exceptionHandlerDecorator);
}

exceptionHandlerDecorator.$inject = ['$delegate', '$injector'];
function exceptionHandlerDecorator($delegate, $injector) {
  return function (exception, cause) {
    // This executes the original functionality ($log.error)
    $delegate(exception, cause);
  };
}

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').config(translations);

// Support for i18n
translations.$inject = ['$translateProvider'];
function translations($translateProvider) {
  $translateProvider.useStaticFilesLoader({
    prefix: '/assets/i18n/',
    suffix: '.json'
  }).registerAvailableLanguageKeys(['en', 'ja'], {
    'en_*': 'en',
    'ja_*': 'ja',
    '*': 'en'
  }).determinePreferredLanguage()
  // https://angular-translate.github.io/docs/#/guide/19_security
  .useSanitizeValueStrategy('sceParameters');
}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').directive('autoFillSync', autoFillSync);

autoFillSync.$inject = ['$interval'];
function autoFillSync($interval) {
  return {
    require: 'ngModel',
    link: function link(scope, elem, attrs, ngModel) {
      var origVal = elem.val();
      $interval(function () {
        var newVal = elem.val();
        if (ngModel.$pristine && origVal !== newVal) {
          ngModel.$setViewValue(newVal);
          origVal = newVal;
        }
      }, 500);
    }
  };
}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').directive('peTrack', peTrack);

peTrack.$inject = ['ZcTag'];
function peTrack(ZcTag) {
  return {
    restrict: 'A',
    link: link,
    scope: {
      peAttrs: '<'
    }
  };

  function link(scope, elem, attrs) {
    var minimumDuration = 500;
    var clickCount = 0;

    var t = new Date().valueOf();
    var mouseEnter = function mouseEnter(e) {
      t = new Date().valueOf();
    };
    var mouseLeave = function mouseLeave() {
      var duration = new Date().valueOf() - t;
      if (duration > minimumDuration) {
        var attribute = _.merge(scope.peAttrs || {}, { duration: duration });
        ZcTag.sendParticularEvent(attrs.peTrack + ':hover', attribute);
      }
    };
    elem.mouseenter(mouseEnter).mouseleave(mouseLeave);

    elem.click(function () {
      clickCount++;
      var attribute = _.merge(scope.peAttrs || {}, { click_count: clickCount });

      ZcTag.sendParticularEvent(attrs.peTrack + ':click', attribute);
    });
  }
}

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// keep this updated with the billable currency in api_rails/app/models/project.rb
var BILLABLE_CURRENCIES = ['jpy', 'usd', 'aud', 'eur', 'gbp', 'hkd', 'idr', 'krw', 'myr', 'sgd', 'thb', 'twd'];

angular.module('zc.core').filter('billable_currencies', billableCurrencies);

billableCurrencies.$inject = [];
function billableCurrencies() {
  return function (arr) {
    var project = arr[0];

    if (project.fixed_invoice_amount || project.product_line === 'zenclerk_lp') {
      return BILLABLE_CURRENCIES;
    }
    // twd has no exchange rate so it cant be billed in usd
    if (project.currency === 'twd') {
      return ['twd'];
    }
    // always gonna be like ['jpy', 'usd']
    if (!BILLABLE_CURRENCIES.includes(project.currency)) {
      return ['usd'];
    }

    // filter out duplicate if dashboard currency is usd
    var currencies = [project.currency, 'usd'].filter(function (v, i, a) {
      return a.indexOf(v) === i;
    });
    return currencies;
  };
}

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').filter('byteFormat', byteFormat);

byteFormat.$inject = [];
function byteFormat() {
  return function (bytes, precision) {
    var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'];
    var number = Math.floor(Math.log(bytes) / Math.log(1024));

    if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
    if (angular.isUndefined(precision)) precision = 1;
    return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
  };
}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').filter('gmtNotation', gmtNotation);

gmtNotation.$inject = [];
function gmtNotation() {
  return function (timezone) {
    var notation = {
      africa_johannesburg: 'South Africa',
      america_los_angeles: 'United States',
      america_new_york: 'United States',
      america_toronto: 'Canada',
      asia_bangkok: 'Thailand',
      asia_ho_chi_minh: 'Vietnam',
      asia_hong_kong: 'Hong Kong',
      asia_jakarta: 'Indonesia',
      asia_kolkata: 'India',
      asia_kuala_lumpur: 'Malaysia',
      asia_manila: 'Philippines',
      asia_seoul: 'Korea',
      asia_shanghai: 'China',
      asia_singapore: 'Singapore',
      asia_taipei: 'Taiwan',
      asia_tokyo: 'Japan',
      australia_sydney: 'Australia',
      europe_amsterdam: 'Netherlands',
      europe_berlin: 'Germany',
      europe_london: 'United Kingdom',
      europe_paris: 'France',
      europe_rome: 'Italy',
      europe_stockholm: 'Sweden',
      europe_zurich: 'Switzerland',
      pacific_auckland: 'New Zealand'
    };

    var offset = moment().tz(timezone).format('Z');
    return notation[timezone] + ' GMT' + offset;
  };
}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').filter('humanizeCurrency', humanizeCurrency);

humanizeCurrency.$inject = ['$translate'];
function humanizeCurrency($translate) {
  return function (currency) {
    return $translate.instant('sharedModules.core.filters.humanizeCurrency.' + currency);
  };
}

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').filter('unique', unique);

unique.$inject = [];
function unique() {
  return function (arr) {
    return _.uniq(arr);
  };
}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core')

/**
 * httpOnce makes sure that no multiple instances of same requests are simultaneously.
 * For example if a page has 10 components which all ask for user and project,
 * there would normally be 10 requests for user and project simultaneously.
 *
 * With httpOnce, subsequent exactly same requests get the first request's
 * promise, so only one request is sent.
 *
 * This is bit modified from:
 * http://stackoverflow.com/questions/32958046/preventing-multiple-http-requests-in-angular-is-there-a-better-way
 */
.factory('$httpOnce', $httpOnce);

$httpOnce.$inject = ['$cacheFactory', '$http'];
function $httpOnce($cacheFactory, $http) {
  // TODO: this is in zc.core, so cannot use babel+es6 yet
  var cache = $cacheFactory('$httpOnce');

  var service = function service(params, options) {
    // TODO: this is in zc.core, so cannot use babel+es6 yet
    var cacheKey = angular.toJson(params);

    // return the promise from cache if same request is already in progress
    return cache.get(cacheKey) || cache.put(cacheKey, $http(params, options)).then(function (response) {
      return response;
    }).finally(function () {
      // clear cache once we are done
      cache.remove(cacheKey);
    });
  };

  return service;
}

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').factory('areaChartV2Config', areaChartV2Config);

areaChartV2Config.$inject = ['chronologicalChartV2Config'];
function areaChartV2Config(chronologicalChartV2Config) {
  return angular.merge({
    options: {
      chart: { type: 'area' }
    }
  }, chronologicalChartV2Config);
}

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').factory('barChartV2Config', barChartV2Config);

barChartV2Config.$inject = ['baseChartV2Config'];
function barChartV2Config(baseChartV2Config) {
  return angular.merge({
    options: {
      chart: { type: 'bar' }
    },
    xAxis: {
      title: { text: null },
      type: 'category'
    },
    yAxis: {
      title: { text: null },
      min: 0
    }
  }, baseChartV2Config);
}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').factory('baseChartV2Config', baseChartV2Config);

baseChartV2Config.$inject = [];
function baseChartV2Config() {
  return {
    options: {
      title: { text: null },
      legend: { enabled: false },
      credits: { enabled: false }
    },
    series: []
  };
}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('zc.core').factory('ChartV2', ChartV2);

ChartV2.$inject = [];
function ChartV2() {
  var Chart = function () {
    function Chart(config, customConfig) {
      _classCallCheck(this, Chart);

      this.config = _.merge({
        options: { rand: Math.random() }
      }, config, customConfig);
    }

    _createClass(Chart, [{
      key: 'getConfig',
      value: function getConfig() {
        return this.config;
      }
    }, {
      key: 'resetSeries',
      value: function resetSeries() {
        this.config.series = [];
      }
    }, {
      key: 'addSeries',
      value: function addSeries(series) {
        this.config.series.push(series);
      }
    }]);

    return Chart;
  }();

  return Chart;
}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').factory('chronologicalChartV2Config', chronologicalChartV2Config);

chronologicalChartV2Config.$inject = ['$translate', '$window', 'baseChartV2Config'];
function chronologicalChartV2Config($translate, $window, baseChartV2Config) {
  return angular.merge({
    options: {
      colors: ['#26c9ff', '#666666'],
      tooltip: {
        shared: true,
        crosshairs: true,
        dateTimeLabelFormats: {
          hour: $translate.instant('sharedModules.dateTimeFormats.chart.monthDayHour'),
          day: $translate.instant('sharedModules.dateTimeFormats.chart.monthDay'),
          week: $translate.instant('sharedModules.dateTimeFormats.chart.monthDay')
        }
      },
      plotOptions: {
        series: {
          marker: {
            symbol: 'circle',
            enabled: false
          }
        }
      }
    },
    xAxis: {
      title: { text: null },
      type: 'datetime',
      dateTimeLabelFormats: {
        hour: $translate.instant('sharedModules.dateTimeFormats.chart.hour'),
        day: $translate.instant('sharedModules.dateTimeFormats.chart.monthDay'),
        week: $translate.instant('sharedModules.dateTimeFormats.chart.monthDay')
      }
    },
    yAxis: {
      title: { text: null },
      min: 0,
      labels: {
        formatter: function formatter() {
          var suffix = void 0,
              valueDecimals = void 0;
          suffix = this.chart.series[0].tooltipOptions.valueSuffix || '';
          valueDecimals = this.chart.series[0].tooltipOptions.valueDecimals || 0;
          return $window.Highcharts.numberFormat(this.value, valueDecimals) + suffix;
        }
      }
    }
  }, baseChartV2Config);
}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').factory('columnChartV2Config', columnChartV2Config);

columnChartV2Config.$inject = ['$window', 'baseChartV2Config'];
function columnChartV2Config($window, baseChartV2Config) {
  return angular.merge({
    options: {
      chart: { type: 'column' },
      colors: ['#26c9ff', '#666666']
    },
    xAxis: {
      title: { text: null },
      type: 'category'
    },
    yAxis: {
      title: { text: null },
      min: 0,
      labels: {
        formatter: function formatter() {
          var suffix = void 0,
              valueDecimals = void 0;
          suffix = this.chart.series[0].tooltipOptions.valueSuffix || '';
          valueDecimals = this.chart.series[0].tooltipOptions.valueDecimals || 0;
          return $window.Highcharts.numberFormat(this.value, valueDecimals) + suffix;
        }
      }
    }
  }, baseChartV2Config);
}

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').factory('funnelChartV2Config', funnelChartV2Config);

funnelChartV2Config.$inject = ['baseChartV2Config'];
function funnelChartV2Config(baseChartV2Config) {
  return angular.merge({
    options: {
      chart: {
        type: 'funnel',
        width: 300,
        height: 120
      },
      plotOptions: {
        series: {
          dataLabels: {
            distance: 0,
            formatter: function formatter() {
              // NOTE: Squaring values which is stored as rooted
              var total = Math.round(Math.pow(this.series.yData[0], 2));
              var y = Math.round(Math.pow(this.y, 2));
              var percent = Math.round(y / total * 100);
              return this.key + ' (' + percent + '%)';
            }
          },
          enableMouseTracking: false,
          width: 180,
          neckWidth: '0%',
          neckHeight: '0%'
        }
      }
    }
  }, baseChartV2Config);
}

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').factory('lineChartV2Config', lineChartV2Config);

lineChartV2Config.$inject = ['chronologicalChartV2Config'];
function lineChartV2Config(chronologicalChartV2Config) {
  return angular.merge({
    options: {
      chart: { type: 'line' }
    }
  }, chronologicalChartV2Config);
}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').factory('pieChartV2Config', pieChartV2Config);

pieChartV2Config.$inject = ['baseChartV2Config'];
function pieChartV2Config(baseChartV2Config) {
  return angular.merge({
    options: {
      chart: { type: 'pie' },
      tooltip: { pointFormat: '<b>{point.percentage:.1f}%</b>' },
      plotOptions: {
        pie: {
          dataLabels: {
            enabled: true,
            distance: -60,
            style: {
              fontWeight: 'bold',
              color: 'white',
              textShadow: '0px 1px 2px black'
            }
          }
        }
      }
    }
  }, baseChartV2Config);
}

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').factory('ZcTag', ZcTag);

ZcTag.$inject = ['$location', '$state', '$window', 'Devise', 'Environment'];
function ZcTag($location, $state, $window, Devise, Environment) {
  var EVENT_PREFIX = ZC_CONFIG.ZC_TAG_EVENT_PREFIX || 'zc';
  var service = {};
  var environment = void 0;
  service.initialized = false;

  Environment.get().then(function (res) {
    environment = res;
  });

  service.initialize = function () {
    if (ZC_CONFIG.ZC_APIKEY && !service.initialized) {
      var zcTag = $('\n      <script type="text/javascript" src="' + $location.protocol() + '://f1.zenclerk.com/publish/' + ZC_CONFIG.ZC_APIKEY + '.js"></script>\n      ');
      $('body').append(zcTag);
      service.initialized = true;
    }
  };

  service.sendParticularEvent = function (name, attributes) {
    if (angular.isUndefined(environment)) {
      return;
    }

    var userId = void 0;
    if (Devise.currentUser) userId = Devise.currentUser.id;

    attributes = _.merge(attributes || {}, { user_id: userId, state: $state.current.name });
    name = EVENT_PREFIX + ':' + name;

    // show log on dev/staging env so that it's easy to test
    if (environment === 'staging' || environment === 'development') {
      console.log('[DEV] Would send particular event', name, attributes);
    }

    // do not allow sending anything else than plain objects (or undefineds)
    if (angular.isDefined(attributes) && !_.isPlainObject(attributes)) {
      console.warn('Tried to send non-object as particular event', attributes);
      return;
    }

    if (angular.isUndefined($window.__zc)) {
      return;
    }

    $window.__zc.ParticularEventController.send($window.__zc.socket, name, attributes);
  };

  return service;
}

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').controller('TosController', TosController);

TosController.$inject = ['$rootScope'];
function TosController($rootScope) {
  var vm = this;

  vm.$onInit = function () {
    vm.selectedLanguage = null;

    // Select TOS based on the language selected in TosHeaderController
    var deregistrationCallback = $rootScope.$on('languageSelected', function (_, selectedLanguage) {
      vm.selectedLanguage = selectedLanguage;
    });

    $rootScope.$on('$destroy', deregistrationCallback);

    $rootScope.$emit('selectDefaultLanguage');
  };
}

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.core').controller('TosHeaderController', TosHeaderController);

TosHeaderController.$inject = ['$location', '$rootScope', '$translate', 'Devise', 'languages'];
function TosHeaderController($location, $rootScope, $translate, Devise, languages) {
  var vm = this;

  vm.$onInit = function () {
    vm.selectedLanguage = null;

    if (languages) {
      vm.languages = languages;
    } else {
      throw new Error('Please specify available languages for TosHeaderController in router');
    }

    var FALLBACK_LANGUAGE = vm.languages[0];

    vm.selectLanguage = function (selectedLanguage) {
      vm.selectedLanguage = selectedLanguage;
      $rootScope.$emit('languageSelected', selectedLanguage);
    };

    var selectDefaultLanguage = function selectDefaultLanguage() {
      Devise.getCurrentUserLanguage().then(function (currentUserLanguage) {
        var id = $location.search().lang || currentUserLanguage || $translate.preferredLanguage();
        var defaultLanguage = _.find(vm.languages, {
          id: id
        }) || FALLBACK_LANGUAGE;

        vm.selectLanguage(defaultLanguage);
      });
    };

    var deregistrationCallback = $rootScope.$on('selectDefaultLanguage', selectDefaultLanguage);
    $rootScope.$on('$destroy', deregistrationCallback);
  };
}

/***/ }),
/* 212 */,
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var magic = {
  ZCLITE_TRACKING_TAG_AUTOCHECK_INTERVAL: 10000,
  ZCLITE_CONVERSION_TAG_AUTOCHECK_INTERVAL: 10000
};

exports.default = magic;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable angular/document-service */

var defaultOptions = {
  /* padding for each direction */
  padding: {
    top: 10,
    bottom: 60,
    left: 70,
    right: 40
  },
  width: 300,
  height: 360,
  /* TODO: what labels? */
  showLabels: true,
  colors: {
    primary: '#1DD5A3',
    secondary: '#775FD3'
  },
  upperSpaceMarginPercentage: 1.2, // leave about 20% to top part of the graph
  isBarChart: false, // TODO: get rid of this, just for barchart padding
  timeFormats: {
    day: d3.time.format('%m/%d')
  },
  tooltipFn: function tooltipFn() {
    return '';
  }
};

/*
TODO:
  - generate the svg
  - generate the tooltip element
  - make responsive
*/

var Zcd3 = function () {

  /**
   * @param {DOMelement} element - div where svg is placed into, should have svg inside it
   * @param {Array} data - data used by the chart
   * @param {Object} opts - Options for data
   */
  function Zcd3(element, data) {
    var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Zcd3);

    // TODO: This is appended to DOM so destroy event is required.
    // Figure out better way to do this...
    var tooltipElement = document.createElement('div');
    tooltipElement.setAttribute('class', 'zcd3-tooltip');
    document.body.appendChild(tooltipElement);

    this.element = element;
    this.tooltipElement = tooltipElement;
    this.tooltipDiv = d3.select(tooltipElement).style('opacity', 0);

    this._options = _.merge({}, defaultOptions, opts);
    this.data = data;
    // This is used to find date from mouse coordinates
    this.bisectDate = d3.bisector(function (d) {
      return d.date;
    }).left;
    this.tooltipFn = opts.tooltipFn;
    this.axes = {};
    this.scales = {};
    this.series = [];

    this.createBaseGraph(this.data);
  }

  _createClass(Zcd3, [{
    key: 'destroy',
    value: function destroy() {
      this.tooltipElement.remove();
    }
  }, {
    key: 'opt',
    value: function opt(_opt) {
      var value = _.get(this._options, _opt);
      if (_.isUndefined(value)) {
        throw new Error('Zcd3 option ' + _opt + ' not defined');
      }

      return value;
    }
  }, {
    key: 'addSeries',
    value: function addSeries(params) {
      var defaultParams = {
        name: 'Serie ' + (this.series.length + 1),
        yAxis: 'left',
        color: defaultOptions.colors.primary
      };
      var combinedParams = _.merge(defaultParams, params);

      this.createNewScaleAndAxis(combinedParams);

      this.series.push(params);

      switch (params.type) {
        case 'line':
          this.addLineSeries(combinedParams);
          break;
        case 'bar':
          this.addBarSeries(combinedParams);
          break;
        case 'area':
          this.addAreaSeries(combinedParams);
          break;
      }

      if (params.trendLine) {
        this.createTrendLine(combinedParams);
      }

      this.checkHideLabels();
    }
  }, {
    key: 'createNewScaleAndAxis',
    value: function createNewScaleAndAxis(params) {
      var self = this;

      if (this.axes[params.yAxis]) return;

      var yScale = d3.scale.linear().domain([0, d3.max(_.map(this.data, params.y)) * this.opt('upperSpaceMarginPercentage')]).range([this.opt('height') - this.opt('padding.bottom'), this.opt('padding.top')]);

      // Y axis
      var yAxis = d3.svg.axis().scale(yScale).orient(params.yAxis).outerTickSize(0).ticks(5).tickFormat(params.yAxisTickFormat);

      if (params.yAxis === 'left') {
        yAxis.innerTickSize(-self.opt('width') + self.opt('padding.right') + self.opt('padding.left'));
      }

      var axisGrp = self.svg.append('g').attr('class', 'axis yaxis');

      if (params.yAxis === 'left') {
        axisGrp.attr('transform', 'translate(' + self.opt('padding.left') + ',0)');
      } else {
        axisGrp.attr('transform', 'translate(' + (self.opt('width') - self.opt('padding.right')) + ',0)');
      }
      axisGrp.call(yAxis);

      // Hide the 0 tick
      d3.select(axisGrp.selectAll('.tick')[0][0]).attr('visibility', 'hidden');

      self.scales[params.yAxis] = yScale;
      self.axes[params.yAxis] = yAxis;
    }
  }, {
    key: 'addLineSeries',
    value: function addLineSeries(params) {
      // TODO: remove in D3 4.0 - https://github.com/d3/d3-selection/issues/43
      var self = this;
      var yScale = this.scales[params.yAxis];
      var xScale = this.xScale;

      var line = d3.svg.line().interpolate('monotone').x(function (d) {
        return xScale(d.date);
      }).y(function (d) {
        return yScale(d[params.y]);
      });

      self.svg.append('path').datum(self.data).classed('line', true).classed('serie-' + params.name, true).attr('d', line).attr('fill', 'none').attr('opacity', 0.75).style('stroke', params.color).style('stroke-width', 2);

      self.svg.selectAll('circle.point-' + params.y).data(this.data).enter().append('circle').classed('point-' + params.y, true).classed('serie-' + params.name, true).attr('r', 3).attr('opacity', 0.3).attr('cx', function (d) {
        return xScale(d.date);
      }).attr('cy', function (d) {
        return yScale(d[params.y]);
      }).style('fill', params.color);
    }
  }, {
    key: 'checkHideLabels',
    value: function checkHideLabels() {
      if (!this.opt('showLabels')) {
        this.svg.selectAll('.axis .tick text').style('opacity', 0);
      }
    }
  }, {
    key: 'addBarSeries',
    value: function addBarSeries(params) {
      // TODO: remove in D3 4.0 - https://github.com/d3/d3-selection/issues/43
      var self = this;
      var yScale = self.scales[params.yAxis];

      var BARWIDTH = (self.opt('width') - self.opt('padding.left') - self.opt('padding.right')) / this.data.length;

      var barGroup = self.svg.selectAll('g.bar-g').data(self.data).enter().append('g').classed('bar-g', true).attr('transform', function (d, i) {
        return 'translate(' + self.xScale(d.date) + ', 0)';
      });

      barGroup.append('rect').attr('y', function (d) {
        return yScale(d[params.y]);
      }).attr('height', function (d) {
        return self.opt('height') - self.opt('padding.bottom') - yScale(d[params.y]);
      }).attr('width', BARWIDTH / 2) // HOX: why 5?
      .attr('transform', 'translate(' + (-BARWIDTH / 2 / 2 + 1) + ', 0)').attr('fill', params.color);
    }
  }, {
    key: 'addAreaSeries',
    value: function addAreaSeries(params) {
      // TODO: remove in D3 4.0 - https://github.com/d3/d3-selection/issues/43
      var self = this;
      var xScale = self.xScale;
      var yScale = self.scales[params.yAxis];
      //const tooltipFn = params.tooltipFn;

      var area = d3.svg.area().interpolate('basis').x(function (d) {
        return xScale(moment(d.date).startOf('day'));
      }).y0(this.opt('height') - this.opt('padding.bottom')).y1(function (d) {
        return yScale(d[params.y]);
      });

      self.svg.append('path').datum(self.data).classed('area', true).attr('d', area).attr('stroke', params.color).attr('fill', d3.rgb(params.color).brighter(2));

      self.svg.selectAll('.area').attr('opacity', 0.8);
    }

    // TODO: unused now, but should be used in highlighter

  }, {
    key: 'mouseOverHighlight',
    value: function mouseOverHighlight(selector) {
      var self = this;

      return function (d) {
        var _this = this;

        self.svg.selectAll('.serie-' + selector).each(function () {
          var tag = d3.select(_this);
          var tagName = tag.node().tagName;

          switch (tagName) {
            case 'path':
            case 'line':
              tag.transition().duration(200).style('stroke-width', '3px');
              break;
            case 'circle':
              tag.transition().duration(200).style('r', 5);
              break;
          }
        });
      };
    }

    // TODO: unused now, but should be used in highlighter

  }, {
    key: 'mouseOutHighlight',
    value: function mouseOutHighlight(selector) {
      var self = this;

      return function (d) {
        var _this2 = this;

        self.svg.selectAll('.serie-' + selector).each(function () {
          var tag = d3.select(_this2);
          var tagName = tag.node().tagName;

          switch (tagName) {
            case 'path':
            case 'line':
              tag.transition().duration(200).style('stroke-width', '2px');
              break;
            case 'circle':
              tag.transition().duration(200).style('r', 3);
              break;
          }
        });
      };
    }
  }, {
    key: 'createBaseGraph',
    value: function createBaseGraph(data) {
      // TODO: remove in D3 4.0 - https://github.com/d3/d3-selection/issues/43
      var self = this;

      var svg = d3.select(this.element).select('svg').attr('width', self.opt('width')).attr('height', self.opt('height')).style('width', self.opt('width') + 'px').style('height', self.opt('height') + 'px').classed('zclite-d3', true).classed('svg-content', true);

      var xExtent = d3.extent(data, function (d) {
        return d.date;
      });

      // TODO: hack... make extent bit larger, so that bar charts have padding
      if (self.opt('isBarChart')) {
        xExtent[0] = moment(xExtent[0]).subtract(8, 'hours').toDate();
        xExtent[1] = moment(xExtent[1]).add(8, 'hours').toDate();
      }

      var xScale = d3.time.scale().domain(xExtent).range([self.opt('padding.left'), self.opt('width') - self.opt('padding.right')]);

      // X axis
      var xAxis = d3.svg.axis().scale(xScale).orient('bottom').innerTickSize(0).outerTickSize(5).ticks(6).tickFormat(self.opt('timeFormats.day'));

      svg.append('g').attr('class', 'axis xaxis').attr('transform', 'translate(0,' + (self.opt('height') - self.opt('padding.bottom')) + ')').call(xAxis);

      // Rotate xAxis texts
      svg.selectAll('.xaxis text').attr('transform', function (d) {
        return 'translate(' + this.getBBox().height * -2 + ',' + this.getBBox().height + ') rotate(-45)';
      });

      this.svg = svg;
      this.xScale = xScale;

      return {
        svg: svg,
        xScale: xScale
      };
    }
  }, {
    key: 'createTrendLine',
    value: function createTrendLine(params) {
      var self = this;
      var yScale = this.scales[params.yAxis];
      var xScale = this.xScale;

      var trendData = _.map(this.createTrendData(self.data, params.y), function (d, i) {
        return {
          date: self.data[i].date,
          value: d
        };
      });
      var trendLine = d3.svg.line().interpolate('monotone').x(function (d) {
        return xScale(d.date);
      }).y(function (d) {
        return yScale(d.value);
      });

      self.svg.append('path').datum(trendData).classed('line', true).classed('serie-' + params.name + '-trend', true).attr('d', trendLine).attr('fill', 'none').attr('stroke', params.color).attr('stroke-width', 2).attr('opacity', 0.75);
    }
  }, {
    key: 'createTrendData',
    value: function createTrendData(orderedData, propertyName) {
      var lastIndex = orderedData.length;
      var trends = _.map(orderedData, function (hourlyData) {
        var index = orderedData.indexOf(hourlyData);

        // take 2 before and after
        var minIndex = index - 2 < 0 ? 0 : index - 2;
        var maxIndex = index + 3 >= lastIndex ? lastIndex : index + 3;
        var trendRanges = _.range(minIndex, maxIndex);

        var trendValues = _.chain(trendRanges).map(function (idx) {
          return _.get(orderedData[idx], propertyName, 0);
        }).sum().value();

        return trendValues / trendRanges.length;
      });

      return trends;
    }
  }, {
    key: 'createVerticalPositionIndicator',
    value: function createVerticalPositionIndicator() {
      var self = this;
      var xScale = this.xScale;

      var vertical = d3.select($(this.element)[0]).append('div').attr('class', 'remove position-indicator').style('position', 'absolute')
      //.style("z-index", "19")
      .style('width', '1px').style('height', self.svg.attr('height')).style('top', self.opt('padding.top') + 'px').style('bottom', self.opt('padding.bottom') + 'px').style('left', '0px').style('pointer-events', 'none').style('opacity', 0).style('background', 'rgba(0,0,0,0.1)');

      self.svg.append('rect').attr('width', this.opt('width')).attr('height', this.opt('height')).style('z-index', 99999).style('fill', 'none').style('pointer-events', 'all').on('mousemove', function () {
        var mousex = d3.mouse(this)[0];
        var invertx = self.xScale.invert(mousex);
        var date = self.bisectDate(self.data, invertx, 1);
        var d0 = self.data[date - 1];
        var d1 = self.data[date];
        var d = d0;
        if (d1 && d0) {
          d = invertx - d0.date > d1.date - invertx ? d1 : d0;
        }

        vertical.style('left', xScale(d.date) + 'px');

        self.tooltipDiv.html(self.tooltipFn(d, self._options)).style('left', d3.event.pageX + 10 + 'px').style('top', d3.event.pageY - 28 + 'px');
        self.tooltipDiv.style('opacity', 0.9);
        vertical.style('opacity', 1);
      }).on('mouseover', function () {
        var mousex = d3.mouse(this);
        mousex = mousex[0];
        vertical.style('left', mousex + 'px');
        vertical.style('opacity', 1);

        self.tooltipDiv.transition().duration(200).style('opacity', 0.9);
      }).on('mouseout', function () {
        vertical.style('opacity', 0);

        self.tooltipDiv.transition().duration(300).style('opacity', 0);
      });
    }
  }]);

  return Zcd3;
}();

exports.default = Zcd3;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').factory('ZcsAccessStats', ZcsAccessStats);

ZcsAccessStats.$inject = ['AccessStats'];
function ZcsAccessStats(AccessStats) {
  var service = {
    getLatestTotals: getLatestTotals,
    getAccessStatsForSegment: getAccessStatsForSegment,
    getPerDeviceAccessStatsForSegment: getPerDeviceAccessStatsForSegment,
    getAccessStatsSameSession: getAccessStatsSameSession
  };

  return service;

  function getLatestTotals(apikey) {
    return AccessStats.find({
      dimension: 'daily',
      apikey: apikey
    }, {
      match: {
        campaign_segment_id: null,
        total_conversion_count: null,
        is_control: null,
        is_after_installed_at: null,
        device: null,
        start_at: { $gte: moment().subtract(4, 'days').toDate() }
      },
      sort: {
        start_at: -1
      },
      limit: 1
    }).then(function (res) {
      return _.last(res);
    });
  }

  function getAccessStatsForSegment(apikey, segmentId, startAt, endAt) {
    return AccessStats.find({
      dimension: 'daily',
      apikey: apikey
    }, {
      match: {
        campaign_segment_id: segmentId,
        total_conversion_count: null,
        is_control: null,
        is_after_installed_at: null,
        device: null,
        start_at: { $gte: startAt, $lt: endAt }
      },
      sort: {
        start_at: -1
      }
    });
  }

  function getPerDeviceAccessStatsForSegment(apikey, segmentId, startAt, endAt) {
    return AccessStats.find({
      dimension: 'daily',
      apikey: apikey
    }, {
      match: {
        campaign_segment_id: segmentId,
        total_conversion_count: null,
        is_control: null,
        is_after_installed_at: null,
        device: { $ne: null },
        start_at: { $gte: startAt, $lt: endAt }
      },
      sort: {
        start_at: -1
      }
    });
  }

  function getAccessStatsSameSession(apikey, startAt, endAt) {
    return AccessStats.aggregate({
      dimension: 'daily',
      apikey: apikey
    }, {
      match: {
        is_control: null,
        device: { $ne: null },
        start_at: { $gte: startAt, $lt: endAt }
      },
      pipeline: [{
        $group: {
          _id: '$start_at',
          conversion_count: { $sum: '$conversion_count' }
        }
      }, {
        $project: {
          _id: 0,
          start_at: '$_id',
          conversion_count: '$conversion_count'
        }
      }, {
        $sort: {
          start_at: 1
        }
      }]
    });
  }
}

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// TODO: move this file to common api!

angular.module('zc.zenclerkS').factory('AgencyProject', AgencyProject);

AgencyProject.$inject = ['$q', '$translate', 'Api', 'projectServiceResponseTransformer'];
function AgencyProject($q, $translate, Api, projectServiceResponseTransformer) {
  var PROJECT_STATUSES = [{
    name: $translate.instant('services.agencyProject.accountCreation') // 0
  }, {
    name: $translate.instant('services.agencyProject.companyInfo') // 1
  }, {
    name: $translate.instant('services.agencyProject.siteInfo') // 2
  }, {
    name: $translate.instant('services.agencyProject.ratePlan') // 3
  }, {
    name: $translate.instant('services.agencyProject.trackingTag') // 4
  }, {
    name: $translate.instant('services.agencyProject.conversionTag') // 5
  }, {
    name: $translate.instant('services.agencyProject.campaignDelivered') // 6
  }];

  var service = {
    all: all,
    create: create,
    calculateProjectStatus: calculateProjectStatus,
    setDemoData: setDemoData,
    projectStatuses: PROJECT_STATUSES
  };
  return service;

  function all(agencyId) {
    return Api.get('/api/agencies/' + agencyId + '/projects', {}, {
      cache: false,
      transformResponse: projectServiceResponseTransformer
    }).then(function (res) {
      if (!res.data.success) {
        return $q.reject(res);
      }
      return res.data.projects;
    });
  }

  function create(agencyId, params) {
    return Api.post('/api/agencies/' + agencyId + '/projects/', params).then(function (res) {
      if (!res.data.success) {
        return $q.reject(res);
      }
      return res.data.projects;
    });
  }

  function calculateProjectStatus(project) {
    if (!project.companyinfo_confirmed_at) {
      project.status = 0;
      project.status_last_updated_at = project.created_at;
    } else if (!project.siteinfo_confirmed_at) {
      project.status = 1;
      project.status_last_updated_at = project.companyinfo_confirmed_at;
    } else if (!project.pricing_confirmed_at) {
      project.status = 2;
      project.status_last_updated_at = project.siteinfo_confirmed_at;
    } else if (!project.tracking_tag_confirmed_at) {
      project.status = 3;
      project.status_last_updated_at = project.pricing_confirmed_at;
    } else if (!project.conversion_tag_confirmed_at) {
      project.status = 4;
      project.status_last_updated_at = project.tracking_tag_confirmed_at;
    } else if (project.started_campaigns.length === 0) {
      project.status = 5;
      project.status_last_updated_at = project.conversion_tag_confirmed_at;
    } else {
      // all is well
      project.status = 6;
      var campaignDates = _.map(project.started_campaigns, function (i) {
        return moment(i.created_at).toDate();
      });
      project.status_last_updated_at = _.sortBy(campaignDates, function (i) {
        return -i;
      })[0];
    }

    // Special case!
    // There might not be users at all for example if agency takes care of everything.
    // In this case pricing_confirmed_at will not be checked, and we should only look
    // at tags and campaigns. Still, there might be users in the project, but they
    // are agency users.
    // Tags are the most important things, next are campaigns
    if (project.tracking_tag_confirmed_at && project.conversion_tag_confirmed_at && project.reviewed_at && // just in case
    project.contracted_at && // will be set manually by emin
    project.started_campaigns.length > 0) {
      // should be ok, because agency handles
      project.status = 6;
      var _campaignDates = _.map(project.started_campaigns, function (i) {
        return moment(i.created_at).toDate();
      });
      project.status_last_updated_at = _.sortBy(_campaignDates, function (i) {
        return -i;
      })[0];
    }

    // convert to more human readable
    project.status_last_updated_str = moment(project.status_last_updated_at).tz(project.region).format('YYYY-MM-DD HH:mm');
  }

  function setDemoData(project) {
    var rand = Math.floor(Math.random() * Math.pow(10, 4));
    project.is_demo = true;
    project.title = 'Demo Site';
    project.base_url = 'http://f' + rand + '.example.com/';
    project.company_name = 'Demo Company';
    project.representative = 'Demo ';
    project.postal_code = '000-0000';
    project.address = '12345 Demo Street';
    project.phone_number = '080-1234-5678';
    project.invoice_calculation_type = 'normal';
    project.shopping_cart_asp = 'other';
  }
}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// TODO: move this file to common api!

angular.module('zc.zenclerkS').factory('AgencyUser', AgencyUser);

AgencyUser.$inject = ['$q', 'Api'];
function AgencyUser($q, Api) {
  var service = {
    all: all,
    create: create,
    destroy: destroy
  };

  return service;

  function all(agencyId) {
    return Api.get('/api/agencies/' + agencyId + '/users', {}, { cache: false }).then(function (res) {
      if (!res.data.success) {
        return $q.reject(res);
      }
      return res.data.users;
    });
  }

  function create(agencyId, user) {
    return Api.post('/api/agencies/' + agencyId + '/users/', { user: user }).then(function (res) {
      if (!res.data.success) {
        return $q.reject(res);
      }
      return res.data.user;
    });
  }

  function destroy(agencyId, id) {
    return Api.delete('/api/agencies/' + agencyId + '/users/' + id).then(function (res) {
      if (!res.data.success) {
        return $q.reject(res);
      }
      return res.data.user;
    });
  }
}

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*globals ga*/
angular.module('zc.zenclerkS').factory('Analytics', Analytics);

Analytics.$inject = ['$log'];
function Analytics($log) {
  var service = {};
  service.initialized = false;

  service.initializeGA = function () {
    if (ZC_CONFIG.GA_TRACKING_ID) {
      var gaJs = $('\n      <script>\n      (function(i,s,o,g,r,a,m){i[\'GoogleAnalyticsObject\']=r;i[r]=i[r]||function(){\n      (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n      m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n      })(window,document,\'script\',\'//www.google-analytics.com/analytics.js\',\'ga\');\n      ga(\'create\', \'' + ZC_CONFIG.GA_TRACKING_ID + '\', \'auto\');\n      </script>\n      ');
      $('body').append(gaJs);
      service.initialized = true;
    }
  };

  service.recordPageview = function (url) {
    if (!service.initialized) {
      return;
    }

    if (!ga) {
      $log.warn('Initialized but no GA found');
      return;
    }
    ga('set', 'page', url);
    ga('send', 'pageview');
  };

  return service;
}

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').factory('Behavior', Behavior);

Behavior.$inject = ['$state', 'MongoHistory'];
function Behavior($state, MongoHistory) {

  var service = {
    current: {
      apikey: undefined,
      usid: undefined,
      sid: undefined,
      histories: [],
      playTime: undefined,
      isPlaying: false,
      speedFactor: undefined
    },
    sessionSearchQuery: {
      device: { pc: true, sp: true, tablet: true },
      use_min_history_count: true,
      use_max_history_count: false,
      min_history_count: 5,
      max_history_count: 10,
      use_min_conversion_count: false,
      use_max_conversion_count: false,
      min_conversion_count: 0,
      max_conversion_count: 0
    },
    defaultSessionSearchQuery: {
      device: { pc: true, sp: true, tablet: true },
      use_min_history_count: true,
      use_max_history_count: false,
      min_history_count: 5,
      max_history_count: 10,
      use_min_conversion_count: false,
      use_max_conversion_count: false,
      min_conversion_count: 0,
      max_conversion_count: 0
    },
    sessionSearchTime: {},
    defaultSessionSearchTime: {},
    isAutoplay: false,
    usidPlaylist: [],

    getNextAutoplayUsid: getNextAutoplayUsid,
    autoplayUsid: autoplayUsid,
    getNextHistorySid: getNextHistorySid
  };

  function getNextAutoplayUsid() {
    var currentIdx = service.usidPlaylist.indexOf(service.current.usid);
    return service.usidPlaylist[currentIdx + 1];
  }

  function autoplayUsid(usid) {
    // get first sid
    return MongoHistory.find({ apikey: service.current.apikey, _usid: usid }).then(function (histories) {
      service.current.histories = histories;
      if (service.current.histories[0]) {
        $state.go('viz.site.session.player', { apikey: service.current.apikey, usid: service.current.usid, sid: service.current.histories[0]._id });
      }
    });
  }

  function getNextHistorySid(sid) {
    if (service.current.histories.length === 0) {
      return null;
    }
    for (var i = 0; i < service.current.histories.length; i++) {
      var item = service.current.histories[i];
      var itemNext = service.current.histories[i + 1];
      if (item._id === sid && itemNext) {
        return _.get(service.current.histories, '_id');
      }
    }
    return undefined;
  }

  return service;
}

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').factory('ZcsCampaign', ZcsCampaign);

ZcsCampaign.$inject = ['$filter', '$uibModal', 'Campaign', 'Devise', 'Environment', 'ZcsCampaignName'];
function ZcsCampaign($filter, $uibModal, Campaign, Devise, Environment, ZcsCampaignName) {
  var FIST_DATA_DAY = '2016-12-01';
  var service = {
    FIST_DATA_DAY: FIST_DATA_DAY,
    openMailMagUrlModal: openMailMagUrlModal,
    save: save,
    getCampaignProgress: getCampaignProgress,
    getTooltipMessage: getTooltipMessage,
    isAllowedLiteTemplate: isAllowedLiteTemplate,
    isAllowedToCreate: isAllowedToCreate,
    isCampaignEndingSoon: isCampaignEndingSoon
  };

  return service;

  function prepareCampaignObject(campaign) {
    var campaignObject = _.merge({}, campaign);

    if (campaignObject.id === 'new') {
      campaignObject.id = undefined;
    }

    // Handle date generation manually so that we can use them for name
    // generation below
    campaignObject.start_at = $filter('dateObjToDate')(campaignObject.start_at_obj);
    campaignObject.end_at = $filter('dateObjToDate')(campaignObject.end_at_obj);

    campaignObject.name = ZcsCampaignName.getCampaignName(campaignObject);

    return campaignObject;
  }

  function getCampaignProgress(campaign) {
    var timeUnitsInJapanese = {
      days: '日',
      hours: '時間',
      minutes: '分'
    };

    var campaignProgress = {
      progress: 0,
      progressUnit: 'days',
      progressLeft: 0,
      toString: function toString() {
        return '残り' + campaignProgress.progressLeft + _.get(timeUnitsInJapanese, campaignProgress.progressUnit);
      }
    };

    if (campaign.current_status === 'terminated') {
      return _.merge(campaignProgress, {
        progress: 100
      });
    }

    if (moment(campaign.end_at).diff(moment(), 'hours') < 24) {
      _.merge(campaignProgress, {
        progressUnit: 'hours'
      });
    }

    if (moment(campaign.end_at).diff(moment(), 'minutes') < 60) {
      _.merge(campaignProgress, {
        progressUnit: 'minutes'
      });
    }

    var timeDifference = moment().diff(moment(campaign.start_at), campaignProgress.progressUnit) + 1;
    if (timeDifference < 0) {
      return campaignProgress;
    }

    var duration = moment(campaign.end_at).diff(moment(campaign.start_at), campaignProgress.progressUnit) + 1;
    _.merge(campaignProgress, {
      progress: Math.max(0, Math.min(100, 100 * (timeDifference / duration))),
      progressLeft: duration - timeDifference
    });

    return campaignProgress;
  }

  function getTooltipMessage(project) {
    if (masterUserCreatingACouponForMakeshopAgencyInProdEnv(project)) {
      return $filter('translate')('services.campaign.notAllowedAccessMaster', { env: Environment.environment });
    }

    if (!project.pricing_confirmed_at) {
      return $filter('translate')('services.campaign.notAllowedAccessPricing');
    }

    if (project.suspended_at) {
      return $filter('translate')('services.campaign.notAllowedCampaignDisabled');
    }
  }

  function isCampaignEndingSoon(campaign) {
    if (!campaign) return false;

    var DAY_LIMIT = 14;
    var campaignProgress = getCampaignProgress(campaign);

    if (_.includes(['hours', 'minutes'], campaignProgress.progressUnit)) {
      return true;
    }

    return campaignProgress.progressLeft < DAY_LIMIT;
  }

  function isAllowedToCreate(project) {
    if (!project) return false;

    if (masterUserCreatingACouponForMakeshopAgencyInProdEnv(project)) {
      return false;
    }

    if (project.suspended_at) {
      return false;
    }

    // TODO: remove on 2017-05         ###START###
    // makerepeater should create normally
    if (project.is_oem) {
      return true;
    } else if (moment().isAfter(moment('2017-04-01')) && !project.pricing_confirmed_at) {
      return false;
    }
    // TODO: remove on 2017-05         ###END###
    return true;
  }

  function masterUserCreatingACouponForMakeshopAgencyInProdEnv(project) {
    var isPreProdOrProdEnv = _.includes(['preprod', 'production'], Environment.environment);
    var isMakeshopAgency = project.is_oem && project.shopping_cart_asp === 'makeshop';
    var isMasterUser = Devise.currentUser && Devise.isMaster();
    var isATestSite = project.is_test;
    // Allow only our makeshop test site to create campaigns
    var isOurTestSite = project.apikey === 'test-6c17db893ab972ed';

    return isPreProdOrProdEnv && isMakeshopAgency && isMasterUser && !isATestSite && !isOurTestSite;
  }

  function save(campaign, project) {
    campaign.isSaving = true;
    var campaignObject = prepareCampaignObject(campaign);

    var promise = void 0;
    if (campaign.id === 'new') {
      promise = Campaign.createFromParams({ projectId: project.id }, { campaign: campaignObject, element: campaignObject.element });
    } else {
      promise = Campaign.update({ projectId: project.id, campaignId: campaign.id }, campaignObject);
    }
    promise.finally(function () {
      campaign.isSaving = false;
    });

    return promise;
  }

  function openMailMagUrlModal(campaign, project) {
    $uibModal.open({
      templateUrl: '/templates/zenclerk_s/sites/campaigns/mail_mag_url_modal.html',
      openedClass: 'shows-all-url-content',
      controllerAs: '$ctrl',
      controller: 'ZcsMailMagUrlModalController',
      resolve: {
        campaign: campaign,
        project: project
      }
    });
  }

  function isAllowedLiteTemplate(campaign, project) {
    var allowedTemplates = ['zcs_textonly', 'zcs_image', 'giftcard'];
    if (project.region !== 'asia_tokyo') {
      allowedTemplates.shift();
    }
    if (_.includes(allowedTemplates, campaign.template_type)) {
      return true;
    }
    return false;
  }
}

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').factory('ZcsCampaignElementCreator', ZcsCampaignElementCreator);

ZcsCampaignElementCreator.$inject = ['$filter', 'Template', 'currencies'];
function ZcsCampaignElementCreator($filter, Template, currencies) {
  var service = {
    createCampaignElement: createCampaignElement,
    getSelectableTemplates: getSelectableTemplates,
    setDefaultMessageValues: setDefaultMessageValues
  };

  var defaultMessage = {
    base_color: '#F1B33B',
    limit: '61',
    badge_position: 'left_bottom',
    badge_vertical_position: 10,
    badge_horizontal_position: 10,
    btntext_offer: $filter('translate')('services.campaignElementCreator.continueShopping'),
    btntext_present: 'OK',
    present_pagetype: 'cart',
    offer_hint: $filter('translate')('services.campaignElementCreator.clickToRedisplay')
  };

  var basicSelectableTemplates = [{
    template_type: 'giftcard',
    label: $filter('translate')('services.campaignElementCreator.modernTemplate'),
    img_url: '/assets/img/icon-lg-coupon-giftcard.svg',
    release_date: new Date('2016-08-17'),
    presets: [{
      name: 'default',
      label: $filter('translate')('services.campaignElementCreator.default'),
      template_type: 'giftcard',
      img_url: '',
      element: _.merge(defaultMessage, {
        // Allowed properties:
        // ==================
        // show_modal_first
        // logo
        // discount_type
        // discount_value
        // limit
        // base_color
        // show_incentive_text
        // badge_position
        // coupon_pattern
        // code_condition
        // code_description
        // preset_pagetype
        // reject_pagetypes
        // receive_page_types
        // ignore_pagetype

        base_color: '#F76065',
        badge_position: 'zc-badge-right'
      })
    }]
  }, {
    template_type: 'zcs_textonly',
    label: $filter('translate')('services.campaignElementCreator.textTemplate'),
    img_url: '/assets/img/icon-lg-coupon-color.svg',
    presets: [{
      name: 'default',
      label: $filter('translate')('services.campaignElementCreator.default'),
      template_type: 'zcs_textonly',
      img_url: '',
      element: _.merge(defaultMessage, {
        // Allowed properties:
        // ==================
        // show_modal_first
        // offer_template
        // zc_header
        // zc_insentive_requirement
        // zc_insentive_value
        // zc_insentive_usage_requirement
        // code_title
        // code_name
        // code_condition
        // code_description
        // present_pagetype
        // base_color
        // second_color
        // enables_timer
        // limit
        // enables_badge
        // badge_position
        // badge_icon
        // offer_hint
        // present_hint
        // btntext_offer
        // linkage_url_offer
        // remove_target_blank
        // btntext_present
        // linkage_url
        // remove_target_blank_present
        // code_autoinput
        // reject_pagetypes
        // ignore_pagetype
        // reject_cbc

        second_color: '#F1B33B',
        code_name: $filter('translate')('services.campaignElementCreator.code'),
        zc_header: $filter('translate')('services.campaignElementCreator.customerNotice'),
        zc_insentive_requirement: '',
        zc_insentive_value: '',
        zc_insentive_usage_requirement: '',
        offer_template: 'pattern3',
        present_hint: $filter('translate')('services.campaignElementCreator.presentHint1') + '<br>\n                          ' + $filter('translate')('services.campaignElementCreator.presentHint2') + '<br>\n                          ' + $filter('translate')('services.campaignElementCreator.presentHint3')
      })
    }]
  }, {
    template_type: 'zcs_image',
    label: $filter('translate')('services.campaignElementCreator.imageTemplate'),
    img_url: '/assets/img/icon-lg-coupon-image.svg',
    presets: [{
      name: 'default',
      label: $filter('translate')('services.campaignElementCreator.default'),
      template_type: 'zcs_image',
      img_url: '',
      element: _.merge(defaultMessage, {
        // Allowed properties:
        // ==================
        // show_modal_first
        // banner
        // code_title
        // code_name
        // code_condition
        // code_description
        // present_pagetype
        // base_color
        // limit
        // badge_position
        // badge_icon_font
        // offer_hint
        // present_hint
        // btntext_offer
        // linkage_url_offer
        // remove_target_blank
        // btntext_present
        // linkage_url
        // remove_target_blank_present
        // code_autoinput
        // reject_pagetypes
        // ignore_pagetype
        // reject_cbc
        // howtouse_text

        banner: '',
        second_color: '#F76065'
      })
    }]
  }];
  // for caching template request values
  var allTemplates = void 0;

  return service;

  function createCampaignElement(campaign, project, selectedTemplate) {
    if (!_.get(campaign, 'element.message')) {
      if (!campaign.element) {
        campaign.element = {};
      }
      campaign.element.message = {};
    }

    if (!allTemplates) {
      Template.all(project.id).then(function (res) {
        allTemplates = res;
        selectTemplate(selectedTemplate, campaign, project);
      });
    } else {
      selectTemplate(selectedTemplate, campaign, project);
    }
  }

  function selectTemplate(selectedTemplate, campaign, project) {
    // if selectedTemplate is null, use the first one
    if (!selectedTemplate) selectedTemplate = basicSelectableTemplates[0];

    campaign.selectedTemplate = selectedTemplate;
    campaign.template_type = selectedTemplate.template_type;

    var template = _.find(allTemplates, function (d) {
      return d.name === campaign.template_type;
    });

    if (template) {
      campaign.campaign_type = template.campaign_type;
      _.each(template.template, function (element) {
        if (element.type === 'number') {
          campaign.element.message[element.name] = 0;
          if (element.default) {
            campaign.element.message[element.name] = element.default;
          }
        } else {
          campaign.element.message[element.name] = '';
          if (element.default) {
            campaign.element.message[element.name] = $filter('translate')(element.default);
          }
        }
      });
    }

    // TODO: support for multiple presets
    campaign.element.message = _.merge(campaign.element.message, selectedTemplate.element);
    setDefaultMessageValues(campaign, project);
  }

  /* sets only the text values! */
  function setDefaultMessageValues(campaign, project) {
    var isUpdateCodeTitleOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var incentive = _.get(campaign, 'incentives[0]') || campaign.incentive_draft;
    // if(!incentive) {
    // TODO: would like to throw error but it is thrown every time on reload on every page expect segment so...
    //  throw new Error(`Unknown incentive type on ${project.apikey} - discount_type: ${incentive.discount_type}, is_free_shipping ${incentive.is_free_shipping} `);
    // }

    if (campaign.template_type === 'giftcard') {
      setGiftCardTemplateValues(campaign, project, incentive, isUpdateCodeTitleOnly);
    } else {
      setLegacyTemplateValues(campaign, project, incentive, isUpdateCodeTitleOnly);
    }
  }

  function setLegacyTemplateValues(campaign, project, incentive, isUpdateCodeTitleOnly) {
    campaign.element.message.code_title = getCodeTitle(project, campaign, incentive,
    /* isLegacy = */true,
    /* useLineBreak = */true,
    /* useExclamationMark = */false);
    campaign.element.message.discount_type = getDiscountType(incentive.discount_type, project);
    campaign.element.message.discount_value = getDiscountValue(incentive);

    if (campaign.template_type === 'zcs_textonly') {
      campaign.element.message.zc_insentive_value = getCodeTitle(project, campaign, incentive,
      /* isLegacy = */true,
      /* useLineBreak = */false,
      /* useExclamationMark = */true);
      campaign.element.message.zc_insentive_requirement = $filter('translate')('services.campaignElementCreator.incentiveRequirement', { limit: campaign.element.message.limit - 1 });
    } else {
      campaign.element.message.zc_insentive_value = undefined;
      campaign.element.message.zc_insentive_requirement = undefined;
      campaign.element.message.zc_insentive_usage_requirement = undefined;
    }

    if (isUpdateCodeTitleOnly) {
      return;
    }

    setLegacyInsentiveUsageRequirement(campaign, project, incentive);
    setLegacyCodeDescription(campaign, project);
    setCodeCondition(campaign, project, incentive, true);
  }

  function setLegacyCodeDescription(campaign, project) {
    var firstLine = '<strong>' + $filter('translate')('services.campaignElementCreator.howToUseCoupon') + '</strong>';

    if (project.shopping_cart_asp === 'shopserve') {
      campaign.element.message.code_description = [firstLine, $filter('translate')('services.campaignElementCreator.couponUsage1'), $filter('translate')('services.campaignElementCreator.couponUsage2')].join('\n');
      return;
    }

    campaign.element.message.code_description = [firstLine, $filter('translate')('services.campaignElementCreator.codeDescription1') + '<br>', $filter('translate')('services.campaignElementCreator.codeDescription2') + '<br>', $filter('translate')('services.campaignElementCreator.codeDescription3')].join('\n');
  }

  // For zcs_textonly template only
  function setLegacyInsentiveUsageRequirement(campaign, project, incentive) {
    var currency = currencies[project.currency];
    if (campaign.template_type !== 'zcs_textonly') {
      return;
    }

    if (project.shopping_cart_asp !== 'makeshop') {
      campaign.element.message.zc_insentive_usage_requirement = $filter('translate')('services.campaignElementCreator.limitedToOnePersone') + '<br>';
    }

    if (incentive && incentive.minimum_price) {
      campaign.element.message.zc_insentive_usage_requirement += '\n' + $filter('translate')('services.campaignElementCreator.incentiveUsageRequirement', { amount: '' + currency.symbol + incentive.minimum_price + currency.suffix });
    }
  }

  function setGiftCardTemplateValues(campaign, project, incentive) {
    var isUpdateCodeTitleOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    campaign.element.message.code_title = getCodeTitle(project, campaign, incentive);
    campaign.element.message.discount_type = getDiscountType(incentive.discount_type, project);
    campaign.element.message.discount_value = getDiscountValue(incentive);
    if (isUpdateCodeTitleOnly) {
      return;
    }
    setCodeCondition(campaign, project, incentive);
    setCodeDescription(campaign, project);
  }

  function setCodeCondition(campaign, project, incentive, isLegacy) {
    var currency = currencies[project.currency];
    campaign.element.message.code_condition = '';

    if (project.shopping_cart_asp !== 'makeshop') {
      campaign.element.message.code_condition = $filter('translate')('services.campaignElementCreator.limitedToOnePersone') + '<br>';
    }

    if (incentive && incentive.minimum_price) {
      campaign.element.message.code_condition += '\n' + $filter('translate')('services.campaignElementCreator.minimumPrice', { amount: '' + currency.symbol + incentive.minimum_price + currency.suffix });

      if (isLegacy) {
        campaign.element.message.code_condition = $filter('translate')('services.campaignElementCreator.codeCondition', { amount: '' + currency.symbol + incentive.minimum_price + currency.suffix });
      }

      if (!incentive.has_price_limit) {
        campaign.element.message.code_condition = '';
      }
    }
  }

  function setCodeDescription(campaign, project) {
    var firstLine = project.shopping_cart_asp === 'makeshop' ? '<li>' + $filter('translate')('services.campaignElementCreator.codeDescriptionAddress') + '</li>' : '<li>' + $filter('translate')('services.campaignElementCreator.codeDescriptionOrder') + '</li>';

    campaign.element.message.code_description = [firstLine, '<li>' + $filter('translate')('services.campaignElementCreator.pasteCode') + '</li>'].join('\n');
  }

  function getDiscountType(type, project) {
    var currency = currencies[project.currency];
    var discountTypes = {
      price: '' + currency.symbol + currency.suffix,
      percent: '%'
    };

    return _.get(discountTypes, type, 'free_shipping');
  }

  function getDiscountValue(incentive) {
    var discountValues = {
      price: incentive.discount_price,
      percent: incentive.discount_percent
    };

    return _.get(discountValues, incentive.discount_type, '');
  }

  function getCodeTitle(project, campaign, incentive) {
    var isLegacy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var useLineBreak = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var useExclamationMark = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    var span = {
      open: isLegacy ? '<span>' : '',
      close: isLegacy ? '</span>' : ''
    };

    var exclamationMark = useExclamationMark ? '!' : '';

    if (!incentive) {
      return $filter('translate')('services.campaignElementCreator.incentive');
    }

    if (incentive.is_free_shipping) {
      var lineBreak = useLineBreak ? '<br>' : '';
      return '' + span.open + $filter('translate')('services.campaignElementCreator.freeShipping') + span.close + lineBreak + $filter('translate')('services.campaignElementCreator.couponPresent') + exclamationMark;
    }

    return [span.open, getDiscountValue(incentive), getDiscountType(incentive.discount_type, project), ' OFF', span.close, $filter('translate')('services.campaignElementCreator.couponPresent'), exclamationMark].join('');
  }

  function getSelectableTemplates(project) {
    if (project.region !== 'asia_tokyo') {
      var textTemplate = _.findIndex(basicSelectableTemplates, { template_type: 'zcs_textonly' });
      if (textTemplate >= 0) {
        basicSelectableTemplates.splice(textTemplate, 1);
      }
    }
    return basicSelectableTemplates;
  }
}

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').factory('ZcsCampaignName', ZcsCampaignName);

ZcsCampaignName.$inject = ['$translate', 'ZcsSegment'];
function ZcsCampaignName($translate, ZcsSegment) {
  var service = {
    getCampaignName: getCampaignName
  };

  return service;

  function getCampaignName(campaign) {
    var name = '';
    var schedulePart = '';
    var segmentPart = campaign.segment.name;
    var incentivePart = '';

    if (!campaign.segment) {
      segmentPart = '';
    } else if (ZcsSegment.segmentData[campaign.segment.name].label) {
      segmentPart = $translate.instant('services.campaignName.userSegment', { segment: ZcsSegment.segmentData[campaign.segment.name].label });
    }

    // Do not add date part if campaign is saved in middle of creation without
    // date being set
    if (campaign.start_at) {
      schedulePart += '' + moment(campaign.start_at).format('MM-DD');

      if (campaign.end_at && moment(campaign.start_at).month() !== moment(campaign.end_at).month()) {
        schedulePart += ' ~ ' + moment(campaign.end_at).format('MM-DD');
      }
    }

    if (campaign.incentives[0]) {
      if (campaign.incentives[0].discount_type === 'price') {
        incentivePart = $translate.instant('services.campaignName.off', { amount: '' + campaign.currency.symbol + campaign.incentives[0].discount_price + campaign.currency.suffix });
      } else if (campaign.incentives[0].discount_type === 'percent') {
        incentivePart = $translate.instant('services.campaignName.off', { amount: campaign.incentives[0].discount_percent + '%' });
      }
    }

    name = schedulePart + ' ' + segmentPart + ' ' + incentivePart;
    return name;
  }
}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').factory('ColorMeShop', ColorMeShop);

ColorMeShop.$inject = ['Api'];
function ColorMeShop(Api) {
  return {
    getLoginUrl: getLoginUrl
  };

  function getLoginUrl() {
    return Api.get('/api/oauth/color_me_shop/login_url').then(function (res) {
      return decodeURIComponent(res.data.login_url);
    }).catch(function (error) {
      return console.error(error);
    });
  }
}

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

angular.module('zc.zenclerkS').factory('ZcsDashboardData', ZcsDashboardData);

ZcsDashboardData.$inject = ['$q', 'FacadeV2'];
function ZcsDashboardData($q, FacadeV2) {
  var service = {
    find: find
  };

  return service;

  function find(params) {
    // Take last 2 days to avoid numbers not becoming nulls when day changes,
    // and sort so that we use the latest available data
    // (because aggregate happens at least 3 hours later...)
    var query = {
      params: {
        match: {
          date: { $gte: moment(params.date).subtract(1, 'days').toDate() }
        },
        sort: {
          date: -1
        }
      }
    };

    return $q.all([FacadeV2.request('/apikeys/' + params.apikey + '/zcs_top_pages_by_canonical_url', query), FacadeV2.request('/apikeys/' + params.apikey + '/zcs_top_pages_by_url', query), FacadeV2.request('/apikeys/' + params.apikey + '/zcs_top_referrers', query)]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 3),
          topPagesByCanonicalUrl = _ref2[0],
          topPagesByUrl = _ref2[1],
          topReferrers = _ref2[2];

      return {
        top_pages_by_canonical_url: _.get(topPagesByCanonicalUrl, ['data', 0, 'data']),
        top_pages_by_url: _.get(topPagesByUrl, ['data', 0, 'data']),
        top_referrers: _.get(topReferrers, ['data', 0, 'data'])
      };
    });
  }
}

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').factory('ZcsDeviceName', ZcsDeviceName);

ZcsDeviceName.$inject = ['$translate'];
function ZcsDeviceName($translate) {
  var service = {
    getDeviceName: getDeviceName,
    getDeviceNames: getDeviceNames
  };

  var deviceNames = {
    devicefree: $translate.instant('services.deviceName.devicefree'),
    pc: $translate.instant('services.deviceName.pc'),
    sp: $translate.instant('services.deviceName.sp'),
    tablet: $translate.instant('services.deviceName.tablet')
  };

  return service;

  function getDeviceName(device) {
    return _.get(deviceNames, device, device);
  }

  function getDeviceNames() {
    return deviceNames;
  }
}

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals alertify */

angular.module('zc.zenclerkS').factory('Devise', Devise);

Devise.$inject = ['$http', '$injector', '$location', '$q', '$translate', '$window', 'Api', 'returnUrl'];
function Devise($http, $injector, $location, $q, $translate, $window, Api, returnUrl) {
  var service = {
    currentUser: undefined,
    signIn: signIn,
    signOut: signOut,
    signUp: signUp,
    update: update,
    updateInfo: updateInfo,
    sendPasswordResetInstructions: sendPasswordResetInstructions,
    resetPassword: resetPassword,
    updatePassword: updatePassword,
    validateInvitationToken: validateInvitationToken,
    accept: accept,
    getCurrentUser: getCurrentUser,
    getCurrentUserLanguage: getCurrentUserLanguage,
    isAuthenticated: isAuthenticated,
    isMaster: isMaster,
    signAgreements: signAgreements
  };

  return service;

  function signIn(email, password, rememberMe) {
    return Api.post('/users/sign_in', {
      user: {
        email: email,
        password: password,
        rememberMe: rememberMe
      }
    }).then(function (res) {
      if (!res.data.success) {
        alertify.error($translate.instant('services.devise.incorrectLogin'), 0);
        $q.reject(res);
        return;
      }
      $http.defaults.headers.common['X-CSRF-TOKEN'] = res.data.csrfToken;
      service.currentUser = res.data.user;
      return service.currentUser;
    });
  }

  function signOut() {
    if ($window.ZC_CONFIG.ENABLE_AUTH0) {
      service.currentUser = null;
      $window.location.href = Api.basePath + '/users/auth/logout?origin=' + $window.location.origin;
    } else {
      Api.delete('/users/sign_out').then(function (res) {
        $http.defaults.headers.common['X-CSRF-TOKEN'] = res.data.csrfToken;
        service.currentUser = null;
        return $window.location.replace('/users/sign_in');
      });
    }
  }

  function signUp(companyName, userFullname, userEmail, userPassword, userPasswordConfirmation) {
    return Api.post('/users', {
      company: {
        name: companyName
      },
      user: {
        full_name: userFullname,
        email: userEmail,
        password: userPassword,
        password_confirmation: userPasswordConfirmation
      }
    }).then(function (res) {
      service.currentUser = res.data.user;
      return service.currentUser;
    });
  }

  function update(companyName, userFullname, userEmail) {
    return Api.patch('/users', {
      company: {
        name: companyName
      },
      user: {
        full_name: userFullname,
        email: userEmail
      }
    }).then(function (res) {
      service.currentUser = res.data.user;
      return service.currentUser;
    });
  }

  function updateInfo(user) {
    return Api.patch('/api/users/update_info', { user: user }).then(function (res) {
      // Ideally would like to do _.merge, but for some reason, after first
      // login, we get login_token null response, which is bad.
      // (although currentUser already has the proper login_token from sign_in)
      // Does not happen locally but only in staging!! (and likely in
      // production)
      var safeData = _.omit(res.data.user, ['login_token']);
      service.currentUser = _.merge(service.currentUser, safeData);
      return service.currentUser;
    });
  }

  function sendPasswordResetInstructions(email) {
    // workaround to show loading spinner without wait
    var NotificationChannel = $injector.get('NotificationChannel');
    NotificationChannel.requestStarted();
    return Api.post('/users/password', {
      zcs: true,
      user: {
        email: email
      }
    }).then(function (res) {
      service.currentUser = res.data.user;
      return service.currentUser;
    });
  }

  function resetPassword(resetPasswordToken, password, passwordConfirmation) {
    return Api.put('/users/password', {
      user: {
        password: password,
        password_confirmation: passwordConfirmation,
        reset_password_token: resetPasswordToken
      }
    }).then(function (res) {
      service.currentUser = res.data.user;
      return service.currentUser;
    });
  }

  function updatePassword(currentPassword, password, passwordConfirmation) {
    // workaround to show loading spinner without wait
    var NotificationChannel = $injector.get('NotificationChannel');
    NotificationChannel.requestStarted();
    return Api.patch('/api/users/update_password', {
      user: {
        password: password,
        current_password: currentPassword,
        password_confirmation: passwordConfirmation
      }
    }).then(function (res) {
      service.currentUser = res.data.user;
      return service.currentUser;
    }).catch(function (res) {
      var errCnt = _.reduce(res.data.errors, function (cnt, errors) {
        return cnt + errors.length;
      }, 0);
      // TODO: Move to directives
      if (errCnt === 0) {
        alertify.error($translate.instant('services.devise.incorrectCurrentPassword'));
      }
      return res;
    });
  }

  function validateInvitationToken(invitationToken) {
    return Api.get('/users/invitation/accept?invitation_token=' + invitationToken).then(function (res) {
      if (res.data) {
        res.data.user.invitation_token = invitationToken;
      }
      return _.get(res.data, 'user');
    });
  }

  function accept(user) {
    return Api.patch('/users/invitation', {
      user: {
        full_name: user.full_name,
        email: user.email,
        password: user.password,
        password_confirmation: user.password_confirmation,
        invitation_token: user.invitation_token,
        lang: user.lang
      },
      locale: user.lang
    }).then(function () {
      return service.signIn(user.email, user.password, true);
    });
  }

  function getCurrentUser() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (service.isAuthenticated() && !opts.force) {
      return $q.when(service.currentUser);
    }

    var apiParams = {};
    if (opts.force) {
      apiParams = { isPreflight: opts.isPreflight, cache: false };
    } else {
      apiParams = { isPreflight: opts.isPreflight };
    }

    return Api.get('/users/show_current', {}, apiParams)
    // load language first
    .then(function (res) {
      if (res.data.test === 'test') {
        return res;
      }
      if (!res.data.success) return res;
      return $translate.use(res.data.user.lang).then(function () {
        return res;
      });
    }).then(function (res) {
      if (!res.data.success) {
        if ($location.path() !== '/users/sign_in' && $location.path() !== '/users/invitation/accept') {
          returnUrl.set($location.path());
        }
        return $q.reject(null);
      }
      $translate.use(res.data.user.lang);

      $http.defaults.headers.common['X-CSRF-TOKEN'] = res.data.csrfToken;
      service.currentUser = res.data.user;
      return res.data.user;
    }).catch(function (err) {
      return $q.reject(null);
    });
  }

  function getCurrentUserLanguage() {
    if (service.isAuthenticated()) {
      return $q.when(service.currentUser.lang);
    }

    return Api.get('/users/show_current', {}).then(function (res) {
      return _.get(res, 'data.user.lang');
    });
  }

  function isAuthenticated() {
    return !!service.currentUser;
  }

  function isMaster() {
    return _.get(service.currentUser, 'role') === 'master';
  }

  function signAgreements(user) {
    return Api.patch('/api/users/' + user.id + '/sign_agreements').then(function (res) {
      // Ideally would like to do _.merge, but for some reason, after first
      // login, we get login_token null response, which is bad.
      // (although currentUser already has the proper login_token from sign_in)
      // Does not happen locally but only in staging!! (and likely in
      // production)
      var safeData = _.omit(res.data.user, ['login_token']);
      service.currentUser = _.merge(service.currentUser, safeData);
      return service.currentUser;
    });
  }
}

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').factory('ZcsEstimator', ZcsEstimator);

ZcsEstimator.$inject = ['$q', 'AccessStats'];
function ZcsEstimator($q, AccessStats) {
  var DAYS_PER_MONTH = 30;
  var service = {
    getEstimatedMonthlyStatsForSegment: getEstimatedMonthlyStatsForSegment,
    calculateEstimations: calculateEstimations
  };

  return service;

  function calculateEstimations(project, accessStats, daysSinceCreated, effectiveDays) {
    if (!project || !accessStats) {
      return {
        estimatedMonthlyCouponRevenue: 0,
        estimatedMonthlyConversionPrice: 0,
        estimatedMonthlyConversionUsers: 0,
        totalConversionPrice: 0,
        totalConversionCount: 0,
        totalDaysSinceSegmentCreation: 0,
        totaleffectiveDays: 0,
        totalStatDays: 0
      };
    }

    var monthMultiplier = DAYS_PER_MONTH / effectiveDays;
    var totalConversionPrice = 0;
    var totalConversionCount = 0;

    _.each(accessStats, function (stats) {
      stats.estimated_coupon_revenue = calculateEstimatedCouponRevenue(project, stats.conversion_price);
      totalConversionPrice += stats.conversion_price;
      totalConversionCount += stats.conversion_count;
    });

    var totalEstimatedCouponRevenue = calculateEstimatedCouponRevenue(project, totalConversionPrice);

    var estimatedMonthlyConversionPrice = totalConversionPrice * monthMultiplier;
    var estimatedMonthlyConversionUsers = totalConversionCount * monthMultiplier;
    var estimatedMonthlyCouponRevenue = totalEstimatedCouponRevenue * monthMultiplier;

    var result = {
      estimatedMonthlyCouponRevenue: estimatedMonthlyCouponRevenue,
      estimatedMonthlyConversionPrice: estimatedMonthlyConversionPrice,
      estimatedMonthlyConversionUsers: estimatedMonthlyConversionUsers,
      totalConversionPrice: totalConversionPrice,
      totalConversionCount: totalConversionCount,
      totalDaysSinceSegmentCreation: daysSinceCreated,
      totaleffectiveDays: effectiveDays,
      totalStatDays: accessStats.length
    };
    return result;
  }

  function calculateEstimatedCouponRevenue(project, conversionPrice) {
    return conversionPrice * ((100 - project.pc_control_percent) / 100) * project.estimated_cv_cover_rate * project.estimated_ai_coupon_multiplier;
  }

  function getEstimatedMonthlyStatsForSegment(project, segment) {
    return $q(function (resolve, reject) {
      // Use segment creation day to evaluate how many days should be taken
      // into account. We cannot use accessStats.length because if there is
      // not a single access, no access stats will be created.
      // + 1 because we want to count whole days
      var daysSinceCreated = moment().diff(moment(segment.created_at), 'days') + 1;
      var effectiveDays = _.min([DAYS_PER_MONTH, daysSinceCreated]);

      AccessStats.find({
        dimension: 'daily',
        apikey: project.apikey
      }, {
        match: {
          campaign_segment_id: segment.id,
          is_control: null,
          device: null,
          start_at: {
            $gte: moment().subtract(effectiveDays, 'days').startOf('day').toDate(),
            $lt: moment().subtract(1, 'days').endOf('day').toDate()
          }
        },
        sort: {
          start_at: -1
        }
      }).then(function (accessStats) {
        if (_.get(accessStats, 'success') === false) {
          return resolve({});
        }
        resolve(calculateEstimations(project, accessStats, daysSinceCreated, effectiveDays));
      });
    });
  }
}

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').factory('FeatureNotification', FeatureNotification);

FeatureNotification.$inject = ['Api'];
function FeatureNotification(Api) {
  var service = {
    markAsRead: markAsRead,
    markAsShown: markAsShown,
    resetAll: resetAll
  };

  return service;

  function markAsShown(notification) {
    return Api.post('/api/feature_notifications/mark_as_shown', { key: notification.key });
  }

  function markAsRead(notification) {
    return Api.post('/api/feature_notifications/mark_as_read', { key: notification.key });
  }

  // for development & testing purposes, allow resetting notifications
  function resetAll() {
    return Api.post('/api/feature_notifications/reset_all');
  }
}

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('zc.zenclerkS').factory('ZcsIncentive', zcsIncentive);

zcsIncentive.$inject = ['Api', 'Incentive'];
function zcsIncentive(Api, Incentive) {
  var MARGINAL_PROFIT_PERCENT_COUPON_MAP = [[0.00, [0.02, 0.03, 0.05]], [0.10, [0.03, 0.04, 0.05]], [0.15, [0.03, 0.05, 0.07]], [0.20, [0.05, 0.07, 0.10]], [0.25, [0.07, 0.10, 0.12]], [0.30, [0.10, 0.12, 0.15]], [0.35, [0.12, 0.15, 0.17]], [0.40, [0.15, 0.17, 0.20]], [1.00, [0.17, 0.20, 0.25]]];

  var ZC_FEE_RATE = 0.05;
  var COUPON_BOTTOM_PRICE_RATE = 0.6;
  var COUPON_CENTER_MINIMUM_PRICE = 100;
  var PRICE_DOWN_PERCENT_SAFE_RATE = 0.6;
  var DEFAULT_PROFIT_PERCENT = 30;
  var DEFAULT_AVERAGE_CONVERSION_PRICE = 8000;

  var COUPON_PRICE_DOWN_MAP = [[100, 50], [200, 100], [300, 200], [500, 300], [1000, 500], [1500, 500], [2000, 500], [3000, 1000], [4000, 2000], [5000, 2500], [7500, 2500], [10000, 3000], [15000, 5000], [20000, 5000], [30000, 10000], [40000, 10000], [50000, 20000], [75000, 25000], [100000, 30000]];

  var ZcsIncentive = function () {
    function ZcsIncentive() {
      _classCallCheck(this, ZcsIncentive);
    }

    _createClass(ZcsIncentive, null, [{
      key: 'getDefaultProfitPercent',
      value: function getDefaultProfitPercent() {
        return DEFAULT_PROFIT_PERCENT;
      }
    }, {
      key: 'getDefaultAverageConversionPrice',
      value: function getDefaultAverageConversionPrice() {
        return DEFAULT_AVERAGE_CONVERSION_PRICE;
      }
    }, {
      key: 'all',
      value: function all(projectId, params) {
        return Incentive.all(projectId, params).then(function (incentives) {
          return (
            // sort latest first because we want to show only the latest created one
            // in the incentive list
            _.sortBy(incentives, function (d) {
              return -new Date(d.created_at);
            })
          );
        });
      }
    }, {
      key: 'versions',
      value: function versions(projectId, incentiveId) {
        return Api.get('/api/projects/' + projectId + '/incentives/' + incentiveId + '/versions').then(function (res) {
          return res.data.versions;
        });
      }

      // Get name for incentive

    }, {
      key: 'getName',
      value: function getName(incentive) {
        if (incentive.discount_type === 'price') {
          return incentive.coupon_code + ' ' + incentive.discount_price + 'jpy';
        } else if (incentive.discount_type === 'percent') {
          return incentive.coupon_code + ' ' + incentive.discount_percent + '%';
        } else if (!incentive.discount_type && incentive.is_free_shipping) {
          return incentive.coupon_code + ' free shipping';
        }
        return 'zcs_unfinished_incentive';
      }
    }, {
      key: 'getRecommendedFixedPriceCoupons',
      value: function getRecommendedFixedPriceCoupons(project) {
        var profitPercent = project.profit_percent || DEFAULT_PROFIT_PERCENT;
        var averageConversionPrice = project.average_conversion_price || DEFAULT_AVERAGE_CONVERSION_PRICE;
        var marginalProfitRate = profitPercent / 100;
        if (!marginalProfitRate) {
          marginalProfitRate = 0;
        }
        var couponBottomPrice = averageConversionPrice * COUPON_BOTTOM_PRICE_RATE;
        var priceDownPercent = (marginalProfitRate - ZC_FEE_RATE) * PRICE_DOWN_PERCENT_SAFE_RATE;

        var bottomPrice = couponBottomPrice * priceDownPercent;
        if (bottomPrice < COUPON_CENTER_MINIMUM_PRICE) {
          bottomPrice = COUPON_CENTER_MINIMUM_PRICE;
        }

        var map = _.findLast(COUPON_PRICE_DOWN_MAP, function (d) {
          return d[0] <= bottomPrice;
        });
        if (!map) {
          return null;
        }

        var _map = _slicedToArray(map, 2),
            centerCouponDownPrice = _map[0],
            diffPrice = _map[1];

        var upperCouponPrice = centerCouponDownPrice + diffPrice;
        var lowerCouponPrice = centerCouponDownPrice - diffPrice;
        return [lowerCouponPrice, centerCouponDownPrice, upperCouponPrice];
      }
    }, {
      key: 'getRecommendedPercentCoupons',
      value: function getRecommendedPercentCoupons(project) {
        var profitPercent = project.profit_percent || DEFAULT_PROFIT_PERCENT;

        var marginalProfitRate = profitPercent / 100;
        if (!marginalProfitRate) {
          marginalProfitRate = 0;
        }
        return _.chain(MARGINAL_PROFIT_PERCENT_COUPON_MAP).findLast(function (d) {
          return d[0] <= marginalProfitRate;
        }).get(1) // get the next value
        .map(function (d) {
          return Math.round(d * 100);
        }) // convert to percent
        .value();
      }
    }, {
      key: 'getMinimumPriceLimit',
      value: function getMinimumPriceLimit(discountPrice) {
        if (!discountPrice) {
          return 0;
        }
        return discountPrice + 1;
      }
    }]);

    return ZcsIncentive;
  }();

  return ZcsIncentive;
}

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('zc.zenclerkS').factory('ZcsInvoice', zcsInvoice);

zcsInvoice.$inject = ['FacadeV2'];
function zcsInvoice(FacadeV2) {
  return function () {
    function ZcsInvoice() {
      _classCallCheck(this, ZcsInvoice);
    }

    _createClass(ZcsInvoice, null, [{
      key: 'all',
      value: function all(apikey) {
        return FacadeV2.request('/apikeys/' + apikey + '/zcs_invoices/').then(function (res) {
          return res.data;
        });
      }
    }, {
      key: 'find',
      value: function find(apikey, term) {
        return FacadeV2.request('/apikeys/' + apikey + '/zcs_invoices/' + term, {}).then(function (res) {
          return res.data;
        });
      }
    }, {
      key: 'generateDemoData',
      value: function generateDemoData() {
        return {
          new_client: true,
          consumption_tax: 680,
          discount: 2,
          fee_rate: 0.05,
          invoice_price: 9180,
          invoice_price_tax_excluded: 8500,
          max_invoice: 30000,
          monthly_total_conversion: 3924191,
          total_campaign_price: 170057,
          details: [{
            _id: '1234',
            conversion_count: 8,
            device: 'pc',
            invoice: 5846,
            total: 116922
          }, {
            _id: '1234',
            conversion_count: 6,
            device: 'other',
            invoice: 2656,
            total: 53135
          }]
        };
      }
    }]);

    return ZcsInvoice;
  }();
}

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('zc.zenclerkS').factory('InvoiceAdjustment', invoiceAdjustmentFactory);

invoiceAdjustmentFactory.$inject = ['$q', 'Api'];
function invoiceAdjustmentFactory($q, Api) {
  return function () {
    function InvoiceAdjustment() {
      _classCallCheck(this, InvoiceAdjustment);
    }

    _createClass(InvoiceAdjustment, null, [{
      key: 'all',
      value: function all(project) {
        return Api.get('/api/projects/' + project.id + '/invoice_adjustments/', {}, { cache: false }).then(function (res) {
          if (!res.data.success) {
            return $q.reject(res);
          }
          return res.data.invoice_adjustments;
        });
      }
    }, {
      key: 'show',
      value: function show(project, month) {
        return Api.get('/api/projects/' + project.id + '/invoice_adjustments/' + month, {}, { cache: false }).then(function (res) {
          if (!res.data.success) {
            return $q.reject(res);
          }
          return res.data.invoice_adjustments;
        });
      }
    }, {
      key: 'remove',
      value: function remove(project, id) {
        return Api.delete('/api/projects/' + project.id + '/invoice_adjustments/' + id).then(function (res) {
          if (!res.data.success) {
            return $q.reject(res);
          }
          return res.data.invoice_adjustment;
        });
      }
    }, {
      key: 'create',
      value: function create(project, invoiceAdjustmentObj) {
        return Api.post('/api/projects/' + project.id + '/invoice_adjustments/', { invoice_adjustment: invoiceAdjustmentObj }).then(function (res) {
          if (!res.data.success) {
            return $q.reject(res);
          }
          return res.data.invoice_adjustment;
        });
      }
    }]);

    return InvoiceAdjustment;
  }();
}

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').factory('ZcsLayout', ZcsLayout);

ZcsLayout.$inject = [];
function ZcsLayout() {
  var service = {
    isSidebarVisible: false
  };
  return service;
}

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable angular/file-name,angular/window-service */
angular.module('zc.zenclerkS').factory('ZcsMakeshopApi', zcsMakeshopApi);

zcsMakeshopApi.$inject = ['Api'];
function zcsMakeshopApi(Api) {
  var ZcsMakeshopApi = function () {
    function ZcsMakeshopApi() {
      _classCallCheck(this, ZcsMakeshopApi);
    }

    _createClass(ZcsMakeshopApi, null, [{
      key: 'searchCoupons',
      value: function searchCoupons(project) {
        return Api.get('/api/master/projects/' + project.id + '/makeshop/coupons', project).then(function (res) {
          return res.data.coupons;
        });
      }
    }]);

    return ZcsMakeshopApi;
  }();

  return ZcsMakeshopApi;
}

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// TODO: move this file to common api!
angular.module('zc.zenclerkS').factory('ProjectUser', projectUser);

projectUser.$inject = ['$q', 'Api'];
function projectUser($q, Api) {
  return function () {
    function ProjectUser() {
      _classCallCheck(this, ProjectUser);
    }

    _createClass(ProjectUser, null, [{
      key: 'all',
      value: function all(apikey) {
        return Api.get('/api/projects/apikey:' + apikey + '/users', {}, { cache: false }).then(function (res) {
          if (res.data.success) {
            return res.data.users;
          }
          return $q.reject(res);
        });
      }
    }, {
      key: 'create',
      value: function create(apikey, user) {
        return Api.post('/api/projects/apikey:' + apikey + '/users', { user: user }).then(function (res) {
          if (res.data.success) {
            return res.data.user;
          }
          return $q.reject(res);
        });
      }
    }, {
      key: 'destroy',
      value: function destroy(apikey, id) {
        return Api.delete('/api/projects/apikey:' + apikey + '/users/' + id).then(function (res) {
          if (res.data.success) {
            return res.data.user;
          }
          return $q.reject(res);
        });
      }
    }]);

    return ProjectUser;
  }();
}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').factory('ZcsSegment', ZcsSegment);

ZcsSegment.$inject = ['$q', '$translate', 'AccessStats', 'CampaignSegment', 'ZcsEstimator'];
function ZcsSegment($q, $translate, AccessStats, CampaignSegment, ZcsEstimator) {
  var DAYS_PER_MONTH = 30;
  var segmentData = {
    zcs_segment_all: {
      label: $translate.instant('services.segment.all.label'),
      details: $translate.instant('services.segment.all.details'),
      info: $translate.instant('services.segment.all.info'),
      icon: '/assets/img/illustration-all.svg',
      demoEstimatedMonthlyCouponRevenue: 589952,
      requiredDays: 0
    },
    zcs_segment_new: {
      label: $translate.instant('services.segment.new.label'),
      details: $translate.instant('services.segment.new.details'),
      info: $translate.instant('services.segment.new.info'),
      icon: '/assets/img/illustration-cart-empty.svg',
      demoEstimatedMonthlyCouponRevenue: 466415,
      requiredDays: 0
    },
    zcs_segment_one_cv: {
      label: $translate.instant('services.segment.oneCv.label'),
      details: $translate.instant('services.segment.oneCv.details'),
      info: $translate.instant('services.segment.oneCv.info'),
      demoEstimatedMonthlyCouponRevenue: 93537,
      requiredDays: 30
    },
    zcs_segment_cv_users: {
      label: $translate.instant('services.segment.cvUsers.label'),
      details: $translate.instant('services.segment.cvUsers.details'),
      info: $translate.instant('services.segment.cvUsers.info'),
      icon: '/assets/img/illustration-cart-ok.svg',
      demoEstimatedMonthlyCouponRevenue: 123537,
      requiredDays: 30
    },
    zcs_segment_loyal: {
      label: $translate.instant('services.segment.loyal.label'),
      details: $translate.instant('services.segment.loyal.details'),
      info: $translate.instant('services.segment.loyal.info'),
      demoEstimatedMonthlyCouponRevenue: 30138,
      requiredDays: 60
    },
    /*zcs_segment_all_except_loyal: {
      label: 'Except Loyal',
      details: '',
      demoEstimatedMonthlyCouponRevenue: 423536,
      requiredDays: 60,
    },
    zcs_segment_dormant: {
      label: 'Dormant',
      details: 'Purchased it in the past, but I have not purchased it within 60 days',
      demoEstimatedMonthlyCouponRevenue: 29139,
      requiredDays: 60,
    },*/
    zcs_segment_mail_only: {
      label: $translate.instant('services.segment.mailOnly.label'),
      details: $translate.instant('services.segment.mailOnly.details'),
      info: $translate.instant('services.segment.mailOnly.info'),
      icon: '/assets/img/illustration-mail.svg',
      demoEstimatedMonthlyCouponRevenue: 0,
      requiredDays: 0,
      disableEstimate: true
    }
  };

  return {
    get: get,
    all: all,
    convertToProposal: convertToProposal,
    getSegmentLabel: getSegmentLabel,
    getSegmentIcon: getSegmentIcon,
    getSegmentInfo: getSegmentInfo,
    getProposals: getProposals,
    getLatestStatsForSegment: getLatestStatsForSegment,
    segmentData: segmentData
  };

  // TODO: use segment instead of name
  function getSegmentLabel(name) {
    if (!segmentData[name]) return '';

    return segmentData[name].label;
  }

  function getSegmentIcon(segment) {
    // TODO: return missing or something
    if (!segment || !segment.name) {
      return '';
    }

    return segmentData[segment.name].icon;
  }

  function getSegmentInfo(segment) {
    // TODO: return missing or something
    if (!segment || !segment.name) {
      return '';
    }

    return segmentData[segment.name].info;
  }

  function getSegmentClass(segment) {
    if (!segment || !segment.name) {
      return '';
    }
    return segment.name.replace(/_/g, '-');
  }

  function convertToProposal(segment) {
    var proposal = {};
    proposal.class = getSegmentClass(segment);
    proposal.name = segment.name;
    proposal.segment = segment;
    proposal.segment_id = segment.id;
    proposal.label = getSegmentLabel(segment.name);
    proposal.icon = getSegmentIcon(segment);
    proposal.info = getSegmentInfo(segment);
    proposal.disableEstimate = segmentData[segment.name].disableEstimate;
    return proposal;
  }

  function generateDemoData(proposal) {
    var estimatedMonthlyCouponRevenue = segmentData[proposal.name].demoEstimatedMonthlyCouponRevenue;
    proposal.stats = { estimatedMonthlyCouponRevenue: estimatedMonthlyCouponRevenue };
  }

  function getProposals(project) {
    // Use $q because we do processing to existing in promises,
    // so this is simplest way.
    // It is necessary to return a resolved result to avoid UI flickering
    // because of asynchronous requests.
    return $q(function (resolve, reject) {
      all(project.apikey).then(function (segments) {
        var proposals = _.map(segments, convertToProposal);
        // for demo
        if (project.is_demo) {
          _.each(proposals, generateDemoData);
          resolve(proposals);
        } else {
          var promises = _.map(proposals, function (proposal) {
            var promise = ZcsEstimator.getEstimatedMonthlyStatsForSegment(project, proposal.segment).then(function (res) {
              proposal.stats = res;
              return proposal;
            });
            return promise;
          });

          $q.all(promises).then(function (resolvedProposals) {
            // disable all_except_loyal if loyal's stats are 0
            var loyalSegment = _.find(proposals, function (p) {
              return p.name === 'zcs_segment_loyal';
            });
            if (loyalSegment && loyalSegment.stats && loyalSegment.stats.estimatedMonthlyCouponRevenue === 0) {
              var disableSegments = ['zcs_segment_loyal', 'zcs_segment_all_except_loyal'];
              resolvedProposals = _.reject(resolvedProposals, function (p) {
                return disableSegments.indexOf(p.name) >= 0;
              });
            }

            resolve(resolvedProposals);
          });
        }
      });
    });
  }

  function getLatestStatsForSegment(segmentId, apikey) {
    return AccessStats.find({
      dimension: 'daily',
      apikey: apikey
    }, {
      match: {
        campaign_segment_id: segmentId,
        is_control: null,
        device: null,
        start_at: {
          // ignore today and take latest
          $gte: moment().subtract(4, 'days').toDate(),
          $lte: moment().subtract(1, 'days').toDate()
        }
      },
      sort: {
        start_at: -1
      },
      limit: 1
    }).then(function (results) {
      _.each(results, function (stats) {
        stats.average_conversion_price = stats.conversion_price / stats.conversion_count;

        stats.estimated_monthly_conversion_price = stats.conversion_price * DAYS_PER_MONTH * 0.34;
      });
      return results;
    });
  }

  function get(projectId, segmentId) {
    return CampaignSegment.get(projectId, segmentId);
  }

  function all(apikey) {
    return CampaignSegment.all('apikey:' + apikey).then(function (res) {
      var segments = res;
      // TODO: filter out also those who didn't have any matches
      return _.chain(segments).filter(function (d) {
        return d.name.indexOf('zcs_segment') === 0;
      }).reject(function (d) {
        return !segmentData[d.name];
      }).value();
    });
  }
}

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').factory('Shopify', Shopify);

Shopify.$inject = ['Api'];
function Shopify(Api) {
  return {
    getLoginUrl: getLoginUrl
  };

  function getLoginUrl(shop) {
    return Api.get('/api/oauth/shopify/login_url?shop=' + shop).then(function (res) {
      return decodeURIComponent(res.data.login_url);
    }).catch(function (error) {
      return console.error(error);
    });
  }
}

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').factory('StateBeforeActionRunner', StateBeforeActionRunner);

StateBeforeActionRunner.$inject = ['$injector', '$q', '$rootScope', '$state', 'Devise'];
function StateBeforeActionRunner($injector, $q, $rootScope, $state, Devise) {
  return {
    initialize: initialize
  };

  function initialize() {
    var _this = this;

    // Calls recursively beforeAction of each state if it exists,
    // in the order that parents are called first
    // ex. When going to 'xxx.yyy.zzz', call first xxx, then xxx.yyy, then xxx.yyy.zzz
    // If beforeAction returns falsy, stop calling subsequent ones
    var eventListener = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
      if (!toState) return;

      var beforeActions = _.chain(toState.name.split('.')).map(function (atom, index) {
        return _.slice(toState.name.split('.'), 0, index + 1).join('.');
      }).map(function (name) {
        return $state.get(name);
      }).filter(function (state) {
        return state.beforeAction;
      }).value();

      var callFromStateRoot = function callFromStateRoot(remainingActions, locals) {
        if (remainingActions.length === 0) return;

        $q(function (resolve) {
          return resolve();
        }).then(function () {
          return $injector.invoke(remainingActions[0].beforeAction, _this, locals);
        }).then(function (flg) {
          if (_.isUndefined(flg)) {
            console.warn('WARNING: Got undefined from beforeAction', remainingActions[0].name);
          } else if (!_.isBoolean(flg)) {
            console.warn('WARNING: Got non-boolean from beforeAction', remainingActions[0].name);
          }

          if (!flg) {
            event.preventDefault();
          } else {
            callFromStateRoot(_.slice(remainingActions, 1), locals);
          }
        });
      };

      Devise.getCurrentUser().then(function (currentUser) {
        var locals = {
          event: event,
          toState: toState,
          toParams: toParams,
          fromState: fromState,
          fromParams: fromParams,
          currentUser: currentUser
        };

        callFromStateRoot(beforeActions, locals);
      });
    });

    // Not really needed but good practice to destroy the listener
    $rootScope.$on('$destroy', function () {
      return eventListener();
    });
  }
}

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').factory('ZcsTiming', ZcsTiming);

ZcsTiming.$inject = ['$translate', 'ZcsOemService'];
function ZcsTiming($translate, ZcsOemService) {
  var service = {};

  // timing plans
  service.timingPlans = [{
    name: 'ai',
    label: $translate.instant('services.timing.deliveryAi'),
    class: 'recommended',
    description: $translate.instant('services.timing.deliveryAiDescription', { service: ZcsOemService.getName() }),
    button_text: $translate.instant('services.timing.selectToProceed'),
    icon: '/assets/img/illustration-delivery-ai.svg'
  }, {
    name: 'all',
    label: $translate.instant('services.timing.deliverySegment'),
    class: '',
    description: $translate.instant('services.timing.deliverySegmentDescription'),
    button_text: $translate.instant('services.timing.selectToProceed'),
    icon: '/assets/img/illustration-delivery-all.svg'
  }];

  return service;
}

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS').factory('MongoZcsDailyDiffStats', mongoZcsDailyDiffStats);

mongoZcsDailyDiffStats.$inject = ['$q', 'FacadeV2'];
function mongoZcsDailyDiffStats($q, FacadeV2) {
  var MongoZcsDailyDiffStats = function () {
    function MongoZcsDailyDiffStats() {
      _classCallCheck(this, MongoZcsDailyDiffStats);
    }

    _createClass(MongoZcsDailyDiffStats, null, [{
      key: 'find',
      value: function find(query) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        return $q(function (resolve, reject) {
          if (!query) {
            query = {};
          }

          if (!query.apikey) {
            return reject('No apikey');
          }

          return FacadeV2.request('/apikeys/' + query.apikey + '/zcs_daily_diff_stats', {
            params: {
              match: query,
              sort: options.sort,
              limit: options.limit || 1000
            }
          }).then(function (res) {
            if (res.status !== 200 || (res.data != null ? res.data.error : undefined)) {
              return reject(res.data != null ? res.data.error : undefined);
            }
            return resolve(res.data);
          });
        });
      }
    }]);

    return MongoZcsDailyDiffStats;
  }();

  return MongoZcsDailyDiffStats;
}

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS').factory('ZcsImage', zcsImage);

zcsImage.$inject = ['Api'];
function zcsImage(Api) {
  var ZcsImage = function () {
    function ZcsImage() {
      _classCallCheck(this, ZcsImage);
    }

    _createClass(ZcsImage, null, [{
      key: 'create',
      value: function create(params, data) {
        return Api.post('/api/projects/' + params.projectId + '/images.json', {}, {
          method: 'POST',
          headers: {
            'Content-Type': undefined
          },
          data: data,
          transformRequest: function transformRequest(outgoingData) {
            var fd = new FormData();
            // val key order!
            angular.forEach(outgoingData, function (val, key) {
              return fd.append(key, val);
            });
            return fd;
          }
        });
      }
    }, {
      key: 'get',
      value: function get(params) {
        return Api.get('/api/projects/' + params.projectId + '/images/' + params.imageId).then(function (res) {
          return res.data.image;
        });
      }
    }]);

    return ZcsImage;
  }();

  return ZcsImage;
}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable angular/file-name,angular/window-service */
angular.module('zc.zenclerkS').factory('ZcsMakerepeaterOem', zcsMakerepeaterOem);

zcsMakerepeaterOem.$inject = ['$cookies', '$location', '$q', '$rootScope', '$window', 'Api', 'Devise'];
function zcsMakerepeaterOem($cookies, $location, $q, $rootScope, $window, Api, Devise) {
  var ZcsMakerepeaterOem = function () {
    function ZcsMakerepeaterOem() {
      _classCallCheck(this, ZcsMakerepeaterOem);
    }

    _createClass(ZcsMakerepeaterOem, null, [{
      key: 'login',
      value: function login(cookie) {
        return Api.post('/api/makerepeater/sessions', { cookie: cookie }).then(function (res) {
          return Devise.getCurrentUser({ force: true });
        });
      }
    }, {
      key: 'handleLogin',
      value: function handleLogin() {
        var cookie = $cookies.get(window.ZC_CONFIG.MAKEREPEATER_COOKIE);
        if (cookie) {
          return ZcsMakerepeaterOem.login(cookie);
        }

        if ($window.parent) {
          // redirect parent frame because the content is in iframe
          $window.parent.location.href = window.ZC_CONFIG.MAKEREPEATER_LOGIN_URL;
        } else {
          $window.location.href = window.ZC_CONFIG.MAKEREPEATER_LOGIN_URL;
        }
        return $q.reject();
      }
    }, {
      key: 'providePublicApi',
      value: function providePublicApi() {
        $window.publicApi = {
          goTo: function goTo(url) {
            $location.url(url);
            return $rootScope.$apply();
          }
        };
      }
    }]);

    return ZcsMakerepeaterOem;
  }();

  return ZcsMakerepeaterOem;
}

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS').factory('ZcsOemService', zcsOemService);

zcsOemService.$inject = ['$q', '$translate', 'ZcsMakerepeaterOem'];
function zcsOemService($q, $translate, ZcsMakerepeaterOem) {
  var ZcsOemService = function () {
    function ZcsOemService() {
      _classCallCheck(this, ZcsOemService);
    }

    _createClass(ZcsOemService, null, [{
      key: 'set',
      value: function set(oemService) {
        this.oemService = oemService;
      }
    }, {
      key: 'get',
      value: function get() {
        return this.oemService;
      }
    }, {
      key: 'isOemService',
      value: function isOemService() {
        return !!this.oemService;
      }
    }, {
      key: 'getName',
      value: function getName() {
        switch (this.oemService) {
          case 'makerepeater':
            return $translate.instant('services.zcsOem.makerepeater');
          default:
            return 'AiDeal lite';
        }
      }
    }, {
      key: 'getConversionTagPrefix',
      value: function getConversionTagPrefix() {
        switch (this.oemService) {
          case 'makerepeater':
            return 'mrcvassist';
          default:
            return 'zenclerk';
        }
      }
    }, {
      key: 'getPublishHostForProject',
      value: function getPublishHostForProject(project) {
        switch (this.oemService) {
          case 'makerepeater':
            return 'cvtr.makerepeater.jp';
          default:
            return project.publish_domain + '.zenclerk.com';
        }
      }
    }, {
      key: 'handleLogin',
      value: function handleLogin() {
        switch (this.oemService) {
          case 'makerepeater':
            return ZcsMakerepeaterOem.handleLogin();
          default:
            return $q.reject();
        }
      }
    }, {
      key: 'providePublicApi',
      value: function providePublicApi() {
        switch (this.oemService) {
          case 'makerepeater':
            return ZcsMakerepeaterOem.providePublicApi();
        }
      }
    }]);

    return ZcsOemService;
  }();

  return ZcsOemService;
}

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/file-name */
// TODO: move this file to common api!
angular.module('zc.zenclerkS').factory('ZcsProject', ZcsProject);

ZcsProject.$inject = ['$q', '$translate', 'Api', 'Project', 'projectServiceRequestTransformer', 'projectServiceResponseTransformer'];
function ZcsProject($q, $translate, Api, Project, projectServiceRequestTransformer, projectServiceResponseTransformer) {
  var PROFIT_RATE_OPTIONS = function PROFIT_RATE_OPTIONS() {
    return [{ value: 10, label: '10-15%' }, { value: 15, label: '15-20%' }, { value: 20, label: '20-25%' }, { value: 25, label: '25-30%' }, { value: 30, label: '30-35%' }, { value: 35, label: '35-40%' }, { value: 40, label: '40-45%' }, { value: 45, label: '45-50%' }, { value: 50, label: $translate.instant('services.zcsProject.moreThan', { number: '50%' }) }];
  };

  var AVERAGE_CONVERSION_PRICE_OPTIONS = function AVERAGE_CONVERSION_PRICE_OPTIONS(currency) {
    return [{ value: 500, label: $translate.instant('services.zcsProject.lessThan', { number: currency.symbol + '1,000' + currency.suffix }) }, { value: 1000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '1,000' + currency.suffix }) }, { value: 2000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '2,000' + currency.suffix }) }, { value: 3000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '3,000' + currency.suffix }) }, { value: 4000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '4,000' + currency.suffix }) }, { value: 5000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '5,000' + currency.suffix }) }, { value: 6000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '6,000' + currency.suffix }) }, { value: 7000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '7,000' + currency.suffix }) }, { value: 8000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '8,000' + currency.suffix }) }, { value: 9000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '9,000' + currency.suffix }) }, { value: 10000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '10,000' + currency.suffix }) }, { value: 11000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '11,000' + currency.suffix }) }, { value: 12000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '12,000' + currency.suffix }) }, { value: 13000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '13,000' + currency.suffix }) }, { value: 14000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '14,000' + currency.suffix }) }, { value: 15000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '15,000' + currency.suffix }) }, { value: 16000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '16,000' + currency.suffix }) }, { value: 17000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '17,000' + currency.suffix }) }, { value: 18000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '18,000' + currency.suffix }) }, { value: 19000, label: $translate.instant('services.zcsProject.about', { number: currency.symbol + '19,000' + currency.suffix }) }, { value: 20000, label: $translate.instant('services.zcsProject.moreThan', { number: currency.symbol + '20,000' + currency.suffix }) }];
  };

  var service = {
    all: all,
    get: get,
    remove: remove,
    saveProject: saveProject,
    PROFIT_RATE_OPTIONS: PROFIT_RATE_OPTIONS,
    AVERAGE_CONVERSION_PRICE_OPTIONS: AVERAGE_CONVERSION_PRICE_OPTIONS
  };

  return service;

  function all(userId) {
    return Api.get('/api/users/' + userId + '/projects', {}, {
      cache: false,
      transformResponse: projectServiceResponseTransformer
    }).then(function (res) {
      if (!res.data.success) {
        $q.reject(res);
        return;
      }
      return _.filter(res.data.projects, { product_line: 'zenclerk_s' });
    });
  }

  function get(userId, apikey) {
    if (!apikey) {
      return $q.reject(null);
    }
    return Api.get('/api/users/' + userId + '/projects/' + apikey, {}, {
      cache: false,
      transformResponse: projectServiceResponseTransformer
    }).then(function (res) {
      if (!res.data.success) {
        return $q.reject(res);
      }
      return res.data.project;
    });
  }

  function remove(userId, apikey) {
    return Api.delete('/api/users/' + userId + '/projects/' + apikey);
  }

  function saveProject(project) {
    return Project.update({ projectId: project.id }, { project: project }, {
      transformRequest: projectServiceRequestTransformer,
      transformResponse: projectServiceResponseTransformer
    });
  }
}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsAgencyHome', {
  templateUrl: '/templates/zenclerk_s/agencies/home/agency_home.html',
  bindings: {
    agency: '<'
  },
  controller: ZcsAgencyHomeController
});

ZcsAgencyHomeController.$inject = ['AgencyProject', 'AgencyUser'];
function ZcsAgencyHomeController(AgencyProject, AgencyUser) {
  var vm = this;

  vm.projects = [];
  vm.showTestProjects = false;
  vm.projectsFetched = false;

  // functions
  vm.updateProjects = updateProjects;

  vm.$onInit = function () {
    AgencyUser.all(vm.agency.name).then(function (users) {
      vm.users = users;
    });

    AgencyProject.all(vm.agency.name).then(function (projects) {
      vm.projectsFetched = true;

      projects = _.filter(projects, { product_line: 'zenclerk_s', is_demo: false, is_test: false });
      vm.installationFinishedProjects = _.filter(projects, function (d) {
        return d.started_campaigns.length > 0;
      });
      vm.allProjects = projects;

      vm.lastProjects = _.chain(projects).filter(function (d) {
        return moment().diff(moment(d.created_at), 'days') < 90;
      }).sortBy(function (d) {
        return -new Date(d.created_at);
      }).value();

      updateProjects();
    });
  };

  function updateProjects() {
    if (vm.showTestProjects) {
      vm.projects = vm.allProjects.slice(0);
    } else {
      vm.projects = _.reject(vm.allProjects, function (p) {
        return p.is_test;
      });
    }
  }
}

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsAgencyInvoiceShowController', ZcsAgencyInvoiceShowController);

ZcsAgencyInvoiceShowController.$inject = ['$state', '$stateParams', '$translate', 'agency', 'currencies', 'invoice', 'projects'];
function ZcsAgencyInvoiceShowController($state, $stateParams, $translate, agency, currencies, invoice, projects) {
  //# Set values
  var vm = this;
  vm.agency = agency;
  vm.invoice = invoice;
  vm.invoiceCurrency = currencies[invoice.invoice_currency || 'jpy'];

  var projectByApikey = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = projects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var project = _step.value;

      projectByApikey[project.apikey] = project;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = vm.invoice.sites[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var site = _step2.value;

      var currentProject = projectByApikey[site.apikey];
      site.title = currentProject ? currentProject.title : site.apikey;
    }

    //# Get the selected month
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  var currentMonth = moment($stateParams.term, 'YYYY-MM').endOf('month');
  vm.invoiceMonth = $stateParams.term;

  vm.currentMonth = currentMonth.format('YYYY/MM');

  vm.header = ['APIKEY', $translate.instant('agencies.invoices.showController.saito_na'), $translate.instant('agencies.invoices.showController.himoku'), $translate.instant('agencies.invoices.showController.seikyuu_kingaku_zeinuki'), $translate.instant('agencies.invoices.showController.dairiten_tesuuryou_zeinuki'), $translate.instant('agencies.invoices.showController.seikyuu_kingaku_dairiten'), $translate.instant('agencies.invoices.showController.note_sum')];

  vm.isLatest = isLatest;
  vm.goToNext = goToNext;
  vm.nextMonth = moment(currentMonth).add(1, 'months').format('YYYY-MM');
  vm.lastMonth = moment(currentMonth).subtract(1, 'months').format('YYYY-MM');
  vm.getCSV = getCSV;

  function isLatest() {
    if (moment(currentMonth).isAfter(moment())) {
      return true;
    }
    return false;
  }

  function goToNext(term) {
    if (vm.isLatest()) {
      return;
    }
    $state.go('zenclerkS.agency.invoices.show', { term: term });
  }

  function getCSV() {
    var resultData = [];
    _.each(vm.invoice.sites, function (site) {
      _.each(site.details, function (detail) {
        var data = [site.apikey, site.title, detail.title, detail.original_price, detail.original_price - detail.price, detail.price];
        resultData.push(data);
      });
    });
    return resultData;
  }
}

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsAgencyInvoicesListController', ZcsAgencyInvoicesListController);

ZcsAgencyInvoicesListController.$inject = ['agency', 'currencies', 'invoices'];
function ZcsAgencyInvoicesListController(agency, currencies, invoices) {
  var vm = this;
  vm.agency = agency;
  vm.thisMonth = moment().format('YYYY-MM');
  vm.invoices = invoices;
  vm.currencies = currencies;
}

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsAgencySettingsController', ZcsAgencySettingsController);

ZcsAgencySettingsController.$inject = ['Agency', 'agency'];
function ZcsAgencySettingsController(Agency, agency) {
  var vm = this;
  vm.agency = agency;

  vm.save = function (updatedAgency) {
    return Agency.update(updatedAgency);
  };
}

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsAgencyCreateSiteController', ZcsAgencyCreateSiteController);

ZcsAgencyCreateSiteController.$inject = ['$scope', '$state', '$stateParams', 'AgencyProject', 'agency', 'regions', 'salesEntities'];
function ZcsAgencyCreateSiteController($scope, $state, $stateParams, AgencyProject, agency, regions, salesEntities) {
  var vm = this;
  vm.site = {};
  vm.regions = regions;
  vm.salesEntities = salesEntities;
  vm.agency = agency;
  vm.site.shopping_cart_asp = agency.default_shopping_cart_asp;
  vm.showCartId = showCartId;
  vm.save = save;

  if ($stateParams.demo) {
    AgencyProject.setDemoData(vm.site);
  }

  if (!agency.is_direct_selling) {
    vm.site.sales_entity = agency.sales_entity;
  }

  vm.shopping_cart_asp_options = [{ value: '', label: 'agencies.sites.createSiteController.sentaku_shitekudasai', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu' }, { value: 'aishipr', label: 'aishipR', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu' }, { value: 'base', label: 'BASE', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu' }, { value: 'cartstar', label: 'CARTSTAR', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.tenpo_koodo' }, { value: 'color_me_shop', label: 'カラーミーショップ', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.akaunto' }, { value: 'commerce_21', label: 'コマース21', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu' }, { value: 'e_shops', label: 'e-shopsカート2', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu' }, { value: 'ebisumart', label: 'ebisumart', invoice_calculation_type: 'normal', id_name: 'ebisumart No' }, { value: 'ec_cube', label: 'EC-CUBE', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu' }, { value: 'ecbeing', label: 'ecbeing', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu' }, { value: 'fc2', label: 'FC2ショッピングカート', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu' }, { value: 'futureshop2', label: 'FutureShop2', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.tenpo' }, { value: 'makeshop', label: 'MakeShop', invoice_calculation_type: 'normal', id_name: 'agencies.sites.createSiteController.shoppu' }, { value: 'ocnk_net', label: 'おちゃのこネット', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu' }, { value: 'os_commerce', label: 'osCommerce', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu' }, { value: 'shopmaker', label: 'ショップメーカー', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu' }, { value: 'shopserve', label: 'ショップサーブ', invoice_calculation_type: 'normal', id_name: 'agencies.sites.createSiteController.shoppu' }, { value: 'shopify', label: 'Shopify', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu' }, { value: 'stores', label: 'STORES.jp', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu' }, { value: 'tamago_repeat', label: 'たまごリピート', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu' }, { value: 'vtex', label: 'Vtex', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu' }, { value: 'zencart', label: 'Zen Cart', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu' }, { value: 'other', label: 'agencies.sites.createSiteController.sonohoka', invoice_calculation_type: 'deemed', id_name: 'agencies.sites.createSiteController.shoppu' }];

  $scope.$watch('vm.site.shopping_cart_asp', shoppingCartAspChanged);

  function shoppingCartAspChanged(shoppingCartAsp) {
    var asp = _.find(vm.shopping_cart_asp_options, { value: shoppingCartAsp });
    if (asp) {
      vm.site.invoice_calculation_type = asp.invoice_calculation_type;
      vm.id_name = asp.id_name;
    }
  }

  function showCartId() {
    return vm.site.shopping_cart_asp !== 'other' && vm.site.shopping_cart_asp !== 'ec_cube' && vm.site.shopping_cart_asp !== 'base';
  }

  function save(site) {
    return AgencyProject.create($stateParams.agencyName, site).then(function (res) {
      return $state.go('zenclerkS.agency.sites', { agencyName: $stateParams.agencyName }, { reload: true });
    });
  }
}

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsAgencyProjectTable', {
  templateUrl: '/templates/zenclerk_s/agencies/sites/agency_project_table.html',
  bindings: {
    projects: '<',
    projectsMaxInvoice: '<'
  },
  controller: zcsAgencyProjectTable
});

zcsAgencyProjectTable.$inject = ['$scope', '$stateParams', '$translate', 'CampaignStatsV2', 'Devise', 'ZcsProject'];
function zcsAgencyProjectTable($scope, $stateParams, $translate, CampaignStatsV2, Devise, ZcsProject) {
  var vm = this;
  vm.sortProp = 'conversion_tag_confirmed_at';

  vm.setSortProp = setSortProp;
  vm.removeProject = removeProject;
  vm.guessProjectStatus = guessProjectStatus;
  vm.getTerminatedDate = getTerminatedDate;

  vm.data = ['apikey', 'title', 'company_name', 'shopping_cart_asp', 'cart_id', 'base_url', 'created_at', 'project_status', 'terminated_at', 'planned_campaigns', 'started_campaigns_count', 'days_since_last_campaign', 'max_invoice'];
  vm.header = ['APIKEY', $translate.instant('agencies.sites.projectTableComponent.saito_na'), $translate.instant('agencies.sites.projectTableComponent.kaishamei'), $translate.instant('agencies.sites.projectTableComponent.kaato_asp'), $translate.instant('agencies.sites.projectTableComponent.kaato_id'), $translate.instant('agencies.sites.projectTableComponent.saito'), $translate.instant('agencies.sites.projectTableComponent.saito_sakusei_hi'), $translate.instant('agencies.sites.projectTableComponent.dounyuu_suteetasu'), $translate.instant('agencies.sites.projectTableComponent.keiyaku_shuuryoubi'), $translate.instant('agencies.sites.projectTableComponent.haishin_kazu_nakaguro'), $translate.instant('agencies.sites.projectTableComponent.kyanpeen_sousuu'), $translate.instant('agencies.sites.projectTableComponent.saigo_no_kyanpeenkara'), $translate.instant('agencies.sites.projectTableComponent.seikyuu_jougen_kingaku')];

  vm.getCSV = getCSV;

  vm.$onChanges = function () {
    vm.filteredProjects = filterProjects();
    _.each(vm.projects, function (project) {
      // Get maximum invoice - falsey means "show spinner", -1 means "not to show""
      if (project.terminated_at || project.is_demo || project.is_test) {
        project.max_invoice = -1;
      } else {
        project.max_invoice = vm.projectsMaxInvoice[project.apikey];
      }

      var elapsedDays = [];
      project.planned_campaigns = 0;
      project.days_since_last_campaign = 0;
      project.started_campaigns_count = project.started_campaigns.length;
      project.has_widget = false;
      project.project_status = vm.guessProjectStatus(project);

      if (project.started_campaigns.length === 0) {
        project.days_since_last_campaign = -1;
      } else {

        _.each(project.started_campaigns, function (campaign) {
          if (campaign.is_widget) {
            if (campaign.status === 'activated') {
              // TODO: not used currently (yet), but just to avoid counting widget
              project.has_widget = true;
            }
          } else if (campaign.status === 'activated' && moment(campaign.end_at).isAfter(moment())) {
            project.planned_campaigns += 1;
          } else if (campaign.status === 'blocked' || campaign.status === 'terminated') {
            project.has_terminated_campaigns = true;
          } else if (campaign.status === 'activated') {
            elapsedDays.push(moment().diff(moment(campaign.end_at), 'days'));
          }
        });

        if (elapsedDays.length === 0) {
          project.days_since_last_campaign = -1;
        }

        // If blocked or terminated exists, check when it was last delivered
        if (!project.has_terminated_campaigns && project.planned_campaigns > 0) {
          // take the lowest value
          project.days_since_last_campaign = _.min(elapsedDays);
        } else {
          // take lastest campaign stats and only after that take the lowest value
          CampaignStatsV2.find({
            dimension: 'hourly',
            apikey: project.apikey
          }, {
            delivery_count: { $gte: 1 }
          }, {
            sort: { start_at: -1 },
            limit: 1
          }).then(function (stats) {
            // if does not have any, it means no campaign has ever been delivered
            if (stats.length > 0) {
              elapsedDays.push(moment().diff(moment(stats[0].start_at), 'days'));
            }
            project.days_since_last_campaign = _.min(elapsedDays) || 0;
          });
        }
      }
    });
  };

  function filterProjects() {
    var projects = _.chain(vm.projects).filter(function (p) {
      return p.product_line === 'zenclerk_s';
    }).sortBy(function (p) {
      // Dates are strings so must do new Date creation or safari sorting does not work
      if (vm.sortProp.endsWith('_at')) {
        return -new Date(p[vm.sortProp]);
      }
      return -_.get(p, vm.sortProp);
    }).value();

    return projects;
  }

  function removeProject(project) {
    Devise.getCurrentUser().then(function (user) {
      ZcsProject.remove(user.id, project.apikey).then(function () {
        vm.projects = _.reject(vm.projects, function (i) {
          return i.apikey === project.apikey;
        });
        vm.filteredProjects = filterProjects();
      });
    });
  }

  function setSortProp(prop) {
    vm.sortProp = prop;
    vm.filteredProjects = filterProjects();
  }

  function getTerminatedDate(date) {
    return moment(date).subtract(1, 'month').format('YYYY-MM');
  }

  function guessProjectStatus(project) {
    if (project.terminated_at) {
      return 'terminated';
    }
    if (project.suspended_at) {
      return 'suspended';
    }
    if (project.conversion_tag_confirmed_at) {
      return 'conversion_tag_confirmed';
    }
    return 'no_tag_set';
  }

  function getCSV() {
    var csvData = _.map(vm.projects, function (p) {
      return _.pick(p, vm.data);
    });
    return csvData;
  }
}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

angular.module('zc.zenclerkS').component('zcsAgencySiteList', {
  templateUrl: '/templates/zenclerk_s/agencies/sites/agency_site_list.html',
  bindings: {
    agency: '<'
  },
  controller: ZcsAgencySiteListController
});

ZcsAgencySiteListController.$inject = ['$filter', '$scope', '$state', 'AgencyProject', 'ZcsAgencyInvoice'];
function ZcsAgencySiteListController($filter, $scope, $state, AgencyProject, ZcsAgencyInvoice) {
  var vm = this;

  vm.projects = [];
  vm.filter = '';
  vm.filteredProjects = [];
  vm.demoProjects = [];
  vm.testProjects = [];
  vm.agencyProjectsMaxInvoice = {}; // for the max invoice(上限金額) column but uses expensive mongodb query

  //actions
  vm.newSite = newSite;
  vm.filterChanged = filterChanged;

  vm.$onInit = function () {
    Promise.all([AgencyProject.all(vm.agency.name), ZcsAgencyInvoice.findAgencyApikeyMaxInvoice(vm.agency.name, moment().format('YYYY-MM'))]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          projects = _ref2[0],
          agencyProjectsMaxInvoice = _ref2[1];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = projects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var project = _step.value;

          if (project.is_demo) {
            vm.demoProjects.push(project);
          } else if (project.is_test) {
            vm.testProjects.push(project);
          } else {
            vm.projects.push(project);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      vm.agencyProjectsMaxInvoice = agencyProjectsMaxInvoice;
      filterChanged();
    });
  };

  function filterChanged() {
    vm.filteredProjects = $filter('searchProject')(vm.projects, vm.filter);
  }

  function newSite(demo) {
    return $state.go('zenclerkS.agency.sites.new', { demo: demo });
  }
}

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsAgencySitesInInstallation', {
  templateUrl: '/templates/zenclerk_s/agencies/sites_in_installation/sites_in_installation.html',
  bindings: {
    agency: '<'
  },
  controller: zcsAgencySitesInInstallation
});

zcsAgencySitesInInstallation.$inject = ['$scope', '$stateParams', '$translate', 'AgencyProject'];
function zcsAgencySitesInInstallation($scope, $stateParams, $translate, AgencyProject) {
  var vm = this;

  // for CSV download
  vm.status = AgencyProject.projectStatuses;
  vm.data = ['apikey', 'title', 'company_name', 'shopping_cart_asp', 'cart_id', 'base_url', 'status', 'status_last_updated_str', 'status_num'];
  vm.header = ['APIKEY', $translate.instant('agencies.sitesInInstallation.component.saito_na'), $translate.instant('agencies.sitesInInstallation.component.kaishamei'), $translate.instant('agencies.sitesInInstallation.component.kaato_asp'), $translate.instant('agencies.sitesInInstallation.component.kaato_id'), $translate.instant('agencies.sitesInInstallation.component.saito'), $translate.instant('agencies.sitesInInstallation.component.dounyuu_suteetasu'), $translate.instant('agencies.sitesInInstallation.component.dounyuu_suteetasu_koushin'), $translate.instant('agencies.sitesInInstallation.component.dounyuu_suteetasu_suuji')];

  vm.getCSV = getCSV;

  vm.$onInit = function () {
    AgencyProject.all($stateParams.agencyName).then(function (projects) {
      projects = _.filter(projects, { product_line: 'zenclerk_s' });
      vm.projects = _.chain(projects).reject(function (d) {
        return d.is_test || d.is_demo;
      }).sortBy(function (d) {
        return -new Date(d.created_at);
      }).each(AgencyProject.calculateProjectStatus).value();
    });
  };

  function getCSV() {
    var csvData = _.map(vm.projects, function (p) {
      return _.pick(p, vm.data);
    });
    _.each(csvData, function (p) {
      p.status_num = p.status;
      p.status = vm.status[p.status].name;
    });
    return csvData;
  }
}

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsAgencySitesUserActivity', {
  templateUrl: '/templates/zenclerk_s/agencies/sites_user_activity/sites_user_activity.html',
  bindings: {
    agency: '<'
  },
  controller: zcsAgencySitesUserActivity
});

zcsAgencySitesUserActivity.$inject = ['$scope', '$stateParams', 'AgencyProject'];
function zcsAgencySitesUserActivity($scope, $stateParams, AgencyProject) {
  var vm = this;

  vm.$onInit = function () {
    AgencyProject.all($stateParams.agencyName).then(function (projects) {
      vm.allProjects = projects;
      filterProjects();
    });
  };

  function filterProjects() {
    vm.projects = _.chain(vm.allProjects).reject(function (d) {
      return d.is_test || d.is_demo;
    }).sortBy(function (d) {
      return -new Date(d.created_at);
    }).value();
  }
}

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsAgencyUsersController', ZcsAgencyUsersController);

ZcsAgencyUsersController.$inject = ['$scope', '$stateParams', 'AgencyUser', 'currentUser', 'users'];

function ZcsAgencyUsersController($scope, $stateParams, AgencyUser, currentUser, users) {
  var vm = this;
  vm.users = users;
  vm.state = {};
  vm.currentUser = currentUser;
  vm.newUser = { email: '', full_name: '' };

  vm.inviteUser = inviteUser;
  vm.removeUser = removeUser;

  function sortUsers() {
    vm.users = _.sortBy(vm.users, function (user) {
      if (vm.currentUser.id === user.id) {
        return -1;
      }
      return user.id;
    });
  }

  //# Invite user
  function inviteUser() {
    AgencyUser.create($stateParams.agencyName, vm.newUser).then(function (user) {
      vm.users.push(user);
      sortUsers();
      vm.newUser = { email: '', full_name: '' };
    });
  }

  //# Remove user
  function removeUser(user) {
    AgencyUser.destroy($stateParams.agencyName, user.id).then(function (deletedUser) {
      _.remove(vm.users, function (u) {
        return u.id === deletedUser.id;
      });
    });
  }

  //# Control for duplicate users
  $scope.$watch('vm.newUser.email', function (email) {
    if (email && !!_.find(vm.users, { email: email })) {
      $scope.form.$invalid = true; // disable form submit
      vm.state.duplicateUser = true; // show warning message
    } else {
      vm.state.duplicateUser = false;
    }
  });
}

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsAgencySidebar', {
  templateUrl: '/templates/zenclerk_s/agencies/sidebar.html',
  controllerAs: 'vm',
  controller: zcsAgencySidebar
});

zcsAgencySidebar.$inject = ['$scope', '$state', '$stateParams', 'Agency', 'Devise'];
function zcsAgencySidebar($scope, $state, $stateParams, Agency, Devise) {
  var vm = this;

  vm.agency = {};
  vm.$stateParams = $stateParams;
  vm.isCategory = isCategory;

  function isCategory(category) {
    if (_.get($state, 'current.data.category') === category) {
      return true;
    }
    return false;
  }

  $scope.$watch('vm.$stateParams', function (newval) {
    if (newval) {
      Agency.get('name:' + newval.agencyName).then(function (res) {
        vm.agency = res;
      });
    }
  });
}

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS').directive('zcsShoppingCartAspOnly', zcsShoppingCartAspOnly);

zcsShoppingCartAspOnly.$inject = ['$stateParams', 'Devise', 'ZcsProject'];
function zcsShoppingCartAspOnly($stateParams, Devise, ZcsProject) {
  return {
    restrict: 'A',
    link: function link(scope, elem, attrs) {
      elem.addClass('hidden-shopping-cart-asp');
      var apikey = $stateParams.apikey;

      if (!apikey) {
        return;
      }
      var asps = attrs.zcsShoppingCartAspOnly.split(',');

      return Devise.getCurrentUser().then(function (user) {
        return ZcsProject.get(user.id, apikey);
      }).then(function (project) {
        if (!asps.includes(project.shopping_cart_asp)) {
          return;
        }
        elem.removeClass('hidden-shopping-cart-asp');
      });
    }
  };
}

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS').directive('agencyOnly', agencyOnly);

agencyOnly.$inject = ['Devise'];
function agencyOnly(Devise) {
  var link = function link(scope, elem, attrs) {
    Devise.getCurrentUser().then(function (user) {
      // TODO: fix only show Agency User
      if (!user || !Devise.isMaster()) {
        elem.css({ display: 'none' });
      }
    });
  };

  return {
    restrict: 'A',
    link: link
  };
}

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/component-name */
/* globals d3 */
angular.module('zc.zenclerkS').component('behaviorVisualizer', {
  templateUrl: '/templates/zenclerk_s/directives/behavior_visualizer/behavior_visualizer.html',
  bindings: {
    behaviorData: '<'
  },
  controller: function controller($element, $scope, $state, $window, $interval, $timeout, $sce, $rootScope, Behavior) {
    var vm = this;
    var SINGLE_FRAME_MS = 50;

    var currentData = void 0;
    var showCursor = void 0;

    var cursor = void 0;
    var svgContainer = void 0;
    var viewFrame = void 0;

    vm.Behavior = Behavior;
    vm.Behavior.current.speedFactor = 1;
    vm.scaleFactor = 1;
    vm.time = {};

    vm.setSpeed = setSpeed;
    vm.goToNext = goToNext;
    vm.jumpToPosition = jumpToPosition;
    vm.togglePlay = togglePlay;
    vm.trustCaptureUrl = function (url) {
      return $sce.trustAsResourceUrl(url);
    };

    vm.singleFrameMs = function () {
      return SINGLE_FRAME_MS * vm.Behavior.current.speedFactor;
    };

    vm.normalizeTime = function (time) {
      return (time - vm.time.startPosition) / vm.time.totalTime * 100;
    };

    vm.normalizePosition = function (pos) {
      return pos * vm.scaleFactor;
    };

    vm.getClosest = function () {
      return _.filter(vm.behaviorData.data, function (d) {
        return Math.abs(vm.time.currentPosition - d.time) < vm.singleFrameMs();
      })[0];
    };

    vm.$onInit = function () {
      if (!vm.behaviorData.data.length) {
        return vm.goToNext();
      }

      //let controlsHeight = $element.find('.playback-controls').height();
      var controlsHeight = 63;
      var totalHeight = $element.find('.visualize-view').height();
      $element.find('.visualize-wrapper').height(totalHeight - controlsHeight);
      $element.find('.visualize-view').height();

      $scope.$on('$destroy', function () {
        // Make sure that the interval is destroyed too
        $interval.cancel(vm.interval);
        $timeout.cancel(vm.timeout);
      });

      vm.time.startPosition = _.minBy(vm.behaviorData.data, function (d) {
        return d.time;
      }).time;
      vm.time.endPosition = _.maxBy(vm.behaviorData.data, function (d) {
        return d.time;
      }).time;
      vm.time.totalTime = vm.time.endPosition - vm.time.startPosition;
      vm.time.currentPosition = vm.time.startPosition;

      initializeView();
    };

    function setSpeed(factor) {
      vm.Behavior.current.speedFactor = factor;
    }

    function initializeView() {
      showCursor = vm.behaviorData.device === 'pc';

      svgContainer = d3.select('.visualize-area-behavior').append('svg');

      vm.captureUrl = vm.behaviorData.url;

      viewFrame = svgContainer.selectAll('rect.view-frame').data([vm.behaviorData.data[0]]).enter().append('rect').attr('class', 'view-frame').attr('x', 0).attr('y', 0)
      // TODO: window might not be defined!!!!!!
      .attr('width', function (d) {
        return d.window.Width || 100;
      }).attr('height', function (d) {
        return d.window.Height || 100;
      }).attr('stroke', 'red').attr('fill', 'none').attr('opacity', 0);

      // do not show on
      cursor = svgContainer.append('g').attr('class', 'cursor').attr('transform', 'translate(0, 0)').attr('opacity', '0');

      if (showCursor) {
        cursor.append('image').attr('class', 'cursor-inner').attr('x', 0).attr('y', 0).attr('width', 22).attr('height', 32).attr('xlink:href', '/assets/visualizer/cursor32.png');
      } else {
        cursor.append('circle').attr('class', 'cursor-inner').attr('cx', 0).attr('cy', 0).attr('r', 20).attr('fill', 'rgba(255,255,0,0.5)');
      }

      vm.Behavior.current.event = currentData;

      // delay playing so that iframe loads
      vm.timeout = $timeout(function () {
        vm.Behavior.current.isPlaying = true;
        // hackish - do this because first frame rendering might take some
        // time
        $timeout(function () {
          cursor.attr('opacity', 1);
          viewFrame.attr('opacity', 1);
        }, 700);
        vm.interval = $interval(update, SINGLE_FRAME_MS);
      }, 2000);
    }

    function update() {
      if (!Behavior.current.isPlaying) return;

      vm.time.currentPosition += vm.singleFrameMs();
      if (vm.time.currentPosition > vm.time.endPosition) {
        Behavior.current.isPlaying = false;
        vm.goToNext();
        $interval.cancel(vm.interval);
        return;
      }

      Behavior.current.playTime = vm.time.currentPosition;
      currentData = vm.getClosest();

      if (!currentData) {
        // fade the cursor out unless something changed
        if (!showCursor) {
          cursor.attr('opacity', function () {
            return d3.select(this).attr('opacity') - 0.05;
          });
        }

        // since there was no data for this frame, return
        return;
      }

      // TODO: dry with above
      if (!showCursor) {
        if (currentData.event && currentData.event.mouse) {
          cursor.attr('opacity', 1);
        } else {
          cursor.attr('opacity', function () {
            return d3.select(this).attr('opacity') - 0.05;
          });
        }
      }

      vm.Behavior.current.event = currentData;
      vm.height = vm.behaviorData.data[0].height;
      vm.scrollWidth = _.get(vm, 'behaviorData.data[0].window.Width') || vm.scrollWidth;
      //vm.scrollWidth = vm.behaviorData.data[0].window.Width;

      if (currentData.scroll) {
        vm.mouseX += currentData.scroll.dX;
        vm.mouseY += currentData.scroll.dY;
        vm.scrollX = currentData.scroll.X;
        vm.scrollY = currentData.scroll.Y;
        //$scope.scrollWidth = $scope.currentEvent.scroll.width
        //$scope.scrollHeight = $scope.currentEvent.scroll.height
        vm.scrollWidth = currentData.window.Width;
        vm.scrollHeight = currentData.window.Height;
      }

      if (currentData.gesture) {
        if (currentData.gesture.type === 'pinchout' || currentData.gesture.type === 'pinchin') {
          createPinch();
        } else {
          createOtherGesture();
        }
      }

      if (currentData.event && currentData.event.click) {
        createClick();
      }

      cursor.transition().duration(50).attr('transform', function (d) {
        if (!currentData.mouse) {
          return d3.select(this).attr('transform');
        }

        var x = currentData.mouse.screenX;
        var y = currentData.mouse.screenY;
        return 'translate(' + x + ', ' + y + ')';
      });

      if (currentData.window) {
        var anim = viewFrame.transition().duration(50).attr('width', currentData.window.Width).attr('height', currentData.window.Height);

        if (currentData.scroll) {
          anim.attr('x', currentData.scroll.X).attr('y', currentData.scroll.Y);
        }
      }

      d3.select('.visualize-area').transition().duration(50).tween('scrollTopTween', scrollTopTween(vm.scrollY)).tween('scrollLeftTween', scrollLeftTween(vm.scrollX));
      d3.select('.iframe-wrapper iframe').transition().duration(50).tween('scrollTopTween', scrollTopTween(vm.scrollY)).tween('scrollLeftTween', scrollLeftTween(vm.scrollX));
    }

    function goToNext() {
      // TODO: there is no next in this way in zenclerk_s
      //Behavior.current.isPlaying = false
      //nextSid = Behavior.getNextHistorySid(vm.behaviorData._sid)
      //if nextSid
      //  $scope.timeout = $timeout () ->
      //    $state.go 'viz.site.session.player', {apikey: Behavior.current.apikey, usid: Behavior.current.usid, sid: nextSid}
      //  , 3000
    }

    function jumpToPosition(event) {
      var width = $(event.target).width();
      var offset = event.offsetX;
      var percentage = offset / width;
      vm.time.currentPosition = vm.time.startPosition + (vm.time.endPosition - vm.time.startPosition) * percentage;
    }

    function togglePlay() {
      if (!vm.Behavior.current.isPlaying) {
        $interval.cancel(vm.interval);
        vm.interval = $interval(update, SINGLE_FRAME_MS);
      }

      // TODO: remove all clicks

      vm.Behavior.current.isPlaying = !vm.Behavior.current.isPlaying;
    }

    function createPinch() {
      var position = {};
      var direction = currentData.gesture.type;

      if (direction === 'pinchin') {

        position.sx1 = currentData.gesture.px + currentData.gesture.dx || -99;
        position.sy1 = currentData.gesture.py + currentData.gesture.dy || -99;
        position.sx2 = currentData.gesture.px - currentData.gesture.dx || -99;
        position.sy2 = currentData.gesture.py - currentData.gesture.dy || -99;
        position.ex1 = currentData.gesture.px || -99;
        position.ey1 = currentData.gesture.py || -99;
        position.ex2 = currentData.gesture.px || -99;
        position.ey2 = currentData.gesture.py || -99;
      } else if (direction === 'pinchout') {

        position.sx1 = currentData.gesture.px || -99;
        position.sy1 = currentData.gesture.py || -99;
        position.sx2 = currentData.gesture.px || -99;
        position.sy2 = currentData.gesture.py || -99;
        position.ex1 = currentData.gesture.px + currentData.gesture.dx || -99;
        position.ey1 = currentData.gesture.py + currentData.gesture.dy || -99;
        position.ex2 = currentData.gesture.px - currentData.gesture.dx || -99;
        position.ey2 = currentData.gesture.py - currentData.gesture.dy || -99;
      }

      var pinch1 = svgContainer.insert('circle', '.cursor').attr('class', 'pinch').attr('cx', position.sx1).attr('cy', position.sy1).attr('r', 25).attr('fill', 'blue').attr('opacity', 0.5);

      var pinch2 = svgContainer.insert('circle', '.cursor').attr('class', 'pinch').attr('cx', position.sx2).attr('cy', position.sy2).attr('r', 25).attr('fill', 'blue').attr('opacity', 0.5);

      pinch1.transition().duration(200).attr('cx', position.ex1).attr('cy', position.ey1).transition().duration(500).attr('opacity', 0.3).transition().duration(2000).attr('opacity', 0).transition().remove();

      pinch2.transition().duration(200).attr('cx', position.ex2).attr('cy', position.ey2).transition().duration(500).attr('opacity', 0.3).transition().duration(2000).attr('opacity', 0).transition().remove();
    }

    function createOtherGesture() {
      var position = {};

      if (currentData.gesture) {
        position.sx = currentData.gesture.px - currentData.gesture.dx;
        position.sy = currentData.gesture.px - currentData.gesture.dx;
        position.ex = currentData.gesture.px;
        position.ey = currentData.gesture.py;
      } else {
        console.log('had no gesture');
      }

      svgContainer.insert('circle', '.cursor').attr('class', 'click')
      // TODO there might not be gesture
      .attr('cx', position.sx).attr('cy', position.sy).attr('r', 25).attr('fill', function () {
        switch (currentData.gesture.type) {
          case 'release':
          case 'swiperight':
          case 'swipeleft':
            return 'purple';
          case 'tap':
            return 'lime';
          default:
            return 'red';
        }
      }).attr('opacity', 0.5).transition().duration(200).attr('cx', position.ex).attr('cy', position.ey).transition().duration(500).attr('opacity', 0.3).transition().duration(5000).attr('opacity', 0).transition().remove();
    }

    function createClick() {
      svgContainer.insert('circle', '.cursor').attr('class', 'click')
      // TODO there might not be mouse
      .attr('cx', currentData.mouse.screenX || -99).attr('cy', currentData.mouse.screenY || -99).attr('r', 25).attr('fill', 'steelblue').attr('opacity', 0.7).transition().duration(50).attr('r', 30).transition().delay(100).duration(500).ease('sin').attr('r', 10).attr('opacity', 0.3).transition().duration(2000).attr('opacity', 0).transition().remove();
    }

    // scrollTop and scrollLeft are arbitrary properties so custom
    // interpolator
    // http://stackoverflow.com/a/16353819
    function scrollTopTween(scrollTop) {
      return function () {
        var _this = this;

        var i = d3.interpolateNumber(this.scrollTop, scrollTop);
        return function (t) {
          _this.scrollTop = i(t);
        };
      };
    }

    function scrollLeftTween(scrollLeft) {
      return function () {
        var _this2 = this;

        var i = d3.interpolateNumber(this.scrollLeft, scrollLeft);
        return function (t) {
          _this2.scrollLeft = i(t);
        };
      };
    }
  }
});

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS').component('campaignActionMenu', {
  bindings: {
    project: '<',
    campaign: '<'
  },
  controller: campaignActionMenuController,
  templateUrl: '/templates/zenclerk_s/directives/campaign/action_menu/campaign_action_menu.html'
});

campaignActionMenuController.$inject = ['$state', '$filter', '$translate', '$uibModal', 'Campaign', 'Devise', 'campaignStatuses', 'ZcsCampaign'];
function campaignActionMenuController($state, $filter, $translate, $uibModal, Campaign, Devise, campaignStatuses, ZcsCampaign) {
  var vm = this;
  var state = void 0;

  vm.$onInit = function () {
    setConfirmToggleCampaignState();
    if (vm.campaign.incentives[0] && vm.campaign.incentives[0].is_integrated_with_makeshop) {
      vm.confirmRemoveCampaign = $translate.instant('directives.campaign.actionMenu.confirmRemoveCampaignMessage');
    }

    vm.isMenuActive = false;
    vm.isAllowedLiteTemplate = isAllowedLiteTemplate;
    vm.openMailMagUrlModal = openMailMagUrlModal;
    vm.openPreviewLinkModal = openPreviewLinkModal;
    vm.copyCampaign = copyCampaign;
    vm.toggleCampaignState = toggleCampaignState;
    vm.removeCampaign = removeCampaign;
    vm.canShowReportButton = canShowReportButton;
    vm.isActiveProject = vm.project.terminated_at === null || moment(vm.project.terminated_at) > new Date();
    vm.isOemProject = vm.project.is_oem;
    vm.isMaster = Devise.isMaster();
  };

  // mail mag url modal
  function openMailMagUrlModal() {
    ZcsCampaign.openMailMagUrlModal(vm.campaign, vm.project);
    vm.isMenuActive = false;
  }

  // preview link modal
  function openPreviewLinkModal() {
    $uibModal.open({
      templateUrl: '/templates/zenclerk_s/sites/campaigns/preview_link_modal.html',
      openedClass: 'preview-link-modal',
      size: 'lg',
      controllerAs: '$ctrl',
      controller: 'ZcsPreviewLinkModalController',
      resolve: {
        campaign: vm.campaign,
        project: vm.project
      }
    });
    vm.isMenuActive = false;
  }

  // duplicate campaign
  function copyCampaign(campaign) {
    var campaignObject = _.merge({}, campaign);

    return Campaign.copy({ projectId: vm.project.id, campaignId: campaignObject.id }, campaignObject).then(function (res) {
      return $state.go('zenclerkS.project.campaigns.draft', { apikey: vm.project.apikey }, { reload: true });
    });
  }

  // toggle campaign state
  function toggleCampaignState() {
    vm.isMenuActive = false;
    if (vm.campaign.status === 'activated') {
      state = 'blocked';
    }
    if (vm.campaign.status === 'blocked') {
      state = 'activated';
    }
    return Campaign.toggleActive({
      projectId: vm.campaign.project_id,
      campaignId: vm.campaign.id,
      state: state === 'activated'
    }).then(function (res) {
      if (res.data.success) {
        vm.campaign.status = state;
        var currentStatus = $filter('currentStatus')(vm.campaign);
        vm.campaign.current_status = currentStatus;
        vm.currentStatusText = campaignStatuses[vm.campaign.current_status].text;
        setConfirmToggleCampaignState();
        return true;
      }
    });
  }

  // delete campaign
  function removeCampaign(campaign) {
    var campaignObject = _.merge({}, campaign);
    if (campaignObject.status === 'incomplete') {
      // If it has not ran yet, destroy (note that we also exclude preview because
      // it has been in publish.js and there can be data with that campaign id)
      return Campaign.destroy({ projectId: vm.project.id, campaignId: campaignObject.id }).then(function (res) {
        return $state.go('zenclerkS.project.campaigns.draft', { apikey: vm.project.apikey }, { reload: true });
      });
    }

    // Otherwise, make it terminated
    // Note, we need to use "terminate" because just updating status
    // would not set end_at to the moment it was terminated!
    return Campaign.terminate({ projectId: vm.project.id, campaignId: campaignObject.id }, campaignObject).then(function (res) {
      campaign.status = 'terminated';
      $state.go('zenclerkS.project.campaigns.active', { apikey: vm.project.apikey }, { reload: true });
    });
  }

  function isAllowedLiteTemplate() {
    return ZcsCampaign.isAllowedLiteTemplate(vm.campaign, vm.project);
  }

  function canShowReportButton() {
    if ($state.current.name === 'zenclerkS.project.campaign.summary') {
      return false;
    }

    if (moment(vm.campaign.start_at).isAfter(moment())) {
      return false;
    }

    if (moment(vm.campaign.end_at).isSameOrBefore(moment(ZcsCampaign.FIST_DATA_DAY))) {
      return false;
    }

    if (vm.campaign.current_status === 'incomplete') {
      return false;
    }

    return true;
  }

  function setConfirmToggleCampaignState() {
    if (vm.campaign.incentives[0] && vm.campaign.incentives[0].is_integrated_with_makeshop) {
      if (vm.campaign.current_status === 'blocked') {
        vm.confirmToggleCampaignState = $translate.instant('directives.campaign.actionMenu.confirmToggleCampaignStateBlocked');
      } else if (vm.campaign.current_status === 'active') {
        vm.confirmToggleCampaignState = $translate.instant('directives.campaign.actionMenu.confirmToggleCampaignStateActive');
      }
    }
  }
}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsCampaignListConversions', {
  bindings: {
    campaign: '<',
    project: '<',
    startAt: '<',
    endAt: '<'
  },
  templateUrl: '/templates/zenclerk_s/directives/campaign/list/conversions.html',
  controller: zcsCampaignListConversionsController
});

zcsCampaignListConversionsController.$inject = ['$q', '$translate', 'MongoCampaign', 'MongoConversion', 'ZcsDeviceName', 'currencies'];
function zcsCampaignListConversionsController($q, $translate, MongoCampaign, MongoConversion, ZcsDeviceName, currencies) {
  var vm = this;
  var CSV_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
  var pagination = {
    itemsPerPage: 10,
    currentPage: 1,
    maxSize: 8
  };

  vm.$onInit = function () {
    vm.currency = currencies[vm.project.currency];
    vm.conversions = [];
    vm.conversionCountPerDevice = {};
    vm.sortCurrent = 'created_at';
    vm.sortReverse = true;
    vm.headers = [{ title: $translate.instant('directives.campaign.list.cvDate'), field: 'created_at', displayTitle: true }, { title: $translate.instant('directives.campaign.list.id'), field: 'id', displayTitle: true }, { title: $translate.instant('directives.common.device'), field: 'device', displayTitle: true }, { title: $translate.instant('directives.campaign.list.purchasePrice'), field: 'price', displayTitle: true }];
    // Header columns for:
    // - Conversion table
    // - CSV Export
    // If the displayTitle parameter is  false, the header will not be shown on the conversion table.
    vm.headerRow = _.map(vm.headers, 'title');
    vm.fields = _.map(vm.headers, 'field');
    vm.getCSV = getCSV;

    vm.pagination = pagination;
    vm.pageChanged = pageChanged;
    vm.sortBy = sortBy;
    vm.isOnlyOneDay = isOnlyOneDay;
    vm.getDevicePercentage = getDevicePercentage;
    vm.getDeviceName = ZcsDeviceName.getDeviceName;

    vm.limitedTo = pagination.itemsPerPage;
    vm.limitFilter = pagination.itemsPerPage;
    vm.chartData = {};
  };

  vm.$onChanges = function () {
    if (!vm.campaign || !vm.startAt || !vm.endAt || !vm.project) {
      return;
    }

    // avoid multiple onChanges calls
    if (vm.gettingConversions) return;
    vm.gettingConversions = true;

    var promise = void 0;
    if (vm.project.invoice_calculation_type === 'normal') {
      promise = getCouponCodeConversions();
    } else if (vm.project.invoice_calculation_type === 'deemed') {
      promise = getCampaignConversions();
    } else {
      throw new Error('invalid invoice calculation type');
    }

    promise.finally(function () {
      vm.gettingConversions = false;
    });
  };

  function getCampaignConversions() {
    var campaignsParams = {
      apikey: vm.project.apikey,
      campaign_id: vm.campaign.id,
      created_at: {
        $gte: vm.startAt,
        $lt: vm.endAt
      },
      is_control: false,
      is_exclude: false
    };

    return MongoCampaign.find(campaignsParams, {
      sort: { created_at: -1 },
      fields: ['_usid', 'created_at'],
      limit: 20000
    }).then(function (sentCampaigns) {
      var usids = _.map(sentCampaigns, function (d) {
        return d._usid;
      });
      // too long requests fail on facade so split into smaller ones
      var chunks = _.chunk(usids, 50);

      var promises = _.map(chunks, function (chunk) {
        var conversionsParams = {
          apikey: vm.project.apikey,
          created_at: {
            $gte: vm.startAt,
            $lt: vm.endAt
          },
          is_exclude: false,
          _usid: { $in: chunk }
        };

        return MongoConversion.find(conversionsParams, {
          sort: { created_at: -1 },
          fields: vm.fields
        });
      });

      return $q.all(promises).then(function (conversionResults) {
        var conversions = _.flatten(conversionResults);
        vm.conversions = _.uniqBy(_.sortBy(conversions, function (d) {
          return -d.created_at;
        }), function (d) {
          return d.id;
        });
        vm.averageConversionPrice = _.sumBy(vm.conversions, function (d) {
          return d.price;
        }) / vm.conversions.length;
        vm.conversionCountPerDevice = _.countBy(vm.conversions, function (d) {
          return d.device;
        });
        vm.pagedConversions = vm.conversions;
        vm.chartData.devices = getDevicesChartData(vm.conversionCountPerDevice);
      });
    });
  }

  function getCouponCodeConversions() {
    return MongoConversion.find({
      apikey: vm.project.apikey,
      created_at: {
        $gte: vm.startAt,
        $lt: vm.endAt
      },
      is_exclude: false,
      coupon_code: vm.campaign.incentives[0].coupon_code
    }, {
      sort: { created_at: -1 },
      fields: vm.fields
    }).then(function (conversions) {
      vm.conversions = _.uniqBy(_.sortBy(conversions, function (d) {
        return -d.created_at;
      }), function (d) {
        return d.id;
      });
      vm.averageConversionPrice = _.sumBy(vm.conversions, function (d) {
        return d.price;
      }) / vm.conversions.length;
      vm.getDevicePercentage = getDevicePercentage;
      vm.conversionCountPerDevice = _.countBy(vm.conversions, function (d) {
        return d.device;
      });
      vm.pagedConversions = vm.conversions;
      vm.chartData.devices = getDevicesChartData(vm.conversionCountPerDevice);
    });
  }

  function pageChanged() {
    var begin = vm.pagination.itemsPerPage * (vm.pagination.currentPage - 1);
    var end = begin + vm.pagination.itemsPerPage;
    var sortedConversions = _.orderBy(vm.conversions, [vm.sortCurrent], [vm.sortReverse ? 'desc' : 'asc']);
    vm.pagedConversions = sortedConversions.slice(begin, end);
  }

  function sortBy(field) {
    vm.sortCurrent = field;
    vm.sortReverse = !vm.sortReverse;
    vm.pageChanged();
  }

  function getDevicePercentage(deviceConversionCount) {
    var totalConversions = _.sum(vm.conversionCountPerDevice);
    return deviceConversionCount / totalConversions * 100;
  }

  function getDevicesChartData(devices) {
    var deviceSegment = [];
    _.each(devices, function (i, d) {
      deviceSegment.push({
        label: vm.getDeviceName(d),
        value: getDevicePercentage(i)
      });
    });
    return deviceSegment;
  }

  function isOnlyOneDay() {
    if (moment(vm.startAt).isSame(vm.endAt, 'd')) {
      return true;
    }
    return false;
  }

  function getCSV() {
    var rows = _.map(vm.conversions, function (cv) {
      return _.pick(cv, vm.fields);
    });

    // sort before formatting date because
    // otherwise sorting by date wouldnt work properly...
    rows = _.orderBy(rows, [vm.sortCurrent], [vm.sortReverse ? 'desc' : 'asc']);

    _.each(rows, function (cv) {
      cv.price = cv.price / Math.pow(10, vm.currency.fractionSize);
      cv.device = vm.getDeviceName(cv.device);
      cv.created_at = moment(new Date(cv.created_at)).format(CSV_DATE_FORMAT);
    });

    return rows;
  }
}

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

angular.module('zc.zenclerkS').component('zcsCampaignTemplateDynamicView', {
  bindings: {
    project: '<',
    campaign: '<',
    onlyViews: '<'
  },
  templateUrl: '/templates/zenclerk_s/directives/campaign/template_editor/campaign_template_dynamic_view.html',
  controller: zcsCampaignTemplateDynamicViewController
});

zcsCampaignTemplateDynamicViewController.$inject = ['$q', '$sce', '$scope', '$timeout', '$translate', 'CampaignTemplate', 'Template'];
function zcsCampaignTemplateDynamicViewController($q, $sce, $scope, $timeout, $translate, CampaignTemplate, Template) {
  var vm = this;

  vm.$onInit = function () {
    vm.viewShow = false;

    vm.offerView = $translate.instant('directives.campaign.templateEditor.dynamicView.offerView');
    vm.isOfferViewInstructionVisible = false;
    vm.offerViewInstruction = '\n      <div class="text-justify">\n        ' + $translate.instant('directives.campaign.templateEditor.dynamicView.offerViewInstruction', { discount: '◯◯円OFF' }) + '\n      </div>\n    ';

    vm.presentView = $translate.instant('directives.campaign.templateEditor.dynamicView.presentView');
    vm.isPresentViewInstructionVisible = false;
    vm.presentViewInstruction = '\n      <div class="text-justify">\n        ' + $translate.instant('directives.campaign.templateEditor.dynamicView.presentViewInstruction') + '\n      </div>\n    ';

    Template.all(vm.project.id).then(function (res) {
      vm.baseTemplates = res;

      // set initial template
      if (vm.campaign.template_type && !vm.campaign.template) {
        vm.campaign.template = _.find(vm.baseTemplates, function (d) {
          return d.name === vm.campaign.template_type;
        });
      }

      $scope.$watch('$ctrl.campaign.template', updateTemplate, true);
      $scope.$watch('$ctrl.campaign.element', updateView, true);
    });
  };

  function updateView() {
    if (!vm.campaign.template_type) {
      return;
    }
    var params = {
      project_id: vm.project.id,
      campaign_id: vm.campaign.id,
      template_type: vm.campaign.template_type,
      campaign_type: vm.campaign.campaign_type,
      message: vm.campaign.element.message,
      element: vm.campaign.element
    };

    return CampaignTemplate.views(angular.extend(params)).then(function (views) {
      // Choose the view always in lite
      var view = $('<div>').append(_.find(views, function (d) {
        return d.file === 'index';
      }).view);
      if (vm.campaign.coupon_code) {
        view.find('.zc_code_insert_code').text(vm.campaign.coupon_code);
      } else if (vm.campaign.incentives[0] != null ? vm.campaign.incentives[0].coupon_code : undefined) {
        view.find('.zc_code_insert_code').text(vm.campaign.incentives[0].coupon_code);
      } else if (vm.campaign.incentive_draft.coupon_code) {
        view.find('.zc_code_insert_code').text(vm.campaign.incentive_draft.coupon_code);
      } else {
        view.find('.zc_code_insert_code').text('COUPONCODE');
      }
      vm.view = $sce.trustAsHtml(view.html()); // currently there is only one view
      vm.hasHtmlError = false;
    }).catch(function (err) {
      vm.hasHtmlError = true;
    }).finally(function () {

      var cssPromises = [CampaignTemplate.confirmJs(params), CampaignTemplate.css(angular.extend(params)), CampaignTemplate.confirmCss(params)];

      return $q.all(cssPromises).then(function () {
        // add random number that ensures that js content has changed and re-executed
        var _Array$from = Array.from(arguments.length <= 0 ? undefined : arguments[0]),
            _Array$from2 = _toArray(_Array$from),
            js = _Array$from2[0],
            css = _Array$from2.slice(1);

        vm.js = $sce.trustAsHtml('<script data-random="' + Math.random() + '">' + js + '</script>');
        vm.css = css.join('\n');
        vm.hasCssError = false;
      }

      //setTemplat eValid true
      // This is to set a dynamic height on coupon view
      // $timeout () ->
      //   for view in vm.views
      //     view.height = angular.element(document.querySelector(".#{view.class}"))[0].offsetHeight
      //     console.log view.height
      ).catch(function (err) {
        vm.hasCssError = true;
      });
    });
  }
  //setTemplateValid false

  function updateTemplate(newval, oldval) {
    vm.viewShow = false;
    $timeout(function () {
      vm.viewShow = true;
    }, 500); // add timeout to avoid template flickering while appending the html/css code

    if (newval) {
      var baseTemplate = _.find(vm.baseTemplates, {
        name: vm.campaign.template_type
      });

      vm.campaign.template = baseTemplate;

      if (!vm.onlyViews) {
        vm.views = vm.campaign.template.views;
      } else {
        vm.views = _.map(vm.onlyViews, function (d) {
          return vm.campaign.template.views[d];
        });
      }
      return updateView();
    }
  }
}

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsCampaignTemplateEditor', {
  bindings: {
    project: '=',
    campaign: '=',
    isInterestWidgetSettingsPage: '='
  },
  templateUrl: '/templates/zenclerk_s/directives/campaign/template_editor/campaign_template_editor.html',
  controller: zcsCampaignTemplateEditor
});

zcsCampaignTemplateEditor.$inject = ['$scope', '$translate', 'Campaign', 'Template'];
function zcsCampaignTemplateEditor($scope, $translate, Campaign, Template) {
  var vm = this;
  vm.lang = $translate.use();

  var COMMON_SETTINGS = {
    giftcard: ['coupon_pattern', 'base_color', 'limit', 'giftcard_offer_message', 'giftcard_free_shipping', 'giftcard_code_message', 'countdown_message', 'code_condition', 'giftcard_button', 'giftcard_present_message', 'code_name', 'giftcard_guide', 'code_description', 'notice', 'badge_position'],
    giftcard_jp: ['coupon_pattern', 'base_color', 'limit', 'giftcard_free_shipping', 'code_condition', 'code_description', 'badge_position'],
    zcs_textonly: ['base_color', 'second_color', 'limit', 'zc_header', 'zc_insentive_usage_requirement', 'btntext_offer', 'code_title', 'code_name', 'code_condition', 'code_description', 'btntext_present', 'badge_position', 'offer_hint', 'notice'],
    zcs_textonly_jp: ['base_color', 'second_color', 'limit', 'zc_insentive_usage_requirement', 'code_condition', 'code_description', 'badge_position'],
    zcs_image: ['banner', 'base_color', 'second_color', 'limit', 'btntext_offer', 'code_title', 'code_name', 'code_condition', 'code_description', 'btntext_present', 'badge_position', 'offer_hint'],
    zcs_image_jp: ['banner', 'base_color', 'second_color', 'limit', 'code_condition', 'code_description', 'badge_position']
  };

  var IW_SETTINGS = ['primary_color', 'badge_icon_color', 'secondary_color', 'widget_position', 'widget_color_launcher', 'widget_color_primary', 'widget_color_secondary', 'iw_item_name_text', 'iw_coupon_name_text'];

  var getAllowedSettings = function getAllowedSettings() {
    var templateName = vm.project.sales_entity === 'appier_jp' ? vm.campaign.template_type + '_jp' : vm.campaign.template_type;
    var allowedSettings = vm.isInterestWidgetSettingsPage ? IW_SETTINGS : COMMON_SETTINGS[templateName];

    return vm.project.site_logo_image_id
    // do not show header if there is logo
    ? _.reject(allowedSettings, function (i) {
      return i === 'zc_header';
    }) : allowedSettings;
  };

  vm.$onInit = function () {
    vm.templateItems = {};
    vm.hasSetting = hasSetting;
    vm.allowedSettings = getAllowedSettings();

    // update the textonly template text when limit changes
    $scope.$watch('$ctrl.campaign.element.message.limit', function (newval) {
      if (_.get(vm.campaign, 'template_type') === 'zcs_textonly') {
        var int = parseInt(newval);
        var timeLimitText = void 0;
        if (int <= 61) {
          timeLimitText = $translate.instant('directives.common.minute', { minute: int - 1 });
        } else {
          timeLimitText = $translate.instant('directives.common.hour', { hour: (int - 1) / 60 });
        }
        vm.campaign.element.message.zc_insentive_requirement = $translate.instant('directives.campaign.templateEditor.editor.timeLimit', { limit: timeLimitText });
      }
    });

    $scope.$watch('$ctrl.campaign.element.message.offer_hint', function (newval) {
      if (vm.campaign.template_type === 'zcs_image') {
        vm.campaign.element.message.present_hint = newval;
      }
    });

    $scope.$watch('$ctrl.campaign.template', function (newval) {
      if (_.get(vm.campaign, 'template_type') === 'zcs_image' && !vm.campaign.element.message.banner) {
        vm.campaign.element.message.banner = ZC_CONFIG.RAILS_API_URL + ':' + ZC_CONFIG.RAILS_API_PORT + '/assets/campaigns/coupon/default/sample_280x280.' + vm.lang + '.png';
      }

      if (newval) {
        vm.allowedSettings = getAllowedSettings();

        // make template items into key/value instead of array,
        // for easier view side accessibility
        vm.templateItems = {};
        _.each(newval.template, function (d) {
          vm.templateItems[d.name] = d;

          // To solve a problem caused by 1-click buy feature in shopify projects:
          // https://github.com/zenclerk/zenclerk/issues/9832
          if (d.name === 'code_condition' && vm.project.integrated_with === 'shopify') {
            vm.templateItems[d.name].description = $translate.instant('directives.campaign.templateEditor.editor.shopifyCodeCondition');
          }

          if (d.name === 'offer_hint') {
            vm.templateItems[d.name].label = $translate.instant('sharedModules.campaignsTemplate.offerHint.label_short');
          }
        });

        if (vm.campaign.element.message.discount_type !== 'free_shipping') {
          delete vm.templateItems.giftcard_free_shipping;
        }
      }
    });

    $scope.$watch('$ctrl.campaign.element', function (newval) {
      if (newval) {
        // giftcard pattern handler
        if (_.get(vm.campaign, 'element.message.coupon_pattern', '').indexOf('http') === 0) {
          vm.campaign.userPattern = true;
        }
      }
    });
  };

  function hasSetting(name) {
    if (!vm.campaign || !vm.campaign.template) {
      return false;
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = Array.from(vm.campaign.template.template)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var item = _step.value;

        if (item.name === name) {
          return true;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return false;
  }
}

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS').directive('zcsCampaignTemplateItem', zcsCampaignTemplateItem).controller('zcsCampaignTemplateItemController', zcsCampaignTemplateItemController);

zcsCampaignTemplateItem.$inject = ['Meta'];
function zcsCampaignTemplateItem(Meta) {
  return {
    restrict: 'E',
    scope: {
      campaign: '=',
      item: '='
    },
    templateUrl: '/templates/zenclerk_s/directives/campaign/template_editor/campaign_template_item.html',
    link: function link(scope) {
      Meta.getServices().then(function (services) {
        scope.adminApp = services.server;
      });

      // giftcard pattern handler
      scope.setPattern = function (pattern) {
        scope.campaign.userPattern = false;
        scope.campaign.element.message.show_incentive_text = true;
        scope.campaign.element.message.coupon_pattern = pattern;
      };
    },

    controllerAs: 'vm',
    controller: 'zcsCampaignTemplateItemController'
  };
}

zcsCampaignTemplateItemController.$inject = ['$translate'];
function zcsCampaignTemplateItemController($translate) {
  var vm = this;

  vm.$onInit = function () {
    vm.viewShow = false;

    vm.isUploadV5InstructionVisible = false;
    vm.uploadV5Instruction = '\n      <div class="row">\n        <div class="col-sm-4"><strong>' + $translate.instant('directives.campaign.templateEditor.instructions.upload.imageSize') + '</strong></div>\n        <div class="col-sm-8">' + $translate.instant('directives.campaign.templateEditor.instructions.upload.imageSizeDetails', { horizontal: '560px', vertical: '560px' }) + '</div>\n      </div>\n      <div class="row">\n        <div class="col-sm-4"><strong>' + $translate.instant('directives.campaign.templateEditor.instructions.upload.imageFormat') + '</strong></div>\n        <div class="col-sm-8">' + $translate.instant('directives.campaign.templateEditor.instructions.upload.imageFormatDetails') + '</div>\n      </div>\n      <div class="row">\n        <div class="col-sm-4"><strong>' + $translate.instant('directives.campaign.templateEditor.instructions.upload.capacity') + '</strong></div>\n        <div class="col-sm-8">png, jpg</div>\n      </div>\n      <p>' + $translate.instant('directives.campaign.templateEditor.instructions.upload.displayDetails') + '</p>\n      <img src="/assets/img/editor/coupon-image-example1.png" />\n      <img src="/assets/img/editor/coupon-image-example2.png" />\n    ';

    vm.isUploadGiftcardInstructionVisible = false;
    vm.uploadGiftCardInstruction = '\n      <div class="row">\n        <div class="col-sm-4"><strong>' + $translate.instant('directives.campaign.templateEditor.instructions.upload.imageSize') + '</strong></div>\n        <div class="col-sm-8">' + $translate.instant('directives.campaign.templateEditor.instructions.upload.imageSizeDetails', { horizontal: '600px', vertical: '330px' }) + '</div>\n      </div>\n      <div class="row">\n        <div class="col-sm-4"><strong>' + $translate.instant('directives.campaign.templateEditor.instructions.upload.imageFormat') + '</strong></div>\n        <div class="col-sm-8">' + $translate.instant('directives.campaign.templateEditor.instructions.upload.imageFormatDetails') + '</div>\n      </div>\n      <div class="row">\n        <div class="col-sm-4"><strong>' + $translate.instant('directives.campaign.templateEditor.instructions.upload.capacity') + '</strong></div>\n        <div class="col-sm-8">png, jpg</div>\n      </div>\n      <p>' + $translate.instant('directives.campaign.templateEditor.instructions.upload.displayDetails') + '</p>\n    ';
  };
}

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsNewImageController', ZcsNewImageController);

ZcsNewImageController.$inject = ['$scope', '$stateParams', 'Devise', 'ZcsImage', 'ZcsProject'];
function ZcsNewImageController($scope, $stateParams, Devise, ZcsImage, ZcsProject) {
  Devise.getCurrentUser().then(function (currentUser) {
    return ZcsProject.get(currentUser.id, $stateParams.apikey);
  }).then(function (project) {
    return $scope.$on('flow::fileAdded', function (event, $flow, flowFile) {
      event.preventDefault();
      return ZcsImage.create({
        projectId: project.id
      }, {
        image: flowFile.file
      }).then(function (res) {
        $scope.campaign.userPattern = true;
        $scope.campaign.element.message[$scope.itemName] = _.get(res, 'data.image.image_url');
      }).catch(function (err) {
        return console.error(err);
      });
    });
  });
}

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS').component('campaignViewCard', {
  bindings: {
    project: '<',
    campaign: '<'
  },
  controller: campaignViewCardController,
  templateUrl: '/templates/zenclerk_s/directives/campaign/view_card/campaign_view_card.html'
});

campaignViewCardController.$inject = ['$uibModal', 'ZcsCampaign', 'ZcsSegment'];
function campaignViewCardController($uibModal, ZcsCampaign, ZcsSegment) {
  var vm = this;
  vm.$onInit = function () {
    vm.coupon = {};
    vm.openMailMagUrlModal = openMailMagUrlModal;
    vm.getSegmentLabel = ZcsSegment.getSegmentLabel;
    vm.campaignProgress = ZcsCampaign.getCampaignProgress(vm.campaign);
    vm.isCampaignEndingSoon = ZcsCampaign.isCampaignEndingSoon;
    getCouponStyle();
  };

  // get coupon design
  function getCouponStyle() {
    var imageUrl = void 0,
        backgroundColor = void 0;

    backgroundColor = vm.campaign.element.message.second_color;
    if (vm.campaign.template_type === 'zcs_image') {
      imageUrl = vm.campaign.element.message.banner;
    } else if (vm.campaign.template_type === 'giftcard') {
      if (vm.campaign.element.message.coupon_pattern.startsWith('http:') || vm.campaign.element.message.coupon_pattern.startsWith('https:')) {
        imageUrl = vm.campaign.element.message.coupon_pattern;
      } else {
        var patternPath = '/assets/campaigns/coupon/giftcard/pattern_' + vm.campaign.element.message.coupon_pattern + '.jpg';
        imageUrl = ZC_CONFIG.RAILS_API_URL + ':' + ZC_CONFIG.RAILS_API_PORT + patternPath;
      }
      backgroundColor = vm.campaign.element.message.base_color;
    }

    vm.coupon.style = {
      'background-color': backgroundColor,
      'background-image': 'url("' + imageUrl + '")'
    };
  }

  // mail mag url modal
  function openMailMagUrlModal($event) {
    $event.stopPropagation();
    ZcsCampaign.openMailMagUrlModal(vm.campaign, vm.project);
    vm.isMenuActive = false;
  }
}

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS').component('changingNumber', {
  template: '<span>{{$ctrl.currentNumber}}</span>',
  bindings: {
    number: '<'
  },
  controller: function controller($interval, $scope) {
    var _this = this;

    this.currentNumber = 0;

    var interval = $interval(function () {
      // Why 7 or 23? They is not so common multipliers in head so it looks
      // more random than say 5 or 10
      if (_this.currentNumber - 100 > _this.number) {
        _this.currentNumber = _this.currentNumber - 23;
      } else if (_this.currentNumber - 25 > _this.number) {
        _this.currentNumber = _this.currentNumber - 7;
      } else if (_this.currentNumber > _this.number) {
        _this.currentNumber--;
      } else if (_this.currentNumber + 100 < _this.number) {
        _this.currentNumber = _this.currentNumber + 23;
      } else if (_this.currentNumber + 25 < _this.number) {
        _this.currentNumber = _this.currentNumber + 7;
      } else if (_this.currentNumber < _this.number) {
        _this.currentNumber++;
      }
    }, 30);

    $scope.$on('$destroy', function () {
      $interval.cancel(interval);
    });
  }
});

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS').component('zcsChartArea', {
  template: '',
  bindings: {
    chartData: '<'
  },
  controller: zcsChartAreaController
});

zcsChartAreaController.$inject = ['$element', '$translate'];
function zcsChartAreaController($element, $translate) {
  var vm = this;

  vm.$onChanges = function () {
    // Create a container for the chart
    $element.html('');
    var svgContainer = d3.select($element[0]).append('svg');

    // Draw a line chart
    nv.addGraph(function () {
      var chart = nv.models.stackedAreaChart().margin({ top: 8, right: 8, bottom: 8, left: 8 }) // fix chart position
      .interpolate('cardinal') // rounded line
      // .showXAxis(false)
      .showLegend(false).showYAxis(false).showControls(false).duration(500).color([angular.element('zcs-chart-area').css('color')]).x(function (d) {
        return moment(d.x).valueOf();
      });

      chart.xAxis.tickFormat(function (x) {
        return d3.time.format($translate.instant('sharedModules.dateTimeFormats.yearMonthDay'))(moment(x).toDate());
      });

      svgContainer.datum(vm.chartData).transition().duration(500).call(chart);

      nv.utils.windowResize(chart.update);

      return chart;
    });
  };
}

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsChartPie', {
  bindings: {
    chartData: '<',
    chartOptions: '<',
    redrawPieChart: '=?'
  },
  controller: zcsChartPieController
});

zcsChartPieController.$inject = ['$element'];
function zcsChartPieController($element) {
  var vm = this;
  var container = angular.element('zcs-chart-pie');
  var svgContainer = d3.select($element[0]).append('svg');
  var chart = nv.models.pieChart();
  var colors = getChartColors();
  var isDrawn = false;

  vm.$onChanges = function (changes) {
    // do not react to dimension changes
    if (vm.redrawPieChart || !isDrawn && changes.chartData) {
      drawChart();
    }
  };

  function getChartColors() {
    var chartClassNames = ['chart-primary', 'chart-secondary', 'chart-tertiary'];
    return _.map(chartClassNames, function (className) {
      container.append('<div class="' + className + '">');
      return angular.element('.' + className).css('color');
    });
  }

  // Draw a pie chart
  function drawChart() {
    nv.addGraph(function () {
      chart.showLabels(false).showLegend(false).color(colors).x(function (d) {
        return d.label;
      }).y(function (d) {
        return d.value;
      });

      // Apply user given chart option if they exist.
      // For example, option like this:
      // {
      //   "margin": {
      //     "top": 30,
      //     "left": 0,
      //     "right": 0
      //   }
      // }
      //
      // Would be applied like this:
      // chart.margin({
      //     "top": 30,
      //     "left": 0,
      //     "right": 0
      //   })
      _.each(_.keys(vm.chartOptions), function (option) {
        if (_.isFunction(chart[option])) {
          var optionValue = _.get(vm.chartOptions, option);
          chart[option](optionValue);
        }
      });

      svgContainer.datum(vm.chartData).transition().duration(350).call(chart);

      nv.utils.windowResize(chart.update);
      return chart;
    });
    isDrawn = true;
    vm.redrawPieChart = false;
  }
}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsChartSingleBar', {
  bindings: {
    chartData: '<',
    chartLegend: '<'
  },
  controller: zcsChartSingleBarController
});

zcsChartSingleBarController.$inject = ['$element', '$translate'];
function zcsChartSingleBarController($element, $translate) {
  var vm = this;
  var svgContainer = d3.select($element[0]).append('svg');
  var xAxisLength = void 0;
  var xAxisCounter = void 0;
  var chart = nv.models.discreteBarChart();

  vm.$onChanges = function (changes) {
    xAxisLength = vm.chartData[0].values.length;
    // do not react to dimension changes
    if (changes.chartData) {
      drawChart();
    }
  };

  // Draw a pie chart
  function drawChart() {
    xAxisCounter = 0;
    return nv.addGraph(function () {
      chart.duration(500).color([angular.element($element[0]).css('color')]).x(function (d) {
        return moment(d.x, 'YYYY-MM-DD').valueOf();
      }).y(function (d) {
        return d.y;
      });

      if (vm.chartLegend || angular.isUndefined(vm.chartLegend)) {
        chart.margin({ right: 0, bottom: 30 }).xAxis.tickPadding(10);
      } else {
        chart.margin({ top: 0, right: 0, bottom: 0, left: 0 }).showXAxis(false).showLegend(false).showYAxis(false);
      }

      chart.xAxis.tickFormat(function (d) {
        return getDate(d);
      });
      chart.yAxis.tickFormat(d3.format(',.0d'));

      svgContainer.datum(vm.chartData).transition().duration(500).call(chart);
      nv.utils.windowResize(chart.update);
      return chart;
    });
  }

  function getDate(timestamp) {
    xAxisCounter = xAxisCounter + 1;
    // reduce xAxis legends when there is too many data
    if (xAxisLength > 11 && xAxisCounter % 4 !== 0 && (vm.chartLegend || angular.isUndefined(vm.chartLegend))) {
      return '';
    }
    return d3.time.format($translate.instant('sharedModules.dateTimeFormats.chart.monthDay'))(new Date(timestamp));
  }
}

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS').directive('zcsChartSingleLine', zcsChartSingleLine);

zcsChartSingleLine.$inject = ['$translate', 'currencies'];
function zcsChartSingleLine($translate, currencies) {
  return {
    scope: {
      chartData: '=',
      domainValues: '=',
      project: '='
    },
    link: function link(scope, elem, attrs) {
      // Show currency symbol or suffix on chart
      var currency = currencies[scope.project.currency];

      // Create a container for the chart
      var svgContainer = d3.select(elem[0]).append('svg');
      var X_AXIS_FORMAT = d3.time.format($translate.instant('sharedModules.dateTimeFormats.chart.monthDay'));
      var Y_AXIS_FORMAT = d3.format(',.0f');
      var HEIGHT = 300;

      // Draw a line chart
      return nv.addGraph(function () {
        var chart = nv.models.lineChart().useInteractiveGuideline(true).margin({
          right: 23,
          left: 23
        }).height(HEIGHT).showXAxis(true).showYAxis(true).showLegend(false).duration(1000).x(function (d) {
          return moment(d.x).valueOf();
        }).xScale(d3.time.scale()).xDomain(scope.domainValues.x).yDomain(scope.domainValues.y);

        var yValuesOver10k = _.chain(scope.chartData[0].values).sortBy(function (d) {
          return d.y;
        }).pickBy(function (d) {
          return d.y > 10000;
        }).map(function (d) {
          return d.y;
        }).value();

        chart.yAxis.ticks(4).tickFormat(function (d) {
          if (yValuesOver10k.length > 1 && scope.project.currency === 'jpy') {
            return Y_AXIS_FORMAT(d / 10000) + '万円'; // only use this short version for Japanese yen
          }
          return currency.symbol + Y_AXIS_FORMAT(d) + currency.suffix;
        });

        chart.xAxis.ticks(6).tickFormat(function (d) {
          return X_AXIS_FORMAT(new Date(d));
        });

        svgContainer.datum(scope.chartData).transition().call(chart);

        var adjustYAxisTextPosition = function adjustYAxisTextPosition() {
          // move the y axis labels on top of it's lines
          svgContainer.selectAll('.nv-y .tick text, .nv-y .nv-axisMaxMin text').attr({
            transform: null,
            dy: -3,
            // TODO: make the x value adjust to label string length?
            dx: 36
          });
        };

        adjustYAxisTextPosition();

        nv.utils.windowResize(function () {
          chart.update();
          adjustYAxisTextPosition();
        });

        return chart;
      }, function (chart) {
        chart.interactiveLayer.tooltip.contentGenerator(function (d) {
          var tooltipHTML = '\n            <table>\n              <thead>\n                <tr>\n                  <td colspan="3">\n                    <strong class="x-value">' + X_AXIS_FORMAT(new Date(d.value)) + '</strong>\n                  </td>\n                </tr>\n              </thead>\n              <tbody>\n                ###TABLE_ROWS###\n              </tbody>\n            </table>';

          var TABLE_ROWS = _.map(d.series, function (serie) {
            return '<tr>\n                <td class="legend-color-guide">\n                  <div style="background-color:' + serie.color + ';"></div>\n                </td>\n                <td class="key">' + serie.key + '</td>\n                <td class="value">' + (currency.symbol + Y_AXIS_FORMAT(serie.value) + currency.suffix) + '</td>\n              </tr>';
          }).join('\n');

          tooltipHTML = tooltipHTML.replace('###TABLE_ROWS###', TABLE_ROWS);

          return tooltipHTML;
        });

        return chart;
      });
    }
  };
}

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsChartStackedBar', {
  bindings: {
    chartData: '<',
    dimension: '<',
    chartLegend: '<'
  },
  controller: zcsChartStackedBarController
});

zcsChartStackedBarController.$inject = ['$element', '$translate'];
function zcsChartStackedBarController($element, $translate) {
  var vm = this;
  vm.$onChanges = function (changes) {
    // do not react to dimension changes
    if (changes.chartData) {
      drawChart();
    }
  };

  function drawChart() {
    var container = $element;
    container.html('');
    container.append('<div class="chart-primary">');
    container.append('<div class="chart-tertiary">');
    // get color from container
    var colors = [angular.element('.chart-primary').css('color'), angular.element('.chart-tertiary').css('color')];

    var tooltipTimeFormatter = vm.dimension === 'hourly' ? d3.time.format($translate.instant('sharedModules.dateTimeFormats.chart.monthDayHour')) : d3.time.format($translate.instant('sharedModules.dateTimeFormats.chart.monthDay'));

    nv.addGraph(function () {
      var svgContainer = d3.select($element[0]).append('svg');
      var chart = nv.models.multiBarChart().showControls(false).showLegend(false).stacked(true)
      //.useInteractiveGuideline(true) // Tooltips which show all data points.
      .reduceXTicks(true).forceY([0, 1]).duration(500).color(colors).x(function (d) {
        return moment(d.x).valueOf();
      }).y(function (d) {
        return d.y;
      });

      if (vm.chartLegend || angular.isUndefined(vm.chartLegend)) {
        chart.margin({
          top: 10,
          right: 0,
          bottom: 20,
          left: 40
        });
      } else {
        chart.margin({ top: 0, right: 0, bottom: 0, left: 0 }).showXAxis(false).showYAxis(false);
      }

      chart.xAxis.tickFormat(function (d) {
        return tooltipTimeFormatter(new Date(d));
      });

      chart.yAxis.tickFormat(d3.format(',.0d'));

      svgContainer.datum(vm.chartData).transition().duration(500).call(chart);

      nv.utils.windowResize(chart.update);
      return chart;
    });
  }
}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS').component('closeButton', {
  bindings: {
    onClick: '&'
  },
  template: '\n    <a ng-click="$ctrl.onClick()"\n      class="modal-close">\n      <svg class="svg-icon" viewbox="0 0 20 20">\n        <path fill="none" d="M12.71,7.291c-0.15-0.15-0.393-0.15-0.542,0L10,9.458L7.833,7.291c-0.15-0.15-0.392-0.15-0.542,0c-0.149,0.149-0.149,0.392,0,0.541L9.458,10l-2.168,2.167c-0.149,0.15-0.149,0.393,0,0.542c0.15,0.149,0.392,0.149,0.542,0L10,10.542l2.168,2.167c0.149,0.149,0.392,0.149,0.542,0c0.148-0.149,0.148-0.392,0-0.542L10.542,10l2.168-2.168C12.858,7.683,12.858,7.44,12.71,7.291z M10,1.188c-4.867,0-8.812,3.946-8.812,8.812c0,4.867,3.945,8.812,8.812,8.812s8.812-3.945,8.812-8.812C18.812,5.133,14.867,1.188,10,1.188z M10,18.046c-4.444,0-8.046-3.603-8.046-8.046c0-4.444,3.603-8.046,8.046-8.046c4.443,0,8.046,3.602,8.046,8.046C18.046,14.443,14.443,18.046,10,18.046z"></path>\n      </svg>\n    </a>\n    '
});

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _magic_numbers = __webpack_require__(213);

var _magic_numbers2 = _interopRequireDefault(_magic_numbers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('zc.zenclerkS').component('zcsConversionTagChecker', {
  templateUrl: '/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_checker.html',
  bindings: {
    project: '<',
    showReturn: '<',
    onComplete: '&'
  },
  controller: zcsConversionTagCheckerController,
  controllerAs: 'vm'
});

zcsConversionTagCheckerController.$inject = ['$interval', '$rootScope', '$scope', '$translate', '$state', 'Devise', 'MongoConversion', 'ZcsOemService', 'currencies'];
function zcsConversionTagCheckerController($interval, $rootScope, $scope, $translate, $state, Devise, MongoConversion, ZcsOemService, currencies) {
  var vm = this;
  vm.currency = currencies[vm.project.currency];

  // variables
  vm.conversions = [];
  vm.showDetails = !vm.project.conversion_tag_confirmed_at;
  vm.isLoading = false;
  vm.lastConversionAt = null;
  vm.interval = null;
  vm.errors = {
    noConversions: false,
    hasBadConversionIds: false,
    hasBadConversionPrices: false,
    hasBadConversionCouponCodes: false,
    hasNoConversionPrice: false,
    hasNoCouponCode: true
  };

  vm.ZcsOemService = ZcsOemService;
  vm.conversionTagPrefix = ZcsOemService.getConversionTagPrefix();
  vm.host = ZcsOemService.getPublishHostForProject(vm.project);

  // actions
  vm.refresh = refresh;
  vm.complete = complete;
  vm.hasTagErrors = hasTagErrors;
  vm.goToNextStep = goToNextStep;

  vm.$onInit = function () {
    refresh();

    $scope.$on('$destroy', function () {
      stopIntervals();
    });
  };

  function refresh() {
    if (vm.isLoading) return;
    vm.isLoading = true;

    var fetchParams = {
      apikey: vm.project.apikey
    };

    if (vm.lastConversionAt) {
      fetchParams.created_at = {
        $gt: vm.lastConversionAt
      };
    }

    MongoConversion.find(fetchParams, {
      sort: {
        created_at: -1
      },
      limit: 20
    }).then(function (conversions) {
      vm.isLoading = false;
      vm.conversions = vm.conversions.concat(conversions);
      vm.conversions = _.chain(vm.conversions).uniqBy(function (cv) {
        return cv._id;
      }).sortBy(function (cv) {
        return -cv.created_at;
      }).value();

      _.each(vm.conversions, function (cv) {
        _.each(cv.items, function (item) {
          try {
            item.parsedName = decodeURIComponent(item.name);
          } catch (err) {
            item.parsedName = item.name;
          }
        });
      });

      checkConversionErrors();

      if (vm.conversions.length > 0) {
        vm.lastConversionAt = _.sortBy(vm.conversions, function (cv) {
          return -cv.created_at;
        })[0].created_at;
      }
    }).finally(function () {
      vm.isLoading = false;

      // loop for new conversions in the background
      if (!vm.interval) {
        vm.interval = $interval(refresh, _magic_numbers2.default.ZCLITE_CONVERSION_TAG_AUTOCHECK_INTERVAL);
      }
    });
  }

  function checkConversionErrors() {
    vm.errors.noConversions = vm.conversions.length === 0;
    if (vm.errors.noConversions) {
      return;
    }

    // check for the various bad reasons
    _.each(vm.conversions, function (conversion) {
      conversion.badConversionId = isBadConversionId(conversion);
      conversion.badConversionPrice = isBadConversionPrice(conversion);

      // in case of deemed, it does not matter
      if (vm.project.invoice_calculation_type === 'deemed') {
        conversion.isBadConversionCouponCode = isBadConversionCouponCode(conversion);
      } else if (vm.project.invoice_calculation_type === 'normal') {
        // if the calculation type is normal, there must be at least one coupon code in the conversion
        vm.errors.hasNoCouponCode = isMissingConversionCouponCode(conversion);
      }
    });

    var latestConversion = _.head(vm.conversions);
    var totalConversionPrice = _.sumBy(vm.conversions, 'price');

    vm.errors.hasBadConversionIds = isBadConversionId(latestConversion);
    vm.errors.hasBadConversionPrices = isBadConversionPrice(latestConversion);
    vm.errors.hasNoConversionPrice = totalConversionPrice === 0;
    vm.errors.hasBadConversionCouponCodes = vm.project.invoice_calculation_type === 'deemed' && isBadConversionCouponCode(latestConversion);

    if (!vm.errors.noConversions && !vm.errors.hasBadConversionIds && !vm.errors.hasBadConversionPrices && !vm.errors.hasNoConversionPrice) {
      if (vm.project.invoice_calculation_type === 'deemed') {
        if (!vm.errors.hasBadConversionCouponCodes) {
          complete();
        }
      } else if (vm.project.invoice_calculation_type === 'normal') {
        if (!vm.errors.hasNoCouponCode) {
          complete();
        }
      }
    }
  }

  function hasTagErrors() {
    var hadErrors = false;

    _.each(vm.errors, function (v, k) {
      if (v) {
        hadErrors = true;
      }
    });

    return hadErrors;
  }

  function isBadConversionId(conversion) {
    return !conversion.id || conversion.id === '[' + $translate.instant('directives.conversionTagChecker.conversionId') + ']';
  }

  function isBadConversionPrice(conversion) {
    return !conversion.price_raw || conversion.price_raw === '[' + $translate.instant('directives.conversionTagChecker.conversionPrice') + ']';
  }

  function isBadConversionCouponCode(conversion) {
    return conversion.coupon_code === '[' + $translate.instant('directives.conversionTagChecker.couponCode') + ']';
  }

  function isMissingConversionCouponCode(conversion) {
    return conversion.coupon_code === null || angular.isUndefined(conversion.coupon_code) || conversion.coupon_code === '[' + $translate.instant('directives.conversionTagChecker.couponCode') + ']';
  }

  function complete() {
    if (!vm.project.conversion_tag_confirmed_at) {
      vm.onComplete();
      // emiting is required for settings pages
      $rootScope.$broadcast('conversionTagFound');
    }
  }

  function goToNextStep() {
    // no need to get more data (+ without this tests are difficult)
    stopIntervals();
    $state.go('zenclerkS.project.setup.complete');
  }

  function stopIntervals() {
    if (vm.interval) {
      $interval.cancel(vm.interval);
    }
  }
}

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS').component('widgetActiveCampaigns', {
  templateUrl: '/templates/zenclerk_s/directives/dashboard/active_campaigns_widget.html',
  bindings: {
    project: '<'
  },
  controller: function controller(Campaign) {
    var vm = this;

    // variables

    // actions

    this.$onInit = function () {
      Campaign.all({ projectId: vm.project.id }).then(function (campaigns) {
        vm.campaigns = _.filter(campaigns, function (d) {
          return d.current_status === 'active';
        });
      });
    };
  }
});

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _zcd = __webpack_require__(214);

var _zcd2 = _interopRequireDefault(_zcd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('zc.zenclerkS').component('widgetConversionChart', {
  templateUrl: '/templates/zenclerk_s/directives/dashboard/conversion_chart_widget.html',
  bindings: {
    project: '<'
  },
  controller: function controller($translate, $element, AccessStats) {
    var vm = this;
    var region = vm.project.region;

    // TODO: get the color from classes
    // colorPrimary = angular.element(".chart-primary").css('color')
    // colorSecondary = angular.element(".chart-secondary").css('color')
    var colorPrimary = '#775FD3';
    var colorSecondary = '#1DD5A3';

    vm.conversionData = [];
    vm.sessionData = [];

    this.$onInit = function () {
      if (vm.project.is_demo) {
        var dates = getMonthlyDateKeys(moment.tz(region).format('YYYY-MM'));

        vm.conversionData = [];
        vm.sessionData = [];

        _.each(dates, function (date, i) {
          if (moment.tz(date, region).isAfter(moment.tz(region))) return;

          vm.conversionData.push({ date: moment.tz(date, 'YYYY-MM-DD', region).valueOf(), conversionCount: Math.round(Math.random() * 3 + 3) });
          vm.sessionData.push({ date: moment.tz(date, 'YYYY-MM-DD', region).valueOf(), sessionCount: Math.round(Math.random() * 10 * i + 300) });
        });

        createChart();
      } else {
        // on 1st day we don't have data yet so show last month
        var startAt = moment.tz(region).subtract(1, 'days').startOf('month').toDate();
        var endAt = moment.tz(region).subtract(1, 'days').endOf('month').toDate();

        AccessStats.find({
          dimension: 'daily',
          apikey: vm.project.apikey
        }, {
          match: {
            apikey: vm.project.apikey,
            device: null,
            campaign_segment_id: null,
            total_conversion_count: null,
            is_control: null,
            is_after_installed_at: null,
            start_at: {
              $gte: startAt,
              $lte: endAt
            }
          },
          sort: { start_at: 1 }
        }).then(function (res) {
          vm.sessionData = _.map(res, function (d) {
            return {
              date: moment.tz(d.start_at, region).toDate(),
              conversionCount: d.conversion_count,
              sessionCount: d.session_count
            };
          });

          createChart();
        });
      }
    };

    function createChart() {
      var WIDTH = $element.find('.widget-conversion-chart').width();
      var el = $element.find('.chart-conversion')[0];

      var deliveryGraph = new _zcd2.default(el, vm.sessionData, {
        width: WIDTH - 30,
        height: 260,
        padding: {
          left: 35,
          right: 50
        },
        isBarChart: true, // TODO: get rid of this, just for padding
        tooltipFn: function tooltipFn(d, opts) {
          return '\n          ' + opts.timeFormats.day(d.date) + '<br>\n          <div class="legend-rect" style="background-color: ' + colorPrimary + '"></div> ' + $translate.instant('directives.dashboard.common.numberOfCV', { value: d.conversionCount }) + '<br>\n          <div class="legend-rect" style="background-color: ' + colorSecondary + '"></div> ' + $translate.instant('directives.dashboard.common.numberOfVisitors', { value: d.sessionCount });
        }
      });

      deliveryGraph.addSeries({
        name: 'delivery-session-count',
        type: 'bar',
        x: 'date',
        y: 'conversionCount',
        color: colorPrimary
      });

      deliveryGraph.addSeries({
        name: 'delivery-percentage',
        type: 'line',
        x: 'date',
        y: 'sessionCount',
        yAxis: 'right',
        // yAxisTickFormat: asPercent,
        color: colorSecondary
      });

      deliveryGraph.createVerticalPositionIndicator();
    }

    function getMonthlyDateKeys(month) {
      var lastDayOfMonth = moment.tz(month, 'YYYY-MM', region).endOf('month').date();
      return _.map(_.range(1, lastDayOfMonth), function (d) {
        return moment.tz(month, 'YYYY-MM', region).date(d).format('YYYY-MM-DD');
      });
    }
  }
}); /* eslint-disable angular/component-name */
/* globals d3,nv */

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/component-name */
/* globals d3,nv */
angular.module('zc.zenclerkS').component('widgetCumulativeConversion', {
  templateUrl: '/templates/zenclerk_s/directives/dashboard/cumulative_conversion_widget.html',
  bindings: {
    project: '<',
    month: '<'
  },
  controller: function controller($q, $translate, $element, ZcsIncentive, ZcsAccessStats, ZcsCampaignStats, ZcsOemService, currencies) {
    var vm = this;
    // TODO: get the color from classes
    // colorPrimary = angular.element(".chart-primary").css('color')
    // colorSecondary = angular.element(".chart-secondary").css('color')
    var colorPrimary = '#1DD5A3';
    var colorSecondary = '#775FD3';
    var region = vm.project.region;
    var currency = currencies[vm.project.currency];

    function formatFraction(number) {
      return number / Math.pow(10, currency.fractionSize);
    }

    var dateRangeOfCurrentMonth = [];
    var today = moment.tz(region);

    this.$onInit = function () {
      vm.svgContainer = d3.select($element.find('.chart-cumulative-conversion')[0]).append('svg');

      vm.campaignConversions = [];
      vm.monthlyDateKeys = [];
      vm.revenueData = { incentives: [] };

      if (!vm.month) {
        vm.month = moment.tz(region).format('YYYY-MM');
      }

      vm.monthlyDateKeys = getMonthlyDateKeys(vm.month);
      var datesValueOf = _.map(vm.monthlyDateKeys, function (d) {
        return moment.tz(d, 'YYYY-MM-DD', region).valueOf();
      });
      if (isCurrentMonth()) {
        dateRangeOfCurrentMonth = [_.head(datesValueOf), moment.tz(region).startOf('days').valueOf()];
      } else {
        dateRangeOfCurrentMonth = [_.head(datesValueOf), _.last(datesValueOf)];
      }

      var startAt = moment.tz(vm.month, 'YYYY-MM', region).valueOf();
      var endAt = moment.tz(vm.month, 'YYYY-MM', region).endOf('month').valueOf();
      ZcsCampaignStats.find({
        apikey: vm.project.apikey,
        dimension: 'daily'
      }, {
        start_at: {
          $gte: startAt,
          $lt: endAt
        }
      }).then(function (res) {
        vm.revenueData = res;

        return ZcsAccessStats.getAccessStatsForSegment(vm.project.apikey, null, startAt, endAt);
      }).then(function (res) {
        vm.accessStats = res;

        return ZcsIncentive.all(vm.project.id);
      }).then(function (incentives) {
        vm.incentivesByCode = _.groupBy(incentives, function (d) {
          return d.coupon_code;
        });

        createCumulativeGraph();
      });
    };

    // create cumulative graph
    function createCumulativeGraph() {
      if (vm.revenueData.length === 0) return;

      var totalConversionData = [];
      var couponCodeConversionData = [];

      var lastValueTotal = 0;
      var lastValueConversion = 0;
      var currentValueTotal = 0;
      var currentValueConversion = 0;

      _.each(vm.monthlyDateKeys, function (date) {
        if (moment.tz(date, region).isAfter(today)) {
          return;
        }

        var campaignData = _.filter(vm.revenueData, function (d) {
          return moment.tz(d.start_at, region).isSame(date, 'day');
        });
        var valueOfDate = moment.tz(date, 'YYYY-MM-DD', region).valueOf();

        if (campaignData.length) {
          currentValueConversion = lastValueConversion + _.sumBy(campaignData, 'effective_conversion_price');
          couponCodeConversionData.push([valueOfDate, currentValueConversion]);
          lastValueConversion = currentValueConversion;
        } else {
          couponCodeConversionData.push([valueOfDate, lastValueConversion]);
        }

        var totalData = _.find(vm.accessStats, function (d) {
          return moment.tz(d.start_at, region).isSame(date, 'day');
        });

        if (totalData) {
          if (campaignData.length) {
            currentValueTotal = lastValueTotal + totalData.conversion_price - _.sumBy(campaignData, 'effective_conversion_price');
          } else {
            currentValueTotal = lastValueTotal + totalData.conversion_price;
          }
          totalConversionData.push([valueOfDate, currentValueTotal]);
          lastValueTotal = currentValueTotal;
        } else {
          totalConversionData.push([valueOfDate, lastValueTotal]);
        }
      });

      nv.addGraph(function () {
        var chart = nv.models.stackedAreaChart().margin({ top: 0, right: 30, bottom: 30, left: 20 }).interpolate('cardinal') // rounded line
        .x(function (d) {
          return d[0];
        }).y(function (d) {
          return formatFraction(d[1]);
        }).showControls(false).xDomain(dateRangeOfCurrentMonth).color([colorPrimary, colorSecondary]);

        chart.xAxis.tickFormat(function (d) {
          return moment.tz(d, region).format('MM/DD');
        });

        chart.yAxis.tickFormat(function (d) {
          return currency.symbol + d3.format(',f')(d) + currency.suffix;
        });

        vm.svgContainer.datum([{ key: $translate.instant('directives.dashboard.cumulativeConversionWidget.viaSales', { service: ZcsOemService.getName() }), values: couponCodeConversionData }, { key: $translate.instant('directives.dashboard.cumulativeConversionWidget.otherSales'), values: totalConversionData }]).call(chart);

        nv.utils.windowResize(chart.update);

        return chart;
      });
    }

    function getMonthlyDateKeys(month) {
      var lastDayOfMonth = moment.tz(vm.month, 'YYYY-MM', region).endOf('month').date();
      // _.range does not include the last value, so add +1
      var range = _.range(1, lastDayOfMonth + 1);
      return _.map(range, function (d) {
        return moment.tz(vm.month, 'YYYY-MM', region).date(d).format('YYYY-MM-DD');
      });
    }

    function isCurrentMonth() {
      return vm.month === moment.tz(region).format('YYYY-MM');
    }
  }
});

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS').component('widgetTopItems', {
  templateUrl: '/templates/zenclerk_s/directives/dashboard/top_items_widget.html',
  bindings: {
    project: '<',
    sortOrder: '@'
  },
  controllerAs: 'vm',
  controller: function controller($state, MongoZcsDailyDiffStats, currencies) {
    var vm = this;

    vm.currency = currencies[vm.project.currency];

    // variables
    vm.stats = {};

    // actions
    vm.isLoading = true;

    vm.min = Math.min;
    vm.conversionTagSettingPage = $state.href('zenclerkS.project.tags.conversion', { projectId: vm.project.project_id });

    this.$onInit = function () {
      MongoZcsDailyDiffStats.find({
        apikey: vm.project.apikey,
        // On 1st, show last month
        month: moment().subtract(1, 'days').format('YYYY-MM')
      }, { sort: { summarize_at: -1 }, limit: 1 }).then(function (res) {
        vm.isLoading = false;
        if (res && res[0]) {
          // take a copy because... well, same request is cached :o
          vm.stats = _.merge({}, res[0]);

          vm.stats.items = _.filter(vm.stats.items, function (d) {
            return d.monthly.pv >= 5;
          });

          if (vm.sortOrder === 'asc') {
            vm.stats.items = _.sortBy(vm.stats.items, function (item) {
              return item.monthly.conversion_ratio;
            });
          } else {
            vm.stats.items = _.sortBy(vm.stats.items, function (item) {
              return -item.monthly.conversion_ratio;
            });
          }
        }
      });
    };
  }
});

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS').component('widgetTopPages', {
  templateUrl: '/templates/zenclerk_s/directives/dashboard/top_pages_widget.html',
  bindings: {
    project: '<'
  },
  controllerAs: 'vm',
  controller: function controller(ZcsDashboardData) {
    var vm = this;
    var demoData = [{
      url: 'https://www.example.com',
      weeklyData: [{ value: 98 }, { value: 75 }]
    }, {
      url: 'https://www.example.com/sale',
      weeklyData: [{ value: 60 }, { value: 0 }]
    }, {
      url: 'https://www.example.com/categories/1',
      weeklyData: [{ value: 42 }, { value: 38 }]
    }, {
      url: 'https://www.example.com/items/123',
      weeklyData: [{ value: 25 }, { value: 52 }]
    }, {
      url: 'https://www.example.com/items/789',
      weeklyData: [{ value: 24 }, { value: 18 }]
    }, {
      url: 'https://www.example.com/items/456',
      weeklyData: [{ value: 10 }, { value: 12 }]
    }];

    // variables
    vm.topPages = [];

    // actions

    this.$onInit = function () {
      if (vm.project.is_demo) {
        vm.topPages = demoData;
      } else {
        ZcsDashboardData.find({
          apikey: vm.project.apikey,
          date: moment().subtract(7, 'days').startOf('day').toDate()
        }).then(function (res) {
          if (res.top_pages_by_canonical_url && res.top_pages_by_canonical_url.length > 0) {
            // remove null canonical_urls..
            vm.topPages = _.filter(res.top_pages_by_canonical_url, 'url');
          } else if (res.top_pages_by_url && res.top_pages_by_url.length > 0) {
            vm.topPages = res.top_pages_by_url;
          } else {
            vm.topPages = demoData;
            vm.showNoDataOverlay = true;
          }
          vm.topPages = _.reject(vm.topPages, function (p) {
            return !p.url || p.url === 'undefined' || p.url === 'null';
          });
        });
      }
    };
  }
});

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS').component('widgetTopReferrers', {
  templateUrl: '/templates/zenclerk_s/directives/dashboard/top_referrers_widget.html',
  bindings: {
    project: '<'
  },
  controllerAs: 'vm',
  controller: function controller(ZcsDashboardData) {
    var vm = this;
    var demoData = [{
      url: '',
      weeklyData: [{ value: 55 }, { value: 61 }]
    }, {
      url: 'https://www.google.co.jp',
      weeklyData: [{ value: 34 }, { value: 31 }]
    }, {
      url: 'https://www.example-campaign.com',
      weeklyData: [{ value: 32 }, { value: 0 }]
    }, {
      url: 'https://www.yahoo.com',
      weeklyData: [{ value: 16 }, { value: 15 }]
    }, {
      url: 'https://sample-site.com',
      weeklyData: [{ value: 11 }, { value: 11 }]
    }, {
      url: 'https://other-campaign.com/landing-page',
      weeklyData: [{ value: 9 }, { value: 0 }]
    }];

    // variables
    vm.topReferrers = [];

    // actions

    this.$onInit = function () {
      if (vm.project.is_demo) {
        vm.topReferrers = demoData;
      } else {
        ZcsDashboardData.find({
          apikey: vm.project.apikey,
          date: moment().subtract(7, 'days').startOf('day').toDate()
        }).then(function (res) {
          if (res.top_referrers && res.top_referrers.length > 0) {
            vm.topReferrers = res.top_referrers;
          } else {
            vm.topReferrers = demoData;
            vm.showNoDataOverlay = true;
          }
        });
      }
    };
  }
});

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS').component('widget', {
  templateUrl: '/templates/zenclerk_s/directives/dashboard/widget.html',
  transclude: {
    title: '?widgetTitle',
    content: 'widgetContent'
  },
  controllerAs: 'vm',
  controller: function controller() {
    // variables

    // actions

    this.$onInit = function () {};
  }
});

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsEstimatedRevenue', {
  templateUrl: '/templates/zenclerk_s/directives/estimated_revenue/estimated_revenue.html',
  bindings: {
    revenue: '=',
    project: '='
  },
  controllerAs: 'vm',
  controller: function controller(currencies) {
    var vm = this;
    vm.limit = 1000;
    vm.currency = currencies[vm.project.currency];
  }
});

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsExcludeIpEditor', {
  bindings: {
    project: '='
  },
  templateUrl: '/templates/zenclerk_s/directives/exclude_ip_editor/exclude_ip_editor.html',
  controllerAs: 'vm',
  controller: function controller(ProjectExcludeIp, Ip, ZcsOemService) {
    var vm = this;
    // only this specific functionality
    vm.excludeIps = [];
    vm.currentIp = '';
    vm.ZcsOemService = '';

    this.$onInit = function () {
      Ip.get().then(function (ip) {
        vm.currentIp = ip;
      });
      ProjectExcludeIp.all(vm.project.id).then(function (excludeIps) {
        vm.excludeIps = excludeIps;
      });
      vm.ZcsOemService = ZcsOemService;
    };

    vm.addExcludeIp = function () {
      vm.excludeIps.push({
        project_id: vm.projectId,
        ip: ''
      });
    };

    vm.onDestroy = function (excludeIp) {
      if (!excludeIp) return;
      vm.excludeIps.splice(vm.excludeIps.indexOf(excludeIp), 1);
    };
  }
});

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsExcludeIpForm', {
  bindings: {
    project: '=',
    excludeIp: '=',
    currentIp: '=',
    onDestroy: '&'
  },
  templateUrl: '/templates/zenclerk_s/directives/exclude_ip_editor/exclude_ip_form.html',
  controllerAs: 'vm',
  controller: function controller($scope, ProjectExcludeIp) {
    var vm = this;

    vm.isDestroying = false;
    vm.isSaving = false;

    vm.saveExcludeIp = function () {
      vm.isSaving = true;

      if (vm.excludeIp.id) {
        ProjectExcludeIp.update({ projectId: vm.project.id, id: vm.excludeIp.id }, { ip: vm.excludeIp.ip }).then(mergePageType).catch(handleError);
      } else {
        ProjectExcludeIp.create({ projectId: vm.project.id }, { ip: vm.excludeIp.ip }).then(mergePageType).catch(handleError);
      }
    };

    vm.destroyExcludeIp = function () {
      if (!vm.excludeIp.id) {
        vm.onDestroy({ excludeIp: vm.excludeIp });
      } else {
        vm.isDestroying = true;
        ProjectExcludeIp.delete(vm.project.id, vm.excludeIp.id).then(function (res) {
          vm.onDestroy({ excludeIp: vm.excludeIp });
          vm.isDestroying = false;
        }).catch(handleError);
      }
    };

    function mergePageType(res) {
      vm.excludeIps = _.merge(vm.excludeIps, res);
      vm.isSaving = false;
      $scope.excludeIpForm.$setPristine();
    }

    function handleError() {
      vm.isSaving = false;
      vm.isDestroying = false;
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsExcludePageEditor', {
  bindings: {
    project: '='
  },
  templateUrl: '/templates/zenclerk_s/directives/exclude_page_editor/exclude_page_editor.html',
  controllerAs: 'vm',
  controller: function controller($scope, MongoHistory, PageType) {
    var vm = this;
    // This limit also exists in project.rb...
    var EXCLUDE_PAGE_TYPE_LIMIT = 500;

    // Calculate exclusion percentage from the most recent 1000 histories
    var EXCLUDE_PAGES_HISTORY_SAMPLING_SIZE = 1000;
    $scope.exclusionPercentage = 0;

    $scope.$on('uploadedPageTypes', function (event, pageTypes) {
      vm.pageTypes = pageTypes;
    });

    $scope.project = vm.project;

    this.$onInit = function () {
      vm.baseUrl = vm.project.base_url;
      vm.pageTypes = [];
      vm.pageTypeSampleUrls = [];
      vm.excludedPageTypeLimit = EXCLUDE_PAGE_TYPE_LIMIT;
      // get rid of last / if it's there
      if (vm.baseUrl && vm.baseUrl.endsWith('/')) {
        vm.baseUrl = vm.baseUrl.substr(0, vm.baseUrl.length - 1);
      }

      PageType.all(vm.project.id).then(function (pageTypes) {
        vm.pageTypes = _.filter(pageTypes, function (pt) {
          return pt.page_type === 'no_publish';
        });
        if (vm.pageTypes.length === 0) {
          vm.pageTypes.push(PageType.new({
            project_id: vm.projectId,
            page_type: 'no_publish',
            match_pattern: '/',
            match_type: 'prefix'
          }));
        } else {
          vm.queryMongoHistoryToCalcExclusionPercentage();
        }
      });

      vm.showExcludeForm = false;
    };

    vm.onDestroy = function (pageType) {
      if (!pageType) return;
      vm.pageTypes.splice(vm.pageTypes.indexOf(pageType), 1);
    };

    vm.queryMongoHistoryToCalcExclusionPercentage = function () {
      MongoHistory.find({ apikey: vm.project.apikey }, { sort: { opened_at: -1 } }, { limit: EXCLUDE_PAGES_HISTORY_SAMPLING_SIZE }).then(function (histories) {
        if (histories) {
          vm.calcExclusionPercentage(vm.pageTypes, histories);
        }
      });
    };

    vm.calcExclusionPercentage = function (pageTypes, histories) {
      var totalCount = histories.length;
      var matchedCount = _.filter(histories, function (history) {
        if (!history.url || history.url.length === 0) {
          return false;
        }
        var url = new URL(history.url);
        var urlPath = '' + url.pathname + url.search + url.hash;
        return _.some(pageTypes, function (pageType) {
          switch (pageType.match_type) {
            case 'prefix':
              if (urlPath.startsWith(pageType.match_pattern)) {
                return true;
              }
              break;
            case 'full':
              if (urlPath === pageType.match_pattern) {
                return true;
              }
              break;
            case 'partial':
              if (urlPath.includes(pageType.match_pattern)) {
                return true;
              }
              break;
          }
          return false;
        });
      }).length;
      $scope.exclusionPercentage = totalCount ? (matchedCount / totalCount * 100).toFixed(2) : 0;
    };
  }
});

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsExcludePageForm', {
  bindings: {
    project: '=',
    baseUrl: '=',
    pageTypes: '=',
    onDestroy: '&'
  },
  templateUrl: '/templates/zenclerk_s/directives/exclude_page_editor/exclude_page_form.html',
  controllerAs: 'vm',
  controller: function controller($scope, $translate, Meta, PageType) {
    var vm = this;
    var EXCLUDE_PAGE_TYPE_LIMIT = 500;
    vm.isDestroying = false;
    vm.isSaving = false;
    vm.excludedPageTypeLimit = EXCLUDE_PAGE_TYPE_LIMIT;

    Meta.getPageTypeMatchTypes().then(function (res) {
      var regexp = _.findIndex(res, { name: 'regexp' });
      if (regexp !== -1) {
        res.splice(regexp, 1);
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = res[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var pt = _step.value;

          pt.label = $translate.instant('directives.excludePage.' + pt.name);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      vm.matchTypes = res;
    });

    vm.savePageType = function () {
      vm.isSaving = true;
      var updatePages = [];
      var createPages = [];

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = vm.pageTypes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var pt = _step2.value;

          if (pt.id) {
            if (pt.isModified) {
              delete pt.isModified;
              updatePages.push(pt);
            }
          } else {
            delete pt.isModified;
            createPages.push(pt);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (createPages.length > 0) {
        PageType.createMany({ projectId: vm.project.id }, createPages).then(mergePageType);
      }

      if (updatePages.length > 0) {
        PageType.updateMany({ projectId: vm.project.id }, updatePages).then(mergePageType);
      }
    };

    vm.destroyPageType = function (pageType) {
      if (!pageType.id) {
        vm.onDestroy(pageType);
      } else {
        vm.isDestroying = true;
        PageType.destroy(pageType).then(function (res) {
          vm.onDestroy(pageType);
          vm.isDestroying = false;
          // When rule is deleted, refresh the exclusion rate which is in parent scope
          $scope.$parent.vm.queryMongoHistoryToCalcExclusionPercentage();
        });
      }
    };

    vm.onDestroy = function (pageType) {
      if (!pageType) return;
      /* eslint-disable angular/no-private-call */
      var pageTypeIndex = vm.pageTypes.findIndex(function (pt) {
        return pt.$$hashKey === pageType.$$hashKey;
      });
      if (pageTypeIndex !== -1) {
        vm.pageTypes.splice(pageTypeIndex, 1);
      }
    };

    function mergePageType(res) {
      vm.isSaving = false;
      $scope.excludePageForm.$setPristine();
      // When rule is added, refresh the exclusion rate which is in parent scope
      $scope.$parent.vm.queryMongoHistoryToCalcExclusionPercentage();
      return res;
    }

    vm.addPageType = function () {
      vm.pageTypes.push(PageType.new({
        project_id: vm.projectId,
        page_type: 'no_publish',
        match_pattern: '/',
        match_type: 'prefix'
      }));
    };

    vm.pageTypeChanged = function (pageType) {
      pageType.isModified = true;
    };
  }
});

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').directive('fullySupportedAspOnly', fullySupportedAspOnly);

fullySupportedAspOnly.$inject = [];
function fullySupportedAspOnly() {
  return {
    restrict: 'A',
    controller: fullySupportedAspOnlyController
  };
}

fullySupportedAspOnlyController.$inject = ['$element', '$scope', '$stateParams', 'Devise', 'ZcsProject'];
function fullySupportedAspOnlyController($element, $scope, $stateParams, Devise, ZcsProject) {
  var originalDisplay = $element.css('display');

  $element.css('display', 'none');

  $scope.$stateParams = $stateParams;

  var cartAsp = ['makeshop'];

  $scope.$watch('$stateParams.apikey', function () {
    if (!$stateParams.apikey) return;

    ZcsProject.get(Devise.currentUser.id, $stateParams.apikey).then(function (project) {
      if (_.includes(cartAsp, project.shopping_cart_asp) || project.show_item_stats) {
        $element.css('display', originalDisplay);
      }
    });
  });
}

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS').component('helpLauncher', {
  templateUrl: '/templates/zenclerk_s/directives/help/launcher.html',
  bindings: {
    class: '@',
    isMain: '<',
    currentProject: '<'
  },
  controller: helpLauncherController
});

helpLauncherController.$inject = ['$element', '$scope', '$state', '$stateParams', 'Devise', 'ZcsLayout', 'ZcsProject'];
function helpLauncherController($element, $scope, $state, $stateParams, Devise, ZcsLayout, ZcsProject) {
  var vm = this;

  this.$onInit = function () {
    vm.hideMainHelp = hideMainHelp;
    vm.openProductChanges = openProductChanges;
  };

  function openProductChanges() {
    ZcsLayout.isSidebarVisible = true;
  }

  function hideMainHelp() {
    if (angular.isDefined(vm.isMain)) {
      return _.get($state, 'current.data.hideMainHelp');
    }
    return false;
  }
}

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS').directive('zcsHideWhenProduction', zcsHideWhenProduction);

zcsHideWhenProduction.$inject = ['Environment'];
function zcsHideWhenProduction(Environment) {
  return {
    restrict: 'A',
    link: function link(scope, elem, attrs) {
      elem.css({ display: 'none' });
      scope.Environment = Environment;
      Environment.get().then(function (environment) {
        if (environment === 'production') {
          elem.css({ display: 'none' });
        } else {
          elem.css({ display: 'block' });
        }
      });
    }
  };
}

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS').directive('zcsMakerepeaterOnly', zcsMakerepeaterOnlyDirective);

zcsMakerepeaterOnlyDirective.$inject = ['ZcsOemService'];
function zcsMakerepeaterOnlyDirective(ZcsOemService) {
  return {
    restrict: 'A',
    link: function link(scope, elem, attrs) {
      scope.ZcsOemService = ZcsOemService;
      scope.$watch('ZcsOemService.get()', function (oemService) {
        if (oemService === 'makerepeater') {
          elem.css({ display: 'block' });
        } else {
          elem.css({ display: 'none' });
        }
      });
    }
  };
}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').directive('masterOnly', masterOnly);

masterOnly.$inject = ['Devise'];
function masterOnly(Devise) {
  return {
    restrict: 'A',
    link: link
  };

  function link(scope, elem, attrs) {
    var originalDisplay = elem.css('display');
    // hide initially!
    elem.css({ display: 'none' });

    Devise.getCurrentUser().then(function (user) {
      if (user && Devise.isMaster()) {
        elem.css({ display: originalDisplay });
      }

      scope.$watch(function () {
        return _.get(Devise.currentUser, 'role');
      }, function () {
        if (!user || !Devise.isMaster()) {
          elem.css({ display: 'none' });
        } else {
          elem.css({ display: originalDisplay });
        }
      });
    });
  }
}

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsNotificationAlert', {
  templateUrl: '/templates/zenclerk_s/directives/notification/notification-alert.html',
  controller: zcsSiteNotificationController
});

zcsSiteNotificationController.$inject = ['$scope', '$state', '$translate', '$stateParams', 'Devise', 'FeatureNotification', 'ZcsLayout', 'ZcsOemService', 'ZcsProject'];
function zcsSiteNotificationController($scope, $state, $translate, $stateParams, Devise, FeatureNotification, ZcsLayout, ZcsOemService, ZcsProject) {
  var vm = this;

  /*
   * key: what will be saved to database
   * containerClass: alert-info, alert-success, etc
   * iconClass: icon
   * text: contents
   * linkAction: what happens when clicked
   * isActive: mostly time limit or can be used for external reason checks also
   * isVisible: on which states it will be shown
   */
  var NOTIFICATIONS = [{
    key: '20220922_aideal_incident_notification',
    containerClass: 'alert alert-info',
    iconClass: 'fa fa-bell-o',
    html: $translate.use() === 'ja' ? '現在、バナーは正常に配信されておりますが、データ集計に問題が発生しており、一部ダッシュボード上の数値が正しくない可能性があります。' : 'We are having data aggregation issue at the moment, numbers on the dashboard might not be correct, please come back later',
    allowDismiss: true,
    isActive: function isActive() {
      return false;
    },
    isVisible: function isVisible() {
      return false;
    }
  }, {
    key: '20191015_aideal_rebrand_notification',
    containerClass: 'alert alert-info',
    iconClass: 'fa fa-bell-o',
    html: $translate.instant('directives.notifications.alert1', { url: '<a href=\'https://www.appier.com/ja/news/appier-acquires-japan-based-emin/\'>' + $translate.instant('directives.common.here') + '</a>' }),
    allowDismiss: true,
    isActive: function isActive() {
      return true;
    },
    isVisible: function isVisible() {
      return true;
    }
  }, {
    key: '20190927_consumption_tax_increase_notification',
    containerClass: 'alert alert-info',
    iconClass: 'fa fa-bell-o',
    text: '' + $translate.instant('directives.notifications.alert2'),
    allowDismiss: true,
    isActive: function isActive() {
      return true;
    },
    // this line is unnecessary, because notifications aren't displayed for oem projects anyway but I'll just add it to be sure.
    isVisible: function isVisible() {
      return !vm.currentProject.is_oem;
    }
  }];

  vm.$onInit = function () {
    vm.currentProject = undefined;
    vm.isDisabled = false;
    vm.dismiss = dismiss;
    vm.isAllowedToShow = isAllowedToShow;
    vm.ZcsOemService = ZcsOemService;

    $scope.$watch(function () {
      return ZcsOemService.get();
    }, function (oemService) {
      // Avoid creating lots of meaningless shows when OEM
      // (this is because hide-when-oem is not ng-if but just hiding with css)
      if (oemService) {
        vm.isDisabled = true;
      } else {
        vm.isDisabled = false;
      }
    });

    // Get current project when stateParams change.
    // We cannot do this in isVisible or something because it's too heavy
    $scope.$watch(function () {
      return $stateParams.apikey;
    }, function (newval) {
      if (vm.isDisabled) {
        return;
      }

      if (newval) {
        Devise.getCurrentUser().then(function (user) {
          if (!user) {
            return;
          }

          ZcsProject.get(user.id, $stateParams.apikey).then(function (project) {
            vm.currentProject = project;
          });
        });
      }
    });
  };

  vm.$onChanges = function () {
    if (vm.isDisabled) {
      return;
    }

    // need to ensure that user exists
    Devise.getCurrentUser().then(function (user) {
      if (!user) {
        return;
      }
      vm.notifications = [];

      _.each(NOTIFICATIONS, function (notification) {
        // Add when not read already
        if (!_.includes(user.read_notifications, notification.key) && notification.isActive()) {
          vm.notifications.push(notification);
        }
      });
    });
  };

  function isAllowedToShow(notification) {
    var isVisible = notification.isVisible();

    // Only set as shown if the state we are in actually allows showing the notification
    if (isVisible && !notification.__markedAsShown &&
    // NOTE: isDisabled for OEM checks to avoid creating notifications,
    // because when OEM, these are just hidden with css
    !vm.isDisabled) {

      FeatureNotification.markAsShown(notification).finally(function () {
        notification.__markedAsShown = true;
      });
    }
    return isVisible;
  }

  function dismiss(notification) {
    vm.notifications = _.reject(vm.notifications, function (d) {
      return d === notification;
    });
    FeatureNotification.markAsRead(notification);
    Devise.getCurrentUser().then(function (user) {
      user.read_notifications.push(notification.key);
    });
  }
}

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsNotificationPanel', {
  templateUrl: '/templates/zenclerk_s/directives/notification/notification-panel.html',
  controller: zcsNotificationPanel
});

zcsNotificationPanel.$inject = ['$scope', 'ZcsLayout'];
function zcsNotificationPanel($scope, ZcsLayout) {
  var vm = this;

  this.$onInit = function () {
    vm.togglePanel = togglePanel;
    vm.isPanelActive = false;
    vm.ZcsLayout = ZcsLayout;

    $scope.$watch(function () {
      return ZcsLayout.isSidebarVisible;
    }, function (newval) {
      vm.isPanelActive = newval;
    });
  };

  function togglePanel() {
    ZcsLayout.isSidebarVisible = !ZcsLayout.isSidebarVisible;
  }
}

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsNotificationTimezone', {
  templateUrl: '/templates/zenclerk_s/directives/notification/timezone.html',
  bindings: {
    project: '=',
    static: '=',
    status: '@'
  },
  controllerAs: 'vm',
  controller: ZcsNotificationTimezoneController
});

function ZcsNotificationTimezoneController() {
  var vm = this;
  if (!vm.status) vm.status = 'warning';
  vm.isTimezoneDiff = moment().tz(vm.project.region).format('Z') !== moment().tz(moment.tz.guess(true)).format('Z');
  vm.showAlert = true;

  vm.hideAlert = hideAlert;
  function hideAlert() {
    vm.showAlert = false;
  }
}

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsProfile', {
  templateUrl: '/templates/zenclerk_s/directives/profile/profile.html',
  controller: zcsProfile
});

zcsProfile.$inject = ['$scope', '$state', 'Devise', 'Environment', '$translate'];
function zcsProfile($scope, $state, Devise, Environment, $translate) {
  var vm = this;
  vm.state = {};
  vm.css = {};

  vm.environment = 'production';
  Environment.get().then(function (environment) {
    vm.environment = environment;
  });

  vm.availableLanguages = $translate.getAvailableLanguageKeys();

  // User info
  // ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
  Devise.getCurrentUser().then(function (user) {
    vm.user = _.merge({}, user);
  });

  // Navigation
  // ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
  vm.state.nav = 'info'; // default view
  vm.nav = function (item) {
    vm.state.nav = item;
  };

  // Info modification
  // ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
  vm.updateInfo = function (user) {
    Devise.updateInfo(user).then(function (res) {
      $translate.use(res.lang);
      moment.locale(res.lang);
      $scope.$parent.$emit('userInfoUpdated');
    });
  };

  // Password modification
  // ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
  vm.updatePassword = function (user) {
    Devise.updatePassword(user.current_password, user.password, user.password_confirmation).then(function (res) {
      vm.user.current_password = vm.user.password;
      vm.user.password = '';
      vm.user.password_confirmation = '';
    });
  };
}

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsFreeShippingCostEditorController', ZcsFreeShippingCostEditorController);

ZcsFreeShippingCostEditorController.$inject = ['$scope', '$uibModalInstance', 'ZcsProject', 'currencies', 'project'];
function ZcsFreeShippingCostEditorController($scope, $uibModalInstance, ZcsProject, currencies, project) {
  var vm = this;
  vm.project = project;
  vm.close = close;
  vm.setFreeShippingCost = setFreeShippingCost;
  vm.isSaving = false;
  // store temporarily first
  vm.freeShippingCost = vm.project.free_shipping_cost;
  vm.currency = currencies[vm.project.currency];

  function setFreeShippingCost() {
    vm.isSaving = true;
    var newProject = _.merge({}, vm.project, { free_shipping_cost: vm.freeShippingCost });
    ZcsProject.saveProject(newProject).then(function (res) {
      vm.project = _.merge(vm.project, res);
    }).finally(function () {
      vm.isSaving = false;
      $scope.setFreeShippingCost.$setPristine();
      close();
    });
  }

  function close() {
    $uibModalInstance.close();
  }
}

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsProjectUserActivity', {
  templateUrl: '/templates/zenclerk_s/directives/project_user_activity/user_activity.html',
  bindings: {
    projects: '<'
  },
  controllerAs: 'vm',
  controller: zcsProjectUserActivityController
});

zcsProjectUserActivityController.$inject = ['$scope', '$q', 'MongoSession'];
function zcsProjectUserActivityController($scope, $q, MongoSession) {
  var vm = this;

  vm.$onInit = function () {
    vm.toggleUserList = toggleUserList;

    $scope.$watchCollection('vm.projects', function (newval, oldval) {
      if (newval) getSessionsForAllProjects();
    });
  };

  function toggleUserList(project) {
    if (!project._showUserList) {
      project._showUserList = true;
    } else {
      project._showUserList = false;
    }
  }

  function getSessionsForUser(user) {
    return MongoSession.find({
      apikey: 'emin-zcs',
      opened_at: { $gte: moment().subtract(1, 'months').toDate() },
      'cookie_segment.user_id': user.id.toString()
    }).then(function (sessions) {
      user.sessions = sessions;
      user.combinedDwell = _.sumBy(user.sessions, function (d) {
        return d.dwell / (60 * 1000);
      });
      if (!user.sessions.length) {
        user.lastViewed = null;
      } else {
        user.lastViewed = _.max(_.map(user.sessions, 'closed_at'));
      }
    });
  }

  function getSessionsForAllProjects() {
    _.each(vm.projects, function (project) {
      var promises = _.map(project.users, getSessionsForUser);
      $q.all(promises).then(function (result) {
        $scope.$broadcast('gotSessions', project);
      });
    });
  }
}

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals d3 */
angular.module('zc.zenclerkS').component('zcsUserActivityGraph', {
  templateUrl: '/templates/zenclerk_s/directives/project_user_activity/user_activity_graph.html',
  bindings: {
    project: '<'
  },
  controllerAs: 'vm',
  controller: function controller($translate, $element, $scope, $window, Campaign, MongoSession) {
    var DAYS = 30;
    var LINE_HEIGHT = 30;
    var MARGINY = 5;
    var WEEKDAYS = [$translate.instant('directives.common.weekday.sunday'), $translate.instant('directives.common.weekday.monday'), $translate.instant('directives.common.weekday.tuesday'), $translate.instant('directives.common.weekday.wednesday'), $translate.instant('directives.common.weekday.thursday'), $translate.instant('directives.common.weekday.friday'), $translate.instant('directives.common.weekday.saturday')];

    var vm = this;

    var svg = void 0;
    var xScale = void 0,
        yScale = void 0,
        yScaleCampaign = void 0,
        color = void 0,
        campaignColor = void 0;
    var margin = { top: 20, right: 20, bottom: 30, left: 20 };
    var width = 300 - margin.left - margin.right;
    var height = LINE_HEIGHT * 2 + 20 - margin.top - margin.bottom;

    this.$onInit = function () {
      svg = d3.select($element.find('svg')[0]);

      Campaign.all({ projectId: vm.project.id }).then(function (campaigns) {
        vm.project.campaigns = _.filter(campaigns, function (d) {
          return d.start_at && d.end_at && d.current_status !== 'unfinished';
        });
        createGraph();
      });

      $scope.$on('gotSessions', function (event, project) {
        if (project.id === vm.project.id) createGraph();
      });

      // listen resize for redrawing
      var w = angular.element($window);
      w.bind('resize', createGraph);
    };

    function addOuterBox(group) {
      group.append('rect').attr('x', 0).attr('y', MARGINY).attr('width', width).attr('height', LINE_HEIGHT).style('stroke-width', 1).style('stroke', 'rgba(0,0,0,1)').style('fill', 'rgba(255,255,255,0.2)').style('pointer-events', 'stroke');
    }

    function addTextLabels(group) {
      group.append('text').attr('x', 0).attr('y', LINE_HEIGHT + 20).style('font-size', '12px').text(function (d) {
        return $translate.instant('directives.common.daysAgo', { day: DAYS });
      });

      group.append('text').attr('x', width - 8).attr('y', LINE_HEIGHT + 20).style('font-size', '12px').text(function (d) {
        return $translate.instant('directives.common.now');
      });
    }

    function addSession(group) {
      group.append('rect').attr('class', 'session').attr('y', MARGINY).attr('x', function (d) {
        return xScale(d.opened_at.valueOf());
      }).attr('width', function (d) {
        if (!d.closed_at) return 3;
        var val = xScale(d.closed_at.valueOf()) - xScale(d.opened_at.valueOf());
        if (val < 3) val = 3;
        return val;
      }).attr('height', LINE_HEIGHT).style('opacity', 0.5).style('fill', function (d) {
        return color(d);
      }).call(setupUserTooltip);
    }

    function addCampaigns(group) {
      group.append('rect').attr('class', 'campaign').attr('y', function (d) {
        return yScaleCampaign(d.id);
      }).attr('x', function (d) {
        return xScale(d.start_at.valueOf());
      }).attr('width', function (d) {
        var val = xScale(d.end_at.valueOf()) - xScale(d.start_at.valueOf());
        var max = width - xScale(d.start_at.valueOf());
        if (val > max) val = max;
        return val;
      }).attr('height', function (d) {
        return (LINE_HEIGHT - MARGINY) / vm.project.campaigns.length;
      }).style('fill', function (d) {
        return campaignColor(d.id);
      }).call(setupCampaignTooltip);
    }

    function createScales() {
      color = d3.scale.category20b().domain(vm.project.users);
      campaignColor = d3.scale.category20c().domain(vm.project.campaigns);

      xScale = d3.scale.linear().domain([moment().subtract(DAYS, 'days').valueOf(), moment().valueOf()]).range([0, width]);

      yScale = d3.scale.ordinal().domain(_.map(vm.project.users, function (u) {
        return u.id;
      })).range([MARGINY, LINE_HEIGHT]);

      yScaleCampaign = d3.scale.ordinal().domain(_.map(vm.project.campaigns, function (c) {
        return c.id;
      })).rangePoints([MARGINY, LINE_HEIGHT - 3]);
    }

    function getUserById(id) {
      return _.filter(vm.project.users, function (user) {
        return user.id === id;
      })[0];
    }

    function hideTooltip(d, i) {
      var tooltip = $element.find('.activity-graph-tooltip');
      // TODO: fix
      //tooltip.css('display', 'none');
      tooltip.css('visibility', 'hidden');
    }

    function moveTooltip(d, i) {
      var tooltip = $element.find('.activity-graph-tooltip');
      tooltip.css('left', d3.event.pageX - 100 + 'px');
      tooltip.css('top', d3.event.pageY - 50 + 'px');
    }

    function showUserTooltip(d, i) {
      if (!d._id) return hideTooltip();

      var tooltip = $element.find('.activity-graph-tooltip');
      var user = getUserById(parseInt(d.cookie_segment.user_id));

      if (!user) return hideTooltip();

      var tooltipText = tooltip.find('.activity-graph-tooltip-text');
      tooltipText.html('\n        <div></div>\n        <div>\n          ' + moment(d.opened_at).format('YYYY-MM-DD HH:mm') + ' \n          (' + WEEKDAYS[moment(d.opened_at).day()] + ')\n        </div>\n        <div>\n          ' + moment(d.closed_at).format('YYYY-MM-DD HH:mm') + '\n          (' + WEEKDAYS[moment(d.closed_at).day()] + ')\n        </div>\n      ');
      // names are set by project users, so set them as text, not HTML
      tooltipText.children().first().text(user.full_name);
      // TODO: fix
      //tooltip.css('display', 'block');
      tooltip.css('visibility', 'visible');
    }

    function showCampaignTooltip(d, i) {
      var tooltip = $element.find('.activity-graph-tooltip');
      var tooltipText = tooltip.find('.activity-graph-tooltip-text');
      tooltipText.html('\n        <div></div>\n        <div>\n          ' + moment(d.start_at).format('YYYY-MM-DD HH:mm') + '\n          (' + WEEKDAYS[moment(d.start_at).day()] + ')\n        </div>\n        <div>\n          ' + moment(d.end_at).format('YYYY-MM-DD HH:mm') + '\n          (' + WEEKDAYS[moment(d.end_at).day()] + ')\n        </div>\n      ');
      // names are set by project users, so set them as text, not HTML
      tooltipText.children().first().text(d.name);
      // TODO: fix
      //tooltip.css('display', 'block');
      tooltip.css('visibility', 'visible');
    }

    function setupCampaignTooltip(group) {
      group.on('mouseenter', showCampaignTooltip).on('mousemove', moveTooltip).on('mouseleave', hideTooltip);
    }

    function setupUserTooltip(group) {
      group.on('mouseenter', showUserTooltip).on('mousemove', moveTooltip).on('mouseleave', hideTooltip);
    }

    function addWeekends(group) {
      var startTime = moment().subtract(DAYS, 'days').toDate();
      var weekends = [];
      for (var i = 0; i < DAYS; i++) {
        var day = moment(startTime).add(i, 'days');
        var dayOfWeek = day.day();
        // sunday or saturday
        if (dayOfWeek === 0 || dayOfWeek === 6) {
          weekends.push(day.toDate());
        }
      }

      group.selectAll('.weekend').data(weekends).enter().append('rect').attr('class', 'weekend').attr('x', function (d) {
        return xScale(moment(d).valueOf());
      }).attr('y', MARGINY).attr('width', function (d) {
        var oneDayLater = moment(d).add(1, 'days').valueOf();
        var now = moment(d).valueOf();
        return xScale(oneDayLater) - xScale(now);
      }).attr('height', LINE_HEIGHT).style('stroke-width', 1).style('stroke', 'rgba(0,0,0,0.2)').style('fill', 'rgba(255,128,0,0.1)').style('pointer-events', 'stroke');
    }

    function createGraph() {
      if (!vm.project.campaigns) vm.project.campaigns = [];

      // update width
      width = $element.parent().width() - margin.left - margin.right;

      svg.attr('width', width + margin.left + margin.right).attr('height', height + margin.top + margin.bottom).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

      var sessions = _.chain(vm.project.users).filter(function (user) {
        return user.sessions;
      }).map(function (user) {
        return user.sessions;
      }).flatten().filter(function (session) {
        return session.opened_at;
      }).value();

      createScales();

      svg.selectAll('*').remove();

      var projectGrp = svg.selectAll('.project-group').data(vm.project.users).enter().append('g').attr('y', function (d) {
        return yScale(d.id);
      }).attr('class', 'project-group');

      var campaignGrp = svg.selectAll('.campaign-group').data(vm.project.campaigns).enter().append('g').attr('y', LINE_HEIGHT).attr('class', 'campaign-group');

      campaignGrp.call(addCampaigns);

      projectGrp.call(addTextLabels);

      svg.call(addWeekends);
      svg.call(addOuterBox);

      svg.selectAll('.session').data(sessions).enter().append('g').attr('y', function (d) {
        return yScale(d);
      }).call(addSession);
    }
  }
});

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsProjectsInInstallation', {
  templateUrl: '/templates/zenclerk_s/directives/projects_in_installation/projects_in_installation.html',
  bindings: {
    projects: '<'
  },
  controller: zcsProjectsInInstallationController
});

zcsProjectsInInstallationController.$inject = ['$q', 'AgencyProject'];
function zcsProjectsInInstallationController($q, AgencyProject) {
  var vm = this;
  vm.statuses = AgencyProject.projectStatuses;
  vm.projectsWithoutCampaign = undefined;

  vm.$onChanges = function (changes) {

    // if there are no projects (first onChanges call), don't show anything
    if (!vm.projects || vm.projects.length === 0) {
      return;
    }

    vm.projectsWithoutCampaign = _.filter(vm.projects, function (p) {
      return p.status < 6;
    }).length;
  };
}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsProjectsWithoutCampaign', {
  templateUrl: '/templates/zenclerk_s/directives/projects_without_campaign/projects_without_campaign.html',
  bindings: {
    projects: '='
  },
  controllerAs: 'vm',
  controller: ZcsProjectsWithoutCampaignController
});

ZcsProjectsWithoutCampaignController.$inject = ['$scope', 'Campaign'];
function ZcsProjectsWithoutCampaignController($scope, Campaign) {
  var vm = this;

  $scope.$watch('vm.projects', activate);

  function activate() {
    _.map(vm.projects, function (project) {
      Campaign.all({ projectId: project.id }).then(function (campaigns) {
        project.activeCampaigns = _.chain(campaigns).filter(function (campaign) {
          return moment().isBefore(moment(campaign.end_at)) && campaign.status === 'activated';
        }).value();

        project.lastEndedCampaign = _.chain(campaigns).filter(function (campaign) {
          return moment().isAfter(moment(campaign.end_at));
        }).sort(function (campaign) {
          return -moment(campaign.end_at).valueOf();
        }).head().value();
      });
    });
  }
}

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsRealtimeBarChart', {
  templateUrl: '/templates/zenclerk_s/directives/realtime/bar-chart.html',
  bindings: {
    /** data should be in following format:
     * [
     *   {
     *      start: Date,
     *      end: Date,
     *      historyCount: Number
     *   }
     * ]
     */
    data: '<',
    showDataMinutes: '<',
    isPaused: '<',
    project: '<'
  },
  controller: zcsRealtimeBarChartController
});

zcsRealtimeBarChartController.$inject = ['$document', '$translate', '$element', '$interval', '$scope', '$timeout'];
function zcsRealtimeBarChartController($document, $translate, $element, $interval, $scope, $timeout) {
  var vm = this;
  var region = vm.project.region;
  var SHOW_DATA_MINUTES = vm.showDataMinutes || 30;
  var HEIGHT = 150;
  var REDRAW_INTERVAL = 2000;
  var paddingBottom = 20;
  var paddingLeft = 20;
  var paddingRight = 20;
  var normalFill = 'rgba(29, 213, 163, 0.5)';
  var activeFill = 'rgba(29, 153, 124, 0.5)';
  var WIDTH = 280;
  var svg = void 0;
  var xScale = void 0;
  var yScale = void 0;
  var xAxis = void 0;
  var tooltip = void 0;
  var redrawInterval = void 0;
  var isInitialized = false;
  var renderedOnceAfterPause = false;

  vm.$onInit = onInit;
  vm.$onChanges = onChanges;

  function onInit() {
    $timeout(function () {
      WIDTH = $element.parent().width();
      createSvg();
      isInitialized = true;
      if (vm.data) {
        onChanges();
      }
    });

    $document.on('resize', function () {
      WIDTH = $element.width();
      createSvg();
    });

    $scope.$on('$destroy', function () {
      $interval.cancel(redrawInterval);
    });
  }

  function onChanges(obj) {
    var currentValue = _.get(obj, 'data.currentValue', 0);
    var previousValue = _.get(obj, 'data.previousValue', 1);
    var valuesDiffer = !_.isEqual(currentValue, previousValue);
    if (isInitialized && vm.data && valuesDiffer) {
      if (vm.isPaused && renderedOnceAfterPause) {
        return;
      }

      updateBars();

      // Prevent generating more and more intervals
      if (!redrawInterval) {
        redrawInterval = $interval(function () {
          if (vm.isPaused) {
            $interval.cancel(redrawInterval);
            redrawInterval = null;
            return;
          }

          renderedOnceAfterPause = false;
          vm.currentTime = moment.tz(region).add(1, 'minute').startOf('minute').toDate();

          updateBars();
        }, REDRAW_INTERVAL);
      }
    }
  }

  function createSvg() {
    if (!svg) {
      svg = d3.select($element.find('.realtime-bar-chart')[0]);
    }

    svg.attr('height', HEIGHT).attr('width', WIDTH);
    xScale = d3.scale.linear().range([WIDTH - paddingRight, paddingLeft]);
    yScale = d3.scale.linear().range([0, HEIGHT - paddingBottom]);

    xAxis = d3.svg.axis().scale(xScale).orient('bottom').tickValues([1, 0]).tickFormat(function (d) {
      if (d === 1) {
        return $translate.instant('directives.common.minutesAgo', { minute: SHOW_DATA_MINUTES });
      } else if (d === 0) {
        return $translate.instant('directives.common.now');
      }
      return d;
    });

    svg.append('g').attr('transform', 'translate(0,' + (HEIGHT - paddingBottom) + ')').attr('class', 'axis').call(xAxis);

    createTooltip();
  }

  function createTooltip() {
    tooltip = $('<div class="nvtooltip" style="display:none"></div>');
    $element.find('.realtime-bar-chart-container').append(tooltip);
  }

  function showTooltip(d) {
    var pos = d3.mouse(this);
    var x = pos[0];
    var y = pos[1];
    var yOffset = 10;
    var xOffset = 30;

    tooltip.html('\n      <table>\n        <thead>\n          <tr>\n            <td colspan="3">' + moment(d.start).format('HH:mm') + ' ~ ' + moment(d.end).format('HH:mm') + '</td>\n          </tr>\n        </thead>\n        <tbody>\n          <tr>\n            <td class="legend-color-guide">\n              <div style="background-color:' + normalFill + '"></div>\n            </td>\n            <td class="key">' + $translate.instant('directives.realtime.barChart.numberOfPageViews') + '</td>\n            <td class="value">' + d.historyCount + '</td>\n          </tr>\n        </tbody>\n      </table>\n    ');

    var chartContainerWidth = $element.find('.realtime-bar-chart-container').width();
    var borderWidth = 2; //left border px + right border px
    var tooltipWidth = $element.find('.realtime-bar-chart-container .nvtooltip').innerWidth() + borderWidth;

    if (x + tooltipWidth > chartContainerWidth) {
      xOffset = -tooltipWidth;
    }

    tooltip.css('left', x + xOffset + 'px').css('top', y - yOffset + 'px').css('opacity', 1).css('display', 'block');
  }

  function hideTooltip(e) {
    tooltip.text('');
    tooltip.css('display', 'none');
  }

  function updateBars() {
    xScale.domain([0, (SHOW_DATA_MINUTES + 1) * 60]);
    var historyCounts = _.map(vm.data, function (d) {
      return d.historyCount;
    });
    yScale.domain([0, _.max(historyCounts)]);

    var historyCountBars = svg.selectAll('.bar-history-count').data(vm.data, function (d) {
      return d.end;
    });

    // enter for new ones
    historyCountBars.enter().append('rect').attr('class', 'bar-history-count').style('fill', normalFill).style('stroke', 'rgb(29, 213, 163)').attr('x', function (d) {
      return xScale(moment.tz(vm.currentTime, region).diff(moment.tz(d.start, region), 'seconds'));
    }).attr('y', HEIGHT - paddingBottom).attr('width', function (d) {
      return (WIDTH - paddingLeft - paddingRight) / SHOW_DATA_MINUTES / 3 * 2;
    }).attr('height', 0).on('mouseover', showTooltip).on('mouseout', hideTooltip);

    // update
    historyCountBars.transition().duration(1000).delay(200).attr('x', function (d) {
      return xScale(moment.tz(vm.currentTime, region).diff(moment.tz(d.start, region), 'seconds'));
    }).attr('y', function (d) {
      if (HEIGHT - paddingBottom - yScale(d.historyCount) < 0) {
        return HEIGHT - paddingBottom;
      }
      return HEIGHT - paddingBottom - yScale(d.historyCount);
    }).attr('width', function (d) {
      return WIDTH / SHOW_DATA_MINUTES / 3 * 2;
    }).attr('height', function (d) {
      if (yScale(d.historyCount) < 0) {
        return 0;
      }
      return yScale(d.historyCount);
    }).style('fill', function (d, i) {
      if (i === 0) {
        return activeFill;
      }
      return normalFill;
    });

    if (vm.isPaused) {
      renderedOnceAfterPause = true;
    } else {
      renderedOnceAfterPause = false;
    }

    historyCountBars.exit().transition().duration(200).attr('height', 0).attr('y', HEIGHT - paddingBottom).transition().remove();
  }
}

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcRealtimeVisitorVisualizer', {
  templateUrl: '/templates/zenclerk_s/directives/realtime_visitor_visualizer/realtime_visitor_visualizer.html',
  bindings: {
    project: '<',
    hideSegments: '=',
    hideUsers: '='
  },
  controller: function controller($filter, $scope, $q, $timeout, $interval, MongoSession, SegmentMatcher, ZcsSegment, ZcsOemService) {
    var vm = this;
    var SINGLE_FETCH_TIME = 3000;
    var VISUAL_REFRESH_MS = 1000;
    var EXIT_IN_SECONDS = 180;
    var MONITOR_MINUTES = 60 * 24;
    var ROWS = 2;
    var MIN_PER_ROW = 14;

    // keepers for intervals
    var intervalForGetNew = void 0;
    var intervalForUpdateExisting = void 0;
    var intervalForRemoveCompletely = void 0;
    var intervalForVisualUpdate = void 0;
    var intervalForSegments = void 0;

    var apikey = vm.project.apikey;
    var region = vm.project.region;
    var elementWidth = $('.current-visitor-visualizer').width();
    var elementHeight = $('.current-visitor-visualizer').height();
    var hasStarted = false;
    var maxTime = void 0;
    var showPerRow = MIN_PER_ROW;
    var svgContainer = void 0;
    var visitorContainer = void 0;
    var xScale = 0;
    var yScale = 0;

    vm.ZcsOemService = ZcsOemService;
    vm.sessions = [];
    vm.conversions = [];
    vm.nonConversions = [];
    vm.segments = [];
    vm.segmentCounts = {};

    // actions
    vm.getSegmentLabel = getSegmentLabel;
    vm.getSegmentClass = getSegmentClass;
    vm.getSegmentGAOther = getSegmentGAOther;
    vm.percent2Em = percent2Em;

    vm.$onInit = function () {
      ZcsSegment.all(apikey).then(function (segments) {
        var promises = _.map(segments, function (s) {
          return ZcsSegment.getLatestStatsForSegment(s.id, apikey);
        });
        $q.all(promises).then(function (stats) {
          stats = _.flatten(stats);
          vm.segments = _.chain(segments).map(function (segment) {
            segment.stats = _.find(stats, function (stat) {
              return stat.campaign_segment_id === segment.id;
            });
            if (!segment.stats) {
              segment.stats = { session_count: 0 };
            }
            segment.segmentQuery = SegmentMatcher.createSegmentQuery(segment.mongo_query);
            return segment;
          }).sortBy(function (d) {
            return -d.stats.session_count;
          }).value();

          // TODO: now initializes here, but should use $onInit
          initializeGraph();
        });
      });

      $scope.$on('$destroy', function () {
        $interval.cancel(intervalForGetNew);
        $interval.cancel(intervalForUpdateExisting);
        $interval.cancel(intervalForRemoveCompletely);
        $interval.cancel(intervalForVisualUpdate);
        $interval.cancel(intervalForSegments);
      });
    };

    function initializeGraph() {

      getInitialVisitors();
      svgContainer = d3.select('.current-visitor-visualizer').append('svg');

      visitorContainer = svgContainer.append('g');

      svgContainer.attr('width', elementWidth).attr('height', elementHeight);

      createScales();

      intervalForVisualUpdate = $interval(update, VISUAL_REFRESH_MS);
    }

    function getSegmentForSession(session) {
      var hit = 'zcs_segment_all';
      var segmentsToConsider = _.chain(vm.segments).filter(function (d) {
        return isEnabledSegment(d);
      }).sortBy(function (d) {
        return -d.stats.session_count;
      }).value();
      _.each(segmentsToConsider, function (segment) {
        var result = SegmentMatcher.matchSessions(segment.segmentQuery, [session]);
        if (!session.segments) {
          session.segments = ['zcs_segment_all'];
        }
        if (result.length) {
          session.segments.unshift(segment.name);
          hit = segment.name;
        }
      });
      return hit;
    }

    function calculateSegments() {
      if (!hasStarted) {
        return;
      }
      var segmentCounts = {};

      var totalCount = vm.sessions.length + vm.conversions.length + vm.nonConversions.length;

      _.each(vm.segments, function (segment) {
        segmentCounts[segment.name] = _.filter(vm.sessions, function (d) {
          return _.includes(d.segments, segment.name);
        }).length;
        segmentCounts[segment.name] += _.filter(vm.conversions, function (d) {
          return _.includes(d.segments, segment.name);
        }).length;
        segmentCounts[segment.name] += _.filter(vm.nonConversions, function (d) {
          return _.includes(d.segments, segment.name);
        }).length;
      });

      _.each(_.keys(segmentCounts), function (key) {
        vm.segmentCounts[key] = segmentCounts[key] / totalCount * 100;
      });
    }

    function filterExcludedAndSupportStatusSessions(sessions) {
      return _.filter(sessions, function (d) {
        return !d.is_exclude && d.support_status === 'full';
      });
    }

    function getInitialVisitors() {
      var query = {
        apikey: apikey,
        opened_at: { $gte: moment().subtract(MONITOR_MINUTES, 'minutes').valueOf() }
      };

      intervalForGetNew = $interval(getNewVisitors, SINGLE_FETCH_TIME);
      intervalForUpdateExisting = $interval(updateExistingVisitors, SINGLE_FETCH_TIME);
      intervalForRemoveCompletely = $interval(removeCompletelyVisitors, SINGLE_FETCH_TIME);
      intervalForSegments = $interval(calculateSegments, 3000);

      // TODO: ugly, do something better :)
      // get 100 first so that we have something to show instantly
      var promise = MongoSession.find(query, {
        limit: 100,
        sort: { opened_at: -1 },
        cache: false,
        t: new Date().valueOf()
      }).then(function (res) {
        hasStarted = true;

        if (res.length > 0) {
          maxTime = _.maxBy(res, function (d) {
            return d.opened_at;
          }).opened_at;
        } else {
          maxTime = new Date();
        }

        return res;
      }).then(handleVisitors);

      promise = _.reduce([200, 200, 200, 200, 200, 200, 200, 200, 300, 1000, 2000, 5000, 10000], function (innerPromise, limit) {
        return innerPromise.then(function (lastTime) {
          if (!lastTime) {
            return $q.reject();
          }
          query.opened_at.$lt = $filter('changeDatetimeFrom')('localToRegion', lastTime, 'integer', region);
          return MongoSession.find(query, { limit: limit, sort: { opened_at: -1 }, ignoreLoadingBar: true, cache: false, t: new Date().valueOf() });
        }).then(handleVisitors);
      }, promise);

      return promise;
    }

    function handleVisitors(res) {
      return $q(function (resolve, reject) {
        var sessions = res || [];

        _.each(sessions, function (session) {
          getSegmentForSession(session);
        });

        sessions = moveEndedToExited(sessions);

        sessions = _.sortBy(sessions, function (d) {
          return d.opened_at;
        });

        // When doing `vm.sessions = xxx`, the visualizer updates and it does
        // not look nice...
        // So unless it's first time, do concat
        if (!vm.sessions.length) {
          vm.sessions = filterExcludedAndSupportStatusSessions(sessions);
        } else {
          vm.sessions.concat(filterExcludedAndSupportStatusSessions(sessions));
        }

        calculateSegments();
        if (!res.length) {
          return reject(undefined);
        }
        return resolve(_.last(res).opened_at);
      });
    }

    function isEnabledSegment(segment) {
      return ['zcs_segment_new', 'zcs_segment_cv_users', 'zcs_segment_all'].indexOf(segment.name) >= 0;
    }

    function getSegmentClass(segmentName) {
      if (!segmentName) {
        return 'zcs-segment-all';
      }
      return segmentName.replace(/_/g, '-');
    }

    function getSegmentLabel(segment) {
      return ZcsSegment.getSegmentLabel(segment.name);
    }

    // TBF! This returns the other Google Analytics Segment.. I guess
    function getSegmentGAOther() {
      return vm.segmentCounts.zcs_segment_all - vm.segmentCounts.zcs_segment_ga_new;
    }

    function getNewVisitors() {
      if (!hasStarted) {
        return;
      }
      var query = {
        apikey: apikey,
        opened_at: { $gt: maxTime }
      };

      MongoSession.find(query, { limit: 10000, cache: false, t: new Date().valueOf(), ignoreLoadingBar: true }).then(function (newSessions) {
        if (!newSessions || !newSessions.length) {
          return;
        }

        newSessions = filterExcludedAndSupportStatusSessions(newSessions);
        _.each(newSessions, function (newSession) {
          if (_.some(vm.sessions, function (session) {
            return session._id === newSession._id;
          })) return;
          var pushDelay = Math.random() * SINGLE_FETCH_TIME;
          getSegmentForSession(newSession);
          $timeout(function () {
            vm.sessions.push(newSession);
          }, pushDelay);
        });

        // Update open time only if there are new sessions
        if (newSessions.length) {
          maxTime = _.maxBy(newSessions, function (d) {
            return d.opened_at;
          }).opened_at;
        }
      });
    }

    function updateExistingVisitors() {
      if (!hasStarted) {
        return;
      }
      var ids = _.map(vm.sessions, function (d) {
        return d._id;
      });
      var idChunks = _.chunk(ids, 50);

      _.each(idChunks, function (idsInChunk) {
        var updateExistingQuery = {
          apikey: apikey,
          _id: { $in: idsInChunk }
        };

        MongoSession.find(updateExistingQuery, { limit: 10000, cache: false, t: new Date().valueOf(), ignoreLoadingBar: true }).then(function (existingSessions) {
          mergeSessions(existingSessions, vm.sessions);
          vm.sessions = moveEndedToExited(vm.sessions);
        });
      });
    }

    function removeCompletelyVisitors() {
      if (!hasStarted) {
        return;
      }
      vm.nonConversions = removeCompletely(vm.nonConversions);
    }

    function mergeSessions(fromSessions, toSessions) {
      _.each(fromSessions, function (d) {
        var idx = _.findIndex(toSessions, function (s) {
          return s._id === d._id;
        });
        if (idx) {
          toSessions[idx] = _.assignIn(toSessions[idx], d);
        }
      });
    }

    function moveEndedToExited(sessions) {
      var momentNow = $filter('changeDatetimeFrom')('regionToLocal', new Date(), 'moment', region);
      var sessionsToBeRemoved = _.filter(sessions, function (d, i) {
        var secondsFromClose = momentNow.diff(moment(d.closed_at), 'seconds');
        return d.closed_at !== null && secondsFromClose > EXIT_IN_SECONDS;
      });

      var afterRemovalSessions = _.reject(sessions, function (d, i) {
        return _.includes(sessionsToBeRemoved, d);
      });

      // push to past conversions also
      _.each(sessionsToBeRemoved, function (d) {
        if (d.conversion_count > 0) {
          vm.conversions.push(d);
        } else {
          vm.nonConversions.push(d);
        }
      });

      return afterRemovalSessions;
    }

    function removeCompletely(sessions) {
      var momentNow = $filter('changeDatetimeFrom')('regionToLocal', new Date(), 'moment', region);
      return _.filter(sessions, function (d) {
        return d.closed_at === null || momentNow.diff(moment(d.closed_at), 'minutes') < MONITOR_MINUTES;
      });
    }

    function createScales() {
      showPerRow = d3.max([Math.ceil(vm.sessions.length / ROWS), MIN_PER_ROW]);
      xScale = d3.scale.linear().domain([0, showPerRow]).rangeRound([0, elementWidth]);
      yScale = d3.scale.linear().domain([0, ROWS]).range([0, elementHeight]);
    }

    function update() {
      createScales();

      var visitor = visitorContainer.selectAll('.visitor').data(vm.sessions, function (d) {
        return d._id;
      });

      // exit
      visitor.exit().transition('exit').duration(VISUAL_REFRESH_MS / 2).attr('transform', function (d, i) {
        return 'scale(0)';
      });

      // enter
      visitor.enter().append('g').attr('class', function (d) {
        return 'visitor ' + getSegmentClass(d.segments[0]) + '-fill';
      }).attr('data-usid', function (d) {
        return d._id;
      }).append('path').attr('d', 'M28.4108527,31.2693483 C31.53832,28.7662087 33.7466252,24.0221674 33.7466252,20.25 C33.7466252,14.8652237 32.2466252,9 23.9966252,9 C15.7466252,9 14.2466252,14.8652237 14.2466252,20.25 C14.2466252,24.029553 16.4635863,28.7847893 19.6007783,31.2840254 C15.3931617,32.1120234 10.8619795,33.6113023 10.8619795,33.6113023 C9.27149834,34.0951213 7.78742498,35.8273335 7.53817454,37.4646824 L7,41 C7,41 14.0104863,48 24.0052432,48 C34,48 41,41 41,41 L40.4675289,37.4646824 C40.2214808,35.831057 38.7424525,34.099987 37.1652794,33.6065459 C37.1652794,33.6065459 32.6584573,32.0929905 28.4108527,31.2693483 Z').attr('stroke', '#fff').attr('stroke-opacity', 0.5).attr('stroke-position', 'outside').attr('stroke-width', '1px').attr('opacity', setVisitorOpacity).attr('transform', 'scale(0)').transition('enter').duration(VISUAL_REFRESH_MS / 2).attr('transform', function (d, i) {
        return 'scale(1)';
      });
      // update
      visitor.transition().duration(VISUAL_REFRESH_MS / 2).attr('opacity', setVisitorOpacity).attr('transform', function (d, i) {
        var y = yScale(Math.floor(i / showPerRow));
        var x = xScale(i - showPerRow * Math.floor(i / showPerRow));
        return 'translate(' + x + ', ' + y + ')';
      });
    }

    function setVisitorOpacity(d) {
      var opacity = 1;
      if (d.closed_at !== null) {
        opacity = d3.min(1, 0.2 + moment().diff(moment(d.closed_at), 'seconds') / EXIT_IN_SECONDS);
      }
      return opacity;
    }

    //# Scale a percentage to a Css element size
    function percent2Em(percent) {
      var scaleSize = 35; // reduce the original percentage
      var scaleMin = 0.8; // minimum size
      var size = percent / scaleSize + scaleMin;
      return size.toFixed(1) + 'em';
    }
  }
});

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS').component('zcsServiceName', {
  template: '{{$ctrl.serviceName}}',
  controller: zcsServiceNameController
});

zcsServiceNameController.$inject = ['$scope', 'ZcsOemService'];
function zcsServiceNameController($scope, ZcsOemService) {
  var vm = this;

  vm.$onInit = function () {
    vm.ZcsOemService = ZcsOemService;
    $scope.$watch(function () {
      return ZcsOemService.getName();
    }, function (serviceName) {
      vm.serviceName = serviceName;
    });
  };
}

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS').component('svgEmbed', {
  template: '',
  bindings: {
    url: '<'
  },
  controller: svgEmbedController
});

// Expects <svg-embed><img src="xxx.svg"></svg-embed> syntax.
// This will embed the actual contents of the svg into html.
// Doing so will allow us to change colors etc.
svgEmbedController.$inject = ['$element', '$http', '$scope', 'Environment'];
function svgEmbedController($element, $http, $scope, Environment) {
  var _this = this;

  Environment.get().then(function (environment) {
    // TODO: GRR: angular tests are REALLY complex with the order of requests
    // and I just can't figure out why some tests fail,
    // so make it so that asset requests don't run on test env >_<
    if (environment === 'test') return;

    $scope.$watch(angular.bind(_this, function () {
      return this.url;
    }), function (newValue, oldValue) {
      if (newValue) {
        // Get the svg with html request and embed it directly.
        // If something goes wrong, the img is still there
        $http.get(newValue).then(function (res) {
          var $el = $(res.data);
          $element.html($el);
        }).catch(function (err) {
          $element.html('<img src="' + newValue + '">');
          console.error('Could not load ' + newValue);
        });
      }
    });
  });
}

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _magic_numbers = __webpack_require__(213);

var _magic_numbers2 = _interopRequireDefault(_magic_numbers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('zc.zenclerkS').component('zcsTrackingTagChecker', {
  templateUrl: '/templates/zenclerk_s/directives/tracking_tag_checker/tracking_tag_checker.html',
  bindings: {
    project: '<',
    // in setup page return should not be shown
    showReturn: '<',
    onComplete: '&'
  },
  controllerAs: 'vm',
  controller: ZcsTrackingTagCheckerController
}); /* globals d3,nv*/


ZcsTrackingTagCheckerController.$inject = ['$element', '$interval', '$rootScope', '$scope', '$state', '$timeout', 'Devise', 'MongoHistory', 'ZcsOemService'];
function ZcsTrackingTagCheckerController($element, $interval, $rootScope, $scope, $state, $timeout, Devise, MongoHistory, ZcsOemService) {
  var vm = this;

  var HISTORIES_TO_GET = 200;
  var colorPrimary = '#1DD5A3';
  var colorSecondary = '#775BD6';
  var colorTertiary = '#ff5c79';
  var DEFAULT_REQUIRED_HISTORIES = 5;
  var REQUIRED_HISTORIES = {
    makeshop: 1
  };

  var chart = void 0;

  // variables
  vm.histories = [];
  vm.listUrls = [];
  vm.showDetails = !vm.project.tracking_tag_confirmed_at;
  vm.showRaw = false;
  vm.isLoading = false;
  vm.errors = {
    noHistories: false,
    notEnoughSamples: false,
    notFoundPcOrTablet: false,
    notFoundSP: false
  };
  vm.interval = undefined;
  vm.lastHistoryAt = undefined;

  // actions
  vm.refresh = refresh;
  vm.complete = complete;
  vm.toggleDetails = toggleDetails;
  vm.toggleRaw = toggleRaw;
  vm.hasTagErrors = hasTagErrors;
  vm.goToNextStep = goToNextStep;

  vm.host = ZcsOemService.getPublishHostForProject(vm.project);

  this.$onInit = function () {
    // if there is limit for specific shopping cart, use it
    vm.currentRequiredHistories = DEFAULT_REQUIRED_HISTORIES;
    if (REQUIRED_HISTORIES[vm.project.shopping_cart_asp]) {
      vm.currentRequiredHistories = REQUIRED_HISTORIES[vm.project.shopping_cart_asp];
    }

    refresh();

    $scope.$on('$destroy', function () {
      stopIntervals();
    });
  };

  function refresh() {
    if (vm.isLoading) return;

    vm.isLoading = true;

    var fetchParams = {
      apikey: vm.project.apikey
    };

    if (vm.lastHistoryAt) {
      fetchParams.opened_at = {
        $gt: vm.lastHistoryAt
      };
    }

    vm.errors.noHistories = false;

    MongoHistory.find(fetchParams, {
      sort: {
        opened_at: -1
      },
      limit: HISTORIES_TO_GET
    }).then(function (historiesResult) {
      vm.histories = vm.histories.concat(historiesResult);

      if (vm.histories.length === 0) {
        vm.errors.noHistories = true;
        return;
      }

      vm.histories = _.chain(vm.histories).uniqBy(function (d) {
        return d._id;
      }).sortBy(function (d) {
        return -d.opened_at;
      }).value();

      // Take the last opened_at so that we don't get duplicates
      vm.lastHistoryAt = _.sortBy(vm.histories, function (d) {
        return -d.opened_at;
      })[0].opened_at;

      createDeviceGraph(vm.histories);

      var foundPcOrTablet = false;
      var foundSP = false;
      _.each(vm.histories, function (history) {
        if (history.device === 'pc' || history.device === 'tablet') foundPcOrTablet = true;
        if (history.device === 'sp') foundSP = true;
      });
      // because these are errors, make them be true
      vm.errors.notFoundPcOrTablet = !foundPcOrTablet;
      vm.errors.notFoundSP = !foundSP;

      vm.percentages = {
        pc: _.filter(vm.histories, function (history) {
          return history.device === 'pc';
        }).length / HISTORIES_TO_GET * 100,
        sp: _.filter(vm.histories, function (history) {
          return history.device === 'sp';
        }).length / HISTORIES_TO_GET * 100,
        tablet: _.filter(vm.histories, function (history) {
          return history.device === 'tablet';
        }).length / HISTORIES_TO_GET * 100
      };

      vm.urls = _.chain(vm.histories).groupBy(function (history) {
        return history.url;
      }).map(function (histories, url) {
        return { url: url, count: histories.length };
      }).value();

      // Do processing here instead of angular view filters to avoid flickering
      vm.listUrls = _.chain(vm.urls).sortBy(function (d) {
        return -d.count;
      }).take(10).value();

      // If there is cart specific limit, use it
      if (vm.urls.length < vm.currentRequiredHistories) {
        vm.errors.notEnoughSamples = true;
      }

      if (!vm.errors.noHistories && !vm.errors.notEnoughSamples) {
        complete();
      }
    }).finally(function () {
      vm.isLoading = false;

      // loop for new histories in the background
      if (!vm.interval) {
        vm.interval = $interval(refresh, _magic_numbers2.default.ZCLITE_TRACKING_TAG_AUTOCHECK_INTERVAL);
      }
    });
  }

  function hasTagErrors() {
    var hadErrors = false;

    _.each(vm.errors, function (v, k) {
      if (v) {
        hadErrors = true;
      }
    });

    return hadErrors;
  }

  function toggleRaw() {
    vm.showRaw = !vm.showRaw;
  }

  function toggleDetails() {
    vm.showDetails = !vm.showDetails;

    // update chart because it might be shown as too small if element was
    // hidden when it was created
    if (chart) {
      $timeout(chart.update, 100);
    }
  }

  function goToNextStep() {
    // no need to get more data (+ without this tests are difficult)
    stopIntervals();

    $state.go('zenclerkS.project.setup.conversionTag');
  }

  function complete() {
    if (!vm.project.tracking_tag_confirmed_at) {
      vm.onComplete();
      // emiting is required for settings pages
      $rootScope.$broadcast('trackingTagFound');
    }
  }

  function createDeviceGraph(histories) {
    var svgSelector = $element.find('.device-graph svg');
    svgSelector.html('');
    if (histories.length === 0) return;

    // create percentage per device
    var data = _.chain(histories).groupBy(function (d) {
      return d.device;
    }).map(function (v, k) {
      return { key: k, value: v.length / histories.length * 100 };
    }).value();

    nv.addGraph(function () {
      chart = nv.models.pieChart().x(function (d) {
        return d.key;
      }).y(function (d) {
        return d.value;
      }).labelType('percent').donut(true).donutRatio(0.35).color([colorPrimary, colorSecondary, colorTertiary]);

      chart.valueFormat(function (d) {
        return d3.format(',d')(d) + '%';
      });

      var svg = d3.select(svgSelector[0]);
      svg.datum(data).call(chart);

      nv.utils.windowResize(chart.update);

      return chart;
    });
  }

  function stopIntervals() {
    if (vm.interval) {
      $interval.cancel(vm.interval);
    }
  }
}

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS').directive('zcsHideWhenIntegrated', zcsHideWhenIntegrated);

zcsHideWhenIntegrated.$inject = ['$stateParams', 'Devise', 'ZcsProject'];
function zcsHideWhenIntegrated($stateParams, Devise, ZcsProject) {
  return {
    restrict: 'A',
    link: function link(scope, elem, attrs) {
      var className = 'hide-when-integrated';
      if (attrs.ngHide || attrs.ngShow) {
        console.warn(className + ' component contains ng-hide or ng-show attributes', elem);
      }

      elem.addClass(className);

      var apikey = $stateParams.apikey;

      if (!apikey) {
        return;
      }

      var integratedCarts = attrs.zcsHideWhenIntegrated.split(',');

      return Devise.getCurrentUser().then(function (user) {
        return ZcsProject.get(user.id, apikey);
      }).then(function (project) {
        if (integratedCarts.includes(project.integrated_with)) {
          return;
        }

        elem.removeClass(className);
      });
    }
  };
}

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').directive('zcsHideWhenOem', zcsHideWhenOem);

zcsHideWhenOem.$inject = ['ZcsOemService'];
function zcsHideWhenOem(ZcsOemService) {
  return {
    restrict: 'A',
    link: link
  };

  function link(scope, elem, attrs) {
    scope.ZcsOemService = ZcsOemService;

    if (attrs.ngHide || attrs.ngShow) {
      console.warn('hide-when-oem component contains ng-hide or ng-show attributes', elem);
    }

    var originalDisplayProperty = elem.css('display');
    scope.$watch('ZcsOemService.get()', function (oemService) {
      var displayProperty = oemService ? 'none' : originalDisplayProperty;
      elem.css({ display: displayProperty });
    });
  }
}

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsInvoiceNote', {
  templateUrl: '/templates/zenclerk_s/directives/zcs_invoice_note/zcs_invoice_note.html',
  bindings: {
    month: '<'
  },
  controller: zcsInvoiceNoteController
});

zcsInvoiceNoteController.$inject = ['ZcsOemService'];
function zcsInvoiceNoteController(ZcsOemService) {
  var vm = this;
  vm.$onInit = function () {
    vm.isMinimumCharge = moment(vm.month).isSameOrAfter(moment('2017-04-01'));
    vm.ZcsOemService = ZcsOemService;
  };
}

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsMaintenance', {
  templateUrl: '/templates/zenclerk_s/directives/zcs_maintenance/zcs_maintenance.html',
  controllerAs: 'vm',
  controller: zcsMaintenanceController
});

zcsMaintenanceController.$inject = ['ZcsOemService'];
function zcsMaintenanceController(ZcsOemService) {
  var vm = this;
  vm.$onInit = function () {
    vm.ZcsOemService = ZcsOemService;
  };
}

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsTagUnset', {
  templateUrl: '/templates/zenclerk_s/directives/zcs_tag_unset/zcs_tag_unset.html',
  bindings: {},
  controllerAs: 'vm',
  controller: ZcsTagUnsetController
});

ZcsTagUnsetController.$inject = ['$state', '$stateParams', 'Devise', 'ZcsProject'];
function ZcsTagUnsetController($state, $stateParams, Devise, ZcsProject) {
  var vm = this;
  ZcsProject.get(Devise.currentUser.id, $stateParams.apikey).then(function (project) {
    vm.project = project;
    vm.trackingTagSettingPage = $state.href('zenclerkS.project.tags.tracking', { projectId: project.project_id });
    vm.conversionTagSettingPage = $state.href('zenclerkS.project.tags.conversion', { projectId: project.project_id });

    if (project.tracking_tag_confirmed_at && project.conversion_tag_confirmed_at) {
      $state.go('zenclerkS.project.dashboard', { apikey: project.apikey });
    }
  });
}

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsHomeController', ZcsHomeController);

ZcsHomeController.$inject = ['$location', '$state', 'Agency', 'Devise', 'agencies', 'projects'];
function ZcsHomeController($location, $state, Agency, Devise, agencies, projects) {
  var vm = this;

  vm.$onInit = function () {
    // add a same filter field for agencies and projects
    _.each(agencies, function (a) {
      a._isAgency = true;
      a._isTerminated = false;
      a._isInstalled = true;
      a._filterText = a.name + ' ' + a.title;
    });
    _.each(projects, function (p) {
      p._filterText = p.apikey + ' ' + p.title + ' ' + p.base_url + ' ' + p.company_name;
      p._isTerminated = p.is_terminated;
      p._isInstalled = false;
      if (p.installed_at) {
        p._isInstalled = true;
      }
      if (p.is_demo) {
        p._isInstalled = true;
      }
    });

    // variables
    vm.projects = [];
    vm.demoProjects = [];
    vm.testProjects = [];
    vm.agencies = agencies;
    vm.all = agencies.concat(projects);
    vm.menu = $location.search().type || 'all';
    vm.items = vm[vm.menu];
    vm.filterInput = '';
    vm.limit = '50';
    vm.showTerminatedOnly = false;
    vm.showNotInstalledOnly = false;

    // actions
    vm.getAgencyColor = Agency.getAgencyColor;
    vm.signOut = Devise.signOut;
    vm.isNew = isNew;
    vm.selectType = selectType;
    vm.goTo = goTo;

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = projects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var project = _step.value;

        if (project.is_demo) {
          vm.demoProjects.push(project);
        } else if (project.is_test) {
          vm.testProjects.push(project);
        } else if (project.apikey) {
          vm.projects.push(project);
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  };

  function selectType(type) {
    if (type === vm.menu) {
      vm.sortReverse = !vm.sortReverse;
    } else {
      vm.sortReverse = false;
    }

    vm.menu = type;
    vm.items = vm[type];
    if (type === 'all') {
      $location.search('type', null);
    } else {
      $location.search('type', type);
    }
  }

  function goTo(item) {
    if (item.apikey) {
      $state.go('zenclerkS.project.dashboard', { apikey: item.apikey });
    } else {
      $state.go('zenclerkS.agency.home', { agencyName: item.name });
    }
  }

  function isNew(createdAt) {
    if (moment().diff(moment(createdAt), 'days') < 15) {
      return true;
    }
    return false;
  }
}

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsFooter', {
  templateUrl: '/templates/zenclerk_s/layout/footer.html',
  controllerAs: 'vm',
  controller: zcsFooter
});

zcsFooter.$inject = [];

function zcsFooter() {}

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsHeader', {
  templateUrl: '/templates/zenclerk_s/layout/header.html',
  controllerAs: 'vm',
  controller: zcsHeader
});

zcsHeader.$inject = ['$document', '$element', '$scope', '$state', '$stateParams', 'Agency', 'Devise', 'ProjectUser', 'ZcsLayout', 'ZcsOemService', 'ZcsProject'];

function zcsHeader($document, $element, $scope, $state, $stateParams, Agency, Devise, ProjectUser, ZcsLayout, ZcsOemService, ZcsProject) {
  var vm = this;

  vm.$onInit = function () {

    // variables
    vm.project = {};
    vm.$stateParams = $stateParams;
    vm.apikey = $stateParams.apikey;
    vm.agencyTitle = '';
    vm.agencyName = '';
    vm.thisMonth = moment().format('YYYY-MM');
    vm.lastMonth = moment().subtract(1, 'month').format('YYYY-MM');
    vm.currentUser = null;
    vm.notification = {
      setting: 0
    };
    vm.state = {
      profile: false,
      profileMenu: false
    };
    // actions
    vm.logout = Devise.signOut;
    // Style & animation
    // ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
    // Set class for navigation menu
    vm.isGroup = isGroup;
    vm.isCategory = isCategory;
    vm.toggleProfile = toggleProfile;
    vm.toggleProfileMenu = toggleProfileMenu;
    vm.toggleNotificationsPanel = toggleNotificationsPanel;
    vm.ZcsOemService = ZcsOemService;

    // Project
    // ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
    $scope.$on('projectUpdated', function (event, project) {
      return updateProject(project);
    });

    $scope.$watch('vm.$stateParams', function (newval) {
      var apikey = _.get(newval, 'apikey');
      if (apikey) {
        Devise.getCurrentUser().then(function (currentUser) {
          return ZcsProject.get(currentUser.id, newval.apikey);
        }).then(function (newProject) {
          return updateProject(newProject);
        });
        vm.apikey = apikey;
      }
    }, true);

    // Modal
    // ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
    $document.on('keydown', closeProfile);

    // Close the menu when clicking outside it
    $document.on('click', clickHandler);

    // Profile
    // ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
    getProfileInfo();

    // Listen to event which is emitted when user updates the profile
    $scope.$on('userInfoUpdated', getProfileInfo);
  };

  this.$onDestroy = function () {
    $document.off('click', clickHandler);
    $document.off('keydown', closeProfile);
  };

  function calculateTagTasksLeft() {
    vm.tagTasksLeft = 0;
    if (!vm.project.tracking_tag_confirmed_at) {
      vm.tagTasksLeft += 1;
    }
    if (!vm.project.conversion_tag_confirmed_at) {
      vm.tagTasksLeft += 1;
    }
    vm.notification.setting += vm.tagTasksLeft;
  }

  function updateProject(newProject) {
    vm.project = _.merge(vm.project, newProject);

    getAgencyTitle(vm.project);

    calculateTagTasksLeft();

    ProjectUser.all($stateParams.apikey).then(function (users) {
      vm.projectUsers = users;
      // Build notification
      if (!vm.project.average_conversion_price) {
        vm.notification.setting += 1;
      }
      if (_.get(vm, 'projectUsers.length') === 0) {
        vm.notification.setting += 1;
      }
    });
  }

  function isGroup(group) {
    return _.get($state.current, 'data.group') === group;
  }

  function isCategory(category) {
    return _.get($state.current, 'data.category') === category;
  }

  function toggleProfile() {
    vm.state.profile = !vm.state.profile;
    $('body').toggleClass('modal-open'); // prevent scrolling
    return true;
  }

  // close modal with escape
  function closeProfile(e) {
    if (e.which === 27 && vm.state.profile) {
      vm.toggleProfile();
      $scope.$apply();
    }
  }
  function getProfileInfo() {
    Devise.getCurrentUser().then(function (currentUser) {
      vm.currentUser = currentUser;
    });
  }

  // Toogle the profile menu
  function toggleProfileMenu() {
    vm.state.profileMenu = !vm.state.profileMenu;
    return true;
  }

  function getAgencyTitle(project) {
    Agency.all().then(function (agencies) {
      var agency = _.find(agencies, function (d) {
        return d.id === project.agency_id;
      });
      if (agency) {
        vm.agencyTitle = agency.title;
        vm.agencyName = agency.name;
      }
    });
  }

  function clickHandler(e) {
    $scope.$apply(function () {
      if (!$element[0].contains(e.target) && vm.state.profileMenu) {
        vm.state.profileMenu = !vm.state.profileMenu;
      }
    });
  }

  function toggleNotificationsPanel() {
    ZcsLayout.isSidebarVisible = !ZcsLayout.isSidebarVisible;
  }
}

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcLayout', {
  templateUrl: '/templates/zenclerk_s/layout/layout.html',
  controllerAs: 'vm',
  controller: zcLayout
});

zcLayout.$inject = ['$translate', 'Devise', 'Environment', 'FeatureNotification', 'ZcsOemService'];
function zcLayout($translate, Devise, Environment, FeatureNotification, ZcsOemService) {
  var vm = this;
  var originalRole = void 0,
      originalAgencyId = void 0;

  this.$onInit = function () {
    vm.showMakerepeaterAdminBanner = true;

    Environment.get().then(function (environment) {
      vm.environment = environment;
    });

    Devise.getCurrentUser().then(function (currentUser) {
      vm.currentUser = currentUser;
      vm.currentLanguage = $translate.use();
    });

    vm.oemService = ZcsOemService.get();
    vm.setOemService = setOemService;
    vm.resetAllNotifications = resetAllNotifications;
    vm.toggleRole = toggleRole;
    vm.getCurrentRole = getCurrentRole;
    vm.availableLanguage = $translate.getAvailableLanguageKeys();
    vm.setLanguage = setLanguage;
  };

  function resetAllNotifications() {
    FeatureNotification.resetAll().then(function () {
      Devise.currentUser.read_notifications = [];
    });
  }

  function toggleRole() {
    // This only changes the looks on the screen, but might not restrict
    // the user from going to other pages
    if (!originalRole || Devise.currentUser.role === 'master') {
      originalRole = Devise.currentUser.role;
      Devise.currentUser.role = 'common';
    } else {
      Devise.currentUser.role = originalRole;
    }

    if (!_.isUndefined(originalAgencyId)) {
      originalAgencyId = Devise.currentUser.agency_id;
      Devise.currentUser.agency_id = null;
    } else {
      Devise.currentUser.agency_id = originalAgencyId;
    }
  }

  function getCurrentRole() {
    return _.get(Devise.currentUser, 'role', '');
  }

  function setOemService(oemService) {
    ZcsOemService.set(oemService);
    vm.oemService = oemService;
  }

  function setLanguage(lang) {
    $translate.use(lang);
    vm.currentLanguage = lang;
  }
}

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsMain', {
  templateUrl: '/templates/zenclerk_s/layout/main.html',
  controllerAs: 'vm',
  controller: zcsMain
});

function zcsMain() {}

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsMenuSetup', {
  templateUrl: '/templates/zenclerk_s/layout/menu_setup.html',
  controllerAs: 'vm',
  controller: zcsMenuSetup
});

zcsMenuSetup.$inject = ['$scope', '$state', '$stateParams', 'Devise', 'ZcsProject'];
function zcsMenuSetup($scope, $state, $stateParams, Devise, ZcsProject) {
  var vm = this;
  vm.project = {};
  vm.$stateParams = $stateParams;
  vm.apikey = $stateParams.apikey;

  // TODO: make directive
  vm.isActive = isActive;

  $scope.$watch('vm.$stateParams', function (newval) {
    if (!newval || !newval.apikey) {
      return;
    }
    Devise.getCurrentUser().then(function (currentUser) {
      return ZcsProject.get(currentUser.id, newval.apikey);
    }).then(function (res) {
      vm.project = res;
      vm.project.url_clean = res.base_url.replace(/((http|https):\/\/)/g, '').replace(/\//g, '');
    });
    vm.apikey = newval.apikey;
  }, true);

  function isActive(category) {
    if (_.get($state.current, 'data.category') === category) {
      return true;
    }
    return false;
  }
}

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsSidebar', {
  templateUrl: '/templates/zenclerk_s/layout/sidebar.html',
  controllerAs: 'vm',
  controller: zcsSidebar
});
zcsSidebar.$inject = ['$document', '$location', '$scope', '$state', 'Devise'];
function zcsSidebar($document, $location, $scope, $state, Devise) {
  var vm = this;
  // variables
  vm.currentUser = null;
  vm.state = {
    modal: false
  };
  // actions
  vm.logout = Devise.signOut;
  vm.toggleModal = toggleModal;

  this.$onInit = function () {
    // close modal with escape
    $document.on('keydown', closeProfile);
    $scope.$on('$destroy', function () {
      return $document.off('keydown', closeProfile);
    });
  };

  this.$onDestroy = function () {
    $document.off('keydown', closeProfile);
  };

  // Modal
  // ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
  function toggleModal() {
    vm.state.modal = !vm.state.modal;
    $('body').toggleClass('modal-open'); // prevent scrolling
    return true;
  }

  function closeProfile(e) {
    if (e.which === 27 && vm.state.modal) {
      vm.toggleModal();
      $scope.$apply();
    }
  }
}

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

angular.module('zc.zenclerkS')

// TODO: can be deleted after 2017-04
.value('litePricingLaterPressed', {}).config(routerConfig);

routerConfig.$inject = ['$stateProvider'];
function routerConfig($stateProvider) {

  $stateProvider

  //#############################################################################
  //#
  //# 404 etc
  //#
  //#############################################################################
  .state('404', {
    url: '/404',
    views: {
      'content@': {
        templateUrl: '/templates/core/views/404.html'
      }
    }
  }).state('500', {
    url: '/500',
    views: {
      'content@': {
        templateUrl: '/templates/core/views/500.html'
      }
    }
  }).state('terms_of_service', {
    url: '/tos/admin',
    views: {
      'layout@': {
        templateUrl: '/templates/zenclerk_s/layout/layout_tos_header+main.html',
        controller: 'TosHeaderController',
        controllerAs: 'vm',
        resolve: {
          languages: function languages() {
            return [{
              id: 'en',
              label: 'English'
            }, {
              id: 'ja',
              label: '日本語'
            }, {
              id: 'zh',
              label: '中文'
            }];
          }
        }
      },
      'mainContent@terms_of_service': {
        templateUrl: '/templates/core/views/tos.html',
        controller: 'TosController',
        controllerAs: 'vm'
      }
    }
  }).state('privacy_policy', {
    url: '/privacy_policy',
    views: {
      'layout@': {
        templateUrl: '/templates/zenclerk_s/layout/layout_tos_header+main.html',
        controller: 'TosHeaderController',
        controllerAs: 'vm',
        resolve: {
          languages: function languages() {
            return [{
              id: 'en',
              label: 'English'
            }, {
              id: 'ja',
              label: '日本語'
            }];
          }
        }
      },
      'mainContent@privacy_policy': {
        templateUrl: '/templates/core/views/privacy_policy.html',
        controller: 'PrivacyPolicyCtrl'
      }
    }
  }).state('users', {
    abstract: true,
    url: '/users'
  }).state('users.signIn', {
    url: '/sign_in',
    views: {
      'layout@': {
        templateUrl: '/templates/zenclerk_s/layout/layout_main.html'
      },
      'mainContent@users.signIn': {
        templateUrl: '/templates/zenclerk_s/users/sign_in/sign_in.html',
        controller: 'UsersSignInController',
        controllerAs: '$ctrl'
      }
    },
    beforeAction: function beforeAction(ZcsOemService, afterLoginHandler, currentUser, toState) {
      // oem service should not show sign in because it uses single sign on
      if (toState.name === 'users.signIn' && ZcsOemService.isOemService()) {
        return afterLoginHandler.handle(currentUser, { forceReload: true });
      }
      return true;
    }
  }).state('users.invitation', {
    abstract: true,
    url: '/invitation'

  }).state('users.invitation.accept', {
    url: '/accept?invitation_token',
    views: {
      'layout@': {
        templateUrl: '/templates/zenclerk_s/layout/layout_main.html'
      },
      'mainContent@users.invitation.accept': {
        templateUrl: '/templates/zenclerk_s/users/invitation/accept.html',
        controller: 'AcceptInvitationController',
        controllerAs: 'vm'
      }
    },
    resolve: {
      invitedUser: function invitedUser($state, $stateParams, Devise) {
        return Devise.validateInvitationToken($stateParams.invitation_token).then(function (user) {
          if (!user) {
            return $state.go('users.signIn');
          }
          return user;
        });
      }
    }

  }).state('users.resetPassword', {
    url: '/password/edit?reset_password_token',
    views: {
      'layout@': {
        templateUrl: '/templates/zenclerk_s/layout/layout_main.html'
      },
      'mainContent@users.resetPassword': {
        templateUrl: '/templates/zenclerk_s/users/reset_password/reset_password.html',
        controller: 'ResetPasswordController',
        controllerAs: '$ctrl'
      }
    }

  }).state('zenclerkS', {
    url: '',
    abstract: true,
    resolve: {
      currentUser: function currentUser(Devise) {
        return Devise.getCurrentUser();
      },
      noFooter: function noFooter(Page, ZcsOemService) {
        Page.setTitle(ZcsOemService.getName());
        Page.showFooter = false;
      }
    },
    beforeAction: function beforeAction($state, ZcsOemService, currentUser, toState) {
      if (!currentUser) {
        $state.go('users.signIn');
        return false;
      }

      if (ZcsOemService.isOemService()) {
        return true;
      }
      if (toState.name === 'zenclerkS.pricing') {
        return true;
      }
      if (toState.name === 'zenclerkS.setup.user') {
        return true;
      }

      if (!currentUser.userinfo_confirmed_at) {
        $state.go('zenclerkS.setup.user');
        return false;
      }
      return true;
    }
  }).state('zenclerkS.home', {
    url: '/home',
    beforeAction: function beforeAction($q, $state, Agency, ZcsProject, currentUser) {
      if (currentUser.role === 'master') {
        return true;
      }

      return $q.all([ZcsProject.all(currentUser.id), Agency.all()]).then(function () {
        // if has agency, go to agency home
        var _Array$from = Array.from(arguments.length <= 0 ? undefined : arguments[0]),
            _Array$from2 = _slicedToArray(_Array$from, 2),
            projects = _Array$from2[0],
            agencies = _Array$from2[1];

        if (agencies.length === 1) {
          $state.go('zenclerkS.agency.home', { agencyName: agencies[0].name });
          return false;
        }

        // if there is only one project, forward to that project's page
        if (projects.length === 1) {
          $state.go('zenclerkS.project.dashboard', { apikey: projects[0].apikey });
          return false;
        }
        return true;
      });
    },


    views: {
      'layout@': {
        templateUrl: '/templates/zenclerk_s/layout/layout_header+main.html',
        controller: function controller($scope, ZcsOemService) {
          $scope.ZcsOemService = ZcsOemService;
        }
      },
      'headerNavigation@zenclerkS.home': {
        controller: function controller($scope) {
          $scope.i18nHeader = 'home.title';
        }
      },
      'mainContent@zenclerkS.home': {
        templateUrl: '/templates/zenclerk_s/home/home.html',
        controllerAs: '$ctrl',
        controller: 'ZcsHomeController',
        resolve: {
          projects: function projects(ZcsProject, currentUser) {
            return ZcsProject.all(currentUser.id);
          },
          agencies: function agencies(Agency) {
            return Agency.all();
          }
        }
      }
    }
  }).state('zenclerkS.setup', {
    url: '/setup',
    abstract: true
  }).state('zenclerkS.setup.user', {
    url: '/users',
    views: {
      'layout@': {
        templateUrl: '/templates/zenclerk_s/layout/layout_header+main.html'
      },
      'mainContent@zenclerkS.setup.user': {
        templateUrl: '/templates/zenclerk_s/setup/setup_user.html',
        controller: 'SetupUserController',
        controllerAs: 'vm',
        resolve: {
          resolve: function resolve($state, ZcsOemService) {
            if (ZcsOemService.isOemService()) {
              return $state.go('zenclerkS.home');
            }
          }
        }
      }
    }
  }).state('zenclerkS.makerepeater', { url: '/makerepeater' }).state('zenclerkS.reload', { // should not have zenclerkS.project as its parent because resolved project may not be right
    url: '/sites/:apikey/reload',
    resolve: {
      // Resolve environment, so that it is fully get before actual redirect
      environment: function environment(Environment) {
        return Environment.get();
      },

      // cannot use beforeAction because it should be called before resolve
      // NOTE: require environment to be resolved first
      redirect: function redirect($stateParams, $state, $window, environment) {
        var url = $state.href('zenclerkS.project.dashboard', { apikey: $stateParams.apikey }, { absolute: true });
        return $window.location.replace(url);
      }
    }
  }).state('zenclerkS.project', {
    url: '/sites/:apikey',
    abstract: true,
    views: {
      'layout@': {
        templateUrl: '/templates/zenclerk_s/layout/layout_header+main.html',
        controller: function controller($scope, ZcsOemService) {
          $scope.ZcsOemService = ZcsOemService;
        }
      },
      'headerNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/site_navigation.html',
        controllerAs: '$ctrl',
        controller: 'ZcsSiteNavigationController'
      }
    },
    resolve: {
      project: function project($state, $stateParams, ZcsProject, currentUser) {
        return ZcsProject.get(currentUser.id, $stateParams.apikey);
      }
    },

    beforeAction: function beforeAction($state, Project, ZcsProject, ZcsOemService, currentUser, litePricingLaterPressed, toState, toParams) {
      if (toState.name.indexOf('zenclerkS.project.setup') === 0) {
        return true;
      }

      return ZcsProject.get(currentUser.id, toParams.apikey).then(function (project) {
        Project.currentProject = project;

        // Master and agency can do whatever they want, and not enter the setup flow
        if (currentUser.role === 'master' || currentUser.agency_id) return true;

        if (project.is_demo) {
          return true;
          // Do terminated checks first so that client does not go to setup when terminated
          // Makerepeater / OEM projects should not be affected by terminated
        } else if (!project.is_oem && project.terminated_at !== null && toState.name === 'zenclerkS.project.terminated') {
          return true;
        } else if (!project.is_oem && project.terminated_at !== null && toState.name.indexOf('zenclerkS.project.invoices') === 0) {
          return true;
        } else if (!project.is_oem && project.terminated_at !== null && toState.name === 'zenclerkS.project.incentives') {
          return true;
        } else if (!project.is_oem && project.terminated_at !== null && toState.name === 'zenclerkS.project.campaign.summary') {
          return true;
        } else if (!project.is_oem && project.terminated_at !== null && toState.name.indexOf('zenclerkS.project.campaigns') !== -1) {
          if (!toState.name.endsWith('finished')) {
            $state.go('zenclerkS.project.campaigns.finished', { apikey: toParams.apikey });
            return false;
          }

          return true;
        } else if (!project.is_oem && project.terminated_at !== null && moment(project.terminated_at).isBefore(moment())) {
          $state.go('zenclerkS.project.terminated', { apikey: toParams.apikey });
          return false;
          // When still in middle of setup
        } else if (!project.companyinfo_confirmed_at) {
          $state.go('zenclerkS.project.setup.company', { apikey: toParams.apikey });
          return false;
        } else if (!project.siteinfo_confirmed_at) {
          $state.go('zenclerkS.project.setup.site', { apikey: toParams.apikey });
          return false;
          // makerepeater should never see anything about pricing
        } else if (ZcsOemService.get() === 'makerepeater' || project.is_oem) {
          return true;
        } else if (!project.pricing_confirmed_at && !project.pricing_pre_201704_confirmed_at) {
          $state.go('zenclerkS.project.setup.pricing', { apikey: toParams.apikey });
          return false;
        }
        return true;
      });
    }
  }).state('zenclerkS.project.setup', {
    url: '/setup',
    abstract: true,
    views: {
      'layout@': {
        templateUrl: '/templates/zenclerk_s/layout/layout_header+main.html',
        controller: function controller($scope, ZcsOemService) {
          $scope.ZcsOemService = ZcsOemService;
        }
      },
      'headerNavigation@zenclerkS.project.setup': {
        controller: function controller($scope) {
          $scope.ZcsOemService = 'setup';
          $scope.i18nHeader = 'sites.setup.title';
        }
      },
      'mainContent@zenclerkS.project.setup': {
        templateUrl: '/templates/zenclerk_s/sites/setup/setup.html',
        controller: 'ZcsSetupController',
        controllerAs: 'vm'
      }
    },
    data: {
      category: 'setup'
    }
  }).state('zenclerkS.project.setup.company', {
    url: '/company',
    views: {
      'siteSetupView@zenclerkS.project.setup': {
        templateUrl: '/templates/zenclerk_s/sites/setup/setup_company.html',
        controller: 'ZcsSetupCompanyController',
        controllerAs: 'vm'
      }
    }
  }).state('zenclerkS.project.setup.site', {
    url: '/site',
    views: {
      'siteSetupView@zenclerkS.project.setup': {
        templateUrl: '/templates/zenclerk_s/sites/setup/setup_site.html',
        controller: 'ZcsSetupSiteController',
        controllerAs: 'vm'
      }
    }
  }).state('zenclerkS.project.setup.pricing', {
    url: '/pricing',
    views: {
      'siteSetupView@zenclerkS.project.setup': {
        templateUrl: '/templates/zenclerk_s/sites/setup/setup_pricing.html',
        controller: 'ZcsSetupPricingController',
        controllerAs: 'vm'
      }
    }
  }).state('zenclerkS.project.setup.trackingTag', {
    url: '/tracking_tag',
    views: {
      'siteSetupView@zenclerkS.project.setup': {
        templateUrl: '/templates/zenclerk_s/sites/setup/setup_tracking_tag.html',
        controller: 'ZcsSetupTrackingTagController',
        controllerAs: 'vm'
      }
    }
  }).state('zenclerkS.project.setup.conversionTag', {
    url: '/conversion_tag',
    views: {
      'siteSetupView@zenclerkS.project.setup': {
        templateUrl: '/templates/zenclerk_s/sites/setup/setup_conversion_tag.html',
        controller: 'ZcsSetupConversionTagController',
        controllerAs: 'vm'
      }
    }
  }).state('zenclerkS.project.setup.complete', {
    url: '/complete',
    views: {
      'siteSetupView@zenclerkS.project.setup': {
        templateUrl: '/templates/zenclerk_s/sites/setup/setup_complete.html'
      }
    }
  }).state('zenclerkS.project.terminated', {
    url: '/terminated',
    data: {
      group: 'terminated',
      category: 'terminated'
    },
    views: {
      'subNavigation@zenclerkS.project': {
        template: ''
      },
      'mainContent@zenclerkS.project': {
        template: '<zcs-terminated project="$resolve.project"></zcs-terminated>'
      }
    }
  }).state('zenclerkS.project.dashboard', {
    url: '',
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/activity/navigation.html'
      },
      'mainContent@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/dashboard/dashboard.html',
        controller: function controller($scope, $stateParams, project) {
          $scope.apikey = $stateParams.apikey;
          $scope.project = project;
          $scope.currentMonth = moment().format('YYYY-MM');
          // TODO: we don't have data until second day and after 4:40am with current
          // aggregation, so figure out a better way
          $scope.cumulativeConversionShowMonth = moment().subtract(1, 'days').subtract(5, 'hours').format('YYYY-MM');
        }
      }
    },
    resolve: {
      redirectIfTagUnset: function redirectIfTagUnset($state, project) {
        if (!project.conversion_tag_confirmed_at || !project.tracking_tag_confirmed_at) {
          $state.go('zenclerkS.project.tag_unset', { apikey: project.apikey });
          return;
        }
      }
    },
    data: {
      group: 'activity',
      category: 'dashboard'
    }
  }).state('zenclerkS.project.dashboardNew', {
    url: '/dashboard?force_mode', // TODO: make this '' after release
    params: {
      force_mode: {
        value: undefined
      }
    },
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/dashboard/navigation.html'
      },
      'mainContent@zenclerkS.project': {
        template: '<zcs-dashboard-main project="$resolve.project"></zcs-dashboard-main>'
      }
    },
    resolve: {
      redirectIfTagUnset: function redirectIfTagUnset($state, project) {
        if (!project.conversion_tag_confirmed_at || !project.tracking_tag_confirmed_at) {
          $state.go('zenclerkS.project.tag_unset', { apikey: project.apikey });
          return;
        }
      }
    },
    data: {
      group: 'dashboardNew',
      category: 'dashboardNew'
    }
  }).state('zenclerkS.project.analytics', {
    url: '/analytics',
    params: {
      force_mode: {
        value: undefined
      }
    },
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/activity/navigation.html'
      },
      'mainContent@zenclerkS.project': {
        template: '<zcs-analytics project="$resolve.project"></zcs-analytics>'
      }
    },
    data: {
      group: 'activity',
      category: 'analytics'
      // TODO: deprecate after new dashboard is released
      // This mode has just different top menu
    } }).state('zenclerkS.project.dashboardNewAnalytics', {
    url: '/analytics',
    params: {
      force_mode: {
        value: undefined
      }
    },
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/dashboard/navigation.html'
      },
      'mainContent@zenclerkS.project': {
        template: '<zcs-analytics project="$resolve.project"></zcs-analytics>'
      }
    },
    data: {
      group: 'dashboardNew',
      category: 'analytics'
    }
  }).state('zenclerkS.project.activity', {
    url: '/realtime',
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/activity/navigation.html'
      },
      'mainContent@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/activity/realtime/realtime.html',
        controller: function controller($scope, $stateParams, project) {
          $scope.apikey = $stateParams.apikey;
          $scope.project = project;
        }
      }
    },
    resolve: {
      redirectIfTagUnset: function redirectIfTagUnset($state, project) {
        if (!project.conversion_tag_confirmed_at || !project.tracking_tag_confirmed_at) {
          $state.go('zenclerkS.project.tag_unset', { apikey: project.apikey });
          return;
        }
      }
    },
    data: {
      group: 'activity',
      category: 'activity'
    }
  }).state('zenclerkS.project.reports', {
    url: '/reports',
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/activity/navigation.html'
      },
      'mainContent@zenclerkS.project': {
        template: '',
        controllerAs: 'vm',
        controller: function controller($state, $stateParams, project) {
          if ($state.current.name === 'zenclerkS.project.reports') {
            // subtract 1 day and 5 hours because until 2nd day morning 4:40, when
            // the aggregation runs, we have no data
            // TODO: this still leaves unknown window when there is no data between
            // 4:40am ~ 5am
            var goToMonth = void 0;
            if (project.is_terminated) {
              goToMonth = moment(project.terminated_at).format('YYYY-MM');
            } else {
              // body...
              goToMonth = moment().subtract(1, 'days').subtract(5, 'hours').format('YYYY-MM');
            }
            return $state.go('zenclerkS.project.report.show', { apikey: $stateParams.apikey, month: goToMonth });
          }
        }
      }
    },
    data: {
      group: 'activity',
      category: 'reports'
    }
  }).state('zenclerkS.project.report', {
    url: '/reports/:month',
    abstract: true
  }).state('zenclerkS.project.report.show', {
    url: '',
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/activity/navigation.html'
      },
      'mainContent@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/reports/show/report_show.html',
        controllerAs: 'vm',
        controller: 'ZcsReportShowController',
        resolve: {
          isDeemed: function isDeemed(project) {
            return project.invoice_calculation_type === 'deemed';
          },
          invoices: function invoices($stateParams, Campaign, Incentive, ZcsInvoice, isDeemed, project) {
            if (project.is_demo) {
              return ZcsInvoice.generateDemoData();
            }
            return Incentive.all(project.id).then(function (incentives) {
              return ZcsInvoice.find($stateParams.apikey, $stateParams.month);
            });
          }
        }
      }
    },
    data: {
      group: 'activity',
      category: 'reports'
    }
  }).state('zenclerkS.project.stats', {
    url: '/stats',
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/activity/navigation.html'
      },
      'mainContent@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/stats/list.html',
        controllerAs: 'vm',
        controller: function controller($state, $stateParams) {
          if ($state.current.name === 'zenclerkS.project.stats') {
            return $state.go('zenclerkS.project.stats.show', { apikey: $stateParams.apikey, month: moment().format('YYYY-MM') });
          }
        }
      }
    },
    data: {
      group: 'activity',
      category: 'stats'
    }
  }).state('zenclerkS.project.stats.show', {
    url: '/:month',
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/activity/navigation.html'
      },
      'mainContent@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/stats/site_stats_show.html',
        controllerAs: 'vm',
        controller: 'ZcsSiteStatsShowController'
      }
    },
    resolve: {
      stats: function stats($stateParams, MongoZcsDailyDiffStats, project) {
        return MongoZcsDailyDiffStats.find({ apikey: project.apikey, month: $stateParams.month }, { sort: { summarize_at: -1 }, limit: 1 }).then(function (res) {
          return res[0];
        });
      }
    },
    data: {
      group: 'activity',
      category: 'stats'
    }
  }).state('zenclerkS.project.campaigns', {
    url: '/campaigns',
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/campaigns/campaign_navigation.html',
        controllerAs: '$ctrl',
        controller: 'ZcsCampaignNavigationController'
      },
      'mainContent@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/campaigns/list/list.html',
        controller: 'ZcsCampaignsListController as vm'
      }
    },
    resolve: {
      redirectIfTagUnset: function redirectIfTagUnset($state, project) {
        if (!project.conversion_tag_confirmed_at || !project.tracking_tag_confirmed_at) {
          $state.go('zenclerkS.project.tag_unset', { apikey: project.apikey });
          return true;
        }
      },

      // require redirectIfTagUnset so that we don't redirect twice
      redirectIfNoPageTypes: function redirectIfNoPageTypes($state, project, campaigns, redirectIfTagUnset) {
        if (redirectIfTagUnset) {
          return false;
        }
        // If site has already had a campaign, do not redirect.
        if (campaigns.length > 0) {
          return false;
        }
        // This might be caused if we accidentally remove page type...

        // conversion is also required, but it is set automatically by conversion tag
        if (!project.has_necessary_zcs_page_types) {
          // Don't show maintenance page if project is_test!
          if (!project.is_test && !project.is_demo) {
            $state.go('zenclerkS.project.maintenance', { apikey: project.apikey });
          }
          return;
        }
      },
      campaigns: function campaigns(project, Campaign) {
        return Campaign.all({ projectId: project.id });
      }
    },

    beforeAction: function beforeAction($state, toState, toParams) {
      if (toState.name === 'zenclerkS.project.campaigns') {
        $state.go('zenclerkS.project.campaigns.active', toParams);
      }
      return true;
    },


    data: {
      group: 'campaigns',
      category: 'campaigns'
    }
  }).state('zenclerkS.project.campaigns.active', {
    url: '/active',
    views: {
      'campaignsList@zenclerkS.project.campaigns': {
        template: '<zcs-campaigns-list project="$resolve.project" filters="$resolve.activeFilters"></zcs-campaigns-list>'
      }
    },
    resolve: {
      activeFilters: function activeFilters(Campaign) {
        return Campaign.activeFilters();
      }
    },
    data: {
      group: 'campaigns',
      category: 'campaigns'
    }
  }).state('zenclerkS.project.campaigns.draft', {
    url: '/draft',
    views: {
      'campaignsList@zenclerkS.project.campaigns': {
        template: '<zcs-campaigns-list project="$resolve.project" filters="$resolve.incompleteFilters"></zcs-campaigns-list>'
      }
    },
    resolve: {
      incompleteFilters: function incompleteFilters(Campaign) {
        return Campaign.incompleteFilters();
      }
    },
    data: {
      group: 'campaigns',
      category: 'campaigns'
    }
  }).state('zenclerkS.project.campaigns.finished', {
    url: '/finished',
    views: {
      'campaignsList@zenclerkS.project.campaigns': {
        template: '<zcs-campaigns-list project="$resolve.project" filters="$resolve.pastFilters"></zcs-campaigns-list>'
      }
    },
    resolve: {
      pastFilters: function pastFilters(Campaign) {
        return Campaign.pastCampaignFilters();
      }
    },
    data: {
      group: 'campaigns',
      category: 'campaigns'
    }
  }).state('zenclerkS.project.campaign', {
    url: '/campaigns/:campaignId',
    abstract: true,
    resolve: {
      campaign: function campaign($state, $stateParams, Campaign, project) {
        if (!project.conversion_tag_confirmed_at || !project.tracking_tag_confirmed_at) {
          $state.go('zenclerkS.project.tag_unset', { apikey: project.apikey });
          return;
        }
        if ($stateParams.campaignId === 'new') {
          return {
            id: 'new',
            name: '',
            campaign_type: 'Coupon',
            status: 'incomplete',
            incentives: [],
            start_at_obj: {},
            end_at_obj: {},
            custom_css: '',
            element: {},
            incentive_draft: {
              name: '',
              discount_type: undefined,
              discount_price: undefined,
              discount_percent: undefined,
              is_free_shipping: false,
              has_price_limit: false,
              is_price_limit_tax_included: undefined,
              minimum_price: undefined
            }
          };
        }
        return Campaign.get({ projectId: project.id, campaignId: $stateParams.campaignId });
      }
    },
    data: {
      group: 'campaigns',
      category: 'campaigns'
    }
  }).state('zenclerkS.project.campaign.summary', {
    url: '/summary',
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/campaigns/campaign_navigation.html',
        controllerAs: '$ctrl',
        controller: 'ZcsCampaignNavigationController'
      },
      'mainContent@zenclerkS.project': {
        template: '<zcs-campaign-summary campaign="$resolve.campaign" project="$resolve.project"></zcs-campaign-summary>'
      }
    },
    data: {
      group: 'campaigns',
      category: 'campaigns'
    }
  }).state('zenclerkS.project.campaign.edit', {
    url: '/edit',
    views: {
      'layout@': {
        templateUrl: '/templates/zenclerk_s/layout/layout_main.html'
      },
      'mainContent@zenclerkS.project.campaign.edit': {
        template: '<zcs-campaign-edit project="$resolve.project" campaign="$resolve.campaign"><zcs-campaign-edit>'
      }
    },
    data: {
      group: 'campaigns',
      category: 'campaigns',
      hideMainHelp: 'true'
    }
  }).state('zenclerkS.project.campaign.edit.segment', {
    url: '/segment',
    views: {
      'campaignEditView@zenclerkS.project.campaign.edit': {
        template: '<zcs-campaign-edit-step-segment><zcs-campaign-edit-step-segment>'
      }
    },
    data: {
      group: 'campaigns',
      category: 'campaigns'
    }
  }).state('zenclerkS.project.campaign.edit.coupon', {
    url: '/coupon?segment',
    views: {
      'campaignEditView@zenclerkS.project.campaign.edit': {
        template: '<zcs-campaign-edit-step-coupon><zcs-campaign-edit-step-coupon>'
      }
    },
    data: {
      group: 'campaigns',
      category: 'campaigns'
    }
  }).state('zenclerkS.project.campaign.edit.design', {
    url: '/design',
    views: {
      'campaignEditView@zenclerkS.project.campaign.edit': {
        template: '<zcs-campaign-edit-step-design><zcs-campaign-edit-step-design>'
      }
    },
    data: {
      group: 'campaigns',
      category: 'campaigns'
    }
  }).state('zenclerkS.project.campaign.edit.delivery', {
    url: '/ai',
    views: {
      'campaignEditView@zenclerkS.project.campaign.edit': {
        template: '<zcs-campaign-edit-step-delivery lite-sampling-ranges="$resolve.liteSamplingRanges"><zcs-campaign-edit-step-delivery>'
      }
    },
    resolve: {
      liteSamplingRanges: function liteSamplingRanges(Meta) {
        return Meta.getLiteSamplingRanges();
      }
    },
    data: {
      group: 'campaigns',
      category: 'campaigns'
    }
  }).state('zenclerkS.project.campaign.edit.schedule', {
    url: '/schedule',
    views: {
      'campaignEditView@zenclerkS.project.campaign.edit': {
        template: '<zcs-campaign-edit-step-schedule><zcs-campaign-edit-step-schedule>'
      }
    },
    data: {
      group: 'campaigns',
      category: 'campaigns'
    }
  }).state('zenclerkS.project.campaign.edit.confirm', {
    url: '/confirm',
    views: {
      'campaignEditView@zenclerkS.project.campaign.edit': {
        template: '<zcs-campaign-edit-step-confirm><zcs-campaign-edit-step-confirm>'
      }
    },
    data: {
      group: 'campaigns',
      category: 'campaigns'
    }
  }).state('zenclerkS.project.interestWidget', {
    abstract: true,
    url: '/iw',
    data: {
      group: 'interestWidget',
      category: 'interestWidget'
    }
  }).state('zenclerkS.project.interestWidget.results', {
    url: '/results',
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/interest_widget/interest_widget_navigation.html',
        controllerAs: '$ctrl',
        controller: 'ZcsInterestWidgetNavigationController'
      },
      'mainContent@zenclerkS.project': {
        controller: function controller($state, $stateParams) {
          if ($state.current.name === 'zenclerkS.project.interestWidget.results') {
            var currentMonth = moment().subtract(1, 'days').format('YYYY-MM');
            return $state.go('zenclerkS.project.interestWidget.results.show', { apikey: $stateParams.apikey, month: currentMonth });
          }
        }
      }
    }
  }).state('zenclerkS.project.interestWidget.results.show', {
    url: '/:month',
    views: {
      'mainContent@zenclerkS.project': {
        template: '<zcs-interest-widget-results project="$resolve.project" month="$resolve.month"></zcs-interest-widget-results>',
        resolve: {
          month: function month($stateParams) {
            return $stateParams.month;
          }
        }
      }
    },
    data: {
      group: 'interestWidget',
      category: 'interestWidgetResults'
    }
  }).state('zenclerkS.project.interestWidget.settings', {
    url: '/settings',
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/interest_widget/interest_widget_navigation.html',
        controllerAs: '$ctrl',
        controller: 'ZcsInterestWidgetNavigationController'
      },
      'mainContent@zenclerkS.project': {
        template: '<zcs-interest-widget-settings project="project"></zcs-interest-widget-settings>',
        controller: function controller($scope, project) {
          $scope.project = project;
        }
      }
    },
    data: {
      group: 'interestWidget',
      category: 'interestWidgetSettings'
    }
  }).state('zenclerkS.project.incentives', {
    url: '/incentives',
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/campaigns/campaign_navigation.html',
        controllerAs: '$ctrl',
        controller: 'ZcsCampaignNavigationController'
      },
      'mainContent@zenclerkS.project': {
        template: '<zcs-coupon-history project="$resolve.project" shows-detail="true"></zcs-coupon-history>'
      }
    },
    data: {
      group: 'campaigns',
      category: 'incentives'
    }
  }).state('zenclerkS.project.integratedIncentives', {
    url: '/integratedIncentives',
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/campaigns/campaign_navigation.html',
        controllerAs: '$ctrl',
        controller: 'ZcsCampaignNavigationController'
      },
      'mainContent@zenclerkS.project': {
        template: '<zcs-integrated-coupon-list project="$resolve.project"></zcs-integrated-coupon-list>'
      }
    },
    data: {
      group: 'campaigns',
      category: 'integratedIncentives'
    }
  }).state('zenclerkS.project.invoices', {
    abstract: true,
    url: '/invoices',
    data: {
      group: 'invoices',
      category: 'invoices'
    }
  }).state('zenclerkS.project.invoices.list', {
    url: '',
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/invoices/navigation.html'
      },
      'mainContent@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/invoices/list/invoices_list.html',
        controller: 'ZcsInvoicesController as vm'
      }
    },
    resolve: {
      invoices: function invoices(ZcsInvoice, project) {
        return ZcsInvoice.all(project.apikey);
      }
    },
    data: {
      group: 'invoices',
      category: 'invoices'
    }
  }).state('zenclerkS.project.invoices.show', {
    url: '/:term',
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/invoices/navigation.html'
      },
      'mainContent@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/invoices/show/invoice.html',
        controllerAs: 'vm',
        controller: 'ZcsInvoiceShowController'
      }
    },
    resolve: {
      month: function month($stateParams) {
        return moment($stateParams.term, 'YYYY-MM');
      },
      invoice: function invoice($state, $stateParams, ZcsInvoice, project) {
        if (!/^\d{4}-\d{2}$/.test($stateParams.term)) {
          $state.go('zenclerkS.project.invoices', { apikey: project.apikey });
        }
        return ZcsInvoice.find($stateParams.apikey, $stateParams.term);
      }
    },

    data: {
      group: 'invoices',
      category: 'invoices'
    }
  }).state('zenclerkS.project.invoices.edit', {
    url: '/:term/edit',
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/invoices/navigation.html'
      },
      'mainContent@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/invoices/edit/index.html',
        controller: 'ZcsInvoiceEditController as vm'
      }
    },
    resolve: {
      adjustments: function adjustments($stateParams, InvoiceAdjustment, project) {
        return InvoiceAdjustment.show(project, $stateParams.term);
      },
      month: function month($stateParams) {
        return moment($stateParams.term, 'YYYY-MM');
      },
      invoice: function invoice($state, $stateParams, ZcsInvoice, project) {
        if (!/^\d{4}-\d{2}$/.test($stateParams.term)) {
          $state.go('zenclerkS.project.invoices', { apikey: project.apikey });
        }
        return ZcsInvoice.find($stateParams.apikey, $stateParams.term);
      }
    },

    data: {
      group: 'invoices',
      category: 'invoicesEdit'
    }
  }).state('zenclerkS.project.settings', {
    url: '/settings',
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/settings/navigation.html'
      },
      'mainContent@zenclerkS.project': {
        template: '<zcs-project-settings project="$resolve.project"></zcs-project-settings>'
      }
    },
    data: {
      group: 'settings',
      category: 'settings'
    }
  }).state('zenclerkS.project.billings', {
    url: '/billings',
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/settings/navigation.html'
      },
      'mainContent@zenclerkS.project': {
        template: '<zcs-project-billings project="$resolve.project"></zcs-project-billings>'
      }
    },
    data: {
      group: 'billings',
      category: 'billings'
    }
  }).state('zenclerkS.project.users', {
    url: '/users',
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/settings/navigation.html'
      },
      'mainContent@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/users/list.html',
        controllerAs: 'vm',
        controller: 'ZcsProjectUserController'
      }
    },
    resolve: {
      users: function users($stateParams, ProjectUser) {
        return ProjectUser.all($stateParams.apikey);
      },
      currentUser: function currentUser(Devise) {
        return Devise.getCurrentUser();
      }
    },
    data: {
      group: 'settings',
      category: 'users'
    }
  }).state('zenclerkS.project.tags', {
    url: '/tags',
    abstract: true,
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/settings/navigation.html'
      },
      'mainContent@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/tags/site_tags.html',
        controllerAs: 'vm',
        controller: 'ZcsSiteTagsController'
      }
    }
  }).state('zenclerkS.project.tags.tracking', {
    url: '/tracking',
    views: {
      'tagView@zenclerkS.project.tags': {
        template: '<zcs-tracking-tag-checker project="$resolve.project" show-return="false"></zcs-tracking-tag-checker>'
      }
    },
    data: {
      group: 'settings',
      category: 'siteTags'
    }
  }).state('zenclerkS.project.tags.conversion', {
    url: '/conversion',
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/settings/navigation.html'
      },
      'tagView@zenclerkS.project.tags': {
        template: '<zcs-conversion-tag-checker project="$resolve.project" show-return="false"></zcs-conversion-tag-checker>'
      }
    },
    data: {
      group: 'settings',
      category: 'siteTags'
    }
  }).state('zenclerkS.project.excludePages', {
    url: '/exclude',
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/settings/navigation.html'
      },
      'mainContent@zenclerkS.project': {
        template: '<zcs-exclude-page-editor project="$resolve.project"></zcs-exclude-page-editor>'
      }
    },
    data: {
      group: 'settings',
      category: 'siteExclude'
    }
  }).state('zenclerkS.project.excludeIps', {
    url: '/exclude_ips',
    views: {
      'subNavigation@zenclerkS.project': {
        templateUrl: '/templates/zenclerk_s/sites/settings/navigation.html'
      },
      'mainContent@zenclerkS.project': {
        template: '<zcs-exclude-ip-editor project="$resolve.project"></zcs-exclude-ip-editor>'
      }
    },
    data: {
      group: 'settings',
      category: 'siteExcludeIps'
    }
  }).state('zenclerkS.pricing', {
    url: '/pricing',
    views: {
      'layout@': {
        templateUrl: '/templates/zenclerk_s/layout/layout_header+main.html',
        controller: function controller($scope, ZcsOemService) {
          $scope.ZcsOemService = ZcsOemService;
        }
      },
      'headerNavigation@zenclerkS.pricing': {
        controller: function controller($scope) {
          $scope.i18nHeader = 'common.pricing.title';
        }
      },
      'mainContent@zenclerkS.pricing': {
        templateUrl: function templateUrl() {
          return '/templates/zenclerk_s/common/pricing/pricing.html';
        },
        controller: function controller($scope, $translate, Devise) {
          $scope.currentLang = $translate.use();
          $scope.signOut = Devise.signOut;
        }
      }
    }
  }).state('zenclerkS.productChanges', {
    url: '/product_changes',
    views: {
      'layout@': {
        templateUrl: '/templates/zenclerk_s/layout/layout_header+main.html',
        controller: function controller($scope, ZcsOemService) {
          $scope.ZcsOemService = ZcsOemService;
        }
      },
      'headerNavigation@zenclerkS.productChanges': {
        controller: function controller($scope) {
          $scope.i18nHeader = 'common.productChanges.title';
        }
      },
      'mainContent@zenclerkS.productChanges': {
        templateUrl: '/templates/zenclerk_s/common/product_changes/product_changes_page.html'
      }
    }
  }).state('zenclerkS.maintenance', {
    url: '/maintenance',
    views: {
      'layout@': {
        templateUrl: '/templates/zenclerk_s/layout/layout_main.html'
      },
      'mainContent@zenclerkS.maintenance': {
        templateUrl: '/templates/zenclerk_s/common/maintenance/maintenance.html'
      }
    }
  }).state('zenclerkS.project.maintenance', {
    url: '/maintenance',
    views: {
      'mainContent@zenclerkS.project': {
        template: '<zcs-maintenance></zcs-maintenance>'
      }
    }
  }).state('zenclerkS.project.tag_unset', {
    url: '/tag_unset',
    views: {
      'mainContent@zenclerkS.project': {
        template: '<zcs-tag-unset></zcs-tag-unset>'
      }
    }
  }).state('zenclerkS.agency', {
    url: '/agencies/:agencyName',
    abstract: true,
    views: {
      'layout@': {
        templateUrl: '/templates/zenclerk_s/layout/layout_main+sidebar-left.html'
      },
      'sidebarContent@zenclerkS.agency': {
        template: '<zcs-agency-sidebar></zcs-agency-sidebar>'
      }
    },
    resolve: {
      agency: function agency($stateParams, Agency) {
        return Agency.get('name:' + $stateParams.agencyName);
      }
    }
  }).state('zenclerkS.agency.home', {
    url: '',
    views: {
      'mainContent@zenclerkS.agency': {
        template: '<zcs-agency-home agency="$resolve.agency"></zcs-agency-home>'
      }
    },
    data: {
      category: 'agencyHome'
    }
  }).state('zenclerkS.agency.campaigns', {
    url: '/campaigns',
    views: {
      'mainContent@zenclerkS.agency': {
        templateUrl: '/templates/zenclerk_s/agencies/campaigns/agency_campaigns.html'
      }
    },
    data: {
      category: 'agencyCampaigns'
    }
  }).state('zenclerkS.agency.invoices', {
    abstract: true,
    url: '/invoices',
    data: {
      category: 'agencyInvoices'
    }
  }).state('zenclerkS.agency.invoices.list', {
    url: '',
    views: {
      'mainContent@zenclerkS.agency': {
        templateUrl: '/templates/zenclerk_s/agencies/invoices/list.html',
        controllerAs: 'vm',
        controller: 'ZcsAgencyInvoicesListController'
      }
    },
    resolve: {
      invoices: function invoices(ZcsAgencyInvoice, agency) {
        return ZcsAgencyInvoice.all(agency.name);
      }
    },

    data: {
      category: 'agencyInvoices'
    }
  }).state('zenclerkS.agency.invoices.show', {
    url: '/:term',
    views: {
      'mainContent@zenclerkS.agency': {
        templateUrl: '/templates/zenclerk_s/agencies/invoices/show.html',
        controllerAs: 'vm',
        controller: 'ZcsAgencyInvoiceShowController'
      }
    },
    resolve: {
      invoice: function invoice($stateParams, ZcsAgencyInvoice, agency) {
        return ZcsAgencyInvoice.find(agency.name, $stateParams.term);
      },
      projects: function projects($stateParams, AgencyProject) {
        return AgencyProject.all($stateParams.agencyName);
      }
    },
    data: {
      category: 'agencyInvoices'
    }
  }).state('zenclerkS.agency.sites', {
    url: '/sites',
    views: {
      'mainContent@zenclerkS.agency': {
        template: '<zcs-agency-site-list agency="$resolve.agency"></zcs-agency-site-list>'
      }
    },
    data: {
      category: 'agencySites'
    }
  }).state('zenclerkS.agency.sites.new', {
    url: '/sites/new?demo',
    views: {
      'mainContent@zenclerkS.agency': {
        templateUrl: '/templates/zenclerk_s/agencies/sites/new.html',
        controllerAs: 'vm',
        controller: 'ZcsAgencyCreateSiteController',
        resolve: {
          regions: function regions(Meta) {
            return Meta.getRegions();
          },
          salesEntities: function salesEntities(Meta) {
            return Meta.getSalesEntities();
          }
        }
      }
    },
    data: {
      category: 'agencySites'
    }
  }).state('zenclerkS.agency.sitesInInstallation', {
    url: '/sites-in-installation',
    views: {
      'mainContent@zenclerkS.agency': {
        template: '<zcs-agency-sites-in-installation agency="$resolve.agency"></zcs-agency-sites-in-installation>'
      }
    },
    data: {
      category: 'agencySitesInInstallation'
    }
  }).state('zenclerkS.agency.sitesUserActivity', {
    url: '/sites-user-activity',
    views: {
      'mainContent@zenclerkS.agency': {
        template: '<zcs-agency-sites-user-activity agency="$resolve.agency"></zcs-agency-sites-user-activity>'
      }
    },
    data: {
      category: 'agencySitesUserActivity'
    }
  }).state('zenclerkS.agency.users', {
    url: '/users',
    views: {
      'mainContent@zenclerkS.agency': {
        templateUrl: '/templates/zenclerk_s/agencies/users/agency_users.html',
        controllerAs: 'vm',
        controller: 'ZcsAgencyUsersController'
      }
    },
    resolve: {
      users: function users($stateParams, AgencyUser) {
        return AgencyUser.all($stateParams.agencyName);
      },
      currentUser: function currentUser(Devise) {
        return Devise.getCurrentUser();
      }
    },
    data: {
      category: 'agencyUsers'
    }
  }).state('zenclerkS.agency.settings', {
    url: '/settings',
    views: {
      'mainContent@zenclerkS.agency': {
        templateUrl: '/templates/zenclerk_s/agencies/settings/agency_settings.html',
        controllerAs: 'vm',
        controller: 'ZcsAgencySettingsController'
      }
    },
    data: {
      category: 'agencySettings'
    }
  });
}

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('SetupUserController', SetupUserController);

SetupUserController.$inject = ['$state', 'Devise', 'currentUser'];
function SetupUserController($state, Devise, currentUser) {
  var vm = this;
  var pick = ['full_name', 'email', 'department', 'position', 'company_name'];

  vm.user = _.pick(currentUser, pick);
  vm.save = function () {
    Devise.updateInfo(_.pick(vm.user, pick)).then(function (user) {
      $state.go('zenclerkS.home');
    });
  };
}

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsAnalytics', {
  templateUrl: '/templates/zenclerk_s/sites/analytics/analytics.html',
  bindings: {
    project: '<'
  },
  controller: zcsAnalyticsController
});

zcsAnalyticsController.$inject = ['ZcsOemService'];
function zcsAnalyticsController(ZcsOemService) {
  var vm = this;

  this.$onInit = function () {
    vm.initialized = true;
    vm.ZcsOemService = ZcsOemService;
  };
}

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsCampaignNavigationController', ZcsCampaignNavigationController);

ZcsCampaignNavigationController.$inject = ['$state', 'project'];
function ZcsCampaignNavigationController($state, project) {
  var vm = this;
  vm.project = project;
  vm.isCategory = isCategory;

  function isCategory(category) {
    if (_.get($state.current, 'data.category') === category) {
      return true;
    }
    return false;
  }
}

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsCouponHistory', {
  templateUrl: '/templates/zenclerk_s/sites/campaigns/coupon/history.html',
  bindings: {
    project: '='
  },
  controller: ZcsCouponHistoryController
});

ZcsCouponHistoryController.$inject = ['$q', '$state', '$translate', 'ZcsAccessStats', 'ZcsIncentive', 'ZcsOemService', 'currencies'];
function ZcsCouponHistoryController($q, $state, $translate, ZcsAccessStats, ZcsIncentive, ZcsOemService, currencies) {
  var vm = this;

  vm.ZcsOemService = ZcsOemService;
  vm.currency = currencies[vm.project.currency];

  /* variables */
  vm.timeLimitTexts = [$translate.instant('sites.campaigns.couponHistory.aboutToExpire'), $translate.instant('sites.campaigns.couponHistory.expired')];
  vm.pastIncentive = [];

  /* actions */
  vm.isAlmostEnded = isAlmostEnded;
  vm.isEnded = isEnded;

  vm.$onInit = function () {

    ZcsIncentive.all(vm.project.id).then(function (incentives) {
      vm.pastIncentive = incentives;

      var promises = _.map(vm.pastIncentive, function (incentive) {
        return ZcsIncentive.versions(vm.project.id, incentive.id);
      });

      var pastIncentivePromise = $q.all(promises).then(function (results) {
        vm.pastIncentive = vm.pastIncentive.concat(_.flatten(results));
        vm.pastIncentive = _.chain(vm.pastIncentive)
        // by default they should be in "newest last"-order, but just in case, let's sort.
        // uniq behaves so that it takes the first.
        .sortBy(function (d) {
          return -new Date(d.created_at);
        }).uniqBy(function (incentive) {
          // consider only start at - changing end at could be possible, but changing start at should not be...
          var getStartAtDate = function getStartAtDate(i) {
            return moment(i.start_at).format('YYYY-MM-DD_HH:mm');
          };
          var prefix = incentive.coupon_code + '_' + getStartAtDate(incentive) + '_';

          if (incentive.discount_type === 'price') {
            return '' + prefix + incentive.discount_price + '_' + incentive.discount_type;
          } else if (incentive.discount_type === 'percent') {
            return '' + prefix + incentive.discount_percent + '_' + incentive.discount_type;
          } else if (incentive.is_free_shipping) {
            return prefix + 'freeshipping';
          }
          return '' + incentive.coupon_code;
        }).value();
      });

      pastIncentivePromise.then(function (res) {
        // remove the current active incentives from plans
        vm.pastIncentive = _.difference(vm.pastIncentive, vm.currentIncentives);
        // sort so that newest comes first
        vm.pastIncentive = _.sortBy(vm.pastIncentive, function (d) {
          return -new Date(d.created_at);
        });
      });
    });
  };

  function isAlmostEnded(time) {
    if (time > new Date() && time < moment().add(3, 'days').toDate()) {
      return true;
    }
    return false;
  }

  function isEnded(time) {
    if (time < new Date()) {
      return true;
    }
    return false;
  }
}

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsCampaignConfirmModalController', ZcsCampaignConfirmModalController);

ZcsCampaignConfirmModalController.$inject = ['$uibModalInstance'];
function ZcsCampaignConfirmModalController($uibModalInstance) {
  var vm = this;

  vm.createCampaign = createCampaign;
  vm.editCampaign = editCampaign;
  vm.close = close;

  function createCampaign() {
    $uibModalInstance.close('new');
  }

  function editCampaign() {
    $uibModalInstance.close('edit');
  }

  function close() {
    $uibModalInstance.close();
  }
}

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsCampaignCreateButton', {
  bindings: {
    project: '<'
  },
  transclude: true,
  templateUrl: '/templates/zenclerk_s/sites/campaigns/create_button/campaign_create_button.html',
  controller: ZcsCampaignCreateButtonCtrl
});

ZcsCampaignCreateButtonCtrl.$inject = ['$uibModal', '$state', '$window', 'Campaign', 'ZcsCampaign'];

function ZcsCampaignCreateButtonCtrl($uibModal, $state, $window, Campaign, ZcsCampaign) {
  var vm = this;
  var latestIncompleteCampaign = void 0;

  vm.$onInit = function () {
    vm.confirmCampaign = confirmCampaign;
    vm.isAllowedToCreate = function () {
      return ZcsCampaign.isAllowedToCreate(vm.project);
    };
    vm.getTooltipMessage = function () {
      return ZcsCampaign.getTooltipMessage(vm.project);
    };
  };

  vm.$onChanges = function () {
    if (vm.project) {
      Campaign.all({ projectId: vm.project.id }).then(function (campaigns) {
        vm.campaigns = campaigns;
        // find newest incomplete campaign
        latestIncompleteCampaign = _.chain(campaigns).filter(function (campaign) {
          return campaign.status === 'incomplete';
        }).filter(function (campaign) {
          return campaign.is_widget === false;
        }) // status is false if the campaign is interest widget
        .sortBy(function (campaign) {
          return campaign.create_at;
        }).last().value();
      });
    }
  };

  function confirmCampaign() {
    if (!ZcsCampaign.isAllowedToCreate(vm.project)) return;
    if (latestIncompleteCampaign) {
      var modalInstance = $uibModal.open({
        templateUrl: '/templates/zenclerk_s/sites/campaigns/create_button/campaign_confirm_modal.html',
        controller: 'ZcsCampaignConfirmModalController',
        controllerAs: '$ctrl',
        size: 'sm'
      });

      modalInstance.result.then(function (campaignState) {
        if (campaignState === 'edit') {
          $state.go('zenclerkS.project.campaign.edit.segment', { apikey: latestIncompleteCampaign.apikey, campaignId: latestIncompleteCampaign.id });
        } else if (campaignState === 'new') {
          $state.go('zenclerkS.project.campaign.edit.segment', { apikey: vm.project.apikey, campaignId: 'new' });
        }
      });
    } else {
      $state.go('zenclerkS.project.campaign.edit.segment', { apikey: vm.project.apikey, campaignId: 'new' });
    }
  }
}

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsCampaignEdit', {
  templateUrl: '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit.html',
  bindings: {
    project: '<',
    campaign: '<'
  },
  controller: ZcsCampaignEditController
});

ZcsCampaignEditController.$inject = ['$filter', '$scope', '$state', '$uibModal', '$translate', 'Campaign', 'Template', 'ZcsCampaign', 'ZcsCampaignName', 'ZcsIncentive', 'ZcsSegment', 'ZcsOemService'];
function ZcsCampaignEditController($filter, $scope, $state, $uibModal, $translate, Campaign, Template, ZcsCampaign, ZcsCampaignName, ZcsIncentive, ZcsSegment, ZcsOemService) {
  var vm = this;
  var templates = [];
  this.$onInit = function () {
    /* variables */
    vm.estimatedCv = ZcsSegment.estimatedCv;
    vm.incentive = vm.campaign.incentives[0] || vm.campaign.incentive_draft;

    /* actions */
    vm.isEnabledStep = isEnabledStep;
    vm.isPreviousStep = isPreviousStep;
    vm.isLastStep = isLastStep;
    vm.isScheduleValid = isScheduleValid;
    vm.areAllStepsValid = areAllStepsValid;
    vm.isModifiedSchedule = isModifiedSchedule;
    vm.getSaveButtonText = getSaveButtonText;
    vm.saveButtonClicked = saveButtonClicked;
    vm.canBeLaunched = canBeLaunched;
    vm.goToStep = goToStep;
    vm.exit = exit;
    vm.existingCouponCodes = [];
    vm.isCopy = isCopy;
    vm.getStepClass = getStepClass;
    vm.isCouponCodeInUse = isCouponCodeInUse;
    vm.isAllowedToCreate = function () {
      return ZcsCampaign.isAllowedToCreate(vm.project);
    };
    vm.getTooltipMessage = function () {
      return ZcsCampaign.getTooltipMessage(vm.project);
    };

    /* oem */
    $scope.$watch(function () {
      return ZcsOemService.get();
    }, isOem);

    function isOem(oemService) {
      if (oemService === 'makerepeater') {
        vm.isOem = true;
        if (vm.project.shopping_cart_asp === 'makeshop') {
          vm.isIntegratedWithMakeshop = vm.campaign.status === 'incomplete' || vm.incentive.is_integrated_with_makeshop;
        } else {
          vm.isIntegratedWithMakeshop = false;
        }
      } else {
        vm.isOem = false;
        vm.isIntegratedWithMakeshop = false;
      }
    }

    /* steps */
    vm.steps = {
      items: [{
        name: 'segment',
        label: $translate.instant('sites.campaigns.edit.campaignEdit.segment'),
        route: 'zenclerkS.project.campaign.edit.segment',
        class: '',
        requiredProperty: undefined
      }, {
        name: 'coupon',
        label: $translate.instant('sites.campaigns.edit.campaignEdit.coupon'),
        route: 'zenclerkS.project.campaign.edit.coupon',
        class: '',
        requiredProperty: 'segment_id'
      }, {
        name: 'design',
        label: $translate.instant('sites.campaigns.edit.campaignEdit.design'),
        route: 'zenclerkS.project.campaign.edit.design',
        class: '',
        requiredProperty: function requiredProperty(campaign) {
          if (!isSegmentSet(campaign)) {
            return false;
          } else if (!isIncentiveSet(campaign)) {
            return false;
          }
          return true;
        }
      }, {
        name: 'delivery',
        label: $translate.instant('sites.campaigns.edit.campaignEdit.deliveryPlan'),
        route: 'zenclerkS.project.campaign.edit.delivery',
        class: '',
        requiredProperty: function requiredProperty(campaign) {
          if (!isSegmentSet(campaign)) {
            return false;
          } else if (!isIncentiveSet(campaign)) {
            return false;
          } else if (!campaign.template_type) {
            return false;
          }
          return true;
        }
      }, {
        name: 'schedule',
        label: $translate.instant('sites.campaigns.edit.campaignEdit.schedule'),
        route: 'zenclerkS.project.campaign.edit.schedule',
        class: '',
        requiredProperty: 'timing'
      }, {
        name: 'confirm',
        label: $translate.instant('sites.campaigns.edit.campaignEdit.confirm'),
        route: 'zenclerkS.project.campaign.edit.confirm',
        class: '',
        requiredProperty: function requiredProperty(campaign) {
          if (isScheduleValid()) {
            return true;
          }
          return false;
        }
      }]
    };

    getExistingCouponCodes();

    init();

    $scope.$on('$viewContentLoaded', function () {
      refreshStepsStates();
    });
  };

  /* functions */

  function init() {
    // forward to segment if accessed directly
    if ($state.current.name === 'zenclerkS.project.campaign.edit') {
      $state.go('zenclerkS.project.campaign.edit.segment');
    } else if (vm.steps.current && !isEnabledStep(vm.steps.current)) {
      $state.go(getStepFromIndex(vm.steps.previous).name);
    }

    // set but do not overwrite in case of existing campaign
    if (vm.campaign.id === 'new') {
      vm.campaign.campaign_device = 'devicefree';
      vm.campaign.campaign_type = 'Coupon';
    }

    Template.all(vm.project.id).then(function (res) {
      templates = res;
      $scope.$watch('$ctrl.campaign.template_type', chooseTemplate);
    });

    // in case of editing, set the initial segment
    if (vm.campaign.segment_id) {
      ZcsSegment.get(vm.project.id, vm.campaign.segment_id).then(function (segment) {
        vm.campaign.segment = segment;
      });
    }

    if (vm.campaign.id !== 'new') {
      vm.campaign.timing = angular.fromJson(vm.campaign.memo);
    }
  }

  function isIncentiveSet(campaign) {
    var incentive = _.get(campaign, 'incentives[0]', campaign.incentive_draft);
    if (incentive.has_price_limit && !incentive.minimum_price) {
      return false;
    } else if (!incentive.coupon_code) {
      return false;
    }
    return true;
  }

  function isSegmentSet(campaign) {
    if (!campaign.segment) {
      return false;
    }
    return true;
  }

  function getExistingCouponCodes() {
    ZcsIncentive.all(vm.project.id).then(function (incentives) {
      var existingCouponCodes = _.chain(incentives)
      // reject self
      .reject(function (d) {
        return vm.campaign.incentives.length > 0 && d.id === vm.campaign.incentives[0].id;
      }).reject(function (d) {
        if (vm.project.is_oem) {
          // do allow any duplicate coupon_code when MR
          return false;
        }
        // reject only active campaigns if not makerepeater (coupon_codes with already ended/terminated campaigns will work)
        return _.filter(d.campaigns, isCampaignActive).length === 0;
      }).map(function (d) {
        return d.coupon_code;
      }).uniq().value();
      // concat so that the reference does not change
      vm.existingCouponCodes = existingCouponCodes;
    });
  }

  function isCouponCodeInUse() {
    return vm.existingCouponCodes.indexOf(vm.incentive.coupon_code) >= 0;
  }

  function isCampaignActive(campaign) {
    return _.includes(['activated', 'blocked'], campaign.status) && moment(campaign.end_at).isAfter(moment());
  }

  function isScheduleValid() {
    if (!vm.incentive.is_infinite && (!_.get(vm.campaign, 'start_at_obj.date') || !_.isNumber(_.get(vm.campaign, 'start_at_obj.time')) || !_.get(vm.campaign, 'end_at_obj.date') || !_.isNumber(_.get(vm.campaign, 'end_at_obj.time')))) {
      return false;
    }

    if (vm.incentive.is_infinite && !_.get(vm.campaign, 'start_at_obj.date') || !_.isNumber(_.get(vm.campaign, 'start_at_obj.time'))) {
      return false;
    }

    if (vm.campaign.status === 'incomplete' && moment().startOf('day').valueOf() > vm.campaign.start_at_obj.date) {
      return false;
    }

    if (!vm.incentive.is_infinite && vm.campaign.start_at_obj.date > vm.campaign.end_at_obj.date) {
      return false;
    }

    return true;
  }

  function isModifiedSchedule() {
    return moment(vm.campaign.end_at).startOf('day').valueOf() !== vm.campaign.end_at_obj.date;
  }

  function isEnabledStep(index) {
    if (isCopy(vm.campaign)) {
      return true;
    }

    var step = getStepFromIndex(index);
    if (step && step.requiredProperty) {
      var prop = void 0;
      if (_.isFunction(step.requiredProperty)) {
        prop = step.requiredProperty(vm.campaign);

        // in case of function, returning false or true is correct
        if (!prop) {
          return false;
        }
      } else {
        prop = _.get(vm.campaign, step.requiredProperty);

        // in case of value, false is also counted
        if (prop === null || angular.isUndefined(prop)) {
          return false;
        }
      }
    }
    return true;
  }

  function refreshStepsStates(step) {
    var stepName = void 0;
    if (step) {
      stepName = step.route;
    } else {
      stepName = $state.current.name;
    }

    vm.steps.current = _.findIndex(vm.steps.items, { route: stepName });
    vm.steps.previous = vm.steps.current - 1;

    if (vm.steps.current === 0) {
      // is first step?
      vm.steps.first = true;
      vm.steps.previous = vm.steps.current;
    } else {
      vm.steps.first = false;
      vm.steps.previous = vm.steps.current - 1;
    }

    if (vm.steps.current === vm.steps.items.length - 1) {
      // is last step?
      vm.steps.last = true;
      vm.steps.next = vm.steps.current;
    } else {
      vm.steps.last = false;
      vm.steps.next = vm.steps.current + 1;
    }
  }

  function getStepFromIndex(index) {
    return vm.steps.items[index];
  }

  /* Used to add css class that helps styling */
  function isPreviousStep() {
    var activeStateIndex = _.findIndex(vm.steps.items, { route: $state.current.name });
    return vm.steps.current < activeStateIndex;
  }

  function saveButtonClicked() {
    if (!canBeLaunched() || !ZcsCampaign.isAllowedToCreate(vm.project)) {
      return false;
    }

    if (isNewCampaign()) {
      openLaunchModal();
    } else {
      ZcsCampaign.save(vm.campaign, vm.project).then(function (res) {
        if (vm.campaign.status === 'incomplete') {
          $state.go('zenclerkS.project.campaigns.draft', { apikey: vm.project.apikey });
        } else {
          $state.go('zenclerkS.project.campaigns.active', { apikey: vm.project.apikey });
        }
      });
    }
    return;
  }

  function goToStep(index, action) {
    if (index === vm.steps.current && action === 'stepper') {
      return;
    }

    if (!isEnabledStep(index)) {
      return;
    }

    var stepNext = getStepFromIndex(index);

    // If we are in a state that's before aiState, and have selected the mail only segment,
    // reset the timing (and memo which has timing stored in it)
    var aiStateIndex = _.findIndex(vm.steps.items, { route: 'zenclerkS.project.campaign.edit.delivery' });
    if (vm.steps.current < aiStateIndex && _.get(vm.campaign, 'segment.name') === 'zcs_segment_mail_only') {
      vm.campaign.timing = undefined;
      vm.campaign.memo = undefined;
    }

    $state.go(stepNext.route, { apikey: vm.project.apikey, campaignId: vm.campaign.id });

    refreshStepsStates(stepNext);
  }

  function isLastStep() {
    if (vm.steps.last) {
      return true;
    }
    return false;
  }

  function canBeLaunched() {
    // no segment set
    if (!vm.campaign.segment_id) {
      return false;
    }

    // no coupon code
    if (!vm.incentive.coupon_code) {
      return false;
    }

    // duplicate coupon code
    if (vm.existingCouponCodes.indexOf(vm.incentive.coupon_code) >= 0) {
      return false;
    }

    // no timing set
    if (!vm.campaign.timing) {
      return false;
    }

    // check schedule
    if (!isScheduleValid()) {
      return false;
    }

    // publish limit reached
    if (vm.project.is_publish_limit_reached) {
      return false;
    }

    return true;
  }

  function areAllStepsValid() {
    // Copy can go to each step
    if (isCopy(vm.campaign)) {
      return true;
    }

    if (!canBeLaunched()) {
      return false;
    }

    return true;
  }

  function getSaveButtonText() {
    if (isNewCampaign()) {
      return $translate.instant('sites.campaigns.edit.campaignEdit.deliver');
    }
    return $translate.instant('sites.campaigns.edit.campaignEdit.save');
  }

  function getStepClass($index) {
    return {
      active: $index === vm.steps.current,
      disabled: !vm.isEnabledStep($index) && !vm.isCopy(vm.campaign),
      'before-active': vm.isPreviousStep($index),
      'needs-action': vm.isCopy(vm.campaign) && ($index === 1 && !vm.campaign.incentive_draft.coupon_code || $index === 4 && (!vm.campaign.start_at_obj.date || !vm.campaign.end_at_obj.date))
    };
  }

  function isNewCampaign() {
    if (vm.campaign.current_status === 'active' || vm.campaign.current_status === 'pending') {
      return false;
    }
    return true;
  }

  function chooseTemplate(newval, oldval) {
    if (!newval) return;
    vm.campaign.template = _.find(templates, function (d) {
      return d.name === newval;
    });
  }

  function isCopy(campaign) {
    if (campaign.name.startsWith($translate.instant('sites.campaigns.edit.campaignEdit.copyInParenthesis'))) {
      return true;
    }
    return false;
  }

  function exit() {
    if (vm.campaign.id === 'new' && angular.isUndefined(vm.campaign.segment)) {
      // exit directly if camapaign have no setting
      $state.go('zenclerkS.project.campaigns', { apikey: vm.project.apikey });
    } else {
      $uibModal.open({
        templateUrl: '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_modal_exit.html',
        controller: 'ZcsCampaignEditModalExitController as $ctrl',
        size: 'sm',
        resolve: {
          campaign: vm.campaign,
          project: vm.project
        }
      });
    }
  }

  function openLaunchModal() {
    $uibModal.open({
      templateUrl: '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_modal_launch.html',
      size: 'sm',
      controller: 'ZcsCampaignEditModalLaunchController as $ctrl',
      resolve: {
        campaign: vm.campaign,
        project: vm.project,
        isIntegratedWithMakeshop: vm.isIntegratedWithMakeshop
      }
    });
  }
}

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsCampaignEditModalConversionPriceController', ZcsCampaignEditModalConversionPriceController);

ZcsCampaignEditModalConversionPriceController.$inject = ['$scope', '$uibModalInstance', 'ZcsProject', 'currencies', 'project'];
function ZcsCampaignEditModalConversionPriceController($scope, $uibModalInstance, ZcsProject, currencies, project) {
  var vm = this;
  vm.project = project;
  vm.currency = currencies[vm.project.currency];
  vm.close = close;
  vm.profitRateOptions = ZcsProject.PROFIT_RATE_OPTIONS();
  vm.averageConversionPriceOptions = ZcsProject.AVERAGE_CONVERSION_PRICE_OPTIONS(vm.currency);
  vm.setProfitAndConversion = setProfitAndConversion;
  vm.isSaving = false;

  function setProfitAndConversion() {
    vm.isSaving = true;
    ZcsProject.saveProject(vm.project).then(function (res) {
      vm.project = _.merge(vm.project, res);
    }).finally(function () {
      vm.isSaving = false;
      $scope.campaignEditConversionPrice.$setPristine();
      close();
    });
  }

  function close() {
    $uibModalInstance.close();
  }
}

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsCampaignEditModalExitController', ZcsCampaignEditModalExitController);

ZcsCampaignEditModalExitController.$inject = ['$state', '$uibModalInstance', 'ZcsCampaign', 'campaign', 'project'];
function ZcsCampaignEditModalExitController($state, $uibModalInstance, ZcsCampaign, campaign, project) {
  /* Init */
  var vm = this;

  /* Variables */
  vm.project = project;
  vm.campaign = campaign;
  vm.isNewCampaign = isNewCampaign;
  vm.save = save;
  vm.close = close;
  vm.exitWithoutSaving = exitWithoutSaving;

  /* Functions */
  function isNewCampaign() {
    return vm.campaign.id === 'new';
  }

  function exitWithoutSaving() {
    exit('zenclerkS.project.campaigns');
  }

  function save() {
    ZcsCampaign.save(vm.campaign, vm.project).then(function (res) {
      if (!vm.campaign.id || vm.campaign.id === 'new') {
        exit('zenclerkS.project.campaigns.draft');
      } else if (vm.campaign.current_status === 'incomplete') {
        exit('zenclerkS.project.campaigns.draft');
      } else {
        exit('zenclerkS.project.campaigns.active');
      }
    });
  }

  function exit(route) {
    $state.go(route, { apikey: vm.project.apikey },
    // reload to refresh possibly edited project object.
    // the object needs to be refreshed because it would otherwise
    // cause errors when saving it in other views
    { reload: true });
    close();
  }

  function close() {
    $uibModalInstance.close();
  }
}

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsCampaignEditModalLaunchController', ZcsCampaignEditModalLaunchController);

ZcsCampaignEditModalLaunchController.$inject = ['$state', '$uibModalInstance', 'ZcsCampaign', 'campaign', 'isIntegratedWithMakeshop', 'project'];
function ZcsCampaignEditModalLaunchController($state, $uibModalInstance, ZcsCampaign, campaign, isIntegratedWithMakeshop, project) {
  /* Init */
  var vm = this;

  /* Scopes */
  vm.project = project;
  vm.isIntegratedWithMakeshop = isIntegratedWithMakeshop;
  vm.campaign = campaign;
  vm.close = close;
  vm.launch = launch;
  vm.saveInProgressOrSucceeded = false;
  vm.$onInit = function () {
    vm.isAllowedToCreate = function () {
      return ZcsCampaign.isAllowedToCreate(vm.project);
    };
    vm.getTooltipMessage = function () {
      return ZcsCampaign.getTooltipMessage(vm.project);
    };
  };

  function launch() {
    if (!ZcsCampaign.isAllowedToCreate(vm.project)) {
      return false;
    }

    // set ready for launching
    vm.campaign.status = 'activated';

    // There's probably a possibility of state.go taking too long time
    // that the button will be active for few ms, and user might click it two times.
    vm.saveInProgressOrSucceeded = true;
    ZcsCampaign.save(vm.campaign, vm.project).then(function (res) {
      $state.go('zenclerkS.project.campaigns.active', { apikey: vm.project.apikey });
      close();
    }).catch(function (err) {
      vm.saveInProgressOrSucceeded = false;
    });
  }

  function close() {
    $uibModalInstance.close();
  }
}

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsCampaignEditStepConfirm', {
  templateUrl: '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_step_confirm.html',
  require: {
    campaignEdit: '^zcsCampaignEdit'
  },
  controller: ZcsCampaignEditStepConfirmController
});

ZcsCampaignEditStepConfirmController.$inject = ['ZcsEstimator', 'ZcsSegment', '$filter', 'currencies'];
function ZcsCampaignEditStepConfirmController(ZcsEstimator, ZcsSegment, $filter, currencies) {
  var vm = this;

  this.$onInit = function () {
    // variables
    vm.campaign = vm.campaignEdit.campaign;
    vm.project = vm.campaignEdit.project;
    vm.incentive = vm.campaignEdit.incentive;
    vm.currency = currencies[vm.project.currency];

    vm.segment = undefined;

    // actions
    vm.getSegmentLabel = ZcsSegment.getSegmentLabel;
    vm.isCouponStepOk = isCouponStepOk;
    vm.dateObjToDate = dateObjToDate;
  };

  function isCouponStepOk() {
    if (vm.incentive.has_price_limit && !vm.incentive.minimum_price) return false;
    return vm.campaignEdit.existingCouponCodes.indexOf(vm.incentive.coupon_code) < 0 && vm.campaignEdit.incentive.coupon_code;
  }

  // TODO: move to some "lib"
  function dateObjToDate(dateObj) {
    if (!dateObj) return;
    return $filter('dateObjToDate')(dateObj);
  }
}

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsCampaignEditStepCoupon', {
  templateUrl: '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_step_coupon.html',
  require: {
    campaignEdit: '^zcsCampaignEdit'
  },
  controller: ZcsCampaignEditStepCouponController
});

ZcsCampaignEditStepCouponController.$inject = ['$location', '$rootScope', '$scope', '$state', '$uibModal', '$translate', 'ZcsEstimator', 'ZcsIncentive', 'ZcsSegment', 'ZcsCampaignElementCreator', 'ZcsProject', 'ZcsOemService', 'currencies'];
function ZcsCampaignEditStepCouponController($location, $rootScope, $scope, $state, $uibModal, $translate, ZcsEstimator, ZcsIncentive, ZcsSegment, ZcsCampaignElementCreator, ZcsProject, ZcsOemService, currencies) {
  var vm = this;
  vm.ZcsOemService = ZcsOemService;

  var incentiveType = void 0;

  this.$onInit = function () {
    // variables
    vm.campaign = vm.campaignEdit.campaign;
    vm.project = vm.campaignEdit.project;
    vm.currency = currencies[vm.project.currency];

    if (!_.get(vm.campaign, 'segment_id')) {
      $state.go('zenclerkS.project.campaign.edit.segment', { apikey: vm.project.apikey, campaignId: vm.campaign.id });
      // We need to return or message gets set on reload, and might cause
      // problems!
      return;
    }

    vm.estimatedCv = ZcsSegment.estimatedCv;
    vm.setFreeShippingCost = setFreeShippingCost;
    vm.incentivePlans = [];

    if (vm.campaignEdit.isIntegratedWithMakeshop) {
      vm.couponCodePattern = /^[a-zA-Z0-9]+$/;
    } else {
      vm.couponCodePattern = /^[a-zA-Z0-9\-_]+$/;
    }

    vm.availableCoupons = {
      type: {
        price: {
          label: {
            prefix: vm.currency.symbol,
            suffix: vm.currency.suffix
          },
          suffix: 'OFF',
          amount: ZcsIncentive.getRecommendedFixedPriceCoupons(vm.project),
          min: 10,
          max: 50000,
          onSelect: function onSelect(incentive) {
            incentive.discount_type = 'price';
            incentive.discount_price = undefined;
            incentive.discount_percent = undefined;
            incentive.is_free_shipping = false;
          }
        },
        percent: {
          label: {
            prefix: '',
            suffix: '%'
          },
          suffix: 'OFF',
          amount: ZcsIncentive.getRecommendedPercentCoupons(vm.project),
          min: 1,
          max: 99,
          onSelect: function onSelect(incentive) {
            incentive.discount_type = 'percent';
            incentive.discount_price = undefined;
            incentive.discount_percent = undefined;
            incentive.is_free_shipping = false;
          }
        },
        free_shipping: {
          label: {
            prefix: '',
            suffix: $translate.instant('sites.campaigns.edit.campaignEdit.stepCoupon.freeShipping')
          },
          onSelect: function onSelect(incentive) {
            incentive.discount_type = undefined;
            incentive.discount_price = undefined;
            incentive.discount_percent = undefined;
            incentive.is_free_shipping = true;
          }
        }
      },
      couponMinLength: 2,
      couponMaxLength: 20
    };

    // actions
    vm.selectIncentiveDiscountAmount = selectIncentiveDiscountAmount;
    vm.switchPriceLimit = switchPriceLimit;
    vm.getMinimumPriceLimit = ZcsIncentive.getMinimumPriceLimit;

    if (vm.campaign.status === 'incomplete') {
      vm.incentive = vm.campaign.incentive_draft;
      incentiveType = 'draft';
    } else {
      vm.incentive = vm.campaign.incentives[0];
      incentiveType = 'normal';
    }

    vm.setProfitAndConversion = setProfitAndConversion;

    $scope.$watch('$ctrl.incentive', incentiveUpdated, true);
  };

  function incentiveUpdated(newValue, oldValue) {
    if (angular.equals(newValue, oldValue)) {
      return;
    }

    if (incentiveType === 'draft') {
      vm.campaign.incentive_draft = _.merge(vm.campaign.incentive_draft, newValue);
      vm.campaign.incentive_draft.name = ZcsIncentive.getName(vm.campaign.incentive_draft);
    } else if (vm.campaign.incentives.length > 0) {
      vm.campaign.incentives[0] = _.merge(vm.campaign.incentives[0], newValue);
      vm.campaign.incentives[0].name = ZcsIncentive.getName(vm.campaign.incentives[0]);
    }

    // If design is not set yet, create it. Otherwise update just the texts.
    // This way colors and designs won't reset every time
    if (_.get(vm.campaign, 'element.message')) {
      var isUpdateCodeTitleOnly = isWhitelistedParameterChanged(newValue, oldValue);
      ZcsCampaignElementCreator.setDefaultMessageValues(vm.campaign, vm.project, isUpdateCodeTitleOnly);
    } else {
      ZcsCampaignElementCreator.createCampaignElement(vm.campaign, vm.project);
    }
  }

  function isWhitelistedParameterChanged(newParams, oldParams) {
    var whitelistedParameters = ['coupon_code', 'name', 'is_price_limit_tax_included'];
    return _.some(whitelistedParameters, function (parameter) {
      var newValue = _.get(newParams, parameter);
      var oldValue = _.get(oldParams, parameter);
      return !_.isEqual(newValue, oldValue);
    });
  }

  function selectIncentiveDiscountAmount(amount) {
    vm.incentive['discount_' + vm.incentive.discount_type] = amount;
  }

  function switchPriceLimit() {
    if (vm.campaign.status !== 'incomplete') {
      return false;
    }
    vm.incentive.has_price_limit = !vm.incentive.has_price_limit;

    if (!vm.incentive.has_price_limit) {
      vm.incentive.minimum_price = null;
    }
  }

  function setFreeShippingCost() {
    var modalInstance = $uibModal.open({
      templateUrl: '/templates/zenclerk_s/directives/project/free_shipping_cost_editor/free_shipping_cost_editor.html',
      controller: 'ZcsFreeShippingCostEditorController',
      controllerAs: '$ctrl',
      size: 'sm',
      resolve: {
        project: vm.project
      }
    });

    modalInstance.result.then(function () {
      // no need to do anything
    });
  }

  function setProfitAndConversion() {
    var modalInstance = $uibModal.open({
      templateUrl: '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_modal_conversion_price.html',
      controller: 'ZcsCampaignEditModalConversionPriceController',
      controllerAs: '$ctrl',
      size: 'sm',
      resolve: {
        project: vm.project
      }
    });

    modalInstance.result.then(function () {
      // update the recommended price and percent values
      vm.availableCoupons.type.price.amount = ZcsIncentive.getRecommendedFixedPriceCoupons(vm.project);
      vm.availableCoupons.type.percent.amount = ZcsIncentive.getRecommendedPercentCoupons(vm.project);
    });
  }
}

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsCampaignEditStepDelivery', {
  templateUrl: '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_step_delivery.html',
  bindings: {
    liteSamplingRanges: '<'
  },
  require: {
    campaignEdit: '^zcsCampaignEdit'
  },
  controller: ZcsCampaignEditStepDeliveryController
});

ZcsCampaignEditStepDeliveryController.$inject = ['$state', 'ZcsTiming', 'ZcsOemService', 'currencies'];
function ZcsCampaignEditStepDeliveryController($state, ZcsTiming, ZcsOemService, currencies) {
  var _this = this;

  var vm = this;

  vm.ZcsOemService = ZcsOemService;

  this.$onInit = function () {
    vm.campaign = _this.campaignEdit.campaign;
    vm.project = _this.campaignEdit.project;

    // variables
    vm.timingPlans = ZcsTiming.timingPlans;
    vm.currency = currencies[vm.project.currency];
    vm.samplingRange = vm.campaign.sampling_range ? _.find(vm.liteSamplingRanges, { label: vm.campaign.sampling_range }).label : _.minBy(vm.liteSamplingRanges, 'name').label;

    // actions
    vm.isDisabled = isDisabled;
    vm.selectSamplingRange = selectSamplingRange;
    vm.selectTiming = selectTiming;

    // select first plan by default
    if (!vm.campaign.timing) {
      if (vm.campaign.segment.name === 'zcs_segment_mail_only') {
        selectTiming(vm.timingPlans[1]);
      } else {
        selectTiming(vm.timingPlans[0]);
      }
    }

    if (!vm.campaign.template_type) {
      $state.go('zenclerkS.project.campaign.edit.design', { apikey: vm.project.apikey, campaignId: vm.campaign.id });
    }
  };

  function isDisabled(plan) {
    if (plan.name === 'ai' && vm.campaign.segment.name === 'zcs_segment_mail_only') {
      return true;
    }
    return false;
  }

  function selectSamplingRange() {
    vm.campaign.configuration_type = 'sampling';
    vm.campaign.sampling_range = vm.samplingRange;
  }

  function deselectSamplingRange() {
    vm.campaign.configuration_type = 'csv_upload';
    vm.campaign.sampling_range = null;
  }

  function selectTiming(plan) {
    if (plan.name === 'ai') {
      selectSamplingRange();
    } else {
      deselectSamplingRange();
    }

    if (isDisabled(plan)) {
      return;
    }
    vm.campaign.timing = plan;
    // TODO: get rid if memo workflow and automatize instead
    vm.campaign.memo = angular.toJson(plan);
  }
}

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsCampaignEditStepDesign', {
  templateUrl: '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_step_design.html',
  require: {
    campaignEdit: '^zcsCampaignEdit'
  },
  controller: ZcsCampaignEditStepDesignController
});

ZcsCampaignEditStepDesignController.$inject = ['$state', 'Template', 'ZcsCampaignElementCreator'];
function ZcsCampaignEditStepDesignController($state, Template, ZcsCampaignElementCreator) {
  var _this = this;

  var vm = this;

  this.$onInit = function () {
    vm.campaign = _this.campaignEdit.campaign;
    vm.project = _this.campaignEdit.project;

    vm.selectedTemplate = undefined;
    vm.selectTemplate = selectTemplate;
    vm.selectableTemplates = ZcsCampaignElementCreator.getSelectableTemplates(vm.project);
    vm.isNewTemplate = isNewTemplate;

    if (!_.get(vm.campaign, 'incentives[0].coupon_code') && !vm.campaign.incentive_draft.coupon_code) {
      $state.go('zenclerkS.project.campaign.edit.coupon', { apikey: vm.project.apikey, campaignId: vm.campaign.id });
      // We need to return or message gets set on reload, and might cause
      // problems!
      return;
    }

    // if no element message
    // FIXME: color picker puts #FFFFFF as message colors before we get into this part,
    // so the selectTemplate does not run when coming in this state
    // (so that's why checking code_title also)
    if (_.isEmpty(vm.campaign.element.message) || !vm.campaign.element.message || !vm.campaign.element.message.code_title) {
      selectTemplate(vm.selectableTemplates[0]);
    }
  };

  function selectTemplate(selectedTemplate) {
    ZcsCampaignElementCreator.createCampaignElement(vm.campaign, vm.project, selectedTemplate);
  }

  function isNewTemplate(template) {
    // newly released templates should be 1 "NEW" for 1 month
    return template.release_date && moment().isBefore(moment(template.release_date).add(1, 'month'));
  }
}

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsCampaignEditStepSchedule', {
  templateUrl: '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_step_schedule.html',
  require: {
    campaignEdit: '^zcsCampaignEdit'
  },
  controller: ZcsCampaignEditStepScheduleController
});

ZcsCampaignEditStepScheduleController.$inject = ['$filter', '$scope', '$state'];
function ZcsCampaignEditStepScheduleController($filter, $scope, $state) {
  var vm = this;

  // these are to memorize the value while changing between custom/incentive
  var startAtObj = {};
  var endAtObj = {};

  this.$onInit = function () {
    vm.isNextDisabled = isNextDisabled;
    vm.isInvalidStart = isInvalidStart;
    vm.isInvalidEnd = isInvalidEnd;
    vm.setToNow = setToNow;
    vm.setToBeginningOfNextMonth = setToBeginningOfNextMonth;
    vm.setToBeginningOfNextNextMonth = setToBeginningOfNextNextMonth;
    vm.setToEndOfMonth = setToEndOfMonth;
    vm.setToEndOfNextMonth = setToEndOfNextMonth;
    vm.setToEndOfNextNextMonth = setToEndOfNextNextMonth;
    vm.setCustomSchedule = setCustomSchedule;
    vm.switchEndLimit = switchEndLimit;
    vm.campaign = vm.campaignEdit.campaign;
    vm.project = vm.campaignEdit.project;
    vm.incentive = vm.campaignEdit.incentive;

    vm.minStart = moment().startOf('day').toDate(); //FIXME: not working
    vm.minEnd = moment(vm.campaign.start_at).add(1, 'days').toDate(); //FIXME: not working

    // OEM has no end time limit by default
    if (vm.campaignEdit.isIntegratedWithMakeshop && vm.campaign.incentives.length === 0) {
      vm.campaign.is_infinite = true;
      vm.incentive.is_infinite = true;
    }

    if (!vm.campaign.timing) {
      $state.go('zenclerkS.project.campaign.edit.delivery', { apikey: vm.project.apikey, campaignId: vm.campaign.id });
    }

    if (vm.campaign.start_at) {
      startAtObj = createDateObject(vm.campaign.start_at);
    }
    if (vm.campaign.end_at) {
      endAtObj = createDateObject(vm.campaign.end_at);
    }

    $scope.$watch(function () {
      return vm.campaign.start_at_obj.date;
    }, function (newval) {
      if (vm.campaign.start_at_obj.date && !isValidTime(vm.campaign.start_at_obj.time)) {
        vm.campaign.start_at_obj.time = moment().hour() * 60;
      }
    });
    $scope.$watch(function () {
      return vm.campaign.end_at_obj.date;
    }, function (newval) {
      if (vm.campaign.is_infinite) return;
      if (vm.campaign.end_at_obj.date && !isValidTime(vm.campaign.end_at_obj.time)) {
        if (vm.campaignEdit.isOem) {
          vm.campaign.end_at_obj.time = 23 * 60; // for OEM the intervals are hourly based
        } else {
          vm.campaign.end_at_obj.time = 23 * 60 + 30;
        }
      }
    });
  };

  function isValidTime(time) {
    return angular.isNumber(time);
  }

  // TODO FIXME: make this unnecessary by developing better date/time component!
  function createDateObject(date) {
    var dateObj = $filter('dateToDateObj')(date);
    return dateObj;
  }

  function isInvalidStart() {
    return _.get(vm.campaign, 'start_at_obj.date') && vm.campaign.status === 'incomplete' && moment().startOf('day').valueOf() > vm.campaign.start_at_obj.date;
  }

  function isInvalidEnd() {
    return !vm.campaign.is_infinite && _.get(vm.campaign, 'start_at_obj.date') && _.get(vm.campaign, 'end_at_obj.date') && vm.campaign.start_at_obj.date > vm.campaign.end_at_obj.date;
  }

  function isNextDisabled() {
    return vm.campaign.useCustomSchedule && (!vm.campaign.start_at_obj.date || !isValidTime(vm.campaign.start_at_obj.time) || !vm.campaign.end_at_obj.date || !isValidTime(vm.campaign.end_at_obj.time));
  }

  function setToNow(dateObj) {
    dateObj.date = moment().startOf('day').valueOf();
    dateObj.time = moment().hours() * 60;
  }

  function setToBeginningOfNextMonth(dateObj) {
    dateObj.date = moment().add(1, 'month').startOf('month').valueOf();
    dateObj.time = 0;
  }

  function setToBeginningOfNextNextMonth(dateObj) {
    dateObj.date = moment().add(2, 'months').startOf('month').valueOf();
    dateObj.time = 0;
  }

  function setToEndOfMonth(dateObj) {
    dateObj.date = moment().endOf('month').startOf('day').valueOf();
    dateObj.time = 23 * 60;
  }

  function setToEndOfNextMonth(dateObj) {
    dateObj.date = moment().add(1, 'month').endOf('month').startOf('day').valueOf();
    dateObj.time = 23 * 60;
  }

  function setToEndOfNextNextMonth(dateObj) {
    dateObj.date = moment().add(2, 'months').endOf('month').startOf('day').valueOf();
    dateObj.time = 23 * 60;
  }

  function setCustomSchedule(val) {
    vm.campaign.useCustomSchedule = val;
    if (!vm.campaign.useCustomSchedule) {
      startAtObj = _.merge({}, vm.campaign.start_at_obj);
      endAtObj = _.merge({}, vm.campaign.end_at_obj);
      vm.setToIncentiveStart(vm.campaign.start_at_obj);
      vm.setToIncentiveEnd(vm.campaign.end_at_obj);
    } else {
      vm.campaign.start_at_obj = startAtObj;
      vm.campaign.end_at_obj = endAtObj;
    }
  }

  function switchEndLimit() {
    vm.incentive.is_infinite = !vm.incentive.is_infinite;
    vm.campaign.is_infinite = !vm.campaign.is_infinite;
  }
}

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsCampaignEditStepSegment', {
  templateUrl: '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_step_segment.html',
  require: {
    campaignEdit: '^zcsCampaignEdit'
  },
  controller: ZcsSegmentCampaignProposalsController
});

ZcsSegmentCampaignProposalsController.$inject = ['$state', 'ZcsProject', 'ZcsEstimator', 'ZcsSegment', 'Devise', 'ZcsOemService'];
function ZcsSegmentCampaignProposalsController($state, ZcsProject, ZcsEstimator, ZcsSegment, Devise, ZcsOemService) {
  var vm = this;

  vm.ZcsOemService = ZcsOemService;

  vm.$onInit = function () {
    vm.campaign = vm.campaignEdit.campaign;
    vm.project = vm.campaignEdit.project;

    // variables
    vm.segments = [];
    vm.estimatedCv = ZcsSegment.estimatedCv;
    // states
    if (vm.campaign.segment_id && vm.campaign.segment) {
      vm.selectedSegmentName = vm.campaign.segment.name;
    }

    vm.isActive = isActive;
    vm.isAllowedToSelect = isAllowedToSelect;
    vm.isCurrentSelected = isCurrentSelected;

    // actions
    vm.toggleSegment = toggleSegment;

    // for ability to select detailed sub cv segments
    vm.baseCvSegment = 'zcs_segment_cv_users';
    vm.subCvSegments = ['zcs_segment_one_cv', 'zcs_segment_loyal'];
    vm.allCvSegments = vm.subCvSegments.concat(vm.baseCvSegment);
    vm.allCvSegmentProposals = [];
    vm.selectedCvSegmentProposal = null;

    ZcsSegment.getProposals(vm.project).then(function (proposals) {
      vm.allCvSegmentProposals = _.filter(proposals, function (proposal) {
        return _.includes(vm.allCvSegments, proposal.name);
      });
      if (vm.campaign.segment && _.includes(vm.allCvSegments, vm.campaign.segment.name)) {
        vm.selectedCvSegmentProposal = _.find(vm.allCvSegmentProposals, function (proposal) {
          return proposal.name === vm.campaign.segment.name;
        });
      } else {
        vm.selectedCvSegmentProposal = _.find(vm.allCvSegmentProposals, function (proposal) {
          return proposal.name === vm.baseCvSegment;
        });
      }
      vm.proposals = _.chain(proposals).reject(function (proposal) {
        return _.includes(vm.subCvSegments, proposal.name);
      }).sortBy(function (proposal) {
        return -proposal.stats.estimatedMonthlyCouponRevenue;
      }).value();
      if (!vm.campaign.segment_id) {
        vm.selectedSegmentName = vm.proposals[0].name;
        vm.campaign.segment_id = vm.proposals[0].segment_id;
        vm.campaign.segment = vm.proposals[0].segment;
      }
    });
  };

  function isActive() {
    return vm.campaign.status !== 'incomplete' && moment().isAfter(moment(vm.campaign.start_at));
  }

  function isAllowedToSelect(segment) {
    var changingAllowedSegments = ['zcs_segment_all', 'zcs_segment_new', 'zcs_segment_cv_users', 'zcs_segment_one_cv', 'zcs_segment_loyal'];

    if (!isActive()) {
      return true;
    }

    if (vm.campaign.segment && _.includes(changingAllowedSegments, vm.campaign.segment.name)) {
      return segment.name !== 'zcs_segment_mail_only';
    } else if (vm.campaign.segment && vm.campaign.segment.name === 'zcs_segment_mail_only') {
      return segment.name === 'zcs_segment_mail_only';
    }
    return false;
  }

  function isCurrentSelected(segment) {
    if (_.includes(vm.subCvSegments, vm.selectedSegmentName)) {
      return segment.name === vm.baseCvSegment;
    }
    return segment.name === vm.selectedSegmentName;
  }

  function toggleSegment(segmentProposal) {
    if (isAllowedToSelect(segmentProposal)) {
      if (segmentProposal.name === vm.baseCvSegment) {
        segmentProposal = vm.selectedCvSegmentProposal;
      }

      vm.selectedSegmentName = segmentProposal.name;
      vm.campaign.segment_id = segmentProposal.segment_id;
      vm.campaign.segment = segmentProposal.segment;
    }
  }
}

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsIntegratedCouponList', {
  templateUrl: '/templates/zenclerk_s/sites/campaigns/integrated_coupon/list.html',
  bindings: {
    project: '='
  },
  controller: ZcsIntegratedCouponListController
});

ZcsIntegratedCouponListController.$inject = ['ZcsMakeshopApi', 'currencies'];
function ZcsIntegratedCouponListController(ZcsMakeshopApi, currencies) {
  var vm = this;

  /* variables */
  vm.coupons = [];
  vm.currency = currencies[vm.project.currency];

  vm.$onInit = function () {
    ZcsMakeshopApi.searchCoupons(vm.project).then(function (coupons) {
      vm.coupons = coupons;
    });
  };
}

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals sift */
// TODO: this and the component use same name, although this uses list.html >_<
angular.module('zc.zenclerkS').controller('ZcsCampaignsListController', ZcsCampaignsListController);

ZcsCampaignsListController.$inject = ['Campaign', 'Devise', 'ProjectExcludeIp', 'ZcsIncentive', 'ZcsOemService', 'project'];
function ZcsCampaignsListController(Campaign, Devise, ProjectExcludeIp, ZcsIncentive, ZcsOemService, project) {
  var vm = this;

  vm.ZcsOemService = ZcsOemService;
  vm.project = project;
  vm.hasActiveCampaigns = true;
  vm.activeFilters = Campaign.activeFilters();
  vm.incompleteFilters = Campaign.incompleteFilters();
  vm.excludeIps = null;
  vm.isActiveProject = vm.project.terminated_at === null;
  vm.isOemProject = vm.project.is_oem;
  vm.isMaster = Devise.isMaster();

  vm.$onInit = function () {
    ProjectExcludeIp.all(vm.project.id).then(function (excludeIps) {
      vm.excludeIps = excludeIps;
    });
  };

  Campaign.all({ projectId: vm.project.id }).then(function (res) {
    var activeCampaigns = sift(vm.activeFilters, res);
    var incompleteCampaigns = sift(vm.incompleteFilters, res);
    vm.incompleteCampaigns = incompleteCampaigns;

    vm.hasActiveCampaigns = activeCampaigns.length > 0 || incompleteCampaigns.length > 0;
  });
  ZcsIncentive.all(vm.project.id).then(function (res) {
    vm.incentives = res;
  });
}

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals sift */
angular.module('zc.zenclerkS').component('zcsCampaignsList', {
  templateUrl: '/templates/zenclerk_s/sites/campaigns/list/campaigns_list.html',
  bindings: {
    project: '<',
    filters: '<',
    titles: '<'
  },
  controller: zcsCampaignsListController
});

zcsCampaignsListController.$inject = ['$filter', '$q', '$scope', '$state', 'Project', 'Campaign', 'CampaignStats', 'ReportCampaignStats', 'ReportRange'];
function zcsCampaignsListController($filter, $q, $scope, $state, Project, Campaign, CampaignStats, ReportCampaignStats, ReportRange) {
  var vm = this;

  vm.$onInit = function () {
    vm.pagination = {
      itemsPerPage: 25,
      currentPage: 1
    };
    vm.Project = Project;

    vm.showStats = true;
    vm.campaigns = [];

    vm.pageChanged = pageChanged;
    vm.removeCampaign = removeCampaign;

    Campaign.all({ projectId: vm.project.id }).then(function (res) {
      vm.campaigns = sift(vm.filters, res);
      vm.campaigns = _.chain(vm.campaigns).sortBy(function (d) {
        return -new Date(d.start_at);
      }).value();
      pageChanged();
    });
  };

  function pageChanged() {
    vm.pagedCampaigns = _.chain(vm.campaigns)
    //.filter((d) ->
    //  d.start_at > moment().subtract(2, 'months').toDate()
    //)
    //.sortBy((d) -> -d.start_at.valueOf())
    .value();
    //begin = scope.pagination.itemsPerPage * (scope.pagination.currentPage-1)
    //end = begin + scope.pagination.itemsPerPage
    //scope.pagedCampaigns = scope.pagedCampaigns.slice begin, end
  }

  function removeCampaign(campaign) {
    var index = _.findIndex(vm.campaigns, campaign);
    vm.campaigns.splice(index, 1);
  }

  $scope.$watch('$ctrl.filters', function (newValue) {
    if (!newValue) {
      return;
    }
    vm.filters = newValue;
    vm.pageChanged();
  }, true);
}

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

angular.module('zc.zenclerkS').component('zcsCampaignsListItem', {
  require: ['?campaign', '?filters'],
  bindings: {
    project: '<',
    campaign: '<',
    filters: '<',
    onUpdate: '&'
  },
  templateUrl: '/templates/zenclerk_s/sites/campaigns/list/item.html',
  controller: zcsCampaignCardController
});

zcsCampaignCardController.$inject = ['$filter', '$q', '$state', '$translate', 'Devise', 'Campaign', 'CampaignStatsV2', 'ReportCampaignStats', 'Project', 'campaignStatuses', 'currencies', 'ZcsCampaignStats', 'ZcsEstimator'];
function zcsCampaignCardController($filter, $q, $state, $translate, Devise, Campaign, CampaignStatsV2, ReportCampaignStats, Project, campaignStatuses, currencies, ZcsCampaignStats, ZcsEstimator) {

  var vm = this;
  var state = void 0;

  vm.$onInit = function () {
    vm.state = {}; // Keep tracking of the states of elements
    vm.Project = Project;
    vm.Devise = Devise;
    vm.currency = currencies[vm.project.currency];
    vm.state = {}; // Keep tracking of the states of elements

    vm.startAt = moment(vm.campaign.start_at).startOf('day');
    vm.chartStartAt = moment(vm.campaign.start_at).startOf('day');

    if (moment(vm.campaign.end_at).isBefore(moment())) {
      if (moment(vm.campaign.end_at).subtract(1, 'month').startOf('day').isBefore(moment(vm.campaign.start_at))) {
        vm.chartStartAt = moment(vm.campaign.start_at);
      } else {
        vm.chartStartAt = moment(vm.campaign.end_at).subtract(1, 'month');
      }
    } else if (moment().subtract(1, 'month').startOf('day').isAfter(vm.startAt)) {
      // Show last month by default
      vm.chartStartAt = moment().subtract(1, 'month').startOf('day');
    }

    vm.startAt = vm.startAt.toDate();
    vm.canShow = !['incomplete', 'preview', 'pending'].includes(vm.campaign.current_status);
    vm.canEdit = ['incomplete', 'preview', 'pending'].includes(vm.campaign.current_status);
    vm.canDestroy = ['incomplete', 'preview'].includes(vm.campaign.status);
    vm.currentStatusText = campaignStatuses[vm.campaign.current_status].text;
    vm.isStarted = vm.campaign.start_at_obj.date >= Date.now();
    vm.isPastCampaign = vm.campaign.end_at && moment(vm.campaign.end_at).isBefore();
    vm.showStats = !['incomplete', 'preview', 'pending'].includes(vm.campaign.current_status);
    vm.totalDeliveryCount = 0;
    vm.totalConversionCount = 0;
    vm.goToSummary = goToSummary;
    vm.chartData = {};
    vm.goToEdit = goToEdit;
    vm.goToConfirm = goToConfirm;
    vm.removeCampaign = removeCampaign;

    // set the current end date (in timestamp) if the campaign is not finish yet
    vm.chartEndAt = vm.campaign.end_at_obj.date > Date.now() ? Date.now() : vm.campaign.end_at_obj.date;
    vm.currentEnd = moment(vm.campaign.end_at_obj.date).startOf('day').toDate();

    prepareChartData();
  };

  function prepareChartData() {
    // For anything before 2016-12-01, we need to use CampaignStatsV2 (from zenclerk).
    // After 2016-12-01 we will use the new zcs shuukei
    var campaignStatsStart = moment(vm.startAt).isBefore(moment('2016-12-01')) ? moment(vm.startAt).toDate() : false;
    var campaignStatsEnd = moment(vm.campaign.end_at).isAfter(moment('2016-12-01')) ? moment('2016-12-01').toDate() : moment(vm.campaign.end_at).toDate();

    var zcsCampaignStatsStart = moment(vm.startAt).isBefore(moment('2016-12-01')) ? moment('2016-12-01').toDate() : moment(vm.startAt).toDate();
    var zcsCampaignStatsEnd = moment(vm.campaign.end_at).isBefore(moment('2016-12-01')) ? false : moment(vm.campaign.end_at).toDate();

    var campaignStatsV2Promise = campaignStatsStart ? CampaignStatsV2.find({
      dimension: 'daily',
      apikey: vm.project.apikey
    }, {
      campaign_id: vm.campaign.id,
      is_control: false,
      start_at: {
        $gte: campaignStatsStart,
        $lt: campaignStatsEnd
      }
    }) : $q.resolve([]);

    var zcsCampaignStatsPromise = zcsCampaignStatsEnd ? ZcsCampaignStats.find({
      dimension: 'daily',
      apikey: vm.project.apikey
    }, {
      campaign_id: vm.campaign.id,
      start_at: {
        $gte: zcsCampaignStatsStart,
        $lt: zcsCampaignStatsEnd
      }
    }) : $q.resolve([]);

    $q.all([campaignStatsV2Promise, zcsCampaignStatsPromise]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          campaignStats = _ref2[0],
          zcsCampaignStats = _ref2[1];

      vm.totalDeliveryCount = _.sumBy(campaignStats, function (d) {
        return d.delivery_count;
      }) + _.sumBy(zcsCampaignStats, function (d) {
        return d.delivery_count;
      });
      vm.totalConversionCount = _.sumBy(campaignStats, function (d) {
        return d.conversion_count;
      }) + _.sumBy(zcsCampaignStats, function (d) {
        return d.effective_conversion_count;
      });
      vm.totalConversionPrice = _.sumBy(campaignStats, function (d) {
        return d.conversion_price;
      }) + _.sumBy(zcsCampaignStats, function (d) {
        return d.effective_conversion_price;
      });
      vm.totalConversionPercentage = vm.totalConversionCount / vm.totalDeliveryCount * 100;
      vm.averageConversionPrice = vm.totalConversionPrice / vm.totalConversionCount;

      var deliveriesByDate = _.groupBy(campaignStats, function (d) {
        return moment(d.start_at).format('YYYY-MM-DD');
      });
      deliveriesByDate = populateMissingDate(deliveriesByDate, 'delivery_count', vm.chartStartAt, vm.chartEndAt);

      var zcsDeliveriesByDate = _.groupBy(zcsCampaignStats, function (d) {
        return moment(d.start_at).format('YYYY-MM-DD');
      });
      zcsDeliveriesByDate = populateMissingDate(zcsDeliveriesByDate, 'delivery_count', vm.chartStartAt, vm.chartEndAt);

      deliveriesByDate = deliveriesByDate.concat(zcsDeliveriesByDate);
      // chart data array
      vm.chartData.delivery = [{
        values: deliveriesByDate,
        label: $translate.instant('sites.campaigns.list.itemDirective.deliveryCount')
      }];

      //# Conversion
      var conversionByDate = _.groupBy(campaignStats, function (d) {
        return moment(d.start_at).format('YYYY-MM-DD');
      });
      conversionByDate = populateMissingDate(conversionByDate, 'conversion_count', vm.chartStartAt, vm.chartEndAt);

      var zcsConversionByDate = _.groupBy(zcsCampaignStats, function (d) {
        return moment(d.start_at).format('YYYY-MM-DD');
      });
      zcsConversionByDate = populateMissingDate(zcsConversionByDate, 'effective_conversion_count', vm.chartStartAt, vm.chartEndAt);

      conversionByDate = conversionByDate.concat(zcsConversionByDate);

      // chart data array
      vm.chartData.conversion = [{
        values: conversionByDate,
        label: vm.project.invoice_calculation_type === 'normal' ? $translate.instant('sites.campaigns.list.itemDirective.couponUsedCount') : $translate.instant('sites.campaigns.list.itemDirective.convertedUser')
      }];
    });
  }

  function goToSummary() {
    if (!vm.canShow) {
      return false;
    }
    $state.go('zenclerkS.project.campaign.summary', { apikey: vm.project.apikey, campaignId: vm.campaign.id });
  }

  function goToEdit(step) {
    state = 'admin.projects.campaigns.edit';
    if (step) {
      state += '.' + step;
    }
    return $state.go(state, { campaignId: vm.campaign.id });
  }

  function goToConfirm() {
    $state.go('admin.projects.campaigns.confirm', { campaignId: vm.campaign.id });
  }

  // function to populate empty value
  function populateMissingDate(data, dataKey, startAt, endAt) {
    var dateKeys = [];
    var date = void 0;
    if (moment(startAt).isBefore(endAt)) {
      date = moment(startAt).valueOf();
    } else {
      date = moment(endAt).valueOf();
    }
    var lastDate = moment(endAt).add(1, 'days').valueOf();
    while (date <= lastDate) {
      dateKeys.push(moment(date).format('YYYY-MM-DD'));
      date = moment(date).add(1, 'days').valueOf();
    }

    data = _.map(dateKeys, function (dateKey) {
      if (data[dateKey]) {
        return { x: dateKey, y: _.sumBy(data[dateKey], function (d) {
            return d[dataKey];
          }) };
      }
      return { x: dateKey, y: 0 };
    });
    return data;
  }

  // FIXME: copypaste from campaign_action_menu
  function removeCampaign(campaign) {
    var campaignObject = _.merge({}, campaign);
    if (campaignObject.status === 'incomplete') {
      // If it has not ran yet, destroy (note that we also exclude preview because
      // it has been in publish.js and there can be data with that campaign id)
      return Campaign.destroy({ projectId: vm.project.id, campaignId: campaignObject.id }).then(function (res) {
        return $state.go('zenclerkS.project.campaigns.draft', { apikey: vm.project.apikey }, { reload: true });
      });
    }

    // Otherwise, make it terminated
    // Note, we need to use "terminate" because just updating status
    // would not set end_at to the moment it was terminated!
    return Campaign.terminate({ projectId: vm.project.id, campaignId: campaignObject.id }, campaignObject).then(function (res) {
      campaign.status = 'terminated';
      $state.go('zenclerkS.project.campaigns.active', { apikey: vm.project.apikey }, { reload: true });
    });
  }
}

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsMailMagUrlModalController', ZcsMailMagUrlModalController);

ZcsMailMagUrlModalController.$inject = ['$uibModalInstance', 'Campaign', 'campaign', 'project'];
function ZcsMailMagUrlModalController($uibModalInstance, Campaign, campaign, project) {
  var vm = this;
  vm.campaign = campaign;
  vm.project = project;
  vm.landingPage = project.base_url; // set to project base_url by default
  vm.getLandingPageUrlWithParameter = getLandingPageUrlWithParameter;

  function getLandingPageUrlWithParameter() {
    return Campaign.showsAllUrl(vm.landingPage, vm.campaign);
  }

  vm.close = function () {
    $uibModalInstance.close();
  };
}

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsPreviewLinkModalController', ZcsPreviewLinkModalController);

ZcsPreviewLinkModalController.$inject = ['$uibModalInstance', 'Campaign', 'campaign', 'project'];
function ZcsPreviewLinkModalController($uibModalInstance, Campaign, campaign, project) {
  var vm = this;
  vm.campaign = campaign;
  vm.project = project;
  vm.previewUrl = Campaign.previewUrl(vm.project.base_url, vm.campaign);

  vm.close = function () {
    $uibModalInstance.close();
  };
}

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

angular.module('zc.zenclerkS').component('zcsCampaignSummary', {
  bindings: {
    campaign: '<',
    project: '<'
  },
  templateUrl: '/templates/zenclerk_s/sites/campaigns/show/summary.html',
  controller: zcsCampaignSummaryController
});

zcsCampaignSummaryController.$inject = ['$filter', '$q', '$scope', '$state', '$uibModal', '$translate', 'Campaign', 'CampaignStatsV2', 'Incentive', 'SearchFilter', 'ZcsAccessStats', 'ZcsCampaign', 'ZcsCampaignStats', 'currencies'];
function zcsCampaignSummaryController($filter, $q, $scope, $state, $uibModal, $translate, Campaign, CampaignStatsV2, Incentive, SearchFilter, ZcsAccessStats, ZcsCampaign, ZcsCampaignStats, currencies) {
  var vm = this;
  var region = vm.project.region;

  var allowedDimensions = {
    hourly: {
      moment: 'hours',
      format: 'YYYY-MM-DD HH:00'
    },
    daily: {
      moment: 'days',
      format: 'YYYY-MM-DD 00:00'
    },
    monthly: {
      moment: 'months',
      format: 'YYYY-MM-DD'
    }
  };

  function isBeginningOfTheMonth(date) {
    return +moment.tz(date, region) === +moment.tz(date, region).startOf('month');
  }

  vm.$onInit = function () {
    var defaultMonth = _.min([$filter('changeDatetimeFrom')('localToRegion', vm.campaign.end_at, 'date', region), moment.tz(region).toDate()]);

    /**
     * Use previous month as the default month filter IF
     *  - the ending date of the campaign is right at the beginning of a month (therefore having no data).
     */
    if (isBeginningOfTheMonth(defaultMonth)) {
      defaultMonth = $filter('changeDatetimeFrom')('localToRegion', vm.campaign.end_at, 'moment', region).subtract(1, 'months').toDate();
    }

    // filter default values
    var filterDefaults = {
      month: {
        default: moment.tz(defaultMonth, region).startOf('month').format('YYYY-MM-DD')
      },
      dimension: {
        default: 'daily'
      },
      main_chart: {
        default: 'conversionPrice'
      }
    };

    vm.firstDataDay = moment.tz(ZcsCampaign.FIST_DATA_DAY, region).toDate();
    vm.firstDataDayInJapanese = moment.tz(vm.firstDataDay, region).format($translate.instant('sites.campaigns.show.summary.yearMonthFormat'));

    vm.filters = SearchFilter.resolveFromLocation();

    SearchFilter.setComponentDefaults('campaignSummary', filterDefaults);

    $scope.$on('$destroy', function () {
      SearchFilter.removeComponentDefaults('campaignSummary');
    });

    vm.totalPeriodStartAt = moment.tz(vm.campaign.start_at, region).startOf('day').valueOf();
    vm.totalPeriodEndAt = vm.campaign.end_at_obj.date > Date.now() ? moment.tz(region).startOf('hour').valueOf() : vm.campaign.end_at.valueOf();

    vm.currency = currencies[vm.project.currency];
    vm.copyCampaign = copyCampaign;
    vm.isAllowedLiteTemplate = isAllowedLiteTemplate;
    vm.isCampaignEndingSoon = ZcsCampaign.isCampaignEndingSoon;
    vm.campaignProgress = ZcsCampaign.getCampaignProgress(vm.campaign);

    vm.defaultFreeShippingCost = 500;

    vm.goToPeriod = goToPeriod;
    vm.setDimension = setDimension;
    vm.setFreeShippingCost = setFreeShippingCost;

    vm.hasNextMonth = hasNextMonth;
    vm.hasPrevMonth = hasPrevMonth;
    vm.hasReachedTheEnd = hasReachedTheEnd;
    vm.setSelectedChart = setSelectedChart;
    vm.isCurrentMonth = isCurrentMonth;

    vm.isCampaignStartedToday = isCampaignStartedToday;

    vm.resumeCampaign = resumeCampaign;
    vm.getMonthlyConversionPercentage = getMonthlyConversionPercentage;

    vm.invoicesPage = $state.href('zenclerkS.project.invoices', { projectId: vm.project.apikey });

    updateData().then(function () {
      // do this only once
      createMonthlyConversionsChartData();
    });
  };

  function getCampaignStats(dimension) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var startAt = opts.start_at || vm.startAt;
    var endAt = opts.end_at || vm.currentEnd;

    if (dimension === 'monthly') {
      startAt = moment.tz(vm.totalPeriodStartAt, region).startOf('month').valueOf();
      endAt = vm.totalPeriodEndAt;
    }

    return ZcsCampaignStats.find({
      apikey: vm.project.apikey,
      dimension: dimension
    }, {
      campaign_id: vm.campaign.id,
      start_at: {
        $gte: startAt,
        $lt: endAt
      }
    });
  }

  function setDimension(dimension) {
    vm.filters.dimension = dimension;
    updateFilters();
  }

  function updateData() {
    vm.startAt = _.max([moment.tz(vm.filters.month, region).startOf('month').valueOf(), moment.tz(vm.campaign.start_at, region).startOf('day').valueOf()] // TODO: in case of hour...
    );
    vm.currentEnd = _.min([moment.tz(vm.filters.month, region).endOf('month').valueOf(), moment.tz(region).startOf('hour').valueOf()]);

    return Promise.all([getCampaignStats(vm.filters.dimension), ZcsAccessStats.getAccessStatsForSegment(vm.project.apikey, vm.campaign.segment_id, vm.startAt, vm.currentEnd)]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          campaignStats = _ref2[0],
          accessStats = _ref2[1];

      vm.fetchedCampaignStats = campaignStats;
      vm.fetchedAccessStats = accessStats;
      calculateAllCosts();

      vm.mainChartData = getMainChartData(vm.filters.main_chart, vm.fetchedCampaignStats);
    });
  }

  function calculateAllCosts() {
    vm.segmentStats = {};
    vm.campaignStats = {};

    vm.campaignStats.conversionPrice = _.sumBy(vm.fetchedCampaignStats, function (d) {
      return d.effective_conversion_price;
    });
    vm.campaignStats.conversionCount = _.sumBy(vm.fetchedCampaignStats, function (d) {
      return d.effective_conversion_count;
    });

    if (!vm.campaign.incentives[0].discount_type || vm.campaign.incentives[0].discount_type === 'none') {
      vm.campaignStats.couponCost = vm.campaignStats.conversionCount * (vm.project.free_shipping_cost || vm.defaultFreeShippingCost);
    } else {
      vm.campaignStats.couponCost = _.sumBy(vm.fetchedCampaignStats, function (d) {
        return d.coupon_cost;
      });
    }

    vm.campaignStats.grossMargin = _.sumBy(vm.fetchedCampaignStats, function (d) {
      return d.effective_conversion_price * d.profit_rate;
    });
    vm.campaignStats.salesCost = _.sumBy(vm.fetchedCampaignStats, function (d) {
      return d.effective_conversion_price * (1 - d.profit_rate);
    });
    vm.campaignStats.zcFeeTaxIncluded = _.sumBy(vm.fetchedCampaignStats, function (d) {
      return d.zc_fee_tax_included;
    });
    vm.campaignStats.campaignProfit = _.sumBy(vm.fetchedCampaignStats, function (d) {
      return d.profit;
    }); // NOTE: not used. Calculated is more correct in case of free_shipping
    vm.campaignStats.campaignProfitCalculated = vm.campaignStats.grossMargin - vm.campaignStats.couponCost - vm.campaignStats.zcFeeTaxIncluded;
    vm.campaignStats.deliveryCount = _.sumBy(vm.fetchedCampaignStats, function (d) {
      return d.delivery_count;
    });
    vm.campaignStats.conversionPercent = vm.campaignStats.conversionCount / vm.campaignStats.deliveryCount * 100 || 0;
    vm.campaignStats.averagePurchase = vm.campaignStats.conversionPrice / vm.campaignStats.conversionCount || 0;
    vm.campaignStats.fee_rate = _.get(vm.fetchedCampaignStats, 'fee_rate', vm.project.fee_rate) * 100;

    vm.segmentStats.sessionCount = _.sumBy(vm.fetchedAccessStats, function (d) {
      return d.session_count;
    });
    vm.segmentStats.conversionCount = _.sumBy(vm.fetchedaccessStats, function (d) {
      return d.conversion_count;
    });
    vm.segmentStats.conversionPrice = _.sumBy(vm.fetchedaccessStats, function (d) {
      return d.conversion_price;
    });
    vm.segmentStats.conversionPercent = vm.segmentStats.conversionCount / vm.segmentStats.sessionCount * 100;
    vm.segmentStats.averagePurchase = vm.segmentStats.conversionPrice / vm.segmentStats.conversionCount;
    vm.segmentStats.campaignDeliveryPercent = vm.campaignStats.deliveryCount / vm.segmentStats.sessionCount * 100;
  }

  function setSelectedChart(chartType) {
    if (vm.filters.main_chart !== chartType) {
      vm.filters.main_chart = chartType;
      updateFilters();
    }
  }

  function updateFilters() {
    SearchFilter.set(vm.filters);
    SearchFilter.updateComponentDefaults('campaignSummary');
    updateData();
  }

  function goToPeriod(month, direction) {
    if (direction === 'prev') {
      if (!hasPrevMonth()) return;
      vm.filters.month = moment.tz(month, region).subtract(1, 'month').format('YYYY-MM-DD');
    } else if (direction === 'next') {
      if (!hasNextMonth()) return;
      vm.filters.month = moment.tz(month, region).add(1, 'month').format('YYYY-MM-DD');
    } else {
      vm.filters.month = moment.tz(month, region).format('YYYY-MM-DD');
    }
    updateFilters();
  }

  function getMainChartData(selectedData, data) {
    if (selectedData === 'conversions') {
      var campaignStatsByDate = _.groupBy(data, function (d) {
        return moment(d.start_at).format('YYYY-MM-DD HH:00');
      });
      var campaignByDate = generateChartData(vm.filters.dimension, campaignStatsByDate, 'delivery_count', vm.startAt, vm.currentEnd, ['effective_conversion_count']);
      var conversionByDate = generateChartData(vm.filters.dimension, campaignStatsByDate, 'effective_conversion_count', vm.startAt, vm.currentEnd);
      // chart data array
      return [{
        values: conversionByDate,
        key: $translate.instant('sites.campaigns.show.summary.cvCount')
      }, {
        values: campaignByDate,
        key: $translate.instant('sites.campaigns.show.summary.couponDeliveryCount')
      }];
    }

    if (selectedData === 'conversionPrice') {
      var _campaignStatsByDate = _.groupBy(data, function (d) {
        return moment(d.start_at).format('YYYY-MM-DD HH:00');
      });
      var conversionPriceByDate = generateChartData(vm.filters.dimension, _campaignStatsByDate, 'effective_conversion_price', vm.startAt, vm.currentEnd);
      // chart data array
      return [{
        values: conversionPriceByDate,
        key: $translate.instant('sites.campaigns.show.summary.conversionPrice')
      }];
    }

    if (selectedData === 'conversionPriceCumulative') {
      var _campaignStatsByDate2 = _.groupBy(data, function (d) {
        return moment(d.start_at).format('YYYY-MM-DD HH:00');
      });
      var _conversionPriceByDate = generateChartData(vm.filters.dimension, _campaignStatsByDate2, 'effective_conversion_price', vm.startAt, vm.currentEnd);

      var total = 0;
      var existingConversionPrice = [];
      _.each(_conversionPriceByDate, function (d) {
        var newItem = _.merge({}, d);
        newItem.y = total;
        total = total + d.y;
        existingConversionPrice.push(newItem);
      });

      // chart data array
      return [{
        values: existingConversionPrice,
        key: $translate.instant('sites.campaigns.show.summary.existingConversionPrice')
      }, {
        values: _conversionPriceByDate,
        key: $translate.instant('sites.campaigns.show.summary.conversionPriceByDate')
      }];
    }
  }

  function createMonthlyConversionsChartData() {
    $q.all([getCampaignStats('monthly')]).then(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 1),
          monthlyStats = _ref4[0];

      var conversionPriceByDate = _.groupBy(monthlyStats, function (d) {
        return moment(d.start_at).format('YYYY-MM-DD');
      });
      var conversionParamName = 'effective_conversion_price';
      conversionPriceByDate = generateChartData('monthly', conversionPriceByDate, conversionParamName, vm.totalPeriodStartAt, vm.totalPeriodEndAt);

      vm.maxMonthlyPrice = _.maxBy(conversionPriceByDate, 'y').y;
      vm.monthlyConversionChartData = conversionPriceByDate;
    });
  }

  function hasReachedTheEnd() {
    return moment.tz(vm.filters.month, 'YYYY-MM-DD', region).subtract(1, 'month').isBefore(moment.tz(vm.firstDataDay, region));
  }

  function hasPrevMonth() {
    var maxDate = _.max([vm.firstDataDay, moment.tz(vm.campaign.start_at, region).startOf('month')]);
    return moment.tz(vm.filters.month, 'YYYY-MM-DD', region).subtract(1, 'month').isSameOrAfter(moment.tz(maxDate, region));
  }

  function hasNextMonth() {
    var maxDate = _.min([moment.tz(region).toDate(), moment.tz(vm.campaign.end_at, region).toDate()]);
    return moment.tz(vm.filters.month, 'YYYY-MM-DD', region).add(1, 'month').isBefore(moment.tz(maxDate, region));
  }

  function generateDateRange(dimension, startAt, endAt) {
    if (!_.has(allowedDimensions, dimension)) {
      console.warn('Invalid dimension given! Valid dimensions are: ' + Object.keys(allowedDimensions).join(', '));
      return;
    }

    var dateRange = [];
    var date = getFirstDate(startAt);
    var lastDate = getLastDate(endAt);
    while (date <= lastDate) {
      dateRange.push(moment.tz(date, region).format(allowedDimensions[dimension].format));
      date = moment.tz(date, region).add(1, allowedDimensions[dimension].moment).valueOf();
    }

    // remove the last month from dateRange if the campaigns ending date is the first day of the month eg. 2017-05-01 00:00
    if (dimension === 'monthly' && isBeginningOfTheMonth(lastDate)) {
      dateRange.pop();
    }

    return dateRange;
  }

  function getFirstDate(startAt) {
    return moment.tz(startAt, region).startOf('month').valueOf();
  }

  function getLastDate(endAt) {
    return moment.tz(endAt, region).endOf('month').valueOf();
  }

  function generateChartData(dimension, dateKeys, paramToBeSummed, startAt, endAt, paramsToBeSubtracted) {
    if (angular.isString(paramsToBeSubtracted)) {
      paramsToBeSubtracted = [paramsToBeSubtracted];
    }

    var dateRange = generateDateRange(dimension, startAt, endAt);

    // generate x and y values for each date in range
    var data = _.map(dateRange, function (dateKey) {
      if (!dateKeys[dateKey]) {
        return { x: moment(dateKey, allowedDimensions[dimension].format).toDate(), y: 0 };
      }

      var y = _.sumBy(dateKeys[dateKey], function (d) {
        return d[paramToBeSummed];
      });

      // subtract any given parameter values from y value.
      if (paramsToBeSubtracted) {
        _.forEach(paramsToBeSubtracted, function (subtractParam) {
          y -= _.sumBy(dateKeys[dateKey], function (d) {
            return d[subtractParam];
          });
        });
      }

      // dont allow negative y values
      if (y < 0) {
        y = 0;
      }
      if (paramToBeSummed !== 'effective_conversion_count' && paramToBeSummed !== 'delivery_count') {
        y = y / Math.pow(10, vm.currency.fractionSize);
      }

      return { x: moment(dateKey, allowedDimensions[dimension].format).toDate(), y: y };
    });
    return data;
  }

  function isCampaignStartedToday() {
    return moment.tz(region).startOf('day').isSame(moment.tz(vm.campaign.start_at, region).startOf('day'));
  }

  // duplicate campaign
  function copyCampaign() {
    var campaignObject = _.merge({}, vm.campaign);

    return Campaign.copy({ projectId: vm.project.id, campaignId: campaignObject.id }, campaignObject).then(function (res) {
      return $state.go('zenclerkS.project.campaigns.draft', { apikey: vm.project.apikey }, { reload: true });
    });
  }

  function isAllowedLiteTemplate() {
    return ZcsCampaign.isAllowedLiteTemplate(vm.campaign, vm.project);
  }

  function isCurrentMonth(month) {
    return moment.tz(month, region).isSame(moment.tz(vm.filters.month, 'YYYY-MM', region));
  }

  function getMonthlyConversionPercentage() {
    var dataOfMonth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    dataOfMonth = dataOfMonth | 0;
    var percentage = dataOfMonth / vm.maxMonthlyPrice * 100;
    var minimumPercentage = 2;

    return percentage < minimumPercentage ? minimumPercentage : percentage;
  }

  function setFreeShippingCost() {
    var modalInstance = $uibModal.open({
      templateUrl: '/templates/zenclerk_s/directives/project/free_shipping_cost_editor/free_shipping_cost_editor.html',
      controller: 'ZcsFreeShippingCostEditorController',
      controllerAs: '$ctrl',
      size: 'sm',
      resolve: {
        project: vm.project
      }
    });

    modalInstance.result.then(function () {
      // update the prices
      calculateAllCosts();
    });
  }

  // toggle campaign state TODO: DRYme into campaign service
  function resumeCampaign() {
    return Campaign.toggleActive({
      projectId: vm.campaign.project_id,
      campaignId: vm.campaign.id,
      state: true
    }).then(function (res) {
      if (res.data.success) {
        vm.campaign.status = 'activated';
        var currentStatus = $filter('currentStatus')(vm.campaign);
        vm.campaign.current_status = currentStatus;
        return true;
      }
    });
  }
}

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* globals sift */
angular.module('zc.zenclerkS').component('zcsDashboardMain', {
  templateUrl: '/templates/zenclerk_s/sites/dashboard/dashboard-main.html',
  bindings: {
    project: '<'
  },
  controller: zcsDashboardMainController
});

zcsDashboardMainController.$inject = ['$compile', '$element', '$location', '$scope', 'Campaign'];
function zcsDashboardMainController($compile, $element, $location, $scope, Campaign) {
  var vm = this;

  var ALLOWED_MODES = {
    tag_setup_unfinished: 0,
    no_first_campaign: 1,
    no_active_campaigns: 2,
    setup_done_active_campaign: 3
  };

  vm.$onInit = function () {
    Campaign.all({ projectId: vm.project.id }).then(function (campaigns) {
      vm.campaigns = campaigns;
      vm.widgets = getVisibleWidgets();
      // generate widgets dynamically to avoid doing any ng-switch non-DRY solution
      _.each(vm.widgets, function (widget) {
        var maxHeight = widget.maxHeight || '500px';
        var template = '\n          <div class="widget-base col-md-' + widget.colWidth + ' ' + widget.widgetName + '-wrapper">\n            <div\n              class="widget-inner ' + widget.widgetName + '"\n              ng-class="{\n                shadow: ' + widget.useShadow + ',\n              }"\n              style="max-height: ' + maxHeight + '">\n              <zcs-dashboard-widget-' + widget.widgetName + '>\n              </zcs-dashboard-widget-' + widget.widgetName + '>\n            </div>\n          </div>\n        ';
        $element.find('.widget-list').append($compile(template)($scope));
      });
    });
  };

  function getVisibleWidgets() {
    var modeToBeEnabled = void 0;
    var activeCampaigns = sift(Campaign.activeFilters(), vm.campaigns);
    var isHideCharts = ['color_me_shop', 'shopify'].includes(vm.project.integrated_with) || vm.project.fixed_invoice_amount;

    if (!vm.project.tracking_tag_confirmed_at || !vm.project.conversion_tag_confirmed_at) {
      modeToBeEnabled = ALLOWED_MODES.tag_setup_unfinished;
    } else if (vm.campaigns.length === 0) {
      modeToBeEnabled = ALLOWED_MODES.no_first_campaign;
    } else if (activeCampaigns.length === 0) {
      modeToBeEnabled = ALLOWED_MODES.no_active_campaigns;
    } else if (activeCampaigns.length > 0) {
      modeToBeEnabled = ALLOWED_MODES.setup_done_active_campaign;
    }

    if (modeToBeEnabled === ALLOWED_MODES.setup_done_active_campaign) {
      return [].concat(_toConsumableArray(isHideCharts ? {} : [{
        widgetName: 'site-status',
        colWidth: 8
      }, {
        widgetName: 'realtime',
        colWidth: 4
      }]), [{
        widgetName: 'campaign-list-title',
        colWidth: 12
      }, {
        widgetName: 'campaign-list',
        colWidth: 12
      }]);
    } else if (modeToBeEnabled === ALLOWED_MODES.no_active_campaigns) {
      return [].concat(_toConsumableArray(isHideCharts ? {} : [{
        widgetName: 'site-status',
        colWidth: 8
      }, {
        widgetName: 'realtime',
        colWidth: 4
      }]), [{
        widgetName: 'no-active-campaign',
        colWidth: 12,
        useShadow: true
      }]);
    } else if (modeToBeEnabled === ALLOWED_MODES.no_first_campaign) {
      return [{
        widgetName: 'create-first-campaign',
        colWidth: 8.0
      }].concat(_toConsumableArray(isHideCharts ? {} : [{
        widgetName: 'realtime',
        colWidth: 4
      }]));
    } else if (modeToBeEnabled === ALLOWED_MODES.tag_setup_unfinished) {
      return [{
        widgetName: 'tag-setup',
        colWidth: 12,
        maxHeight: 'none',
        useShadow: true
      }];
    }

    return [];
  }
}

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS').component('noDataOverlay', {
  bindings: {
    customMessage: '@'
  },
  template: '\n      <div class="no-data-overlay-wrapper">\n        <span class="gray-box">\n          {{$ctrl.message}}\n        </span>\n      </div>\n    ',
  controller: noDataOverlayController
});

noDataOverlayController.$inject = ['$translate'];
function noDataOverlayController($translate) {
  var vm = this;

  vm.$onInit = function () {
    vm.message = $translate.instant('sites.dashboard.noDataOverlay.hyouji_surutame_ni');
    if (vm.customMessage) {
      vm.message = vm.customMessage;
    }
  };
}

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS').component('zcsSetTagButton', {
  bindings: {
    project: '<'
  },
  transclude: true,
  templateUrl: '/templates/zenclerk_s/sites/dashboard/set-tag-button.html',
  controller: ZcsSetTagButtonController
});

ZcsSetTagButtonController.$inject = ['$state'];
function ZcsSetTagButtonController($state) {
  var vm = this;

  vm.$onInit = function () {
    vm.goToTagSetupPage = goToTagSetupPage;
  };

  function goToTagSetupPage() {
    $state.go('zenclerkS.project.tags.tracking', { apikey: vm.project.apikey });
  }
}

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsDashboardWidgetCampaignListTitle', {
  templateUrl: '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-campaign-list-title.html',
  require: {
    dashboard: '^zcsDashboardMain'
  },
  controller: zcsDashboardWidgetCampaignListTitleController
});

zcsDashboardWidgetCampaignListTitleController.$inject = [];
function zcsDashboardWidgetCampaignListTitleController() {
  var vm = this;

  vm.$onInit = function () {
    vm.project = vm.dashboard.project;
  };
}

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsDashboardWidgetCampaignList', {
  templateUrl: '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-campaign-list.html',
  require: {
    dashboard: '^zcsDashboardMain'
  },
  controller: zcsDashboardWidgetCampaignListController
});

zcsDashboardWidgetCampaignListController.$inject = ['$scope', '$q', 'Campaign'];
function zcsDashboardWidgetCampaignListController($scope, $q, Campaign) {
  var vm = this;

  vm.$onInit = function () {
    vm.project = vm.dashboard.project;
    vm.filters = Campaign.activeFilters();
  };
}

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsDashboardWidgetCreateFirstCampaign', {
  templateUrl: '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-create-first-campaign.html',
  require: {
    dashboard: '^zcsDashboardMain'
  },
  controller: zcsDashboardWidgetCreateFirstCampaignController
});

zcsDashboardWidgetCreateFirstCampaignController.$inject = ['ZcsOemService'];
function zcsDashboardWidgetCreateFirstCampaignController(ZcsOemService) {
  var vm = this;

  vm.$onInit = function () {
    vm.ZcsOemService = ZcsOemService;
    vm.project = vm.dashboard.project;
  };
}

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsDashboardWidgetNoActiveCampaign', {
  templateUrl: '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-no-active-campaign.html',
  require: {
    dashboard: '^zcsDashboardMain'
  },
  controller: zcsDashboardWidgetNoActiveCampaignController
});

zcsDashboardWidgetNoActiveCampaignController.$inject = [];
function zcsDashboardWidgetNoActiveCampaignController() {
  var vm = this;

  vm.$onInit = function () {
    vm.project = vm.dashboard.project;
  };
}

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

angular.module('zc.zenclerkS').component('zcsDashboardWidgetRealtime', {
  templateUrl: '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-realtime.html',
  require: {
    dashboard: '^zcsDashboardMain'
  },
  controller: zcsDashboardWidgetRealtimeController
});

zcsDashboardWidgetRealtimeController.$inject = ['$filter', '$interval', '$scope', '$location', '$q', 'MongoConversion', 'MongoHistory', 'ZcsDeviceName'];
function zcsDashboardWidgetRealtimeController($filter, $interval, $scope, $location, $q, MongoConversion, MongoHistory, ZcsDeviceName) {
  var vm = this;
  var SHOW_DATA_MINUTES = 30;
  var WIDGET_WRAPPER_SELECTOR = '.realtime-wrapper';
  var GRAY_OVERLAY_CLASSNAME = 'gray-overlay';
  var DATA_FETCH_INTERVAL_MS = 3000;
  var MINUTES_BEFORE_SLEEP_MODE = 5;
  var SECONDS_BEFORE_SLEEP_MODE = MINUTES_BEFORE_SLEEP_MODE * 60;
  var DEVICES = _.omit(ZcsDeviceName.getDeviceNames(), 'devicefree');
  var pageDataFetchingInterval = void 0;
  var pageDataIntervalStartingTime = void 0;
  var lastHistoryDate = void 0;

  vm.$onInit = function () {
    vm.isLoading = true;
    vm.showNoDataOverlay = false;
    vm.redrawPieChart = false;
    // if away from keyboard for a while, turn on pause mode to save bandwidth &
    // avoid crashing tab on background.
    vm.isPaused = false;
    vm.showDataMinutes = SHOW_DATA_MINUTES;
    vm.continueRealtime = continueRealtime;
    vm.conversions = [];
    vm.histories = [];
    vm.minutesBeforeSleepMode = MINUTES_BEFORE_SLEEP_MODE;
    vm.project = vm.dashboard.project;

    startFetchingPageData();

    $scope.$on('$destroy', function () {
      $interval.cancel(pageDataFetchingInterval);
      clearNoDataStatus();
    });
  };

  function startFetchingPageData() {
    lastHistoryDate = getDatetimeFromMinutesAgo(SHOW_DATA_MINUTES);

    var conversionsPromise = getConversions(lastHistoryDate);
    var getHistoriesPromise = getHistories(lastHistoryDate);

    $q.all([conversionsPromise, getHistoriesPromise]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          conversions = _ref2[0],
          histories = _ref2[1];

      vm.conversions = conversions;
      vm.histories = histories;

      if (histories && histories.length <= 0) {
        applyNoDataStatus();
      } else {
        disableGrayOverlay();
        generateData();
      }

      initializePageDataFetchingInterval();
    });
  }

  function stopFetchingPageData() {
    vm.showNoDataOverlay = false;
    vm.isPaused = true;
    enableGrayOverlay();
    $interval.cancel(pageDataFetchingInterval);
  }

  function initializePageDataFetchingInterval() {
    if (pageDataFetchingInterval) {
      return;
    }

    pageDataIntervalStartingTime = new Date();
    pageDataFetchingInterval = $interval(function () {
      // Check if we should turn this off and pause
      var runningTimeInSeconds = moment.tz(vm.project.region).diff(moment.tz(pageDataIntervalStartingTime, vm.project.region), 'seconds');
      if (runningTimeInSeconds > SECONDS_BEFORE_SLEEP_MODE) {
        stopFetchingPageData();
        return;
      }

      fetchAndUpdatePageData();
    }, DATA_FETCH_INTERVAL_MS);
  }

  function fetchAndUpdatePageData() {
    var conversionsPromise = getConversions(lastHistoryDate);
    var getHistoriesPromise = getHistories(lastHistoryDate);

    $q.all([conversionsPromise, getHistoriesPromise]).then(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          conversions = _ref4[0],
          histories = _ref4[1];

      // In case we are showing the overlay and there will be visit,
      // we can remove the overlay
      var gotNewHistories = histories && histories.length > 0;
      if (vm.showNoDataOverlay && gotNewHistories) {
        clearNoDataStatus();
      }

      vm.conversions = conversions;
      vm.histories = vm.histories.concat(histories);
      vm.histories = _.uniqBy(vm.histories, '_id');
      vm.histories = _.filter(vm.histories, function (d) {
        //SHOW_DATA_MINUTES + 1 would display empty bar chart after 1 minute, so
        //SHOW_DATA_MINUTES only makes the chart go into no data mode as soon as the last
        //visible bar has been destroyed
        var maxDatetime = moment.tz(getDatetimeFromMinutesAgo(SHOW_DATA_MINUTES), vm.project.region).startOf('minute');
        var isTooOldToBeShown = moment.tz(d.opened_at, vm.project.region).isAfter(maxDatetime);
        return isTooOldToBeShown;
      });

      generateData();

      // Apply No Data Status when there are no histories
      // left after filtering them above
      if (vm.histories.length <= 0) {
        applyNoDataStatus();
      }
    });

    vm.isLoading = false;
  }

  function getDatetimeFromMinutesAgo() {
    var minutes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SHOW_DATA_MINUTES;

    return moment.tz(vm.project.region).subtract(minutes, 'minutes').valueOf();
  }

  function reDrawPieChart() {
    // this variable is binded with the pie chart,
    // and it will redraw the pie chart when there's
    // a change
    vm.redrawPieChart = true;
  }

  function updateLastHistoryDate() {
    lastHistoryDate = _.max(_.map(vm.histories, 'opened_at'));

    // Don't use the value above if it's
    // invalid or from dummy data, instead
    // define the last history date as NOW minus SHOW_DATA_MINUTES
    if (!_.isFinite(lastHistoryDate) || vm.showNoDataOverlay) {
      lastHistoryDate = getDatetimeFromMinutesAgo(SHOW_DATA_MINUTES);
    }
  }

  function continueRealtime() {
    vm.isPaused = false;
    pageDataFetchingInterval = null;
    // display loading here?
    // vm.isLoading = true;
    startFetchingPageData();
  }

  function enableGrayOverlay() {
    angular.element(WIDGET_WRAPPER_SELECTOR).addClass(GRAY_OVERLAY_CLASSNAME);
  }

  function disableGrayOverlay() {
    angular.element(WIDGET_WRAPPER_SELECTOR).removeClass(GRAY_OVERLAY_CLASSNAME);
  }

  function applyNoDataStatus() {
    if (vm.showNoDataOverlay) {
      return;
    }

    vm.showNoDataOverlay = true;
    vm.histories = generateDummyHistoryData();
    // generate data here so that
    // the no data layout gets applied immediately,
    // not after DATA_FETCH_INTERVAL_MS
    generateData();

    enableGrayOverlay();
  }

  function clearNoDataStatus() {
    vm.showNoDataOverlay = false;

    // we should also clear histories, because there is dummy histories now...
    vm.histories = [];

    // and as we clear the histories, we should display the loading spinner
    // while fetching real histories!
    vm.isLoading = true;

    disableGrayOverlay();
  }

  function generateDummyHistoryData() {
    var currentTime = moment.tz(vm.project.region).valueOf();

    var startingTime = moment.tz(vm.project.region).subtract(SHOW_DATA_MINUTES, 'minutes').valueOf();
    var dummyHistoryData = [];

    var _loop = function _loop() {
      // add random amount of history data
      var randomDevice = _.sample(_.keys(DEVICES));
      _.each(_.range(_.random(30)), function () {
        var randomId = _.random(0.1);
        var historyData = {
          _id: randomId,
          _usid: randomId,
          opened_at: moment.tz(startingTime, vm.project.region).add(3, 'seconds').toDate(),
          device: randomDevice
        };
        dummyHistoryData.push(historyData);
      });

      // swift the starting time X minutes further
      startingTime = moment.tz(startingTime, vm.project.region).add(_.random(1.3), 'minute').valueOf();
    };

    while (startingTime < currentTime) {
      _loop();
    }

    return dummyHistoryData;
  }

  function getConversions() {
    var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : moment.tz(vm.project.region).valueOf();
    var endTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : moment.tz(vm.project.region).valueOf();

    var apiKey = vm.dashboard.project.apikey;
    return MongoConversion.find({
      apikey: apiKey,
      created_at: {
        $gte: startTime,
        $lt: endTime
      }
    }, {
      fields: ['created_at']
    });
  }

  function getHistories() {
    var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : moment.tz(vm.project.region).valueOf();
    var endTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : moment.tz(vm.project.region).valueOf();

    var apiKey = vm.dashboard.project.apikey;
    return MongoHistory.find({
      apikey: apiKey,
      opened_at: {
        $gt: startTime,
        $lt: endTime
      }
    }, {
      limit: 5000,
      // take only what's necessary
      fields: ['_id', '_usid', 'device', 'opened_at']
    });
  }

  function generateData() {
    var oldHistoryCount = vm.historyCount;
    vm.historyCount = vm.histories.length;
    vm.sessionCount = _.uniqBy(vm.histories, function (h) {
      return h._usid;
    }).length;
    vm.conversionCount = vm.conversions.length;

    updateLastHistoryDate();

    calculateDeviceChartData();

    generateHistoryBuckets();

    // redraw pie chart on data changes
    if (oldHistoryCount !== vm.historyCount) {
      reDrawPieChart();
    }

    // stop loading here if we got data to show,
    // otherwise stop at the end of fetchAndUpdatePageData()
    if (vm.historyCount > 0) {
      vm.isLoading = false;
    }
  }

  /**
   * Takes history list and converts it into visualizable format
   *
   * {
   *   start:
   *   end:
   *   historyCount:
   *   sessionCount:
   *   perDeviceCounts:
   *   conversionCount:
   * }
   */
  function generateHistoryBuckets() {
    var buckets = _.range(-60, 60 * SHOW_DATA_MINUTES + 60, 60);
    var defaultDeviceCountValues = _.transform(DEVICES, function (result, deviceName, deviceType) {
      result[deviceType] = 0;
    });

    vm.historiesByBucket = [];
    _.each(buckets, function (bucket, i) {
      // don't handle the last bucket
      if (_.isUndefined(buckets[i + 1])) return;

      var startTime = moment.tz(vm.project.region).subtract(buckets[i + 1], 'seconds').startOf('minute').valueOf();
      var endTime = moment.tz(vm.project.region).subtract(bucket, 'seconds').startOf('minute').valueOf();
      var perDeviceCounts = defaultDeviceCountValues;
      var conversionCount = _.chain(vm.conversions).filter(function (c) {
        var valueOfCreatedAt = $filter('changeDatetimeFrom')('localToRegion', c.created_at, 'integer', vm.project.region);
        return valueOfCreatedAt >= startTime && valueOfCreatedAt < endTime;
      }).size().value();
      var historiesForBucket = _.chain(vm.histories).filter(function (h) {
        var valueOfOpenendAt = $filter('changeDatetimeFrom')('localToRegion', h.opened_at, 'integer', vm.project.region);
        return valueOfOpenendAt >= startTime && valueOfOpenendAt < endTime;
      }).each(function (h) {
        perDeviceCounts[h.device] += 1;
      }).value();

      var sessionCount = _.uniqBy(historiesForBucket, function (d) {
        return d._usid;
      }).length;
      var currentBucketData = {
        start: startTime,
        end: endTime,
        perDeviceCounts: perDeviceCounts,
        conversionCount: conversionCount,
        sessionCount: sessionCount,
        historyCount: historiesForBucket.length
      };

      vm.historiesByBucket.push(currentBucketData);
    });

    vm.historiesByBucket = _.sortBy(vm.historiesByBucket, function (d) {
      return -d.start;
    });
  }

  function calculateDeviceChartData() {
    var baseDeviceChartData = _.map(DEVICES, function (deviceName, deviceType) {
      return {
        label: deviceName,
        type: deviceType
      };
    });

    var deviceChartData = _.chain(vm.histories).groupBy(function (h) {
      return h.device;
    }).map(function (deviceHistories, device) {
      var data = {};
      data[device] = deviceHistories.length / vm.histories.length * 100;
      return data;
    }).value();

    // assign an object array into one object
    deviceChartData = _.assign.apply(_, deviceChartData);

    // loop the base chart data and apply device values from deviceChartData
    vm.chartDataDevices = _.map(baseDeviceChartData, function (device) {
      var deviceValue = _.get(deviceChartData, device.type, 0);
      return {
        label: device.label,
        value: deviceValue
      };
    });
  }
}

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/* globals sift */
angular.module('zc.zenclerkS').component('zcsDashboardWidgetSiteStatus', {
  templateUrl: '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-site-status.html',
  require: {
    dashboard: '^zcsDashboardMain'
  },
  controller: zcsDashboardWidgetSiteStatusController
});

zcsDashboardWidgetSiteStatusController.$inject = ['$translate', '$q', 'ZcsCampaignStats', 'ZcsInvoice', 'ZcsOemService', 'Campaign', 'currencies'];
function zcsDashboardWidgetSiteStatusController($translate, $q, ZcsCampaignStats, ZcsInvoice, ZcsOemService, Campaign, currencies) {
  var vm = this;
  var isOem = ZcsOemService.isOemService();
  var CHART_DATE_FORMAT = 'YYYY-MM-DD';
  var DEFAULT_MAX_INVOICE_PRICE = 10000;
  var COLORS = {
    primary: angular.element('.zc-primary').css('color') || '#1DD5A3',
    secondary: angular.element('.zc-secondary').css('color') || '#775FD3',
    tertiary: angular.element('.zc-tertiary').css('color') || '#A6B1BB'
  };

  function formatFraction(number) {
    return number / Math.pow(10, vm.currency.fractionSize);
  }

  vm.$onInit = function () {
    vm.project = vm.dashboard.project;
    vm.isLoading = true;
    vm.invoiceLimitReached = false;
    vm.showNoDataOverlay = false;
    vm.hasActiveCampaigns = false;
    vm.currentMonth = moment().format('YYYY/MM');
    vm.currency = currencies[vm.project.currency];
    vm.legends = {
      totalFeeTaxExcluded: $translate.instant('sites.dashboard.widgets.dashboardWidgetSiteStatus.seika_houshuu_suii'),
      maxInvoicePrice: $translate.instant('sites.dashboard.widgets.dashboardWidgetSiteStatus.seikyuu_jougen'),
      totalConversionPrice: vm.project.invoice_calculation_type === 'deemed' ? $translate.instant('sites.dashboard.widgets.dashboardWidgetSiteStatus.haishin_yuuzaano_uriage') : $translate.instant('sites.dashboard.widgets.dashboardWidgetSiteStatus.kuupon_riyou_uriage'),
      minimumCharge: $translate.instant('sites.dashboard.widgets.dashboardWidgetSiteStatus.minimamuchaaji')
    };

    var invoicesPromise = ZcsInvoice.find(vm.project.apikey, moment().format('YYYY-MM'));
    var campaignsPromise = Campaign.all({ projectId: vm.project.id });
    var campaignStatsPromise = ZcsCampaignStats.find({
      apikey: vm.project.apikey,
      dimension: 'daily'
    }, {
      start_at: {
        $gte: moment().startOf('month').toDate(),
        $lt: moment().endOf('month').toDate()
      }
    });

    $q.all([invoicesPromise, campaignsPromise, campaignStatsPromise]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 3),
          invoice = _ref2[0],
          campaigns = _ref2[1],
          campaignStats = _ref2[2];

      vm.campaignStats = campaignStats;
      vm.stats = {};
      vm.stats.totalConversionPrice = _.sumBy(campaignStats, 'effective_conversion_price');
      vm.stats.totalConversionCount = _.sumBy(campaignStats, 'effective_conversion_count');
      vm.stats.totalFeeTaxExcluded = _.sumBy(campaignStats, 'zc_fee_tax_excluded');
      vm.stats.invoicePriceTaxExcluded = _.get(invoice, 'invoice_price_tax_excluded', 0);
      vm.stats.maxInvoicePrice = _.get(invoice, 'max_invoice', 0);
      if (invoice.adjustments.length > 0) {
        vm.stats.minimumCharge = _.chain(invoice.adjustments).filter({ adjustment_name: 'minimum_charge' }).sum('price').value();
      }

      if (!vm.stats.maxInvoicePrice) {
        vm.stats.maxInvoicePrice = DEFAULT_MAX_INVOICE_PRICE;
      }

      vm.stats.isInvoiceLimitReached = vm.stats.totalFeeTaxExcluded >= vm.stats.maxInvoicePrice && !vm.project.fixed_invoice_amount;

      var activeCampaigns = sift(Campaign.activeFilters(), campaigns);
      var activeCampaignsThisMonth = sift(Campaign.activeFiltersThisMonth(), campaigns);
      vm.hasActiveCampaigns = activeCampaigns.length > 0;
      vm.hasActiveCampaignsThisMonth = activeCampaignsThisMonth.length > 0;

      if (campaignStats && campaignStats.length <= 0) {
        applyNoDataStatus();
      }

      var feeTaxExcludedSum = 0;
      var chartData = _.chain(vm.campaignStats).sortBy(function (d) {
        return d.start_at;
      }).groupBy(function (d) {
        return d.start_at;
      }).map(function (d) {
        feeTaxExcludedSum += _.sumBy(d, 'zc_fee_tax_excluded');
        return {
          x: moment(d[0].start_at).format(CHART_DATE_FORMAT),
          y: formatFraction(feeTaxExcludedSum)
        };
      }).value();
      chartData = fillDatesBeforeCampaignsStarted(chartData);

      vm.domainValues = getDomainValues();
      vm.chartInvoiceData = [{
        key: vm.legends.totalFeeTaxExcluded,
        values: chartData,
        color: COLORS.primary
      }];

      var borderLineXAxisDates = [
      // subtract 1 day to make the line start from the very left of the chart
      moment().startOf('month').subtract(1, 'day').valueOf(), moment().endOf('month').valueOf()];

      if (vm.stats.maxInvoicePrice > 0 && !vm.project.fixed_invoice_amount) {
        var invoicePriceData = _.map(borderLineXAxisDates, function (d) {
          return {
            x: d,
            y: formatFraction(vm.stats.maxInvoicePrice)
          };
        });

        vm.chartInvoiceData.push({
          key: vm.legends.maxInvoicePrice,
          values: invoicePriceData,
          color: COLORS.secondary
        });
      }

      if (!isOem && vm.stats.minimumCharge > 0) {
        var minimumChargeData = _.map(borderLineXAxisDates, function (d) {
          return {
            x: d,
            y: formatFraction(vm.stats.minimumCharge)
          };
        });

        vm.chartInvoiceData.push({
          key: vm.legends.minimumCharge,
          values: minimumChargeData,
          color: COLORS.tertiary
        });
      }

      vm.isLoading = false;
    });
  };

  function fillDatesBeforeCampaignsStarted(chartData) {
    var dateCampaignsStarted = moment(_.minBy(chartData, function (d) {
      return moment(d.x);
    }).x).valueOf();
    var xDomainDate = moment().startOf('month').valueOf();

    while (xDomainDate < dateCampaignsStarted) {
      chartData.push({
        x: moment(xDomainDate).format(CHART_DATE_FORMAT),
        y: 0
      });
      xDomainDate = moment(xDomainDate).add(1, 'day').valueOf();
    }

    return _.sortBy(chartData, function (d) {
      return d.x;
    });
  }

  function applyNoDataStatus() {
    vm.stats = generateDummyStats();
    vm.campaignStats = generateDummyCampaignStats();
  }

  function generateDummyStats() {
    return {
      totalFeeTaxExcluded: 0,
      maxInvoicePrice: DEFAULT_MAX_INVOICE_PRICE,
      totalConversionPrice: 0
    };
  }

  function generateDummyCampaignStats() {
    var today = moment().endOf('today').valueOf();
    var xDomainDate = moment().startOf('month').valueOf();
    var dummyCampaignStats = [];

    while (xDomainDate < today) {
      dummyCampaignStats.push({
        start_at: xDomainDate,
        end_at: moment(xDomainDate).endOf('day').valueOf(),
        zc_fee_tax_excluded: 0
      });
      xDomainDate = moment(xDomainDate).add(1, 'day').valueOf();
    }

    return dummyCampaignStats;
  }

  function getXDomainValues() {
    var minDate = moment().startOf('month');
    var maxDate = moment().endOf('month');

    return [moment(minDate).subtract(1, 'day').valueOf(), maxDate.valueOf()];
  }

  function getYDomainValues() {
    var yMin = 0;
    var yMaxPadding = 1.1;
    var yMax = formatFraction(vm.stats.totalFeeTaxExcluded);

    if (!vm.stats.isInvoiceLimitReached) {
      yMax = formatFraction(vm.stats.maxInvoicePrice);
    }

    yMax *= yMaxPadding;

    return [yMin, yMax];
  }

  function getDomainValues() {
    return {
      x: getXDomainValues(),
      y: getYDomainValues()
    };
  }
}

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsDashboardWidgetTagSetup', {
  templateUrl: '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-tag-setup.html',
  require: {
    dashboard: '^zcsDashboardMain'
  },
  controller: zcsDashboardWidgetTagSetupController
});

zcsDashboardWidgetTagSetupController.$inject = [];
function zcsDashboardWidgetTagSetupController() {
  var vm = this;

  vm.$onInit = function () {
    vm.project = vm.dashboard.project;
  };
}

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsDashboardWidgetTest', {
  templateUrl: '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-test.html',
  require: {
    dashboard: '^zcsDashboardMain'
  },
  controller: zcsDashboardWidgetTestController
});

zcsDashboardWidgetTestController.$inject = [];
function zcsDashboardWidgetTestController() {
  var vm = this;

  vm.$onInit = function () {
    vm.project = vm.dashboard.project;
  };
}

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsInterestWidgetNavigationController', ZcsInterestWidgetNavigationController);

ZcsInterestWidgetNavigationController.$inject = ['project'];
function ZcsInterestWidgetNavigationController(project) {
  var vm = this;

  vm.project = project;
}

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _zcd = __webpack_require__(214);

var _zcd2 = _interopRequireDefault(_zcd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('zc.zenclerkS').component('zcsInterestWidgetResults', {
  templateUrl: '/templates/zenclerk_s/sites/interest_widget/interest_widget_results.html',
  bindings: {
    project: '<',
    month: '<'
  },
  controller: zcsInterestWidgetResultsController
});

zcsInterestWidgetResultsController.$inject = ['$element', '$filter', '$timeout', '$translate', 'Campaign', 'MongoCampaignInterestWidgetStatsWithoutBounces', 'currencies'];
function zcsInterestWidgetResultsController($element, $filter, $timeout, $translate, Campaign, MongoCampaignInterestWidgetStatsWithoutBounces, currencies) {
  var vm = this;

  vm.currency = currencies[vm.project.currency];

  vm.minIwDate = moment('2016-09').toDate();

  // TODO: use interest widget creation time if later than 09-01
  vm.startAt = moment(vm.month, 'YYYY-MM').startOf('month').toDate();
  vm.endAt = moment(vm.month, 'YYYY-MM').endOf('month').toDate();

  if (moment().isBefore(vm.endAt)) {
    vm.endAt = moment().endOf('day').toDate();
  }

  vm.timerangeChanged = timerangeChanged;

  vm.$onInit = function () {
    Campaign.all({ projectId: vm.project.id }).then(function (campaigns) {
      var iwCampaigns = _.filter(campaigns, function (campaign) {
        return campaign.interest_widget_id;
      });
      var devices = _.countBy(iwCampaigns, 'campaign_device');

      // get only required devices
      var device = null;
      if (devices.sp && devices.pc) {
        device = null;
      } else if (devices.sp) {
        device = 'sp';
      } else if (devices.sp) {
        device = 'pc';
      }
      vm.device = device;

      prepareAndShowGraphs();
    });
  };

  function prepareAndShowGraphs() {
    getIwStats(vm.device).then(function (iwStats) {
      var iwDataForGraph = createIwData(iwStats);

      vm.totalDeliveryCount = _.sumBy(iwDataForGraph, 'iwDeliverySessionCount');

      // we won't show anything if it's not delivered
      if (vm.totalDeliveryCount === 0) {
        return;
      }
      vm.totalDeliveryPercentage = getRoundedPercentage(iwDataForGraph, 'iwDeliverySessionCount', 'totalSessionCount');
      vm.totalUsagePercentage = getRoundedPercentage(iwDataForGraph, 'iwUserSessionCount', 'iwDeliverySessionCount');
      vm.totalUserConversion = _.sumBy(iwDataForGraph, 'iwUserConversionPrice');

      vm.averageIwConversionPercentage = getRoundedPercentage(iwDataForGraph, 'iwDeliveryConversionCount', 'iwDeliverySessionCount');
      vm.averageNoIwConversionPercentage = getRoundedPercentage(iwDataForGraph, 'noIwDeliveryConversionCount', 'noIwDeliverySessionCount');

      vm.averageIwCartButtonClickPercentage = getRoundedPercentage(iwDataForGraph, 'iwDeliveryCartButtonClickCount', 'iwDeliverySessionCount');
      vm.averageNoIwCartButtonClickPercentage = getRoundedPercentage(iwDataForGraph, 'noIwDeliveryCartButtonClickCount', 'noIwDeliverySessionCount');

      // do this in $timeout because the element might not be there yet and
      // then everything breaks
      $timeout(function () {
        createGraphs(iwDataForGraph);
      }, 500);
    });
  }

  function getRoundedPercentage(data, prop, totalProp) {
    return _.round(_.sumBy(data, prop) / _.sumBy(data, totalProp) * 100, 2);
  }

  function createGraphs(iwDataForGraph) {
    var WIDTH = $element.find('.card.card-graph').eq(0).width();
    $element.find('.position-indicator').remove();

    var colors = {
      primary: '#1DD5A3',
      secondary: '#775FD3'
    };

    var graphs = {};

    function asYen(value) {
      var zcCurrency = $filter('zcCurrency');
      return zcCurrency(value, vm.currency.symbol, 0, vm.currency.suffix);
    }

    function asPercent(value) {
      return d3.format('.1f')(value) + '%';
    }

    // Delivery graph
    graphs.delivery = new _zcd2.default($element.find('.delivery-graph')[0], iwDataForGraph, {
      width: WIDTH,
      isBarChart: true, // TODO: get rid of this, just for padding
      tooltipFn: function tooltipFn(d, opts) {
        return [opts.timeFormats.day(d.date), $translate.instant('sites.interestWidget.interestWidgetResults.hyouji_sesshon_kazu', { count: d.iwDeliverySessionCount }), $translate.instant('sites.interestWidget.interestWidgetResults.haishin_wariai', { ratio: _.round(d.iwDeliveryPercentage, 1).toFixed(1) })].join('<br>');
      }
    });

    graphs.delivery.addSeries({
      name: 'delivery-session-count',
      type: 'bar',
      x: 'date',
      y: 'iwDeliverySessionCount',
      color: colors.primary
    });

    graphs.delivery.addSeries({
      name: 'delivery-percentage',
      type: 'line',
      x: 'date',
      y: 'iwDeliveryPercentage',
      yAxis: 'right',
      yAxisTickFormat: asPercent,
      color: colors.secondary
    });

    graphs.delivery.createVerticalPositionIndicator();

    // Cumulative conversion price graph
    graphs.cumulativeConversion = new _zcd2.default($element.find('.cumulative-conversion-graph')[0], iwDataForGraph, {
      width: WIDTH,
      tooltipFn: function tooltipFn(d, opts) {
        return [opts.timeFormats.day(d.date), $translate.instant('sites.interestWidget.interestWidgetResults.ruiseki_riyou_yuuzaanokonbaajon', { amount: asYen(d.iwCumulativeConversionPrice) }), $translate.instant('sites.interestWidget.interestWidgetResults.toujitsu_riyou_yuuzaanokonbaajon', { amount: asYen(d.iwUserConversionPrice) }), $translate.instant('sites.interestWidget.interestWidgetResults.toujitsu_riyousha_igai', { amount: asYen(d.allUserConversionPrice - d.iwUserConversionPrice) })].join('<br>');
      }
    });

    graphs.cumulativeConversion.addSeries({
      type: 'area',
      x: 'date',
      y: 'iwCumulativeConversionPrice',
      yAxisTickFormat: asYen,
      color: colors.secondary
    });

    graphs.cumulativeConversion.createVerticalPositionIndicator();

    // Cart button click rate graph
    graphs.cartButtonClickRate = new _zcd2.default($element.find('.cart-button-click-rate-graph')[0], iwDataForGraph, {
      width: WIDTH,
      tooltipFn: function tooltipFn(d, opts) {
        return [opts.timeFormats.day(d.date), '<b>' + $translate.instant('sites.interestWidget.interestWidgetResults.hyouji_yuuzaa') + '</b>', $translate.instant('sites.interestWidget.interestWidgetResults.hyouji_kazu', { count: d.iwDeliverySessionCount }), $translate.instant('sites.interestWidget.interestWidgetResults.kaatobotankurikku_kazu', { count: d.iwDeliveryCartButtonClickCount }), $translate.instant('sites.interestWidget.interestWidgetResults.kaatobotankurikku_ritsu', { rate: _.round(d.iwDeliveryCartButtonClickPercentage, 1).toFixed(1) }), '<b>' + $translate.instant('sites.interestWidget.interestWidgetResults.hyouji_yuuzaa_igai') + '</b>', $translate.instant('sites.interestWidget.interestWidgetResults.sesshon_kazu', { count: d.noIwDeliverySessionCount }), $translate.instant('sites.interestWidget.interestWidgetResults.kaatobotankurikku_kazu', { count: d.noIwDeliveryCartButtonClickCount }), $translate.instant('sites.interestWidget.interestWidgetResults.kaatobotankurikku_ritsu', { rate: _.round(d.noIwDeliveryCartButtonClickPercentage, 1).toFixed(1) })].join('<br>');
      }
    });

    graphs.cartButtonClickRate.addSeries({
      type: 'line',
      x: 'date',
      y: 'iwDeliveryCartButtonClickPercentage',
      yAxisTickFormat: asPercent,
      color: colors.primary
    });

    graphs.cartButtonClickRate.addSeries({
      type: 'line',
      x: 'date',
      y: 'noIwDeliveryCartButtonClickPercentage',
      yAxisTickFormat: asPercent,
      color: colors.secondary
    });

    graphs.cartButtonClickRate.createVerticalPositionIndicator();

    // Conversion rate graph
    graphs.conversionRate = new _zcd2.default($element.find('.conversion-rate-graph')[0], iwDataForGraph, {
      width: WIDTH,
      tooltipFn: function tooltipFn(d, opts) {
        return [opts.timeFormats.day(d.date), '<b>' + $translate.instant('sites.interestWidget.interestWidgetResults.hyouji_yuuzaa') + '</b>', $translate.instant('sites.interestWidget.interestWidgetResults.hyouji_kazu', { count: d.iwDeliverySessionCount }), $translate.instant('sites.interestWidget.interestWidgetResults.konbaajon_kazu', { count: d.iwDeliveryConversionCount }), $translate.instant('sites.interestWidget.interestWidgetResults.konbaajon_ritsu', { rate: _.round(d.iwDeliveryConversionPercentage, 1).toFixed(1) }), '<b>' + $translate.instant('sites.interestWidget.interestWidgetResults.hyouji_yuuzaa_igai') + '</b>', $translate.instant('sites.interestWidget.interestWidgetResults.sesshon_kazu', { count: d.noIwDeliverySessionCount }), $translate.instant('sites.interestWidget.interestWidgetResults.konbaajon_kazu', { count: d.noIwDeliveryConversionCount }), $translate.instant('sites.interestWidget.interestWidgetResults.konbaajon_ritsu', { rate: _.round(d.noIwDeliveryConversionPercentage, 1).toFixed(1) })].join('<br>');
      }
    });

    graphs.conversionRate.addSeries({
      type: 'line',
      x: 'date',
      y: 'iwDeliveryConversionPercentage',
      yAxisTickFormat: asPercent,
      color: colors.primary
    });

    graphs.conversionRate.addSeries({
      type: 'line',
      x: 'date',
      y: 'noIwDeliveryConversionPercentage',
      yAxisTickFormat: asPercent,
      color: colors.secondary
    });

    graphs.conversionRate.createVerticalPositionIndicator();
  }

  function createIwData(iwStats) {
    var dateRangeInDays = moment(vm.endAt).add(1, 'days').diff(vm.startAt, 'days');

    var iwCumulativeConversionPrice = 0;

    var iwDataForGraph = _.map(_.range(dateRangeInDays), function (dayNumber) {
      var date = moment(vm.startAt).add(dayNumber, 'days').startOf('day').toDate();
      var iwStat = _.find(iwStats, function (d) {
        return moment(d.start_at).isSame(date);
      });
      var totalSessionCount = _.get(iwStat, 'all.session_count', 0);
      var iwDeliverySessionCount = _.get(iwStat, 'widget_received.session_count', 0);
      var iwUserSessionCount = _.get(iwStat, 'widget_received.cart_button_click_count', 0);
      var iwUserConversionPrice = _.get(iwStat, 'item_clicked.conversion_price', 0);
      var iwDeliveryConversionCount = _.get(iwStat, 'widget_received.conversion_count', 0);
      var iwDeliveryCartButtonClickCount = _.get(iwStat, 'widget_received.cart_button_click_count', 0);
      var iwDeliveryPercentage = 0;
      var iwDeliveryConversionPercentage = 0;
      var iwDeliveryCartButtonClickPercentage = 0;
      var noIwDeliveryConversionPercentage = 0;
      var noIwDeliveryCartButtonClickPercentage = 0;
      var noIwDeliverySessionCount = _.get(iwStat, 'widget_not_received.session_count', 0);
      var noIwUserSessionCount = _.get(iwStat, 'all.session_count', 0) - iwUserSessionCount;
      var noIwDeliveryConversionCount = _.get(iwStat, 'widget_not_received.conversion_count', 0);
      var noIwDeliveryCartButtonClickCount = _.get(iwStat, 'widget_not_received.cart_button_click_count', 0);
      var allUserConversionPrice = _.get(iwStat, 'all.conversion_price', 0);

      if (iwStat) {

        if (totalSessionCount) {
          iwDeliveryPercentage = iwDeliverySessionCount / totalSessionCount * 100;
        }

        iwCumulativeConversionPrice += iwUserConversionPrice;

        // iw and non iw conversion and cart click rates
        if (iwStat.widget_received.session_count) {
          iwDeliveryConversionPercentage = iwStat.widget_received.conversion_count / iwStat.widget_received.session_count * 100;
          iwDeliveryCartButtonClickPercentage = iwStat.widget_received.cart_button_click_count / iwStat.widget_received.session_count * 100;
        }

        if (iwStat.widget_not_received.session_count) {
          noIwDeliveryConversionPercentage = iwStat.widget_not_received.conversion_count / iwStat.widget_not_received.session_count * 100;
          noIwDeliveryCartButtonClickPercentage = iwStat.widget_not_received.cart_button_click_count / iwStat.widget_not_received.session_count * 100;
        }
      }

      return {
        date: date,
        totalSessionCount: totalSessionCount,
        iwDeliveryPercentage: iwDeliveryPercentage,
        iwCumulativeConversionPrice: iwCumulativeConversionPrice,
        allUserConversionPrice: allUserConversionPrice,

        iwDeliverySessionCount: iwDeliverySessionCount,
        iwUserSessionCount: iwUserSessionCount,
        iwDeliveryConversionCount: iwDeliveryConversionCount,
        iwDeliveryCartButtonClickCount: iwDeliveryCartButtonClickCount,
        iwUserConversionPrice: iwUserConversionPrice,
        iwDeliveryConversionPercentage: iwDeliveryConversionPercentage,
        iwDeliveryCartButtonClickPercentage: iwDeliveryCartButtonClickPercentage,

        noIwDeliverySessionCount: noIwDeliverySessionCount,
        noIwUserSessionCount: noIwUserSessionCount,
        noIwDeliveryConversionCount: noIwDeliveryConversionCount,
        noIwDeliveryCartButtonClickCount: noIwDeliveryCartButtonClickCount,
        noIwDeliveryConversionPercentage: noIwDeliveryConversionPercentage,
        noIwDeliveryCartButtonClickPercentage: noIwDeliveryCartButtonClickPercentage
      };
    });

    return iwDataForGraph;
  }

  function getIwStats(device) {
    return MongoCampaignInterestWidgetStatsWithoutBounces.find({
      dimension: 'daily',
      apikey: vm.project.apikey
    }, {
      device: device,
      start_at: {
        $gte: vm.startAt,
        $lt: moment(vm.endAt).endOf('day').toDate()
      }
    });
  }

  function timerangeChanged(min, max) {
    vm.startAt = min;
    vm.endAt = max;
    prepareAndShowGraphs();
  }
}

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsInterestWidgetSettings', {
  templateUrl: '/templates/zenclerk_s/sites/interest_widget/interest_widget_settings.html',
  bindings: {
    project: '<'
  },
  controller: zcsInterestWidgetSettingsController
});

zcsInterestWidgetSettingsController.$inject = ['$translate', 'Campaign', 'InterestWidget', 'Template'];
function zcsInterestWidgetSettingsController($translate, Campaign, InterestWidget, Template) {
  var vm = this;

  vm.$onInit = function () {
    vm.campaign = undefined;
    vm.currentView = 'pc';

    vm.selectView = selectView;
    vm.changeIwStatus = changeIwStatus;
    vm.saveCampaign = saveCampaign;
    vm.isSaving = false;

    Campaign.all({ projectId: vm.project.id }).then(function (campaigns) {
      var iwCampaigns = _.filter(campaigns, function (c) {
        return c.interest_widget_id;
      });

      _.each(iwCampaigns, function (iwCampaign) {
        InterestWidget.get(vm.project.apikey, iwCampaign.interest_widget_id).then(function (iw) {
          iwCampaign.interest_widget = _.merge({}, iw);
        });
      });

      if (iwCampaigns.length) {
        // Separate PC and SP for now - ideal would be that they are shown as one
        vm.campaignPC = _.find(iwCampaigns, function (c) {
          return c.campaign_device === 'pc';
        });
        vm.campaignSP = _.find(iwCampaigns, function (c) {
          return c.campaign_device === 'sp';
        });

        if (!vm.campaignPC && vm.campaignSP) {
          selectView('sp');
        } else {
          selectView('pc');
        }

        setTemplate(vm.campaignPC);
        setTemplate(vm.campaignSP);
      }
    });
  };

  function selectView(device) {
    if (device === 'pc') {
      vm.currentView = 'pc';
      vm.campaign = vm.campaignPC;
    } else {
      vm.currentView = 'sp';
      vm.campaign = vm.campaignSP;
    }
    setTemplate(vm.campaign);
  }

  function setTemplate(campaign) {
    if (!campaign) return;

    Template.all(vm.project.id).then(function (templates) {
      campaign.template = _.find(templates, function (template) {
        return template.name === campaign.template_type;
      });
    });
  }

  function changeIwStatus(status) {
    if (vm.campaign.interest_widget.status === 'enable') {
      if (!confirm($translate.instant('sites.interestWidget.interestWidgetSettings.haishin_ga_tomarimasu'))) {
        return;
      }
    }

    vm.campaign.interest_widget.status = status;
    InterestWidget.update(vm.project.apikey, vm.campaign.interest_widget.id, vm.campaign.interest_widget).then(function (interestWidget) {
      vm.campaign.interest_widget = interestWidget;
    });
  }

  function saveCampaign() {
    vm.isSaving = true;
    Campaign.update({ projectId: vm.project.id, campaignId: vm.campaign.id }, vm.campaign).then(function (campaign) {
      vm.campaign = _.merge(vm.campaign, campaign);
      vm.isSaving = false;
    });
  }
}

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsInvoiceEditController', ZcsInvoiceEditController);

ZcsInvoiceEditController.$inject = ['$scope', '$stateParams', '$translate', 'InvoiceAdjustment', 'adjustments', 'month', 'project'];
function ZcsInvoiceEditController($scope, $stateParams, $translate, InvoiceAdjustment, adjustments, month, project) {
  var vm = this;
  vm.project = project;
  vm.adjustments = adjustments;
  vm.showCreateView = month.isSameOrAfter(Date.now(), 'month');
  vm.newAdjustment = {};
  vm.discountTypeOptions = {
    normal: $translate.instant('sites.invoices.edit.invoice.edit.tsuujou'),
    agency: $translate.instant('sites.invoices.edit.invoice.edit.dairiten_mochi'),
    emin: $translate.instant('sites.invoices.edit.invoice.edit.appier_mochi'),
    agency_emin: $translate.instant('sites.invoices.edit.invoice.edit.dairiten_to_emin_ga')
  };
  vm.adjustmentNameOptions = [{ name: 'initial', title: $translate.instant('sites.invoices.edit.invoice.edit.shoki_hiyou') }, { name: 'initial_discount', title: $translate.instant('sites.invoices.edit.invoice.edit.shoki_hiyou_waribiki') }, { name: 'minimal_discount', title: $translate.instant('sites.invoices.edit.invoice.edit.saitei_riyouryou_waribiki') }, { name: 'nullify_minimum_charge', title: $translate.instant('sites.invoices.edit.invoice.edit.minimamuchaaji_nashi') }, { name: 'monthly_percent_discount', title: $translate.instant('sites.invoices.edit.invoice.edit.maitsuki_teiritsu_waribiki') }, { name: 'other', title: $translate.instant('sites.invoices.edit.invoice.edit.sonohoka_hiyou') }, { name: 'other_discount', title: $translate.instant('sites.invoices.edit.invoice.edit.sonohoka_waribiki') }];
  vm.createInvoiceAdjustment = createInvoiceAdjustment;
  vm.removeInvoiceAdjustment = removeInvoiceAdjustment;
  vm.name = 'unknown';

  $scope.$watch('vm.newAdjustment.adjustment_name', function () {
    var obj = _.find(vm.adjustmentNameOptions, { name: vm.newAdjustment.adjustment_name });
    if (!obj) {
      return;
    }
    vm.newAdjustment.title = obj.title;
  });

  function refreshInvoiceAdjustment() {
    InvoiceAdjustment.show(project, $stateParams.term).then(function (refreshAdjustments) {
      vm.adjustments = refreshAdjustments;
    });
  }

  function createInvoiceAdjustment() {
    vm.newAdjustment.adjustment_for = month.toDate();
    if (['initial_discount', 'minimal_discount', 'other_discount'].includes(vm.newAdjustment.adjustment_name)) {
      vm.newAdjustment.price = vm.newAdjustment.price * -1;
    }
    return InvoiceAdjustment.create(project, vm.newAdjustment).then(function (createdAdjustments) {
      vm.newAdjustment = {};
      refreshInvoiceAdjustment();
    });
  }

  function removeInvoiceAdjustment(id) {
    InvoiceAdjustment.remove(project, id).then(function (removedAdjustments) {
      vm.newAdjustment = {};
      refreshInvoiceAdjustment();
    });
  }
}

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsInvoicesController', ZcsInvoicesController);

ZcsInvoicesController.$inject = ['currencies', 'invoices', 'project'];
function ZcsInvoicesController(currencies, invoices, project) {
  var vm = this;
  vm.invoices = invoices;
  vm.project = project;
  vm.thisMonth = moment().format('YYYY-MM');
  vm.currencies = currencies;
  var currentMonth = moment().startOf('month');

  vm.isTerminated = false;
  if (project.terminated_at && currentMonth.isSameOrAfter(moment(project.terminated_at))) {
    vm.isTerminated = true;
  }
}

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsInvoiceShowController', ZcsInvoiceShowController);

ZcsInvoiceShowController.$inject = ['$stateParams', 'currencies', 'invoice', 'project'];
function ZcsInvoiceShowController($stateParams, currencies, invoice, project) {
  var vm = this;
  var currentMonth = moment($stateParams.term, 'YYYY-MM');

  vm.$onInit = function () {
    vm.invoiceMonth = $stateParams.term;
    vm.invoice = invoice;
    vm.project = project;
    vm.currentMonth = moment(currentMonth).endOf('month').format('YYYY/MM');

    vm.invoiceCurrency = currencies[vm.project.invoice_currency || 'jpy'];
    vm.isFixedPrice = !!project.fixed_invoice_amount;

    vm.isTerminated = false;
    if (project.terminated_at) {
      if (currentMonth.isSameOrAfter(moment(project.terminated_at))) {
        vm.isTerminated = true;
      }
    }

    var isMinimumChargeDiscounted = _.some(vm.invoice.adjustments, { adjustment_name: 'minimum_charge_discount' });
    if (isMinimumChargeDiscounted) {
      vm.invoice.adjustments = _.reject(vm.invoice.adjustments, function (adjustment) {
        return _.includes(['minimum_charge', 'minimum_charge_discount'], adjustment.adjustment_name);
      });
    }

    vm.hasInvoiceData = vm.invoice && (vm.invoice.details.length > 0 || vm.invoice.adjustments.length > 0 || vm.invoice.invoice_price > 0);
  };
}

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsDeemedInvoice', {
  templateUrl: '/templates/zenclerk_s/sites/invoices/show/zcs_deemed_invoice.html',
  controllerAs: 'vm',
  bindings: {
    invoice: '=',
    currency: '='
  },
  controller: function controller() {}
});

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsInvoice', {
  templateUrl: '/templates/zenclerk_s/sites/invoices/show/zcs_invoice.html',
  controllerAs: 'vm',
  bindings: {
    invoice: '=',
    currency: '='
  },
  controller: function controller() {}
});

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsOldDeemedInvoice', {
  templateUrl: '/templates/zenclerk_s/sites/invoices/show/zcs_old_deemed_invoice.html',
  bindings: {
    invoice: '<',
    currency: '='
  },
  controllerAs: 'vm',
  controller: zcsOldDeemedInvoiceController
});

function zcsOldDeemedInvoiceController() {
  var vm = this;

  vm.$onInit = function () {
    // do nothing
  };
}

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsReportShowController', ZcsReportShowController);

ZcsReportShowController.$inject = ['$stateParams', 'invoices', 'project'];
function ZcsReportShowController($stateParams, invoices, project) {
  var vm = this;
  vm.month = $stateParams.month;
  vm.project = project;
  vm.invoices = invoices;
}

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('zc.zenclerkS').component('zcsMonthlyReport', {
  templateUrl: '/templates/zenclerk_s/sites/reports/show/zcs_monthly_report.html',
  bindings: {
    project: '<',
    invoices: '<',
    month: '<'
  },
  controllerAs: 'vm',
  controller: zcsMonthlyReportController
});

zcsMonthlyReportController.$inject = ['$element', '$translate', 'ZcsCampaignStats', 'ZcsIncentive', 'ZcsAccessStats', 'ZcsOemService', 'currencies'];
function zcsMonthlyReportController($element, $translate, ZcsCampaignStats, ZcsIncentive, ZcsAccessStats, ZcsOemService, currencies) {
  var vm = this;
  var CONSUMPTION_TAX = 1.1;
  var region = vm.project.region;

  // TODO: get the color from classes
  // colorPrimary = angular.element(".chart-primary").css('color')
  // colorSecondary = angular.element(".chart-secondary").css('color')
  var colorPrimary = '#1DD5A3';
  var colorSecondary = '#775BD6';
  var colorTertiary = '#ff5c79';

  function formatFraction(number) {
    return number / Math.pow(10, vm.currency.fractionSize);
  }

  var dateRangeOfCurrentMonth = [];
  var today = moment.tz(region);

  vm.$onInit = function () {
    vm.svgContainerRelativeDailyConversion = d3.select($element.find('.chart-relative-conversion')[0]).append('svg');
    vm.svgContainerAbsoluteDailyConversion = d3.select($element.find('.chart-daily-conversion')[0]).append('svg');
    vm.svgContainerConversionPerDevice = d3.select($element.find('.chart-conversion-per-device')[0]).append('svg');
    vm.svgContainerCouponUsagePerDevice = d3.select($element.find('.chart-coupon-usage-per-device')[0]).append('svg');
    vm.svgContainerSameSessionConversion = d3.select($element.find('.chart-same-session-cv')[0]).append('svg');

    vm.campaignConversions = [];
    vm.mongoCampaigns = [];
    vm.monthlyDateKeys = [];
    vm.revenueData = {};
    vm.ZcsOemService = ZcsOemService;
    vm.currency = currencies[vm.project.currency];

    if (vm.project.sales_entity === 'appier_jp') {
      vm.campaignInvoicePrice = Math.floor(vm.invoices && vm.invoices.campaign_invoice_price_after_rounding_discount * CONSUMPTION_TAX);
    } else {
      vm.campaignInvoicePrice = Math.floor(vm.invoices && vm.invoices.campaign_invoice_price_after_rounding_discount);
    }

    if (isCurrentMonth()) {
      vm.today = moment.tz(region).format('YYYY-MM-DD HH:mm z');
    } else {
      vm.today = undefined;
    }

    vm.monthlyDateKeys = getMonthlyDateKeys(vm.month);

    var datesValueOf = _.map(vm.monthlyDateKeys, function (d) {
      return moment.tz(d, 'YYYY-MM-DD', region).valueOf();
    });

    // set range to today's date for current month
    if (isCurrentMonth()) {
      dateRangeOfCurrentMonth = [_.head(datesValueOf), moment.tz(region).startOf('days').valueOf()];
    } else {
      dateRangeOfCurrentMonth = [_.head(datesValueOf), _.last(datesValueOf)];
    }

    var startAt = moment.tz(vm.month, 'YYYY-MM', region).toDate();
    var endAt = moment.tz(vm.month, 'YYYY-MM', region).endOf('month').toDate();

    return ZcsCampaignStats.find({
      apikey: vm.project.apikey,
      dimension: 'daily'
    }, {
      start_at: {
        $gte: startAt,
        $lt: endAt
      }
    }).then(function (res) {
      vm.revenueData = res;
      return ZcsAccessStats.getAccessStatsForSegment(vm.project.apikey, null, startAt, endAt);
    }).then(function (res) {
      vm.accessStats = res;
      return ZcsAccessStats.getPerDeviceAccessStatsForSegment(vm.project.apikey, null, startAt, endAt);
    }).then(function (res) {
      vm.perDeviceAccessStats = res;
      return ZcsIncentive.all(vm.project.id);
    }).then(function (incentives) {
      vm.incentivesByCode = _.groupBy(incentives, function (d) {
        return d.coupon_code;
      });
      return ZcsAccessStats.getAccessStatsSameSession(vm.project.apikey, startAt, endAt);
    }).then(function (res) {
      vm.conversionSameSession = res;

      calculateCouponCost();
      createAbsoluteDailyConversionGraph();
      createRelativeDailyConversionGraph();
      createConversionPerDeviceGraph();
      if (vm.revenueData.length > 0) {
        createCouponUsagePerDeviceGraph();
      } else {
        createSameSessionConversionGraph();
      }
    });
  };

  function calculateCouponCost() {
    if (vm.revenueData.length === 0) return 0;

    var couponCostTotal = _.sum(_.map(vm.revenueData, 'coupon_cost'));

    vm.totalConversion = formatFraction(_.sumBy(vm.accessStats, 'conversion_price'));
    vm.zcTotalConversion = formatFraction(_.sum(_.map(vm.revenueData, 'effective_conversion_price')));

    if (vm.totalConversion) {
      vm.zcTotalConversionPercentage = vm.zcTotalConversion / vm.totalConversion * 100;
    } else {
      vm.zcTotalConversionPercentage = 0;
    }

    vm.profitPercent = vm.project.profit_percent || ZcsIncentive.getDefaultProfitPercent();
    vm.grossProfit = vm.zcTotalConversion * (vm.profitPercent / 100);
    vm.costOfGoods = vm.zcTotalConversion * (1 - vm.profitPercent / 100);
    vm.couponCost = formatFraction(couponCostTotal);
    vm.residualProfit = Math.round(vm.zcTotalConversion) - Math.round(vm.costOfGoods) - vm.campaignInvoicePrice - Math.round(vm.couponCost);
  }

  // create absolute daily conversion graph
  function createAbsoluteDailyConversionGraph() {

    var totalConversionData = [];
    var couponCodeConversionData = [];

    _.each(vm.monthlyDateKeys, function (date) {
      if (moment.tz(date, region).isAfter(today)) {
        return;
      }

      var valueOfDate = moment.tz(date, 'YYYY-MM-DD', region).valueOf();
      var campaignData = _.filter(vm.revenueData, function (d) {
        return moment.tz(d.start_at, region).isSame(date, 'day');
      });
      if (campaignData.length) {
        couponCodeConversionData.push([valueOfDate, _.sumBy(campaignData, 'effective_conversion_price')]);
      } else {
        couponCodeConversionData.push([valueOfDate, 0]);
      }

      var totalData = _.find(vm.accessStats, function (d) {
        return moment.tz(d.start_at, region).isSame(date, 'day');
      });
      if (totalData) {
        var totalValue = void 0;
        if (campaignData) {
          totalValue = totalData.conversion_price - _.sumBy(campaignData, 'effective_conversion_price');
        } else {
          totalValue = totalData.conversion_price;
        }
        totalConversionData.push([valueOfDate, totalValue]);
      } else {
        totalConversionData.push([valueOfDate, 0]);
      }
    });

    nv.addGraph(function () {
      var chart = nv.models.stackedAreaChart().margin({ top: 30, right: 60, bottom: 50, left: 70 })
      //.interpolate("cardinal") # rounded line
      .x(function (d) {
        return d[0];
      }).y(function (d) {
        return formatFraction(d[1]);
      }).showControls(false).xDomain(dateRangeOfCurrentMonth).color([colorPrimary, colorSecondary]);

      chart.xAxis.tickFormat(function (d) {
        return moment.tz(d, region).format('MM/DD');
      });

      chart.yAxis.tickFormat(function (d) {
        return vm.currency.symbol + d3.format(',f')(d) + vm.currency.suffix;
      });

      vm.svgContainerAbsoluteDailyConversion.datum([{
        key: $translate.instant('sites.reports.show.zcsMonthlyReport.kuupon', { name: ZcsOemService.getName() }),
        values: couponCodeConversionData
      }, {
        key: $translate.instant('sites.reports.show.zcsMonthlyReport.sonohoka'),
        values: totalConversionData
      }]).call(chart);

      nv.utils.windowResize(chart.update);

      return chart;
    });
  }

  // create relative daily conversion graph
  function createRelativeDailyConversionGraph() {

    var couponCodeConversionPercents = [];

    _.each(vm.monthlyDateKeys, function (date) {
      if (moment.tz(date, region).isAfter(today)) {
        return;
      }
      var currentDate = moment.tz(date, 'YYYY-MM-DD', region).valueOf();

      var totalData = _.find(vm.accessStats, function (d) {
        return moment.tz(d.start_at, region).isSame(date, 'day');
      });
      var campaignData = _.filter(vm.revenueData, function (d) {
        return moment.tz(d.start_at, region).isSame(date, 'day');
      });

      if (totalData && campaignData) {
        var totalValue = totalData.conversion_price;
        var couponConversionPercent = totalValue > 0 ? 100 * _.sumBy(campaignData, 'effective_conversion_price') / totalValue : 0;
        couponCodeConversionPercents.push([currentDate, couponConversionPercent]);
      } else {
        couponCodeConversionPercents.push([moment.tz(date, 'YYYY-MM-DD', region).valueOf(), 0]);
      }
    });

    nv.addGraph(function () {
      var chart = nv.models.stackedAreaChart().showControls(false)
      //.interpolate("cardinal") # rounded line
      .margin({ top: 30, right: 60, bottom: 50, left: 70 }).x(function (d) {
        return d[0];
      }).y(function (d) {
        return d[1];
      }).xDomain(dateRangeOfCurrentMonth).color([colorPrimary, 'rgba(0,0,0,0)']);
      chart.xAxis.tickFormat(function (d) {
        return moment.tz(d, region).format('MM/DD');
      });
      chart.yAxis.tickFormat(function (d) {
        return d3.format('f')(d) + '%';
      });

      vm.svgContainerRelativeDailyConversion.datum([{
        key: $translate.instant('sites.reports.show.zcsMonthlyReport.kuupon', { name: ZcsOemService.getName() }),
        values: couponCodeConversionPercents
      }]).call(chart);

      nv.utils.windowResize(chart.update);

      return chart;
    });
  }

  // create conversion per device
  function createConversionPerDeviceGraph() {
    // TODO: filter per device
    var data = getConversionsPerDevice(vm.perDeviceAccessStats);

    nv.addGraph(function () {
      var chart = nv.models.pieChart().x(function (d) {
        return d.key;
      }).y(function (d) {
        return d.value;
      }).labelType('percent').donut(true).donutRatio(0.35).color([colorPrimary, colorSecondary, colorTertiary]);

      chart.valueFormat(function (d) {
        return vm.currency.symbol + d3.format(',d')(d) + vm.currency.suffix;
      });

      vm.svgContainerConversionPerDevice.datum(data).call(chart);

      nv.utils.windowResize(chart.update);

      return chart;
    });
  }

  // create coupon usage per device
  function createCouponUsagePerDeviceGraph() {
    // const data = vm.revenueData;
    var deviceData = {
      pc: 0,
      sp: 0,
      tablet: 0
    };

    var perDeviceArrays = _.map(vm.revenueData, function (d) {
      return d.per_device_conversions;
    });
    _.each(perDeviceArrays, function (d) {
      _.each(d, function (dd) {
        deviceData[dd.device] += dd.conversion_price;
      });
    });
    var data = _.chain(deviceData).map(function (d, k) {
      return { device: k, conversion_price: d };
    }).sortBy(function (d) {
      return d.device;
    }).value();

    // check if all conversion_price values are 0
    if (!_.map(data, 'conversion_price').every(function (d) {
      return d === 0;
    })) {
      nv.addGraph(function () {
        var chart = nv.models.pieChart().x(function (d) {
          return d.device;
        }).y(function (d) {
          return d.conversion_price;
        }).labelType('percent').donut(true).donutRatio(0.35).color([colorPrimary, colorSecondary, colorTertiary]);

        chart.valueFormat(function (d) {
          return vm.currency.symbol + d3.format(',d')(d) + vm.currency.suffix;
        });

        vm.svgContainerCouponUsagePerDevice.datum(data).call(chart);

        nv.utils.windowResize(chart.update);

        return chart;
      });
    } else {
      d3.select($element.find('.chart-coupon-usage-per-device')[0]).remove();
      vm.noCouponConversions = true;
    }
  }

  function createSameSessionConversionGraph() {
    var sameSessionConversion = [];

    _.each(vm.monthlyDateKeys, function (date) {
      if (moment.tz(date, region).isAfter(today)) {
        return;
      }
      var currentDate = moment.tz(date, 'YYYY-MM-DD', region).valueOf();

      var totalData = _.find(vm.conversionSameSession, function (d) {
        return moment.tz(d.start_at, region).isSame(date, 'day');
      });

      if (totalData) {
        var totalValue = totalData.conversion_count;
        sameSessionConversion.push([currentDate, totalValue]);
      } else {
        sameSessionConversion.push([moment.tz(date, 'YYYY-MM-DD', region).valueOf(), 0]);
      }
    });

    nv.addGraph(function () {
      var chart = nv.models.lineChart().margin({ top: 30, right: 60, bottom: 50, left: 70 }).x(function (d) {
        return moment(d[0]);
      }).y(function (d) {
        return d[1];
      }).xDomain(dateRangeOfCurrentMonth);

      chart.xAxis.tickFormat(function (d) {
        return moment.tz(d, region).format('MM/DD');
      });

      var conversionMax = Math.max.apply(Math, _toConsumableArray(vm.conversionSameSession.map(function (elt) {
        return elt.conversion_count;
      })));
      chart.yAxis.scale().domain([0, conversionMax]);

      vm.svgContainerSameSessionConversion.datum([{ values: sameSessionConversion, key: $translate.instant('sites.reports.show.zcsMonthlyReport.conversion_count') }]).call(chart);

      nv.utils.windowResize(chart.update);

      return chart;
    });
  }

  function getConversionsPerDevice(conversionData) {
    var data = _.chain(conversionData).groupBy(function (d) {
      return d.device;
    }).map(function (array, k) {
      return {
        key: k,
        value: _.sumBy(array, function (dd) {
          return dd.conversion_price;
        })
      };
    }).tap(function (array) {
      // need to add value: 0 to have always same color on pie charts
      if (!_.some(array, { key: 'pc' })) {
        array.push({ key: 'pc', value: 0 });
      }
      if (!_.some(array, { key: 'sp' })) {
        array.push({ key: 'sp', value: 0 });
      }
      if (!_.some(array, { key: 'tablet' })) {
        array.push({ key: 'tablet', value: 0 });
      }
    }).sortBy(function (d) {
      return d.key;
    }).value();

    return data;
  }

  function getMonthlyDateKeys(month) {
    var lastDayOfMonth = moment.tz(vm.month, 'YYYY-MM', region).endOf('month').date();
    // +1 because it's inclusive
    return _.map(_.range(1, lastDayOfMonth + 1), function (d) {
      return moment.tz(vm.month, 'YYYY-MM', region).date(d).format('YYYY-MM-DD');
    });
  }

  function isCurrentMonth() {
    return vm.month === moment.tz(region).format('YYYY-MM');
  }
}

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsProjectBillings', {
  templateUrl: '/templates/zenclerk_s/sites/settings/project_billings.html',
  bindings: {
    project: '='
  },
  controllerAs: 'vm',
  controller: ZcsProjectBillingsController
});

ZcsProjectBillingsController.$inject = ['$rootScope', 'Project'];
function ZcsProjectBillingsController($rootScope, Project) {
  var vm = this;

  // actions
  vm.saveProject = saveProject;

  function saveProject(project) {
    Project.update({ projectId: project.id }, { project: project }).then(function (res) {
      vm.project = res;
      $rootScope.$emit('projectUpdated', vm.project);
    });
  }
}

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsProjectSettings', {
  templateUrl: '/templates/zenclerk_s/sites/settings/project_settings.html',
  bindings: {
    project: '='
  },
  controllerAs: 'vm',
  controller: ZcsProjectSettingsController
});

ZcsProjectSettingsController.$inject = ['$scope', '$rootScope', 'AccessStats', 'Devise', 'ZcsImage', 'ZcsProject', 'currencies', 'Meta'];
function ZcsProjectSettingsController($scope, $rootScope, AccessStats, Devise, ZcsImage, ZcsProject, currencies, Meta) {
  var vm = this;

  vm.currency = currencies[vm.project.currency];

  // variables
  vm.avgPayment = undefined;
  vm.profitRateOptions = ZcsProject.PROFIT_RATE_OPTIONS();
  vm.isSaving = false;
  vm.canEditCurrencies = canEditCurrencies;
  vm.regions = [];
  vm.dashboardCurrencies = [];
  Meta.getRegions().then(function (res) {
    return vm.regions = res;
  });
  Meta.getCurrencies().then(function (res) {
    return vm.dashboardCurrencies = res;
  });
  // actions
  vm.saveProject = saveProject;

  activate();

  $scope.$watch('vm.project.site_logo_image_id', function (imageId) {
    if (!imageId) return;
    ZcsImage.get({
      projectId: vm.project.id,
      imageId: imageId
    }).then(function (image) {
      vm.project.site_logo_image_url = image.image_url;
    });
  });

  function activate() {
    AccessStats.find({
      dimension: 'daily',
      apikey: vm.project.apikey
    }, {
      match: {
        campaign_segment_id: null,
        is_control: null,
        device: null,
        start_at: { $gte: moment().subtract(4, 'days').toDate() }
      }
    }).then(function (res) {
      if (res.length > 0) {
        vm.avgPayment = res[0].conversion_price / res[0].conversion_count;
      }
    });
  }

  function saveProject(project) {
    vm.isSaving = true;
    ZcsProject.saveProject(project).then(function (res) {
      vm.project = _.merge(vm.project, res);
      $rootScope.$emit('projectUpdated', vm.project);
    }).finally(function () {
      vm.isSaving = false;
      vm.currency = currencies[vm.project.currency];
      $scope.siteSettings.$setPristine();
    });
  }

  function canEditCurrencies() {
    if (Devise.isMaster()) return true;
    if (Devise.currentUser.agency_id && Devise.currentUser.agency_id === vm.project.agency_id) return true;
    return false;
  }
}

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('SiteLogoImageController', SiteLogoImageController);

SiteLogoImageController.$inject = ['$scope', 'ZcsImage'];
function SiteLogoImageController($scope, ZcsImage) {
  $scope.$on('flow::fileAdded', function (event, $flow, flowFile) {
    event.preventDefault();
    return ZcsImage.create({ projectId: $scope.$parent.vm.project.id }, {
      image: flowFile.file,
      is_site_logo: 1
    }).then(function (res) {
      $scope.$parent.vm.project.site_logo_image_id = res.data.image.id;
      $scope.$parent.siteSettings.$setDirty();
    });
  });
}

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsSetupController', ZcsSetupController);

ZcsSetupController.$inject = ['$scope', '$state', '$translate', 'Devise', 'ZcsOemService', 'ZcsProject', 'project'];
function ZcsSetupController($scope, $state, $translate, Devise, ZcsOemService, ZcsProject, project) {
  var company = {
    label: $translate.instant('sites.setup.setupController.kaishajouhou'),
    name: 'zenclerkS.project.setup.company',
    class: '',
    requiredProperty: 'user.userinfo_confirmed_at'
  };

  var site = {
    label: $translate.instant('sites.setup.setupController.saito_jouhou'),
    name: 'zenclerkS.project.setup.site',
    class: '',
    requiredProperty: 'project.companyinfo_confirmed_at'
  };

  var pricing = {
    label: $translate.instant('sites.setup.setupController.ryoukin_puran_no'),
    name: 'zenclerkS.project.setup.pricing',
    class: '',
    requiredProperty: 'project.siteinfo_confirmed_at'
  };

  var trackingTag = {
    label: $translate.instant('sites.setup.setupController.torakkingutagu_settei'),
    name: 'zenclerkS.project.setup.trackingTag',
    class: '',
    requiredProperty: 'project.pricing_confirmed_at'
  };

  var conversionTag = {
    label: $translate.instant('sites.setup.setupController.konbaajontagu_settei'),
    name: 'zenclerkS.project.setup.conversionTag',
    class: '',
    requiredProperty: 'project.pricing_confirmed_at'
  };

  var complete = {
    label: $translate.instant('sites.setup.setupController.kanryou'),
    name: 'zenclerkS.project.setup.complete',
    class: '',
    requiredProperty: 'project.pricing_confirmed_at'
  };

  var vm = this;
  vm.project = project;
  vm.user = _.merge({}, Devise.currentUser);
  vm.ZcsOemService = ZcsOemService;

  vm.signOut = Devise.signOut;

  // show the companyinfo & pricing only for non makerepeater oem users
  if (ZcsOemService.get() === 'makerepeater' || vm.project.is_oem) {
    vm.states = [site, trackingTag, conversionTag, complete];
    // So the requirements are also bit different
    trackingTag.requiredProperty = 'project.siteinfo_confirmed_at';
  } else if (vm.project.integrated_with === 'color_me_shop') {
    // Hide:
    // - pricing, because color me shop users pay up front at the zcs app installation page
    // - trackingTag, because it's set automatically by our code.
    // - conversionTag, because it's set automatically by our code.
    trackingTag.requiredProperty = 'project.siteinfo_confirmed_at';
    vm.states = [company, site, complete];
  } else if (vm.project.integrated_with === 'shopify') {
    // Hide:
    // - pricing, because shopify users pay up front at the zcs app installation page
    // - trackingTag, because it's automatically set by our code.
    trackingTag.requiredProperty = 'project.siteinfo_confirmed_at';
    vm.states = [company, site, conversionTag, complete];
  } else if (vm.project.fixed_invoice_amount != null || vm.project.fixed_invoice_amount > 0) {
    vm.states = [company, site, trackingTag, conversionTag, complete];
  } else {
    vm.states = [company, site, pricing, trackingTag, conversionTag, complete];
  }

  // actions
  vm.nextStep = nextStep;
  vm.isActiveState = isActiveState;
  vm.isDisabledState = isDisabledState;
  vm.isPreviousState = isPreviousState;
  vm.goToState = goToState;
  vm.isAllowedToReturnToMain = isAllowedToReturnToMain;

  activate();

  function activate() {
    // forward to segment if accessed directly
    if ($state.current.name === 'zenclerkS.project.setup') {
      $state.go('zenclerkS.project.setup.company');
    } else {
      var currentState = _.find(vm.states, function (d) {
        return d.name === $state.current.name;
      });
      // if current state is disabled, go to previous
      if (currentState && isDisabledState(currentState)) {
        var prevStateIndex = _.findIndex(vm.states, function (d) {
          return d === currentState;
        }) - 1;
        $state.go(vm.states[prevStateIndex].name);
      }
    }

    $scope.$on('siteSetup.nextStep', function (ev) {
      // get the latest user in case it has been updated
      vm.user = _.merge({}, Devise.currentUser);
      ZcsProject.get(vm.user.id, vm.project.apikey).then(function (result) {
        vm.project = _.merge(vm.project, result);
        nextStep();
      });
    });
  }

  function isAllowedToReturnToMain() {
    if (vm.user.role === 'master' || vm.user.agency_id) return true;
    if (vm.user.userinfo_confirmed_at && vm.project.companyinfo_confirmed_at && vm.project.siteinfo_confirmed_at && vm.project.pricing_confirmed_at && vm.project.tracking_tag_confirmed_at && vm.project.conversion_tag_confirmed_at) {
      return true;
    }

    return false;
  }

  function isDisabledState(state) {
    if (state.requiredProperty) {
      if (!_.get(vm, state.requiredProperty)) {
        return true;
      }
    }
    return false;
  }

  function isActiveState(state) {
    return $state.current.name === state.name;
  }

  /* Used to add css class that helps styling */
  function isPreviousState(state) {
    var currentStateIndex = _.findIndex(vm.states, { name: state.name });
    var activeStateIndex = _.findIndex(vm.states, { name: $state.current.name });
    return currentStateIndex < activeStateIndex;
  }

  function goToState(state) {
    if (!isDisabledState(state)) {
      // use reload so that the data (updated project) won't be cached
      $state.go(state.name, { apikey: vm.project.apikey }, { reload: true });
    }
  }

  function nextStep(state) {
    var currentStateIndex = _.findIndex(vm.states, { name: $state.current.name });
    // do nothing if last state
    if (currentStateIndex < vm.states.length) {
      // use reload so that the data (updated project) won't be cached
      $state.go(vm.states[currentStateIndex + 1].name, { apikey: vm.project.apikey });
    }
  }
}

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsSetupCompanyController', ZcsSetupCompanyController);

ZcsSetupCompanyController.$inject = ['$rootScope', '$stateParams', 'Project', 'ZcsOemService', 'project'];
function ZcsSetupCompanyController($rootScope, $stateParams, Project, ZcsOemService, project) {
  var vm = this;
  var pick = ['is_same_billing_info', 'is_direct_selling', 'companyinfo_confirmed', 'companyinfo_confirmed_at', 'company_name', 'representative', 'postal_code', 'address', 'phone_number', 'person_in_charge', 'person_in_charge_email', 'billing_company_name', 'billing_representatives', 'billing_postal_code', 'billing_address', 'billing_phone_number'];

  // variables
  vm.project = _.merge({}, _.pick(project, pick));

  if (vm.project.companyinfo_confirmed_at) {
    vm.project.company_check = true;
  }

  vm.isOem = ZcsOemService.isOemService();

  // actions
  vm.save = save;

  activate();

  function activate() {}

  function save() {
    vm.project.companyinfo_confirmed = true;
    Project.update({ projectId: 'apikey:' + $stateParams.apikey }, { project: _.pick(vm.project, pick) }).then(function (result) {
      vm.project = _.merge(vm.project, result);
      $rootScope.$broadcast('siteSetup.nextStep');
    });
  }
}

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsSetupConversionTagController', ZcsSetupConversionTagController);

ZcsSetupConversionTagController.$inject = ['Project', 'project'];
function ZcsSetupConversionTagController(Project, project) {
  var vm = this;
  var isCompleting = false;

  // variables
  vm.project = project;

  // actions
  vm.save = save;
  vm.onComplete = onComplete;

  activate();

  function activate() {}

  function onComplete() {
    if (!vm.project.conversion_tag_confirmed_at && !isCompleting) {
      isCompleting = true;
      vm.project.conversion_tag_confirmed = true;
      Project.update({ projectId: 'apikey:' + vm.project.apikey }, { project: vm.project }).then(function (result) {
        isCompleting = false;
        vm.project = _.merge(vm.project, result);
      });
    }
  }

  function save() {}
}

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsSetupPricingController', ZcsSetupPricingController);

ZcsSetupPricingController.$inject = ['$rootScope', 'Project', 'currencies', 'project'];
function ZcsSetupPricingController($rootScope, Project, currencies, project) {
  var vm = this;

  vm.project = project;
  vm.currency = currencies[vm.project.currency];

  if (vm.project.campaign_status === 'completed') {
    vm.project.pricing_confirmation_1 = vm.project.pricing_confirmation_2 = true;
  }

  vm.save = function () {
    vm.project.pricing_confirmed = true;
    vm.project.campaign_status = 'completed';
    // do not update for nothing
    if (!vm.project.pricing_confirmed_at) {
      Project.update({ projectId: 'apikey:' + vm.project.apikey }, { project: vm.project }).then(function (result) {
        vm.project = _.merge(vm.project, result);
        $rootScope.$broadcast('siteSetup.nextStep');
      });
    } else {
      $rootScope.$broadcast('siteSetup.nextStep');
    }
  };
}

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsSetupSiteController', ZcsSetupSiteController);

ZcsSetupSiteController.$inject = ['$rootScope', 'Project', 'ZcsOemService', 'project'];
function ZcsSetupSiteController($rootScope, Project, ZcsOemService, project) {
  var vm = this;

  // variables
  vm.project = _.merge({}, project);
  vm.isOemService = ZcsOemService.isOemService();

  // actions
  vm.save = save;

  activate();

  function activate() {}

  function save() {
    vm.project.siteinfo_confirmed = true;
    Project.update({ projectId: 'apikey:' + vm.project.apikey }, { project: vm.project }).then(function (result) {
      vm.project = _.merge(vm.project, result);
      $rootScope.$broadcast('siteSetup.nextStep');
    });
  }
}

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsSetupTrackingTagController', ZcsSetupTrackingTagController);

ZcsSetupTrackingTagController.$inject = ['Project', 'project'];
function ZcsSetupTrackingTagController(Project, project) {
  var vm = this;
  var isCompleting = false;

  // variables
  vm.project = project;

  // actions
  vm.save = save;
  vm.onComplete = onComplete;

  activate();

  function activate() {}

  function onComplete() {
    if (!vm.project.tracking_tag_confirmed_at && !isCompleting) {
      isCompleting = true;
      vm.project.tracking_tag_confirmed = true;
      Project.update({ projectId: 'apikey:' + vm.project.apikey }, { project: vm.project }).then(function (result) {
        isCompleting = false;
        vm.project = _.merge(vm.project, result);
      });
    }
  }

  function save() {}
}

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsSiteNavigationController', ZcsSiteNavigationController);

ZcsSiteNavigationController.$inject = ['$scope', '$state', 'Devise', 'InterestWidget', 'project'];
function ZcsSiteNavigationController($scope, $state, Devise, InterestWidget, project) {
  var vm = this;

  vm.project = project;
  vm.hasInterestWidgets = false;

  vm.isGroup = isGroup;
  vm.isMaster = false;

  $scope.$watch(function () {
    return Devise.isMaster();
  }, function () {
    vm.isMaster = Devise.isMaster();
  });

  InterestWidget.all(vm.project.apikey).then(function (interestWidgets) {
    var activeIws = _.reject(interestWidgets, function (iw) {
      return iw.status === 'incomplete_setting';
    });
    if (activeIws.length > 0) {
      vm.hasInterestWidgets = true;
    }
  });

  function isGroup(group) {
    return _.get($state, 'current.data.group') === group;
  }
}

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsSiteStatsShowController', ZcsSiteStatsShowController);

ZcsSiteStatsShowController.$inject = ['$stateParams', '$translate', 'currencies', 'project', 'stats'];
function ZcsSiteStatsShowController($stateParams, $translate, currencies, project, stats) {
  var vm = this;

  // variables
  vm.project = project;
  vm.stats = stats;
  vm.summarize_at = moment(vm.stats && vm.stats.summarize_at).format('YYYY-MM-DD');
  vm.month = $stateParams.month;
  vm.filterText = '';
  vm.histories = [];
  vm.sortFields = [{ value: 'price', label: $translate.instant('sites.stats.siteStatsShow.tanka') }, { value: 'monthly.pv', label: $translate.instant('sites.stats.siteStatsShow.akusesu_kazu') }, { value: 'monthly.conversion_count', label: $translate.instant('sites.stats.siteStatsShow.kaisuu') }, { value: 'monthly.conversion_amount', label: $translate.instant('sites.stats.siteStatsShow.hanbai_suuryou') }, { value: 'monthly.conversion_price', label: $translate.instant('sites.stats.siteStatsShow.kingaku') }, { value: 'monthly.conversion_ratio', label: $translate.instant('sites.stats.siteStatsShow.ritsu') }, { value: 'monthly.sales_ratio', label: $translate.instant('sites.stats.siteStatsShow.uriage_kouseihi') }];

  vm.sortItems = sortItems;
  vm.currency = currencies[vm.project.currency];

  activate();

  function activate() {
    vm.sortField = 'monthly.conversion_price';
    vm.sortItems();
  }

  function sortItems() {
    vm.sortedItems = _.chain(vm.stats && vm.stats.items).filter(function (d) {
      return d.name.indexOf(vm.filterText) >= 0;
    }).sortBy(function (d) {
      return -_.get(d, vm.sortField);
    }).value();
  }
}

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsSiteTagsController', ZcsSiteTagsController);

ZcsSiteTagsController.$inject = ['$rootScope', '$scope', 'Project', 'project'];
function ZcsSiteTagsController($rootScope, $scope, Project, project) {
  var vm = this;

  // variables
  vm.project = project;
  vm.currentState = 'tracking';

  // actions

  activate();

  function activate() {
    $scope.$on('trackingTagFound', function (params) {
      if (!vm.project.tracking_tag_confirmed_at) {
        vm.project.tracking_tag_confirmed = true;
        updateProject();
      }
    });

    $scope.$on('conversionTagFound', function (params) {
      if (!vm.project.conversion_tag_confirmed_at) {
        vm.project.conversion_tag_confirmed = true;
        updateProject();
      }
    });
  }

  function updateProject() {
    Project.update({ projectId: 'apikey:' + vm.project.apikey }, { project: vm.project }).then(function (newProject) {
      vm.project = newProject;
      $rootScope.$emit('projectUpdated', vm.project);
    });
  }
}

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').component('zcsTerminated', {
  templateUrl: '/templates/zenclerk_s/sites/terminated/terminated.html',
  bindings: {
    project: '<'
  },
  controller: ZcsTerminated
});

ZcsTerminated.$inject = [];
function ZcsTerminated() {
  var vm = this;
  vm.$onInit = function () {
    vm.terminatedDate = moment(vm.project.terminated_at).format('YYYY/MM/DD');
  };
}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ZcsProjectUserController', ZcsProjectUserController);

ZcsProjectUserController.$inject = ['$document', '$rootScope', '$scope', '$stateParams', 'ProjectUser', 'currentUser', 'users'];
function ZcsProjectUserController($document, $rootScope, $scope, $stateParams, ProjectUser, currentUser, users) {
  var vm = this;
  vm.users = users;
  vm.state = {};
  vm.currentUser = currentUser;
  vm.newUser = { email: '', full_name: '' };
  vm.state = {};

  if (vm.users.length === 0) {
    vm.state.addUser = true;
  } else {
    vm.state.addUser = false;
  }

  var itemMargin = 20; // can't get outer height with JS so here the hardcoded margin TODO: use a wrapper
  vm.css = {
    newItemHeight: angular.element($document[0].querySelector('.list-new'))[0].offsetHeight + itemMargin
  };
  vm.css.listItemTranslation = 0;
  vm.toggleNew = toggleNew;
  vm.inviteUser = inviteUser;
  vm.removeUser = removeUser;

  //# Control for duplicate users
  $scope.$watch('vm.newUser.email', function (email) {
    if (email && !!_.find(vm.users, { email: email })) {
      $scope.form.$invalid = true; // disable form submit
      vm.state.duplicateUser = true; // show warning message
    } else {
      vm.state.duplicateUser = false;
    }
  });

  function sortUsers() {
    vm.users = _.sortBy(vm.users, function (user) {
      if (vm.currentUser.id === user.id) {
        return -1;
      }
      return user.id;
    });
  }

  function toggleNew() {
    // remove to origine
    if (vm.state.addUser) {
      vm.css.listItemTranslation = 0;
      // display add user form
    } else {
      vm.css.listItemTranslation = vm.css.newItemHeight;
    }
    vm.state.addUser = !vm.state.addUser;
  }

  //# Invite user
  function inviteUser() {
    ProjectUser.create($stateParams.apikey, vm.newUser).then(function (user) {
      vm.toggleNew();
      vm.users.push(user);
      sortUsers();
      vm.newUser = { email: '', full_name: '' };
      $rootScope.$emit('projectUpdated', vm.project);
    });
  }

  //# Remove user
  function removeUser(user) {
    ProjectUser.destroy($stateParams.apikey, user.id).then(function (deletedUser) {
      _.remove(vm.users, function (u) {
        return u.id === deletedUser.id;
      });
      sortUsers();
    });
  }
}

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('AcceptInvitationController', AcceptInvitationController);

AcceptInvitationController.$inject = ['$stateParams', '$translate', '$window', 'Devise', 'Page', 'afterLoginHandler', 'invitedUser'];
function AcceptInvitationController($stateParams, $translate, $window, Devise, Page, afterLoginHandler, invitedUser) {
  $translate('users.invitation.invitation').then(function (translation) {
    return Page.setTitle(translation);
  });

  var vm = this;
  vm.user = invitedUser;
  vm.isAgreeToTosAndPrivacyPolicy = false;

  vm.setLanguage = function (lang) {
    $translate.use(lang);
    vm.selectedLanguage = lang;
    vm.user.lang = lang;
    $window.document.documentElement.lang = lang;
  };

  vm.setLanguage(invitedUser.lang);

  vm.submit = function () {
    if (!vm.isAgreeToTosAndPrivacyPolicy) return;

    Devise.accept(angular.extend({ invitation_token: $stateParams.invitation_token }, vm.user)).then(function (user) {
      return Devise.signAgreements(user);
    }).then(function (user) {
      return afterLoginHandler.handle(user);
    });
  };
}

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('ResetPasswordController', ResetPasswordController);

ResetPasswordController.$inject = ['$state', '$stateParams', '$translate', '$window', 'Devise', 'Page'];
function ResetPasswordController($state, $stateParams, $translate, $window, Devise, Page) {
  var vm = this;
  vm.user = {};
  $translate('users.resetPassword.reenterPassword').then(function (translation) {
    return Page.setTitle(translation);
  });

  vm.submit = submit;

  vm.setLanguage = function (lang) {
    $translate.use(lang);
    $window.document.documentElement.lang = lang;
  };

  function submit(user) {
    Devise.resetPassword($stateParams.reset_password_token, user.password, user.password_confirmation).then(function (res) {
      return Devise.signIn(res.email, user.password, true);
    }).then(function (usr) {
      return $window.location.replace($state.href('zenclerkS.home'));
    });
  }
}

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('zc.zenclerkS').controller('UsersSignInController', UsersSignInController);

UsersSignInController.$inject = ['$scope', '$translate', '$window', 'afterLoginHandler', 'Api', 'ColorMeShop', 'Devise', 'Environment', 'localStorageService', 'Page', 'returnUrl', 'Shopify', 'ZcTag'];
/* eslint-disable angular/di-order */
function UsersSignInController($scope, $translate, $window, afterLoginHandler, Api, ColorMeShop, Devise, Environment, localStorageService, Page, returnUrl, Shopify, ZcTag) {

  var vm = this;
  vm.user = {
    email: '',
    password: '',
    remember_me: true
  };
  vm.showForgot = false;
  vm.forgotHasBeenSubmitted = false;
  vm.login = login;
  vm.toggleForgot = toggleForgot;
  vm.forgot = forgot;
  vm.shopifyShopName = '';
  vm.shopifyShopDomain = '.myshopify.com';
  vm.showShopifyLogin = false;
  vm.shopifyLogin = shopifyLogin;
  vm.toggleShopifyLogin = toggleShopifyLogin;
  vm.setLanguage = setLanguage;
  vm.environment = 'production';
  vm.enableAuth0 = $window.ZC_CONFIG.ENABLE_AUTH0;
  vm.loginWithAuth0 = loginWithAuth0;

  ColorMeShop.getLoginUrl().then(function (loginUrl) {
    vm.loginUrlForColorMeShop = loginUrl;
  });

  Environment.get().then(function (environment) {
    vm.environment = environment;
  });

  // To ensure user to read updated angular app.
  $scope.$on('$locationChangeSuccess', function () {
    // Devise.currentUser == undefined means never logined
    if (angular.isDefined(Devise.currentUser) && $window.location.pathname === '/users/sign_in') {
      localStorageService.clearAll();
      return $window.location.reload();
    }
  });
  $translate('users.signIn.login').then(function (translation) {
    return Page.setTitle(translation);
  });
  Page.setBodyClass('account-bg');

  function setLanguage(lang) {
    $translate.use(lang);
    $window.document.documentElement.lang = lang;
  }

  // Login
  //#############################################################################

  function login(user) {
    ZcTag.sendParticularEvent('users.signIn.login:submit', { remember_me: user.remember_me });
    return Devise.signIn(user.email, user.password, user.remember_me).then(function (res) {
      ZcTag.sendParticularEvent('users.signIn.login:success');
      return afterLoginHandler.handle(res);
    });
  }

  // Forgot password
  //#############################################################################

  // Toggle the forgot form
  function toggleForgot() {
    vm.showForgot = !vm.showForgot;
  }
  // Send new password to user
  function forgot(email) {
    vm.forgotHasBeenSubmitted = true;
    ZcTag.sendParticularEvent('users.signIn.forgotPassword:submit');
    Devise.sendPasswordResetInstructions(email);
    vm.toggleForgot();
  }

  // Shopify login and redirect
  function shopifyLogin() {
    Shopify.getLoginUrl('' + vm.shopifyShopName + vm.shopifyShopDomain).then(function (loginUrl) {
      if (loginUrl) {
        $window.location.href = loginUrl;
      }
    });
  }

  // Toggle the shopify login form
  function toggleShopifyLogin() {
    vm.showShopifyLogin = !vm.showShopifyLogin;
  }

  function loginWithAuth0() {
    var returnPath = returnUrl.get() || '';
    $window.location.href = Api.basePath + '/users/auth/login?origin=' + $window.location.origin + returnPath;
  }
}

/***/ }),
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */
/***/ (function(module, exports) {

angular.module('zc.commonApi', []);


/***/ }),
/* 557 */
/***/ (function(module, exports) {

angular.module('zc.core', ['ui.router', 'pascalprecht.translate', 'LocalStorageModule']);


/***/ }),
/* 558 */,
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _browser = __webpack_require__(596);

var Sentry = _interopRequireWildcard(_browser);

var _tracing = __webpack_require__(641);

var _integrations = __webpack_require__(624);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable angular/file-name,angular/module-name */
__webpack_require__(678);

// CSS files
__webpack_require__(898);

// Initialize the required modules first
__webpack_require__(557);
__webpack_require__(556);
__webpack_require__(113);

var ZC_CONFIG = __webpack_require__(212);

var enableSentry = !['development', 'test'].includes(ZC_CONFIG.ENV);

if (enableSentry) {
  Sentry.init({
    dsn: ZC_CONFIG.SENTRY_DSN,
    integrations: [new _integrations.Angular(), new _tracing.Integrations.BrowserTracing({
      tracingOrigins: ['localhost', 'aideal-lite.appier.com', 'aideal-lite-pre.appier.com', 'lite-stg.aideal.arepa.appier.co']
    })],
    tracesSampleRate: 0.01,
    sendClientReports: false,
    environment: ZC_CONFIG.ENV
  });
}

if (enableSentry) {
  angular.module('zc', ['ngAnimate', 'ngCookies', 'ngMessages', 'ngResource', 'angular-loading-bar', 'angular-md5', 'colorpicker.module', 'flow', 'hc.marked', 'hljs', 'LocalStorageModule', 'ngCsv', 'ngSentry', 'pascalprecht.translate', 'ui.bootstrap', 'ui.bootstrap.dropdown', 'ui.bootstrap.tooltip', 'ui.router', 'zc.commonApi', 'zc.core', 'zc.zenclerkS']);
} else {
  angular.module('zc', ['ngAnimate', 'ngCookies', 'ngMessages', 'ngResource', 'angular-loading-bar', 'angular-md5', 'colorpicker.module', 'flow', 'hc.marked', 'hljs', 'LocalStorageModule', 'ngCsv', 'pascalprecht.translate', 'ui.bootstrap', 'ui.bootstrap.dropdown', 'ui.bootstrap.tooltip', 'ui.router', 'zc.commonApi', 'zc.core', 'zc.zenclerkS']);
}

// angular-loading-bar options
angular.module('zc').config(cpfLoadingBar);

cpfLoadingBar.$inject = ['cfpLoadingBarProvider'];
function cpfLoadingBar(cfpLoadingBarProvider) {
  // Wait in ms before the loading bar is display
  cfpLoadingBarProvider.latencyThreshold = 300;
  cfpLoadingBarProvider.includeSpinner = false;
}

// NOTE: Copied from zenclerk, but this causes incorrect behavior in AiDeal lite...
// Proper behavior is to always scroll to top (except when going backwards)
//
// disable automatic scrolling to where ui-view changed
// app.value('$anchorScroll', angular.noop)
// Avoid screen move when page transition
angular.module('zc').config(uiScrollViewProviderConfig);

uiScrollViewProviderConfig.$inject = ['$uiViewScrollProvider'];
function uiScrollViewProviderConfig($uiViewScrollProvider) {
  $uiViewScrollProvider.useAnchorScroll();
}

angular.module('zc').config(compileProviderConfig);

compileProviderConfig.$inject = ['$compileProvider'];
function compileProviderConfig($compileProvider) {
  $compileProvider.preAssignBindingsEnabled(true);
}

angular.module('zc').config(qProviderConfig);

qProviderConfig.$inject = ['$qProvider'];
function qProviderConfig($qProvider) {
  $qProvider.errorOnUnhandledRejections(false);
}

// coffee
var moduleReq = __webpack_require__(593);
var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
  for (var _iterator = Array.from(moduleReq.keys())[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
    var key = _step.value;

    if (!key.match(/\.test(\.js|\.coffee)?$/)) {
      moduleReq(key);
    }
  }
} catch (err) {
  _didIteratorError = true;
  _iteratorError = err;
} finally {
  try {
    if (!_iteratorNormalCompletion && _iterator.return) {
      _iterator.return();
    }
  } finally {
    if (_didIteratorError) {
      throw _iteratorError;
    }
  }
}

moduleReq = __webpack_require__(1453);
var _iteratorNormalCompletion2 = true;
var _didIteratorError2 = false;
var _iteratorError2 = undefined;

try {
  for (var _iterator2 = Array.from(moduleReq.keys())[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
    var _key = _step2.value;

    if (!_key.match(/\.test(\.js)?$/)) {
      moduleReq(_key);
    }
  }
} catch (err) {
  _didIteratorError2 = true;
  _iteratorError2 = err;
} finally {
  try {
    if (!_iteratorNormalCompletion2 && _iterator2.return) {
      _iterator2.return();
    }
  } finally {
    if (_didIteratorError2) {
      throw _iteratorError2;
    }
  }
}

angular.module('zc').service('afterLoginHandler', afterLoginHandlerService); // eslint-disable-line angular/no-service-method

afterLoginHandlerService.$inject = ['$cookies', '$location', '$q', '$state', '$translate', '$window', 'Environment', 'returnUrl'];
function afterLoginHandlerService($cookies, $location, $q, $state, $translate, $window, Environment, returnUrl) {
  var AfterLoginHandlerService = function () {
    function AfterLoginHandlerService() {
      _classCallCheck(this, AfterLoginHandlerService);
    }

    _createClass(AfterLoginHandlerService, null, [{
      key: 'handle',
      value: function handle(currentUser, opts) {
        if (opts == null) {
          opts = {};
        }
        if (!currentUser) {
          return false;
        }
        Environment.get().then(function (env) {
          $cookies.put('__zcs_admin', 'user_id=' + currentUser.id, { path: '/', expires: moment().add(1, 'years').toDate(), secure: ['production', 'preprod', 'staging'].includes(env) });
        });

        // set lang
        $translate.use(currentUser.lang);
        moment.locale(currentUser.lang);

        var url = returnUrl.get();
        returnUrl.set(null);

        // forceReload option exists, because we want to force zenclerk tag reload
        // after doing login. This is to update cookie segment.
        if (opts.forceReload) {
          if (url) {
            $window.location.replace(url);
          } else {
            $window.location.replace($state.href('zenclerkS.home', {}, { absolute: true }));
          }
        } else if (url) {
          $location.url(url);
        } else {
          $state.go('zenclerkS.home');
        }
        return $q.resolve();
      }
    }]);

    return AfterLoginHandlerService;
  }();

  return AfterLoginHandlerService;
}

angular.module('zc').run(appRunner);

appRunner.$inject = ['$http', '$location', '$rootScope', '$state', '$window', 'Analytics', 'Api', 'Devise', 'Page', 'StateBeforeActionRunner', 'ZcTag', 'ZcsOemService', 'afterLoginHandler', 'localStorageService'];
function appRunner($http, $location, $rootScope, $state, $window, Analytics, Api, Devise, Page, StateBeforeActionRunner, ZcTag, ZcsOemService, afterLoginHandler, localStorageService) {

  Analytics.initializeGA();
  ZcTag.initialize();

  var token = localStorageService.get('zc_token');
  token = localStorageService.cookie.get('auth_token');
  if (token) {
    $http.defaults.headers.common.Authorization = 'Bearer ' + token;
  }

  $rootScope.Page = Page;

  if (_.endsWith($location.host(), window.ZC_CONFIG.MAKEREPEATER_DOMAIN)) {
    // eslint-disable-line angular/window-service
    // allow makerepeater to access AiDeal lite's dom through iframe
    $window.document.domain = window.ZC_CONFIG.MAKEREPEATER_DOMAIN; // eslint-disable-line angular/window-service
    ZcsOemService.set('makerepeater');
    ZcsOemService.providePublicApi();
    Api.setBasePath(window.ZC_CONFIG.MAKEREPEATER_API_URL); // eslint-disable-line angular/window-service
  }

  StateBeforeActionRunner.initialize();

  var makeRepeaterOrigin = 'https://' + $window.ZC_CONFIG.MAKEREPEATER_OEM_HOST;

  function sendMessageToMakeRepeater(message) {
    $window.parent.postMessage(message, makeRepeaterOrigin);
  }

  sendMessageToMakeRepeater($window.document.body.scrollHeight);

  $window.addEventListener('message', function (event) {
    if (event.origin !== makeRepeaterOrigin) {
      return;
    }

    if (angular.isString(event.data)) {
      if (event.data.startsWith('/')) {
        $location.url(event.data);
        $rootScope.$applyAsync();
      } else if (event.data === 'getHeight') {
        sendMessageToMakeRepeater($window.document.body.scrollHeight);
      }
    }
  });

  var stateChangeStartListener = $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {

    var promise = void 0;
    if (!toState) {
      return;
    }

    var IGNORE_STATES = ['404', '500', 'terms_of_service', 'privacy_policy', 'signUp', 'users.agreement', 'users.invitation.accept', 'users.resetPassword', 'users.signUp'];

    if (IGNORE_STATES.indexOf(toState.name) > -1) {
      return;
    }

    if (ZcsOemService.isOemService()) {
      promise = ZcsOemService.handleLogin();
    } else {
      promise = Devise.getCurrentUser();
    }
    return promise.then(function (user) {
      if (!ZcsOemService.isOemService()) {
        $window.document.documentElement.lang = user.lang;
        if (user && !Devise.isMaster() && user.makerepeater_user_id && !user.makerepeater_is_admin) {
          Devise.signOut();
          return;
        }
      }

      if (toState.name.indexOf('zenclerkS') === 0) {
        return;
      }

      return afterLoginHandler.handle(user);
    }).catch(function (err) {
      return console.error('Catch error changing state', err, toState, toParams);
    });
  });

  var stateChangeSuccessListener = $rootScope.$on('$stateChangeSuccess', function (event, toState, toStateParams, fromState, fromStateParams) {
    if (toState) {
      Analytics.recordPageview($location.url());
    }
  });

  var stateChangeErrorListener = $rootScope.$on('$stateChangeError', function (event, toState, toStateParams, fromState, fromStateParams, errors) {
    console.error('Error changing state', errors, 'FROM', fromState, 'TO', toState, toStateParams);
    if (!Devise.currentUser) {
      $state.go('users.signIn');
    }
  });

  $rootScope.$on('$destroy', function () {
    stateChangeStartListener();
    stateChangeSuccessListener();
    stateChangeErrorListener();
  });
}

// For webpack dev server reloading
if (window.ZC_CONFIG.USE_WEBPACK_DEV_SERVER) {
  // eslint-disable-line angular/window-service
  $.getScript('/webpack-dev-server.js');
}

/***/ }),
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./common_api/api/advertising.service.coffee": 1155,
	"./common_api/api/agency.service": 169,
	"./common_api/api/agency.service.js": 169,
	"./common_api/api/badge_position_adjustments.service.coffee": 1156,
	"./common_api/api/breadcrumb_selector.service.coffee": 1157,
	"./common_api/api/campaign.service.js.coffee": 1158,
	"./common_api/api/campaign_policy_set.service.coffee": 1159,
	"./common_api/api/campaign_segment.service.coffee": 1160,
	"./common_api/api/campaign_template.service.coffee": 1161,
	"./common_api/api/cart_button.service.coffee": 1162,
	"./common_api/api/cart_price.service.coffee": 1163,
	"./common_api/api/clearance_item_set.service.coffee": 1164,
	"./common_api/api/cookie.service.coffee": 1165,
	"./common_api/api/dashboard_chart_positions.service": 170,
	"./common_api/api/dashboard_chart_positions.service.js": 170,
	"./common_api/api/deleted_item_detectors.coffee": 1166,
	"./common_api/api/exclude_ips.service.coffee": 1167,
	"./common_api/api/image_service.js.coffee": 1168,
	"./common_api/api/incentive.service.coffee": 1169,
	"./common_api/api/inquiry_service.js.coffee": 1170,
	"./common_api/api/installation_service.js.coffee": 1171,
	"./common_api/api/invoice_adjustments.service.coffee": 1172,
	"./common_api/api/ip.service.coffee": 1173,
	"./common_api/api/item_list_price.service.coffee": 1174,
	"./common_api/api/item_price.service.coffee": 1175,
	"./common_api/api/login_evaluator.service.coffee": 1176,
	"./common_api/api/meta_service.js.coffee": 1177,
	"./common_api/api/newsletter_parameter.service.coffee": 1178,
	"./common_api/api/page_type_sample_url_service.js.coffee": 1179,
	"./common_api/api/page_type_service.js.coffee": 1180,
	"./common_api/api/particular_event.service.coffee": 1181,
	"./common_api/api/project_request.transformer.js.coffee": 1182,
	"./common_api/api/project_response.transformer.js.coffee": 1183,
	"./common_api/api/project_service.js.coffee": 1184,
	"./common_api/api/segment_cookie.service.coffee": 1185,
	"./common_api/api/template_service.js.coffee": 1186,
	"./common_api/api/thumbnail_selector.service.coffee": 1187,
	"./common_api/api/title_selector.service.coffee": 1188,
	"./common_api/api/unique_coupon_code.service.coffee": 1189,
	"./common_api/api/untrack_page_type_service.js.coffee": 1190,
	"./common_api/api/user.service.coffee": 1191,
	"./common_api/api/visitor_segment.service.coffee": 1192,
	"./common_api/apollo/apollo.service": 171,
	"./common_api/apollo/apollo.service.js": 171,
	"./common_api/base_project_crud.service.js.coffee": 1193,
	"./common_api/facade/access_stats_service.js.coffee": 1194,
	"./common_api/facade/campaign_conversion_data.service": 172,
	"./common_api/facade/campaign_conversion_data.service.js": 172,
	"./common_api/facade/campaign_event_stats.service.coffee": 1195,
	"./common_api/facade/campaign_segment_stats.service": 173,
	"./common_api/facade/campaign_segment_stats.service.js": 173,
	"./common_api/facade/campaign_stats.service.js.coffee": 1196,
	"./common_api/facade/campaign_stats_v2.service": 174,
	"./common_api/facade/campaign_stats_v2.service.js": 174,
	"./common_api/facade/campaign_users.service.coffee": 1197,
	"./common_api/facade/installation_checker.js.coffee": 1198,
	"./common_api/facade/interest_trees.service.coffee": 1199,
	"./common_api/facade/interest_widget_item.service": 175,
	"./common_api/facade/interest_widget_item.service.js": 175,
	"./common_api/facade/interest_widget_stats.service": 176,
	"./common_api/facade/interest_widget_stats.service.js": 176,
	"./common_api/facade/mongo_campaign.service.coffee": 1200,
	"./common_api/facade/mongo_campaign_interest_widget_stats_without_bounces.service": 177,
	"./common_api/facade/mongo_campaign_interest_widget_stats_without_bounces.service.js": 177,
	"./common_api/facade/mongo_conversion.service.coffee": 1201,
	"./common_api/facade/mongo_history.service.coffee": 1202,
	"./common_api/facade/mongo_particular_event.service.coffee": 1203,
	"./common_api/facade/mongo_raw.service.coffee": 1204,
	"./common_api/facade/mongo_session.service.coffee": 1205,
	"./common_api/facade/project_stats_service.js.coffee": 1206,
	"./common_api/facade/report_campaign_stats.service.coffee": 1207,
	"./common_api/facade/report_service.js.coffee": 1208,
	"./common_api/facade/report_stats_response_transformer.coffee": 1209,
	"./common_api/facade/tag_non_existing_urls.service.js.coffee": 1210,
	"./common_api/facade/zcs_agency_invoice.service.coffee": 1211,
	"./common_api/facade/zcs_campaign_stats.service": 178,
	"./common_api/facade/zcs_campaign_stats.service.js": 178,
	"./common_api/filters/campaign_filter.js.coffee": 1212,
	"./common_api/filters/campaign_text_filter.js.coffee": 1213,
	"./common_api/filters/current_status.coffee": 1214,
	"./common_api/filters/device_filter.js.coffee": 1215,
	"./common_api/filters/overall_campaign_cvr_increase_rate": 179,
	"./common_api/filters/overall_campaign_cvr_increase_rate.js": 179,
	"./common_api/filters/project_text_filter.js.coffee": 1216,
	"./common_api/index.coffee": 556,
	"./common_api/misc/campaign_graph_options.coffee": 1217,
	"./common_api/misc/campaign_statuses.constant.coffee": 1218,
	"./common_api/misc/report_range.service.coffee": 1219,
	"./common_api/misc/segment_estimator.service.coffee": 1220,
	"./common_api/misc/segment_matcher.service.coffee": 1221,
	"./common_api/page_description.service.coffee": 1222,
	"./common_api/services.service": 180,
	"./common_api/services.service.js": 180,
	"./core/components/api_public_file_downloader/api_public_file_downloader": 181,
	"./core/components/api_public_file_downloader/api_public_file_downloader.html": 1275,
	"./core/components/api_public_file_downloader/api_public_file_downloader.js": 181,
	"./core/components/billing_representatives/billing_representatives": 182,
	"./core/components/billing_representatives/billing_representatives.html": 1276,
	"./core/components/billing_representatives/billing_representatives.js": 182,
	"./core/components/billing_representatives/billing_representatives.scss": 896,
	"./core/components/increase_or_decrease_percentage/increase_or_decrease_percentage": 183,
	"./core/components/increase_or_decrease_percentage/increase_or_decrease_percentage.html": 1277,
	"./core/components/increase_or_decrease_percentage/increase_or_decrease_percentage.js": 183,
	"./core/components/increase_or_decrease_percentage/increase_or_decrease_percentage.scss": 897,
	"./core/components/month_chooser/month_chooser": 184,
	"./core/components/month_chooser/month_chooser.html": 1278,
	"./core/components/month_chooser/month_chooser.js": 184,
	"./core/components/session_prediction_distribution/session_prediction_distribution": 185,
	"./core/components/session_prediction_distribution/session_prediction_distribution.html": 1279,
	"./core/components/session_prediction_distribution/session_prediction_distribution.js": 185,
	"./core/components/session_price_distribution/session_price_distribution": 186,
	"./core/components/session_price_distribution/session_price_distribution.html": 1280,
	"./core/components/session_price_distribution/session_price_distribution.js": 186,
	"./core/components/session_uplift_modeling_classification/session_uplift_modeling_classification": 187,
	"./core/components/session_uplift_modeling_classification/session_uplift_modeling_classification.html": 1281,
	"./core/components/session_uplift_modeling_classification/session_uplift_modeling_classification.js": 187,
	"./core/components/sync_contract_info_button/sync_contract_info_button": 188,
	"./core/components/sync_contract_info_button/sync_contract_info_button.html": 1282,
	"./core/components/sync_contract_info_button/sync_contract_info_button.js": 188,
	"./core/components/tos_notification/tos_notification": 189,
	"./core/components/tos_notification/tos_notification.html": 1283,
	"./core/components/tos_notification/tos_notification.js": 189,
	"./core/config/zc.core.exceptions": 190,
	"./core/config/zc.core.exceptions.js": 190,
	"./core/config/zc.core.routes.js.coffee": 1223,
	"./core/config/zc.core.settings.js.coffee": 1224,
	"./core/config/zc.core.translations": 191,
	"./core/config/zc.core.translations.js": 191,
	"./core/constants/cron_hours.coffee": 1225,
	"./core/constants/currencies.coffee": 1226,
	"./core/controllers/admin_header.js.coffee": 1227,
	"./core/controllers/mainnav_controller.js.coffee": 1228,
	"./core/directives/admin.directive.coffee": 1229,
	"./core/directives/auto_fill_sync.directive": 192,
	"./core/directives/auto_fill_sync.directive.js": 192,
	"./core/directives/confirm_modal.js.coffee": 1230,
	"./core/directives/date_range.directive.coffee": 1231,
	"./core/directives/date_time_picker.js.coffee": 1232,
	"./core/directives/dirty_form_dialog.directive.coffee": 1233,
	"./core/directives/download_campaign_data_button.directive.coffee": 1234,
	"./core/directives/fixed-on-scroll.directive.coffee": 1235,
	"./core/directives/footer.directive.coffee": 1236,
	"./core/directives/loading.js.coffee": 1237,
	"./core/directives/pe_track.directive": 193,
	"./core/directives/pe_track.directive.js": 193,
	"./core/directives/positive_or_negative.js.coffee": 1238,
	"./core/directives/zc_date_time_picker.js.coffee": 1239,
	"./core/filters/billable_currencies": 194,
	"./core/filters/billable_currencies.js": 194,
	"./core/filters/byte_format.filter": 195,
	"./core/filters/byte_format.filter.js": 195,
	"./core/filters/change_datetime_from.filter.coffee": 1240,
	"./core/filters/date_obj_to_date.filter.js.coffee": 1241,
	"./core/filters/date_to_date_obj.filter.js.coffee": 1242,
	"./core/filters/day_of_week.js.coffee": 1243,
	"./core/filters/elapse_time_filter.js.coffee": 1244,
	"./core/filters/empty_to_end.js.coffee": 1245,
	"./core/filters/gmt_notation.filter": 196,
	"./core/filters/gmt_notation.filter.js": 196,
	"./core/filters/hour_of_day.js.coffee": 1246,
	"./core/filters/humanize_currency": 197,
	"./core/filters/humanize_currency.js": 197,
	"./core/filters/search_project.filter.coffee": 1247,
	"./core/filters/segment_value_format.filter.coffee": 1248,
	"./core/filters/show_element.filter.coffee": 1249,
	"./core/filters/unique_array": 198,
	"./core/filters/unique_array.js": 198,
	"./core/filters/zc_currency.coffee": 1250,
	"./core/filters/zc_date.coffee": 1251,
	"./core/filters/zeros_for_missing_time.coffee": 1252,
	"./core/index.js.coffee": 557,
	"./core/interceptors/error_interceptor.js.coffee": 1253,
	"./core/interceptors/notification_interceptor.js.coffee": 1254,
	"./core/interceptors/session_recoverer.coffee": 1255,
	"./core/modal_selector.controller.js.coffee": 1256,
	"./core/services/$http_once.service": 199,
	"./core/services/$http_once.service.js": 199,
	"./core/services/api.service.coffee": 1257,
	"./core/services/area_chart_v2_config.service": 200,
	"./core/services/area_chart_v2_config.service.js": 200,
	"./core/services/bar_chart_v2_config.service": 201,
	"./core/services/bar_chart_v2_config.service.js": 201,
	"./core/services/base_chart_v2_config.service": 202,
	"./core/services/base_chart_v2_config.service.js": 202,
	"./core/services/chart_v2.service": 203,
	"./core/services/chart_v2.service.js": 203,
	"./core/services/chronological_chart_v2_config.service": 204,
	"./core/services/chronological_chart_v2_config.service.js": 204,
	"./core/services/column_chart_v2_config.service": 205,
	"./core/services/column_chart_v2_config.service.js": 205,
	"./core/services/environment.service.coffee": 1258,
	"./core/services/facade_service.js.coffee": 1259,
	"./core/services/facade_v2_service.js.coffee": 1260,
	"./core/services/funnel_chart_v2_config.service": 206,
	"./core/services/funnel_chart_v2_config.service.js": 206,
	"./core/services/interest_widget.service.coffee": 1261,
	"./core/services/lib.coffee": 1262,
	"./core/services/line_chart_v2_config.service": 207,
	"./core/services/line_chart_v2_config.service.js": 207,
	"./core/services/notification_channel_service.js.coffee": 1263,
	"./core/services/page_layout.service.coffee": 1264,
	"./core/services/page_service.js.coffee": 1265,
	"./core/services/pie_chart_v2_config.service": 208,
	"./core/services/pie_chart_v2_config.service.js": 208,
	"./core/services/return_url.service.coffee": 1266,
	"./core/services/search_filter_service.js.coffee": 1267,
	"./core/services/zc_tag.service": 209,
	"./core/services/zc_tag.service.js": 209,
	"./core/views/404.html": 1284,
	"./core/views/500.html": 1285,
	"./core/views/admin.html": 1286,
	"./core/views/admin_header.html": 1287,
	"./core/views/admin_header_logout_only.html": 1288,
	"./core/views/data_processing_addendum.coffee": 1268,
	"./core/views/data_processing_addendum.html": 1289,
	"./core/views/directives/footer.html": 1290,
	"./core/views/directives/zc_date_time_picker.html": 1291,
	"./core/views/emptynav.html": 1292,
	"./core/views/mainnav.html": 1293,
	"./core/views/privacy_policy.html": 1294,
	"./core/views/privacy_policy.js.controller.coffee": 1269,
	"./core/views/terms_of_service_appier_inc.directive.coffee": 1270,
	"./core/views/terms_of_service_appier_inc.html": 1295,
	"./core/views/terms_of_service_appier_jp.directive.coffee": 1271,
	"./core/views/terms_of_service_appier_jp.html": 1296,
	"./core/views/terms_of_service_appier_others.directive.coffee": 1272,
	"./core/views/terms_of_service_appier_others.html": 1297,
	"./core/views/tos": 210,
	"./core/views/tos.html": 1298,
	"./core/views/tos.js": 210,
	"./core/views/tos_header": 211,
	"./core/views/tos_header.html": 1299,
	"./core/views/tos_header.js": 211
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 593;

/***/ }),
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 896 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 897 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 898 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 899 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 900 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 901 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 902 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 903 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 904 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 905 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 906 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 907 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 908 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 909 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 910 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 911 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 912 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 913 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 914 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 915 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 916 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 917 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 918 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 919 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 920 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 921 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 922 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 923 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 924 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 925 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 926 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 927 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 928 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 929 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 930 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 931 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 932 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 933 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 934 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 935 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 936 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 937 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 938 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 939 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 940 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 941 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 942 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 943 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 944 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 945 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 946 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 947 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 948 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 949 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 950 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 951 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 952 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 953 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 954 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 955 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 956 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 957 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 958 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 959 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 960 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 961 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 962 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c5330aaa5ee12e76fd844eb3004656f7.svg";

/***/ }),
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory("ProjectAdvertising", ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectAdvertising;
  ProjectAdvertising = (function(superClass) {
    extend(ProjectAdvertising, superClass);

    function ProjectAdvertising() {
      return ProjectAdvertising.__super__.constructor.apply(this, arguments);
    }

    return ProjectAdvertising;

  })(BaseProjectCrudService);
  return new ProjectAdvertising($resource, $q, "/api/projects/:projectId/advertisings/:id", "advertising", "advertisings");
}]);


/***/ }),
/* 1156 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectBadgePositionAdjustment', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectBadgePositionAdjustment;
  ProjectBadgePositionAdjustment = (function(superClass) {
    extend(ProjectBadgePositionAdjustment, superClass);

    function ProjectBadgePositionAdjustment() {
      return ProjectBadgePositionAdjustment.__super__.constructor.apply(this, arguments);
    }

    return ProjectBadgePositionAdjustment;

  })(BaseProjectCrudService);
  return new ProjectBadgePositionAdjustment($resource, $q, '/api/master/projects/:projectId/badge_position_adjustments/:id', 'badge_position_adjustment', 'badge_position_adjustments');
}]);


/***/ }),
/* 1157 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectBreadcrumb', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectBreadcrumb;
  ProjectBreadcrumb = (function(superClass) {
    extend(ProjectBreadcrumb, superClass);

    function ProjectBreadcrumb() {
      return ProjectBreadcrumb.__super__.constructor.apply(this, arguments);
    }

    return ProjectBreadcrumb;

  })(BaseProjectCrudService);
  return new ProjectBreadcrumb($resource, $q, '/api/master/projects/:projectId/breadcrumbs/:id', 'breadcrumb', 'breadcrumbs');
}]);


/***/ }),
/* 1158 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module('zc.commonApi').factory("Campaign", ["$http", "$injector", "$q", "$resource", "$translate", "Api", "CampaignConversionData", "FacadeV2", "Meta", "MongoSession", "Project", "campaignServiceRequestTransformer", "campaignServiceResponseTransformer", function($http, $injector, $q, $resource, $translate, Api, CampaignConversionData, FacadeV2, Meta, MongoSession, Project, campaignServiceRequestTransformer, campaignServiceResponseTransformer) {
  var Campaign, getCSVData, getCampaignConversionData, getConversionCSVData, service;
  Campaign = $resource(Api.path("/api/projects/:projectId/campaigns/:campaignId"), {
    projectId: this.projectId,
    campaignId: this.id
  }, {
    get: {
      method: 'GET',
      transformResponse: campaignServiceResponseTransformer
    },
    query: {
      method: 'GET',
      transformResponse: campaignServiceResponseTransformer,
      isArray: false
    },
    update: {
      method: 'PUT',
      transformRequest: campaignServiceRequestTransformer,
      transformResponse: campaignServiceResponseTransformer
    },
    create: {
      method: 'POST',
      transformRequest: campaignServiceRequestTransformer,
      transformResponse: campaignServiceResponseTransformer
    }
  });
  getCSVData = function(conversionData, csvHeaders, fractionSize) {
    var conversion, header, i, len, results;
    if (fractionSize == null) {
      fractionSize = 0;
    }
    results = [];
    for (i = 0, len = conversionData.length; i < len; i++) {
      conversion = conversionData[i];
      results.push((function() {
        var j, len1, results1;
        results1 = [];
        for (j = 0, len1 = csvHeaders.length; j < len1; j++) {
          header = csvHeaders[j];
          if (header === 'created_at') {
            results1.push(moment(conversion.conversion_at).format('YYYY/MM/DD HH:mm:ss'));
          } else if (header === 'usid_overlap') {
            results1.push(conversion[header] || '');
          } else if (header === 'is_control') {
            results1.push(+conversion[header]);
          } else if (header === 'price') {
            results1.push(conversion[header] / Math.pow(10, fractionSize));
          } else {
            results1.push(conversion[header]);
          }
        }
        return results1;
      })());
    }
    return results;
  };
  getCampaignConversionData = function(params) {
    var match;
    match = {
      apikey: params.apikey,
      campaign_id: params.campaignId,
      start_at: {
        $gte: moment(params.filters.start_at).toDate(),
        $lt: moment(params.filters.end_at).toDate()
      }
    };
    if (params.isSecretAb) {
      match.is_control = false;
    }
    return CampaignConversionData.find({
      apikey: params.apikey
    }, {
      match: match
    }).then(function(conversions) {
      var chunks, promises;
      if (_.every(conversions, function(conversion) {
        return _.has(conversion, 'landing_page');
      })) {
        return conversions;
      }
      chunks = _.chunk(_.map(conversions, '_usid'), 50);
      promises = _.map(chunks, function(chunk) {
        return MongoSession.find({
          apikey: params.apikey,
          _id: {
            $in: chunk
          }
        }, {
          fields: ['landing_page']
        });
      });
      return $q.all(promises).then(function(sessions) {
        sessions = _.flatten(sessions);
        return _.map(conversions, function(conversion) {
          var conversionSession;
          conversionSession = _.find(sessions, {
            _id: conversion._usid
          });
          conversion.landing_page = _.get(conversionSession, 'landing_page') || null;
          return conversion;
        });
      });
    });
  };
  getConversionCSVData = function(params) {
    return getCampaignConversionData(params).then(function(conversionData) {
      var conversion, csvHeaders, cvIdConversions, data, filteredConversionData, i, len, noCvIdConversions;
      csvHeaders = [];
      csvHeaders.push('_uuid');
      csvHeaders.push('_usid');
      if (!params.isSecretAb) {
        csvHeaders.push('is_control');
      }
      csvHeaders.push('id');
      csvHeaders.push('price');
      csvHeaders.push('currency');
      csvHeaders.push('url');
      csvHeaders.push('landing_page');
      csvHeaders.push('created_at');
      csvHeaders.push('usid_overlap');
      for (i = 0, len = conversionData.length; i < len; i++) {
        conversion = conversionData[i];
        conversion['conversion_at_str'] = moment(conversion.conversion_at).format('YYYY/MM/DD HH:mm:ss');
      }
      _.sortBy(conversionData, ['is_control', 'conversion_at_str']);
      noCvIdConversions = _.filter(conversionData, function(cv) {
        return cv.id === 'undefined';
      });
      cvIdConversions = _.filter(conversionData, function(cv) {
        return cv.id !== 'undefined';
      });
      filteredConversionData = _.uniqBy(cvIdConversions, 'id');
      filteredConversionData = _.concat(filteredConversionData, noCvIdConversions);
      data = getCSVData(filteredConversionData, csvHeaders, params.fractionSize);
      data.unshift(csvHeaders);
      if (!params.isSecretAb) {
        data.unshift([$translate.instant('sharedModules.commonApi.api.campaign.notDisplayAb')]);
      }
      data.unshift([$translate.instant('sharedModules.commonApi.api.campaign.multipleCvOneSession')]);
      data.unshift([$translate.instant('sharedModules.commonApi.api.campaign.conversionManagement')]);
      data.unshift([$translate.instant('sharedModules.commonApi.api.campaign.conversionNotMatch')]);
      return data;
    });
  };
  service = {
    getCSV: function(params) {
      if (params.csvType === 'conversions') {
        return getConversionCSVData(params);
      } else {
        throw new Error("Unknown csvType: " + params.csvType);
      }
    },
    pastCampaignFilters: function() {
      return {
        interest_widget_id: null,
        $or: [
          {
            end_at: {
              $lt: moment().toDate()
            },
            status: {
              $nin: ['incomplete', 'preview', 'pending']
            }
          }, {
            status: 'terminated'
          }
        ]
      };
    },
    activeFilters: function() {
      return {
        interest_widget_id: null,
        end_at: {
          $gte: moment().toDate()
        },
        status: {
          $nin: ['incomplete', 'preview', 'pending', 'terminated']
        }
      };
    },
    activeFiltersThisMonth: function() {
      return {
        interest_widget_id: null,
        end_at: {
          $gte: moment().startOf('month').toDate()
        },
        status: {
          $nin: ['incomplete', 'preview', 'pending', 'terminated']
        }
      };
    },
    incompleteFilters: function() {
      return {
        interest_widget_id: null,
        status: {
          $in: ['incomplete']
        }
      };
    },
    isWidget: function(campaign) {
      return Meta.getInterestWidgetTemplates().then(function(templates) {
        var ref;
        return ref = campaign.template_type, indexOf.call(templates, ref) >= 0;
      });
    },
    previewUrl: function(base_url, campaign) {
      var coupon_code, id_param, ref, ref1, ref2, ref3;
      coupon_code = '';
      if (((ref = campaign.current_incentive) != null ? ref.incentive_type : void 0) === 'unique_coupon_code') {
        coupon_code = 'UNIQUE CODE';
      }
      if (((ref1 = campaign.current_incentive) != null ? ref1.coupon_code : void 0) != null) {
        coupon_code = (ref2 = campaign.current_incentive) != null ? ref2.coupon_code : void 0;
      } else if (((ref3 = campaign.incentives[0]) != null ? ref3.coupon_code : void 0) != null) {
        coupon_code = campaign.incentives[0].coupon_code;
      }
      id_param = campaign.interest_widget_id ? 'zc_widget_id' : 'zc_element_id';
      base_url += base_url.match(/\?/) ? '&' : '?';
      base_url += id_param + "=" + campaign.element.id + "&zc_control=0&zc_force_connection=1";
      if (coupon_code) {
        base_url += "&zc_coupon_code=" + coupon_code;
      }
      if (campaign.is_widget) {
        base_url += '&zc_console=1';
      }
      return base_url;
    },
    showsAllParams: function(campaign) {
      var md5;
      md5 = $injector.get('md5');
      return "zc_mmcp=" + (md5.createHash(campaign.element.id.toString()));
    },
    showsAllUrl: function(base_url, campaign) {
      var params;
      params = this.showsAllParams(campaign);
      if (base_url.match(/\?/)) {
        return base_url + "&" + params;
      } else {
        return base_url + "?" + params;
      }
    },
    adminUrl: function(params, campaign) {
      return "https://zenclerk.com/admin/projects/" + params + "/campaigns/" + campaign.id + "/creative";
    },
    toggleActive: function(params) {
      return Api.patch("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId + "/active", {
        campaign: {
          state: params.state
        }
      });
    },
    finish: function(params) {
      return Api.patch("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId + "/finished");
    },
    activate: function(params) {
      return Api.patch("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId + "/activated");
    },
    preview: function(params) {
      return Api.patch("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId + "/preview");
    },
    terminate: function(params) {
      return Api.patch("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId + "/terminated");
    },
    incomplete: function(params) {
      return Api.patch("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId + "/incomplete");
    },
    copy: function(params) {
      return Api.post("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId + "/copy", {
        transformResponse: campaignServiceResponseTransformer
      });
    },
    destroy: function(params) {
      return Api["delete"]("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId);
    },
    getTemplate: function(params) {
      var d;
      d = $q.defer();
      Api.get("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId + "/template").then(function(res) {
        return d.resolve(res.data.template);
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    },
    all: function(params) {
      var d;
      d = $q.defer();
      Campaign.query(params).$promise.then(function(res) {
        return d.resolve(res.campaigns);
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    },
    get: function(params) {
      return $q(function(resolve, reject) {
        return Campaign.get(params).$promise.then(function(res) {
          return resolve(res.campaign);
        }, function(err) {
          return reject(err);
        });
      });
    },
    update: function(params, campaign) {
      return $q(function(resolve, reject) {
        return Campaign.update(params, campaign).$promise.then(function(res) {
          if (res.success) {
            return resolve(res);
          } else {
            return reject(res);
          }
        });
      });
    },
    create: function(params, campaign) {
      var d;
      d = $q.defer();
      Api.post("/api/projects/" + params.projectId + "/campaigns", {
        campaign: {}
      }).then(function(res) {
        return d.resolve(res.data);
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    },
    createFromParams: function(paths, params) {
      var d;
      d = $q.defer();
      Campaign.create({
        projectId: paths.projectId
      }, params).$promise.then(function(res) {
        return d.resolve(res.data);
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    },
    campaignEventOrder: function(params) {
      var d;
      d = $q.defer();
      Api.get("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId + "/event_order").then(function(res) {
        return d.resolve(res.data.event_order);
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    },
    campaignEventNotices: function(params) {
      var d;
      d = $q.defer();
      Api.get("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId + "/event_notices").then(function(res) {
        return d.resolve(res.data.event_notices);
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    },
    githubUrl: function(params) {
      return $q(function(resolve, reject) {
        return Api.get("/api/projects/" + params.projectId + "/campaigns/" + params.campaignId + "/github_url").then(function(res) {
          return resolve(res.data.github_url);
        }, function(err) {
          return reject(err);
        });
      });
    },
    publish: function(params) {
      return $q(function(resolve, reject) {
        return FacadeV2.request("/apikeys/" + params.apikey + "/campaigns/" + params.campaign_id + "/publish/" + params._usid, {
          method: 'POST',
          transformResponse: $http.defaults.transformResponse,
          params: params
        }).then(function(res) {
          if (!res.data.success) {
            return reject(res.data.error);
          }
          return resolve(res.data);
        });
      });
    },
    addCouponCode: function(params) {
      return Api.post("/api/projects/" + params.project_id + "/campaigns/" + params.campaign_id + "/add_coupon_code_to_campaign", params).then(function(res) {
        if (res.data.success) {
          return res.data.agency;
        } else {
          return $q.reject(res);
        }
      });
    },
    addIncentives: function(params) {
      return Api.patch("/api/projects/" + params.project_id + "/campaigns/" + params.campaign_id + "/add_incentives", params).then(function(res) {
        if (res.data.success) {
          return res.data.incentives;
        } else {
          return $q.reject(res);
        }
      });
    },
    canAddIncentive: function(campaign) {
      if (campaign.current_status === 'terminated') {
        return false;
      }
      if (campaign.is_widget) {
        return false;
      }
      return true;
    },
    hideBadgeConfigItem: function(item, campaign) {
      var ref;
      if (((ref = item.name) === 'badge_position' || ref === 'badge_icon' || ref === 'countdown_lang' || ref === 'offer_hint' || ref === 'offer_hint_display_until' || ref === 'notice' || ref === 'present_hint' || ref === 'reload_button_text') && campaign.element.message.enables_badge === false) {
        return true;
      }
      return false;
    },
    hideCodeLabelConfigItem: function(item, campaign) {
      var ref;
      if (((ref = item.name) === 'code_name') && campaign.element.message.enables_code_offer_view === false) {
        return true;
      }
      return false;
    }
  };
  return service;
}]).factory('campaignServiceResponseTransformer', ["$filter", "currencies", "lib", function($filter, currencies, lib) {
  var doTransform;
  doTransform = function(campaign) {
    var campaign_obj, current_status, element, end_at, err, i, incentive, len, pageTypeFields, ref, start_at;
    try {
      start_at = null;
      if (campaign.start_at) {
        start_at = $filter('changeDatetimeFrom')('regionToLocal', campaign.start_at, 'string', campaign.region);
      }
      start_at = $filter('dateToDateObj')(start_at);
      end_at = null;
      if (campaign.end_at) {
        end_at = $filter('changeDatetimeFrom')('regionToLocal', campaign.end_at, 'string', campaign.region);
      }
      end_at = $filter('dateToDateObj')(end_at);
      element = {};
      element.message = {};
      if (campaign.elements && campaign.elements.length > 0) {
        element.id = campaign.elements[0].id;
        element.message = angular.fromJson(campaign.elements[0].message);
        pageTypeFields = ['reject_pagetypes', 'receive_page_types', 'ignore_pagetype', 'limit_pagetypes'];
        _.each(pageTypeFields, function(pageTypeField) {
          if (_.isString(element.message[pageTypeField])) {
            return element.message[pageTypeField] = lib.stringToArray(element.message[pageTypeField]);
          }
        });
      }
      current_status = $filter('currentStatus')(campaign);
      if (campaign.incentives) {
        ref = campaign.incentives;
        for (i = 0, len = ref.length; i < len; i++) {
          incentive = ref[i];
          if (incentive.start_at) {
            incentive.start_at = $filter('changeDatetimeFrom')('regionToLocal', incentive.start_at, 'date', campaign.region);
          }
          if (incentive.end_at) {
            incentive.end_at = $filter('changeDatetimeFrom')('regionToLocal', incentive.end_at, 'date', campaign.region);
          }
        }
      }
      campaign_obj = {
        id: campaign.id,
        name: campaign.name,
        fee_rate: campaign.fee_rate,
        fee_calculation_type: campaign.fee_calculation_type,
        notes_json: campaign.notes_json,
        apikey: campaign.apikey,
        api_version: campaign.api_version,
        currency: currencies[campaign.project_currency],
        project_id: campaign.project_id,
        project_name: campaign.project_name,
        memo: campaign.memo,
        custom_css: campaign.custom_css,
        control_percent: campaign.control_percent,
        campaign_device: campaign.campaign_device,
        campaign_target: campaign.campaign_target,
        campaign_policy_set: campaign.campaign_policy_set,
        campaign_policy_set_id: campaign.campaign_policy_set_id,
        is_fired: campaign.is_fired,
        clearance_item_set_id: campaign.clearance_item_set_id,
        has_been_started: campaign.has_been_started,
        project_base_url: campaign.project_base_url,
        project_product_line: campaign.project_product_line,
        project_users: campaign.project_users,
        template_type: campaign.template_type,
        campaign_type: campaign.campaign_type,
        status: campaign.status,
        days_since_last_received: campaign.days_since_last_received,
        days_since_last_received_conversion: campaign.days_since_last_received_conversion,
        is_information_campaign: campaign.is_information_campaign,
        is_aov_campaign: campaign.is_aov_campaign,
        is_secret_ab: campaign.is_secret_ab,
        current_status: current_status,
        region: campaign.region,
        start_at: campaign.start_at ? $filter('changeDatetimeFrom')('regionToLocal', campaign.start_at, 'date', campaign.region) : void 0,
        end_at: campaign.end_at ? $filter('changeDatetimeFrom')('regionToLocal', campaign.end_at, 'date', campaign.region) : void 0,
        start_at_obj: start_at,
        end_at_obj: end_at,
        referrer_type: (!campaign.referrer_type ? 0 : campaign.referrer_type),
        segment: campaign.segment,
        segment_id: campaign.segment_id,
        exclude_logged_in: campaign.exclude_logged_in,
        element: element,
        incentives: campaign.incentives,
        incentive_ids: _.map(campaign.incentives, 'id'),
        requires_incentives: campaign.requires_incentives,
        current_incentive: campaign.current_incentive,
        aggregate_type: campaign.aggregate_type,
        created_at: moment(campaign.created_at).tz("Asia/Tokyo").toDate(),
        updated_at: moment(campaign.updated_at).tz("Asia/Tokyo").toDate(),
        interest_widget_id: campaign.interest_widget_id,
        is_widget: campaign.is_widget,
        is_supported_by_widget: campaign.is_supported_by_widget,
        is_infinite: campaign.is_infinite,
        auto_restart: campaign.auto_restart,
        target_conversion_name: campaign.target_conversion_name,
        incentive_draft: campaign.incentive_draft,
        campaign_control_percent: campaign.campaign_control_percent,
        was_activated_before: campaign.was_activated_before,
        cost_per_acquisition: campaign.cost_per_acquisition,
        predictions_max_threshold: campaign.predictions_max_threshold,
        predictions_min_threshold: campaign.predictions_min_threshold,
        exclude_cart_button_click: campaign.exclude_cart_button_click,
        price_min_threshold: campaign.price_min_threshold,
        price_max_threshold: campaign.price_max_threshold,
        exclude_no_price: campaign.exclude_no_price,
        configuration_type: campaign.configuration_type,
        score_threshold: campaign.score_threshold,
        auto_configuration: campaign.auto_configuration,
        model_names: campaign.model_names,
        testing_unit: campaign.testing_unit,
        ai_model_names: campaign.ai_model_names,
        sampling_range: campaign.sampling_range,
        sampling_score_threshold: campaign.sampling_score_threshold,
        enable_botbonnie_integration: campaign.enable_botbonnie_integration,
        botbonnie_trigger_rules: campaign.botbonnie_trigger_rules,
        enable_botbonnie_open_chatroom: campaign.enable_botbonnie_open_chatroom
      };
      _.each(['notes_json', 'incentive_draft', 'model_names'], function(parameter) {
        var err;
        try {
          if (campaign_obj[parameter]) {
            return campaign_obj[parameter] = JSON.parse(campaign_obj[parameter]);
          } else {
            return campaign_obj[parameter] = {};
          }
        } catch (error) {
          err = error;
          throw new Error('Invalid JSON value', campaign[parameter]);
        }
      });
      return campaign_obj;
    } catch (error) {
      err = error;
      return {};
    }
  };
  return function(data, headers, status) {
    var campaigns, obj;
    try {
      data = angular.fromJson(data);
    } catch (error) {
      if (status === 406 && data.match(/UnknownFormat/)) {

      } else {
        console.log("Failed to parse campaign");
      }
      data = {
        campaigns: []
      };
    }
    if (_.get(data, 'campaigns')) {
      campaigns = data.campaigns;
      if (_.isArray(campaigns)) {
        if (campaigns.length > 0) {
          return _.assignIn(data, {
            campaigns: _.map(campaigns, doTransform)
          });
        }
        return _.assignIn(data, {
          campaigns: []
        });
      }
    } else if (_.get(data, 'campaign')) {
      obj = data.campaign;
      obj.elements = data.elements;
      return _.assignIn(data, {
        campaign: doTransform(obj)
      });
    }
    return _.assignIn(data, {
      campaigns: []
    });
  };
}]).factory('campaignServiceRequestTransformer', ["$filter", function($filter) {
  var doTransform;
  doTransform = function(elem) {
    var pageTypeFields;
    elem = $.extend(true, {}, elem);
    elem.start_at = $filter('dateObjToDate')(elem.start_at_obj);
    elem.start_at = $filter('changeDatetimeFrom')('localToRegion', elem.start_at, 'string', elem.region);
    elem.end_at = $filter('dateObjToDate')(elem.end_at_obj);
    elem.end_at = $filter('changeDatetimeFrom')('localToRegion', elem.end_at, 'string', elem.region);
    elem.updated_at = moment().tz("Asia/Tokyo").toDate();
    if (elem.incentive_draft) {
      if (elem.incentive_draft.is_infinite) {
        elem.end_at = moment('2100-12-31').toDate();
      }
      elem.incentive_draft = angular.toJson(elem.incentive_draft);
    }
    if (elem.notes_json) {
      elem.notes_json = angular.toJson(elem.notes_json);
    }
    if (elem.elements) {
      elem.elements = [elem.elements[0]];
    } else {
      elem.elements = [elem.element];
    }
    pageTypeFields = ['reject_pagetypes', 'receive_page_types', 'ignore_pagetype', 'limit_pagetypes'];
    if (elem.elements[0] && elem.elements[0].message) {
      _.each(pageTypeFields, function(pageTypeField) {
        if (_.isArray(elem.elements[0].message[pageTypeField])) {
          return elem.elements[0].message[pageTypeField] = elem.elements[0].message[pageTypeField].join(',');
        } else if (elem.elements[0].message[pageTypeField] === null) {
          return elem.elements[0].message[pageTypeField] = '';
        }
      });
    }
    return elem;
  };
  return function(data) {
    if (data.campaign) {
      data.campaign = doTransform(data.campaign);
    } else {
      data = {
        campaign: doTransform(data)
      };
    }
    data.element = data.campaign.elements[0];
    return JSON.stringify(data);
  };
}]);


/***/ }),
/* 1159 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('CampaignPolicySet', ["$resource", "$q", "Api", function($resource, $q, Api) {
  var CampaignPolicySet, URL, service;
  URL = '/api/projects/:projectId/campaign_policy_sets/:id';
  CampaignPolicySet = $resource(Api.path(URL), {
    projectId: this.projectId,
    id: this.id
  }, {
    query: {
      method: 'GET',
      isArray: false
    },
    save: {
      method: 'POST',
      headers: {
        'Content-Type': void 0
      },
      transformRequest: function(data) {
        var formData;
        formData = new FormData();
        angular.forEach(data, function(val, key) {
          return formData.append(key, val);
        });
        return formData;
      }
    },
    destroy: {
      method: 'DELETE'
    }
  });
  service = {
    all: function(params) {
      return $q(function(resolve, reject) {
        return CampaignPolicySet.query(params, function(res) {
          return resolve(res.campaign_policy_sets);
        });
      });
    },
    create: function(params, set) {
      return $q(function(resolve, reject) {
        var campaign_policy_set;
        campaign_policy_set = new CampaignPolicySet(set);
        return campaign_policy_set.$save(params).then(function(res) {
          return resolve(res.campaign_policy_set);
        });
      });
    },
    destroy: function(params) {
      return $q(function(resolve, reject) {
        return CampaignPolicySet.destroy(params).$promise.then(function(res) {
          return resolve(res);
        });
      });
    }
  };
  return service;
}]);


/***/ }),
/* 1160 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory("CampaignSegment", ["$resource", "$q", "BaseProjectCrudService", "Api", "campaignSegmentResponseTransformer", "campaignSegmentRequestTransformer", function($resource, $q, BaseProjectCrudService, Api, campaignSegmentResponseTransformer, campaignSegmentRequestTransformer) {
  var CampaignSegment;
  CampaignSegment = (function(superClass) {
    extend(CampaignSegment, superClass);

    function CampaignSegment() {
      return CampaignSegment.__super__.constructor.apply(this, arguments);
    }

    CampaignSegment.prototype.toZcRuleCollection = function(name, collection) {
      var column, f, ret, v;
      ret = {};
      for (f in collection) {
        v = collection[f];
        if (!f || f === 'apikey') {
          continue;
        }
        column = name + "#" + f;
        if (!(_.isBoolean(v) || _.isPlainObject(v)) && /^(is_)|(syncd)/.test(f)) {
          throw {
            message: column + " should be boolean or object "
          };
        }
        if (_.isPlainObject(v) && v['$not'] && v['$not']['$regex']) {
          throw {
            message: "{$not: {$regex: 'xxx'}} is not allowed in MongoDB"
          };
        }
        ret[column] = v;
      }
      return ret;
    };

    CampaignSegment.prototype.toZcRule = function(campaignSegment) {
      var err, jsonObj;
      jsonObj = {};
      try {
        if (campaignSegment.visitor) {
          eval("var visitorQuery = " + campaignSegment.visitor + ";");
          _.assignIn(jsonObj, this.toZcRuleCollection('Visitor', visitorQuery));
        }
        if (campaignSegment.session) {
          eval("var sessionQuery = " + campaignSegment.session + ";");
          _.assignIn(jsonObj, this.toZcRuleCollection('Session', sessionQuery));
        }
        campaignSegment.raw = JSON.stringify({
          visitor: campaignSegment.visitor,
          session: campaignSegment.session
        });
        campaignSegment.message = '';
      } catch (error) {
        err = error;
        campaignSegment.message = err.message;
        null;
      }
      return jsonObj;
    };

    CampaignSegment.prototype.checkZcRule = function(campaignSegment) {
      var f, ref, v;
      if (!campaignSegment) {
        return;
      }
      campaignSegment.rule = this.toZcRule(campaignSegment);
      campaignSegment.ruleView = '';
      if (campaignSegment.rule) {
        ref = campaignSegment.rule;
        for (f in ref) {
          v = ref[f];
          campaignSegment.ruleView += f + ", " + (JSON.stringify(v)) + "\n";
        }
        return campaignSegment.json = JSON.stringify(campaignSegment.rule);
      }
    };

    CampaignSegment.prototype.getMongoQuery = function(campaignSegment) {
      var segment;
      segment = _.merge({}, campaignSegment);
      if (segment.conditions_json.limit_to_landing_page_types && (_.isEmpty(segment.conditions_json.limit_to_landing_page_types) || segment.conditions_json.limit_to_landing_page_types[0] === "NOT_SELECTED")) {
        delete segment.conditions_json.limit_to_landing_page_types;
      }
      return $q(function(resolve, reject) {
        return Api.post("/api/projects/" + campaignSegment.project_id + "/campaign_segments/mongo_query", {
          campaign_segment: segment
        }).then(function(res) {
          return resolve(res.data.mongo_query);
        });
      });
    };

    return CampaignSegment;

  })(BaseProjectCrudService);
  return new CampaignSegment($resource, $q, "/api/projects/:projectId/campaign_segments/:id", "campaign_segment", "campaign_segments", {
    response: campaignSegmentResponseTransformer,
    request: campaignSegmentRequestTransformer
  });
}]).factory("campaignSegmentRequestTransformer", function() {
  var doTransform;
  doTransform = function(elem) {
    if (elem.conditions_json.limit_to_landing_page_types && elem.conditions_json.limit_to_landing_page_types.length && elem.conditions_json.limit_to_landing_page_types[0] === 'NOT_SELECTED') {
      elem.conditions_json.limit_to_landing_page_types[0] = "";
    }
    return elem;
  };
  return function(data) {
    var dataObj;
    dataObj = _.merge({}, data);
    if (dataObj.campaign_segment) {
      dataObj.campaign_segment = doTransform(dataObj.campaign_segment);
    }
    return angular.toJson(dataObj);
  };
}).factory("campaignSegmentResponseTransformer", function() {
  var doTransform;
  doTransform = function(elem) {
    var raw;
    raw = angular.fromJson(elem.raw);
    if (raw) {
      elem.visitor = raw.visitor;
      return elem.session = raw.session;
    }
  };
  return function(data) {
    var campaign_segment, i, len, ref;
    if (!data) {
      return;
    }
    data = angular.fromJson(data);
    if (data.campaign_segment) {
      doTransform(data.campaign_segment);
    } else {
      ref = data.campaign_segments;
      for (i = 0, len = ref.length; i < len; i++) {
        campaign_segment = ref[i];
        doTransform(campaign_segment);
      }
    }
    return data;
  };
});


/***/ }),
/* 1161 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('CampaignTemplate', ["$q", "Api", function($q, Api) {
  var CampaignTemplate;
  return CampaignTemplate = (function() {
    function CampaignTemplate() {}

    CampaignTemplate.views = function(params) {
      return $q(function(resolve, reject) {
        return Api.post("/api/projects/" + params.project_id + "/campaigns/" + params.campaign_id + "/" + (params.campaign_type.toLowerCase()) + "s/" + params.template_type + "/views", params).then(function(res) {
          return resolve(res.data.views);
        }, function(err) {
          return reject(err);
        });
      });
    };

    CampaignTemplate.css = function(params) {
      return $q(function(resolve, reject) {
        return Api.post("/api/projects/" + params.project_id + "/campaigns/" + params.campaign_id + "/" + (params.campaign_type.toLowerCase()) + "s/" + params.template_type + "/css", params).then(function(res) {
          return resolve(res.data.css);
        }, function(err) {
          return reject(err);
        });
      });
    };

    CampaignTemplate.confirmCss = function(params) {
      return $q(function(resolve, reject) {
        return Api.post("/api/projects/" + params.project_id + "/campaigns/" + params.campaign_id + "/" + (params.campaign_type.toLowerCase()) + "s/" + params.template_type + "/confirm_css", params).then(function(res) {
          return resolve(res.data.css);
        }, function(err) {
          return reject(err);
        });
      });
    };

    CampaignTemplate.confirmJs = function(params) {
      return $q(function(resolve, reject) {
        return Api.post("/api/projects/" + params.project_id + "/campaigns/" + params.campaign_id + "/" + (params.campaign_type.toLowerCase()) + "s/" + params.template_type + "/confirm_js", params).then(function(res) {
          return resolve(res.data.js);
        }, function(err) {
          return reject(err);
        });
      });
    };

    return CampaignTemplate;

  })();
}]);


/***/ }),
/* 1162 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectCartButton', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectCartButton;
  ProjectCartButton = (function(superClass) {
    extend(ProjectCartButton, superClass);

    function ProjectCartButton() {
      return ProjectCartButton.__super__.constructor.apply(this, arguments);
    }

    return ProjectCartButton;

  })(BaseProjectCrudService);
  return new ProjectCartButton($resource, $q, '/api/projects/:projectId/cart_buttons/:id', 'cart_button', 'cart_buttons');
}]);


/***/ }),
/* 1163 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectCartPrice', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectCartPrice;
  ProjectCartPrice = (function(superClass) {
    extend(ProjectCartPrice, superClass);

    function ProjectCartPrice() {
      return ProjectCartPrice.__super__.constructor.apply(this, arguments);
    }

    return ProjectCartPrice;

  })(BaseProjectCrudService);
  return new ProjectCartPrice($resource, $q, '/api/projects/:projectId/cart_prices/:id', 'cart_price', 'cart_prices');
}]);


/***/ }),
/* 1164 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('ClearanceItemSet', ["$resource", "$q", "Api", function($resource, $q, Api) {
  var ClearanceItemSet, URL, service;
  URL = '/api/projects/:projectId/clearance_item_sets/:id';
  ClearanceItemSet = $resource(Api.path(URL), {
    projectId: this.projectId,
    id: this.id
  }, {
    query: {
      method: 'GET',
      isArray: false
    },
    save: {
      method: 'POST',
      headers: {
        'Content-Type': void 0
      },
      transformRequest: function(data) {
        var formData;
        formData = new FormData();
        angular.forEach(data, function(val, key) {
          return formData.append(key, val);
        });
        return formData;
      }
    },
    destroy: {
      method: 'DELETE'
    },
    update: {
      method: 'PATCH'
    },
    items: {
      method: 'GET',
      url: (Api.path(URL)) + "/items"
    }
  });
  service = {
    all: function(params) {
      return $q(function(resolve, reject) {
        return ClearanceItemSet.query(params, function(res) {
          return resolve(res.clearance_item_sets);
        }, function(err) {
          return reject(err);
        });
      });
    },
    find: function(params) {
      return $q(function(resolve, reject) {
        return ClearanceItemSet.query(params, function(res) {
          return resolve(res.clearance_item_set);
        }, function(err) {
          return reject(err);
        });
      });
    },
    getItems: function(params) {
      return $q(function(resolve, reject) {
        return ClearanceItemSet.items(params, function(res) {
          return resolve(res.clearance_items);
        }, function(err) {
          return reject(err);
        });
      });
    },
    create: function(params, set) {
      return $q(function(resolve, reject) {
        var clearance_item_set;
        clearance_item_set = new ClearanceItemSet(set);
        return clearance_item_set.$save(params).then(function(res) {
          return resolve(res.clearance_item_set);
        }, function(err) {
          return reject(err);
        });
      });
    },
    destroy: function(params) {
      return $q(function(resolve, reject) {
        return ClearanceItemSet.destroy({
          projectId: params.project_id,
          id: params.id
        }).$promise.then(function(res) {
          return resolve(res);
        }, function(err) {
          return reject(err);
        });
      });
    }
  };
  return service;
}]);


/***/ }),
/* 1165 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectCookie', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectCookie;
  ProjectCookie = (function(superClass) {
    extend(ProjectCookie, superClass);

    function ProjectCookie() {
      return ProjectCookie.__super__.constructor.apply(this, arguments);
    }

    return ProjectCookie;

  })(BaseProjectCrudService);
  return new ProjectCookie($resource, $q, '/api/projects/:projectId/cookies/:id', 'cookie', 'cookies');
}]);


/***/ }),
/* 1166 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectDeletedItemDetector', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectDeletedItemDetector;
  ProjectDeletedItemDetector = (function(superClass) {
    extend(ProjectDeletedItemDetector, superClass);

    function ProjectDeletedItemDetector() {
      return ProjectDeletedItemDetector.__super__.constructor.apply(this, arguments);
    }

    return ProjectDeletedItemDetector;

  })(BaseProjectCrudService);
  return new ProjectDeletedItemDetector($resource, $q, '/api/master/projects/:projectId/deleted_item_detectors/:id', 'deleted_item_detector', 'deleted_item_detectors');
}]);


/***/ }),
/* 1167 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectExcludeIp', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectExcludeIp;
  ProjectExcludeIp = (function(superClass) {
    extend(ProjectExcludeIp, superClass);

    function ProjectExcludeIp() {
      return ProjectExcludeIp.__super__.constructor.apply(this, arguments);
    }

    return ProjectExcludeIp;

  })(BaseProjectCrudService);
  return new ProjectExcludeIp($resource, $q, '/api/projects/:projectId/exclude_ips/:id', 'exclude_ip', 'exclude_ips');
}]);


/***/ }),
/* 1168 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("Image", ["$resource", "$q", "Api", function($resource, $q, Api) {
  var Image, service;
  Image = $resource(Api.path("/api/projects/:projectId/images/:imageId"), {
    projectId: this.projectId,
    imageId: this.id
  }, {
    query: {
      method: 'GET',
      isArray: false
    },
    destroy: {
      method: 'DELETE'
    }
  });
  service = {
    all: function(params) {
      var d;
      d = $q.defer();
      Image.query(params).$promise.then(function(res) {
        return d.resolve(res.images);
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    },
    get: function(params) {
      var d;
      d = $q.defer();
      Image.get(params).$promise.then(function(res) {
        return d.resolve(res.images);
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    },
    markAsUnselectable: function(params) {
      var d;
      d = $q.defer();
      d.promise;
      Image.destroy({
        projectId: params.project_id,
        imageId: params.id
      }).$promise.then(function(res) {
        return d.resolve(res.images);
      }, function(err) {
        return d.reject(err);
      });
      return d.promise;
    }
  };
  return service;
}]);


/***/ }),
/* 1169 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('Incentive', ["$filter", "$q", "$resource", "BaseProjectCrudService", function($filter, $q, $resource, BaseProjectCrudService) {
  var Incentive;
  Incentive = (function(superClass) {
    extend(Incentive, superClass);

    function Incentive() {
      return Incentive.__super__.constructor.apply(this, arguments);
    }

    return Incentive;

  })(BaseProjectCrudService);
  return new Incentive($resource, $q, "/api/projects/:projectId/incentives/:id", "incentive", "incentives", {
    request: function(data) {
      var i, incentive, len, ref;
      if (data.incentives) {
        ref = data.incentives;
        for (i = 0, len = ref.length; i < len; i++) {
          incentive = ref[i];
          if (incentive.start_at) {
            incentive.start_at = $filter('changeDatetimeFrom')('localToRegion', incentive.start_at);
          }
          if (incentive.end_at) {
            incentive.end_at = $filter('changeDatetimeFrom')('localToRegion', incentive.end_at);
          }
        }
      } else if (data.incentive) {
        if (data.incentive.start_at) {
          data.incentive.start_at = $filter('changeDatetimeFrom')('localToRegion', data.incentive.start_at);
        }
        if (data.incentive.end_at) {
          data.incentive.end_at = $filter('changeDatetimeFrom')('localToRegion', data.incentive.end_at);
        }
      }
      return angular.toJson(data);
    },
    response: function(data) {
      var i, incentive, len, ref;
      data = angular.fromJson(data);
      if (data.incentives) {
        ref = data.incentives;
        for (i = 0, len = ref.length; i < len; i++) {
          incentive = ref[i];
          if (incentive.start_at) {
            incentive.start_at = $filter('changeDatetimeFrom')('regionToLocal', incentive.start_at);
          }
          if (incentive.end_at) {
            incentive.end_at = $filter('changeDatetimeFrom')('regionToLocal', incentive.end_at);
          }
        }
      } else if (data.incentive) {
        if (data.incentive.start_at) {
          data.incentive.start_at = $filter('changeDatetimeFrom')('regionToLocal', data.incentive.start_at);
        }
        if (data.incentive.end_at) {
          data.incentive.end_at = $filter('changeDatetimeFrom')('regionToLocal', data.incentive.end_at);
        }
      }
      return data;
    }
  });
}]);


/***/ }),
/* 1170 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('Inquiry', ["$resource", "Api", "$q", "$injector", function($resource, Api, $q, $injector) {
  var Inquiry, service;
  Inquiry = $resource(Api.path("/api/inquiry/"));
  service = {
    reasons: null,
    create: function(projectId, message, reason) {
      var NotificationChannel, d, inquiry;
      NotificationChannel = $injector.get('NotificationChannel');
      NotificationChannel.requestStarted();
      inquiry = new Inquiry({
        message: message,
        reason: reason
      });
      d = $q.defer();
      inquiry.$save().then(function(res) {
        return d.resolve(res.inquiry);
      });
      return d.promise;
    },
    getReasons: function() {
      var d;
      if (service.reasons) {
        return $q.when(service.reasons);
      } else {
        d = $q.defer();
        Api.get('/api/inquiry/reasons').then(function(res) {
          service.reasons = res.data.reasons;
          return d.resolve(service.reasons);
        });
        return d.promise;
      }
    }
  };
  return service;
}]);


/***/ }),
/* 1171 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('installationApi', ["$resource", "Api", "$q", "$stateParams", function($resource, Api, $q, $stateParams) {
  var _baseapi, _project_id, _urlapi, getDelegate, service, setDelegate;
  _project_id = $stateParams.projectId;
  _baseapi = $resource(Api.path("/api/projects/:project_id/installation/:id"), {
    project_id: '@project_id',
    id: '@id'
  });
  _urlapi = $resource(Api.path("/api/projects/:project_id/installation/:id/set"), {
    project_id: '@project_id',
    id: '@id',
    step: '@step'
  });
  getDelegate = function(param) {
    var d;
    param['project_id'] = _project_id;
    d = $q.defer();
    _baseapi.get(param).$promise.then(function(res) {
      return d.resolve(res.result);
    }, function(err) {
      return d.reject(err);
    });
    return d.promise;
  };
  setDelegate = function(param) {
    var _postm, d;
    param['project_id'] = _project_id;
    _postm = new _urlapi(param);
    d = $q.defer();
    _postm.$save().then(function(res) {
      return d.resolve(res.result);
    });
    return d.promise;
  };
  service = {
    getTrackingStatus: function() {
      return getDelegate({
        id: 'statelist'
      });
    },
    getTrackingState: function(state) {
      return getDelegate({
        id: 'status',
        state: state
      });
    },
    getTrackingPageLists: function() {
      return getDelegate({
        id: 'trackingpagelist'
      });
    },
    getTrackingPageTypes: function() {
      return getDelegate({
        id: 'trackingpagetype'
      });
    },
    setTrackingPage: function(urlobj) {
      return setDelegate({
        id: 'trackingpage',
        url: urlobj
      });
    },
    deleteTrackingPage: function(urlobj) {
      return setDelegate({
        id: 'deletetrackingpage',
        url: urlobj
      });
    },
    getConversionStatus: function() {
      return getDelegate({
        id: 'conversionstateus'
      });
    },
    getSettingDomain: function() {
      return getDelegate({
        id: 'settingdomain'
      });
    },
    setSettingDomain: function(domain) {
      return setDelegate({
        id: 'settingdomain',
        domain: domain
      });
    },
    deleteSettingDomain: function(domain) {
      return setDelegate({
        id: 'deletedomain',
        domain: domain
      });
    },
    getSiteAnalysisList: function() {
      return getDelegate({
        id: 'siteanalysislist'
      });
    },
    getSiteAnalysisState: function() {
      return getDelegate({
        id: 'siteanalysisstate'
      });
    },
    putSiteAnalysis: function(site) {
      return setDelegate({
        id: 'siteanalysis',
        site: site
      });
    },
    getIpAddresss: function() {
      return getDelegate({
        id: 'ipaddress'
      });
    },
    setIpAddress: function(address) {
      return setDelegate({
        id: 'ipaddress',
        address: address
      });
    },
    deleteIpAdress: function(address) {
      return setDelegate({
        id: 'deleteipaddress',
        address: address
      });
    },
    putinviteuser: function(mail) {
      return setDelegate({
        id: 'inviteuser',
        mail: mail
      });
    }
  };
  return service;
}]);


/***/ }),
/* 1172 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory("InvoiceAdjustments", ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var InvoiceAdjustments;
  InvoiceAdjustments = (function(superClass) {
    extend(InvoiceAdjustments, superClass);

    function InvoiceAdjustments() {
      return InvoiceAdjustments.__super__.constructor.apply(this, arguments);
    }

    return InvoiceAdjustments;

  })(BaseProjectCrudService);
  return new InvoiceAdjustments($resource, $q, "/api/projects/:projectId/invoice_adjustments/:id", "invoice_adjustment", "invoice_adjustments");
}]);


/***/ }),
/* 1173 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('Ip', ["$q", "Api", function($q, Api) {
  var Ip;
  return Ip = (function() {
    function Ip() {}

    Ip.get = function() {
      return Api.get("/api/ip/").then(function(res) {
        if (res.data.success) {
          return res.data.ip;
        } else {
          return $q.reject(res);
        }
      });
    };

    return Ip;

  })();
}]);


/***/ }),
/* 1174 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectItemListPrice', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectItemListPrice;
  ProjectItemListPrice = (function(superClass) {
    extend(ProjectItemListPrice, superClass);

    function ProjectItemListPrice() {
      return ProjectItemListPrice.__super__.constructor.apply(this, arguments);
    }

    return ProjectItemListPrice;

  })(BaseProjectCrudService);
  return new ProjectItemListPrice($resource, $q, '/api/projects/:projectId/item_list_prices/:id', 'item_list_price', 'item_list_prices');
}]);


/***/ }),
/* 1175 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectItemPrice', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectItemPrice;
  ProjectItemPrice = (function(superClass) {
    extend(ProjectItemPrice, superClass);

    function ProjectItemPrice() {
      return ProjectItemPrice.__super__.constructor.apply(this, arguments);
    }

    return ProjectItemPrice;

  })(BaseProjectCrudService);
  return new ProjectItemPrice($resource, $q, '/api/projects/:projectId/item_prices/:id', 'item_price', 'item_prices');
}]);


/***/ }),
/* 1176 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory("ProjectLoginEvaluator", ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectLoginEvaluator;
  ProjectLoginEvaluator = (function(superClass) {
    extend(ProjectLoginEvaluator, superClass);

    function ProjectLoginEvaluator() {
      return ProjectLoginEvaluator.__super__.constructor.apply(this, arguments);
    }

    return ProjectLoginEvaluator;

  })(BaseProjectCrudService);
  return new ProjectLoginEvaluator($resource, $q, "/api/projects/:projectId/login_evaluators/:id", "login_evaluator", "login_evaluators");
}]);


/***/ }),
/* 1177 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('Meta', ["Api", "$q", function(Api, $q) {
  var factory;
  factory = [];
  _.each(["devices", "segments", "referrer_types", "project_campaign_statuses", "session_count_evaluators", "particular_event_page_types", "particular_event_names", "cart_price_page_types", "cart_button_page_types", "advertising_match_types", "newsletter_parameter_match_types", "login_evaluator_match_types", "login_evaluator_evaluation_types", "project_domain_link_types", "project_ranks", "product_lines", "currencies", "regions", "sales_entities", "campaign_segment_allowed_conditions", "page_types", "page_type_match_types", "trial_invoice_calculation_types", "incentive_discount_types", "contract_statuses", "shopping_cart_asps", "invoice_calculation_types", "payment_methods", "invoice_issue_days", "invoice_due_days", "invoice_payment_days", "invoice_payment_months", "services", "interest_widget", "interest_widget_templates", "badge_position_adjustment_devices", "pricing_types", "google_analytics_event_labels", "opt_targets", "configuration_types", "testing_units", "sampling_ranges", "lite_sampling_ranges", "country_codes"], function(meta) {
    var camelized;
    camelized = _.upperFirst(_.camelCase(meta));
    return factory["get" + camelized] = function() {
      var d;
      d = $q.defer();
      Api.get("/api/meta/" + meta).then(function(res) {
        if (res.data.success) {
          return d.resolve(res.data[meta]);
        } else {
          return d.reject([]);
        }
      });
      return d.promise;
    };
  });
  return factory;
}]);


/***/ }),
/* 1178 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory("ProjectNewsletterParameter", ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectNewsletterParameter;
  ProjectNewsletterParameter = (function(superClass) {
    extend(ProjectNewsletterParameter, superClass);

    function ProjectNewsletterParameter() {
      return ProjectNewsletterParameter.__super__.constructor.apply(this, arguments);
    }

    return ProjectNewsletterParameter;

  })(BaseProjectCrudService);
  return new ProjectNewsletterParameter($resource, $q, "/api/projects/:projectId/newsletter_parameters/:id", "newsletter_parameter", "newsletter_parameters");
}]);


/***/ }),
/* 1179 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("PageTypeSampleUrl", ["$resource", "$q", "pageTypeSampleUrlServiceRequestTransformer", "PageType", "Api", function($resource, $q, pageTypeSampleUrlServiceRequestTransformer, PageType, Api) {
  var PageTypeSampleUrl, service;
  PageTypeSampleUrl = $resource(Api.path("/api/projects/:projectId/page_type_sample_urls/:id"), {
    projectId: this.projectId,
    id: this.id
  }, {
    query: {
      method: 'GET',
      isArray: false
    },
    create: {
      method: 'POST'
    },
    update: {
      method: 'PATCH',
      transformRequest: pageTypeSampleUrlServiceRequestTransformer
    },
    destroy: {
      method: 'DELETE'
    },
    options: {
      method: 'GET',
      cache: true
    }
  });
  service = {
    create: function(params, obj) {
      return $q(function(resolve, reject) {
        var page_type_sample_url;
        page_type_sample_url = new PageTypeSampleUrl(obj);
        return page_type_sample_url.$save({
          projectId: params.projectId
        }).then(function(res) {
          if (res.success) {
            return resolve(res.page_type_sample_url);
          } else {
            return reject(res);
          }
        });
      });
    },
    update: function(params, update) {
      return $q(function(resolve, reject) {
        return PageTypeSampleUrl.update(params, update).$promise.then(function(res) {
          if (res.success) {
            return resolve(res.page_type_sample_url);
          } else {
            return reject(res);
          }
        });
      });
    },
    all: function(projectId) {
      return $q(function(resolve, reject) {
        return PageTypeSampleUrl.query({
          projectId: projectId
        }, function(res) {
          return resolve(res.page_type_sample_urls);
        });
      });
    },
    destroy: function(pageType) {
      return $q(function(resolve, reject) {
        return PageTypeSampleUrl.destroy({
          projectId: pageType.project_id,
          id: pageType.id
        }).$promise.then(function(res) {
          if (res.success) {
            return resolve(res);
          } else {
            return reject();
          }
        }, function(err) {
          return reject(err);
        });
      });
    },
    "new": function(options) {
      var DEFAULT_OPTIONS, page_type_options;
      DEFAULT_OPTIONS = {
        required_device: 'both',
        page_type: '',
        types: []
      };
      page_type_options = DEFAULT_OPTIONS;
      if (options) {
        page_type_options = angular.extend(page_type_options, options);
      }
      return new PageTypeSampleUrl(page_type_options);
    },
    getPageTypeOptions: function(projectId) {
      return PageType.getPageTypeOptions(projectId);
    },
    getDevices: function(projectId) {
      return PageType.getDevices(projectId);
    }
  };
  return service;
}]).factory('pageTypeSampleUrlServiceRequestTransformer', function() {
  var doTransform;
  doTransform = function(elem) {
    elem = _.assignIn({}, elem);
    delete elem["id"];
    delete elem["isOk"];
    delete elem["types"];
    return elem;
  };
  return function(data) {
    if (data.page_type_sample_url) {
      data.page_type_sample_url = doTransform(data.page_type_sample_url);
    }
    return angular.toJson(data);
  };
});


/***/ }),
/* 1180 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module('zc.commonApi').factory("PageType", ["$resource", "$q", "Api", "pageTypeServiceRequestTransformer", function($resource, $q, Api, pageTypeServiceRequestTransformer) {
  var PageType, URL, service;
  URL = "/api/projects/:projectId/page_types/:id";
  PageType = $resource(Api.path(URL), {
    projectId: this.projectId,
    id: this.id
  }, {
    query: {
      method: 'GET',
      isArray: false
    },
    create: {
      method: 'POST',
      transformRequest: pageTypeServiceRequestTransformer
    },
    createMany: {
      method: 'POST',
      url: Api.path("/api/projects/:projectId/page_types/create_many"),
      headers: {
        'Content-Type': 'application/json'
      }
    },
    update: {
      method: 'PATCH',
      transformRequest: pageTypeServiceRequestTransformer
    },
    updateMany: {
      method: 'PATCH',
      url: Api.path("/api/projects/:projectId/page_types/update_many"),
      headers: {
        'Content-Type': 'application/json'
      }
    },
    destroy: {
      method: 'DELETE'
    },
    options: {
      method: 'GET',
      cache: true
    },
    save: {
      method: 'POST',
      headers: {
        'Content-Type': void 0
      },
      transformRequest: function(data) {
        var formData;
        formData = new FormData();
        angular.forEach(data, function(val, key) {
          return formData.append(key, val);
        });
        return formData;
      }
    }
  });
  service = {
    CUSTOM_PAGE_TYPE: '_custom_',
    transformCustomPageType: function(page_type_options, page_type) {
      var i, len, options, page_type_option, ref;
      for (i = 0, len = page_type_options.length; i < len; i++) {
        page_type_option = page_type_options[i];
        page_type_option[1];
      }
      options = (function() {
        var j, len1, results;
        results = [];
        for (j = 0, len1 = page_type_options.length; j < len1; j++) {
          page_type_option = page_type_options[j];
          results.push(page_type_option[1]);
        }
        return results;
      })();
      if (ref = page_type.page_type, indexOf.call(options, ref) < 0) {
        page_type.custom_name = page_type.page_type;
        page_type.page_type = service.CUSTOM_PAGE_TYPE;
      }
      return page_type;
    },
    create: function(params, obj) {
      return $q.all([
        service.getPageTypeOptions(params.projectId), PageType.create({
          projectId: params.projectId
        }, obj).$promise
      ]).then(function(arg) {
        var page_type_options, res;
        page_type_options = arg[0], res = arg[1];
        if (res.success) {
          return service.transformCustomPageType(page_type_options, res.page_type);
        } else {
          return $q.defer().reject(res);
        }
      });
    },
    createMany: function(params, obj) {
      return PageType.createMany({
        projectId: params.projectId
      }, {
        page_types: obj
      }).$promise;
    },
    update: function(params, update) {
      return $q.all([service.getPageTypeOptions(params.projectId), PageType.update(params, update).$promise]).then(function(arg) {
        var page_type_options, res;
        page_type_options = arg[0], res = arg[1];
        if (res.success) {
          return service.transformCustomPageType(page_type_options, res.page_type);
        } else {
          return $q.defer().reject(res);
        }
      });
    },
    updateMany: function(params, update) {
      return PageType.updateMany({
        projectId: params.projectId
      }, {
        page_types: update
      }).$promise;
    },
    all: function(projectId) {
      return $q.all([
        service.getPageTypeOptions(projectId), PageType.query({
          projectId: projectId
        }).$promise
      ]).then(function(arg) {
        var page_type_options, page_types, res;
        page_type_options = arg[0], res = arg[1];
        page_types = res.page_types.map(function(page_type) {
          return service.transformCustomPageType(page_type_options, page_type);
        });
        return page_types;
      });
    },
    destroy: function(pageType) {
      return $q(function(resolve, reject) {
        return PageType.destroy({
          projectId: pageType.project_id,
          id: pageType.id
        }).$promise.then(function(res) {
          if (res.success) {
            return resolve(res);
          } else {
            return reject();
          }
        }, function(err) {
          return reject(err);
        });
      });
    },
    "new": function(options) {
      var DEFAULT_OPTIONS, page_type_options;
      DEFAULT_OPTIONS = {
        required_device: 'both',
        evaluator: 'url',
        page_type: '',
        match_type: '',
        custom_name: ''
      };
      page_type_options = DEFAULT_OPTIONS;
      if (options) {
        page_type_options = angular.extend(page_type_options, options);
      }
      return new PageType(page_type_options);
    },
    PageTypeOptions: {},
    getPageTypeOptions: function(projectId) {
      return $q(function(resolve, reject) {
        if (service.PageTypeOptions[projectId]) {
          return resolve(service.PageTypeOptions[projectId]);
        }
        return PageType.options({
          projectId: projectId,
          id: "page_type_options"
        }, function(res) {
          if (!res.success) {
            return reject(null);
          }
          service.PageTypeOptions[projectId] = res.page_types;
          return resolve(res.page_types);
        });
      });
    },
    getMatchTypes: function(projectId) {
      return $q(function(resolve, reject) {
        return PageType.options({
          projectId: projectId,
          id: "match_types"
        }, function(res) {
          if (!res.success) {
            return reject(null);
          }
          return resolve(res.match_types);
        });
      });
    },
    getDevices: function(projectId) {
      return $q(function(resolve, reject) {
        return PageType.options({
          projectId: projectId,
          id: "devices"
        }, function(res) {
          if (!res.success) {
            return reject(null);
          }
          return resolve(res.devices);
        });
      });
    },
    isCustomPageType: function(page_type) {
      return page_type.page_type === service.CUSTOM_PAGE_TYPE;
    }
  };
  return service;
}]).factory('pageTypeServiceRequestTransformer', ["$injector", function($injector) {
  var doTransform;
  doTransform = function(elem) {
    var PageType;
    elem = _.assignIn({}, elem);
    delete elem["id"];
    delete elem["isOk"];
    PageType = $injector.get("PageType");
    if (elem.page_type === PageType.CUSTOM_PAGE_TYPE) {
      elem.page_type = elem.custom_name;
    }
    return elem;
  };
  return function(data) {
    if (data.page_type) {
      data.page_type = doTransform(data.page_type);
    }
    return angular.toJson(data);
  };
}]);


/***/ }),
/* 1181 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectParticularEvent', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectParticularEvent;
  ProjectParticularEvent = (function(superClass) {
    extend(ProjectParticularEvent, superClass);

    function ProjectParticularEvent() {
      return ProjectParticularEvent.__super__.constructor.apply(this, arguments);
    }

    return ProjectParticularEvent;

  })(BaseProjectCrudService);
  return new ProjectParticularEvent($resource, $q, '/api/projects/:projectId/particular_events/:id', 'particular_event', 'particular_events');
}]);


/***/ }),
/* 1182 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('projectServiceRequestTransformer', ["$filter", function($filter) {
  var doTransform;
  doTransform = function(project) {
    project = _.assignIn({}, project);
    if (project.installed_at) {
      project.installed_at = $filter('changeDatetimeFrom')('localToRegion', project.installed_at, 'string');
    }
    if (project.contracted_at) {
      project.contracted_at = $filter('changeDatetimeFrom')('localToRegion', project.contracted_at, 'string');
    }
    if (project.terminated_at) {
      project.terminated_at = $filter('changeDatetimeFrom')('localToRegion', project.terminated_at, 'string');
    }
    if (project.trial_started_at) {
      project.trial_started_at = $filter('changeDatetimeFrom')('localToRegion', project.trial_started_at, 'string');
    }
    if (project.trial_end_at) {
      project.trial_end_at = $filter('changeDatetimeFrom')('localToRegion', project.trial_end_at, 'string');
    }
    if (project.lens_contracted_at) {
      project.lens_contracted_at = $filter('changeDatetimeFrom')('localToRegion', project.lens_contracted_at, 'string');
    }
    if (project.lens_cancelled_at) {
      project.lens_cancelled_at = $filter('changeDatetimeFrom')('localToRegion', project.lens_cancelled_at, 'string');
    }
    if (project.iw_trial_started_at) {
      project.iw_trial_started_at = $filter('changeDatetimeFrom')('localToRegion', project.iw_trial_started_at, 'string');
    }
    if (project.iw_trial_end_at) {
      project.iw_trial_end_at = $filter('changeDatetimeFrom')('localToRegion', project.iw_trial_end_at, 'string');
    }
    if (project.iw_cancelled_at) {
      project.iw_cancelled_at = $filter('changeDatetimeFrom')('localToRegion', project.iw_cancelled_at, 'string');
    }
    if (project.iw_contracted_at) {
      project.iw_contracted_at = $filter('changeDatetimeFrom')('localToRegion', project.iw_contracted_at, 'string');
    }
    return project;
  };
  return function(data) {
    if (data.project) {
      data.project = doTransform(data.project);
    }
    return JSON.stringify(data);
  };
}]);


/***/ }),
/* 1183 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('projectServiceResponseTransformer', ["$filter", function($filter) {
  var doTransform;
  doTransform = function(project) {
    var campaign, i, len, ref;
    project.installed_at = $filter('changeDatetimeFrom')('regionToLocal', project.installed_at, 'date', project.region);
    project.companyinfo_confirmed_at = $filter('changeDatetimeFrom')('regionToLocal', project.companyinfo_confirmed_at, 'date', project.region);
    project.siteinfo_confirmed_at = $filter('changeDatetimeFrom')('regionToLocal', project.siteinfo_confirmed_at, 'date', project.region);
    project.tracking_tag_confirmed_at = $filter('changeDatetimeFrom')('regionToLocal', project.tracking_tag_confirmed_at, 'date', project.region);
    project.conversion_tag_confirmed_at = $filter('changeDatetimeFrom')('regionToLocal', project.conversion_tag_confirmed_at, 'date', project.region);
    project.first_campaign_start_at = $filter('changeDatetimeFrom')('regionToLocal', project.first_campaign_start_at, 'date', project.region);
    project.contracted_at = $filter('changeDatetimeFrom')('regionToLocal', project.contracted_at, 'date', project.region);
    project.terminated_at = $filter('changeDatetimeFrom')('regionToLocal', project.terminated_at, 'date', project.region);
    project.lens_contracted_at = $filter('changeDatetimeFrom')('regionToLocal', project.lens_contracted_at, 'date', project.region);
    project.lens_cancelled_at = $filter('changeDatetimeFrom')('regionToLocal', project.lens_cancelled_at, 'date', project.region);
    project.iw_cancelled_at = $filter('changeDatetimeFrom')('regionToLocal', project.iw_cancelled_at, 'date', project.region);
    project.iw_contracted_at = $filter('changeDatetimeFrom')('regionToLocal', project.iw_contracted_at, 'date', project.region);
    project.iw_trial_started_at = $filter('changeDatetimeFrom')('regionToLocal', project.iw_trial_started_at, 'date', project.region);
    project.iw_trial_end_at = $filter('changeDatetimeFrom')('regionToLocal', project.iw_trial_end_at, 'date', project.region);
    project.trial_started_at = $filter('changeDatetimeFrom')('regionToLocal', project.trial_started_at, 'date', project.region);
    project.trial_end_at = $filter('changeDatetimeFrom')('regionToLocal', project.trial_end_at, 'date', project.region);
    if (project.started_campaigns) {
      ref = project.started_campaigns;
      for (i = 0, len = ref.length; i < len; i++) {
        campaign = ref[i];
        campaign.start_at = $filter('changeDatetimeFrom')('regionToLocal', campaign.start_at, 'date', project.region);
        campaign.end_at = $filter('changeDatetimeFrom')('regionToLocal', campaign.end_at, 'date', project.region);
      }
    }
    return project;
  };
  return function(data) {
    var i, len, obj, project, ref;
    try {
      obj = angular.fromJson(data);
      if (obj.project) {
        doTransform(obj.project);
      }
      if (obj.projects) {
        ref = obj.projects;
        for (i = 0, len = ref.length; i < len; i++) {
          project = ref[i];
          doTransform(project);
        }
      }
      return obj;
    } catch (error) {
      return {};
    }
  };
}]);


/***/ }),
/* 1184 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('Project', ["$resource", "$q", "$state", "Api", "projectServiceResponseTransformer", "projectServiceRequestTransformer", function($resource, $q, $state, Api, projectServiceResponseTransformer, projectServiceRequestTransformer) {
  var Project, URL, doGet, service;
  URL = "/api/projects/:projectId";
  Project = $resource(Api.path(URL), {
    get: {
      projectId: '@id',
      transformResponse: projectServiceResponseTransformer
    }
  }, {
    query: {
      method: 'GET',
      transformResponse: projectServiceResponseTransformer,
      isArray: false,
      cache: true
    },
    update: {
      method: 'PATCH',
      transformRequest: projectServiceRequestTransformer,
      transformResponse: projectServiceResponseTransformer
    },
    'delete': {
      method: 'DELETE'
    },
    removePageTypes: {
      method: 'DELETE',
      url: Api.path(URL + "/remove_page_types/:page_type")
    },
    visitorIdsForDM: {
      method: 'GET',
      url: Api.path(URL + "/visitor_ids_for_dm")
    },
    uploadVisitorIdsForDM: {
      method: 'PATCH',
      url: Api.path(URL + "/upload_visitor_ids_for_dm"),
      headers: {
        'Content-Type': void 0
      },
      transformRequest: function(data) {
        var formData;
        formData = new FormData();
        angular.forEach(data, function(val, key) {
          return formData.append(key, val);
        });
        return formData;
      }
    },
    uploadPageTypes: {
      method: 'PATCH',
      url: Api.path(URL + "/upload_page_types/:page_type"),
      headers: {
        'Content-Type': void 0
      },
      transformRequest: function(data) {
        var formData;
        formData = new FormData();
        angular.forEach(data, function(val, key) {
          return formData.append(key, val);
        });
        return formData;
      }
    }
  });
  doGet = function(selector, params) {
    return $q(function(resolve, reject) {
      return Project.get(angular.extend(selector, params)).$promise.then(function(res) {
        var response;
        if (res.project) {
          response = projectServiceResponseTransformer(res);
          return resolve(response.project);
        } else {
          return reject();
        }
      }, function(err) {
        return reject(err);
      });
    });
  };
  service = {
    currentProject: null,
    create: function(params) {
      return $q(function(resolve, reject) {
        return Project.save({
          project: params
        }).$promise.then(function(res) {
          return resolve(res.project);
        });
      });
    },
    update: function(params, update) {
      return $q(function(resolve, reject) {
        return Project.update(params, update).$promise.then(function(res) {
          if (!res.success) {
            return reject({});
          } else {
            return resolve(res.project);
          }
        });
      });
    },
    removePageTypes: function(params) {
      return Project.removePageTypes(params).$promise;
    },
    remove: function(params) {
      return Project["delete"](params).$promise;
    },
    all: function() {
      return Project.query().$promise.then(function(res) {
        service.projects = res.projects;
        return res.projects;
      });
    },
    get: function(projectId, params) {
      if (params == null) {
        params = {};
      }
      return doGet({
        projectId: projectId
      }, params);
    },
    getByApikey: function(apikey, params) {
      if (params == null) {
        params = {};
      }
      return doGet({
        projectId: "apikey:" + apikey
      }, params);
    },
    getVisitorIdsForDM: function(params) {
      return $q(function(resolve, reject) {
        return Project.visitorIdsForDM(params).$promise.then(function(res) {
          return resolve(res.visitor_ids_for_dm);
        });
      });
    },
    uploadVisitorIdsForDM: function(params, update) {
      return $q(function(resolve, reject) {
        return Project.uploadVisitorIdsForDM(params, update).$promise.then(function(res) {
          return resolve(res.visitor_ids_for_dm);
        });
      });
    },
    uploadPageTypes: function(params, update) {
      return $q(function(resolve, reject) {
        return Project.uploadPageTypes(params, update).$promise.then(function(res) {
          return resolve(res.page_types);
        });
      });
    },
    getCurrent: function(projectId) {
      return $q(function(resolve, reject) {
        if (projectId) {
          return service.get(projectId).then(function(project) {
            service.currentProject = project;
            return resolve(project);
          });
        } else {
          service.currentProject = null;
          return resolve(null);
        }
      });
    },
    goHome: function(project) {
      service.currentProject = project;
      return $state.go('admin.projects.campaigns.list', {
        projectId: project.id
      });
    },
    getRegion: function() {
      var ref;
      return (ref = service.currentProject) != null ? ref.region : void 0;
    },
    isZenClerk: function() {
      var ref;
      return ((ref = service.currentProject) != null ? ref.product_line : void 0) === 'zenclerk';
    },
    isZenClerkS: function() {
      var ref;
      return ((ref = service.currentProject) != null ? ref.product_line : void 0) === 'zenclerk_s';
    },
    isZenClerkLP: function() {
      var ref;
      return ((ref = service.currentProject) != null ? ref.product_line : void 0) === 'zenclerk_lp';
    }
  };
  return service;
}]);


/***/ }),
/* 1185 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectSegmentCookie', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectSegmentCookie;
  ProjectSegmentCookie = (function(superClass) {
    extend(ProjectSegmentCookie, superClass);

    function ProjectSegmentCookie() {
      return ProjectSegmentCookie.__super__.constructor.apply(this, arguments);
    }

    return ProjectSegmentCookie;

  })(BaseProjectCrudService);
  return new ProjectSegmentCookie($resource, $q, '/api/projects/:projectId/segment_cookies/:id', 'segment_cookie', 'segment_cookies');
}]);


/***/ }),
/* 1186 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory("Template", ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var Template;
  Template = (function(superClass) {
    extend(Template, superClass);

    function Template() {
      return Template.__super__.constructor.apply(this, arguments);
    }

    return Template;

  })(BaseProjectCrudService);
  return new Template($resource, $q, "/api/projects/:projectId/templates", "template", "templates");
}]);


/***/ }),
/* 1187 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectThumbnailSelector', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectThumbnailSelector;
  ProjectThumbnailSelector = (function(superClass) {
    extend(ProjectThumbnailSelector, superClass);

    function ProjectThumbnailSelector() {
      return ProjectThumbnailSelector.__super__.constructor.apply(this, arguments);
    }

    return ProjectThumbnailSelector;

  })(BaseProjectCrudService);
  return new ProjectThumbnailSelector($resource, $q, '/api/master/projects/:projectId/thumbnail_selectors/:id', 'thumbnail_selector', 'thumbnail_selectors');
}]);


/***/ }),
/* 1188 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectTitleSelector', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectTitleSelector;
  ProjectTitleSelector = (function(superClass) {
    extend(ProjectTitleSelector, superClass);

    function ProjectTitleSelector() {
      return ProjectTitleSelector.__super__.constructor.apply(this, arguments);
    }

    return ProjectTitleSelector;

  })(BaseProjectCrudService);
  return new ProjectTitleSelector($resource, $q, '/api/master/projects/:projectId/title_selectors/:id', 'title_selector', 'title_selectors');
}]);


/***/ }),
/* 1189 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('UniqueCouponCode', ["$resource", "$q", "Api", function($resource, $q, Api) {
  var URL, UniqueCouponCode, service;
  URL = '/api/projects/:projectId/incentives/:incentiveId/unique_coupon_codes';
  UniqueCouponCode = $resource(Api.path(URL), {
    projectId: this.projectId,
    incentiveId: this.incentiveId
  }, {
    query: {
      method: 'GET',
      isArray: false
    },
    count: {
      method: 'GET',
      url: Api.path(URL + "/count")
    },
    upload: {
      method: 'PATCH',
      url: Api.path(URL + "/upload"),
      headers: {
        'Content-Type': void 0
      },
      transformRequest: function(data) {
        var formData;
        formData = new FormData();
        angular.forEach(data, function(val, key) {
          return formData.append(key, val);
        });
        return formData;
      }
    }
  });
  service = {
    all: function(params) {
      return $q(function(resolve, reject) {
        return UniqueCouponCode.query(params, function(res) {
          return resolve(res.unique_coupon_codes);
        });
      });
    },
    count: function(params) {
      return $q(function(resolve, reject) {
        return UniqueCouponCode.count(params, function(res) {
          return resolve(res.count);
        });
      });
    },
    upload: function(params, update) {
      return $q(function(resolve, reject) {
        return UniqueCouponCode.upload(params, update).$promise.then(function(res) {
          return resolve(res);
        });
      });
    }
  };
  return service;
}]);


/***/ }),
/* 1190 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory("UntrackPageType", ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var UntrackPageType;
  UntrackPageType = (function(superClass) {
    extend(UntrackPageType, superClass);

    function UntrackPageType() {
      return UntrackPageType.__super__.constructor.apply(this, arguments);
    }

    return UntrackPageType;

  })(BaseProjectCrudService);
  return new UntrackPageType($resource, $q, "/api/projects/:projectId/untrack_page_types/:id", "untrack_page_type", "untrack_page_types");
}]);


/***/ }),
/* 1191 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectUser', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectUser;
  ProjectUser = (function(superClass) {
    extend(ProjectUser, superClass);

    function ProjectUser() {
      return ProjectUser.__super__.constructor.apply(this, arguments);
    }

    return ProjectUser;

  })(BaseProjectCrudService);
  return new ProjectUser($resource, $q, '/api/projects/:projectId/users/:id', 'user', 'users');
}]);


/***/ }),
/* 1192 */
/***/ (function(module, exports) {

var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

angular.module('zc.commonApi').factory('ProjectVisitorSegment', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  var ProjectVisitorSegment;
  ProjectVisitorSegment = (function(superClass) {
    extend(ProjectVisitorSegment, superClass);

    function ProjectVisitorSegment() {
      return ProjectVisitorSegment.__super__.constructor.apply(this, arguments);
    }

    return ProjectVisitorSegment;

  })(BaseProjectCrudService);
  return new ProjectVisitorSegment($resource, $q, '/api/projects/:projectId/visitor_segments/:id', 'visitor_segment', 'visitor_segments');
}]);


/***/ }),
/* 1193 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("BaseProjectCrudService", ["Api", function(Api) {
  var BaseProjectCrudService;
  return BaseProjectCrudService = (function() {
    function BaseProjectCrudService($resource, $q, url, obj_name, obj_name_plural, transformers) {
      var options;
      this.$q = $q;
      this.url = url;
      this.obj_name = obj_name;
      this.obj_name_plural = obj_name_plural;
      options = {
        get: {
          method: 'GET'
        },
        query: {
          method: 'GET',
          isArray: false
        },
        create: {
          method: 'POST',
          isArray: false
        },
        update: {
          method: 'PATCH',
          isArray: false
        }
      };
      if (transformers) {
        if (transformers.response) {
          options.get.transformResponse = transformers.response;
        }
        if (transformers.response) {
          options.query.transformResponse = transformers.response;
        }
        if (transformers.request) {
          options.create.transformRequest = transformers.request;
        }
        if (transformers.request) {
          options.update.transformRequest = transformers.request;
        }
      }
      this.Resource = $resource(Api.path(this.url), {}, options);
    }

    BaseProjectCrudService.prototype.all = function(projectId, params) {
      return this.$q((function(_this) {
        return function(resolve, reject) {
          return _this.Resource.query(angular.extend({
            projectId: projectId
          }, params), function(res) {
            return resolve(res[_this.obj_name_plural]);
          });
        };
      })(this));
    };

    BaseProjectCrudService.prototype.get = function(projectId, id) {
      return this.$q((function(_this) {
        return function(resolve, reject) {
          return _this.Resource.get({
            projectId: projectId,
            id: id
          }, function(res) {
            return resolve(res[_this.obj_name]);
          });
        };
      })(this));
    };

    BaseProjectCrudService.prototype.create = function(params, newObject) {
      return this.$q((function(_this) {
        return function(resolve, reject) {
          return _this.Resource.create(params, newObject).$promise.then(function(res) {
            if (res.success) {
              return resolve(res[_this.obj_name]);
            } else {
              return reject({});
            }
          });
        };
      })(this));
    };

    BaseProjectCrudService.prototype.update = function(params, newObject) {
      return this.$q((function(_this) {
        return function(resolve, reject) {
          return _this.Resource.update(params, newObject).$promise.then(function(res) {
            if (res.success) {
              return resolve(res[_this.obj_name]);
            } else {
              return reject({});
            }
          });
        };
      })(this));
    };

    BaseProjectCrudService.prototype["delete"] = function(projectId, id) {
      return this.$q((function(_this) {
        return function(resolve, reject) {
          return _this.Resource["delete"]({
            projectId: projectId,
            id: id
          }).$promise.then(function(res) {
            if (res.success) {
              return resolve(id);
            } else {
              return reject({});
            }
          });
        };
      })(this));
    };

    return BaseProjectCrudService;

  })();
}]);


/***/ }),
/* 1194 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("AccessStats", ["$q", "FacadeV2", function($q, FacadeV2) {
  var AccessStats;
  AccessStats = (function() {
    var emptyToNull, filtersToMatch;

    function AccessStats() {}

    AccessStats.handleCampaignDevice = function(campaign_device) {
      switch (campaign_device) {
        case 'pc':
          return {
            $in: ['pc', 'tablet']
          };
        case 'sp':
        case 'iphone':
          return 'sp';
        case 'devicefree':
          return {
            $in: ['pc', 'tablet', 'sp']
          };
        default:
          return null;
      }
    };

    AccessStats.fields = ['session_count', 'history_count', 'interest_count', 'conversion_count', 'conversion_price', 'cart_button_click_count', 'referrer_count', 'dwell', 'repeat_session_count', 'mobile_session_count', 'tablet_session_count', 'pc_session_count', 'other_device_session_count'];

    AccessStats.aggregate = function(paths, query) {
      var params;
      params = {};
      params.match = query.match;
      params.pipeline = query.pipeline;
      return FacadeV2.request("/apikeys/" + paths.apikey + "/access_stats/" + paths.dimension + "/aggregate", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    AccessStats.aggregateDefault = function(paths, match) {
      var field, group, i, j, len, len1, project, query, ref, ref1, ref2, ref3;
      query = {
        match: match
      };
      query.pipeline = [];
      group = {
        total_found: {
          $sum: 1
        }
      };
      if ((ref = paths.dimension) === 'hour_of_day' || ref === 'day_of_week') {
        group._id = {};
        group._id[paths.dimension] = "$" + paths.dimension;
      } else {
        group._id = null;
      }
      ref1 = this.fields;
      for (i = 0, len = ref1.length; i < len; i++) {
        field = ref1[i];
        group[field] = {
          $sum: "$" + field
        };
      }
      query.pipeline.push({
        $group: group
      });
      query.pipeline.push({
        $sort: {
          _id: 1
        }
      });
      project = {
        total_found: 1
      };
      if ((ref2 = paths.dimension) === 'hour_of_day' || ref2 === 'day_of_week') {
        project[paths.dimension] = "$_id." + paths.dimension;
      }
      ref3 = this.fields;
      for (j = 0, len1 = ref3.length; j < len1; j++) {
        field = ref3[j];
        project[field] = 1;
      }
      query.pipeline.push({
        $project: project
      });
      paths = _.assignIn({}, paths);
      if (paths.dimension === 'hour_of_day') {
        paths.dimension = 'hourly';
      }
      if (paths.dimension === 'day_of_week') {
        paths.dimension = 'daily';
      }
      return this.aggregate(paths, query).then((function(_this) {
        return function(data) {
          var dummy, k, len2, ref4;
          if (data.length) {
            data = _this.transformResults(data);
          } else {
            dummy = {
              total_found: 0
            };
            ref4 = _this.fields;
            for (k = 0, len2 = ref4.length; k < len2; k++) {
              field = ref4[k];
              data[field] = 0;
            }
            data = [dummy];
          }
          return data;
        };
      })(this));
    };

    AccessStats.aggregateByFilter = function(paths, filters) {
      var match;
      match = filtersToMatch(filters);
      return this.aggregateDefault(paths, match);
    };

    AccessStats.find = function(paths, params) {
      return FacadeV2.request("/apikeys/" + paths.apikey + "/access_stats/" + paths.dimension + "/find", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    AccessStats.findDefault = function(paths, match) {
      var query;
      query = {
        match: match,
        limit: 10000,
        fields: this.fields.concat('end_at').concat(_.keys(match))
      };
      return this.find(paths, query).then((function(_this) {
        return function(data) {
          var base, base1, base2, doc, field, i, j, len, len1, name, ref, sumByStartAt;
          if (data.length) {
            sumByStartAt = {};
            for (i = 0, len = data.length; i < len; i++) {
              doc = data[i];
              sumByStartAt[name = doc.start_at] || (sumByStartAt[name] = {});
              (base = sumByStartAt[doc.start_at])['start_at'] || (base['start_at'] = doc['start_at']);
              (base1 = sumByStartAt[doc.start_at])['end_at'] || (base1['end_at'] = doc['end_at']);
              ref = _this.fields;
              for (j = 0, len1 = ref.length; j < len1; j++) {
                field = ref[j];
                (base2 = sumByStartAt[doc.start_at])[field] || (base2[field] = 0);
                sumByStartAt[doc.start_at][field] += doc[field];
              }
            }
            data = _.values(sumByStartAt);
            data = _this.transformResults(data);
          } else {
            data = [];
          }
          return data;
        };
      })(this));
    };

    AccessStats.findByFilter = function(paths, filters) {
      var match;
      match = filtersToMatch(filters);
      return this.findDefault(paths, match);
    };

    filtersToMatch = function(filters) {
      return {
        device: emptyToNull(filters.device),
        campaign_segment_id: emptyToNull(filters.campaign_segment),
        is_control: emptyToNull(filters.is_control),
        start_at: {
          $gte: moment(filters.start_at).toDate(),
          $lt: moment(filters.end_at).toDate()
        }
      };
    };

    emptyToNull = function(val) {
      if (val === '') {
        return null;
      } else {
        return val;
      }
    };

    AccessStats.transformResults = function(access_stats) {
      var i, len, stats;
      for (i = 0, len = access_stats.length; i < len; i++) {
        stats = access_stats[i];
        if (stats.session_count) {
          stats.conversion_rate = stats.conversion_count / stats.session_count;
          stats.cart_button_click_rate = stats.cart_button_click_count / stats.session_count;
          stats.average_dwell = stats.dwell / stats.session_count;
          stats.average_history_count = stats.history_count / stats.session_count;
          stats.average_interest_count = stats.interest_count / stats.session_count;
          stats.mobile_session_rate = stats.mobile_session_count / stats.session_count;
          stats.repeat_session_rate = stats.repeat_session_count / stats.session_count;
        } else {
          stats.conversion_rate = 0;
          stats.cart_button_click_rate = 0;
          stats.average_dwell = 0;
          stats.average_history_count = 0;
          stats.average_interest_count = 0;
          stats.mobile_session_rate = 0;
          stats.repeat_session_rate = 0;
        }
        if (stats.conversion_count) {
          stats.average_conversion_price = stats.conversion_price / stats.conversion_count;
        } else {
          stats.average_conversion_price = 0;
        }
        if (stats.start_at) {
          stats.start_at = new Date(stats.start_at).valueOf();
        }
        if (stats.end_at) {
          stats.end_at = new Date(stats.end_at).valueOf();
        }
      }
      return access_stats;
    };

    return AccessStats;

  })();
  return AccessStats;
}]);


/***/ }),
/* 1195 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('CampaignEventStats', ["FacadeV2", function(FacadeV2) {
  var CampaignEventStats;
  return CampaignEventStats = (function() {
    function CampaignEventStats() {}

    CampaignEventStats.aggregate = function(paths, params) {
      return FacadeV2.request("/apikeys/" + paths.apikey + "/campaign_event_stats/" + paths.dimension + "/aggregate", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    CampaignEventStats.find = function(paths, params) {
      return FacadeV2.request("/apikeys/" + paths.apikey + "/campaign_event_stats/" + paths.dimension + "/find", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    return CampaignEventStats;

  })();
}]);


/***/ }),
/* 1196 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module('zc.commonApi').factory('CampaignStats', ["$filter", "$q", "Facade", "FacadeV2", "campaignGraphOptions", "lib", function($filter, $q, Facade, FacadeV2, campaignGraphOptions, lib) {
  var BASE_ITEMS, SIGNIFICANCE_LEVEL, ZC_COST_RATE, service;
  BASE_ITEMS = ['conversion_count', 'conversion_price', 'delivery_count', 'dwell', 'cart_button_click_count', 'history_count', 'interest_count'];
  SIGNIFICANCE_LEVEL = 0.1;
  ZC_COST_RATE = 0.1;
  service = {
    ZC_COST_RATE: ZC_COST_RATE,
    find: function(params) {
      return Facade.request("/apikeys/" + params.apikey + "/campaign_stats/" + params.dimension, {
        params: {
          json: params
        },
        transformResponse: this.campaignStatsResponseTransformer
      }).then(function(res) {
        var ref;
        return (ref = res.data) != null ? ref.campaign_stats : void 0;
      });
    },
    aggregate: function(params) {
      return Facade.request("/apikeys/" + params.apikey + "/campaign_stats/" + params.dimension + "/aggregate", {
        params: {
          json: params
        },
        transformResponse: this.campaignStatsResponseTransformer
      }).then(function(res) {
        var ref;
        return (ref = res.data) != null ? ref.campaign_stats : void 0;
      });
    },
    getCampaignStats: function(params, callback) {
      params.dimension || (params.dimension = 'hourly');
      return Facade.request("/apikeys/" + params.apikey + "/campaigns/" + params.campaign_id + "/stats/" + params.dimension + "/aggregate", {
        params: params
      }).then((function(_this) {
        return function(res) {
          var ref;
          return _this.groupCampaigns((ref = res.data) != null ? ref.stats : void 0);
        };
      })(this));
    },
    getCampaignEventStats: function(params, callback) {
      params.dimension || (params.dimension = 'hourly');
      return Facade.request("/apikeys/" + params.apikey + "/campaigns/" + params.campaign_id + "/event_stats/" + params.dimension + "/aggregate", {
        params: params
      }).then(function(res) {
        var ref;
        return (ref = res.data) != null ? ref.event_stats : void 0;
      });
    },
    getHourlyConversionPriceDistribution: function(params, callback) {
      params.dimension || (params.dimension = 'hourly');
      return Facade.request("/apikeys/" + params.apikey + "/campaigns/" + params.campaign_id + "/conversion_price_distribution/" + params.dimension + "/aggregate", {
        params: params
      }).then(function(res) {
        var ref;
        return (ref = res.data) != null ? ref.conversion_price_distribution : void 0;
      });
    },
    getHourlyDwellDistribution: function(paths, query) {
      var params;
      params = {};
      params.match = query.match;
      params.pipeline = query.pipeline;
      return FacadeV2.request("/apikeys/" + paths.apikey + "/campaign_dwell_distribution/" + paths.dimension + "/aggregate", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    },
    getHourlyHistoryCountDistribution: function(paths, query) {
      var params;
      params = {};
      params.match = query.match;
      params.pipeline = query.pipeline;
      return FacadeV2.request("/apikeys/" + paths.apikey + "/campaign_history_count_distribution/" + paths.dimension + "/aggregate", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    },
    getInterestWidgetItemDistribution: function(paths, query) {
      var params;
      params = {};
      params.match = query.match;
      params.pipeline = query.pipeline;
      return FacadeV2.request("/apikeys/" + paths.apikey + "/campaign_interest_widget_item_distribution/" + paths.dimension + "/aggregate", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    },
    groupCampaigns: function(res) {
      var cid, data, j, len, single;
      if (!res) {
        return {};
      }
      data = {};
      for (j = 0, len = res.length; j < len; j++) {
        single = res[j];
        cid = single.campaign_id;
        if (!data[cid]) {
          data[cid] = {
            ctrl: [],
            exp: []
          };
        }
        if (single.is_control) {
          data[cid].ctrl.push(single);
        } else {
          data[cid].exp.push(single);
        }
      }
      return data;
    },
    sum: function(funcName, campaigns) {
      return _.reduce(campaigns, function(memo, campaign) {
        return memo += service[funcName](campaign);
      }, 0);
    },
    totalVisitors: function(campaign) {
      var ref, ref1, ref2, ref3;
      return (((ref = campaign.cumulative) != null ? (ref1 = ref.exp) != null ? ref1.delivery_count : void 0 : void 0) + ((ref2 = campaign.cumulative) != null ? (ref3 = ref2.ctrl) != null ? ref3.delivery_count : void 0 : void 0)) || 0;
    },
    totalConversions: function(campaign) {
      var ref, ref1, ref2, ref3;
      return (((ref = campaign.cumulative) != null ? (ref1 = ref.exp) != null ? ref1.conversion_count : void 0 : void 0) + ((ref2 = campaign.cumulative) != null ? (ref3 = ref2.ctrl) != null ? ref3.conversion_count : void 0 : void 0)) || 0;
    },
    totalConversionPrice: function(campaign) {
      var ref, ref1, ref2, ref3;
      return (((ref = campaign.cumulative) != null ? (ref1 = ref.exp) != null ? ref1.conversion_price : void 0 : void 0) + ((ref2 = campaign.cumulative) != null ? (ref3 = ref2.ctrl) != null ? ref3.conversion_price : void 0 : void 0)) || 0;
    },
    totalDeliveryCount: function(campaign) {
      var ref, ref1;
      return ((ref = campaign.cumulative) != null ? (ref1 = ref.exp) != null ? ref1.delivery_count : void 0 : void 0) || 0;
    },
    liftRate: function(campaign) {
      var ctrlConversionRate, expConversionRate, liftRate, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
      expConversionRate = ((ref = campaign.cumulative) != null ? (ref1 = ref.exp) != null ? ref1.conversion_count : void 0 : void 0) / ((ref2 = campaign.cumulative) != null ? (ref3 = ref2.exp) != null ? ref3.delivery_count : void 0 : void 0) || 1;
      ctrlConversionRate = ((ref4 = campaign.cumulative) != null ? (ref5 = ref4.ctrl) != null ? ref5.conversion_count : void 0 : void 0) / ((ref6 = campaign.cumulative) != null ? (ref7 = ref6.ctrl) != null ? ref7.delivery_count : void 0 : void 0) || 0;
      liftRate = (expConversionRate - ctrlConversionRate) / expConversionRate;
      return liftRate;
    },
    liftedConversionCount: function(campaign) {
      var ref, ref1;
      return ((ref = campaign.cumulative) != null ? (ref1 = ref.exp) != null ? ref1.conversion_count : void 0 : void 0) * service.liftRate(campaign) || 0;
    },
    liftedConversionPrice: function(campaign) {
      var ref, ref1;
      return ((ref = campaign.cumulative) != null ? (ref1 = ref.exp) != null ? ref1.conversion_price : void 0 : void 0) * service.liftRate(campaign) || 0;
    },
    bootstrapData: function(campaign_cumulative) {
      var bootstrap, conversion_rate, create_bootstrap_data, create_histogram_data, delivery_count, hist, n_boot, n_rank;
      n_boot = 500;
      n_rank = 10;
      create_bootstrap_data = function(delivery_count, conversion_rate, n_boot) {
        var boot, j, result, results;
        boot = (function() {
          results = [];
          for (var j = 0; 0 <= n_boot ? j <= n_boot : j >= n_boot; 0 <= n_boot ? j++ : j--){ results.push(j); }
          return results;
        }).apply(this);
        result = _.map(boot, function(item) {
          var i, k, ref, sum;
          if (delivery_count === 0) {
            return 0;
          }
          sum = 0;
          for (i = k = 1, ref = delivery_count; 1 <= ref ? k <= ref : k >= ref; i = 1 <= ref ? ++k : --k) {
            if (Math.random() < conversion_rate) {
              sum += 1;
            }
          }
          return sum / delivery_count;
        });
        return result;
      };
      create_histogram_data = function(data, n_rank) {
        var i, interval, j, k, max, min, ranks, ref, ref1, ref2, ref3, results;
        min = _.min(data);
        max = _.max(data);
        interval = (max - min) / n_rank;
        if (interval === 0) {
          return [0, 0];
        }
        ranks = [];
        for (i = j = ref = min, ref1 = max, ref2 = interval; ref2 > 0 ? j <= ref1 : j >= ref1; i = j += ref2) {
          ranks.push((function() {
            results = [];
            for (var k = i, ref3 = i + interval; i <= ref3 ? k <= ref3 : k >= ref3; i <= ref3 ? k++ : k--){ results.push(k); }
            return results;
          }).apply(this));
        }
        return _.map(ranks, function(rank) {
          var count, mean;
          mean = (rank[0] + rank[rank.length - 1]) / 2 * 100;
          mean = Math.round(mean * 100) / 100;
          count = _.reduce(data, function(memo, d) {
            if (rank.indexOf(d) !== -1) {
              memo += 1;
            }
            return memo;
          }, 0);
          return [mean, count];
        });
      };
      delivery_count = campaign_cumulative.delivery_count;
      conversion_rate = (campaign_cumulative.conversion_count / campaign_cumulative.history_count) || 0;
      bootstrap = create_bootstrap_data(delivery_count, conversion_rate, n_boot);
      hist = create_histogram_data(bootstrap, n_rank);
      return hist;
    },
    campaignStatsResponseTransformer: function(data) {
      var j, len, ref, stats;
      try {
        data = angular.fromJson(data);
        ref = data.campaign_stats;
        for (j = 0, len = ref.length; j < len; j++) {
          stats = ref[j];
          if (stats.delivery_count) {
            stats.average_dwell = stats.dwell / stats.delivery_count;
            stats.average_history_count = stats.history_count / stats.delivery_count;
            stats.cart_button_click_rate = stats.cart_button_click_count / stats.delivery_count;
            stats.conversion_rate = stats.conversion_count / stats.delivery_count;
            if (stats.conversion_count > 0) {
              stats.campaign_coupon_used_rate = stats.campaign_coupon_used_count / stats.conversion_count;
            } else {
              stats.campaign_coupon_used_rate = 0;
            }
          } else {
            stats.average_dwell = 0;
            stats.average_history_count = 0;
            stats.cart_button_click_rate = 0;
            stats.conversion_rate = 0;
            stats.campaign_coupon_used_rate = 0;
          }
          if (stats.cart_button_click_count) {
            stats.cart_through_rate = stats.conversion_count / stats.cart_button_click_count;
          }
          if (stats.conversion_count) {
            stats.average_conversion_price = stats.conversion_price / stats.conversion_count;
          } else {
            stats.average_conversion_price = 0;
          }
          stats.start_at = $filter('changeDatetimeFrom')('regionToLocal', stats.start_at, 'integer', stats.region);
          stats.end_at = $filter('changeDatetimeFrom')('regionToLocal', stats.end_at, 'integer', stats.region);
        }
        return data;
      } catch (error) {
        return {};
      }
    },
    groupById: function(campaign_stats) {
      var campaign_id, control_conversion_rate, conversion, conversion_string, j, k, len, len1, stats, statsById, sum_conversions;
      statsById = {};
      for (j = 0, len = campaign_stats.length; j < len; j++) {
        stats = campaign_stats[j];
        if (stats.original_conversions) {
          sum_conversions = lib.sumOriginalConversions(stats);
          conversion_string = '';
          for (k = 0, len1 = sum_conversions.length; k < len1; k++) {
            conversion = sum_conversions[k];
            conversion_string += conversion.price_decimal + " " + (conversion.currency.toUpperCase()) + "\n";
          }
          stats.original_conversions_string = conversion_string;
        }
        if (!statsById[stats.campaign_id]) {
          statsById[stats.campaign_id] = {
            control: {},
            experimental: {}
          };
        }
        if (stats.is_control) {
          statsById[stats.campaign_id].control = stats;
        } else {
          statsById[stats.campaign_id].experimental = stats;
        }
      }
      for (campaign_id in statsById) {
        stats = statsById[campaign_id];
        if (stats.control.conversion_rate) {
          stats.conversion_up_rate = stats.experimental.conversion_rate / stats.control.conversion_rate;
        } else {
          stats.conversion_up_rate = 0;
        }
        if (stats.experimental.conversion_rate) {
          control_conversion_rate = stats.control.conversion_rate || 0;
          stats.conversion_lift_rate = (stats.experimental.conversion_rate - control_conversion_rate) / stats.experimental.conversion_rate;
        } else {
          stats.conversion_lift_rate = 0;
        }
        if (stats.experimental.conversion_price) {
          stats.contribution_price = lib.truncateFraction(stats.conversion_lift_rate * stats.experimental.conversion_price);
        } else {
          stats.contribution_price = 0;
        }
        if (stats.experimental.conversion_count) {
          stats.contribution_count = lib.truncateFraction(stats.conversion_lift_rate * stats.experimental.conversion_count);
        } else {
          stats.contribution_count = 0;
        }
        if (new Date('2017-02-01T00:00:00+0900') <= new Date()) {
          stats.contribution_price = _.max([0, stats.contribution_price]);
          stats.contribution_count = _.max([0, stats.contribution_count]);
        }
      }
      return statsById;
    },
    forChart: function(campaign_stats) {
      var j, len, stats;
      for (j = 0, len = campaign_stats.length; j < len; j++) {
        stats = campaign_stats[j];
        stats.conversion_rate = stats.conversion_rate * 100;
        stats.average_dwell = stats.average_dwell / (1000 * 60);
        stats.cart_button_click_rate = stats.cart_button_click_rate * 100;
      }
      return campaign_stats;
    },
    calculateCumulatives: function(stats, start_at) {
      var first;
      stats = _.chain(stats).filter(function(d) {
        return d.start_at >= start_at;
      }).sortBy('startAt').value();
      first = stats.splice(0, 1)[0];
      _.each(stats, function(d) {
        var chartNames;
        _.each(BASE_ITEMS, function(name) {
          return d[name] = d[name] - first[name];
        });
        chartNames = _.chain(campaignGraphOptions).map('name').reject(function(d) {
          return indexOf.call(BASE_ITEMS, d) >= 0;
        }).value();
        return _.each(chartNames, function(name) {
          d[name] = 0;
          switch (name) {
            case 'average_history_count':
              if (d.delivery_count) {
                return d[name] = d.history_count / d.delivery_count;
              }
              break;
            case 'average_dwell':
              if (d.delivery_count) {
                return d[name] = d.dwell / d.delivery_count / (1000 * 60);
              }
              break;
            case 'average_conversion_price':
              if (d.conversion_count) {
                return d[name] = d.conversion_price / d.conversion_count;
              }
              break;
            case 'conversion_rate':
              if (d.delivery_count) {
                return d[name] = d.conversion_count / d.delivery_count * 100;
              }
              break;
            case 'cart_button_click_rate':
              if (d.delivery_count) {
                return d[name] = d.cart_button_click_count / d.delivery_count * 100;
              }
              break;
            case 'cart_through_rate':
              if (d.cart_button_click_count) {
                return d[name] = d.conversion_count / d.cart_button_click_count * 100;
              }
          }
        });
      });
      return stats;
    },
    chisqTest: function(stats) {
      return this.chisqP(stats) < SIGNIFICANCE_LEVEL;
    },
    chisqP: function(stats) {
      return ZCStats.chisqdist(1, this.chisq(stats));
    },
    chisq: function(stats) {
      var control, control_expectation, experimental, experimental_expectation, total_conversion_rate, total_delivery_count;
      if (!stats) {
        return 0;
      }
      total_delivery_count = stats.experimental.delivery_count + stats.control.delivery_count;
      if (total_delivery_count === 0) {
        return 0;
      }
      total_conversion_rate = (stats.experimental.conversion_count + stats.control.conversion_count) / total_delivery_count;
      experimental_expectation = stats.experimental.delivery_count * total_conversion_rate;
      if (experimental_expectation === 0) {
        return 0;
      }
      control_expectation = stats.control.delivery_count * total_conversion_rate;
      if (control_expectation === 0) {
        return 0;
      }
      experimental = (Math.pow(stats.experimental.conversion_count - experimental_expectation, 2)) / experimental_expectation;
      control = (Math.pow(stats.control.conversion_count - control_expectation, 2)) / control_expectation;
      return experimental + control;
    },
    calculateInvoiceAmount: function(project, campaign, stats) {
      var contribution_count, contribution_price;
      if (stats === void 0) {
        return null;
      }
      if (campaign.fee_calculation_type === 'contribution') {
        contribution_price = stats.contribution_price;
        contribution_count = stats.contribution_count;
      } else if (campaign.fee_calculation_type === 'conversion') {
        contribution_price = stats.experimental.conversion_price;
        contribution_count = stats.experimental.conversion_count;
      } else {
        throw "Unknown fee calculation type: " + campaign.fee_calculation_type + "! apikey: " + project.apikey;
      }
      switch (project.product_line) {
        case 'zenclerk':
          return contribution_price * (campaign.fee_rate || ZC_COST_RATE);
        case 'zenclerk_lp':
          if (!campaign.cost_per_acquisition) {
            return null;
          }
          return campaign.cost_per_acquisition * contribution_count;
        case 'zenclerk_s':
          return null;
        default:
          throw new Error("Unexpected product line! apikey: " + project.apikey + ", product_line: " + project.product_line);
      }
    },
    transformReport: function(json) {
      var data, report, transformed;
      try {
        data = angular.fromJson(json);
        report = data.report_stats[0];
        if (report) {
          transformed = {
            exp: {
              conversion_count: report.experimental.conversion_count,
              conversion_price: report.experimental.conversion_price,
              delivery_count: report.experimental.delivery_count
            },
            ctrl: {
              conversion_count: report.control.conversion_count,
              conversion_price: report.control.conversion_price,
              delivery_count: report.control.delivery_count
            },
            contribution_count: report.contribution_count,
            contribution_price: report.contribution_price
          };
        } else {
          transformed = {
            exp: {
              conversion_count: 0,
              conversion_price: 0,
              delivery_count: 0
            },
            ctrl: {
              conversion_count: 0,
              conversion_price: 0,
              delivery_count: 0
            },
            contribution_count: 0,
            contribution_price: 0
          };
        }
        transformed.exp.average_conversion_price = transformed.exp.conversion_price / transformed.exp.conversion_count || 0;
        transformed.ctrl.average_conversion_price = transformed.ctrl.conversion_price / transformed.ctrl.conversion_count || 0;
        transformed.exp.conversion_rate = transformed.exp.conversion_count / transformed.exp.delivery_count || 0;
        transformed.ctrl.conversion_rate = transformed.ctrl.conversion_count / transformed.ctrl.delivery_count || 0;
        if (transformed.exp.conversion_rate === 0) {
          transformed.lift_rate = 0;
        } else {
          transformed.lift_rate = (transformed.exp.conversion_rate - transformed.ctrl.conversion_rate) / transformed.exp.conversion_rate || 0;
        }
        if (transformed.ctrl.conversion_rate === 0) {
          transformed.up_rate = 0;
        } else {
          transformed.up_rate = (transformed.exp.conversion_rate / transformed.ctrl.conversion_rate) || 0;
        }
        return transformed;
      } catch (error) {
        return {};
      }
    }
  };
  return service;
}]);


/***/ }),
/* 1197 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('CampaignUsers', ["FacadeV2", function(FacadeV2) {
  var CampaignUsers;
  return CampaignUsers = (function() {
    function CampaignUsers() {}

    CampaignUsers.aggregate = function(paths, params) {
      return FacadeV2.request("/apikeys/" + paths.apikey + "/campaign_users/" + paths.dimension + "/aggregate", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    CampaignUsers.find = function(paths, params) {
      return FacadeV2.request("/apikeys/" + paths.apikey + "/campaign_users/" + paths.dimension + "/find", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    CampaignUsers.findConversions = function(paths, params) {
      return FacadeV2.request("/apikeys/" + paths.apikey + "/campaign_users/" + paths.dimension + "/find_conversions", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    return CampaignUsers;

  })();
}]);


/***/ }),
/* 1198 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("installationChecker", ["$q", "Facade", function($q, Facade) {
  var service;
  service = {
    checkTrackingCode: function(params) {
      return Facade.request("/apikeys/" + params.apikey + "/setup/check_tracking_code", {
        params: params,
        cache: false
      }).then(function(res) {
        return res.data;
      });
    },
    getLatestConversions: function(params) {
      return Facade.request("/apikeys/" + params.apikey + "/conversions/latest", {
        params: params,
        cache: false
      }).then(function(res) {
        return res.data.conversions;
      });
    },
    checkPageTypes: function(params) {
      return Facade.request("/apikeys/" + params.apikey + "/installation/check_page_types", {
        params: params,
        cache: false
      }).then(function(res) {
        return res.data;
      });
    },
    checkConversionTag: function(params) {
      return Facade.request("/apikeys/" + params.apikey + "/installation/check_conversion_tag", {
        params: params,
        cache: false
      }).then(function(res) {
        return res.data;
      });
    },
    checkDomains: function(params) {
      return Facade.request("/apikeys/" + params.apikey + "/installation/check_domains", {
        params: params,
        cache: false
      }).then(function(res) {
        return res.data;
      });
    },
    checkSessionCountEvaluator: function(params) {
      return Facade.request("/apikeys/" + params.apikey + "/installation/check_session_count_evaluator", {
        params: params,
        cache: false
      }).then(function(res) {
        return res.data;
      });
    }
  };
  return service;
}]);


/***/ }),
/* 1199 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('InterestTree', ["$q", "FacadeV2", function($q, FacadeV2) {
  var InterestTree;
  InterestTree = (function() {
    function InterestTree() {}

    InterestTree.find = function(paths, params) {
      return FacadeV2.request("/apikeys/" + paths.apikey + "/interest_trees", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    return InterestTree;

  })();
  return InterestTree;
}]);


/***/ }),
/* 1200 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("MongoCampaign", ["$q", "FacadeV2", function($q, FacadeV2) {
  var MongoCampaign;
  MongoCampaign = (function() {
    function MongoCampaign() {}

    MongoCampaign.find = function(query, options) {
      if (options == null) {
        options = {};
      }
      return $q(function(resolve, reject) {
        query || (query = {});
        if (!query.apikey) {
          return reject("No apikey");
        }
        if (!(query._id || query._sid || query._uuid || query._usid || query.campaign_id || query.created_at)) {
          return reject("no _id or _sid or _uuid or _usid or campaign_id");
        }
        return FacadeV2.request("/apikeys/" + query.apikey + "/campaigns", {
          params: {
            match: query,
            sort: options.sort,
            fields: options.fields,
            limit: options.limit || 1000
          }
        }).then(function(res) {
          if (res.status !== 200 || res.data.error) {
            return reject(res.data.error);
          } else {
            return resolve(res.data);
          }
        });
      });
    };

    return MongoCampaign;

  })();
  return MongoCampaign;
}]);


/***/ }),
/* 1201 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("MongoConversion", ["$q", "FacadeV2", function($q, FacadeV2) {
  var MongoConversion;
  MongoConversion = (function() {
    function MongoConversion() {}

    MongoConversion.find = function(query, options) {
      if (options == null) {
        options = {};
      }
      return $q(function(resolve, reject) {
        query || (query = {});
        if (!query.apikey) {
          return reject("No apikey");
        }
        return FacadeV2.request("/apikeys/" + query.apikey + "/conversions", {
          params: {
            match: query,
            sort: options.sort,
            fields: options.fields,
            limit: options.limit || 1000
          },
          cache: false
        }).then(function(res) {
          if (res.status !== 200 || res.data.error) {
            return reject(res.data.error);
          } else {
            return resolve(res.data);
          }
        });
      });
    };

    return MongoConversion;

  })();
  return MongoConversion;
}]);


/***/ }),
/* 1202 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("MongoHistory", ["$q", "FacadeV2", function($q, FacadeV2) {
  var MongoHistory;
  MongoHistory = (function() {
    function MongoHistory() {}

    MongoHistory.find = function(query, options) {
      if (options == null) {
        options = {};
      }
      return $q(function(resolve, reject) {
        query || (query = {});
        if (!query.apikey) {
          return reject("No apikey");
        }
        return FacadeV2.request("/apikeys/" + query.apikey + "/histories", {
          params: {
            match: query,
            sort: options.sort,
            limit: options.limit || 1000,
            fields: options.fields
          },
          cache: false
        }).then(function(res) {
          if (res.status !== 200 || res.data.error) {
            return reject(res.data.error);
          } else {
            return resolve(res.data);
          }
        });
      });
    };

    MongoHistory.aggregate = function(paths, query) {
      var params;
      params = {};
      params.match = query.match;
      params.pipeline = query.pipeline;
      params.limit = query.limit || 1000;
      return FacadeV2.request("/apikeys/" + paths.apikey + "/histories/aggregate", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    return MongoHistory;

  })();
  return MongoHistory;
}]);


/***/ }),
/* 1203 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("MongoParticularEvent", ["$q", "FacadeV2", function($q, FacadeV2) {
  var MongoParticularEvent;
  MongoParticularEvent = (function() {
    function MongoParticularEvent() {}

    MongoParticularEvent.find = function(query, options) {
      if (options == null) {
        options = {};
      }
      return $q(function(resolve, reject) {
        query || (query = {});
        if (!query.apikey) {
          return reject("No apikey");
        }
        return FacadeV2.request("/apikeys/" + query.apikey + "/particular_events", {
          params: {
            match: query,
            sort: options.sort,
            limit: options.limit || 1000
          },
          cache: false
        }).then(function(res) {
          if (res.status !== 200 || res.data.error) {
            return reject(res.data.error);
          } else {
            return resolve(res.data);
          }
        });
      });
    };

    return MongoParticularEvent;

  })();
  return MongoParticularEvent;
}]);


/***/ }),
/* 1204 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("MongoRaw", ["$q", "FacadeV2", function($q, FacadeV2) {
  var MongoRaw;
  MongoRaw = (function() {
    function MongoRaw() {}

    MongoRaw.find = function(query, options) {
      if (options == null) {
        options = {};
      }
      return $q(function(resolve, reject) {
        query || (query = {});
        if (!query.apikey) {
          return reject("No apikey");
        }
        if (!(query._id || query._sid)) {
          return reject("no _id or _sid");
        }
        return FacadeV2.request("/apikeys/" + query.apikey + "/raws", {
          params: {
            match: query,
            sort: options.sort,
            limit: options.limit || 1000
          }
        }).then(function(res) {
          if (res.status !== 200 || res.data.error) {
            return reject(res.data.error);
          } else {
            return resolve(res.data);
          }
        });
      });
    };

    return MongoRaw;

  })();
  return MongoRaw;
}]);


/***/ }),
/* 1205 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("MongoSession", ["$q", "FacadeV2", function($q, FacadeV2) {
  var MongoSession;
  MongoSession = (function() {
    function MongoSession() {}

    MongoSession.find = function(query, options) {
      if (options == null) {
        options = {};
      }
      return $q(function(resolve, reject) {
        var params;
        query || (query = {});
        if (!query.apikey) {
          return reject("No apikey");
        }
        if (!(query._id || query._uuid || query.opened_at || (options.sort && options.sort.indexOf("opened_at") >= 0))) {
          return reject("no _id or apikey/opened_at provided");
        }
        params = {
          params: {
            match: query,
            sort: options.sort,
            limit: options.limit || 1000,
            fields: options.fields,
            t: options.t ? options.t : void 0
          },
          ignoreLoadingBar: options.ignoreLoadingBar ? options.ignoreLoadingBar : void 0
        };
        return FacadeV2.request("/apikeys/" + query.apikey + "/sessions", params).then(function(res) {
          if (res.status !== 200 || res.data.error) {
            return reject(res.data.error);
          } else {
            return resolve(res.data);
          }
        });
      });
    };

    return MongoSession;

  })();
  return MongoSession;
}]);


/***/ }),
/* 1206 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("ProjectStats", ["$q", "FacadeV2", "AccessStats", function($q, FacadeV2, AccessStats) {
  var ProjectStats;
  return ProjectStats = (function() {
    function ProjectStats() {}

    ProjectStats.getDailyProjectStats = function(match, callback) {
      var dimension, field, group, i, len, params, query, ref;
      dimension = 'daily';
      query = {
        match: match
      };
      query.match = _.assignIn({}, match, {
        device: null,
        campaign_segment_id: null,
        is_control: {
          $ne: null
        }
      });
      query.pipeline = [];
      group = {
        _id: {
          apikey: "$apikey",
          is_control: "$is_control"
        }
      };
      ref = AccessStats.fields;
      for (i = 0, len = ref.length; i < len; i++) {
        field = ref[i];
        group[field] = {
          $sum: "$" + field
        };
      }
      query.pipeline.push({
        $group: group
      });
      params = {};
      params.match = FacadeV2.encode({}, query.match);
      params.pipeline = FacadeV2.encode([], query.pipeline);
      return FacadeV2.request("/master/access_stats/" + dimension + "/aggregate", {
        params: params
      }).then(function(res) {
        var apikey, base, f, j, len1, name, ref1, safeDiv, stat, stats, v;
        safeDiv = function(a, b) {
          if (b) {
            return a / b;
          } else {
            return 0;
          }
        };
        stats = {};
        ref1 = res.data;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          stat = ref1[j];
          stat.apikey = stat._id.apikey;
          stats[name = stat.apikey] || (stats[name] = {
            total_conversion_price: 0
          });
          for (f in stat) {
            v = stat[f];
            (base = stats[stat.apikey])[f] || (base[f] = 0);
            stats[stat.apikey][f] += v;
            if (f === 'conversion_price') {
              stats[stat.apikey]['total_conversion_price'] += v;
            }
          }
          if (stat._id.is_control) {
            stats[stat.apikey].ctl_conversion_rate = safeDiv(stat.conversion_count, stat.session_count);
            stats[stat.apikey].ctl_cart_button_click_rate = safeDiv(stat.cart_button_click_count, stat.session_count);
          } else {
            stats[stat.apikey].exp_conversion_rate = safeDiv(stat.conversion_count, stat.session_count);
            stats[stat.apikey].exp_cart_button_click_rate = safeDiv(stat.cart_button_click_count, stat.session_count);
          }
        }
        for (apikey in stats) {
          stat = stats[apikey];
          stat.avg_history_count = safeDiv(stat.history_count, stat.session_count);
          stat.avg_interest_count = safeDiv(stat.interest_count, stat.session_count);
        }
        return stats;
      });
    };

    return ProjectStats;

  })();
}]);


/***/ }),
/* 1207 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("ReportCampaignStats", ["$q", "FacadeV2", function($q, FacadeV2) {
  var ReportCampaignStats;
  ReportCampaignStats = (function() {
    function ReportCampaignStats() {}

    ReportCampaignStats.find = function(paths, params) {
      return FacadeV2.request("/apikeys/" + paths.apikey + "/report_campaign_stats/" + paths.dimension + "/find", {
        params: params
      }).then(function(res) {
        return ReportCampaignStats.transformReport(res.data);
      });
    };

    ReportCampaignStats.transformReport = function(data) {
      var cumulatives, i, len, stats;
      try {
        for (i = 0, len = data.length; i < len; i++) {
          stats = data[i];
          cumulatives = {
            experimental: {
              conversion_count: stats.experimental.conversion_count,
              conversion_price: stats.experimental.conversion_price,
              delivery_count: stats.experimental.delivery_count
            },
            control: {
              conversion_count: stats.control.conversion_count,
              conversion_price: stats.control.conversion_price,
              delivery_count: stats.control.delivery_count
            },
            contribution_count: stats.contribution_count,
            contribution_price: stats.contribution_price
          };
          cumulatives.experimental.average_conversion_price = cumulatives.experimental.conversion_price / cumulatives.experimental.conversion_count || 0;
          cumulatives.control.average_conversion_price = cumulatives.control.conversion_price / cumulatives.control.conversion_count || 0;
          cumulatives.experimental.conversion_rate = cumulatives.experimental.conversion_count / cumulatives.experimental.delivery_count || 0;
          cumulatives.control.conversion_rate = cumulatives.control.conversion_count / cumulatives.control.delivery_count || 0;
          if (cumulatives.control.conversion_rate === 0) {
            cumulatives.conversion_up_rate = 0;
          } else {
            cumulatives.conversion_up_rate = (cumulatives.experimental.conversion_rate / cumulatives.control.conversion_rate) || 0;
          }
          angular.extend(stats, cumulatives);
        }
        return data;
      } catch (error) {
        return {};
      }
    };

    return ReportCampaignStats;

  })();
  return ReportCampaignStats;
}]);


/***/ }),
/* 1208 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('Report', ["$q", "FacadeV2", "Project", function($q, FacadeV2, Project) {
  var Report;
  return Report = (function() {
    function Report() {}

    Report.find = function(paths, params) {
      return FacadeV2.request("/apikeys/" + paths.apikey + "/report_stats/" + paths.dimension + "/find", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    Report.findOne = function(paths, params) {
      return FacadeV2.request("/apikeys/" + paths.apikey + "/report_stats/" + paths.dimension + "/find_one", {
        params: params
      }).then(function(res) {
        return res.data;
      });
    };

    return Report;

  })();
}]);


/***/ }),
/* 1209 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('reportStatsResponseTransformer', function() {
  return function(data) {
    var i, len, ref, stats;
    try {
      data = angular.fromJson(data);
      ref = data.report_stats;
      for (i = 0, len = ref.length; i < len; i++) {
        stats = ref[i];
        if (stats.start_at) {
          stats.start_at = moment(stats.start_at).valueOf();
        }
        if (stats.end_at) {
          stats.end_at = moment(stats.end_at).valueOf();
        }
      }
      return data;
    } catch (error) {
      return {};
    }
  };
});


/***/ }),
/* 1210 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('TagNonExistingUrls', ["FacadeV2", function(FacadeV2) {
  var TagNonExistingUrls;
  return TagNonExistingUrls = (function() {
    function TagNonExistingUrls() {}

    TagNonExistingUrls.findOne = function(paths) {
      return FacadeV2.request("/apikeys/" + paths.apikey + "/tag_non_existing_urls", {
        params: {
          match: {}
        }
      }).then(function(results) {
        var ref;
        return (ref = results.data) != null ? ref[0] : void 0;
      });
    };

    return TagNonExistingUrls;

  })();
}]);


/***/ }),
/* 1211 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('ZcsAgencyInvoice', ["$q", "FacadeV2", function($q, FacadeV2) {
  var ZcsAgencyInvoice;
  return ZcsAgencyInvoice = (function() {
    function ZcsAgencyInvoice() {}

    ZcsAgencyInvoice.all = function(agency_id) {
      return FacadeV2.request("/agencies/" + agency_id + "/zcs_agency_invoices/").then(function(res) {
        return _.map(res.data, function(d) {
          d.invoice_price = parseInt(d.invoice_price);
          d.invoice_price_tax_excluded = parseInt(d.invoice_price_tax_excluded);
          return d;
        });
      });
    };

    ZcsAgencyInvoice.find = function(agency_id, month) {
      return FacadeV2.request("/agencies/" + agency_id + "/zcs_agency_invoices/" + month, {}).then(function(res) {
        res.data.invoice_price = parseInt(res.data.invoice_price);
        res.data.invoice_price_tax_excluded = parseInt(res.data.invoice_price_tax_excluded);
        return res.data;
      });
    };

    ZcsAgencyInvoice.findAgencyApikeyMaxInvoice = function(agency_id, month) {
      return FacadeV2.request("/agencies/" + agency_id + "/zcs_agency_invoices/" + month + "/apikeyMaxInvoice", {}).then(function(res) {
        var max_invoice_by_apikey;
        max_invoice_by_apikey = {};
        _.each(res.data, function(d) {
          return max_invoice_by_apikey[d.apikey] = d.max_invoice;
        });
        return max_invoice_by_apikey;
      });
    };

    return ZcsAgencyInvoice;

  })();
}]);


/***/ }),
/* 1212 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').filter('campaign', function() {
  return function(campaigns, filters) {
    var result;
    result = _.filter(campaigns, function(campaign) {
      if (filters) {
        if (filters.start_at && filters.end_at && campaign.start_at && campaign.end_at) {
          if (moment(campaign.start_at).startOf("day").valueOf() > filters.end_at) {
            return false;
          }
          if (campaign.end_at.valueOf() < filters.start_at) {
            return false;
          }
        }
        if (filters.device_value && filters.device_value.name && filters.device_value.name !== campaign.campaign_device) {
          return false;
        }
        if (filters.campaign_segment_value && filters.campaign_segment_value.id && filters.campaign_segment_value.id !== _.get(campaign, 'segment.id', -1)) {
          return false;
        }
        if (filters.referrer_type && filters.referrer_type.name && filters.referrer_type.name !== campaign.referrer_type) {
          return false;
        }
      }
      if (filters.status) {
        if (campaign.current_status !== filters.status) {
          return false;
        }
      }
      return true;
    });
    return result;
  };
});


/***/ }),
/* 1213 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').filter('campaignText', function() {
  return function(campaigns, search) {
    var result;
    result = _.filter(campaigns, function(campaign) {
      var conditions, keywords, ref, ref1, ref2;
      if (!search) {
        return true;
      }
      conditions = [campaign.project_name, campaign.apikey, campaign.status, campaign.campaign_device, campaign.name, campaign.id, (ref = campaign.elements) != null ? (ref1 = ref[0]) != null ? ref1.id : void 0 : void 0, campaign.template_type, campaign.campaign_target, (ref2 = campaign.campaign_policy_set) != null ? ref2.name : void 0];
      keywords = search.split(/\s/);
      return _.every(keywords, function(keyword) {
        return _.some(conditions, function(condition) {
          if (typeof condition !== 'string') {
            condition = condition + '';
          }
          if (condition && condition.indexOf(keyword) > -1) {
            return true;
          }
          return false;
        });
      });
    });
    return result;
  };
});


/***/ }),
/* 1214 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').filter('currentStatus', function() {
  return function(campaign) {
    var current_status, hasActiveIncentives, hasEnded, hasIncentives, hasNotStartedYet, hasPendingIncentives, isRunning;
    isRunning = function(campaign) {
      return moment(campaign.start_at).diff(moment()) < 0 && moment(campaign.end_at).diff(moment()) > 0;
    };
    hasNotStartedYet = function(campaign) {
      return moment(campaign.start_at).diff(moment()) > 0;
    };
    hasEnded = function(campaign) {
      return moment(campaign.end_at).diff(moment()) < 0;
    };
    hasIncentives = function(campaign) {
      return _.get(campaign, 'incentives', []).length > 0;
    };
    hasActiveIncentives = function(campaign) {
      if (!hasIncentives(campaign)) {
        return false;
      }
      return typeof _.find(campaign.incentives, {
        current_status: 'active'
      }) !== 'undefined';
    };
    hasPendingIncentives = function(campaign) {
      if (!hasIncentives(campaign)) {
        return false;
      }
      return typeof _.find(campaign.incentives, {
        current_status: 'pending'
      }) !== 'undefined';
    };
    current_status = campaign.status;
    if (current_status === 'activated') {
      if (isRunning(campaign)) {
        if (!campaign.requires_incentives || hasActiveIncentives(campaign)) {
          return 'active';
        }
        if (hasPendingIncentives(campaign)) {
          return 'pending';
        }
        return 'no_incentives';
      }
      if (hasNotStartedYet(campaign)) {
        return 'pending';
      }
      if (hasEnded(campaign)) {
        return 'terminated';
      }
    }
    if (current_status === 'blocked') {
      if (hasEnded(campaign)) {
        return 'terminated';
      }
    }
    return current_status;
  };
});


/***/ }),
/* 1215 */
/***/ (function(module, exports) {

var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

angular.module('zc.commonApi').filter('device', function() {
  return function(templates, device) {
    return _.filter(templates, function(template) {
      return indexOf.call(template.support_devices, device) >= 0;
    });
  };
});


/***/ }),
/* 1216 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').filter('projectText', function() {
  return function(projects, filterText) {
    var result;
    result = _.filter(projects, function(project) {
      var conditions, keywords;
      if (!filterText) {
        return true;
      }
      conditions = [project.title, project.apikey, project.base_url, project.id];
      keywords = filterText.split(/\s/);
      return _.every(keywords, function(keyword) {
        return _.some(conditions, function(condition) {
          if (typeof condition !== 'string') {
            condition = condition + '';
          }
          if (condition && condition.indexOf(keyword) > -1) {
            return true;
          }
          return false;
        });
      });
    });
    return result;
  };
});


/***/ }),
/* 1217 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').service('campaignGraphOptions', ["$filter", function($filter) {
  return [
    {
      name: 'delivery_count',
      isMasterOnly: false,
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.deliveryCount'),
      unit: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.visit'),
      decimal: 0
    }, {
      name: 'conversion_count',
      isMasterOnly: false,
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.conversionCount'),
      unit: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.conversion'),
      decimal: 0
    }, {
      name: 'conversion_rate',
      isMasterOnly: false,
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.conversion_rate'),
      unit: ' %',
      decimal: 1
    }, {
      name: 'cvr_increase_rate',
      isMasterOnly: true,
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.cvrIncreaseRate'),
      unit: ' %',
      decimal: 1
    }, {
      name: 'cart_button_click_rate',
      isMasterOnly: false,
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.cartButtonClickRate'),
      unit: ' %',
      decimal: 1
    }, {
      name: 'cart_through_rate',
      isMasterOnly: false,
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.cartThroughRate'),
      unit: ' %',
      decimal: 2
    }, {
      name: 'average_history_count',
      isMasterOnly: false,
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.averageHistoryCount'),
      unit: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.pageView'),
      decimal: 1
    }, {
      name: 'average_dwell',
      isMasterOnly: false,
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.averageDwell'),
      unit: $filter('translate')('sharedModules.dateTimeFormats.minute'),
      decimal: 1
    }, {
      name: 'average_conversion_price',
      isMasterOnly: false,
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.averageConversionPrice'),
      unit: '',
      decimal: 0
    }, {
      name: 'conversion_price',
      isMasterOnly: false,
      label: $filter('translate')('sharedModules.commonApi.misc.campaignGraphOptions.conversionPrice'),
      unit: '',
      decimal: 0
    }
  ];
}]);


/***/ }),
/* 1218 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').service('campaignStatuses', ["$filter", function($filter) {
  return {
    incomplete: {
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.incomplete'),
      statusClass: 'label status-notset'
    },
    preview: {
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.preview'),
      statusClass: 'label status-waiting'
    },
    active: {
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.active'),
      statusClass: 'label status-active'
    },
    finished: {
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.finished'),
      statusClass: 'label status-finished'
    },
    terminated: {
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.terminated'),
      statusClass: 'label status-finished'
    },
    pending: {
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.pending'),
      statusClass: 'label status-waiting'
    },
    no_incentives: {
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.no_incentives'),
      statusClass: 'label status-waiting'
    },
    blocked: {
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.blocked'),
      statusClass: 'label status-stop'
    }
  };
}]);


/***/ }),
/* 1219 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('ReportRange', ["cronHours", "Project", function(cronHours, Project) {
  var ReportRange;
  return ReportRange = (function() {
    var baseTime;

    function ReportRange() {}

    ReportRange.isLatest = function(begin_at) {
      return moment(begin_at).tz(Project.getRegion()).isSame(baseTime(), 'month');
    };

    ReportRange.hasLatest = function() {
      return baseTime().date() > 1;
    };

    ReportRange.getLatest = function() {
      var _baseTime;
      _baseTime = baseTime();
      return {
        begin_at: moment(_baseTime).startOf('month').toDate(),
        start_at: moment(_baseTime).subtract(1, 'days').startOf('day').toDate(),
        end_at: moment(_baseTime).startOf('day').toDate()
      };
    };

    baseTime = function() {
      return moment().tz(Project.getRegion()).subtract(cronHours.dailyReport, 'hours');
    };

    return ReportRange;

  })();
}]);


/***/ }),
/* 1220 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').service("SegmentEstimator", ["MasterMongoSession", "MasterMongoVisitor", "MasterAccessStats", "SegmentMatcher", "$q", function(MasterMongoSession, MasterMongoVisitor, MasterAccessStats, SegmentMatcher, $q) {
  var SegmentEstimator;
  return SegmentEstimator = (function() {
    var buildQueryWithTiming;

    function SegmentEstimator() {}

    buildQueryWithTiming = function(combinedQuery, timingSegments) {
      var base, i, j, len, len1, originalSessionOr, originalVisitorOr, query, ref, ref1, timingSessionsQueries, timingVisitorsQueries;
      originalSessionOr = combinedQuery['$or'] || [];
      originalVisitorOr = combinedQuery['visitor']['$or'] || [];
      if (!_.isEmpty(originalSessionOr)) {
        delete combinedQuery['$or'];
      }
      if (!_.isEmpty(originalVisitorOr)) {
        delete combinedQuery['visitor']['$or'];
      }
      timingSessionsQueries = _.chain(timingSegments).map(SegmentMatcher.createSegmentQuery).compact().filter(function(x) {
        return !_.isEmpty(x);
      }).value();
      timingVisitorsQueries = _.chain(timingSegments).map(SegmentMatcher.createVisitorQuery).compact().filter(function(x) {
        return !_.isEmpty(x);
      }).value();
      if (!(_.isEmpty(originalSessionOr) && _.isEmpty(timingSessionsQueries))) {
        combinedQuery['$and'] || (combinedQuery['$and'] = []);
      }
      ref = [originalSessionOr, timingSessionsQueries];
      for (i = 0, len = ref.length; i < len; i++) {
        query = ref[i];
        if (!_.isEmpty(query)) {
          combinedQuery['$and'] = combinedQuery['$and'].concat([
            {
              '$or': query
            }
          ]);
        }
      }
      if (!(_.isEmpty(originalVisitorOr) || _.isEmpty(timingVisitorsQueries))) {
        (base = combinedQuery['visitor'])['$and'] || (base['$and'] = []);
      }
      ref1 = [originalVisitorOr, timingVisitorsQueries];
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        query = ref1[j];
        if (!_.isEmpty(query)) {
          combinedQuery['visitor']['$and'] = combinedQuery['visitor']['$and'].concat([
            {
              '$or': query
            }
          ]);
        }
      }
      return combinedQuery;
    };

    SegmentEstimator.filterSessionsBySegmentQuery = function(mongo_query, device, sessions, timingSegments) {
      var combinedQuery, deviceQuery, deviceSessions, matchedSessions, segmentQuery, visitorQuery;
      segmentQuery = SegmentMatcher.createSegmentQuery(mongo_query);
      visitorQuery = SegmentMatcher.createVisitorQuery(mongo_query);
      combinedQuery = segmentQuery;
      combinedQuery.visitor = visitorQuery;
      if (timingSegments) {
        combinedQuery = buildQueryWithTiming(combinedQuery, timingSegments);
      }
      deviceSessions = sessions;
      if (device !== 'all') {
        combinedQuery.device = device;
        deviceQuery = {
          device: device
        };
        deviceSessions = SegmentMatcher.matchSessions(deviceQuery, sessions);
      }
      matchedSessions = SegmentMatcher.matchSessions(combinedQuery, sessions);
      return {
        matchedSessions: matchedSessions,
        deviceSessions: deviceSessions
      };
    };

    SegmentEstimator.getSessions = function(apikey, timeLimitDate) {
      var CHUNK_SIZE, SESSIONS_TO_GET, query, sessions;
      SESSIONS_TO_GET = 1000;
      CHUNK_SIZE = 100;
      sessions = [];
      query = {
        apikey: apikey
      };
      if (timeLimitDate) {
        _.merge(query, {
          opened_at: {
            $lt: timeLimitDate
          }
        });
      }
      return MasterMongoSession.find(query, {
        limit: SESSIONS_TO_GET,
        sort: "-opened_at"
      }).then(function(_sessions) {
        var chunks, promises, uuids;
        sessions = _sessions;
        uuids = _.chain(sessions).map('_uuid').uniq().value();
        chunks = _.chunk(uuids, CHUNK_SIZE);
        promises = _.map(chunks, function(chunk) {
          return MasterMongoVisitor.find({
            _id: {
              $in: chunk
            }
          });
        });
        return $q.all(promises);
      }).then(function(visitors) {
        visitors = _.flatten(visitors);
        _.each(sessions, function(session) {
          return _.each(visitors, function(visitor) {
            if (visitor._id === session._uuid) {
              return session.visitor = visitor;
            }
          });
        });
        return sessions;
      });
    };

    SegmentEstimator.getAccessStats = function(apikey, start_at, segment_id) {
      return MasterAccessStats.find({
        apikey: apikey,
        start_at: start_at,
        is_control: null,
        is_after_installed_at: null,
        total_conversion_count: null,
        campaign_segment_id: {
          $in: [null, segment_id]
        }
      }).then(function(res) {
        var accessStatsEnd, accessStatsMatchedCounts, accessStatsStart, accessStatsTotalCounts;
        accessStatsTotalCounts = {
          all: 0
        };
        accessStatsMatchedCounts = {
          all: 0
        };
        accessStatsStart = null;
        accessStatsEnd = null;
        _.chain(res).groupBy(function(d) {
          return d.campaign_segment_id;
        }).each(function(grouped) {
          return _.each(grouped, function(stat) {
            if (stat.campaign_segment_id === null) {
              accessStatsTotalCounts[stat.device || "all"] = stat.session_count;
            } else if (stat.campaign_segment_id === segment_id) {
              accessStatsMatchedCounts[stat.device || "all"] = stat.session_count;
            }
            accessStatsStart = stat.start_at;
            return accessStatsEnd = stat.end_at;
          });
        }).value();
        return {
          accessStatsTotalCounts: accessStatsTotalCounts,
          accessStatsMatchedCounts: accessStatsMatchedCounts,
          accessStatsStart: accessStatsStart,
          accessStatsEnd: accessStatsEnd
        };
      });
    };

    return SegmentEstimator;

  })();
}]);


/***/ }),
/* 1221 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory("SegmentMatcher", function() {
  var service;
  service = {
    getCombinedDeviceCondition: function(device) {
      switch (device) {
        case 'pc':
          return {
            $in: ['pc', 'tablet']
          };
        case 'sp':
        case 'iphone':
          return 'sp';
        default:
          return {
            $exists: true
          };
      }
    },
    isDateString: function(str) {
      return !(_.isNaN(Date.parse(str)) || /^\d\.?\d*$/.test(str));
    },
    recursivelyReplaceZcVariables: function(query) {
      var found, k, key, keys, results, v;
      results = [];
      for (k in query) {
        v = query[k];
        if (_.isObject(v)) {
          found = false;
          keys = Object.keys(v);
          if (keys.length === 1) {
            key = keys[0];
            switch (key) {
              case '$zcDaysFromNow':
                query[k] = moment().add(v[key], "days").toDate();
                found = true;
                break;
              case '$zcSecondsFromNow':
                query[k] = moment().add(v[key], 'seconds').toDate();
                found = true;
            }
          }
          if (!found) {
            results.push(service.recursivelyReplaceZcVariables(v));
          } else {
            results.push(void 0);
          }
        } else if (service.isDateString(v)) {
          results.push(query[k] = new Date(v));
        } else {
          results.push(void 0);
        }
      }
      return results;
    },
    createSegmentQuery: function(query) {
      var k, segmentQuery, v;
      segmentQuery = {};
      for (k in query) {
        v = query[k];
        if (_.startsWith(k, 'Session#')) {
          segmentQuery[k.slice('Session#'.length)] = v;
        }
      }
      return segmentQuery;
    },
    createHistoryQuery: function(query) {
      var k, segmentQuery, v;
      segmentQuery = {};
      for (k in query) {
        v = query[k];
        if (_.startsWith(k, 'History#')) {
          segmentQuery[k.slice('History#'.length)] = v;
        }
      }
      return segmentQuery;
    },
    createVisitorQuery: function(query) {
      var k, v, visitorQuery;
      visitorQuery = {};
      for (k in query) {
        v = query[k];
        if (_.startsWith(k, 'Visitor#')) {
          visitorQuery[k.slice('Visitor#'.length)] = v;
        }
      }
      return visitorQuery;
    },
    matchSessions: function(query, sessions) {
      query = _.merge({}, query);
      service.recursivelyReplaceZcVariables(query);
      return sift(query, sessions);
    }
  };
  return service;
});


/***/ }),
/* 1222 */
/***/ (function(module, exports) {

angular.module('zc.commonApi').factory('ProjectPageDescription', ["$resource", "$q", "BaseProjectCrudService", function($resource, $q, BaseProjectCrudService) {
  return new BaseProjectCrudService($resource, $q, '/api/master/projects/:projectId/page_descriptions/:id', 'page_description', 'page_descriptions');
}]);


/***/ }),
/* 1223 */
/***/ (function(module, exports) {

angular.module('zc.core').config(["$urlRouterProvider", function($urlRouterProvider) {
  return $urlRouterProvider.rule(function($injector, $location) {
    var path;
    path = $location.url();
    if (path[path.length - 1] === "/") {
      return path.slice(0, -1);
    }
    if (path.indexOf("/?") > -1) {
      return path.replace("/?", "?");
    }
  });
}]).config(["$urlRouterProvider", function($urlRouterProvider) {
  return $urlRouterProvider.otherwise(function($injector, $location) {
    var $state, Devise;
    $state = $injector.get('$state');
    Devise = $injector.get('Devise');
    if (!Devise.currentUser && ($location.path() === '/' || $location.path() === '')) {
      $state.go('users.signIn', null, {});
    } else if (Devise.currentUser && ($location.path() === '/' || $location.path() === '')) {
      $state.go('admin.home');
    } else {
      $state.go('404', null, {
        location: false
      });
    }
  });
}]);


/***/ }),
/* 1224 */
/***/ (function(module, exports) {

angular.module('zc.core').config(["$locationProvider", function($locationProvider) {
  return $locationProvider.html5Mode({
    enabled: true,
    requireBase: false
  }).hashPrefix('!');
}]).config(["$httpProvider", function($httpProvider) {
  var authToken;
  authToken = $('meta[name="csrf-token"]').attr('content');
  $httpProvider.defaults.headers.common['X-CSRF-TOKEN'] = authToken;
  return $httpProvider.defaults.withCredentials = true;
}]).config(["$httpProvider", function($httpProvider) {
  return $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
}]).config(["$httpProvider", function($httpProvider) {
  return $httpProvider.interceptors.push('SessionRecoverer');
}]).config(["$httpProvider", function($httpProvider) {
  return $httpProvider.interceptors.push('errorInterceptor');
}]).config(["$httpProvider", function($httpProvider) {
  return $httpProvider.interceptors.push('notificationInterceptor');
}]).config(["localStorageServiceProvider", function(localStorageServiceProvider) {
  return localStorageServiceProvider.setPrefix('zc');
}]).config(["$httpProvider", function($httpProvider) {
  return $httpProvider.defaults.headers.patch = {
    'Content-Type': 'application/json;charset=utf-8'
  };
}]).config(["$sceDelegateProvider", function($sceDelegateProvider) {
  return $sceDelegateProvider.resourceUrlWhitelist(['self', 'http://**', 'https://**']);
}]);


/***/ }),
/* 1225 */
/***/ (function(module, exports) {

angular.module('zc.core').constant('cronHours', {
  dailyReport: 5
});


/***/ }),
/* 1226 */
/***/ (function(module, exports) {

angular.module('zc.core').constant('currencies', {
  jpy: {
    symbol: '',
    fractionSize: 0,
    suffix: '円'
  },
  usd: {
    symbol: '',
    fractionSize: 2,
    suffix: 'USD'
  },
  aud: {
    symbol: '',
    fractionSize: 2,
    suffix: 'AUD'
  },
  cad: {
    symbol: 'C$',
    fractionSize: 2,
    suffix: ''
  },
  chf: {
    symbol: 'CHF',
    fractionSize: 2,
    suffix: ''
  },
  cny: {
    symbol: '',
    fractionSize: 2,
    suffix: 'Yuan'
  },
  eur: {
    symbol: '€',
    fractionSize: 2,
    suffix: ''
  },
  gbp: {
    symbol: '£',
    fractionSize: 2,
    suffix: ''
  },
  hkd: {
    symbol: '',
    fractionSize: 2,
    suffix: 'HKD'
  },
  idr: {
    symbol: 'Rp',
    fractionSize: 0,
    suffix: ''
  },
  inr: {
    symbol: '₹',
    fractionSize: 0,
    suffix: ''
  },
  krw: {
    symbol: '₩',
    fractionSize: 0,
    suffix: ''
  },
  myr: {
    symbol: 'RM',
    fractionSize: 2,
    suffix: ''
  },
  nzd: {
    symbol: 'NZ$',
    fractionSize: 2,
    suffix: ''
  },
  php: {
    symbol: '₱',
    fractionSize: 2,
    suffix: ''
  },
  sgd: {
    symbol: '',
    fractionSize: 2,
    suffix: 'SGD'
  },
  sek: {
    symbol: '',
    fractionSize: 0,
    suffix: 'kr'
  },
  thb: {
    symbol: '฿',
    fractionSize: 2,
    suffix: ''
  },
  twd: {
    symbol: 'NT$',
    fractionSize: 0,
    suffix: ''
  },
  vnd: {
    symbol: '',
    fractionSize: 0,
    suffix: '₫'
  },
  zar: {
    symbol: 'R',
    fractionSize: 2,
    suffix: ''
  },
  clp: {
    symbol: '$',
    fractionSize: 2,
    suffix: ''
  },
  cop: {
    symbol: '$',
    fractionSize: 2,
    suffix: ''
  }
});


/***/ }),
/* 1227 */
/***/ (function(module, exports) {

angular.module('zc.core').controller('AdminHeaderCtrl', ["$scope", "currentUser", "Project", "Environment", function($scope, currentUser, Project, Environment) {
  $scope.currentUser = currentUser;
  $scope.Project = Project;
  $scope.notification = true;
  $scope.switchNotification = function() {
    return $scope.notification = !$scope.notification;
  };
  $scope.environment = 'production';
  return Environment.get().then(function(env) {
    return $scope.environment = env;
  });
}]);


/***/ }),
/* 1228 */
/***/ (function(module, exports) {

angular.module('zc.core').controller('MainnavCtrl', ["$scope", "Project", "Devise", "currentUser", function($scope, Project, Devise, currentUser) {
  $scope.Project = Project;
  $scope.isMaster = Devise.isMaster();
  $scope.isInternalUser = Devise.isInternalUser();
  $scope.currentUser = currentUser;
  $scope.isDisplayAajsWarningMsg = false;
  return $scope.$watch('Project.currentProject', function(newValue, oldValue) {
    $scope.projectId = newValue != null ? newValue.id : void 0;
    $scope.thisMonth = moment().format('YYYY-MM');
    if (newValue) {
      $scope.aiReportURL = ZC_CONFIG.AIDEAL_URL + "/site/" + newValue.apikey + "/report?period=" + $scope.thisMonth;
      return $scope.isDisplayAajsWarningMsg = newValue.enable_aajs && _.some([newValue.site_id, newValue.tracking_id, newValue.scope_id], (function(_this) {
        return function(item) {
          return !(item && item.length > 0);
        };
      })(this));
    }
  });
}]);


/***/ }),
/* 1229 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('zcAdmin', ["$rootScope", "$location", "PageLayout", function($rootScope, $location, PageLayout) {
  return {
    restrict: 'E',
    templateUrl: '/templates/core/views/admin.html',
    link: function(scope, elem, attrs) {
      return $rootScope.$on('$stateChangeSuccess', function() {
        if ($location.path().indexOf('/admin/master') === 0) {
          return PageLayout.showFooter = false;
        } else {
          return PageLayout.showFooter = true;
        }
      });
    }
  };
}]);


/***/ }),
/* 1230 */
/***/ (function(module, exports) {

angular.module('zc.core').directive("confirmModal", ["$translate", "$window", function($translate, $window) {
  return {
    scope: {
      suppressConfirm: '=',
      confirmClick: '&'
    },
    link: function(scope, element, attr) {
      return element.bind("click", function(event) {
        var isElementDisabled, msg;
        msg = attr.confirmModal || $translate.instant('sharedModules.core.directives.confirmModal');
        isElementDisabled = _.get(attr, 'disabled', false) === "true" || element[0].classList.contains('disabled');
        if (isElementDisabled) {
          return;
        }
        if (scope.suppressConfirm) {
          return scope.confirmClick();
        } else {
          if ($window.confirm(msg)) {
            return scope.confirmClick();
          }
        }
      });
    }
  };
}]);


/***/ }),
/* 1231 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('zcDateRange', ["$filter", function($filter) {
  return {
    restrict: "E",
    scope: {
      startAt: '=',
      endAt: '=',
      isInfinite: '=',
      displayTime: '='
    },
    template: "{{ startAt | zcDate: { smart: isUseSmart, dateOnly: !displayTime } }}\n-\n{{ isInfinite\n  ? ('projectsCampaignsViews.directives.campaignRange.kigen_nashi' | translate)\n  : ( endAt | zcDate: { smart: isUseSmart, dateOnly: !displayTime } ) }}",
    link: function(scope) {
      return scope.isUseSmart = moment(scope.startAt).isSame(moment(scope.endAt), 'year');
    }
  };
}]);


/***/ }),
/* 1232 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('dateTimePicker', ["$filter", function($filter) {
  return {
    restrict: 'EA',
    scope: {
      data: '=?ngModel',
      date: '=?',
      isRequired: '=?',
      region: '<',
      productLine: '<',
      interval: '<'
    },
    template: '<div class="row clearfix">\n  <div class="col-md-6">\n    <div class="date input-group input-group-lg">\n      <span class="input-group-addon">\n        <i class="fa fa-calendar"></i>\n      </span>\n      <input\n        class="form-control form_datepick"\n        ng-class="{\n          \'ng-invalid\': isRequired && !data.date\n        }"\n        ng-style="{\n          \'border\': borderStyle\n        }"\n        datepick\n        size="16"\n        type="text"\n        date="data.date"\n        ng-required="isRequired"/>\n    </div>\n  </div>\n  <div class="col-md-6">\n    <div class="time input-group input-group-lg">\n      <span class="input-group-addon">\n        <i class="glyphicon glyphicon-time"></i>\n      </span>\n      <input\n        class="form-control form_timepick"\n        ng-class="{\n          \'ng-invalid\': isRequired && !data.time && data.time !== 0\n        }"\n        ng-style="{\n          \'border\': borderStyle\n        }"\n        timepick\n        size="16"\n        type="text"\n        time="data.time"\n        interval="interval"\n        ng-required="isRequired"/>\n        <span\n          class="input-group-addon"\n          tooltip="{{ region | gmtNotation }}">\n          {{ gmtOffset }}\n        </span>\n    </div>\n  </div>\n</div>',
    link: function(scope, element, attrs) {
      var region;
      region = scope.region ? scope.region : 'Asia/Tokyo';
      scope.gmtOffset = "(" + (moment().tz(region).format('Z')) + ")";
      scope.isNotLite = scope.productLine && scope.productLine !== 'zenclerk_s';
      scope.borderStyle = scope.isNotLite ? 'solid 1px #ccc' : 'auto';
      scope.$watch('date', function(newValue) {
        if (!newValue) {
          return;
        }
        return scope.data = $filter('dateToDateObj')(newValue);
      }, true);
      return scope.$watch('data', function(newValue) {
        if (!newValue) {
          return;
        }
        return scope.date = $filter('dateObjToDate')(newValue);
      }, true);
    }
  };
}]).directive('timepick', [
  '$timeout', function($timeout) {
    return {
      restrict: 'A',
      require: '?time',
      scope: {
        time: '=',
        interval: '='
      },
      link: function(scope, element, attrs) {
        var $input, picker, processChange;
        processChange = function(ev) {
          if (typeof ev.select === 'undefined') {
            return scope.$apply(function(scope) {
              return scope.time = void 0;
            });
          } else {
            return scope.$apply(function(scope) {
              return scope.time = ev.select;
            });
          }
        };
        $input = element.pickatime({
          onSet: processChange,
          format: 'HH:i',
          formatSubmit: 'HH:i',
          interval: scope.interval
        });
        picker = $input.pickatime('picker');
        if (scope.time || scope.time === 0) {
          $timeout(function() {
            return picker.set('select', scope.time);
          });
        }
        scope.$watch('time', function(newValue) {
          if (typeof newValue !== 'undefined') {
            return $timeout(function() {
              return picker.set('select', newValue);
            });
          }
        });
        return $input.off('focus');
      }
    };
  }
]).directive('datepick', [
  '$timeout', '$filter', function($timeout, $filter) {
    return {
      restrict: 'A',
      require: '?date',
      scope: {
        date: '=',
        min: '=',
        max: '='
      },
      link: function(scope, element, attrs) {
        var $input, picker, processChange, updateDate, updateMax, updateMin;
        updateDate = function(newValue, oldValue) {
          if (newValue === oldValue) {
            return;
          }
          if (newValue) {
            return picker.set('select', moment(newValue).format());
          } else {
            return picker.clear();
          }
        };
        updateMin = function(newValue) {
          var min;
          min = newValue ? moment(newValue).startOf('day').toDate() : false;
          return picker.set('min', min);
        };
        updateMax = function(newValue) {
          var max;
          max = newValue ? moment(newValue).endOf('day').toDate() : false;
          return picker.set('max', max);
        };
        processChange = function(ev) {
          if (scope.$$phase || scope.$root.$$phase) {
            return;
          }
          if (typeof ev.select === 'undefined') {
            return scope.$apply(function(scope) {
              return scope.date = null;
            });
          } else {
            return scope.$apply(function(scope) {
              return scope.date = moment(ev.select).startOf('day').format();
            });
          }
        };
        $input = element.pickadate({
          onSet: processChange,
          format: $filter('translate')('sharedModules.dateTimeFormats.dateTimePicker.format'),
          formatSubmit: $filter('translate')('sharedModules.dateTimeFormats.dateTimePicker.format')
        });
        picker = $input.pickadate('picker');
        $input.off('focus');
        updateDate(scope.date);
        updateMin(scope.min);
        updateMax(scope.max);
        scope.$watch('date', updateDate, true);
        scope.$watch('min', updateMin, true);
        return scope.$watch('max', updateMax, true);
      }
    };
  }
]);


/***/ }),
/* 1233 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('zcDirtyFormDialog', ["$translate", "NotificationChannel", function($translate, NotificationChannel) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var doPrompt, isDirty;
      isDirty = function() {
        var form;
        form = scope[element.attr('name')];
        return form && form.$pristine === false;
      };
      doPrompt = function() {
        if (isDirty()) {
          return $translate.instant('sharedModules.core.directives.dirtyFormDialog');
        }
        return void 0;
      };
      $(window).bind('beforeunload', doPrompt);
      element.bind('$destroy', function() {
        return $(window).unbind('beforeunload', doPrompt);
      });
      return scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
        var prompt;
        if (fromState === toState) {
          return;
        }
        prompt = doPrompt();
        if (prompt && !confirm(prompt)) {
          event.preventDefault();
          return NotificationChannel.requestEnded();
        }
      });
    }
  };
}]);


/***/ }),
/* 1234 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('zcDownloadCampaignDataButton', ["$q", "clientReportCsvCreator", "CampaignStats", function($q, clientReportCsvCreator, CampaignStats) {
  return {
    restrict: 'E',
    scope: {
      filters: '=',
      project: '=',
      campaigns: '=',
      isAb: '='
    },
    template: "<button\n  class=\"btn btn-sm pull-right btn-default\"\n  ng-csv=\"getCSV()\"\n  add-bom=\"true\"\n  charset=\"utf-16\"\n  field-separator=\"\\t\"\n  filename=\"report_{{project.apikey}}_{{date}}.csv\">\n  <i class=\"fa fa-cloud-download\"></i> {{ 'sharedModules.core.directives.download_campaign_data_button' | translate }}\n</button>",
    link: function(scope, element, attrs) {
      scope.date = moment().format('YYYYMMDD');
      scope.prepareCampaigns = function(campaigns) {
        return $q(function(resolve) {
          var c, campaign, end_at, i, len, ref, result, start_at;
          result = [];
          campaigns = _.sortBy(campaigns, function(campaign) {
            return campaign.id;
          });
          for (i = 0, len = campaigns.length; i < len; i++) {
            campaign = campaigns[i];
            start_at = new Date(scope.filters.start_at);
            end_at = moment(scope.filters.end_at).endOf('day').toDate();
            if (new Date(campaign.start_at) > start_at) {
              start_at = new Date(campaign.start_at);
            }
            if (new Date(campaign.end_at) < end_at) {
              end_at = new Date(campaign.end_at);
            }
            c = _.assignIn({}, campaign);
            c.start_at = start_at;
            c.end_at = end_at;
            if ((ref = c.stats) != null) {
              ref.invoice_amount = CampaignStats.calculateInvoiceAmount(scope.project, c, c.stats);
            }
            result.push(c);
          }
          return resolve(result);
        });
      };
      return scope.getCSV = function() {
        return $q(function(resolve) {
          return scope.prepareCampaigns(scope.campaigns).then(function(campaignsWithStats) {
            return clientReportCsvCreator.createCsv(scope.project, campaignsWithStats, scope.isAb);
          }).then(function(res) {
            return resolve(res);
          });
        });
      };
    }
  };
}]);


/***/ }),
/* 1235 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('fixedOnScroll', ["$document", function($document) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var DEFAULT_OFFSET, el, handleScroll, initialPosition, offset, offsetTop;
      DEFAULT_OFFSET = 10;
      try {
        if (attrs.offsetTop) {
          offsetTop = parseInt(attrs.offsetTop);
        } else {
          offsetTop = DEFAULT_OFFSET;
        }
      } catch (error) {
        offsetTop = DEFAULT_OFFSET;
      }
      el = angular.element(element);
      offset = el.offset();
      initialPosition = el.css('position') || "static";
      handleScroll = function(ev) {
        var scrollTop;
        scrollTop = $document.scrollTop();
        if (scrollTop > offset.top - offsetTop) {
          el.css('position', 'fixed');
          return el.css('top', offsetTop);
        } else {
          return el.css('position', initialPosition);
        }
      };
      $document.on('scroll', handleScroll);
      return scope.$on('$destroy', function() {
        return $document.off('scroll', handleScroll);
      });
    }
  };
}]);


/***/ }),
/* 1236 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('zcFooter', ["PageLayout", function(PageLayout) {
  return {
    restrict: 'E',
    templateUrl: '/templates/core/views/directives/footer.html',
    link: function(scope, elem, attrs) {
      scope.PageLayout = PageLayout;
      scope.$watch('PageLayout.showFooter', function(newval) {
        if (newval === false) {
          elem.addClass('hidden');
          return $("#wrapper").addClass('no-padding');
        } else {
          elem.removeClass('hidden');
          return $("#wrapper").removeClass('no-padding');
        }
      });
      return scope.thisYear = moment().year();
    }
  };
}]);


/***/ }),
/* 1237 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('loading', ["NotificationChannel", function(NotificationChannel) {
  var directive;
  directive = {
    restrict: "A",
    link: function(scope, element) {
      var endRequestHandler, startRequestHandler;
      element.addClass("all-filter-remove");
      startRequestHandler = function() {
        return element.removeClass("all-filter-remove");
      };
      endRequestHandler = function() {
        return element.addClass("all-filter-remove");
      };
      NotificationChannel.onRequestStarted(scope, startRequestHandler);
      return NotificationChannel.onRequestEnded(scope, endRequestHandler);
    }
  };
  return directive;
}]);


/***/ }),
/* 1238 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('positiveOrNegative', ["$filter", function($filter) {
  var directive;
  directive = {
    restrict: "A",
    require: '?value',
    scope: {
      zero: "@",
      type: "@",
      positivePrefix: "@",
      zeroIsNegative: "@",
      showsZero: '<',
      fractionSize: '<',
      value: "=value"
    },
    template: "<span class=\"positive-or-negative label\" ng-class=\"statusClass\" ng-if=\"shows\">{{prefix}}{{showValue}}</span>",
    link: function(scope, element, attrs) {
      scope.value || (scope.value = 0);
      scope.statusClass = "";
      scope.prefix = "";
      return scope.$watch('value', function(oldValue, newValue) {
        var fractionSize;
        if (typeof scope.type === "undefined") {
          scope.type = "number";
        }
        if (typeof scope.positivePrefix === 'undefined') {
          scope.positivePrefix = "+";
        }
        if (typeof scope.zeroIsNegative === 'undefined') {
          scope.zeroIsNegative = true;
        }
        if (typeof scope.showsZero === 'undefined') {
          scope.showsZero = true;
        }
        if (typeof scope.fractionSize === 'undefined') {
          fractionSize = 0;
        } else {
          fractionSize = scope.fractionSize;
        }
        scope.zero || (scope.zero = 0);
        if (scope.value < scope.zero || (scope.zeroIsNegative && scope.value === scope.zero)) {
          scope.statusClass = "negative";
          scope.prefix = "";
          scope.type;
        } else {
          scope.statusClass = "positive";
          if (scope.positivePrefix) {
            scope.prefix = scope.positivePrefix;
          }
        }
        if (!scope.value && scope.value !== 0) {
          scope.showValue = "";
          scope.prefix = "";
        } else if (scope.type === "percentage") {
          scope.showValue = $filter('number')(scope.value * 100, fractionSize) + "%";
        } else {
          scope.showValue = $filter('number')(scope.value, fractionSize);
        }
        if (scope.showsZero) {
          return scope.shows = true;
        } else if (scope.value === scope.zero) {
          return scope.shows = false;
        } else {
          return scope.shows = true;
        }
      });
    }
  };
  return directive;
}]);


/***/ }),
/* 1239 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('zcDateTimePicker', ["$filter", function($filter) {
  return {
    restrict: 'E',
    scope: {
      pickerId: '@',
      data: '=?ngModel',
      isRequired: '=?',
      minView: '@'
    },
    templateUrl: '/templates/core/views/directives/zc_date_time_picker.html'
  };
}]);


/***/ }),
/* 1240 */
/***/ (function(module, exports) {

angular.module('zc.core').filter('changeDatetimeFrom', ["Project", function(Project) {
  return function(from, date, returnType, region) {
    var datetimeInBrowser, datetimeInRegion, targetDatetime;
    if (returnType == null) {
      returnType = 'date';
    }
    if (!['localToRegion', 'regionToLocal'].includes(from)) {
      throw new TypeError("Please provide a valid 'from' value. " + from);
    }
    if (!date) {
      return null;
    }
    if (new Date(date).toString() === 'Invalid Date') {
      throw new TypeError('Please provide a date');
    }
    region || (region = Project.getRegion());
    if (!region) {
      throw new TypeError('Please provide a region');
    }
    if (from === 'localToRegion') {
      datetimeInBrowser = moment(date).format('YYYY-MM-DD HH:mm:ss');
      targetDatetime = moment.tz(datetimeInBrowser, region);
    } else {
      datetimeInRegion = moment(date).tz(region).format('YYYY-MM-DD HH:mm:ss');
      targetDatetime = moment(datetimeInRegion, 'YYYY-MM-DD HH:mm:ss');
    }
    if (returnType === 'moment') {
      return targetDatetime;
    }
    if (returnType === 'string') {
      return targetDatetime.format();
    }
    if (returnType === 'integer') {
      return targetDatetime.valueOf();
    }
    return targetDatetime.toDate();
  };
}]);


/***/ }),
/* 1241 */
/***/ (function(module, exports) {

angular.module('zc.core').filter('dateObjToDate', ["$filter", function($filter) {
  return function(date_obj) {
    var date;
    date = null;
    if (date_obj && date_obj.date && (date_obj.time || date_obj.time === 0)) {
      date = moment(date_obj.date).add(date_obj.time, 'minutes').format();
    }
    return date;
  };
}]);


/***/ }),
/* 1242 */
/***/ (function(module, exports) {

angular.module('zc.core').filter('dateToDateObj', ["$filter", "$translate", function($filter, $translate) {
  return function(date) {
    var date_obj;
    date_obj = {};
    if (date) {
      date_obj.date = moment(date).startOf('day').valueOf();
      date_obj.time = moment(date).diff(moment(date_obj.date)) / 60 / 1000;
      date_obj.date_raw = moment(date_obj.date).format($translate.instant('sharedModules.dateTimeFormats.filters.dateToDateObj.format'));
      date_obj.time_raw = moment().startOf('day').add(date_obj.time, 'minutes').format('HH:mm');
    } else {
      date_obj.date = null;
      date_obj.time = null;
    }
    return date_obj;
  };
}]);


/***/ }),
/* 1243 */
/***/ (function(module, exports) {

angular.module('zc.core').filter("dayOfWeek", ["$filter", function($filter) {
  return function(day) {
    var date;
    date = moment().day(day).toDate();
    return $filter('date')(date, 'EEEE');
  };
}]);


/***/ }),
/* 1244 */
/***/ (function(module, exports) {

angular.module('zc.core').filter("elapseTime", ["$filter", function($filter) {
  var A_DAY;
  A_DAY = 1000 * 60 * 60 * 24;
  return function(milliseconds) {
    if ((0 <= milliseconds && milliseconds < A_DAY)) {
      return $filter('date')(milliseconds, 'HH:mm:ss', 'UTC');
    } else if (A_DAY <= milliseconds) {
      return '(data too big)';
    } else {
      return "-" + $filter('date')(-milliseconds, 'HH:mm:ss', 'UTC');
    }
  };
}]);


/***/ }),
/* 1245 */
/***/ (function(module, exports) {

angular.module('zc.core').filter("emptyToEnd", ["$parse", function($parse) {
  return function(array, key, reverse) {
    var empty, keyFn, present;
    if (!angular.isArray(array)) {
      return;
    }
    keyFn = $parse(key);
    empty = [];
    present = [];
    angular.forEach(array, function(item) {
      var val;
      val = keyFn(item);
      if (angular.isUndefined(val) || val === null) {
        return empty.push(item);
      } else {
        return present.push(item);
      }
    });
    if (reverse) {
      return present.concat(empty);
    } else {
      return empty.concat(present);
    }
  };
}]);


/***/ }),
/* 1246 */
/***/ (function(module, exports) {

angular.module('zc.core').filter('hourOfDay', ["$filter", "$translate", function($filter, $translate) {
  return function(hour) {
    var date;
    date = moment().hour(hour).toDate();
    return $filter('date')(date, $translate.instant('sharedModules.dateTimeFormats.filters.hourOfDay.format'));
  };
}]);


/***/ }),
/* 1247 */
/***/ (function(module, exports) {

angular.module('zc.core').filter('searchProject', function() {
  return function(projects, filter) {
    if (!filter) {
      return projects;
    }
    return projects.filter(function(project) {
      return _.includes(project.title, filter) || _.includes(project.apikey, filter);
    });
  };
});


/***/ }),
/* 1248 */
/***/ (function(module, exports) {

angular.module('zc.core').filter("segmentValueFormat", ["$parse", function($parse) {
  return function(value) {
    if (angular.isString(value)) {
      return "\"" + value + "\"";
    } else if (_.isNull(value)) {
      return "null";
    } else {
      return value;
    }
  };
}]);


/***/ }),
/* 1249 */
/***/ (function(module, exports) {

var escapeHtml;

escapeHtml = function(str) {
  return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
};

angular.module('zc.core').filter("showElement", ["$sce", function($sce) {
  return function(message, column) {
    var escaped, html, value;
    value = message[column.name];
    if (value) {
      escaped = escapeHtml(value);
      html = (function() {
        switch (column.type) {
          case "image":
            return "<div><image src=\"" + escaped + "\"></div>";
          case "color":
            return "<div><div style=\"background-color:" + escaped + "; width: 24px; height:24px; display:inline-block\"></div> <span>" + escaped + "</span></div>";
          case "url":
            if (/^https?:\/\//i.test(String(value))) {
              return "<div style=\"background-color:" + escaped + ";\"><a href=\"" + escaped + "\" target=\"_blank\">" + escaped + "</a></div>";
            } else {
              return "<div>" + escaped + "</div>";
            }
            break;
          case "duration":
            return "<div>" + escaped + "min</div>";
          default:
            return "<div>" + escaped + "</div>";
        }
      })();
      return $sce.trustAsHtml(html);
    } else {
      return "empty";
    }
  };
}]);


/***/ }),
/* 1250 */
/***/ (function(module, exports) {

angular.module('zc.core').filter("zcCurrency", ["$filter", function($filter) {
  return function(currency, symbol, fractionSize, suffix) {
    var string;
    currency = currency / (Math.pow(10, fractionSize));
    string = $filter('currency')(currency, symbol, fractionSize);
    if (suffix) {
      string += suffix;
    }
    return string;
  };
}]);


/***/ }),
/* 1251 */
/***/ (function(module, exports) {

angular.module('zc.core').filter('zcDate', ["$filter", function($filter) {
  var HM_FORMAT, LONG_FORMAT, SHORT_FORMAT;
  SHORT_FORMAT = $filter('translate')('sharedModules.dateTimeFormats.filters.zcDate.shortFormat');
  LONG_FORMAT = $filter('translate')('sharedModules.dateTimeFormats.filters.zcDate.longFormat');
  HM_FORMAT = $filter('translate')('sharedModules.dateTimeFormats.filters.zcDate.timeFormat');
  return function(date, options) {
    var long_format, short_format;
    if (options == null) {
      options = {};
    }
    if (!date) {
      return '';
    }
    if (options.dateOnly) {
      short_format = SHORT_FORMAT;
      long_format = LONG_FORMAT;
    } else {
      short_format = SHORT_FORMAT + " " + HM_FORMAT;
      long_format = LONG_FORMAT + " " + HM_FORMAT;
    }
    if (options.smart) {
      if (moment().isSame(date, 'year')) {
        return $filter('date')(date, short_format);
      } else {
        return $filter('date')(date, long_format);
      }
    } else if (options.format) {
      return $filter('date')(date, options.format);
    } else if (options.short) {
      return $filter('date')(date, short_format);
    } else {
      return $filter('date')(date, long_format);
    }
  };
}]);


/***/ }),
/* 1252 */
/***/ (function(module, exports) {

angular.module('zc.core').filter("zerosForMissingTime", ["$filter", function($filter) {
  var DAILY_INTERVAL, HOURLY_INTERVAL, dimensions;
  DAILY_INTERVAL = 24 * 60 * 60 * 1000;
  HOURLY_INTERVAL = 60 * 60 * 1000;
  dimensions = {
    hourly: {
      singular: 'hour',
      plural: 'hours',
      interval: HOURLY_INTERVAL
    },
    daily: {
      singular: 'day',
      plural: 'days',
      interval: DAILY_INTERVAL
    }
  };
  return function(array, dimension, opts) {
    var addZerosForPeriod, afterEndAt, allKeys, beforeStartAt, convertTo, createObj, currentDimension, i, lastDate, len, obj, toBeAdded;
    if (opts == null) {
      opts = {};
    }
    opts = _.merge({
      start_at_key: 'start_at',
      end_at_key: 'end_at'
    }, opts);
    if (array.length == null) {
      return array;
    }
    if (array.length === 0) {
      return array;
    }
    if (!_.has(dimensions, dimension)) {
      return array;
    }
    currentDimension = dimensions[dimension];
    array = _.sortBy(array, function(o) {
      return o[opts.start_at_key];
    });
    toBeAdded = [];
    lastDate = void 0;
    convertTo = 'date';
    if (typeof array[0][opts.start_at_key] === 'number') {
      convertTo = 'number';
    }
    allKeys = _.chain(array).map(function(obj) {
      return Object.getOwnPropertyNames(obj);
    }).flatten().union().value();
    createObj = function(start_at, end_at) {
      var i, key, len, newObj;
      newObj = {};
      for (i = 0, len = allKeys.length; i < len; i++) {
        key = allKeys[i];
        newObj[key] = 0;
      }
      newObj[opts.start_at_key] = start_at;
      newObj[opts.end_at_key] = end_at;
      return newObj;
    };
    addZerosForPeriod = function(start_at, end_at) {
      var diffInMilliseconds, diffInTimeUnits, endAt, i, ref, results, startAt, timeCounter;
      diffInMilliseconds = moment(end_at).valueOf() - moment(start_at).valueOf();
      if (diffInMilliseconds > currentDimension.interval) {
        diffInTimeUnits = diffInMilliseconds / currentDimension.interval;
        results = [];
        for (timeCounter = i = 1, ref = diffInTimeUnits - 1; 1 <= ref ? i <= ref : i >= ref; timeCounter = 1 <= ref ? ++i : --i) {
          startAt = moment(start_at).add(timeCounter, currentDimension.plural).valueOf();
          endAt = moment(startAt).endOf(currentDimension.singular).valueOf();
          results.push(toBeAdded.push(createObj(startAt, endAt)));
        }
        return results;
      }
    };
    for (i = 0, len = array.length; i < len; i++) {
      obj = array[i];
      if (lastDate) {
        addZerosForPeriod(lastDate, obj[opts.start_at_key]);
      }
      lastDate = obj[opts.start_at_key];
    }
    if (opts.start_at) {
      beforeStartAt = moment(opts.start_at).diff(moment(array[0][opts.start_at_key]));
      if (beforeStartAt !== 0) {
        addZerosForPeriod(moment(opts.start_at).subtract(1, currentDimension.plural), moment(array[0][opts.start_at_key]));
      }
    }
    if (opts.end_at) {
      afterEndAt = moment(moment(array[0][opts.end_at_key])).diff(opts.end_at);
      if (afterEndAt !== 0) {
        if (dimension === 'hourly' && moment().startOf('day').isSame(moment(opts.end_at).startOf('day'))) {
          addZerosForPeriod(moment(array[array.length - 1][opts.end_at_key]).startOf(currentDimension.singular), moment(opts.end_at).hour(moment().hour()).startOf(currentDimension.singular));
        } else {
          addZerosForPeriod(moment(array[array.length - 1][opts.end_at_key]).startOf(currentDimension.singular), moment(opts.end_at).add(1, currentDimension.singular).startOf(currentDimension.singular));
        }
      }
    }
    array = _.chain(array).union(toBeAdded).sortBy(function(o) {
      return o[opts.start_at_key];
    }).map(function(o) {
      if (convertTo === 'date') {
        o[opts.start_at_key] = new Date(o[opts.start_at_key]);
        o[opts.end_at_key] = new Date(o[opts.end_at_key]);
      }
      return o;
    }).value();
    return array;
  };
}]);


/***/ }),
/* 1253 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('errorInterceptor', ["$location", "$q", "$injector", "$translate", "returnUrl", function($location, $q, $injector, $translate, returnUrl) {
  var _createBetterErrorsModal, createBetterErrorsModal, error, success, translateErrorKeyName;
  _createBetterErrorsModal = function(res) {
    var Environment;
    Environment = $injector.get('Environment');
    return Environment.get().then(function(environment) {
      var betterErrors;
      if (environment !== 'development') {
        return;
      }
      if ($("#better-errors-modal").length === 0) {
        betterErrors = "<div class=\"modal fade\" id=\"better-errors-modal\" tabindex=\"-1\" role=\"dialog\">\n  <div class=\"modal-dialog\" style=\"width: 80%\" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\n        <h4 class=\"modal-title\">500 Error</h4>\n      </div>\n      <div class=\"modal-body\">\n        <iframe src=\"\" style=\"width: 100%; height: 60vh\"></iframe>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>\n      </div>\n    </div><!-- /.modal-content -->\n  </div><!-- /.modal-dialog -->\n</div><!-- /.modal -->";
        $("body").append(betterErrors);
      } else {
        $('#better-errors-modal .modal-body iframe').attr("src", "");
      }
      $('#better-errors-modal').on('shown.bs.modal', function() {
        return $('#better-errors-modal .modal-body iframe').attr("src", ZC_CONFIG.RAILS_API_URL + ":" + ZC_CONFIG.RAILS_API_PORT + "/__better_errors");
      });
      return $('#better-errors-modal').modal();
    });
  };
  createBetterErrorsModal = _.debounce(_createBetterErrorsModal, 500);
  success = function(res) {
    var ref;
    if ((ref = res.data) != null ? ref.message : void 0) {
      alertify.success(res.data.message);
    }
    return res;
  };
  translateErrorKeyName = function(res, keyName) {
    var anchorElement, apiPath, qualifiedKeyName, translatedKeyName;
    translatedKeyName = $translate.instant(keyName);
    if (translatedKeyName !== keyName) {
      return translatedKeyName;
    } else {
      anchorElement = document.createElement('a');
      anchorElement.href = res.config.url;
      apiPath = anchorElement.pathname;
      if (!apiPath) {
        return keyName;
      }
      apiPath = _(apiPath.replace(/\d+/g, '').replace('//', '/').split('/')).compact().join(".");
      qualifiedKeyName = apiPath + "." + keyName;
      return $translate.instant(qualifiedKeyName);
    }
  };
  error = function(res) {
    var $state, Devise, ref, ref1;
    if (res != null ? (ref = res.data) != null ? ref.error_message : void 0 : void 0) {
      alertify.error(res.data.error_message, 0);
    }
    $state = $injector.get('$state');
    switch (res.status) {
      case 401:
        if ($state.current.name.length > 0 && $state.current.name.indexOf('users') !== 0) {
          Devise = $injector.get('Devise');
          Devise.signOut();
        }
        break;
      case 406:
        if ($state.current.name.indexOf('users') !== 0) {
          if ($location.path() !== $state.href('users.signIn', {})) {
            returnUrl.set($location.url());
          }
          $state.transitionTo('users.signIn');
        }
        break;
      case 404:
        $state.go('404', null, {
          location: false
        });
        break;
      case 422:
        _.each(res.data.errors, function(errors, key) {
          return _.each(errors, function(error) {
            return alertify.error("" + (translateErrorKeyName(res, key)) + error, 0);
          });
        });
        break;
      case 500:
        alertify.error("500 Error: " + res.data.error, 0);
        if ((ref1 = res.data) != null ? ref1.show_better_errors : void 0) {
          createBetterErrorsModal(res);
        }
    }
    return $q.reject(res);
  };
  return {
    response: success,
    responseError: error
  };
}]);


/***/ }),
/* 1254 */
/***/ (function(module, exports) {

angular.module('zc.core').factory("notificationInterceptor", ["$q", "$injector", function($q, $injector) {
  var NotificationChannel, error, request, success;
  NotificationChannel = void 0;
  success = function(res) {
    var $http;
    $http = $http || $injector.get("$http");
    if ($http.pendingRequests.length < 1) {
      NotificationChannel = NotificationChannel || $injector.get("NotificationChannel");
      NotificationChannel.requestEnded();
    }
    return res;
  };
  error = function(res) {
    var $http;
    $http = $http || $injector.get("$http");
    if ($http.pendingRequests.length < 1) {
      NotificationChannel = NotificationChannel || $injector.get("NotificationChannel");
      NotificationChannel.requestEnded();
    }
    return $q.reject(res);
  };
  request = function(config) {
    NotificationChannel = NotificationChannel || $injector.get("NotificationChannel");
    NotificationChannel.requestStarted();
    return config;
  };
  return {
    request: request,
    response: success,
    responseError: error
  };
}]);


/***/ }),
/* 1255 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('SessionRecoverer', ["$q", "$injector", "$location", "$timeout", "$window", "localStorageService", function($q, $injector, $location, $timeout, $window, localStorageService) {
  var PREFLIGHT_TIMEOUT_MINUTES, _environmentRequestDone, _lastRequestTime, _preflightInProgress, preflightRequest, success, updateRememberUserToken;
  PREFLIGHT_TIMEOUT_MINUTES = 30;
  _lastRequestTime = moment();
  _preflightInProgress = false;
  _environmentRequestDone = false;
  updateRememberUserToken = function() {
    var Devise;
    if (_preflightInProgress) {
      return _preflightInProgress;
    }
    Devise = $injector.get('Devise');
    return _preflightInProgress = Devise.getCurrentUser({
      force: true,
      isPreflight: true
    }).then(function(res) {
      _preflightInProgress = false;
      return res;
    })["catch"](function(err) {
      _preflightInProgress = false;
      return $q.reject(err);
    });
  };
  preflightRequest = function(config) {
    var Environment, preflightTimeoutMinutes;
    Environment = $injector.get('Environment');
    if (!_environmentRequestDone) {
      if (/\/api\/environment/.test(config.url)) {
        return config;
      } else if (/\/templates\/.*\.html$/.test(config.url) || /\/i18n\/locale-ja\.json/.test(config.url)) {
        return config;
      } else {
        return Environment.get().then(function() {
          _environmentRequestDone = true;
          return config;
        });
      }
    }
    if (config.isPreflight && /\/users\/show_current/.test(config.url)) {
      return config;
    }
    preflightTimeoutMinutes = localStorageService.get('_zc_preflight_timeout_minutes') || PREFLIGHT_TIMEOUT_MINUTES;
    if (_lastRequestTime.isAfter(moment().subtract(preflightTimeoutMinutes, 'minutes'))) {
      return config;
    }
    return updateRememberUserToken().then(function(res) {
      return config;
    });
  };
  success = function(response, req) {
    var $httpOnce, Devise, ref;
    Devise = $injector.get('Devise');
    $httpOnce = $injector.get('$httpOnce');
    _lastRequestTime = moment();
    if ((ref = response.data) != null ? ref.login_expired : void 0) {
      return Devise.getCurrentUser({
        force: true
      }).then(function(user) {
        var $state, config;
        config = _.assignIn({}, response.config);
        config.headers["X-LOGIN-TOKEN"] = user.login_token;
        config.cache = false;
        config.repeatCounter || (config.repeatCounter = 0);
        config.repeatCounter++;
        if (config.repeatCounter < 2) {
          return $httpOnce(config);
        } else {
          $state = $injector.get('$state');
          return $window.location = $state.href("users.signIn", {
            absolute: true
          });
        }
      })["catch"](function(err) {
        return $window.location.href = "/users/sign_in";
      });
    } else {
      return response;
    }
  };
  return {
    request: preflightRequest,
    response: success
  };
}]);


/***/ }),
/* 1256 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('BaseModalSelectorCtrl', function() {
  var BaseModalSelectorCtrl;
  return BaseModalSelectorCtrl = (function() {
    function BaseModalSelectorCtrl($scope, $modalInstance, items) {
      $scope.items = items;
      $scope.selected = {
        item: $scope.items[0]
      };
      $scope.ok = function() {
        return $modalInstance.close($scope.selected.item);
      };
      $scope.cancel = function() {
        return $modalInstance.dismiss('cancel');
      };
    }

    return BaseModalSelectorCtrl;

  })();
}).controller('ModalSelectorCtrl', ["$scope", "$modalInstance", "items", "BaseModalSelectorCtrl", function($scope, $modalInstance, items, BaseModalSelectorCtrl) {
  return new BaseModalSelectorCtrl($scope, $modalInstance, items);
}]);


/***/ }),
/* 1257 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('Api', ["$httpOnce", function($httpOnce) {
  var Api;
  Api = (function() {
    function Api() {}

    Api.basePath = (typeof ZC_CONFIG !== "undefined" && ZC_CONFIG !== null ? ZC_CONFIG.RAILS_API_URL : void 0) && (typeof ZC_CONFIG !== "undefined" && ZC_CONFIG !== null ? ZC_CONFIG.RAILS_API_PORT : void 0) ? ZC_CONFIG.RAILS_API_URL + ":" + ZC_CONFIG.RAILS_API_PORT : "";

    Api.setBasePath = function(path) {
      return this.basePath = path;
    };

    Api.path = function(endpoint) {
      return "" + this.basePath + endpoint;
    };

    Api.post = function(path, data, opts) {
      if (opts == null) {
        opts = {};
      }
      opts.method = 'POST';
      return this.request(path, data, opts);
    };

    Api.get = function(path, data, opts) {
      if (opts == null) {
        opts = {};
      }
      opts.method = 'GET';
      return this.request(path, data, opts);
    };

    Api.put = function(path, data, opts) {
      if (opts == null) {
        opts = {};
      }
      opts.method = 'PUT';
      return this.request(path, data, opts);
    };

    Api.patch = function(path, data, opts) {
      if (opts == null) {
        opts = {};
      }
      opts.method = 'PATCH';
      return this.request(path, data, opts);
    };

    Api["delete"] = function(path, data, opts) {
      if (opts == null) {
        opts = {};
      }
      opts.method = 'DELETE';
      return this.request(path, data, opts);
    };

    Api.request = function(path, data, opts) {
      var reqParams;
      if (opts == null) {
        opts = {};
      }
      reqParams = _.assignIn({}, {
        url: Api.path(path),
        data: data
      }, opts);
      return $httpOnce(reqParams);
    };

    return Api;

  })();
  return Api;
}]);


/***/ }),
/* 1258 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('Environment', ["$q", "Api", function($q, Api) {
  var Environment;
  return Environment = (function() {
    function Environment() {}

    Environment.environment = void 0;

    Environment.get = function() {
      if (this.environment) {
        return $q.when(this.environment);
      }
      return Api.get("/api/environment", {}).then((function(_this) {
        return function(res) {
          if (res.data.success) {
            return _this.environment = res.data.environment;
          } else {
            return $q.reject(res);
          }
        };
      })(this));
    };

    return Environment;

  })();
}]);


/***/ }),
/* 1259 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('Facade', ["$filter", "$httpOnce", "Devise", "Project", function($filter, $httpOnce, Devise, Project) {
  var service;
  service = {
    _forPath: function(endpoint) {
      return ZC_CONFIG.FACADE_API_URL + ":" + ZC_CONFIG.FACADE_API_PORT + "/api/v1" + endpoint;
    },
    request: function(path, opts) {
      if (opts == null) {
        opts = {};
      }
      return Devise.getCurrentUser().then(function() {
        var ref, ref1, reqParams;
        reqParams = _.assignIn({}, {
          method: 'GET',
          url: service._forPath(path),
          cache: true,
          withCredentials: false,
          headers: {
            'X-LOGIN-TOKEN': Devise != null ? (ref = Devise.currentUser) != null ? ref.login_token : void 0 : void 0
          }
        }, opts);
        if (reqParams != null ? (ref1 = reqParams.params) != null ? ref1.json : void 0 : void 0) {
          reqParams.params.json = service.transformDatesInRequest(reqParams.params.json);
        }
        return $httpOnce(reqParams);
      });
    },
    transformDatesInRequest: function(obj) {
      var isUnixTimestampIsh, json, key, region, value;
      json = _.assignIn({}, obj);
      for (key in obj) {
        value = obj[key];
        if (!key || !key.endsWith('_at')) {
          continue;
        }
        isUnixTimestampIsh = _.isNumber(value) && new Date(value).toString() !== 'Invalid Date';
        if (_.isDate(value) || isUnixTimestampIsh) {
          region = Project.getRegion();
          region || (region = 'Asia/Tokyo');
          json[key] = $filter('changeDatetimeFrom')('localToRegion', value, 'integer', region);
        }
      }
      return json;
    },
    setLoginToken: function(login_token) {
      return service.login_token = login_token;
    }
  };
  return service;
}]);


/***/ }),
/* 1260 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('FacadeV2', ["$filter", "$httpOnce", "$translate", "Devise", "Project", function($filter, $httpOnce, $translate, Devise, Project) {
  var FacadeV2;
  FacadeV2 = (function() {
    var login_token;

    function FacadeV2() {}

    login_token = void 0;

    FacadeV2.requestTransformer = function(data) {
      data.match = FacadeV2.encode({}, data.match);
      data.pipeline = FacadeV2.encode({}, data.pipeline);
      return {
        json: JSON.stringify(data)
      };
    };

    FacadeV2.responseTransformer = function(data) {
      var doc, i, len, ref, res, ret;
      res = angular.fromJson(data);
      if (!res || res.error || res.login_expired) {
        return res;
      } else if (_.isArray(res.data)) {
        try {
          ret = [];
          ref = res.data;
          for (i = 0, len = ref.length; i < len; i++) {
            doc = ref[i];
            ret.push(FacadeV2.decode({}, doc));
          }
          return ret;
        } catch (error) {
          alertify.error($translate.instant('sharedModules.core.services.facade_v2_service.badResponse'));
          return [];
        }
      } else {
        try {
          if (res.data) {
            return FacadeV2.decode({}, res.data);
          } else {
            return res.data;
          }
        } catch (error) {
          alertify.error($translate.instant('sharedModules.core.services.facade_v2_service.badResponse'));
          return {};
        }
      }
    };

    FacadeV2.setLoginToken = function(login_token) {
      return this.login_token = login_token;
    };

    FacadeV2._forPath = function(endpoint) {
      return ZC_CONFIG.FACADE_API_URL + ":" + ZC_CONFIG.FACADE_API_PORT + "/api/v2" + endpoint;
    };

    FacadeV2.request = function(path, opts) {
      if (opts == null) {
        opts = {};
      }
      return Devise.getCurrentUser().then(function() {
        var ref, reqParams;
        reqParams = _.assignIn({}, {
          method: 'GET',
          url: FacadeV2._forPath(path),
          transformResponse: FacadeV2.responseTransformer,
          cache: true,
          withCredentials: false,
          headers: {
            'X-LOGIN-TOKEN': Devise != null ? (ref = Devise.currentUser) != null ? ref.login_token : void 0 : void 0
          }
        }, opts);
        if (reqParams.params) {
          reqParams.params = FacadeV2.requestTransformer(reqParams.params);
        }
        return $httpOnce(reqParams);
      });
    };

    FacadeV2.decode = function(obj, json) {
      var f, region, v;
      for (f in json) {
        v = json[f];
        if (_.isNull(v)) {
          obj[f] = v;
        } else if (v['.T'] === 'D') {
          region = Project.getRegion();
          region || (region = 'Asia/Tokyo');
          obj[f] = $filter('changeDatetimeFrom')('regionToLocal', v['.V'], 'date', region);
        } else if (_.isString(v)) {
          obj[f] = v;
        } else if (_.isNumber(v)) {
          obj[f] = v;
        } else if (_.isBoolean(v)) {
          obj[f] = v;
        } else if (_.isArray(v)) {
          obj[f] = [];
          this.decode(obj[f], v);
        } else {
          obj[f] = {};
          this.decode(obj[f], v);
        }
      }
      return obj;
    };

    FacadeV2.dateObject = function(date) {
      var dateObject;
      dateObject = {};
      if (Project.getRegion()) {
        dateObject['.V'] = $filter('changeDatetimeFrom')('localToRegion', date, 'integer');
      } else {
        dateObject['.V'] = date.valueOf();
      }
      dateObject['.T'] = 'D';
      return dateObject;
    };

    FacadeV2.encode = function(json, obj) {
      var f, v;
      for (f in obj) {
        v = obj[f];
        if (_.isNull(v) || _.isUndefined(v)) {
          json[f] = null;
        } else if (_.isDate(v)) {
          json[f] = FacadeV2.dateObject(v);
        } else if (_.isString(v)) {
          json[f] = v;
        } else if (_.isNumber(v)) {
          json[f] = v;
        } else if (_.isBoolean(v)) {
          json[f] = v;
        } else if (_.isArray(v)) {
          json[f] = [];
          FacadeV2.encode(json[f], v);
        } else {
          json[f] = {};
          FacadeV2.encode(json[f], v);
        }
      }
      return json;
    };

    return FacadeV2;

  })();
  return FacadeV2;
}]);


/***/ }),
/* 1261 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('InterestWidget', ["$q", "$translate", "Api", "Campaign", function($q, $translate, Api, Campaign) {
  var InterestWidget;
  return InterestWidget = (function() {
    var AB_DELIVERY, COMPLETE_DELIVERY, DUMMY_ID;

    function InterestWidget() {}

    DUMMY_ID = -1;

    AB_DELIVERY = {
      id: 'ab_delivery',
      name: $translate.instant('sharedModules.core.services.interestWidget.abDelivery')
    };

    COMPLETE_DELIVERY = {
      id: 'complete_delivery',
      name: $translate.instant('sharedModules.core.services.interestWidget.completeDelivery')
    };

    InterestWidget.all = function(apikey) {
      if (!apikey) {
        $q.reject(null);
      }
      return Api.get("/api/projects/apikey:" + apikey + "/interest_widgets", {}, {
        cache: false
      }).then(function(res) {
        if (!res.data.success) {
          $q.reject(res);
          return;
        }
        return res.data.interest_widgets;
      });
    };

    InterestWidget.get = function(apikey, id) {
      if (!apikey) {
        $q.reject(null);
      }
      return Api.get("/api/projects/apikey:" + apikey + "/interest_widgets/" + id, {}, {
        cache: false
      }).then(function(res) {
        if (!res.data.success) {
          $q.reject(res);
          return;
        }
        return res.data.interest_widget;
      });
    };

    InterestWidget.create = function(apikey, interest_widget) {
      if (!apikey) {
        $q.reject(null);
      }
      return Api.post("/api/projects/apikey:" + apikey + "/interest_widgets/", {
        interest_widget: interest_widget
      }, {
        cache: false
      }).then(function(res) {
        if (!res.data.success) {
          $q.reject(res);
          return;
        }
        return res.data.interest_widget;
      });
    };

    InterestWidget.update = function(apikey, id, interest_widget) {
      if (!apikey) {
        $q.reject(null);
      }
      return Api.patch("/api/projects/apikey:" + apikey + "/interest_widgets/" + id, {
        interest_widget: interest_widget
      }, {
        cache: false
      }).then(function(res) {
        if (!res.data.success) {
          $q.reject(res);
          return;
        }
        return res.data.interest_widget;
      });
    };

    InterestWidget.remove = function(apikey, id, interest_widget) {
      if (!apikey) {
        $q.reject(null);
      }
      return Api["delete"]("/api/projects/apikey:" + apikey + "/interest_widgets/" + id, {
        cache: false
      }).then(function(res) {
        if (!res.data.success) {
          $q.reject(res);
          return;
        }
        return res.data.interest_widget;
      });
    };

    InterestWidget.updateCampaignWithInterestWidget = function(campaign) {
      return Campaign.isWidget(campaign).then(function(isWidget) {
        var ref, ref1;
        campaign.is_coupon_campaign = !isWidget;
        if (campaign.is_coupon_campaign) {
          campaign.available_delivery_type_options = [AB_DELIVERY];
        } else {
          campaign.available_delivery_type_options = [AB_DELIVERY, COMPLETE_DELIVERY];
          campaign.days_since_last_received = 0;
        }
        if (((ref = campaign.delivery_type_option) != null ? ref.id : void 0) === 'complete_delivery') {
          if (!campaign.interest_widget_id) {
            campaign.interest_widget_id = DUMMY_ID;
          }
        } else if (((ref1 = campaign.delivery_type_option) != null ? ref1.id : void 0) === 'ab_delivery') {
          if (campaign.interest_widget_id) {
            campaign.interest_widget_id = 0;
          }
        }
        if (campaign.interest_widget_id && !campaign.is_coupon_campaign) {
          return campaign.delivery_type_option = COMPLETE_DELIVERY;
        } else {
          campaign.delivery_type_option = AB_DELIVERY;
          return campaign.interest_widget_id = 0;
        }
      });
    };

    return InterestWidget;

  })();
}]);


/***/ }),
/* 1262 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('lib', ["$filter", "$location", "Project", function($filter, $location, Project) {
  return {
    getField: function(data, field) {
      var get;
      if (!field) {
        return data;
      }
      get = function(d, f) {
        var c, k;
        k = f.shift();
        c = d[k];
        if (!f.length) {
          return c;
        }
        return get(c, f);
      };
      return get(data, field.split('\.'));
    },
    stringToArray: function(string, separator) {
      var error;
      if (separator == null) {
        separator = ',';
      }
      if (_.isArray(string)) {
        return string;
      }
      if (_.isString(string) && string.length === 0) {
        return [];
      }
      try {
        return string.split(separator);
      } catch (error1) {
        error = error1;
        return [];
      }
    },
    setHighChartOptions: function() {
      return Highcharts.setOptions({
        global: {
          useUTC: true,
          getTimezoneOffset: function(timestamp) {
            var isMidnight, localDate, localUtcOffset, regionDate, regionUtcOffset;
            if (!timestamp) {
              return 0;
            }
            localDate = $filter('changeDatetimeFrom')('regionToLocal', timestamp, 'moment');
            regionDate = moment.tz(localDate.format(), Project.getRegion());
            localUtcOffset = -localDate.utcOffset();
            regionUtcOffset = regionDate.utcOffset();
            isMidnight = moment(timestamp).format('HH:mm') === '00:00';
            if (regionDate.isDST() && regionUtcOffset === 60 && !isMidnight) {
              localUtcOffset -= regionUtcOffset;
            }
            return localUtcOffset;
          }
        },
        lang: {
          months: moment.monthsShort()
        }
      });
    },
    copyName: function(oldName) {
      var match, newName, number;
      newName = "";
      match = oldName.match(/\s\((\d+)\)$/);
      if (match) {
        number = parseInt(match[1]);
        newName = oldName.replace(match[0], " (" + (number + 1) + ")");
      } else {
        newName = oldName + " (2)";
      }
      return newName;
    },
    truncateFraction: function(number) {
      if (number > 0) {
        return Math.floor(number);
      } else {
        return Math.ceil(number);
      }
    },
    removeFromLocationSearch: function(itemName) {
      var oldSearch;
      oldSearch = $location.search();
      delete oldSearch[itemName];
      return $location.search(oldSearch);
    },
    iterateCountMaps: function(countMaps, baseMap, accumulatedCountMaps) {
      var countMap, j, key, keyMap, len, val;
      keyMap = {};
      for (j = 0, len = countMaps.length; j < len; j++) {
        countMap = countMaps[j];
        for (key in countMap) {
          val = countMap[key];
          if (_.isNumber(val)) {
            baseMap[key] || (baseMap[key] = 0);
            baseMap[key] += val;
          } else if (_.isDate(val) || _.isString(val) || _.isBoolean(val)) {
            baseMap[key] = val;
          } else if (_.isArray(val)) {
            throw 'Array is not supported!';
          } else if (_.isObject(val)) {
            baseMap[key] || (baseMap[key] = {});
            keyMap[key] = true;
          }
        }
        if (accumulatedCountMaps) {
          accumulatedCountMaps.push(_.cloneDeep(baseMap));
        }
      }
      return keyMap;
    },
    sumCountMap: function(countMaps, baseMap) {
      var j, key, keyMap, len, ref, vals;
      if (baseMap == null) {
        baseMap = {};
      }
      keyMap = this.iterateCountMaps(countMaps, baseMap);
      ref = Object.keys(keyMap);
      for (j = 0, len = ref.length; j < len; j++) {
        key = ref[j];
        vals = _.map(countMaps, key);
        this.sumCountMap(vals, baseMap[key]);
      }
      return baseMap;
    },
    accumulateCountMap: function(countMaps, baseMap) {
      var accumulatedCountMaps, j, key, keyMap, len, ref, vals;
      if (baseMap == null) {
        baseMap = {};
      }
      accumulatedCountMaps = [];
      keyMap = this.iterateCountMaps(countMaps, baseMap, accumulatedCountMaps);
      ref = Object.keys(keyMap);
      for (j = 0, len = ref.length; j < len; j++) {
        key = ref[j];
        vals = _.map(countMaps, key);
        vals = this.accumulateCountMap(vals, baseMap[key]);
        accumulatedCountMaps.forEach(function(map, i) {
          return map[key] = vals[i];
        });
      }
      return accumulatedCountMaps;
    },
    sumOriginalConversions: function(stats) {
      var flattenedConversions;
      flattenedConversions = _.flatten(stats.original_conversions);
      return _.reduce(flattenedConversions, function(sumHourlyOriginalConversions, conversion) {
        var conversionPriceDecimal, originalConversion;
        conversionPriceDecimal = new Decimal(conversion.price_decimal.$numberDecimal.toString());
        originalConversion = _.find(sumHourlyOriginalConversions, {
          currency: conversion.currency
        });
        if (originalConversion) {
          originalConversion.price += conversion.price;
          originalConversion.price_decimal = originalConversion.price_decimal.plus(conversionPriceDecimal);
        } else {
          sumHourlyOriginalConversions.push({
            price: conversion.price,
            price_decimal: conversionPriceDecimal,
            currency: conversion.currency
          });
        }
        return sumHourlyOriginalConversions;
      }, []);
    }
  };
}]);


/***/ }),
/* 1263 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('NotificationChannel', ["$rootScope", function($rootScope) {
  var service;
  service = {
    requestStarted: function() {
      return $rootScope.$broadcast('$stateChangeStart');
    },
    requestEnded: function() {
      return $rootScope.$broadcast('$stateChangeSuccess');
    },
    onRequestStarted: function($scope, handler) {
      return $scope.$on('$stateChangeStart', function(event) {
        return handler();
      });
    },
    onRequestEnded: function($scope, handler) {
      return $scope.$on('$stateChangeSuccess', function(event) {
        return handler();
      });
    }
  };
  return service;
}]);


/***/ }),
/* 1264 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('PageLayout', function() {
  return {
    showFooter: false
  };
});


/***/ }),
/* 1265 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('Page', ["Environment", function(Environment) {
  var bodyClass, env, page, title;
  title = 'AiDeal';
  bodyClass = '';
  env = '';
  Environment.get().then(function(res) {
    return env = res;
  });
  page = {
    title: function() {
      if (env === 'production') {
        return title;
      } else {
        return "[" + env + "] " + title;
      }
    },
    setTitle: function(newTitle) {
      if (newTitle) {
        return title = newTitle + " - AiDeal";
      } else {
        return title = 'AiDeal';
      }
    },
    bodyClass: function() {
      return bodyClass;
    },
    setBodyClass: function(newBodyClass) {
      return bodyClass = newBodyClass;
    }
  };
  return page;
}]);


/***/ }),
/* 1266 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('returnUrl', function() {
  var ReturnUrl;
  return ReturnUrl = (function() {
    function ReturnUrl() {}

    ReturnUrl._url = null;

    ReturnUrl.set = function(url) {
      return this._url = url;
    };

    ReturnUrl.get = function() {
      return this._url;
    };

    return ReturnUrl;

  })();
});


/***/ }),
/* 1267 */
/***/ (function(module, exports) {

angular.module('zc.core').factory('SearchFilter', ["$rootScope", "$location", "Meta", "lib", function($rootScope, $location, Meta, lib) {
  var SearchFilter;
  SearchFilter = (function() {
    function SearchFilter() {}

    SearchFilter._normalDefaults = {
      search_term: '',
      start_at: moment().startOf('month').valueOf(),
      end_at: moment().endOf('day').valueOf()
    };

    SearchFilter.pageDefaults = {};

    SearchFilter.componentDefaults = {};

    SearchFilter._filters = {
      search_term: '',
      start_at: moment().startOf('month').valueOf(),
      end_at: moment().endOf('day').valueOf()
    };

    SearchFilter.get = function() {
      return SearchFilter._filters;
    };

    SearchFilter.getDateFilterValue = function(propertyName, pageDefaults) {
      var momentDate, search;
      if (!_.includes(['start_at', 'end_at'], propertyName)) {
        throw new Error('Invalid property name given!');
      }
      search = $location.search();
      if (search[propertyName]) {
        momentDate = moment(search[propertyName]);
        if (propertyName === 'start_at') {
          return momentDate.startOf('day').valueOf();
        }
        return momentDate.endOf('day').valueOf();
      }
      return _.get(pageDefaults, propertyName, SearchFilter._filters[propertyName]);
    };

    SearchFilter.getDefaultReportFilters = function(reportId) {
      var reportDate;
      reportDate = moment(parseInt(reportId));
      return {
        start_at: reportDate.startOf('month').valueOf(),
        end_at: reportDate.endOf('month').valueOf(),
        device: null,
        device_value: null,
        campaign_segment: null,
        campaign_segment_value: null
      };
    };

    SearchFilter.set = function(searchFilters) {
      searchFilters.start_at || (searchFilters.start_at = SearchFilter._normalDefaults.start_at);
      searchFilters.start_at = moment(searchFilters.start_at).startOf('day').valueOf();
      searchFilters.end_at || (searchFilters.end_at = SearchFilter._normalDefaults.end_at);
      searchFilters.end_at = moment(searchFilters.end_at).endOf('day').valueOf();
      SearchFilter._filters = searchFilters;
      return SearchFilter.updateLocationSearch();
    };

    SearchFilter.reset = function(baseObject) {
      return SearchFilter._filters = _.merge(baseObject, SearchFilter.pageDefaults);
    };

    SearchFilter.setComponentDefaults = function(componentName, params) {
      if (SearchFilter.componentDefaults[componentName]) {
        return;
      }
      SearchFilter.componentDefaults[componentName] = {};
      return _.each(params, function(v, k) {
        if (SearchFilter.componentDefaults[componentName][k]) {
          console.warn("Trying to register SearchFilter value twice for " + k + " in " + componentName);
          return;
        }
        SearchFilter.componentDefaults[componentName][k] = v;
        if (v.getter != null) {
          SearchFilter._filters[k] = $location.search()[k] || v["default"];
          SearchFilter._filters[k + '_value'] = v.getter($location.search()[k]) || v.getter(v["default"]);
        } else {
          SearchFilter._filters[k] = $location.search()[k] || v["default"];
        }
      });
    };

    SearchFilter.removeComponentDefaults = function(componentName) {
      _.each(SearchFilter.componentDefaults[componentName], function(v, k) {
        return delete SearchFilter.componentDefaults[componentName][k];
      });
      return delete SearchFilter.componentDefaults[componentName];
    };

    SearchFilter.resetComponentDefaults = function(componentName) {
      return _.each(SearchFilter.componentDefaults[componentName], function(v, k) {
        SearchFilter._filters[k] = v["default"];
        if (v.getter != null) {
          SearchFilter._filters[k + '_value'] = v.getter(v["default"]);
        }
        return lib.removeFromLocationSearch(k);
      });
    };

    SearchFilter.updateComponentDefaults = function(componentName) {
      return _.each(SearchFilter.componentDefaults[componentName], function(v, k) {
        if ((v.getter != null) && SearchFilter._filters[k + '_value']) {
          SearchFilter._filters[k] = SearchFilter._filters[k + '_value'][v.keyProperty];
        }
        if (SearchFilter._filters[k] === v["default"]) {
          return lib.removeFromLocationSearch(k);
        } else {
          return $location.search(k, SearchFilter._filters[k]);
        }
      });
    };

    SearchFilter.updateLocationSearch = function() {
      if (moment(SearchFilter._filters.start_at).isSame(SearchFilter.pageDefaults.start_at)) {
        lib.removeFromLocationSearch('start_at');
      } else {
        $location.search('start_at', moment(SearchFilter._filters.start_at).format('YYYY-MM-DD'));
      }
      if (moment(SearchFilter._filters.end_at).endOf('day').isSame(SearchFilter.pageDefaults.end_at)) {
        lib.removeFromLocationSearch('end_at');
      } else {
        $location.search('end_at', moment(SearchFilter._filters.end_at).startOf('day').format('YYYY-MM-DD'));
      }
      if (SearchFilter._filters.search_term === SearchFilter.pageDefaults.search_term) {
        return lib.removeFromLocationSearch('search_term');
      } else {
        return $location.search('search_term', SearchFilter._filters.search_term);
      }
    };

    SearchFilter.resolveFromLocation = function(pageDefaults) {
      var search;
      if (pageDefaults == null) {
        pageDefaults = {};
      }
      SearchFilter.pageDefaults = _.merge({}, SearchFilter._normalDefaults, pageDefaults);
      search = $location.search();
      return SearchFilter._filters = _.merge(SearchFilter._filters, SearchFilter.pageDefaults, {
        search_term: search.search_term ? search.search_term : void 0,
        start_at: moment(SearchFilter.getDateFilterValue('start_at', pageDefaults)).valueOf(),
        end_at: moment(SearchFilter.getDateFilterValue('end_at', pageDefaults)).valueOf()
      });
    };

    return SearchFilter;

  })();
  return SearchFilter;
}]);


/***/ }),
/* 1268 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('zcDataProcessingAddendum', function() {
  return {
    restrict: 'E',
    templateUrl: '/templates/core/views/data_processing_addendum.html'
  };
});


/***/ }),
/* 1269 */
/***/ (function(module, exports) {

angular.module('zc.core').controller('PrivacyPolicyCtrl', ["$rootScope", "$scope", "$translate", "Page", function($rootScope, $scope, $translate, Page) {
  var deregistrationCallback;
  Page.setBodyClass('');
  $translate('usersPages.views.privacyPolicy.title').then(function(translation) {
    return Page.setTitle(translation);
  });
  deregistrationCallback = $rootScope.$on('languageSelected', function(_, language) {
    if (language.id) {
      return $scope.currentLang = language.id;
    } else {
      return $scope.currentLang = language;
    }
  });
  $rootScope.$on('$destroy', deregistrationCallback);
  return $rootScope.$emit('selectDefaultLanguage');
}]);


/***/ }),
/* 1270 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('zcTermsOfServiceAppierInc', function() {
  return {
    restrict: 'E',
    templateUrl: '/templates/core/views/terms_of_service_appier_inc.html'
  };
});


/***/ }),
/* 1271 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('zcTermsOfServiceAppierJp', function() {
  return {
    restrict: 'E',
    templateUrl: '/templates/core/views/terms_of_service_appier_jp.html'
  };
});


/***/ }),
/* 1272 */
/***/ (function(module, exports) {

angular.module('zc.core').directive('zcTermsOfServiceAppierOthers', function() {
  return {
    restrict: 'E',
    templateUrl: '/templates/core/views/terms_of_service_appier_others.html'
  };
});


/***/ }),
/* 1273 */,
/* 1274 */,
/* 1275 */
/***/ (function(module, exports) {

var path = '/templates/core/components/api_public_file_downloader/api_public_file_downloader.html';
var html = "<a target=_self href=\"{{ vm.href }}\" download=\"{{ vm.href }}\"><i class=\"fa fa-download\"></i> {{ vm.text }}</a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1276 */
/***/ (function(module, exports) {

var path = '/templates/core/components/billing_representatives/billing_representatives.html';
var html = "<div class=billing-representatives><input type=button class=\"btn btn-sm btn-primary add-representative-btn\" ng-disabled=vm.isRepresentativeLimitReached() ng-click=vm.addNewRepresentative() value=\"+ {{ 'sharedModules.core.components.billingRepresentatives.tantousha_tsuika' | translate }}\"><div ng-if=vm.isRepresentativeLimitReached() class=\"alert alert-hint config-lead\">{{ 'sharedModules.core.components.billingRepresentatives.jougen_ni_tasshita' | translate }}</div><table class=col-xs-12><thead><tr><th>{{ 'sharedModules.core.components.billingRepresentatives.shimei_furuneemu' | translate }}</th><th>{{ 'sharedModules.core.components.billingRepresentatives.meeruadoresu' | translate }}</th><th></th></tr></thead><tbody ng-repeat=\"(representativeIndex, representative) in vm.representatives track by representativeIndex\"><tr><td><input class=form-control ng-model=representative.full_name required></td><td><input type=email class=form-control ng-model=representative.email required></td><td style=\"text-align: center;\"><span class=delete-representative ng-click=vm.removeRepresentative(representativeIndex) ng-disabled=vm.isRepresentativesObjectCompletelyEmpty()>{{ 'sharedModules.core.components.billingRepresentatives.sakujo' | translate }}</span></td></tr></tbody></table></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1277 */
/***/ (function(module, exports) {

var path = '/templates/core/components/increase_or_decrease_percentage/increase_or_decrease_percentage.html';
var html = "<span class=increase-or-decrease ng-if=$ctrl.showValue ng-class=\"{ 'positive': $ctrl.percentage >= 0, 'negative': $ctrl.percentage < 0 }\">{{ $ctrl.showValue }}</span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1278 */
/***/ (function(module, exports) {

var path = '/templates/core/components/month_chooser/month_chooser.html';
var html = "<a class=\"btn btn-sm btn-default\" ng-click=$ctrl.goToPrev() ng-disabled=!$ctrl.prevMonth>{{ 'sharedModules.core.components.monthChooser.sengetsu' | translate }}</a> <a class=\"btn btn-sm btn-default\" ng-click=$ctrl.goToNext() ng-disabled=!$ctrl.nextMonth>{{ 'sharedModules.core.components.monthChooser.yokugetsu' | translate }}</a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1279 */
/***/ (function(module, exports) {

var path = '/templates/core/components/session_prediction_distribution/session_prediction_distribution.html';
var html = "<div class=row><div class=col-md-11><h4 class=element_title ng-if=\"$ctrl.threshold === 'predictions_max_threshold'\"><span ng-if=\"$ctrl.campaign.predictions_max_threshold === 0\">{{ 'sharedModules.core.components.sessionPredictionDistribution.yosoku_no_saidaichi' | translate }}</span> <span translate=sharedModules.core.components.sessionPredictionDistribution.yosoku_no_saidaichi_ga translate-value-threshold=\"{{ $ctrl.campaign.predictions_max_threshold | number }}\" ng-if=\"$ctrl.campaign.predictions_max_threshold !== 0\"></span> <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'sharedModules.core.components.sessionPredictionDistribution.saito_houmon_kara' | translate }}\"></i></h4><h4 class=element_title ng-if=\"$ctrl.threshold === 'predictions_min_threshold'\"><span ng-if=\"$ctrl.campaign.predictions_min_threshold === 100\">{{ 'sharedModules.core.components.sessionPredictionDistribution.yosoku_ga_saitei' | translate }}</span> <span translate=sharedModules.core.components.sessionPredictionDistribution.yosoku_no_saidaichi_yori translate-value-threshold=\"{{ $ctrl.campaign.predictions_min_threshold | number }}\" ng-if=\"$ctrl.campaign.predictions_min_threshold !== 100\"></span> <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'sharedModules.core.components.sessionPredictionDistribution.saito_houmon_tokikara' | translate }}\"></i></h4></div><div class=col-md-1><button type=button class=\"btn btn-default btn-xs pull-right\" style=\"margin-right: 10px;\" tooltip=\"{{ 'sharedModules.core.components.sessionPredictionDistribution.kakudai' | translate }}\" ng-click=$ctrl.resizeFull()><i class=\"glyphicon glyphicon-resize-full\"></i></button></div></div><highchart config=$ctrl.chartConfig style=\"height: 150px;\"></highchart><rzslider rz-slider-model=$ctrl.campaign[$ctrl.threshold] rz-slider-options=$ctrl.sliderConfig></rzslider><div id={{$ctrl.modalId}} class=\"modal fade\"><div class=modal-dialog><div class=modal-content><div class=\"modal-header row\"><div class=col-md-11><h4 class=\"modal-title element_title\" ng-if=\"$ctrl.threshold === 'predictions_max_threshold'\"><span ng-if=\"$ctrl.campaign.predictions_max_threshold === 0\">{{ 'sharedModules.core.components.sessionPredictionDistribution.yosoku_no_saidaichi' | translate }}</span> <span translate=sharedModules.core.components.sessionPredictionDistribution.yosoku_no_saidaichi_ga translate-value-threshold=\"{{ $ctrl.campaign.predictions_max_threshold | number }}\" ng-if=\"$ctrl.campaign.predictions_max_threshold !== 0\"></span></h4><h4 class=\"modal-title element_title\" ng-if=\"$ctrl.threshold === 'predictions_min_threshold'\"><span ng-if=\"$ctrl.campaign.predictions_min_threshold === 100\">{{ 'sharedModules.core.components.sessionPredictionDistribution.yosoku_ga_saitei' | translate }}</span> <span translate=sharedModules.core.components.sessionPredictionDistribution.yosoku_no_saidaichi_yori translate-value-threshold=\"{{ $ctrl.campaign.predictions_min_threshold | number }}\" ng-if=\"$ctrl.campaign.predictions_min_threshold !== 100\"></span></h4></div><div class=col-md-1><button type=button class=\"btn btn-default btn-xs pull-right\" style=\"margin-right: 10px;\" tooltip=\"{{ 'sharedModules.core.components.sessionPredictionDistribution.motonimodosu' | translate }}\" ng-click=$ctrl.resizeSmall()><i class=\"glyphicon glyphicon-resize-small\"></i></button></div></div><div class=modal-body><highchart config=$ctrl.chartConfig style=\"height: 450px;\"></highchart><rzslider rz-slider-model=$ctrl.campaign[$ctrl.threshold] rz-slider-options=$ctrl.sliderConfig></rzslider></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1280 */
/***/ (function(module, exports) {

var path = '/templates/core/components/session_price_distribution/session_price_distribution.html';
var html = "<div class=row><div class=col-md-11><h4 class=element_title><span ng-if=\"$ctrl.campaign.price_max_threshold === $ctrl.campaign.price_min_threshold\">{{ 'sharedModules.core.components.sessionPriceDistribution.etsuran_shouhin' | translate }}</span> <span ng-if=\"$ctrl.campaign.price_max_threshold !== $ctrl.campaign.price_min_threshold\"><span ng-if=\"$ctrl.campaign.price_max_threshold !== 0\" translate=sharedModules.core.components.sessionPriceDistribution.withPriceMaxAndMinConditions translate-value-pricemaxthreshold=\"{{ $ctrl.campaign.price_max_threshold | zcCurrency: $ctrl.currency.symbol:0:$ctrl.currency.suffix }}\" translate-value-priceminthreshold=\"{{ $ctrl.campaign.price_min_threshold | zcCurrency: $ctrl.currency.symbol:0:$ctrl.currency.suffix }}\"></span> <span ng-if=\"$ctrl.campaign.price_max_threshold === 0\" translate=sharedModules.core.components.sessionPriceDistribution.withPriceMinConditionOnly translate-value-priceminthreshold=\"{{ $ctrl.campaign.price_min_threshold | zcCurrency: $ctrl.currency.symbol:0:$ctrl.currency.suffix }}\"></span></span> <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'sharedModules.core.components.sessionPriceDistribution.shiyou_kingaku_seigen' | translate }}\"></i></h4></div><div class=col-md-1><button type=button class=\"btn btn-default btn-xs pull-right\" style=\"margin-right: 10px;\" tooltip=\"{{ 'sharedModules.core.components.sessionPriceDistribution.kakudai' | translate }}\" ng-click=$ctrl.resizeFull()><i class=\"glyphicon glyphicon-resize-full\"></i></button></div></div><highchart config=$ctrl.chartConfig style=\"height: 150px;\"></highchart><rzslider rz-slider-model=$ctrl.campaign.price_max_threshold rz-slider-high=$ctrl.campaign.price_min_threshold rz-slider-options=$ctrl.sliderConfig></rzslider><div id={{$ctrl.modalId}} class=\"modal fade\"><div class=modal-dialog><div class=modal-content><div class=\"modal-header row\"><div class=col-md-11><h4 class=\"modal-title element_title\"><span ng-if=\"$ctrl.campaign.price_max_threshold === $ctrl.campaign.price_min_threshold\">{{ 'sharedModules.core.components.sessionPriceDistribution.etsuran_shouhin' | translate }}</span> <span ng-if=\"$ctrl.campaign.price_max_threshold !== $ctrl.campaign.price_min_threshold\"><span ng-if=\"$ctrl.campaign.price_max_threshold !== 0\" translate=sharedModules.core.components.sessionPriceDistribution.withPriceMaxAndMinConditions translate-value-pricemaxthreshold=\"{{ $ctrl.campaign.price_max_threshold | number | zcCurrency: $ctrl.currency.symbol:0:$ctrl.currency.suffix }}\" translate-value-priceminthreshold=\"{{ $ctrl.campaign.price_min_threshold | number | zcCurrency: $ctrl.currency.symbol:0:$ctrl.currency.suffix }}\"></span> <span ng-if=\"$ctrl.campaign.price_max_threshold === 0\" translate=sharedModules.core.components.sessionPriceDistribution.withPriceMinConditionOnly translate-value-priceminthreshold=\"{{ $ctrl.campaign.price_min_threshold | number | zcCurrency: $ctrl.currency.symbol:0:$ctrl.currency.suffix }}\"></span></span></h4></div><div class=col-md-1><button type=button class=\"btn btn-default btn-xs pull-right\" style=\"margin-right: 10px;\" tooltip=\"{{ 'sharedModules.core.components.sessionPriceDistribution.motonimodosu' | translate }}\" ng-click=$ctrl.resizeSmall()><i class=\"glyphicon glyphicon-resize-small\"></i></button></div></div><div class=modal-body><highchart config=$ctrl.chartConfig style=\"height: 450px;\"></highchart><rzslider rz-slider-model=$ctrl.campaign.price_max_threshold rz-slider-high=$ctrl.campaign.price_min_threshold rz-slider-options=$ctrl.sliderConfig></rzslider></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

var path = '/templates/core/components/session_uplift_modeling_classification/session_uplift_modeling_classification.html';
var html = "<div><div class=\"panel panel-default\"><div class=panel-heading><h5 class=panel-title>{{ 'sharedModules.core.components.sessionUpliftModelingClassification.houmon_kabaa' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'sharedModules.core.components.sessionUpliftModelingClassification.houmon_kabaa_ritsu' | translate }}\"></i></h5></div><div class=panel-body><div><table class=\"table table-bordered text-center\"><tr><td class=col-md-6><p>{{ 'sharedModules.core.components.sessionUpliftModelingClassification.amanojaku_jogai' | translate }}</p><p><span class=text-blue style=\"font-size: 20px;\">{{ $ctrl.negativeImpactSessionCount / $ctrl.totalSessionCount * 100 || 0 | number : 1 }}</span> <span class=unit>%</span></p><div class=text-muted>({{ $ctrl.negativeImpactSessionCount | number }} {{ 'sharedModules.core.components.sessionUpliftModelingClassification.houmon' | translate }})</div></td><td class=col-md-6><p>{{ 'sharedModules.core.components.sessionUpliftModelingClassification.mukanshin_jogai' | translate }}</p><p><span class=text-blue style=\"font-size: 20px;\">{{ $ctrl.noConversionAnywaySessionCount / $ctrl.totalSessionCount * 100 || 0 | number : 1 }}</span> <span class=unit>%</span></p><div class=text-muted>({{ $ctrl.noConversionAnywaySessionCount | number }} {{ 'sharedModules.core.components.sessionUpliftModelingClassification.houmon' | translate }})</div></td></tr><tr><td class=col-md-6><p>{{ 'sharedModules.core.components.sessionUpliftModelingClassification.teppan_jogai' | translate }}</p><p><span class=text-blue style=\"font-size: 20px;\">{{ $ctrl.conversionAnywaySessionCount / $ctrl.totalSessionCount * 100 || 0 | number : 1 }}</span> <span class=unit>%</span></p><div class=text-muted>({{ $ctrl.conversionAnywaySessionCount | number }} {{ 'sharedModules.core.components.sessionUpliftModelingClassification.houmon' | translate }})</div></td><td class=col-md-6 style=\"background: #f5f5f5;\"><p>{{ 'sharedModules.core.components.sessionUpliftModelingClassification.haishin_taagetto' | translate }}</p><p><span class=text-blue style=\"font-size: 20px;\">{{ $ctrl.positiveImpactSessionCount / $ctrl.totalSessionCount * 100 || 0 | number : 1 }}</span> <span class=unit>%</span></p><div class=text-muted>({{ $ctrl.positiveImpactSessionCount | number }} {{ 'sharedModules.core.components.sessionUpliftModelingClassification.houmon' | translate }})</div></td></tr></table><div translate=sharedModules.core.components.sessionUpliftModelingClassification.zentai_houmon translate-value-sessions=\"{{ $ctrl.totalSessionCount | number }}\" class=\"all_session_number text-muted\"></div></div></div></div></div><div><div class=\"panel panel-default\"><div class=panel-heading><h5 class=panel-title>{{ 'sharedModules.core.components.sessionUpliftModelingClassification.konbaajonkabaa_ritsu' | translate }} <i class=\"glyphicon glyphicon-question-sign\" tooltip=\"{{ 'sharedModules.core.components.sessionUpliftModelingClassification.konbaajonkabaa_ritsu_taishou' | translate }}\"></i></h5></div><div class=panel-body><div><table class=\"table table-bordered text-center\"><tr><td class=col-md-6><p>{{ 'sharedModules.core.components.sessionUpliftModelingClassification.amanojaku_jogai' | translate }}</p><p><span class=text-blue style=\"font-size: 20px;\">{{ $ctrl.negativeImpactConversionCount / $ctrl.totalConversionCount * 100 || 0 | number : 1 }}</span> <span class=unit>%</span></p><div class=text-muted>({{ $ctrl.negativeImpactConversionCount | number }} CV)</div></td><td class=col-md-6><p>{{ 'sharedModules.core.components.sessionUpliftModelingClassification.mukanshin_jogai' | translate }}</p><p><span class=text-blue style=\"font-size: 20px;\">{{ $ctrl.noConversionAnywayConversionCount / $ctrl.totalConversionCount * 100 || 0 | number : 1 }}</span> <span class=unit>%</span></p><div class=text-muted>({{ $ctrl.noConversionAnywayConversionCount | number }} CV)</div></td></tr><tr><td class=col-md-6><p>{{ 'sharedModules.core.components.sessionUpliftModelingClassification.teppan_jogai' | translate }}</p><p><span class=text-blue style=\"font-size: 20px;\">{{ $ctrl.conversionAnywayConversionCount / $ctrl.totalConversionCount * 100 || 0 | number : 1 }}</span> <span class=unit>%</span></p><div class=text-muted>({{ $ctrl.conversionAnywayConversionCount | number }} CV)</div></td><td class=col-md-6 style=\"background: #f5f5f5;\"><p>{{ 'sharedModules.core.components.sessionUpliftModelingClassification.haishin_taagetto' | translate }}</p><p><span class=text-blue style=\"font-size: 20px;\">{{ $ctrl.positiveImpactConversionCount / $ctrl.totalConversionCount * 100 || 0 | number : 1 }}</span> <span class=unit>%</span></p><div class=text-muted>({{ $ctrl.positiveImpactConversionCount | number }} CV)</div></td></tr></table><div translate=sharedModules.core.components.sessionUpliftModelingClassification.all_session_number translate-value-conversions=\"{{ $ctrl.totalConversionCount | number }}\" class=\"all_session_number text-muted\"></div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

var path = '/templates/core/components/sync_contract_info_button/sync_contract_info_button.html';
var html = "<p style=\"padding-top: 0; padding-bottom: 0.5em; font-size: 0.9em;\" translate=sharedModules.core.components.syncContractInfoButton.to_onaji_baai translate-value-target=\"{{ vm.syncTargetName }}\"></p><input type=button id=sync-contract-info-btn class=\"btn btn-sm btn-primary\" value=\"{{ 'sharedModules.core.components.syncContractInfoButton.douki_suru' | translate }}\" style=\"font-size: 0.8em;\" ng-click=vm.syncContractInfoWithBillingInfo()>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

var path = '/templates/core/components/tos_notification/tos_notification.html';
var html = "<div ng-if=!vm.isTosSigned class=\"alert alert-warning\" role=alert><div ng-class=\"{ 'text-center': vm.serviceName === 'AiDeal' || vm.user.lang === 'en', 'text-left': vm.serviceName !== 'AiDeal' && vm.user.lang === 'ja', }\" style=\"font-size: 1.4em;\"><span class=\"fa fa-warning\"></span> <strong><span ng-if=\"vm.serviceName === 'AiDeal'\" translate=sharedModules.core.components.tosNotification.tosHasBeenUpdatedSince translate-value-terms-of-service=\"<a href='{{ vm.tosUrl }}' style='color: white; text-decoration: underline;' >{{ 'sharedModules.core.components.tosNotification.termsOfService' | translate: { service: vm.serviceName } }}</a>\" translate-value-date=\"{{ vm.updatedAt }}\"></span> <span ng-if=\"vm.serviceName !== 'AiDeal'\" translate=sharedModules.core.components.liteTosNotification.tosHasBeenUpdatedSince translate-value-terms-of-service=\"<a href='{{ vm.tosUrl }}' style='color: white; text-decoration: underline;' >{{ 'sharedModules.core.components.liteTosNotification.termsOfService' | translate: { service: vm.serviceName } }}</a>\" translate-value-date=\"{{ vm.updatedAt }}\"></span> <button class=btn style=\"margin-left: 10px; background: #ec9924; border: 1px solid;\" ng-click=vm.signAgreements()>OK</button></strong></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

var path = '/templates/core/views/404.html';
var html = "<div id=error-page><div class=error-number>404</div><div class=error-message>{{ 'sharedModules.core.views.404.pageNotFound' | translate }}</div><a ui-sref=admin.home>{{ 'sharedModules.core.views.404.backToHome' | translate }}</a></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1285 */
/***/ (function(module, exports) {

var path = '/templates/core/views/500.html';
var html = "<div id=error-page><div class=error-number>500</div><div class=error-message>{{ 'sharedModules.core.views.500.errorOccurred' | translate }}</div><a ui-sref=admin.home>{{ 'sharedModules.core.views.500.backToHome' | translate }}</a></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1286 */
/***/ (function(module, exports) {

var path = '/templates/core/views/admin.html';
var html = "<div class=all-filter loading><div id=loader></div></div><div id=wrapper><header class=\"navbar navbar-inverse\" role=banner><div ui-view=header></div></header><div ui-view=mainnav></div><div ui-view=content></div></div><zc-footer></zc-footer>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1287 */
/***/ (function(module, exports) {

var path = '/templates/core/views/admin_header.html';
var html = "<div class=container ng-class=\"{notificationPadding: environment!='production' && notification}\"><div class=\"navbar-notification navbar-fixed-top {{environment}}\" ng-if=\"environment!='production' && notification\"><ng-container ng-if=\"environment === 'preprod'\">⚠️ {{ 'sharedModules.core.views.admin_header.preprodEnvironment'| translate }} ⚠️</ng-container><ng-container ng-if=\"environment !== 'preprod'\" translate=sharedModules.core.views.admin_header.currentEnvironment translate-value-environment={{environment}}></ng-container><span class=navbar-notification-remove ng-click=switchNotification()><i class=\"fa fa-times-circle\"></i></span></div><div class=navbar-header><button class=navbar-toggle type=button data-toggle=collapse data-target=.navbar-collapse><span class=sr-only>{{ 'sharedModules.core.views.admin_header.toggleNavigation' | translate }}</span> <i class=\"fa fa-cog\"></i></button> <a ui-sref=admin.home class=\"navbar-brand navbar-brand-img\"><img src=/assets/logo.png alt=AiDeal></a></div><nav class=\"collapse navbar-collapse\" role=navigation><ul class=\"nav navbar-nav navbar-zc navbar-right\"><project-apikey-menu></project-apikey-menu><projects-menu></projects-menu><projects-menu-search></projects-menu-search><master-menu></master-menu><user-menu></user-menu></ul></nav></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1288 */
/***/ (function(module, exports) {

var path = '/templates/core/views/admin_header_logout_only.html';
var html = "<div class=container ng-class=\"{notificationPadding: environment!='production' && notification}\"><div class=\"navbar-notification navbar-fixed-top {{environment}}\" ng-if=\"environment!='production' && notification\" translate=sharedModules.core.views.admin_header.currentEnvironment translate-value-environment={{environment}}><span class=navbar-notification-remove ng-click=switchNotification()><i class=\"fa fa-times-circle\"></i></span></div><div class=navbar-header><button class=navbar-toggle type=button data-toggle=collapse data-target=.navbar-collapse><span class=sr-only>{{ 'sharedModules.core.views.admin_header.toggleNavigation' | translate }}</span> <i class=\"fa fa-cog\"></i></button> <a ui-sref=admin.home class=\"navbar-brand navbar-brand-img\"><img src=/assets/logo.png alt=AiDeal></a></div><nav class=\"collapse navbar-collapse\" role=navigation><ul class=\"nav navbar-nav navbar-zc navbar-right\"><master-menu></master-menu><user-menu logout-only=true></user-menu></ul></nav></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

var path = '/templates/core/views/data_processing_addendum.html';
var html = "<h1 class=text-center>Data Processing Addendum</h1><ol><li><p>To the extend that, under this Services Agreement, personal data is transferred outside of the European Economic Area or any European Commission approved country, the User hereby agree to and hereby enter in the Controller to Processor Standard Contractual Clauses (Commission Implementing Decision (EU) 2021/914) (“C2P SCCs”) with Appier, the terms of which are hereby incorporated into this Services Agreement. For the purposes of the C2P SCCs, the User is the data exporter and Appier is the data importer, and the governing law of the C2P SCCs is the law where the data exporter is established.</p></li><li><p>In addition to the foregoing, to the extend applicable, both Appier and User hereby agree the data protection scope as follows:</p><ol><li><p>Both parties shall comply with applicable data protection law which apply to it in respect of the performance of its obligations under this Services Agreement. The parties agree that (a) Appier is a data processor, and (b) Purchaser is a data controller. For the purpose of this Data Processing Addendum (“DPA”), (i) data controller refers to an entity that determines the purposes and means of the processing of personal data and (ii) data processor refers to an entity which processes personal data on behalf of the controller.</p></li><li><p>The User shall be responsible for obtaining the consent and providing privacy or transparency notices to each end user, on their website, in compliance with, and where required by, applicable data protection law. For the purpose of this DPA, end user shall include but not limited to Viewers.</p></li><li><p>The parties shall cooperate reasonably with each other in the fulfilment of their respective obligations in respect of data subject requests for third party notification, erasure or other requests under applicable data protection law.</p></li><li><p>Taking into account the nature of and risks associated with the type of personal data collected or used in connection with the Services (if any), each party shall use commercially reasonable effort to have in place appropriate technical and organizational measures to ensure a level of security appropriate to the risks that are presented by each party’s processing of personal data.</p></li><li><p>Appier ensures that all persons authorized by it to process the personal data are committed to confidentiality or are under a statutory obligation of confidentiality under applicable law.</p></li><li><p>To a commercially reasonable extend, Appier will make available to the User information which is reasonably necessary to demonstrate the compliance with the obligations set out in this Article 2.</p></li><li><p>Appier acknowledges that the User is under certain obligations under the applicable data protection law, such as recordkeeping, and agrees to make commercially reasonable efforts to provide the Purchaser with reasonable assistance and information required by the User to satisfy such obligations.</p></li><li><p>To the extent Appier becomes aware and determines that an incident shall be deemed as a personal data breach leading to the accidental or unlawful destruction, loss, alteration, unauthorized disclosure of, or access to, personal data transmitted, stored or otherwise processed by Appier, Appier will (a) notify the User of such incident without undue delay, (b) conduct investigation to a reasonable extend to comply with this Agreement and (c) provide necessary information and/or assistance for User to investigate and/or understand the incident.</p></li><li><p>The User grants a general authorization (a) to Appier to appoint any of its affiliates (Appier and any of its affiliates hereinafter collectively referred to as “<strong>Appier Group</strong>”) as sub-processors, and (b) to Appier Group to appoint third parties (including but not limited to outsourcing business, engineering and customer support providers) as sub-processors to support and/or improve the performance of the Services.</p></li><li><p>To the extend applicable, terms used under this Article 2 shall share the meaning within C2P SCCs.</p></li></ol></li></ol><p>Appendix to C2P SCCs</p><p>EXPLANATORY NOTE:</p><p>It must be possible to clearly distinguish the information applicable to each transfer or category of transfers and, in this regard, to determine the respective role(s) of the Parties as data exporter(s) and/or data importer(s). This does not necessarily require completing and signing separate appendices for each transfer/category of transfers and/or contractual relationship, where this transparency can achieved through one appendix. However, where necessary to ensure sufficient clarity, separate appendices should be used.</p><p>ANNEX I to C2P SCC</p><p>A. &nbsp; LIST OF PARTIES</p><span><strong>On behalf of the data exporter:</strong></span><table style=\"width: 100%; table-layout: fixed\"><tbody><tr><td colspan=1 rowspan=1><span>Name of the data exporting organization:</span></td><td colspan=2 rowspan=1><span>&nbsp; &nbsp; &nbsp;</span></td></tr><tr><td colspan=1 rowspan=1><span>Address:</span></td><td colspan=2 rowspan=1><span>&nbsp; &nbsp; &nbsp;</span></td></tr><tr><td colspan=1 rowspan=1><span>Tel: &nbsp; &nbsp; &nbsp;</span></td><td colspan=1 rowspan=1><span>Fax: &nbsp; &nbsp; &nbsp;</span></td><td colspan=1 rowspan=1><span>Email: &nbsp; &nbsp; &nbsp;</span></td></tr><tr><td colspan=3 rowspan=1><p>Other information needed to identify the organization:</p></td></tr><tr><td colspan=1 rowspan=1></td><td colspan=1 rowspan=1><span style=\"padding-left: 55%\">Signature:</span></td><td colspan=1 rowspan=1><span>&nbsp; &nbsp; &nbsp;</span></td></tr><tr><td colspan=1 rowspan=1></td><td colspan=1 rowspan=1><span style=\"padding-left: 55%\">Print Name:</span></td><td colspan=1 rowspan=1><span>&nbsp; &nbsp; &nbsp;</span></td></tr><tr><td colspan=1 rowspan=1></td><td colspan=1 rowspan=1><span style=\"padding-left: 55%\">Title:</span></td><td colspan=1 rowspan=1><span>&nbsp; &nbsp; &nbsp;</span></td></tr><tr><td colspan=1 rowspan=1></td><td colspan=1 rowspan=1><span style=\"padding-left: 55%\">Date:</span></td><td colspan=1 rowspan=1><span>&nbsp; &nbsp; &nbsp;</span></td></tr></tbody></table><p>&nbsp;</p><span><strong>On behalf of the data importer:</strong></span><table style=\"width: 100%; table-layout: fixed\"><tbody><tr><td colspan=1 rowspan=1><span>Name of the data importing organization:</span></td><td colspan=2 rowspan=1><span style=\"text-decoration: underline\">Appier Pte. Ltd.</span></td></tr><tr><td colspan=1 rowspan=1><span>Address:</span></td><td colspan=2 rowspan=1><span style=\"text-decoration: underline\">Wilkie Road, #03-01, Wilkie Edge, Singapore (228095)</span></td></tr><tr><td colspan=1 rowspan=1><span>Tel:</span> <span style=\"text-decoration: underline\">+886-2-87802800</span></td><td colspan=1 rowspan=1><span>Fax:</span> <span style=\"text-decoration: underline\">+886 2 87808809</span></td><td colspan=1 rowspan=1><span>Email:</span> <span style=\"text-decoration: underline\">legal.eu@appier.com</span></td></tr><tr><td colspan=3 rowspan=1><p>Other information needed to identify the organization:</p></td></tr><tr><td colspan=1 rowspan=1></td><td colspan=1 rowspan=1 style=\"vertical-align: top\"><span style=\"padding-left: 55%\">Signature:</span></td><td colspan=1 rowspan=1><img src=" + __webpack_require__(963) + " width=84></td></tr><tr><td colspan=1 rowspan=1></td><td colspan=1 rowspan=1><span style=\"padding-left: 55%\">Print Name:</span></td><td colspan=1 rowspan=1><span style=\"text-decoration: underline\">Chih-Han Yu</span></td></tr><tr><td colspan=1 rowspan=1></td><td colspan=1 rowspan=1><span style=\"padding-left: 55%\">Title:</span></td><td colspan=1 rowspan=1><span style=\"text-decoration: underline\">CEO</span></td></tr><tr><td colspan=1 rowspan=1></td><td colspan=1 rowspan=1><span style=\"padding-left: 55%\">Date:</span></td><td colspan=1 rowspan=1><span>&nbsp; &nbsp; &nbsp;</span></td></tr></tbody></table><p>&nbsp;</p><p>B. &nbsp; DESCRIPTION OF TRANSFER</p><p><span style=\"font-style: italic\"><strong>Categories of data subjects whose personal data is transferred</strong></span></p><p>Please refer to Appier&rsquo;s privacy policy</p><ul><li><strong>&nbsp;</strong></li></ul><p><span style=\"font-style: italic\"><strong>Sensitive data transferred (if applicable) and applied restrictions or safeguards that fully take into consideration the nature of the data and the risks involved, such as for instance strict purpose limitation, access restrictions (including access only for staff having followed specialized training), keeping a record of access to the data, restrictions for onward transfers or additional security measures.</strong></span></p><p>The personal data that may be transferred would not normally concern any special categories of data, but data exporter is in control in this regard.</p><p>The restrictions and safeguards specified in Annex II apply to these categories of Customer Personal Data (if any).</p><p><span style=\"font-style: italic\"><strong>The frequency of the transfer (e.g. whether the data is transferred on a one-off or continuous basis).</strong></span></p><p>Customer Personal Data may be transferred on a continuous basis until it is deleted in accordance with the Terms of Service (as applicable).</p><p><span style=\"font-style: italic\"><strong>Nature of the processing</strong></span></p><p>The data importer will process Customer Personal Data to provide, secure and monitor the Services in accordance with the Agreement.</p><p><span style=\"font-style: italic\"><strong>Purpose(s) of the data transfer and further processing</strong></span></p><p>The data importer will transfer Customer Personal Data to provide, secure and monitor the Services in accordance with the Agreement.</p><p><span style=\"font-style: italic\"><strong>The period for which the personal data will be retained, or, if that is not possible, the criteria used to determine that period</strong></span></p><p>For the duration of the Agreement until deletion in accordance with the provisions of the Terms of Service (as applicable).</p><p><span style=\"font-style: italic\"><strong>For transfers to (sub-) processors, also specify subject matter, nature and duration of the processing</strong></span></p><p>As above.</p><p>C. &nbsp; COMPETENT SUPERVISORY AUTHORITY</p><p>ANNEX II to C2P SCC</p><p>&nbsp;</p><p>TECHNICAL AND ORGANISATIONAL MEASURES INCLUDING TECHNICAL AND ORGANISATIONAL MEASURES TO ENSURE THE SECURITY OF THE DATA</p><p>&nbsp;</p><h2><strong>1. Service providers</strong></h2><h3><strong>Infrastructure</strong></h3><p>Appier uses the Appier Cloud Platform (GCP) and Amazon Web Services (AWS) as its infrastructure providers.</p><p>Both GCP and AWS meet the most stringent data protection and security requirements.</p><p>Please refer to the following links for the security and privacy of our cloud service providers:</p><p><span style=\"font-style: italic\">GCP: <a href=\"https://www.google.com/url?q=https://cloud.google.com/security/compliance&amp;sa=D&amp;source=editors&amp;ust=1643278314580350&amp;usg=AOvVaw3fonrTyjHfd3oZsgK5sQRi\">https://cloud.Appier.com/security/compliance</a></span></p><p><span style=\"font-style: italic\">AWS: <a href=\"https://www.google.com/url?q=https://aws.amazon.com/tw/compliance/&amp;sa=D&amp;source=editors&amp;ust=1643278314580729&amp;usg=AOvVaw1LzFPErXt315RJQHIxYS24\">https://aws.amazon.com/tw/compliance/</a></span></p><p>&nbsp;</p><h2><span><strong>2. Data protection and encryption</strong></span></h2><h3><span><strong>Data handling after retention</strong></span></h3><p>Deletion of personal data is performed by the following principles:</p><ul><li>After the deletion is completed, the personal data files should not exist.</li><li>It is no longer possible to recover or backup personal data.</li><li>Certain employee is responsible for the deletion of the data.</li><li>The records of deletion are kept.</li></ul><h3><span><strong>Encryption</strong></span></h3><p>Appier complies ISO 27001 to implement compatible encryption for the transmission and the storage of personal data.</p><p>&nbsp;</p><h2><span><strong>3. Confidentiality and integrity</strong></span></h2><h3><span><strong>Equipment access control</strong></span></h3><p>Measures designed to deny unauthorized persons access to equipment used for processing personal data.</p><ul><li>Appier takes the following measures to ensure that unauthorized persons do not gain access to data processing systems in which data is processed:</li><li>Doors accessing Secure Area shall be equipped with access control mechanism, such as access cards or locks, to prevent unauthorized entry.</li><li>Access card to Secure Area can only be used as the application of its usage been submitted and approved. Access card shall be used in the manner that is consistent with the intended information processing activities.</li></ul><p>Clearly defined security concepts are in place for data processing and storage at AWS and GCP.</p><p>Except for the access options provided to administrators as agreed with the client, access to the data centers in which the client&#39;s data are stored is impossible for employees.</p><p>Access to the data centers is strictly controlled by the cloud service provider. The implemented measures include but not limited to:</p><ul><li>Video surveillance</li><li>Movement sensors, intruder alarm system and security for the premises</li><li>Division into safety zones / restricted areas</li><li>Identity check by the gatekeeper or security service</li><li>Full documentation and regular verification of any access granted</li></ul><p>&nbsp;</p><h3><span><strong>User access control</strong></span></h3><p>Appier follows strict policy to protect user access control including the follows:</p><ul><li>System Administrators shall be separated into different roles based on their characteristics, such as development, testing, release, maintenance and equipment management.</li><li>User accounts and passwords shall refrain from being shared among personnel.</li><li>The accounts and the corresponding permissions shall be adjusted, disabled or deleted when the personnel that uses them is no longer working in the same job capacity.</li><li>Accounts irrelevant to system operation or maintenance shall be deleted when the project or job is completed.</li><li>Access control through devices other than account (i.e. IC card, USB key) shall be treated to be the same as the account for its protection.</li><li>Account with the system&rsquo;s highest permission (i.e. administration account) shall be used as authorized while appropriate audit trails are retained.</li></ul><p>&nbsp;</p><h3><span><strong>Transfer control</strong></span></h3><p>Appier has designed measures to ensure that personal data cannot be read, copied, altered, or deleted without authorization during electronic transmission, transport or storage on data carriers. These measures include:</p><ul><li>Sign agreements with third parties before the third parties provide services to Appier, and ensure that the data duties of third parties are disclosed in the agreement.</li><li>When Appier shares data with the third parties, the contract between Appier and the third parties should include the data protection duties, data processing purposes and restrictions.</li><li>When transferring personal data due to business needs, encryption or other data security mechanisms should be implemented during the transfer.</li><li>Data sharing or transfer should comply with Appier&#39;s security policy.</li></ul><p>&nbsp;</p><h3><span><strong>Input control</strong></span></h3><p>Measures designed to ensure that it is subsequently possible to verify and establish whether and by whom personal data have been entered into, modified, or removed from data processing systems.</p><p>The client&rsquo;s transmitted data are recorded by the platform in an audit-proof manner. Any sub-sequent modification or deletion of the client&#39;s data is also recorded by the platform. The measures include the follows:</p><ul><li>When any application accessed by a user involves the collection, processing, and utilization of personal data, its additions, changes, deletions, and inquiries, regardless of the success or failure of the system&#39;s processing results, should record the user&#39;s access behavior.</li><li>The application system log storage location should be set up with an access authority control mechanism and read-only access for user accounts to prevent the log from being tampered with.</li></ul><p>&nbsp;</p><h3><span><strong>Processing control</strong></span></h3><p>Measures designed to ensure that personal data processed can only be processed in compliance with Appier&rsquo;s fundamental principles for personal data processing. These measures include:</p><ul><li>Personal data processing should be legal, fair and transparent.</li><li>The purpose of personal data collection must be specific, explicit and legal.</li><li>The collection and processing of personal data must comply with the principle of data minimization.</li><li>The accuracy of personal data should be ensured.</li><li>The retention time of personal data should not be longer than the time necessary for processing purposes.</li><li>Personal data should be processed in a safe manner to prevent unauthorized or illegal processing, maintaining the integrity and confidentiality of personal data.</li></ul><p>&nbsp;</p><h3><span><strong>Separability</strong></span></h3><p>Measures designed to ensure that personal data collected for different purposes can be processed separately (storage, modification, deletion, transmission). Among others, the following measures are implemented:</p><ul><li>Data will be imported into the system and displayed according to their intended use.</li><li>Separation of data by client / customer</li><li>Separation of functions / production environment / test environment</li><li>Creation of an authorization concept</li></ul><p>&nbsp;</p><h2><span><strong>4. Availability and recovery</strong></span></h2><p>Measures designed to ensure that personal data are available and protected against accidental loss and destruction and that systems may, in the case of malfunctions, be restored.</p><ul><li>Storage of data backup at a secure, external location</li><li>Regular checks on the functionality of the backup &amp; recovery concept</li></ul><p>In addition to the measures taken by Appier, the cloud service provider also take actions to serve the best of availability.</p><h2><span><strong>5. Data protection by default / Data protection by design</strong></span></h2><p>With regard to privacy by default and privacy by design, Appier has established the privacy by design policy to ensure data protection.</p><p>During the application, system, and product evaluation phase, the developer should incorporate the &quot;Privacy by Design Sheet&quot; question into the design to ensure that relevant requirements can be met.</p><p>During the application, system, and product testing phase, developers should test and complete the &quot;Privacy by Design Sheet&quot;, and provide the form to the Appier&rsquo;s Data Protection Office after the test is completed. If there is any inapplicability in the process of filling in, the reason for inapplicability should be written.</p><p>During the application, system, and product development, developers should ensure that application development is performed in accordance with the requirements of &quot;Privacy by Design Sheet&quot;.</p><p>&nbsp;</p><h2><span><strong>6. Regular verification procedures</strong></span></h2><h3><span><strong>Data protection office</strong></span></h3><p>Appier has created a corporate data protection office whose main tasks include the development, implementation, and monitoring of a data protection management system and the regular monitoring of processing activities and data protection measures.</p><h3><span><strong>Risk analysis</strong></span></h3><p>A risk analysis is regularly carried out by the information security team in to assess the current threat level and determine measures to be taken.</p><p>&nbsp;</p>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1290 */
/***/ (function(module, exports) {

var path = '/templates/core/views/directives/footer.html';
var html = "<footer class=\"footer zc-footer\"><div class=container><p class=pull-left ng-cloak>{{ thisYear }} Appier Japan, Inc. All rights reserved</p><div class=pull-right><a ui-sref=privacy_policy>{{ 'usersPages.views.directives.footerLinks.privacyPolicy' | translate }}</a> | <a ui-sref=terms_of_service>{{ 'usersPages.views.directives.footerLinks.zcTermsOfUse' | translate }}</a></div></div></footer>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1291 */
/***/ (function(module, exports) {

var path = '/templates/core/views/directives/zc_date_time_picker.html';
var html = "<div class=dropdown dropdown><a class=dropdown-toggle id={{pickerId}} role=button data-toggle=dropdown dropdown-toggle href=#><div class=input-group><span class=input-group-addon><i class=\"glyphicon glyphicon-calendar\"></i></span> <input type=text class=form-control value=\"{{ data | date: ('sharedModules.dateTimeFormats.datetime' | translate) }}\"></div></a><ul class=dropdown-menu role=menu aria-labelledby=dLabel><datetimepicker data-ng-model=data data-datetimepicker-config=\"{ dropdownSelector: '#'+pickerId, minView: minView }\"></datetimepicker></ul></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1292 */
/***/ (function(module, exports) {

var path = '/templates/core/views/emptynav.html';
var html = "<div class=mainnav></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1293 */
/***/ (function(module, exports) {

var path = '/templates/core/views/mainnav.html';
var html = "<div class=mainnav><div ng-if=false class=\"navbar-notification status-waiting text-dark\"><ng-container ng-if=\"currentUser.lang === 'ja'\">現在、バナーは正常に配信されておりますが、データ集計に問題が発生しており、一部ダッシュボード上の数値が正しくない可能性があります。</ng-container><ng-container ng-if=\"currentUser.lang !== 'ja'\">We are having data aggregation issue at the moment, numbers on the dashboard might not be correct, please come back later</ng-container></div><zc-tos-notification tos-url=/admin/tos updated-at=2020/11/15 service-name=AiDeal></zc-tos-notification><div class=container><a class=mainnav-toggle data-toggle=collapse data-target=.mainnav-collapse><span class=sr-only>{{ 'sharedModules.core.views.mainnav.toggleNavigation' | translate }}</span> <i class=\"fa fa-bars\"></i></a><nav class=\"collapse mainnav-collapse\" role=navigation><ul class=mainnav-menu><li ui-sref-active=active zc-master-only><a ui-sref=admin.projects.dashboard({projectId:projectId})><i class=\"fa fa-lock\"></i> {{ 'sharedModules.core.views.mainnav.dashboard' | translate }}</a></li><li ui-sref-active=active><a ui-sref=admin.projects.campaigns.list({projectId:projectId})>{{ 'sharedModules.core.views.mainnav.campaigns' | translate }}</a></li><li ui-sref-active=active ng-if=isMaster><a ui-sref=admin.projects.segments({projectId:projectId})><i class=\"fa fa-lock\"></i> {{ 'sharedModules.core.views.mainnav.segments' | translate }}</a></li><li ui-sref-active=active><a ui-sref=admin.projects.incentives({projectId:projectId})>{{ 'sharedModules.core.views.mainnav.incentives' | translate }}</a></li><li ui-sref-active=active ng-if=\"isMaster || project.allow_app_access\"><a ng-href=\"{{ aiReportURL }}\" target=_blank><i class=\"fa fa-lock\"></i> {{ 'sharedModules.core.views.mainnav.aiReport' | translate }}</a></li><li ui-sref-active=active ng-if=\"isMaster || project.shows_site_report\"><a ui-sref=\"admin.projects.site_report.summary({projectId:projectId, month:thisMonth})\"><i class=\"fa fa-lock\" ng-if=!project.shows_site_report></i> {{ 'sharedModules.core.views.mainnav.newReport' | translate }}</a></li><li ui-sref-active=active ng-if=\"project.sales_entity_fullname === 'Appier Japan (JP)'\"><a ui-sref=admin.projects.reports({projectId:projectId})>{{ 'sharedModules.core.views.mainnav.report' | translate }}</a></li><li ui-sref-active=active ng-if=\"project.iw_contracted_at || project.iw_trial_started_at\"><a ui-sref=admin.projects.iw.report({projectId:projectId})>{{ 'sharedModules.core.views.mainnav.interestWidget' | translate }}</a></li><li ui-sref-active=active ng-if=\"isMaster || project.shows_site_data || isInternalUser\"><a ui-sref=admin.projects.analytics({projectId:projectId})><i class=\"fa fa-lock\" ng-if=!project.shows_site_data></i> {{ 'sharedModules.core.views.mainnav.siteData' | translate }}</a></li><li ui-sref-active=active ng-show=\"projectId === 1109\"><a ui-sref=admin.projects.heatmap({projectId:projectId})>{{ 'sharedModules.core.views.mainnav.heatmap' | translate }}(β)</a></li><li ui-sref-active=active><a ui-sref=admin.projects.settings.basic({projectId:projectId})><i class=\"fa fa-cog\"></i> {{ 'sharedModules.core.views.mainnav.settings' | translate }}</a></li></ul></nav><div ng-if=isDisplayAajsWarningMsg class=\"alert alert-warning\" role=alert zc-master-only>{{ 'sharedModules.core.views.mainnav.notification.aajsSettingsWarningMsg' | translate }}</div></div></div><zc-project-notification></zc-project-notification>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

var path = '/templates/core/views/privacy_policy.html';
var html = "<div class=document-wrapper><div class=row><div class=\"col-md-push-2 col-md-8\"><div ng-switch=currentLang class=\"document-wrapper privacy-policy\"><ng-container ng-switch-when=ja><h1 class=text-center>プライバシーポリシー</h1><ol><li>概要</li></ol><p>このプライバシー声明（以下「プライバシーポリシー」という）において情報の収集および利用方法を説明し、Appier Inc.、その子会社および関連会社（以下「Appier」、または「当社」という）はお客様のプライバシーを尊重し、お客様の個人情報を保護するほか、お客様の個人情報の収集、使用、共有を透明化することに取り込みます。このプライバシーポリシーは、Appierのオンラインサービス、ウェブサイト（<a href=\"https://www.google.com/url?q=https://www.appier.com//&amp;sa=D&amp;ust=1536048166950000\">www.appier.com</a>）またはこのプライバシーポリシーへのリンクあるいは関連するすべてのウェブサイト（以下併せて「ウェブサイト」という）に適用し、並びに当社がどのように個人情報を処理するか（詳細は後述）、およびお客様の個人情報の収集、使用、保存、および更新、訂正等に関してお客様によるご利用の選択肢を説明します。</p><ol><li>Appierのサービス</li></ol><p>Appierは、Cross X アドソリューション、アイコア（マーケティングオートメーションプラットフォーム）、アイソン（データサイエンスプラットフォーム）等企業の経営課題の解決を支援する人工知能（AI）搭載のプラットフォームを提供します。</p><ol><li>当社で収集した個人情報</li></ol><ul class=second-section><li>ウェブサイトを通じて</li></ul><p>当社は、当社のウェブサイトで又はウェブサイトの利用過程においてお客様が提供した個人情報をはじめとするデータを収集します。「個人情報」には、、直接的または間接的に、自然人として識別できる情報、特に当社が利用できる他の情報、例えば、個人番号（マイナンバー）、オンライン識別子、またはお客様を自然人として識別できる一つまたは複数の要素を結合した情報を含みますが、これらに限りません。</p><p>それ故、ウェブサイトで作成したフォームを使用する場合、当社も、次の情報を収集する可能性があります。</p><ul><li>連絡先情報、例えば氏名、住所、電話番号、メールアドレス等</li><li>人口統計情報、例えば国、会社、役職等</li><li>コメント</li></ul><p>Appierは、当社が有す個人情報が正確かつ最新であることの確保を目的としています。ご提供いただいた個人情報が正確且つ最新であることをご確認下さい。</p><p>もし、お客様はAppierに要請されても、特定の個人データが提供しなかった場合、当社はお客様と締結した契約（例えば製品またはサービスの提供）を履行できない可能性があるか、または当社が負うべき法的義務を遵守できないことがあります。</p><p>さらに、ウェブサイトでウェブサイト上の情報をブラウズ、閲覧、またはダウンロードするとき、お客様のウェブブラウザーは自動的に次の情報を当社に送信します（当社はこれを保有することができる）。</p><ul><li>インターネットにアクセスしているインターネットドメイン</li><li>使用しているコンピュータのプロトコルアドレス</li><li>使用しているブラウザソフトウェアおよびオペレーティングシステムの種類</li><li>ウェブサイトにアクセスした日付および時刻</li><li>ウェブサイトに直接リンクしたサイトのインターネットアドレス</li></ul><p>当社は、当社のクッキーポリシーに従い、ウェブサイトの維持に役立てるために、これらの情報を集計データとして利用します。例えば、ウェブサイト上のさまざまなセクションへの訪問者数の確定、ウェブサイトの正常な運営の確認およびウェブサイトへの簡単なアクセスまたは使用に役立てます。<br>また、当社も信頼できる第三者から個人情報の収集を行ない、且つ個人情報収集のために雇用した第三者の協力を受けます。</p><ul class=second-section><li>当社の各サービスを通じて</li></ul><p>また、当社のサービスを当社の取引先（以下「顧客」という）に提供するために、当社は、顧客が自らまたは協力会社に依頼し顧客のウェブサイトに当社のクッキーを設置することを通じて、個人情報を追加収集する可能性があります。<br>お客様の個人情報は、そのような広告目的のクッキーを受け入れた場合にのみ収集されます。</p><ul class=third-section><li>インターネット上で収集する個人情報：</li></ul><ul><li>Appier のクッキー識別子</li><li>IPアドレス</li><li>IPジオロケーション</li><li>訪問されたさまざまなサイトのページURL</li><li>さまざまなページでブラウシングした時刻</li><li>ネットでブラウスしたブラウザーのタイプとバージョン</li><li>同じ目標で収集されたパートナーのテクノロジープラットフォームのクッキー識別子</li><li>広告ID</li><li>広告ウェブページのURL</li><li>イベントID―例えば、エンドユーザーによる広告の「クリック」、インプレッションの「ビュー」</li></ul><ul class=third-section><li>モバイルアプリケーションを通じて収集する個人情報</li></ul><p>Appierは、モバイルアプリケーションを使用して個人情報を収集するために、さ信頼できるパートナーに依頼して次の個人情報を収集します。</p><ul><li>IPアドレス</li><li>広告主の携帯電話識別子（IOSデバイスのIDFAとAndroidのGAID）</li><li>GPSジオロケーションデータ</li><li>携帯電話の品番およびそのオペレーティングシステム（IOS、Android等）</li><li>ビューされた顧客ウェブサイトのページURL</li><li>時刻</li><li>広告ID</li><li>アプリケーション名</li></ul><ol><li>当社によるお客様の個人情報利用</li></ol><p>当社は次の目的でのみ、お客様の個人情報の収集、利用および保存をします。当社の業務経営、引き渡し処理、当社ウェブサイトおよび当社が提供する各種製品とサービスのカスタマイズおよび改善、当社業務に関わるマーケティングおよびその他通信、お客様の要求に基づき、お客様に情報、製品およびサービスの提供、並びに適用する法律で認められたその他合法的用途に用います。</p><p>具体的な状況により、前述合法的用途の基準において、当社は関連処理する前に基準事実発生時点で、お客様に告知します。</p><p>Appierによる各目的に基づく個人情報の収集は、次のものを含みます。</p><ul><li>お客様が当社に要求した情報の提供</li><li>お客様の問い合わせへの回答</li><li>マーケティングまたは顧客調査を含む目的とするお客様へのメッセージ発信：Appierから直接発送（具体状況による）またはお客様の同意を得た当社の第三者からの発信</li><li>お客様と契約を締結してお客様が購読済みまたは購読予定の各種サービスの提供</li><li>アカウント作成</li><li>詐欺、政策または条項違反ならび脅威あるいは損害の抑止および対応</li><li>特にチャットロボットを通じた、お客様へのサービスとサポートの提供</li><li>お客様の一般の地理的位置に対応したウェブサイトの運営改善および／またはウェブコンテンツ調整協力並びに通報の用途</li><li>ジョブアプリケーションの管理</li></ul><p>当社は、当社の顧客への各種サービスに個人情報を提供する場合があります。特に、次の場合です。</p><ul><li>もっともお客様のニーズおよび好みを満たす広告、マーケティングおよび販売優遇をお客様へ提供する</li><li>広告主およびパブリッシャー（メディア運営者）の現有および潜在顧客に対しロイヤリティの構築および商業開拓キャンペーンを目的とするターゲティングに協力する</li><li>企業による非侵襲性広告発信への協力</li><li>広告の発信頻度（マーケティングプレッシャ）の最適化</li><li>異なる産業の広告主（自動車産業、不動産業、販売店等）の研究開発に協力し、消費者ニーズおよび市場の更なる理解に協力するとともに、顧客ロイヤリティと商業宣伝を目標とした各種イベントのパフォーマンスを分析する</li><li>異なる端末のそれぞれの識別子を調整し、確率的な方法でプロファイルに近づける</li></ul><p>適用する法律規定または法律許可範囲において、且つ、(i)Appierにかかる法律義務(ii)当社と当事者と何らかの協議に基づく条件の執行目的に基づくもの、または(iii)Appier、Appierの顧客または他人の権利、財産または安全等の保護の目的に基づき、当社が誠実に合理的で、しかも必要性を認めた場合、お客様の個人情報を使用し、または特定範囲の第三者に開示する場合があります。</p><ol><li>当社によるお客様の個人情報の共有</li></ol><p>所在地が欧州連合（「EU」）または欧州経済領域（「EEA」）に所在するかを問わず、当社の業務経営、引き渡し処理、当社ウェブサイトの改善およびカスタマイズ、ならびに当社が提供する各種製品とサービスの改善、当社業務に関わるマーケティングおよびその他通信発信の目的かつ、お客様の同意を得た後、当社は当社と関連事業体およびその他第三者事業パートナー、プロバイダー、ベンダーまたは当社を代表して、当社の指示を執行する請負業者とお客様の個人情報を共有することがあります。</p><p>従って、当社は個人情報を次の方法で共有します。</p><ul><li>個人情報処理または保存の目的、かつ、前述した各項の用途に関連し、Appier内部および当社の所在地がEU/EEAの国内または海外にあるすべての関連実体内部での共有</li><li>当社製品およびサービス提供または取引実現を目的としたAppier事業パートナー、ベンダー、授権された第三者代理人または請負業者との共有例えば、オーダーを処理し、各ウェブサイトのタスク処理センターとしてのサポートの提供（これを含むがこれ等に限らない）</li><li>合併プロジェクト、会社資産売却、併合、組織改造、融資プロジェクトまたは他社による当社の全部もしくは一部業務の買収等の関連または交渉期間中</li><li>具体的状況により、お客様のプライバシーのより厳密な保護を図り、Appierはサマリー形式でお客様の個人情報を共有し、これらの情報は直接または間接的にお客様のアイデンティティ識別に用いる</li></ul><p>適用する法律、法規または法的手続きによって授権または認可された場合、当社はEU/EEA国内または海外の法執行官、政府主務機関またはその他第三者にお客様の個人情報を開示します。但し、このような開示は法律の正当な手続きに合致し、かつ、Appierに対して拘束力あり、しかも法的手続きの遵守または国家安全需要の必要範囲を超えない限度において、Appier、Appierの事業パートナー、お客様または他人の各権利、財産および安全も保護されることを前提とします。</p><ol><li>第三者のウェブサイトへのリンク</li></ol><p>ウェブサイトには、当社が管理していない会社が運営する第三者のウェブサイトへのリンクが含まれている場合があります。これらの第三者のウェブサイト上でのお客様の活動は、これらの第三者のプライバシーポリシーおよび手続きのみによって管理されます。このような第三者のコンテンツまたは情報実務について、Appierは一切の責任を負いません。また、これらのWebサイトで情報を開示する前に、これらの第三者のプライバシーポリシーをレビューすることをお勧めします。</p><ol><li>当社の情報保存期限および情報処分方法</li></ol><p>第4条の規定に従い収集したお客様の個人情報について、当社の保存期間は収集のための存続期間とし、且つ当社の業務、法的義務、争議解決、当社の資産保護およびAppierの当事者の各項協議ニーズの執行に限り、当該期間満了後は、お客様の個人情報を削除します。</p><p>いずれにしても、当社のサービスを1年間使用しない場合、当社はお客様の個人情報を削除します。</p><ol><li>個人情報のセキュリティと機密性</li></ol><p>お客様の個人情報の安全性と機密性は当社にとって非常に重要です。お客様の個人情報が紛失、盗難、誤用、改ざん、違法または不正アクセス、使用もしくは開示されないよう保護するために、当社は各種の適切な具体的、行政管理上、技術上の手段およびお客様の個人情報保護のため作成された保護手段を実施します。</p><p>Appierは同時に、当社が保有する個人情報を保護するために、各種の合理的な措置を実施しています。これには以下を含みます。</p><ul><li>個人情報の使用、セキュリティおよび守秘について、グループ全体のポリシーおよび手順の実施</li><li>厳格な管制について、知る必要があり且つ厳格な機密保持規定の拘束を受ける従業員および第三者のサービス提供者のみが個人情報へアクセスができる。</li><li>送信過程におけるデータ保護のために各種のテクノロジーを利用する。例えば、お客様がウェブサイトを通じて提供したデータの一部についてSSL暗号化を行い、且つ適切なセキュリティ手段を使用して当社が収集して保持するデータを保護する。</li><li>業界標準に対応する手段およびプロセスを使用し、コンピュータシステムおよびネットワークに違反する不適切な試みを検出し、且つ対応する。</li></ul><p>インターネットとその通信が常に安全であることを保証することはできません。また、お客様が本テクノロジーを通じて当社に提供した個人情報の安全性を当社は確保または保証することができません。これに対し、疑わしいデータセキュリティ違反について、当社は既存の手順により処理します。疑わしい違反事件が生じた場合、当社は法律規定によりお客様および主務機関に通知します。</p><p>電子通信、特に電子メールは、傍受に対して必ずしも安全ではないことにご注意ください。Appierは、業界標準に合致するデータ収集および暗号化システムを使用して、個人の識別可能な情報の安全な収集と送信を保証します。機密データ（ソーシャルセキュリティ、銀行口座、クレジットカードの番号など）をメールまたはウェブフォームで送信しないでください。</p><ol><li>お客様の権利</li></ol><p>お客様はご自身の個人情報の正確性を確認するために、当社が保管しているすべてご自身の個人情報のアクセス、紙または電子コピーの獲得、レビュー、修正、および更新する権利を有します。関連の法的要件や免除の対象に違反しない前提で、お客様はご自身の個人情報に対する処理について、反対、制限、またはお客様の特定の個人情報を当社のファイルから削除するよう要求することができます。</p><p>もしお客様がEU内に居住していて、且つ情報処理の合法的な基礎が（i）（a）契約または（b）お客様の同意、および（ⅱ）自動化手段である場合、お客様は個人情報のデータポータビリティ権を行使することができます。しかし当該要求は、お客様が当社に提供した個人情報について、その時点で保有していた場合に限り、且つ身元確認手続きを含む関連の法的要件や免除の対象に違反しないことを前提とします。</p><p>当該要求が法律で禁止されているか、またはAppierが合法的な目的でお客様の個人情報を保有する場合を除き、Appierは前述の要求に応じるために合理的な努力を行います。前記の場合、当社は不当な遅延がなくお客様に知らせます。お客様の個人情報に関する一切の要求を処理する前に、当社はお客様の身元を確認する権利を保留します。お客様の個人情報に関する質問がある場合、このプライバシーポリシーの最後に記載されている連絡先をご利用ください。</p><p>本プライバシーポリシーに基づき、もし当社がEUまたはスイスの自然人から直接関係がある個人情報を受取る場合、当社は当該個人に選択を提供し（場合によっては、オプトアウトまたはオプトインを選択する）個人情報を(1) 第三者に開示するかどうか、直接販売を目的とするものを含む、または(2) 最初に集められた目的とは異なる目的のための使用、または今後当該自然人の同意を得て且つ当初の目的と相反しないもの。但し(i) 当社を代表するかまたは当社の指示に従い直接業務を遂行する第三者によるデータの転送および(ii) お客様の事前承諾を必要とする新たな処理業務の場合はこの限りではありません。</p><p>オプトアウトを希望する個人は、このプライバシーポリシーの末尾に記載されている連絡情報の詳細を利用してAppierに連絡してオプトアウトするか、または新しい目的に関連する情報プロセスにいつでも自由にアクセスできます。</p><ol><li>子供のプライバシー</li></ol><p>Appierは両親および保護者による子供のオンライン活動への積極な参与を推奨します。 Appierは児童に対し、製品およびサービスを販売又は提供しません。従って、当社ウェブサイトは成人ユーザーの相互交流の為に設計してあるので、故意に18歲未満の子供から個人情報を収集することはありません。もしお客様が16歲以下の未成年者の両親又は法定後見人で、なお且つ当該未成年者が既に当社に個人情報を開示したことを確信している場合、本プライバシーポリシーで提供する連絡先から当社に連絡してください。</p><ol><li>個人情報の転送、処理および保存</li></ol><p>当社は国境を越えた業務運営を行うグローバル組織として、Appierを代表してAppierの管理を受けて行う情報処理又は保存を含む前述の「当社によるお客様の個人情報の共有」の一節で述べた目的により、お客様の個人情報を、台湾にあるAppierのサーバーおよび事業体、全世界のAppierの関連事業体又はEU/EEA内部あるいは外部の第三者事業パートナー、プロバイダー、ベンダー、又は請負業者に移転することがあります。</p><p>Appierは2016年4月27日可決のEU法規番号第2016/679号の一般データ保護規則 (即ち「GDPR」)を含む適用のあるプライバシーおよびデータ保護法規に基づき越境移転を実施します。法律規定の適用により、お客様の個人情報も十分な保護が得られ、Appierの適切な措置の実施によりお客様の個人情報はAppier関連事業体および上述第三者間において、プライバシーおよび情報保護法規適用が遵守並びに尊重された形式で処理されます。当該措置には、EU居留民関連情報を転送するためのAppierとAppier各事業体又はサービスプロバイダーとの情報処理/移転協議が含まれます。</p><ol><li>プライバシーポリシーの改訂</li></ol><p>当社製品又はサービスの何らかの変更を反映したり、又は当社法定および/又は主務機関の規制義務の変動に従うために当社は随時プライバシーポリシーを更新する権利を保有します。当社がプライバシーポリシーを改訂した場合は、ウェブサイトにおいて最新更新期日とともに改訂版を掲載します。重要な内容の変更がある場合、当社は各項変更の実施前に他の方法でお客様に通知しますが、例えば電子メール送信による通知です。もしお客様が前述の改訂実施三十日後に当社ウェブサイトの利用を継続していた場合は、各項改訂を受け入れて同意し、これを遵守しているものと見なします。</p><ol><li>APPIERの連絡先情報</li></ol><p>お客様の個人情報保護並びに個人情報に関する要望を受けるにあたり、Appierは以下の部署および人員を指定します。<br>プライバシー保護担当部署：</p><p>法務担当部署<br>所在地：110 台湾台北市信義区松仁路123号8F<br>電話：+886287802800<br>電子メール信箱：&nbsp;<a href=mailto:legal@appier.com>legal@appier.com</a></p><p>もし当社の対応又は当社によるプライバシーポリシーに基づく処理方法にご不満がある場合、お客様には情報保護主務機関又は管轄権を有する裁判所に告発又は提訴する権利があります。EU加盟国内にお住まいの方は、下記に各国情報保護主務機関リストをご参照ください。<br><a href=\"https://www.google.com/url?q=http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm&amp;sa=D&amp;ust=1536048166971000\">http//ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm</a></p></ng-container><ng-container ng-switch-default><h1 class=text-center>Privacy Policy</h1><ol><li>OVERVIEW</li></ol><p>This privacy statement (“Privacy Policy”) indicates the way information is collected and utilized by Appier Inc., its subsidiaries and affiliates (“Appier”, “we”, or “us”) respect your privacy and are committed to protecting your Personal Information and being transparent about how we collect, use, and share your Personal Information This privacy policy (“Privacy Policy”) applies to all Appier’s online services and website (<a href=\"https://www.google.com/url?q=https://www.appier.com//&amp;sa=D&amp;ust=1536048166950000\">www.appier.com</a>) or to any website that includes a link or reference to this Privacy Policy (together, the “Website”) and describes how we handle Personal Information (as described below) and the choices available to you regarding collection, use, access and how to update and correct your Personal Information.</p><ol><li>APPIER’S SERVICE</li></ol><p>Appier operates artificial intelligence platforms, such as Cross X Ad Solution, AIQUA (Marketing Automation Platform) and AIXON (Data Science Platform), to help enterprises solve their most challenging business problems.</p><ol><li>PERSONAL INFORMATION WE COLLECT</li></ol><ul class=second-section><li>THROUGH THE WEBSITE</li></ul><p>We collect data, including Personal Information that you provide on our Website and as you use the Website. “Personal Information” includes information that can be used to identify you as a natural person, directly or indirectly, in particular in combination with other information available to us such as an identification number, online identifier or one or more factors specific to your identity as a natural person and may include, but is not limited to, your:</p><p>As such, should you use the form made available on the Website, we may also collect the following information:</p><ul><li>Contact information, such as name, address, phone number, email address (etc.);</li><li>Demographic information, such as your country, company, &nbsp;job title;</li><li>Comments</li></ul><p>Appier aims at keeping the Personal Information we hold is accurate and up-to-date. Please ensure that the Personal Information you communicate to us is accurate and up-to-date.</p><p>If you fail to provide certain personal data when requested, we may not be able to perform the contract we have entered into with you (such as providing you with a product or service), or we may be prevented from complying with our legal obligations.<br>In addition, when you visit our website to browse, read, or download information on the Website, your web browser automatically sends us (and we may retain) information such as the:</p><ul><li>Internet domain through which you access the Internet</li><li>Internet Protocol address of the computer you are using</li><li>Type of browser software and operating system you are using</li><li>Date and time you access our site</li><li>The Internet address of the site from which you linked directly to our site</li></ul><p>We will use this information as aggregate data to help us maintain this site, e.g., to determine the number of visitors to different sections of our site, to ensure the site is working properly, and to help us make our site more accessible and useful and in accordance with our Cookie Policy.</p><p>We also collect Personal Information from trusted third-party sources and engage third parties to collect Personal Information to assist us.</p><ul class=second-section><li>THROUGH OUR SERVICES</li></ul><p>In addition, in order to provide our services to our customers, we may also collect additional Personal Information, through our cookies placed by our customers on their own websites or from website partners authorized to collect such Personal Information.</p><p>This Personal Information is collected only if you accept the cookies for such advertising purpose.</p><ul class=third-section><li>Personal Information collected on Internet:</li></ul><ul><li>Appier Cookie identifier,</li><li>IP address,</li><li>IP geolocation,</li><li>URLs of pages of the various sites visited,</li><li>The time of your browsing on the various pages,</li><li>The type and version of the browser with which you browse the Net,</li><li>Cookie identifiers of partner technological platforms, which share the same goals, for which this data has been collected.</li><li>Ad ID</li><li>Ad web page URL</li><li>Event ID -such as&nbsp;the&nbsp;end&nbsp;user “clicks” the&nbsp;Ad or “views” the&nbsp;impression</li></ul><ul class=third-section><li>Personal information collected via Mobile Application</li></ul><p>To collect Personal Information using a mobile application, Appier relies on various partners to collect the following Personal Information:</p><ul><li>The IP address,</li><li>The mobile phone’s identifier for advertisers (IDFA for IOS devices and GAID for Android),</li><li>GPS geolocation data,</li><li>The model of mobile phone as well as its operating system (IOS, Android, etc.).</li><li>URL of pages on the client website which have been&nbsp;viewed.</li><li>Time</li><li>Ad ID</li><li>App name.</li></ul><ol><li>HOW WE USE YOUR PERSONAL INFORMATION</li></ol><p>We only collect, use and store your Personal Information for the purposes of operating our business, delivering, improving, and customizing our Website as well as products and services we provide, sending marketing and other communications related to our business, providing you with information, products and services that you request from us, and for [other legitimate purposes permitted by applicable law].</p><p>As the case may be, we will provide you with the basis of such legitimate purposes upon its occurrence, prior to implementation of the related processing.</p><p>Appier collects Personal Information for a variety of purposes, including the following:</p><ul><li>Providing you with information you requested from us;</li><li>Respond to an inquiry from you;</li><li>Sending communications to you, including for marketing or customer survey purposes, either directly from Appier or, subject to your consent, as the case may be, from our third-party partners;</li><li>Contract with you for, and provide you with our services to which you have subscribed or considering subscribing;</li><li>Creating an account;</li><li>Prevent and address fraud, breach of policies or terms, and threats or harm.</li><li>Providing customer service and support, notably through chatbots;</li><li>Improving the operation of the Website and/or help adjust the content of the Website to the general geographic location of you and for reporting purposes;</li><li>Managing a job application.</li></ul><p>We may also use the Personal Information in connection with the services rendered to our customers, and notably:</p><ul><li>To deliver advertisements as well as marketing and sales offers to you that best correspond to your needs and preferences,</li><li>To help advertisers and publishers better target their current and future customers in their loyalty building and commercial prospecting campaigns,</li><li>To help businesses distribute non-intrusive advertising,</li><li>To optimise distribution frequency of advertisements (marketing pressure) with a view to avoiding saturation,</li><li>To develop studies for advertisers of various industries (automotive, real estate, distribution, etc.) in the interest, amongst others, of helping them to better understand consumers’ needs and their market as well as to analyse the performance of their loyalty building and commercial prospecting campaigns.</li><li>Reconcile the different identifiers of various terminals in order to bring them closer to a profile in a probabilistic way.</li></ul><p>Where required or permitted by applicable law, we also use or disclose your Personal Information to limited third parties when we believe, in good faith, that such use or disclosure is reasonably necessary to (i) comply with the legal obligation bearing on Appier, (ii) enforce or apply the terms of any agreement to which we are a party, or (iii) protect the rights, property or safety of Appier, Appier customers, or others.</p><ol><li>HOW WE SHARE YOUR PERSONAL INFORMATION</li></ol><p>We may share your personal Information with our affiliate entities and other third-party business partners, providers, vendors or contractors acting on our behalf and under our instructions, whether located within or outside of the European Union (“EU”) or the Economic Area (“EEA”), for the purposes of operating our business, delivering, improving, and customizing our Website as well as our products and services, sending marketing and other communications related to our business and when needed, with your consent.</p><p>Therefore, we may share Personal Information in the following ways:</p><ul><li>Within Appier and any of our affiliate entities located within or outside of the EU/EEA, for purposes of Personal Information processing or storage in connection with the aforementioned purposes;</li><li>With Appier’s business partners, vendors, authorized third-party agents or contractors to provide our products and services or facilitate transactions. Examples include, but are not limited to: processing or orders, hosting websites and providing support.</li><li>In connection with, or during negotiations of, any merger, sale of company assets, consolidation or restructuring, financing, or acquisition of all or a portion of our business by another company;</li><li>As the case may be, for further protection of your privacy, Appier will share your Personal Information in aggregated form which may be used to identify you direclty or indirectly;</li></ul><p>Where mandated or permitted by applicable law, regulation or legal process, we will disclose your Personal Information to law enforcement officials, government authorities or other third parties, located inside and outside of the EU/EEA, where such disclosure is in accordance with due process of law and binding upon Appier, to the extent necessary to comply with legal process or meet national security requirements, protect the rights, property, or safety of Appier, its business partners, you, or others.</p><ol><li>LINKS TO THIRD-PARTIES’ WEBSITES</li></ol><p>The Website may contain links to third-party websites that are operated by companies outside of our control. Your activities on those third-party websites will be solely governed by the privacy policies and procedures of those third parties. Appier takes no responsibility whatsoever for the content or information practices of such third parties and encourage you to review the privacy polices of these third parties before disclosing any information on their websites.</p><ol><li>HOW LONG WE KEEP INFORMATION AND THE METHOD OF DESTRUCTION</li></ol><p>We will retain your Personal Information only for the duration of the purpose for which it was collected in accordance with Section 4, as well as as necessary to comply with our business requirements, legal obligations, resolve disputes, protect our assets and enforce agreements to which Appier is a party and will delete your Personal information further to this period.</p><p>In any case, we will delete your Personal Information when you do not use our service for a period of one year</p><ol><li>SECURITY AND CONFIDENTIALITY OF YOUR PERSONAL INFORMATION</li></ol><p>The security and confidentiality of your Personal Information is important to us. We implement appropriate physical, administrative, and technical measures and safeguards designed to protect your Personal Information from loss, theft, misuse, alteration, unlawful or unauthorized access, use, or disclosure.</p><p>Appier also relies on reasonable measures to safeguard Personal Information in our possession, including:</p><ul><li>Enforcement of group-wide policies and procedures on Personal Information use, security and confidentiality;</li><li>Restricting access to Personal Information to only those employees and third-party service providers on a “need to know” basis and under strict confidentiality requirements;</li><li>Use of technologies to safeguard data during transmission, such as SSL encryption for some of the data that you provide via the Website and using appropriate security measures to safeguard the data we collect and possess;</li><li>Use of industry-standard measures and processes for detecting and responding to inappropriate attempts to breach our computer systems and networks.</li></ul><p>The Internet and any communication thereon cannot be guaranteed to be secure at all times, and we cannot ensure or warrant the security of any Personal Information you provide us through this technology. In this regard, we have procedures to deal with any suspected data security breach and will notify you and any regulator of a suspected breach, as mandated by law.</p><p>Please note that electronic communication, particularly email, is not necessarily secure against interception. Appier uses industry-standard data collection and encryption systems to ensure the secure collection and transmission of your personal identifiable information. Please do not send sensitive data (e.g., Social Security, bank account, or credit card numbers) by email or web form.</p><ol><li>YOUR RIGHTS</li></ol><p>You have the right to access, obtain a paper or electronic copy, review, correct, update or delete all your Personal Information stored by us, notably to confirm its accuracy. Subject to any relevant legal requirements and exemptions, you may also oppose to or limit the processing or your Personal Information or request that certain of your Personal Information be deleted from our files.</p><p>If you reside within the EU, you may also exercise you right to portability of your Personal Information where the lawful basis for the processing is (i) (a) a contract or (b) your consent and (ii) by automated means. Please note that such a request could be limited to the sole Personal Information you provided us with or that we hold at that given time and subject to any relevant legal requirements and exemptions, including identity verification procedures.</p><p>Appier will make reasonable efforts to comply with the aforementioned requests, unless such requests are prohibited by law, or there is a legitimate purpose to retain your Personal Information, in which case we will inform you without undue delay. We reserve the right to verify your identity before any request relating to your Personal Information processed by us. Please direct any questions about your Personal Information using the contact details provided at the end of this Privacy Policy.</p><p>In accordance with this Privacy Policy, but excluding (i) any transfers of data to third parties performing tasks directly on our behalf and pursuant to our instructions and (ii) new processing operation requiring your prior consent, where we receive Personal Information directly from an EU or Swiss individual to which such Personal Information relates, we will offer the individual the opportunity to choose (as the case may be, through opt-out or opt-in) whether his or her Personal Information is (1) disclosed to a third party, including for direct marketing purposes; or (2) used for a purpose that is different than the purpose it was originally collected or subsequently authorized by the individual and compatible with that original purpose.</p><p><b>Any individual who wishes to opt out&nbsp;or to delete Personal Information&nbsp;can do so freely and at any time by contacting&nbsp;Appier at privacy@appier.com or&nbsp;the contact details provided at the end of this Privacy Policy or further to the information process relating to the new purpose.</b></p><ol><li>CHILDREN’S PRIVACY</li></ol><p>Appier encourages parents and guardians to take an active role in their children’s online activities. Appier does not sell or offer its products and services to children. As such, our Website is designed for adult user interaction. We do not intentionally collect Personal Information from children under the age of 18. If you are a parent or legal guardian of a minor under the age of 16 and believe that the minor has disclosed personal information to us, please contact us using the contact details provided in this Privacy Policy.</p><ol><li>TRANSFER, PROCESSING AND STORAGE OF PERSONAL INFORMATION</li></ol><p>As a global organization with business processes in operation across borders, we may transfer your Personal Information to Appier’s servers and entities located in Taiwan, to any Appier affiliate entity worldwide or to third-party business partners, providers, vendors, or contractors, that are located inside or outside of the EU/EEA, for purposes described in the section “How We Share your Personal Information” above, including for the purpose of data processing or storage on behalf and under the control of Appier.</p><p>Appier implements cross-borders transfers in compliance with applicable privacy and data protection regulations, including Regulation (EU) 2016/679 of 27 April 2016 on the protection of personal data (the “GDPR”). Where mandated by applicable law, to ensure that your personal data does receive an adequate level of protection, Appier implements the appropriate measures to ensure that your Personal Information is treated across Appier affiliated entities and by the aforementioned third parties in a way that is consistent with and which respects the applicable privacy and data protection laws. Measures include the following: a data processing/transfer agreements between Appier and its entities or its service providers for onward transfers of data processing agreements for data relating to EU residents.</p><ol><li>CHANGES TO PRIVACY POLICY</li></ol><p>We reserve the right to update this Privacy Policy from time to time in order to reflect any changes to our products or services or to comply with changes in our legal and/or regulatory obligations. If we modify our Privacy Policy, we will post the revised version on the Website, with an updated revision date. Where such changes are substantial, we will also notify you by other means prior to the changes taking effect, such as by sending you an email notification. By continuing to use our website thirty days after such revisions are in effect, you will be deemed to accept and agree to the revisions and to abide by them.</p><ol><li>CONTACT INFORMATION AT APPIER</li></ol><p>The following department and personnel have been designated by Appier to protect your personal data and to receive your requests regarding your information.</p><p>Department responsible for privacy protection: Legal Department</p><p>Address: 8F, No.123, Songren Road, Xinyi District, Taipei 110, Taiwan</p><p>Tel: +886287802800</p><p>E-mail:&nbsp;<a href=mailto:legal@appier.com>legal@appier.com</a></p><p>If you are not satisfied with our answer or the way we process your Personal Information pursuant to this Privacy Policy, you may also have the right to lodge a complaint with a data protection authority or a Court of competent jurisdiction. If you reside within the European Union, a list of national data protection authorities can be found here: <a href=\"https://www.google.com/url?q=http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm&amp;sa=D&amp;ust=1536048166971000\">http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm</a>.</p></ng-container></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

var path = '/templates/core/views/terms_of_service_appier_inc.html';
var html = "<h1 class=text-center>AiDeal使用規約</h1><p>本使用規約（下稱「本規約」）之下列內容係關於使用Appier集團所屬公司（Appier之簽約主體應依AiDeal申請表單（詳第2條定義）所載為準。下稱「Appier」）提供之AiDeal服務時之應遵守事項、及使用者與Appier間之權利義務。擬申請使用本服務者，敬請於申請前詳閱全文。</p><ol><li><p><strong>適用範圍</strong></p></li></ol><ol><li><p>本規約係以規定Appier與使用者（詳第2條定義）間就使用本服務（詳第2條定義）之相關權利義務關係為目的，並適用於使用者與Appier間有關使用本服務之一切事務。又Appier之隱私權政策（ <a href=\"https://www.appier.com/privacy-policy/\">https://www.appier.com/privacy-policy/</a> ，包含所有日後隨時得變更之內容）亦經引用而應視為本規約之一部分。Appier得按其裁量，隨時變更、修改本規約，且無須為事前通知。使用者同意，使用者繼續使用本服務者，將視為使用者同意變更、修改後之本規約。</p></li><li><p>Appier隨時刊載於Appier網站（詳第2條定義）之關於本服務之規範、各項規定等，均為本規約之一部分（包含刊載於本公司網站之本服務相關規定、AiDeal收費標準、及其他各項規定等）。惟如AiDeal申請表單（詳第2條定義）另有約定，並與本規約有不一致之情形時，應以AiDeal申請表單之記載為準。</p></li></ol><ol class=article start=2><li><p><strong>定義</strong></p></li></ol><p>本規約中所使用之下列用語，應分別具有以下所定涵義：</p><ol><li><p>「瀏覽者」：指瀏覽指定網站及／或指定應用程式之消費者。</p></li><li><p>「服務費用」：指第6條第1項定義。</p></li><li><p>「指定應用程式」：指使用者之將利用本服務的行動應用程式，並該等行動應用程式應以與使用者所營運之公司事業相關者為限。</p></li><li><p>「指定網站」：指使用者之將利用本服務的網站，並該等網站應以與使用者所營運之公司事業相關者為限。</p></li><li><p>「智慧財產權」：指著作權、專利權、新型專利權、商標權、設計專利權及其他智慧財產權（包含取得或申請該等權利註冊之權利）。</p></li><li><p>「Appier網站」：指Appier所營運之主網域位址為「appier.com」之網站（不論任何理由，如本公司網站之網域位址或內容有變更時，包含變更後之網站）。</p></li><li><p>「本服務」：指由本公司及/或關係企業即Appier集團提供名稱含有「AiDeal」之服務（不論任何理由，如服務之名稱或內容有變更時，包含該變更後之服務）。又Appier得按其裁量，隨時變更本服務之服務範圍（包括但不限於變更或停止本服務之一部或全部），且無須為事前通知。</p></li><li><p>「申請資料」：指使用者依本公司所定之制式申請表單（下稱「AiDeal申請表單」）所填載並向本公司提出之資料。</p></li><li><p>「使用者」：指與本公司締結本服務之使用契約之個人或法人。</p></li><li><p>「使用契約」：指Appier及使用者簽署之AiDeal申請表單，並本規約亦經引用而應視為使用契約之一部分。如使用者擬於歐洲經濟區或任何經歐盟委員會核准之國家使用本服務，則附於本規約之後的資料處理增補合約（Data Processing Addendum）（僅提供英文版本）亦應視為使用契約之一部分。</p></li><li><p>「有效期間」：指AiDeal申請表單中所載自起始日起至結束日之期間（如有適用，亦包含自動更新期間）。</p></li></ol><ol class=article start=3><li><p><strong>資料變更</strong></p></li></ol><p>使用者應負責確保任何向Appier提供之資料都為最新之資料；如申請資料及／或其他向Appier提供之資料（例如：與使用者帳戶相關之資料）有任何變動時，應按Appier指定之方式立即通知Appier，並按Appier之要求提供必要之資訊。如Appier認為有任何使用者資料之變動導致違反本規約之情事時，Appier得將該等違約情事告知使用者，並立即終止使用契約，且Appier無須負任何責任。</p><ol class=article start=4><li><p><strong>使用者帳戶管理</strong></p></li></ol><ol><li><p>當使用者正式開始使用本服務時，使用者應按Appier之說明建立使用者之帳戶（下稱「<strong>使用者帳戶</strong>」），並設定ID及密碼。</p></li><li><p>使用者應負全責管理及保護其使用者帳戶，於任何情形下皆不得有讓第三人使用、或出借、轉讓、出售帳戶予第三人等行為。</p></li><li><p>使用者應就因不當使用使用者帳戶相關之行為（包括但不限於使用者之故意或過失行為，或未經授權之第三人之行為）所生之損害自負全責；Appier於該情況下皆無須向使用者及／或任何第三人負責。</p></li><li><p>不論使用者是否知悉，使用者應就其使用者帳戶之所有行為負責。使用者如發現其密碼或使用者帳戶受盗、遭第三人使用時，應立即通知本公司，並完全按本公司之指示辦理。</p></li></ol><ol class=article start=5><li><p><strong>關於程式碼（Tag）及軟體開發工具包（SDK）之使用</strong></p></li></ol><ol><li><p>為利使用者可使用本服務之目的，Appier已開發並將提供相關之程式碼（下稱「Tag」）及軟體開發工具包（下稱「SDK」）。使用者僅得按照Appier之所有指示使用各個Tag及SDK。又鑒於本服務之性質，Appier得隨時更新Tag及SDK。</p></li><li><p>使用者僅得於為使用本服務之範圍內，使用各Tag及SDK。使用者不得使用Tag及SDK構築與本服務競爭之任何產品或服務。</p></li></ol><ol class=article start=6><li><p><strong>服務費用及付款</strong></p></li></ol><ol><li><p>使用者應向Appier支付AiDeal申請表單中所載之費用（下稱「服務費用」）作為使用本服務之對價。Appier會於AiDeal申請表單中提供收款資訊供使用者作業，且，如經Appier要求，使用者應以書面將使用者之付款資訊（例如：銀行代碼、分行代碼、帳戶類別、帳戶號碼及銀行帳戶所有人之資訊）通知Appier。</p></li><li><p>除Appier及使用者間另有事前書面約定外，各月份之服務費用應於各日曆月之末日結算之（於本項範圍內，下稱「結算日」），且使用者應於翌日起五個工作日內確認並同意該等金額。又如使用契約於結算日後終止，但使用者尚未付款時，使用者仍應給付使用契約終止前所產生之服務費用。為避免疑義，如本服務之開始日距結算日未滿一個月（例如使用者於1月15日起使用本服務，而最初之結算日為1月31日），且使用者應適用固定月費時，服務費用將按比例計算之。</p></li><li><p>使用者延遲支付服務費用時，使用者應按年利率14.6%（或其他應適用之法律所允許之最高利率，取其高者）計算遲延利息作為對Appier之遲延損害賠償金。</p></li><li><p>使用者得依使用契約之約定終止合約，惟Appier於任何情況下皆無須向使用者返還使用者於使用契約終止前已支付之任何服務費用。</p></li></ol><ol class=article start=7><li><p><strong>智慧財產權歸屬</strong></p></li></ol><ol><li><p>與本服務相關之智慧財產權（包括但不限於Appier提供及開發之所有Tag及SDK）於任何時點均應歸屬Appier及/或Appier之授權人所有。除本規約另有明文約定者外，授權使用本服務，並不代表授權使用Appier或Appier之授權人之智慧財產權。使用者不得以任何方式（包括但不限於逆向分解、逆向編譯及逆向工程）侵害Appier或其授權人之智慧財產權。</p></li><li><p>使用者應就所有內容及素材（包括但不限於文字、設計、圖示、或使用者提供給Appier或使用者自行上傳至AiDeal平台之其他任何廣告素材、或Appier依照使用者指示準備之任何素材）（以下合稱「使用者內容」）負全責；且使用者在此保證其擁有於使用本服務之過程中利用、提供及上傳使用者內容之所有必要之權利。使用者並聲明及保證，經使用者所提供之使用者內容，及Appier利用該等使用者內容，均不會侵害、濫用第三人之智慧財產權，且不會違反任何應適用之法律。</p></li><li><p>Appier為使用者製作、及／或由使用者向Appier提供之使用者內容中之智慧財產權，於任何時點均應歸屬使用者及／或其授權人所有。使用者在此授予Appier一經限制、非專屬、不可撤回、不限地域、無權利金、可轉讓之權利，使Appier得於提供本服務所必要之範圍內、就該等使用者內容進行再授權、存取、瀏覽、使用、複製、變更、公開顯示及傳送。</p></li><li><p>使用者不得未經Appier事前書面同意，為了任何目的以任何方式使用或顯示Appier之名稱、商標、Logo或其他Appier專屬資訊。</p></li></ol><ol class=article start=8><li><p><strong>使用者之其他責任義務</strong></p></li></ol><ol><li><p>使用者為接受本服務所必要之電腦、軟體、其他機器、通訊線路及其他通訊環境等之準備及維護，由使用者負擔費用並自行處理。</p></li><li><p>基於Appier之合理請求，使用者應將Appier另以書面指定之事項（如有）列入指定網站及／或指定應用程式之隱私權政策中，並應使瀏覽者得易於閱覽該等隱私權政策。</p></li><li><p>使用者了解，其應以自己之責任，按應適用之法律（例如，關於個人資料保護相關之法律及規定）取得容許使用者利用本服務所必要之瀏覽者之同意。如Appier合理請求使用者變更於有效期間內應適用於瀏覽者之使用者自身的規約、政策以及其他規則等（下稱「使用者規約」）時，使用者應於Appier所定期間內配合處理。Appier就有關使用者與瀏覽者間所發生之交易、溝通、爭議等（包含但不限因使用者規約所生者）不負任何責任，使用者應以自己之責任及費用予以解決。</p></li><li><p>使用契約終止時，使用者應按Appier之指示，自指定網站及／或指定應用程式、及所有使用者之裝置（如適用）中刪除所有Tag及／或SDK。使用者在此確認，如使用者未能自指定網站及／或指定應用程式、及所有使用者之裝置（如適用）刪除所有Tag及／或SDK，而因Appier於使用契約終止後就Tag及／或SDK進行變更及／或使其失效，而導致使用者受有任何損害（包括但不限於指定網站及／或指定應用程式出現錯誤）時，Appier概不負責。</p></li></ol><ol class=article start=9><li><p><strong>機密資訊</strong></p></li></ol><ol><li><p>「機密資訊」包括與本服務相關，或對某一當事人 （下稱「揭露方」） 目前或未來之營運具有或可能具有商業價值或其他功用而向對方 （下稱「收受方」） 揭露之全部資訊或資料，包括但不限於財務狀況、顧客名單、市場開發、或技術資訊，且於揭露時經指定為機密、或按其揭露之情境或經揭漏之資訊之性質應被視為機密者。基於例示且非限制之原則，機密資訊包括 （但不限於） 以下各項：（i）雙方當事人間所交換，以任何形式或媒材存在之資訊，但該等資訊應於揭露時標示為「機密」；（ii）其揭露之情境應係一般理智人士會認為接受人應該會將該等資訊視為機密。</p></li><li><p>縱有前項約定，「機密資訊」不包括下列資訊：（i）該資訊係於揭露方提供前，收受方已合法知悉或取得者；（ii）於收受方受揭露之後因不可歸責於收受方之因素成為公開資訊者，或因不可歸責於收受方之事由為收受方所知悉者；（iii）收受方合法自無保密義務之第三人取得或知悉者；（iv）該資訊是由收受方於未參考機密資訊之情形下自行研發所得。</p></li><li><p>縱有前開約定，任一方當事人得依任何法院命令、法規或類似之調查或要求，於必要範圍內揭露他方當事人之機密資訊。惟收受方依本條揭露機密資訊之前，應以合理之努力（i）立刻以書面通知揭露方該等揭露機密資訊之要求，並（ii）配合揭露方保護或縮小揭露範圍，或取得保護令。</p></li><li><p>收受方了解，如其未經同意而揭露機密資訊，所導致之損害將難以單靠金錢賠償彌補之。基此，如收受方未經同意揭露方同意而揭露機密資訊，揭露方得按應適用之法律尋求禁制令或其他同等及所有可能之救濟。</p></li></ol><ol class=article start=10><li><p><strong>禁止行為</strong></p></li></ol><p>使用者使用本服務時，不得有該當下列任一款之行為。如經Appier按自己之裁量權判斷，使用者或指定網站／指定應用程式有該當下列任一事由、或有該當該等情形之虞時，Appier得於不負任何額外責任之情形下對該使用者暫停提供本服務或終止使用契約：</p><ol><li><p>侵害Appier或其他第三人之智慧財產權、肖像權、隱私權、名譽、其他權利或利益之行為（包含但不限於直接或間接之侵權行為)。</p></li><li><p>試圖針對Appier用於提供本服務之軟體進行逆向分解、破解、逆向編譯、逆向工程及／或其他推導原始碼之行為。</p></li><li><p>涉及違法、犯罪或違反公序良俗之行為。</p></li><li><p>傳送虛偽或其他不適當之內容，包括但不限於違法之色情、猥褻、及/或暴力相關之資訊。</p></li><li><p>傳送含有電腦病毒及其他有害電腦程式訊息之行為。</p></li><li><p>有妨礙Appier營運（包括但不限於本服務之營運）之行為。</p></li><li><p>利用本公司所提供之程式碼及／或SDK，逕自於指定網站及／或指定應用程式以外之網站／應用程式向瀏覽者提供購買回饋獎勵之行為（包含但不限發行優惠券、提供折扣及發放贈品等）。</p></li><li><p>其他經Appier判斷屬不適當之行為。</p></li></ol><ol class=article start=11><li><p><strong>本服務之停止</strong></p></li></ol><ol><li><p>於符合以下任一款事由時，Appier得不事前通知使用者，逕行停止或中斷本服務之一部或全部：</p><ol><li><p>緊急進行本服務相關電腦系統之檢查或維修作業時。</p></li><li><p>電腦、通訊線路等因事故而停止時。</p></li><li><p>因火災、停電、天災地變等不可抗力而無法營運本服務時。</p></li><li><p>其他經本公司判斷須停止或中斷時。</p></li></ol></li></ol><ol class=article start=2><li><p>Appier於任何情況下，均不就因採取本條所列之措施而對使用者造成之損害負責。</p></li></ol><ol class=article start=12><li><p><strong>終止</strong></p></li></ol><ol><li><p>下各款任一事由時，Appier得不經事前通知或催告即暫停該使用者對本服務之使用或終止使用契約。</p><ol><li><p>違反本規約任一條款時。</p></li><li><p>經確認AiDeal申請表單有虛偽陳述時。</p></li><li><p>依應適用之法律，使用者有停止付款或陷於無清償能力之情事，或有聲請開始進行破産程序、民事再生程序、公司重整程序、特別清算或類似之程序時。</p></li></ol></li><li><p>如使用者符合前項各款任一事由，使用者對Appier所負之一切債務將當然喪失期限利益，並應立即向Appier支付所有未付之款項。</p></li><li><p>Appier於任何情況下，均不就因採取本條所列之措施而對使用者造成之損害負責。</p></li><li><p>使用者得依AiDeal申請表單所載之方式（如適用），以事前書面通知Appier於指定之日曆月之末日終止使用契約。</p></li></ol><ol class=article start=13><li><p><strong>違約責任</strong></p></li></ol><p>如使用者未能履行或違反使用契約之義務，且導致Appier因此受有損害或遭第三人提出任何主張或請求，則使用者應提供Appier所有必要之協助，且賠償Appier因此所受之所有損害，包括但不限於訴訟費用及律師費用。</p><ol class=article start=14><li><p><strong>聲明與保證</strong></p></li></ol><ol><li><p>Appier茲聲明並保證：（a）Appier有充分權利與權限得締結使用契約，並履行使用契約之約定；（b）Appier按使用契約履行其應盡義務不會違反其所簽署之任何其他協議；（c）使用契約一經簽署與交付，即構成對Appier之有效、合法且具約束力義務。</p></li><li><p>使用者茲聲明並保證：（a）使用者有充分權利與權限得締結使用契約，並履行使用契約之約定；（b）使用者按使用契約履行其應盡義務不會違反其所簽署之任何其他協議；（c）使用契約一經簽署與交付，即構成對使用者之有效、合法且具約束力義務；（d）不得以任何病毒、蠕蟲、破解程式、自動機器人軟體、機械或電子設備、其他電腦程式或任何不正當手段介入、侵入、損害、更改、反解譯本服務；（e）不得進行逆向工程或變更本服務之原始碼；（f）其於任何時間點均不會遭認定為反社會勢力（定義如下）；（g）其於任何時間點均不會被列於美國海外資產控制辦公室（Office of Foreign Assets Control，下稱「OFAC」）之制裁名單。</p></li><li><p>使用者應以自己之責任及費用確認其使用本服務是否會違反任何應適用於使用者之法律或所屬產業組織之相關規範。Appier就使用者使用本服務是否符合任何應適用於使用者之法律或所屬產業組織之相關規範事，不為任何保證。使用者並應以自己之責任處理及解決任何使用者與第三方間之與本服務相關的交易、聯絡或爭議。Appier就前述事由概不負責。</p></li><li><p>就Appier暫停、停止、終止本服務、或使本服務無法被使用、或變更本服務內容，或使用者因使用本服務導致資料消滅、設備故障或損壞，或因其他與本服務相關之事由導致使用者所受之損害，Appier概不負責。</p></li></ol><ol class=article start=15><li><p><strong>免責條款</strong></p></li></ol><ol><li><p>本服務乃以「現況」及「以目前明示的條件下」的狀態提供。Appier就本服務，不提供任何明示或默示的擔保及保證，包括但不限於特定目的之適銷性、未侵害任何他人權利、針對特定目的之適用性、其他關於交易或履約過程之默示保證；Appier亦不保證本服務，或依本規約提供之任何服務或平台，將永久可得、可存取、不受干擾、即時、或無錯誤。</p></li><li><p>Appier無須為（I）使用者之作業或傳輸疏失、中斷、刪除、錯誤或延遲；（II）通訊傳輸中斷或網路壅塞；（III）竊盜或其他不法行為；（IV）未經授權之使用或修改本服務；或（V）其他不可歸責於Appier之行為或原因對使用者負責。</p></li><li><p>除與本規約第7條所相關之事由外，對於基於使用契約之履約或未履約或因其而生之任何衍生性、間接、隨附、懲罰性或任何類型之特殊損害賠償，無論對方所蒙受之相關損害是否係基於違約、侵權 （包括但不限於重大過失），或任何責任理論 （包括但不限於所失利益、營業中斷或其他經濟損失），且無論相關當事人是否已獲悉相關損失或損害之可能性，任一當事人均無須向他方當事人負責。</p></li><li><p>就因本服務、或因任何使用（或未能使用）本服務或使用者內容而產生、或與前述事由相關之原因而致Appier應負任何責任時，Appier對使用者之賠償責任應以自相關請求發生時起回遡3個月內Appier實際自使用者受領之本服務使用費用之總額為上限。</p></li></ol><ol class=article start=16><li><p><strong>其他合規要求</strong></p></li></ol><ol><li><p>於應適用之範圍內，如使用者經Appier判斷屬於反社會勢力（係指黑社會組織、黑社會組織成員、右翼團体、反社會勢力、及其他與之相當者；下同。），或透過提供資金或其他方式協助、參與反社會勢力之維持、營運及經營等方式，與反社會勢力進行任何交流或有所牽連時，Appier得不經事前通知立即終止使用契約。</p></li><li><p>除前項所定情形之外，如確認使用者之董事、監察人、員工或其他成員、股東、交易往來對象或顧問為反社會勢力，或透過提供資金或其他方式協助、參與反社會勢力之維持、營運及經營等方式，與反社會勢力進行任何交流或有所牽連，如受Appier通知要求停止該等關係惟於相當期間內仍未能停止者，Appier得以書面通知使用者立即終止使用契約。</p></li><li><p>於應適用之範圍內，如使用者經Appier確認被列於OFAC之制裁名單內，則Appier得不經事前通知立即終止使用契約。</p></li><li><p>如使用契約依第16條約定遭終止，而導致使用者受有任何損害時，Appier概不負責；又使用者應賠償Appier因此所受之一切損害。</p></li></ol><ol class=article start=17><li><p><strong>有效期間</strong></p></li></ol><p>除雙方另有約定外，使用契約之有效期間應自AiDeal申請表單所載之開始日起生效，直到（i）AiDeal申請表單所載之結束日止，或（ii）任一方依本規約或AiDeal申請表單所載之約定終止使用契約時為止。</p><ol class=article start=18><li><p><strong>聯絡／通知</strong></p></li></ol><p>本服務相關諮詢及其他使用者對Appier之聯絡或通知、及其他Appier對使用者之聯絡或通知，應依本公司另定之方法為之。</p><ol class=article start=19><li><p><strong>轉讓</strong></p></li></ol><ol><li><p>使用者未經Appier書面事前同意，不得將其於使用契約上之地位或依本規約所生之權利或義務轉讓、移轉、設定擔保、為其他處分予第三人。</p></li><li><p>如Appier將本服務相關事業轉讓予其他公司，Appier得隨該營業讓與將Appier於使用契約上之地位、依本規約所生之權利及義務暨使用者註冊資訊或其他顧客資訊轉讓予該營業讓與之受讓人，使用者在此就該等轉讓表示同意。此外，本項所稱營業讓與，除一般營業讓與外，應包含公司分割及其他營業移轉等任何情形。</p></li></ol><ol class=article start=20><li><p><strong>可分性</strong></p></li></ol><p>使用契約之任一條款或部分內容如依應適用之法令等經判斷為無效或無法執行，其餘規定仍繼續具完整效力。</p><ol class=article start=21><li><p><strong>存續規定</strong></p></li></ol><p>依其性質，於必要之範圍內，第4條第3項、第5條、第6條、第7條、第8條第3項及第4項、第9條、第12條第2項及第3項、第 13 條至第 16條、及第18條至第 23 條之規定於使用契約終止後仍應有效存續。又縱有前開約定，第9條於使用契約終止後3年內應繼續有效。</p><ol class=article start=22><li><p><strong>準據法及管轄法院</strong></p></li></ol><p>使用契約應以Appier簽約主體所在地之法律作為準據法，但不適用其法律衝突之規定。</p><ol><li><p>如使用契約應以新加坡法為準據法，任何因使用契約所生或與其相關之一切爭議，包括但不限於其存在、有效性或終止（下稱「爭議」），應按新加坡國際仲裁中心當時有效之仲裁規定於新加坡進行仲裁，且該等仲裁規定應視為使用契約之一部分。除雙方當事人另有約定外，仲裁庭應由3名仲裁人組成。仲裁程序應以英文進行，且仲裁判斷將為拘束雙方當事人之終局判斷。</p></li><li><p>如使用契約應以日本法為準據法，所有爭議應以東京地方法院為第一審管轄法院。</p></li><li><p>如使用契約應以中華民國法律為準據法，所有爭議應以台北地方法院為第一審管轄法院。</p></li></ol><ol class=article start=23><li><p><strong>爭議解決</strong></p></li></ol><p>如於對本規約未盡事項或本規約之解釋生有疑義，Appier及使用者應先行相互遵循誠信原則進行協議，並盡速謀求解決。</p><p>【修訂：2020年11月15日】</p><p>【初版：2019年10月15日】</p>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1296 */
/***/ (function(module, exports) {

var path = '/templates/core/views/terms_of_service_appier_jp.html';
var html = "<h1 class=text-center>AiDeal利用規約</h1><p>本利用規約（以下「本規約」といいます）には、当社Appierのグループ会社（Appier側の締約者は申込フォーマット（下記第2条に定義）の記載に準じます）が提供するAiDealサービスの内容、及び当該サービスの利用にあたり、当社とユーザーの皆様との間の権利義務関係が定められております。本サービスの利用をお申し込みいただく方は、お申し込み前に、必ず全文お読み下さい。</p><ol><li><p><strong>適用範囲</strong></p></li></ol><ol><li><p>本規約は、本サービス（第 2 条に定義）の利用に関する当社とユーザー（第 2 条に定義）との間の権利義務関係を定めることを目的とし、ユーザーと当社の間の本サービスの利用に関わる一切の関係に適用されます。なお、当社のプライバシーポリシー（ <a href=\"https://www.appier.com/privacy-policy/\">https://www.appier.com/privacy-policy/</a> ，今後随時修正するバージョンを含む）は本規約の一部とみなします。当社は、当社の独自の裁量で、事前通知なしで本規約を随時変更もしくは改正できるものとします。ユーザーは、本サービスを利用し続けることにより、改定後の本規約に同意するとみなします。</p></li><li><p>当社が当社ウェブサイト（第 2 条に定義）上で随時掲載する本サービスに関するルール、諸規定等は本規約の一部を構成するものとします（当社ウェブサイトに掲載する本サービスに関するルール、「AiDealシリーズ料金表」、その他の諸規定等を含みます）。前記にかかわらず、申込フォーマットにて別途の約定があり、且つ本規約と齟齬がある場合、申込フォーマットに記載する約定を優先適用します。</p></li></ol><ol class=article start=2><li><p><strong>定義</strong></p></li></ol><p>本規約において使用する以下の用語は各々以下に定める意味を有するものとします。</p><ol><li><p>「閲覧者」とは、対象サイトもしくは対象アプリを閲覧する者を意味します。</p></li><li><p>「サービス利用料金」とは、第6条第1項に定める「サービス利用料金」を意味します。</p></li><li><p>「対象アプリ」とは、本サービスを利用するユーザーが有するモバイルアプリケーションを意味します。ただし、当該モバイルアプリケーションはユーザーが運営するビジネスに関連するものに限ります。</p></li><li><p>「対象サイト」とは、本サービスを利用するユーザーが有するウェブサイトを意味します。ただし、当該ウェブサイトはユーザーが運営するビジネスに関連するものに限ります。</p></li><li><p>「知的財産権」とは、著作権、特許権、実用新案権、商標権、意匠権その他の知的財産権(それらの権利を取得し、又はそれらの権利につき登録等を出願する権利を含む)を意味します。</p></li><li><p>「当社ウェブサイト」とは、当社が運営するメインドメイン「appier.com」に属するすべてのウェブサイトを意味します（理由を問わず、当社のウェブサイトのドメインもしくは内容が変更された場合は、当該変更後のウェブサイトを含みます)。</p></li><li><p>「本サービス」とは、当社が提供する“AiDeal”という名称が入っているサービスを意味します(理由を問わず、サービスの名称もしくは内容が変更された場合は、当該変更後のサービスを含みます)。当社は、当社の独自の裁量で、事前通知なしで本サービスの範囲や内容を随時変更できるものとします（本サービスの一部もしくは全部の機能変更もしくは提供中止を含むがこれらに限りません）。</p></li><li><p>「申込情報」とは、ユーザーが当社の定める様式の申込フォーマット（以下「申込フォーマット」といいます。）に記載し当社に提出した情報を指します。</p></li><li><p>「ユーザー」とは、当社との間で本サービスの利用契約を締結した個人又は法人を意味します。</p></li><li><p>「利用契約」とは、当社とユーザーの間で締結した申込フォーマット及び参照することにより組み込まれた本規約を指します。なお、ユーザーが欧州経済領域 （European Economic Area）またはいずれかの欧州委員会（European Commission）に認可された国に本サービスを利用する場合、本規約に添付されるデータ処理補足契約書 （Data Processing Addendum）（英語バージョンのみ）は利用契約の一部としてみなします。</p></li><li><p>「有効期間」とは、申込フォーマットに記載される開始日から終了日までの期間（自動更新期間（定めがある場合）を含む）を指します。</p></li></ol><ol class=article start=3><li><p><strong>申込情報の変更<br></strong></p></li></ol><p>ユーザーは責任をもって当社に提供する全ての情報が最新なものであることを保証すべきであり、申込情報もしくはそのほか本サービスのために提供した情報（例えば、アカウントに関するいかなる情報）に変更があった場合、ユーザーは滞りなく、当社の定める方法により、当該変更事項を当社に通知し、当社から要求された情報を提出するものとします。当該変更により、本規約に違反することとなると当社が判断した場合には、当社はいかなる責任も負わず、ユーザーとの本サービス利用契約を直ちに解約できるものとします。</p><ol class=article start=4><li><p><strong>ユーザーアカウントの管理</strong></p></li></ol><ol><li><p>ユーザーが正式に本サービスの利用を始める際に、ユーザーは当社の指示に従いユーザーアカウントを作る（ID及びパスワードの設定を含む）ものとします。</p></li><li><p>ユーザーはアカウントの管理及び保管に関する全責任を負うべきものとし、いかなる場合においても第三者にアカウントの利用を許し、またはアカウントを第三者に貸し、譲渡、売り渡すことをしてはなりません。</p></li><li><p>ユーザーは、ユーザーのアカウントに関する管理ミスもしくは過失（第三者による不正利用を含むがこれに限らない）により生じたすべての損害について責任を負うべきであり、且つ当社は前記の状況においてユーザーもしくはいかなる第三者に対し何らかの責任も負いません。</p></li><li><p>ユーザーの認識の有無を問わず、ユーザーは所有するアカウントのもとに行ったすべてのアクティビティについて全責任を負うものとします。アカウントの不正利用が発覚した場合、ユーザーは滞りなく当社に知らせるべきであり、且つ当社の指示に全面的に従うものとします。</p></li></ol><ol class=article start=5><li><p><strong>タグ及びSDKの利用</strong></p></li></ol><ol><li><p>ユーザーの本サービスへのアクセスを可能にするために、当社は関連するタグ及びソフトウエア開発キット（以下「SDK」という）を開発し、提供するものとします。ユーザーは各タグもしくはSDKを当社の指示に従い利用するものとします。本サービスの性質上、当社は随時各タグもしくはSDKを更新できるものとします。</p></li><li><p>ユーザーは本サービスを利用する目的のためにのみ各タグもしくはSDKを利用するものとします。ユーザーは各タグもしくはSDKを使って本サービスと競合するサービスまたは商品を作ってはなりません。</p></li></ol><ol class=article start=6><li><p><strong>サービス利用料金及び支払い</strong></p></li></ol><ol><li><p>ユーザーは、本サービス利用の対価として、申込フォーマットに記載された料金を（以下「サービス利用料金」といいます。）を負担し、当社に支払うものとします。当社は申込フォーマットにて振込情報をユーザーに提供します。ユーザーは、当社のリクエストに応じて、書面をもってユーザーの支払い情報（銀行口座の銀行コード、支店コード、口座の種別、口座番号および口座に記載された主たる口座保有者の氏名など）を当社に提供するものとします。</p></li><li><p>当社とユーザーの間に別途の書面による約定がある場合を除き、各月のサービス利用料金は各暦月の末日（本項のために「締め日」という）に基づき計算するものとし、ユーザーは締め日以降5営業日以内に支払額を確認し、同意しなければなりません。なお、利用契約が締め日以降、サービス利用料金の支払い前に解約された場合、ユーザーは解約前に発生したサービス利用料金を支払うべきものとします。疑義を避けるために明記すると、本サービスの開始日と最初の締め日の間の期間が一か月未満であり（例えばユーザーは1月15日より本サービスの利用を開始する場合、最初の締め日は1月31日になります）、且つユーザーがサービス利用料金の定額プランを適用する場合、当該月のサービス利用料金は比例計算されます。</p></li><li><p>ユーザーがサービス利用料金の支払を遅滞した場合、ユーザーは年14.6%の割合による遅延損害金を当社に支払うものとします。</p></li><li><p>ユーザーは利用契約の約定に基づき解約することができます。但し、当社はいかなる場合であっても、解約前に既にユーザーから当社へ支払われたサービス利用料金を返還する義務を負わないものとします。</p></li></ol><ol class=article start=7><li><p><strong>知的財産権の所有権について</strong></p></li></ol><ol><li><p>本サービスに関連する知的財産権（当社が開発しかつ発行するタグもしくはSDKに関連するものを含むがこれらに限らない）はいつでも当社または／及び当社のライセンサーが所有するものとします。本規約に定めがある場合を除き、本サービスの利用への承諾は、いかなる場合においても当社または当社のライセンサーが有する知的財産権に関するライセンスの許諾としてみなしてはなりません。ユーザーは当社または当社のライセンサーが有する知的財産権を侵害するまたは侵害する恐れがあるいかなる行為もしてはなりません（逆アセンブル、逆コンパイル、リバースエンジニアリングを含みますが、これに限定されません）。</p></li><li><p>ユーザーは全てのコンテンツ及び素材（テキスト、デザイン、画像、及び／またはいかなるユーザーが当社に提供する、またはユーザーが直接に本サービスのプラットフォームにアップロードする広告素材や、当社がユーザーの指示のもとに用意するいかなる素材を含むがこれらに限らない）（以下まとめて「コンテンツ」という）について全責任を負うものとします。ユーザーは、ユーザーが本サービスを利用する際に前記のコンテンツを活用、提供、アップロードするために要する全ての権利を有することを、当社に保証します。なお、ユーザーは、ユーザーがいかなるコンテンツを提供すること、及び当社がそれらを利用することは（1）いかなる第三者の知的財産権に対する侵害または濫用にならないこと、また（2）適用すべきいかなる法律にも違反しないことを、当社に対し保証します。</p></li><li><p>ユーザーのために当社が作るコンテンツ、及び／またはユーザーが当社に提供するコンテンツに関する知的財産権はいつでもユーザーおよびユーザーのライセンサーが所有するものとします。ユーザーは、当社に使用を限定する非専属的、撤回不能な、世界全域で有効な,ロイヤリティフリー、譲渡可能なライセンスを付与するとともに、当社に本サービを提供するための範囲内にコンテンツを再授権、アクセス、閲覧、複製、修正、公開表示、及び配布する権利も付与するものとします。</p></li><li><p>当社事前の書面による同意を得た場合を除き、ユーザーはいかなる方法で当社の社名、商標、ロゴ、またはそのほかの専有情報をいかなる目的のために利用または表示することはできません。</p></li></ol><ol class=article start=8><li><p><strong>ユーザーの責務</strong></p></li></ol><ol><li><p>ユーザーが本サービスの提供を受けるために必要な、コンピューター、ソフトウェアその他の機器、通信回線その他の通信環境等の準備及び維持は、ユーザーの費用と責任において行うものとします。</p></li><li><p>ユーザーは、当社が合理的な要請をした場合、当社が別途で書面をもって提供する事項（もしある場合）を対象サイトまたは対象アプリのプライバシーポリシーに記載し、閲覧者に対して当該プライバシーポリシーが容易に閲覧可能な状態にしなければなりません。</p></li><li><p>ユーザーは、ユーザーが本サービスを利用できるように、適用すべき法律（例えば、個人情報保護に関する法律や規定）において必要とする閲覧者の同意をユーザーの責任で取得すべきことを、理解しています。ユーザーは、当社が、有効期間内に閲覧者に対し適用するユーザーの規約及びポリシー（プライバシーポリシーを含む）その他の規則等（以下「ユーザー規約等」という）を変更するよう合理的に求める場合、当社が定める期間内にこれに応じるものとします。ユーザーと閲覧者との間で生じた取引、連絡、紛争等（ユーザー規約等に起因するものを含むが、これに限らない）について、当社はいかなる責任も負わないものとし、ユーザーは自己の責任と費用においてこれらを解決するものとします。</p></li><li><p>利用契約が解約された場合、ユーザーは、当社の指示に従い、対象サイト、対象アプリまたはユーザーの端末（もし適用であれば）からすべてのタグもしくはSDKを削除し、外さなければなりません。ユーザーが対象サイト、対象アプリまたはユーザーの端末（もし適用であれば）から全てのタグもしくはSDKを削除または外さなかったなどの場合、ユーザーは、当社が利用契約の解約以降に行ったタグもしくはSDKの変更及び／または無効化によりユーザーが被ったいかなる損害に対し、当社はいかなる責任も負わないものとします（対象サイトまたは対象アプリに生じるエラーを含みますがこれらに限りません）。</p></li></ol><ol class=article start=9><li><p><strong>機密情報</strong></p></li></ol><ol><li><p>「機密情報」とは、本サービに関連していずれか一方の当事者（以下「開示当事者」という）を他方当事者（以下「受領当事者」という）に開示するいかなる情報及び／または資料であり（開示当事者の現在または将来のビジネス運営計画、財務状況、マーケティング活動、または技術関連情報を含むがこれらに限らない）、且つ開示当時に機密情報であることを明記し、もしくは開示時の状況または開示された情報の性質を鑑み、受領当事者が当該情報を機密情報として認識することが合理的であると考えるものを指します。機密情報は、以下のものを含みますがこれらに限りません：（i）情報開示当時、情報を記載している媒体や形態を問わず、「機密」もしくは類似な文字を記載されているすべてのもの、及び（i i）実務上、善意的な情報受領者が機密として認識する全ての情報。</p></li><li><p>前項にかかわらず、次のいずれかに該当する場合、当該情報は機密情報に該当しません：（i）受領当事者が開示当事者から情報を受領する前にすでに公開情報となったもの、または受領当事者がすでに知悉しまたは取得したもの。（ii）開示当事者により情報開示を受けた以降、受領当事者の責に帰すべきではない事由により公開情報になったもの、または受領当事者の責に帰すべきでない事由により受領当事者が別途で知らされた情報。（iii）受領当事者が合法的に秘密保持義務を有しない第三者から知悉しまたは取得したもの。（iv）受領当事者が機密情報を参考することなく独自に開発したもの。</p></li><li><p>本規約の約定は、いずれか一方の当事者が、いかなる裁判所命令、法律規程、法執行や類似する要請や調査等に従って他方当事者の機密情報を開示することを妨げません。ただし、前記の約定に基づき機密情報を開示する前に、受領当事者は合理的な努力をもって（i）速やかに書面をもって開示当事者に開示要請について知らせるものとし、なお（ii）開示当事者に協力し、当該開示要請を拒否しもしくは最小限にとどまるようにつとめ、または秘密保持命令を取得するものします。</p></li><li><p>受領当事者は、機密情報の同意されていない開示は、開示当事者にとって金銭的損害賠償も補えない実質的な損害をもたらすことを理解しているものとします。従って、受領当事者が同意を得ることなく機密情報を開示した場合、開示当事者は適用すべき法律に基づき差し止めまたはそのほか公正とされる救済、及びすべて可能な賠償を受ける権利を有します。</p></li></ol><ol class=article start=10><li><p><strong>禁止行為</strong></p></li></ol><p>ユーザーは、本サービスを利用する際に、以下に定めた行為のいずれも行ってはなりません。当社の裁量で、ユーザー、対象サイトまたは対象アプリが下記条項のいずれかに該当する（または該当する恐れがある）と当社が認める場合、当社はユーザーに対し本サービスを一時停止し、及び／またはいかなる責任も負わず利用契約を解約する権利を有するものとします。</p><ol><li><p>当社またはいかなる第三者が有する知的財産権、肖像権、プライバシーに関する権利、名誉またはそのほかの権利や利益を侵害すること（直接的及び間接的な侵害行為を含みますがこれらに限りません）。</p></li><li><p>逆アセンブル、復号、逆コンパイル、リバースエンジニアリング及び／またはそのほかの方法で、当社が本サービスを提供するために使っているソフトウエアのソースコードの解明を試みること。</p></li><li><p>適用すべき法律または規定に違反し、犯罪を行い、または公序良俗に反する行為を行うこと。</p></li><li><p>虚偽の情報または不適切なコンテンツ（違法なセクシュアル、猥褻や暴力に関連する情報を含みますがこれらに限りません）を提供すること。</p></li><li><p>コンピューター・ウイルスその他の有害なコンピューター・プログラムを含む情報を送信すること。</p></li><li><p>当社の運営（本サービスの提供を含むがこれに限らない）を妨害するおそれがある行為をすること。</p></li><li><p>当社が提供しているタグまたは／及びSDKを利用して、対象サイト／対象アプリ以外の特定サイト／アプリを閲覧する者に対し購買インセンティブ（クーポンの発行、割引の実施及び景品の配布を含むが、これらに限られない）を恣意に与えること。</p></li><li><p>その他、当社が当社の裁量で不適切であると判断する行為。</p></li></ol><ol class=article start=11><li><p><strong>本サービスの中止</strong></p></li></ol><ol><li><p>下記いずれかの状況に該当する場合、当社は本サービスの一部または全部を、ユーザーに対し事前に通知することなく、一時停止または中止できるものとします。</p><ol><li><p>本サービスに係るコンピューター・システムの点検又は保守作業を緊急に行う場合。</p></li><li><p>コンピューター、通信回線等が事故により一時停止した場合。</p></li><li><p>火災、停電、天災地変などの不可抗力により本サービスの運営ができなくなった場合。</p></li><li><p>その他、当社が停止又は中止を必要と判断した場合。</p></li></ol></li><li><p>本条に基づき当社が行った措置によりユーザーに生じた損害について、当社は一切の責任を負わないものとします。</p></li></ol><ol class=article start=12><li><p><strong>解約</strong></p></li></ol><ol><li><p>ユーザーが下記いずれかの状況に該当する場合、当社は、事前通知なく、本サービスを一時停止しもしくは利用契約を解約できるものとします。</p><ol><li><p>本規約のいずれかの約定に違反した場合。</p></li><li><p>申込情報に虚偽の記述が含まれたことが判明した場合。</p></li><li><p>適用すべき法律に基づき、支払停止若しくは支払不能となり、又は破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始若しくはこれらに類する手続の開始の申立てがあった場合。</p></li></ol></li><li><p>前項各号のいずれかの事由に該当した場合、ユーザーは、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務の支払を行わなければなりません。</p></li><li><p>当社は、本条に基づき当社が行った行為によりユーザーに生じた損害について一切の責任も負わないものとします。</p></li><li><p>ユーザーは、当社に対し事前に書面をもって通知することにより、申込フォーマットに記載された手順に従って（定めがある場合）各暦月の末日に利用契約を解約できるものとします。</p></li></ol><ol class=article start=13><li><p><strong>利用契約に関する違約責任</strong></p></li></ol><p>ユーザーが利用契約に定められた義務を履行しないまたは契約の約定に違反することにより、Appierに損害が生じ、または第三者からの請求を受けた場合、ユーザーはAppierにすべて必要な協力を提供し、Appierが被ったすべての損害（弁護士費用及び訴訟費用を含むがこれに限らない）を賠償するものとします。</p><ol class=article start=14><li><p><strong>保証</strong></p></li></ol><ol><li><p>当社はユーザーに対し下記の通りに声明し、保証します：(a) 当社は、利用契約を締結し、その義務を履行する十分な権利及び権限を有すること。(b)当社は、利用契約に基づきその義務を履行することは、当社が締結したほかの約定に違反しないこと。(c)利用契約は署名されることにより、当社に効力を生じ、合法的なかつ拘束力を有すること。</p></li><li><p>ユーザー当社に対し下記の通りに声明し、保証します：(a) ユーザーは、利用契約を締結し、その義務を履行する十分な権利及び権限を有すること。(b) ユーザーは、利用契約に基づきその義務を履行することは、当社が締結したほかの約定に違反しないこと。(c)利用契約は署名されることにより、ユーザーに効力を生じ、合法的なかつ拘束力を有すること。(d)ウイルス、ワーム、クラックプログラム、BOT、電子設備、コンピュータープログラムまたはそのほかの不正方法を利用し、本サービスに対しての妨げ、侵入、損害、変更または逆コンパイルをしないこと。(e)本サービスに対してのリバースエンジニアリング、もしくは本サービスのソースコードに対しての変更をしないこと。(f)いかなる時も反社会的勢力（以下に定義）に該当しないこと。(g)いかなる時も米国財務省外国資産管理局の制裁リスト（United States’ Office of Foreign Assets Control Sanctions List）に含まれないこと。</p></li><li><p>ユーザーは、本サービスを利用することが、ユーザーに適用のある法令、業界団体の内部 規則等に違反するか否かを自己の責任と費用に基づいて調査するものとし、当社は、ユーザーによる本サービスの利用が、ユーザーに適用のある法令、業界団体の内部規則等に適合することを何ら保証するものではありません。</p></li><li><p>本サービスに関連してユーザーと第三者との間において生じた取引、連絡、紛争等については、ユーザーの責任において処理及び解決するものとし、当社はかかる事項について一切責任を負いません。</p></li><li><p>当社は、当社による本サービスの提供の中断、停止、終了、利用不能又は変更、本サービスの利用によるデータの消失又は機器の故障若しくは損傷、その他本サービスに関連してユーザーが被った損害について、賠償する責任を一切負わないものとします。</p></li></ol><ol class=article start=15><li><p><strong>保証の否認及び免責</strong></p></li></ol><ol><li><p>本サービスは「現状」及び「現在明示的な条件の下」で提供するものとします。当社は、本サービスについて、いかなる明示的なまたは黙示的な担保及び保証（特定目的における商品性、侵害の不存在、特定目的への適合性、そのほかの取引または契約履行のプロセスに関する黙示的な保証を含むがそれらに限らない）も行わず、それらの保証を明示的に否認します。また、当社は、本規約により提供する本サービスまたはプラットフォームが常に利用可能であり、アクセス可能であり、中断されず、時宜にかなっており、安全であること、もしくはエラーなく運用されることを保証しない。</p></li><li><p>当社は、ユーザーに対し、次のいずれかの事由において一切の責任も負わないものとします：(I)ユーザーの作業または転送ミス、中断、削除、エラーまたは遅延。(II) 通信転送の中断またはネットワークの混雑。(III)窃盗またはそのほか違法行為。(IV) 許諾なく本サービスを使用し、または変更すること。(V) そのほか当社の責に帰すべきではない行為または事由。</p></li><li><p>本規約第7条を除き、利用契約に基づく契約の履行、不履行またはそれらにより生じるいかなる派生的、間接的、付随的、懲罰的またはいかなる性質の特殊損害賠償について、いずれかの当事者は、相手方に対し、相手方が被る関連の損害が契約違反、不法行為（重大過失を含むがそれに限らない）、またはいかなる責任理論（逸失利益、営業中断またはその他の経済的損失を含むがそれらに限らない）によるものか否かを問わず、且つ当該当事者が関連する損失または損害の可能性について知っているか否かも問わず、責任を負わないものとします。</p></li><li><p>いかなる場合においても、利用契約から生じたもしくは関連する損害、または本サービスやコンテンツを利用すること、利用できなかったことに関する争議について、当社が負う賠償責任は損害の事由が生じた時点から遡って3ヶ月以内にユーザーから現実に受領した本サービス利用料金の総額を上限とします。</p></li></ol><ol class=article start=16><li><p><strong>コンプライアンス</strong></p></li></ol><ol><li><p>適用される法律に従って、ユーザーが反社会的勢力等(暴力団、暴力団員、右翼団体、反社会的勢力、また適用すべき日本法律や規定に基づき、その他これに準ずる者を意味します。以下同じ。)であり、又は資金提供その他を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する等反社会的勢力等との何らかの交流若しくは関与を行っていると当社が判断した場合、当社は、ユーザーに対し事前通知することなく、直ちに利用契約を解約することができます。</p></li><li><p>前項の約定に加え、ユーザーの取締役、監査役、従業員その他の構成員、株主、取引先、若しくは顧問その他のアドバイザーが反社会的勢力等であること、又は資金提供その他を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する等反社会的勢力等との何らかの交流若しくは関与を行っていることが判明した場合において、その解消を求める当社からの通知を受領後相当期間内にこれが解消されないときは、当社は、ユーザーに書面で通知することにより直ちに利用契約を解約できるものとします。</p></li><li><p>適用される法律に従って、ユーザーが米国財務省外国資産管理局の制裁リストに含まれたと当社が判断した場合、当社は、ユーザーに対し事前通知することなく、直ちに利用契約を解約することができます。</p></li><li><p>利用契約がこの第16条に従って解約された場合、当社は、ユーザーがこれにより被ったいかなる損害についても賠償責任を負わないものとし、ユーザーは当社がこれにより被られたいかなる損害について賠償しなければならないものとします。</p></li></ol><ol class=article start=17><li><p><strong>契約有効期間</strong></p></li></ol><p>双方当事者が別途で合意した場合を除き、利用契約の有効期間は、申込フォーマットに記載された開始日より、(i) 申込フォーマットに記載された終了日、または(ii)いずれかの当事者が本規約や申込フォーマットの約定に従って利用契約を解約した日（適用可能であれば）までとします。</p><ol class=article start=18><li><p><strong>連絡および通知</strong></p></li></ol><p>本サービスに関する問い合わせその他ユーザーから当社に対する連絡又は通知、及びその他当社からユーザーに対する連絡又は通知は、当社が別途での定める方法で行うものとします。</p><ol class=article start=19><li><p><strong>契約上の地位譲渡等</strong></p></li></ol><ol><li><p>ユーザーは、当社の書面による事前の承諾なく、利用契約上の地位又は本規約に基づく権利若しくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。</p></li><li><p>当社は本サービスにかかる事業を他社に譲渡した場合には、当該事業譲渡に伴い利用契約上の地位、本規約に基づく権利及び義務並びにユーザーの登録情報その他の顧客情報を当該事業譲渡の譲受人に譲渡することができるものとし、ユーザーは、かかる譲渡につき本項において予め同意したものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。</p></li></ol><ol class=article start=20><li><p><strong>分離可能性</strong></p></li></ol><p>利用契約のいずれかの条項又はその一部が、適用すべき法律等により無効又は執行不能と判断された場合、 その残りの約定は、継続して完全に効力を有します。</p><ol class=article start=21><li><p><strong>存続規定</strong></p></li></ol><p>各条項の性質に応じて必要な範囲内に、第4条第3項、第5条、第6条、第7条、第8条第3項及び第4項、第9条、第12条第2項及び第3項、第13条から第16条、第18条から第23条までの規定は利用契約の終了後も有効に存続するものとします。前記にかかわらず、第9条は利用契約終了以降3年以内に効力を有するものとします。</p><ol class=article start=22><li><p><strong>準拠法及び管轄</strong></p></li></ol><p>利用契約は、当社の締約する法人の所在地の法律に準拠し、解釈されるものとします。ただし法の抵触の原則は適用しないものとします。</p><ol><li><p>利用契約がシンガポールの法律に準拠する場合、利用契約に起因もしくは関連して生じるいかなる問題もしくは争議（契約の存在、有効性または解約等を含む）（以下「<strong>争議</strong>」という）は、シンガポールにおける仲裁に付託され、最終的に同仲裁により解決されるものとします。なお同仲裁は、当該時点において効力を有しているシンガポール国際仲裁センター（Singapore International Arbitration Centre）の仲裁規則に従って行われるものとします。双方当事者が別途の書面による約定をした場合を除き、仲裁廷は3人の仲裁人により構成されるものとします。仲裁手続きは英語にて行います。当該仲裁裁定は、最終的なものとして両当事者を拘束します。</p></li><li><p>利用契約が日本の法律に準拠する場合、すべての争議について東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p></li><li><p>利用契約が台湾（中華民国）の法律に準拠する場合、すべての争議について台北地方裁判所を第一審の専属的合意管轄裁判所とします。</p></li></ol><ol class=article start=23><li><p><strong>紛争解決</strong></p></li></ol><p>当社及びユーザーは、本規約に定めのない事項又は本規約の解釈に疑義が生じた場合には、互いに信義誠実の原則に従って協議の上速やかに解決を図るものとします。</p><p>【改訂：2020年11月15日】</p><p>【初出：2019年10月15日】</p>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

var path = '/templates/core/views/terms_of_service_appier_others.html';
var html = "<h1 class=text-center>AiDeal Terms of Service</h1><p>These Terms of Service (hereafter referred to as these “Terms”) refer to the AiDeal service provided by Appier’s group entities (the contracting party from Appier shall be determined in the Application Form (as defined in Article 2)) and specify the rules to be complied as well as the rights and obligations between Appier and the user. The User shall read the content of these Terms thoroughly before applying to use the Services.</p><p class=article><strong>Article 1 Scope</strong></p><ol><li><p>The purpose of these Terms is to stipulate the rights and obligations related to the use of the Services (as defined in Article 2) between Appier and the User (as defined in Article 2) and shall be applicable to all relationship between the User and Appier with regard to the use of the Services. Appier’s Privacy Policy (<a href=\"https://www.appier.com/privacy-policy/\">https://www.appier.com/privacy-policy/</a>, including all the amendments made available at anytime as applicable in the future) is also incorporated as part of these Terms by reference. Appier may amend and revise these Terms from time to time without prior notice at Appier’s sole discretion. The User hereby agrees that, if the User continues its use of the Services, the User is indicating its agreement to the amended Terms.</p></li><li><p>All relevant rules and regulations related to the Services posted on Appier Website (as defined in Article 2) shall constitute part of these Terms (including relevant rules and regulations related to the Services posted on Appier’s Website, AiDeal Fee Schedule, and other relevant rules). However, if it is otherwise agreed in the Application Form and is inconsistent with these Terms, the terms provided in the Application Form shall prevail.</p></li></ol><p class=article><strong>Article 2 Definition</strong></p><p>The terms used in these Terms shall have the following meaning:</p><ol><li><p>“Viewers”: refers to the person(s) that browse the Designated Website and/or Designated Application.</p></li><li><p>“Service Fees”: refers to the “Service Fees” as defined in Paragraph 1 of Article 6.</p></li><li><p>“Designated Application”: refers to the User’s mobile application that uses the Services, provided that such mobile application shall be related to businesses operating by the Users.</p></li><li><p>“Designated Website”: refers to the User’s website that uses the Services, provided that such website shall be related to businesses operating by the Users.</p></li><li><p>“Intellectual Property Rights”: refers to copyrights, patents, utility model patents, trademarks, design patents as well as other intellectual property rights (including the rights to obtain or apply for registration of such rights).</p></li><li><p>“Appier Website”: refers to website(s) operated by Appier under the main domain “appier.com” (in the event that Appier changes the domain and/or contents in its website(s) for any reason, such website(s) shall also be included).</p></li><li><p>“Services”: refers to the services provided by Appier with the name of “AiDeal” (in the event that the Services changes its name or contents for any reason, such changed services shall also be included). Appier may change the scope of the Services (including but not limited to modify the functions or discontinue all or part of the Services) from time to time without prior notice, at Appier’s sole discretion.</p></li><li><p>“Application Information”: refers to the information filled in by the User in the standard application form (hereafter referred to as the “Application Form”) prepared by Appier and submitted to Appier thereafter.</p></li><li><p>“User”: refers to the individual or entity that entered into the Services Agreement with Appier for the Services.</p></li><li><p>“Services Agreement”: refers to the Application Form entered between Appier and the User which these Terms are incorporated by reference. If the User will use the Services in the European Economic Area or any European Commission approved country, the Data Processing Addendum attached to these Terms shall be deemed as a part of the Services Agreement.</p></li><li><p>“Effective Term”: refers to the period starts from the starting date to the end date (including the renewal period, as applicable) stated in the Application Form.</p></li></ol><p class=article><strong>Article 3 Change of Information</strong></p><p>The User shall be responsible to keep all the information provided to Appier up to date, and notify Appier of changes made to the Application Information and/or other information provided to the Service (e.g., any information relating to the Account) without delay via methods determined by Appier and submit necessary information as requested by Appier. In the event that Appier determines that any changes to User’s information will result in violating these Terms, Appier may notify the User regarding the violation and terminate the Services Agreement immediately without any liability.</p><p class=article><strong>Article 4 Management of User’s Account</strong></p><ol><li><p>Once the User successfully enrolled in the Services, the User shall follow Appier’s guidance to create User’s account (\"Account\") with ID and password.</p></li><li><p>The User shall be solely responsible for the management and safekeeping of the Account, and shall in no event authorize any third party to use, or lend, transfer, assign or sell the same to any third party.</p></li><li><p>The User shall be responsible for any damages caused by User’s mismanagement (including but not limited to intended or negligence conducts) relating to the Account (including but not limited to unauthorized use made by any third party), and Appier shall in no event be held liable to User and/or any third party under such event.</p></li><li><p>The User shall be responsible for all activities that occur under such Account, regardless that whether the User is aware about such activities. The User shall notify Appier without delay of any unauthorized use of the Account and fully comply with Appier’s instructions thereafter.</p></li></ol><p class=article><strong>Article 5 Use of Tags and SDK</strong></p><ol><li><p>For the purpose to allow the User to access the Service, Appier has developed and provides relevant tags (“<strong>Tags</strong>”) and software development kit (“<strong>SDK</strong>”). The User shall only use each Tag and/or SDK in accordance with Appier’s any and all instructions. Given the nature of the Services, Appier may update the Tags and/or SDK from time to time.</p></li><li><p>The User shall only use the Tags and/or SDK only for the purpose to use the Services. The User shall not use the Tags and/or SDK to build any service or product that will compete with the Services.</p></li></ol><p class=article><strong>Article 6 Service Fees and Payment</strong></p><ol><li><p>As consideration for the use of the Services, the User shall pay Appier the fees specified in the Application Form (hereafter referred as to the “Service Fees”). Appier will provide payment collecting information in the Application Form for User’s handling, and, as required by Appier, the User shall notify Appier in writing of User’s payment information (e.g., bank code, branch code, type of account, account number and name of the main account holder specified on the bank account).</p></li><li><p>Unless otherwise agreed by Appier and the User with prior writing, the monthly Service Fees shall be calculated at the last day of each calendar month (for the purpose of this paragraph, the “<strong>Record Date</strong>”), and the User shall confirm and agree with the payment amount within the next five (5) working days. In addition, in the event that the Services Agreement is terminated after the Record Date but prior to its payment of the Service Fees, the User shall still be obligated to pay the Service Fees incurred prior to the termination of the Services Agreement. For avoidance of doubt, when the period between the starting date of the Services to the first Record Date is less than one month (e.g., the User started to use the Services from 15 January, which the first Record Date is 31 January) and the User is subject to monthly fixed fee plan, then the Service Fee will be calculated on pro-rata basis.</p></li><li><p>In the event that the User delays payment of the Service Fees, the User shall borne an annual interest rate of 14.6% (or the highest rate allowed by applicable law, whichever is lower) as compensation to Appier for delay damages.</p></li><li><p>User may terminate the Services Agreement pursuant to the terms and conditions therein, providing that in no event shall Appier be obligated to refund the Service Fees paid by the User to Appier prior to the termination.</p></li></ol><p class=article><strong>Article 7 Ownership of Intellectual Property Rights</strong></p><ol><li><p>The ownership of the Intellectual Property Rights in the Services (including but not limited to Tags / SDK issued and developed by Appier) shall at all time belong to Appier and/or Appier’s licensor(s). Unless otherwise expressly provided in these Terms, the consent to allow the use of the Services does not constitute the grant of license regarding the Intellectual Property Rights of Appier or its licensor from any aspect. User shall not act in any way that infringes or may infringe the Intellectual Property Rights of Appier or its licensor (including but not limited to disassembly, de-compilation and reverse engineering).</p></li><li><p>User shall be fully responsible for all the content and material (including but not limited to text, designs, images, and/or any other advertising materials provided by User to Appier or uploaded to the Services’ platform directly by User, or any materials prepared by Appier under User’s instructions) (collectively, the “Contents”), and the User herby warrants that it has all rights that are required for User to utilize, provide, upload such Contents during its use of the Services. User shall also warrant and represent that any Content provided by User and Appier’s usage thereof will not infringe, misappropriate or violate any third party’s Intellectual Property Rights, or result in violating any applicable laws.</p></li><li><p>The Intellectual Property Rights in the Content created for the User by Appier, and/or provided by the User to Appier, shall at all time belong to the User and/or its licensor(s). User hereby grant to Appier a limited, non-exclusive, irrevocable, worldwide, royalty-free, transferable license, with the rights to sublicense, access, view, use, copy, modify, publicly display and distribute such Content to the extent required to provide the Services.</p></li><li><p>The User shall not in any way use or display Appier’s name, trademark, logo or other proprietary information for whatever purpose without Appier’s prior written notice.</p></li></ol><p class=article><strong>Article 8 Users’ other Responsibilities and Obligations</strong></p><ol><li><p>The User shall be responsible and at its own cost to prepare and maintain the computer, software, other equipment, communication lines as well as other internet environments which are necessary to receive the Services.</p></li><li><p>When reasonably requested by Appier, the User shall incorporate the matters provided by Appier in writing (if any) separately into its privacy policy applicable to the Designated Website and/or the Designated Application, and such privacy policy shall be made easily accessible to the Viewers.</p></li><li><p>User understands and acknowledges that, it shall be fully responsible to obtain Viewers’ consent as required under applicable laws (e.g., personal data protection relating laws and regulations) that will enable the User to use the Services. In the event that Appier reasonably requests the User to change User’s terms of service, policies (including privacy policy) or other rules of the User (hereafter referred to as the “User Rules”) applicable to the Viewers during the Effective Term, the User shall fulfill such request within the period as specified by Appier. In no event shall Appier be responsible for any transaction, communication or dispute (including but not limited to those arise from the User Rules) between the User and the Viewers. The User shall solve such issues with its own responsibility and at its own cost.</p></li><li><p>Upon the termination of the Services Agreement, the User shall delete and remove all the Tags and/or SDK from the Designated Website and/or Designated Application and all User’s devices (as applicable) per Appier’s instruction. The User hereby acknowledges that, including but not limited to the event that the User fails to delete and remove the Tags and/or SDK from the Designated Website and/or Designated Application and all User’s devices (as applicable), Appier in no event will be held liable for any damages suffered by the User in relation to or arise from Appier’s modification and/or invalidation of the Tags and/or SDK which take place after the termination for the Services Agreement (including but not limited to errors in the Designated Website and/or Designated Application).</p></li></ol><p class=article><strong>Article 9 Confidential Information</strong></p><ol><li><p>Confidential Information means all and any information and/or materials disclosed by a party (“Disclosing Party”) to the other party (“Receiving Party”) in relation with the Services, including but not limited to those relating to Disclosing Party’s current or future business operation, finance status, marketing activities or technical information, provided that such information is identified as confidential at the time of disclosure or should be reasonably known by the Receiving Party to be confidential or proprietary given the nature of the information disclosed and the circumstances relating to the disclosure. Confidential Information also includes, but not limited to, (i) all the information disclosed contained in material of whatever nature and/or formats of any kind, which is affixed with “confidential” or other wordings alike when being disclosed; and (ii) all the information which in practice a receiving party with good faith will consider it as confidential.</p></li><li><p>Notwithstanding the preceding paragraph, information which falls within any following scope shall not be viewed as Confidential Information: (i) information that is already in the public domain or already known to the Receiving Party at the time it is provided or disclosed by the Disclosing Party; (ii) information that becomes available in public domain through publication or other means after being disclosed by the Disclosing Party or being known by Receiving Party due to reasons not attributable to Receiving Party; (iii) information that is received lawfully from a third party who has the rights to provide or disclose such information without breach of confidentiality obligation; and (iv) information that is independently developed by the Receiving Party without reference to the Confidential Information.</p></li><li><p>Nothing herein shall prevent a party from disclosing the other party’s Confidential Information as necessary pursuant to any court order or any legal, regulatory, law enforcement or similar requirement or investigation; provided, prior to any such disclosure, the Receiving Party shall use reasonable efforts to (i) promptly notify the Disclosing Party in writing of such requirement to disclose and (ii) cooperate with the Disclosing Party in protecting against or minimizing any such disclosure or obtaining a protective order.</p></li><li><p>The Receiving Party acknowledges that unauthorized disclosure of Confidential Information would cause substantial harm for which monetary damage compensation alone would not be a sufficient remedy. Therefore, upon Receiving Party’s unauthorized disclosure of Confidential Information, the Disclosing Party will be entitled to injunctive or other equitable relief along with any available remedies under applicable laws.</p></li></ol><p class=article><strong>Article 10 Prohibited Action</strong></p><p>User is prohibited from taking any action as listed below when using the Services. If, at Appier’s sole discretion, it is determined that the User or the Designated Website / Designated Application falls within (or may fall within) any of the following scope, Appier has the right to suspend its Services to such User and/or terminate the Services Agreement without any liability.</p><ol><li><p>Infringement of Intellectual Property Rights, portrait rights, privacy rights, reputation or other rights or interests owned by Appier or any other third party (including but not limited to direct or indirect infringement);</p></li><li><p>Attempt to conduct disassembly, decipherment, de-compilation, reverse engineering and/or other methods to derive the source code regarding any software used by Appier to provide the Services.</p></li><li><p>Violation of applicable laws or regulations, conduct criminal acts or violation of public order or good morals.</p></li><li><p>Distribute untrue information or other inappropriate contents, including but not limited to illegal sexual, obscene and violence relating information.</p></li><li><p>Transmission of information containing computer virus or other harmful computer programs.</p></li><li><p>Actions which may possibly interfere Appier’s operation (including but not limited to the operation of the Services).</p></li><li><p>Use the Tags and/or SDK provided by Appier to arbitrary provide purchase incentives (including but not limited to issuance of coupons, discounts and provision of gifts) to viewers who browse a specific website / application other than the Designated Website / Designated Application.</p></li><li><p>Any other inappropriate action as determined by Appier at its sole discretion.</p></li></ol><p class=article><strong>Article 11 Suspension of the Services</strong></p><ol><li><p>Under any of the following events, Appier may suspend or cease the Services in whole or in part without prior notice to the User:</p><ol><li><p>Emergency inspection or maintenance of the computer systems related to the Services.</p></li><li><p>Suspension due to accidents relating to computer or communication lines.</p></li><li><p>The Services cannot be operated due to force majeure events such as fire, power failure, and natural disaster.</p></li><li><p>Other circumstances where suspension or cease of Services is necessary as determined by Appier.</p></li></ol></li><li><p>Appier shall not be held liable for any damages caused to the User by actions taken by Appier pursuant to this Article 11.</p></li></ol><p class=article><strong>Article 12 Termination</strong></p><ol><li><p>In the event that the User falls within the scope of any following events, Appier may suspend the Services and/or terminate the Services Agreement without any prior notice.</p><ol><li><p>Breach of any provision of these Terms.</p></li><li><p>False statement is found in the Application Information.</p></li><li><p>Under the applicable laws, the User suspends its payment or becomes insolvency, or is subjected to the commence of bankruptcy, civil rehabilitation, corporate reorganization, special liquidation or other similar procedures.</p></li></ol></li><li><p>In the event that the Users falls within the scope of any of the events provided in the preceding paragraph, the User shall lose its benefit of time with respect to all outstanding payments and shall pay Appier the full amount of all outstanding payment(s) immediately.</p></li><li><p>Appier shall in no event be held liable for the damages suffered by the User due to Appier’s action taken under this Article.</p></li><li><p>The User may terminate the Services Agreement on an end date of a calendar month with a prior written notice to Appier following the step designated in the Application Form (as applicable).</p></li></ol><p class=article><strong>Article 13 Liability for Breaching the Services Agreement</strong></p><p>If the User fails to perform or breaches its obligations under the Services Agreement, and thus cause damages to Appier or result in other third party’s claim against Appier, the User shall provide any and all necessary assistance to Appier, and be liable to compensate all the damages suffered by Appier, including but not limited to attorney fees and litigation fees.</p><p class=article><strong>Article 14 Warranties</strong></p><ol><li><p>Appier hereby warrants and represents that (a) it has full corporate right, power and authority to enter into the Services Agreement and to perform the acts required of it hereunder; (b) the execution of the Services Agreement by Appier, and the performance of its obligations and duties hereunder, do not and will not violate any agreement to which it is bound, and (c) it will be bound by the Services Agreement upon the execution of the same.</p></li><li><p>The User hereby warrants and represents that (a) it has full corporate right, power and authority to enter into the Services Agreement and to perform the acts required of it hereunder; (b) the execution of the Services Agreement by the User, and the performance of its obligations and duties hereunder, do not and will not violate any agreement to which it is bound, (c) it will be bound by the Services Agreement upon the execution of the same, (d) it will not use any virus, worm, crack programs, bot, electronic equipment, computer programs or any other inappropriate method to interfere, invade, damage, modify and decompile the Services, (e) it will not conduct reverse-engineering against the Services nor modify the source code of the Services; (f) it does not and will not fall within the scope of Anti-Social Forces (defined as follows) for all time and (g) it is not and will not be listed in the United States’ Office of Foreign Assets Control Sanctions List for all time.</p></li><li><p>The User shall assume the responsibility and expenses of confirming whether its use of the Services will violate any laws or internal rules of industry associations that are applicable to the User. Appier makes no warranty that the use of the Services by the User will comply with all laws or internal rules of industry associations that are applicable to the User.</p></li><li><p>The User shall be responsible for handling and resolving any transaction, contact or dispute arises between the User and any third party relating to the Services. Appier shall in no event be held liable for the foregoing events.</p></li><li><p>Appier shall not be held liable for the suspension, cease, termination, unavailability or change of the Services caused by Appier, or deletion of data, or malfunction or damage of equipment due to use of the Services, or any other damages suffered by the User in connection with the Services.</p></li></ol><p class=article><strong>Article 15 Disclaimer and Indemnification</strong></p><ol><li><p>THE SERVICES ARE PROVIDED ON AN \"AS IS\" AND \"AS AVAILABLE\" BASIS. APPIER EXPRESSLY DISCLAIMS ALL WARRANTIES, REPRESENTATIONS AND CONDITIONS OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO THE IMPLIED WARRANTIES, REPRESENTATIONS AND CONDITIONS OF MERCHANTABILITY, NON-INFRINGEMENT, OR FITNESS FOR A PARTICULAR PURPOSE, AND IMPLIED WARRANTIES ARISING FROM COURSE OF DEALING OR PERFORMANCE. APPIER EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND THAT THE SERVICES WILL ALWAYS BE AVAILABLE, ACCESSIBLE, UNINTERRUPTED, TIMELY, AND SECURE OR OPERATE WITHOUT ERROR OR THAT ANY SERVICES OR PLATFORM PROVIDED HEREUNDER WILL OPERATE WITHOUT ERROR.</p></li><li><p>APPIER WILL IN NO EVENT BE HELD LIABLE FOR (I) USER’S NEGLIGENCE, INTERRUPTIONS, DELETIONS, ERRORS OR DELAY DURING USER’S OPERATION OR TRANSFERATION, (II) TRANSMISSION INTERRUPTION OR INTERNET CONGESTION, (III) THEFT OR ANY OTHER ILLEGAL CONDUCTS, (IV) UNAUTHORIZED USE OR MODIFICATION AGAINST THE SERVICE, OR (V) OTHER EVENTS NOT ATTRIBUTABLE TO APPIER.</p></li><li><p>EXCEPT FOR EVENTS RELATING TO ARTICLE 7 OF THESE TERMS, IN NO EVENT WILL EITHER PARTY BE LIABLE TO THE OTHER PARTY FOR ANY INDIRECT, INCIDENTAL, PUNITIVE, SPECIAL, RELIANCE OR CONSEQUENTIAL DAMAGES OF ANY KIND OR NATURE WHATSOEVER, HOWEVER CAUSED, AND WHETHER BASED ON BREACH OF CONTRACT, TORT (INCLUDING WITHOUT LIMITATION GROSS NEGLIGENCE), OR ANY THEORY OF LIABILITY, SUFFERED BY THE OTHER PARTY, INCLUDING, WITHOUT LIMITATION, LOST PROFITS, BUSINESS INTERRUPTIONS OR OTHER ECONOMIC LOSS UNDER OR ARISING OUT OF THE PERFORMANCE OR NON-PERFORMANCE HEREUNDER, AND WHETHER OR NOT THE APPLICABLE PARTY WAS ADVISED OF THE POSSIBILITY OF SUCH LOSS OR DAMAGES.</p></li><li><p>IN NO EVENT WILL APPIER’S TOTAL LIABILITY ARISING OUT OF OR IN CONNECTION WITH THE SERVICES AGREEMENT, ANY DISPUTE FROM THE USE OF OR INABILITY TO USE THE SERVICES OR CONTENT EXCEED THE AGGREGATED AMOUNT PAID BY THE USER TO APPIER IN THE THREE (3) MONTHS PRECEDING THE DATE THE CLAIM AROSE.</p></li></ol><p class=article><strong>Article 16 Additional compliance requirement</strong></p><ul><li><p>To the extent applicable, as determined by Appier, if the User belongs to anti-social forces (referring hereafter to organized crime group, organized crime group member, right-wing organization, anti-social forces or other equivalent organizations according to applicable Japanese laws and regulations, “<strong>Anti-Social Force</strong>”), or provides funds or uses other means to maintain, operate, or assist in or participate in the operation of Anti-Social Forces or has any interaction or involvement with Anti-Social Forces, Appier may terminate the Services Agreement immediately without prior notice to the User.</p></li><li><p>In addition to the provision of the preceding paragraph, in the event that any User’s director, supervisor, employee or other member, shareholder, client and/or supplier, or consultant or other expert advisor is confirmed to be Anti-Social Forces, or provides funds or uses other means to maintain, operate, or assist or participate in the operation of Anti-Social Forces or has any interaction or involvement with Anti-Social Forces, Appier may terminate the Services Agreement immediately by written notice to the User if the User fails comply with Appier’s request to eliminate such relationship within a reasonable period upon the User’s receipt of Appier’s notice.</p></li><li><p>To the extent applicable, as determined by Appier, if the User is confirmed to be listed in the United States’ Office of Foreign Assets Control Sanctions List, Appier may terminate the Services Agreement immediately without prior notice to the User.</p></li><li><p>In the event that the Services Agreement is terminated under this Article 16, Appier shall not be held liable for any damages suffered by the User due to such termination, while the User shall compensate Appier for any and all damages suffered by Appier.</p></li></ul><p class=article><strong>Article 17 Effective Term</strong></p><p>Unless otherwise agreed by both parties, the Services Agreement shall become effective from the starting date as stated in the Application Form, until (i) the expiration date as stated in the Application Form, or (ii) either party terminates the Services Agreement pursuant to any provisions provided in these Terms or the Application Form, as applicable.</p><p class=article><strong>Article 18 Communication/Notice</strong></p><p>The User’s queries about the Services and other communications or notices from the User to Appier, as well as other communications and notices from Appier to the User shall be given in the manner specified by Appier separately.</p><p class=article><strong>Article 19 Assignment</strong></p><ol><li><p>With respect to its status under the Services Agreement or the rights and obligations under these Terms, the User shall not assign, transfer, pledge or otherwise make any disposal to any third party without with the prior written consent of Appier.</p></li><li><p>If Appier assigns the business relating to the Services to another company, its status under the Services Agreement, rights and obligations under these Terms, as well as registration data of the User or other customer information may also be assigned to the assignee of such business assignment. The User shall hereby agree to such assignment in advance. Furthermore, assignment of business as referred to in this paragraph shall, in addition to general assignment of business, also include company split-ups and any other business transfer events.</p></li></ol><p class=article><strong>Article 20 Severability</strong></p><p>If any provision or part of the Services Agreement is determined to be invalid or unenforceable under applicable laws, the remainder of these Terms shall remain in full force and effect.</p><p class=article><strong>Article 21 Survival</strong></p><p>To the extent necessary by its nature, Paragraph 3 of Article 4, Article 5. Article 6, Article 7, Paragraphs 3 and 4 of Article 8, Article 9, Paragraphs 2 and 3 of Article 12, Articles 13 through 16, and Articles 18 through 23 shall survive the termination of the Services Agreement. Notwithstanding anything to the contrary, Article 9 shall remain effective until the third anniversary from the termination of the Services Agreement.</p><p class=article><strong>Article 22 Governing Law and Jurisdiction</strong></p><p>The Services Agreement shall be governed, construed and interpreted in accordance with the laws where the signing entity of Appier locates, without giving effect to principles of conflict of laws.</p><ol><li><p>If the Services Agreement shall be governed by laws of Singapore, any issues or disputes arising out of or in connection with the Services Agreement, including any question regarding its existence, validity or termination (“<strong>Disputes</strong>”), shall be referred to and finally resolved by arbitration in Singapore in accordance with the Arbitration Rules of the Singapore International Arbitration Centre for the time being in force, which rules are deemed to be incorporated by reference in this clause. The tribunal shall consist of 3 arbitrators unless otherwise agreed by the Parties in writing. The language of the arbitration shall be English. The arbitral award shall be final and binding upon both parties.</p></li><li><p>If the Services Agreement shall be governed by the laws of Japan, all the Disputes hall be brought in Tokyo District Court as the exclusive court of competent jurisdiction.</p></li><li><p>If the Services Agreement shall be governed by the laws of Taiwan, Republic of China, all the Disputes hall be brought in Taipei District Court as the exclusive court of competent jurisdiction.</p></li></ol><p class=article><strong>Article 23 Dispute Resolution</strong></p><p>For matters not stipulated in these Terms or in the event of any doubt regarding the interpretation of these Terms, Appier and the User shall first negotiate and resolve the issues in good faith.</p><p>【Revised: November 15, 2020】</p><p>【Original: October 15, 2019】</p>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1298 */
/***/ (function(module, exports) {

var path = '/templates/core/views/tos.html';
var html = "<div class=document-wrapper><div class=row><div class=\"col-md-push-2 col-md-8\"><div ng-switch=vm.selectedLanguage.id class=document-wrapper><ng-container ng-switch-when=zh><zc-terms-of-service-appier-inc></zc-terms-of-service-appier-inc></ng-container><ng-container ng-switch-when=ja><zc-terms-of-service-appier-jp></zc-terms-of-service-appier-jp></ng-container><ng-container ng-switch-default><zc-terms-of-service-appier-others></zc-terms-of-service-appier-others></ng-container></div><zc-data-processing-addendum></zc-data-processing-addendum></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1299 */
/***/ (function(module, exports) {

var path = '/templates/core/views/tos_header.html';
var html = "<div class=container><div class=navbar-header><button class=navbar-toggle type=button data-toggle=collapse data-target=.navbar-collapse><span class=sr-only>Toggle navigation</span> <i class=\"fa fa-cog\"></i></button> <a ui-sref=admin.home class=\"navbar-brand navbar-brand-img\"><img src=/assets/logo.png alt=AiDeal></a></div><nav class=\"collapse navbar-collapse\" role=navigation><ul class=\"nav navbar-nav navbar-right\"><li class=dropdown dropdown><a class=dropdown-toggle dropdown-toggle><i class=\"fa fa-language\"></i> {{ vm.selectedLanguage.label }}</a><ul class=dropdown-menu role=menu><li ng-repeat=\"language in vm.languages\"><a ng-click=vm.selectLanguage(language)>{{ language.label }}</a></li></ul></li></ul></nav></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/agencies/campaigns/agency_campaigns.html';
var html = "<div><header>{{ 'agencies.campaigns.kyanpeen_ichiran' | translate }}</header><div class=container></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/agencies/home/agency_home.html';
var html = "<div class=agency-home><header>{{$ctrl.agency.title}}</header><div class=\"container-fluid container-limited\"><div class=\"row margin-y\"><div class=col-sm-4><h2>{{ 'agencies.home.dairiten_jouhou' | translate }}</h2><table class=\"table table-agency-overview\"><tr><td>{{ 'agencies.home.yuuzaa_kazu' | translate }}</td><td class=text-right>{{$ctrl.users.length}}</td></tr><tr><td>{{ 'agencies.home.saito_kazu' | translate }}</td><td class=text-right>{{$ctrl.allProjects.length}}</td></tr><tr><td>{{ 'agencies.home.dounyuu_kanryou_saito' | translate }}</td><td class=text-right>{{$ctrl.installationFinishedProjects.length}}</td></tr><tr><td>{{ 'agencies.home.dounyuu_mikanryou_saito' | translate }}</td><td class=text-right>{{$ctrl.allProjects.length - $ctrl.installationFinishedProjects.length}}</td></tr></table></div><div class=col-sm-8><h2>{{ 'agencies.home.saikin_sakusei_saretasaito' | translate }}</h2><div ng-if=$ctrl.projectsFetched><div class=\"alert alert-info text-center\" ng-if=!$ctrl.lastProjects.length>{{ 'agencies.home.kagetsu_inai_saito' | translate }}</div><table class=table ng-if=\"$ctrl.lastProjects.length > 0\"><tr ng-repeat=\"project in $ctrl.lastProjects | limitTo: 10\"><td>{{project.created_at | zcDate:{dateOnly: true} }}</td><td>{{project.title}}<br><a ui-sref=\"zenclerkS.project.dashboard({apikey: project.apikey})\">{{project.apikey}}</a></td><td><a ng-href={{project.base_url}} target=_blank>{{project.base_url | limitTo: 30}}</a></td></tr></table></div></div></div><hr></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1302 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/agencies/invoices/list.html';
var html = "<header>{{ 'agencies.invoices.list.go_seikyuu_ichiran' | translate }}</header><div class=\"container-fluid container-limited padding-y\"><div ng-repeat=\"invoice in vm.invoices | orderBy: '-month'\" class=list-item ui-sref=\"zenclerkS.agency.invoices.show({agency_name: vm.agency, term: invoice.month})\" ng-init=\"currency = vm.currencies[invoice.invoice_currency || 'jpy'];\"><div class=list-item-header><span style=\"flex: 3 3 65%\">{{invoice.month}}{{ 'agencies.invoices.list.seikyuu_fun' | translate }} <span ng-if=!invoice.is_finalized>{{ 'agencies.invoices.list.sokuhou' | translate }}</span></span> <span style=\"flex: 2 2 auto; text-align: right\">{{ invoice.invoice_price | zcCurrency : currency.symbol : currency.fractionSize : currency.suffix }}</span> <a class=list-item-action style=\"flex: 1 1 5%; text-align: right\">{{ 'agencies.invoices.list.shousai' | translate }}</a></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/agencies/invoices/show.html';
var html = "<div class=invoice><header>{{ 'agencies.invoices.show.go_seikyuu_ichiran' | translate }}</header><div class=\"container-fluid container-limited invoice-container\"><div class=invoice-pager><button class=\"btn btn-sm btn-default pull-right\" ng-csv=vm.getCSV() csv-header=vm.header add-bom=true charset=utf-16 field-separator=\\t filename=invoice_list.csv><i class=\"fa fa-download\"></i>{{ 'agencies.invoices.show.daunroodo' | translate }}</button> <a class=\"btn btn-sm btn-default\" ui-sref=zenclerkS.agency.invoices.show({term:vm.lastMonth})>{{ 'agencies.invoices.show.sengetsu' | translate }}</a> <a class=\"btn btn-sm btn-default\" ng-click=vm.goToNext(vm.nextMonth) ng-disabled=vm.isLatest()>{{ 'agencies.invoices.show.yokugetsu' | translate }}</a></div><div id=invoice class=margin-y><div class=\"row invoice-header\"><div class=col-md-6><img id=logo src=/assets/img/logo-aideal.svg></div><div class=\"col-md-6 text-right\"><label ng-if=vm.invoice.is_finalized>{{ 'agencies.invoices.show.seikyuu' | translate }}</label> <label ng-if=!vm.invoice.is_finalized>{{ 'agencies.invoices.show.sokuhou_seikyuu' | translate }}</label> <small>{{vm.currentMonth}}</small></div></div><div class=invoice-amount><div class=invoice-price><label ng-if=vm.invoice.is_finalized>{{ 'agencies.invoices.show.seikyuu_kingaku_zeikomi' | translate }}</label> <label ng-if=!vm.invoice.is_finalized>{{ 'agencies.invoices.show.sokuhou_seikyuu_kingaku' | translate }}</label> <span class=number-xl>{{vm.invoice.invoice_price || 0 | zcCurrency : vm.invoiceCurrency.symbol : vm.invoiceCurrency.fractionSize : vm.invoiceCurrency.suffix}}</span></div></div><table class=table><thead><th>{{ 'agencies.invoices.show.saito_na' | translate }}</th><th>{{ 'agencies.invoices.show.koumokumei' | translate }}</th><th>{{ 'agencies.invoices.show.saito_seikyuugaku' | translate }}</th><th>{{ 'agencies.invoices.show.dairiten' | translate }}<br>{{ 'agencies.invoices.show.shikiritsu' | translate }}</th><th>{{ 'agencies.invoices.show.dairiten_seikyuu_kingaku' | translate }}</th></thead><tbody ng-repeat=\"site in vm.invoice.sites\"><tr><th class=link ui-sref=\"zenclerkS.project.invoice.show({apikey: site.apikey, month: vm.currentMonth})\">{{site.title}}</th><th></th><th></th><th></th><th class=text-right>{{site.invoice_price || 0 | zcCurrency : vm.invoiceCurrency.symbol : vm.invoiceCurrency.fractionSize : vm.invoiceCurrency.suffix}}</th></tr><tr class=thead-inverse ng-repeat=\"detail in site.details\"><td ng-if=$first>{{site.apikey}}</td><td ng-if=!$first></td><td>{{detail.title}}</td><td>{{detail.original_price || 0 | zcCurrency : vm.invoiceCurrency.symbol : vm.invoiceCurrency.fractionSize : vm.invoiceCurrency.suffix}}</td><td>{{100 - detail.margin_percent || 0}}%</td><td class=text-right>{{detail.price || 0 | zcCurrency : vm.invoiceCurrency.symbol : vm.invoiceCurrency.fractionSize : vm.invoiceCurrency.suffix}}</td></tr></tbody><tr><td colspan=4>{{ 'agencies.invoices.show.zeinuki_seikyuugaku' | translate }}</td><td class=text-right>{{vm.invoice.invoice_price_tax_excluded || 0 | zcCurrency : vm.invoiceCurrency.symbol : vm.invoiceCurrency.fractionSize : vm.invoiceCurrency.suffix}}</td></tr><tr><td colspan=4>{{ 'agencies.invoices.show.shouhizei' | translate }}</td><td class=text-right>{{vm.invoice.consumption_tax || 0 | zcCurrency : vm.invoiceCurrency.symbol : vm.invoiceCurrency.fractionSize : vm.invoiceCurrency.suffix}}</td></tr><tr><td colspan=4>{{ 'agencies.invoices.show.goukei' | translate }}</td><td class=text-right>{{vm.invoice.invoice_price || 0 | zcCurrency : vm.invoiceCurrency.symbol : vm.invoiceCurrency.fractionSize : vm.invoiceCurrency.suffix}}</td></tr></table></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1304 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/agencies/settings/agency_settings.html';
var html = "<header>{{ 'agencies.settings.kaisha_settei' | translate }}</header><div class=\"container-fluid container-limited margin-y\"><div class=row><div class=\"col-md-8 col-md-offset-2 panel\"><form class=\"form-horizontal padding-top\" ng-submit=vm.save(vm.agency) name=form><h1>{{ 'agencies.settings.keiyaku_jouhou' | translate }}</h1><div class=row><div class=col-md-12><div class=form-group><label for=title class=col-md-3>{{ 'agencies.settings.kaishamei' | translate }}</label><div class=col-md-9><input class=form-control id=title name=title ng-model=vm.agency.title required></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=representative class=col-md-3>{{ 'agencies.settings.kaisha_daihyou_na' | translate }}</label><div class=col-md-9><input class=form-control id=representative name=representative ng-model=vm.agency.representative required></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=postal_code class=col-md-3>{{ 'agencies.settings.yuubinbangou' | translate }}</label><div class=col-md-9><input class=form-control placeholder=\"({{ 'agencies.settings.rei' | translate }})150-0022\" id=postal_code name=postal_code ng-model=vm.agency.postal_code required></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=address class=col-md-3>{{ 'agencies.settings.juusho' | translate }}</label><div class=col-md-9><input class=form-control id=address name=address ng-model=vm.agency.address required></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=phone_number class=col-md-3>{{ 'agencies.settings.denwabangou' | translate }}</label><div class=col-md-9><input class=form-control id=phone_number name=phone_number ng-model=vm.agency.phone_number required></div></div></div></div><section style=\"margin: 0; padding-bottom: 0;\"><h1>{{ 'agencies.settings.seikyuu_saki_jouhou' | translate }}</h1><div class=row><div class=\"col-md-9 col-md-push-3\"><div class=form-group><zc-sync-contract-info-button class=col-md-12 source=vm.agency></zc-sync-contract-info-button></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=billing_company_name class=col-md-3>{{ 'agencies.settings.kaishamei' | translate }}</label><div class=col-md-9><input class=form-control id=billing_company_name name=billing_company_name ng-model=vm.agency.billing_company_name required></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=billing_postal_code class=col-md-3>{{ 'agencies.settings.yuubinbangou' | translate }}</label><div class=col-md-9><input class=form-control placeholder=\"{{ 'agencies.settings.rei_denwa' | translate }}\" id=billing_postal_code name=billing_postal_code ng-model=vm.agency.billing_postal_code required></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=billing_address class=col-md-3>{{ 'agencies.settings.juusho' | translate }}</label><div class=col-md-9><input class=form-control placeholder=\"{{ 'agencies.settings.rei_juusho' | translate }}\" id=billing_address name=billing_address ng-model=vm.agency.billing_address required></div></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=billing_phone_number class=col-md-3>{{ 'agencies.settings.denwabangou' | translate }}</label><div class=col-md-9><input class=form-control id=billing_phone_number name=billing_phone_number ng-model=vm.agency.billing_phone_number required></div></div></div></div><hr><h1 style=\"padding: 0 0 1em 0;\">{{ 'agencies.settings.seikyuu_tantousha_jouhou' | translate }}</h1><zc-billing-representatives representatives=vm.agency.billing_representatives></zc-billing-representatives></section><hr><div class=row><label class=col-md-3>{{ 'agencies.settings.deforuto_seika_houshuu' | translate }}</label> {{ vm.agency.default_fee_rate * 100 || 0 | number : 1 }}%</div><div class=row><label class=col-md-3>{{ 'agencies.settings.dairiten_tesuuryou_ritsu' | translate }}</label> {{vm.agency.margin_percent}}%</div><div class=\"row text-center footer\"><button type=submit class=\"btn btn-primary\" ng-disabled=form.$invalid>{{ 'agencies.settings.hozon' | translate }}</button></div></form></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1305 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/agencies/sidebar.html';
var html = "<div class=sidebar-menu-agency><div class=currently-viewing>{{vm.agency.title}}</div><nav><a ng-class=\"{active:vm.isCategory('agencyHome')}\" ui-sref=zenclerkS.agency.home()><i class=\"fa fa-tasks\"></i> {{ 'agencies.sidebar.hoomu' | translate }}</a> <a ng-class=\"{active:vm.isCategory('agencySites')}\" ui-sref=zenclerkS.agency.sites()><i class=\"fa fa-list\"></i> {{ 'agencies.sidebar.saito_ichiran' | translate }}</a> <a ng-class=\"{active:vm.isCategory('agencySitesInInstallation')}\" ui-sref=zenclerkS.agency.sitesInInstallation()><i class=\"fa fa-list\"></i> {{ 'agencies.sidebar.dounyuu_tochuu_no' | translate }}</a> <a ng-class=\"{active:vm.isCategory('agencySitesUserActivity')}\" ng-hide=\"vm.agency.name === 'makerepeater'\" ui-sref=zenclerkS.agency.sitesUserActivity()><i class=\"fa fa-list\"></i> {{ 'agencies.sidebar.tantousha_akutibiti' | translate }}</a> <a ng-class=\"{active:vm.isCategory('agencyInvoices')}\" ng-show=\"vm.agency.sales_entity === 'appier_jp'\" ui-sref=zenclerkS.agency.invoices.list()><i class=\"fa fa-file-text-o\"></i> {{ 'agencies.sidebar.seikyuu_ichiran' | translate }}</a> <a ng-class=\"{active:vm.isCategory('agencyUsers')}\" ui-sref=zenclerkS.agency.users()><i class=\"fa fa-user\"></i> {{ 'agencies.sidebar.yuuzaa_ichiran' | translate }}</a> <a ng-class=\"{active:vm.isCategory('agencySettings')}\" ui-sref=zenclerkS.agency.settings()><i class=\"fa fa-user\"></i> {{ 'agencies.sidebar.kaisha_settei' | translate }}</a></nav></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1306 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/agencies/sites/agency_project_table.html';
var html = "<div class=agency-project-table><div class=text-right><button class=\"btn btn-sm btn-default pull-right\" ng-csv=$ctrl.getCSV() csv-header=$ctrl.header add-bom=true charset=utf-16 field-separator=\\t filename=campaign_data.csv><i class=\"fa fa-download\"></i> {{ 'agencies.sites.projectTable.daunroodo' | translate }}</button></div><table class=table ng-if=$ctrl.filteredProjects.length><thead><tr><th colspan=5></th><th colspan=2 class=text-center>{{ 'agencies.sites.projectTable.kyanpeen_kazu' | translate }}</th><th colspan=2></th><th></th></tr><tr><th>#</th><th ng-click=\"$ctrl.setSortProp('title')\">{{ 'agencies.sites.projectTable.saito_na' | translate }}</th><th ng-click=\"$ctrl.setSortProp('apikey')\">apikey</th><th ng-click=\"$ctrl.setSortProp('created_at')\">{{ 'agencies.sites.projectTable.sakusei_hi' | translate }}</th><th ng-click=\"$ctrl.setSortProp('conversion_tag_confirmed_at')\" class=text-center>{{ 'agencies.sites.projectTable.dounyuu_suteetasu' | translate }}</th><th ng-click=\"$ctrl.setSortProp('planned_campaigns')\" class=text-center>{{ 'agencies.sites.projectTable.haishin_uchi_nakaguro' | translate }}</th><th ng-click=\"$ctrl.setSortProp('started_campaigns.length')\" class=text-center>{{ 'agencies.sites.projectTable.sousuu' | translate }}</th><th ng-click=\"$ctrl.setSortProp('days_since_last_campaign')\" class=text-center>{{ 'agencies.sites.projectTable.haishin_kara_no' | translate }}</th><th ng-click=\"$ctrl.setSortProp('max_invoice')\" class=text-center>{{ 'agencies.sites.projectTable.jougen_kingaku' | translate }}</th><th></th></tr></thead><tbody><tr ng-repeat=\"project in $ctrl.filteredProjects\" ng-class=\"::{terminated: project.is_terminated}\"><td>{{$index + 1}}</td><td><a ui-sref=\"zenclerkS.project.dashboard({apikey: project.apikey})\">{{::project.title}}</a></td><td>{{::project.apikey}}</td><td>{{::project.created_at | zcDate:{dateOnly: true} }}</td><td class=text-center><span uib-tooltip=\"{{::project.conversion_tag_confirmed_at | zcDate}}\" ng-if=\"::($ctrl.guessProjectStatus(project) == 'conversion_tag_confirmed')\">{{ 'agencies.sites.projectTable.kanryou' | translate }}</span> <span uib-tooltip={{::$ctrl.getTerminatedDate(project.terminated_at)}} ng-if=\"::($ctrl.guessProjectStatus(project) == 'terminated')\" class=\"label label-danger\"><span ng-if=\"!project.is_terminated && project.terminated_at\">{{::$ctrl.getTerminatedDate(project.terminated_at)}}</span> {{ 'agencies.sites.projectTable.kaiyaku' | translate }}</span> <span uib-tooltip=\"{{ 'agencies.sites.projectTable.kyousei_teishi_uchi' | translate }}: {{::project.suspended_at | zcDate}}\" ng-if=\"::($ctrl.guessProjectStatus(project) == 'suspended')\" class=\"label label-danger\">{{ 'agencies.sites.projectTable.teishi' | translate }}</span></td><td class=text-center><span ng-show=\"!project.is_terminated && project.planned_campaigns > 0\">{{project.planned_campaigns}}</span></td><td class=text-center><span ng-class=\"{'label label-warning': project.started_campaigns.length === 0}\">{{project.started_campaigns.length}}</span></td><td class=text-center><span ng-show=\"project.days_since_last_campaign && project.planned_campaigns === 0 && project.days_since_last_campaign > 0\" ng-class=\"{'label label-warning': project.days_since_last_campaign > 10 && !project.is_terminated}\">{{project.days_since_last_campaign}}</span></td><td class=text-center><div ng-if=\"::!project.is_test && !project.is_demo && !project.is_terminated && project.conversion_tag_confirmed_at\"><span ng-if=!project.max_invoice><div class=spinner></div></span> <span ng-if=\"project.max_invoice && project.max_invoice > 0\">{{project.max_invoice | number}}</span></div></td><td class=text-center><a class=\"btn btn-default btn-xs\" ui-sref=\"zenclerkS.project.campaigns({apikey: project.apikey})\"><i class=\"fa fa-list\" title=\"{{ 'agencies.sites.projectTable.kyanpeenrisuto' | translate }}\"></i></a><div ng-if=\"::project.is_demo || project.is_test\"><a class=\"btn btn-default btn-sm\" confirm-modal confirm-click=$ctrl.removeProject(project)><i class=\"fa fa-trash\" title=\"{{ 'agencies.sites.projectTable.sakujo' | translate }}\"></i></a></div></td></tr></tbody></table></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/agencies/sites/agency_site_list.html';
var html = "<header>{{ 'agencies.sites.siteList.saito_ichiran' | translate }}</header><div class=\"container-fluid container-limited\"><h2><div class=col-md-6>{{ 'agencies.sites.siteList.saito_ichiran' | translate }}<div class=\"btn btn-add\" ng-click=$ctrl.newSite()>{{ 'agencies.sites.siteList.saito_wo_shinki' | translate }}</div><div class=\"btn btn-sm btn-default\" ng-click=$ctrl.newSite(true)>{{ 'agencies.sites.siteList.demosaito_wo_shinki' | translate }}</div></div><div class=\"col-md-6 text-right\"><span class=badge>{{$ctrl.projects.length}}</span></div></h2><div class=row><div class=col-md-6><input class=form-control placeholder=\"{{ 'agencies.sites.siteList.searchByNameOrApikey' | translate }}\" ng-model=$ctrl.filter ng-change=$ctrl.filterChanged() ng-model-options=\"{debounce: 500}\"></div></div><br><zcs-agency-project-table projects=$ctrl.filteredProjects projects-max-invoice=$ctrl.agencyProjectsMaxInvoice></zcs-agency-project-table><div ng-if=$ctrl.testProjects.length><h2>{{ 'agencies.sites.siteList.tesutosaito' | translate }}</h2><zcs-agency-project-table projects=$ctrl.testProjects projects-max-invoice=$ctrl.agencyProjectsMaxInvoice></zcs-agency-project-table></div><div ng-if=$ctrl.demoProjects.length><h2>{{ 'agencies.sites.siteList.demosaito' | translate }}</h2><zcs-agency-project-table projects=$ctrl.demoProjects projects-max-invoice=$ctrl.agencyProjectsMaxInvoice></zcs-agency-project-table></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/agencies/sites/new.html';
var html = "<header ng-if=vm.site.is_demo>{{ 'agencies.sites.new.demosaito_shinki_sakusei' | translate }}</header><header ng-if=!vm.site.is_demo>{{ 'agencies.sites.new.saito_shinki_sakusei' | translate }}</header><div class=\"container-fluid container-limited margin-y\"><div class=row><div class=\"col-md-8 col-md-offset-2 panel\"><form class=\"form-horizontal padding-top\" ng-submit=vm.save(vm.site) name=form><div class=form-group><label for=title class=\"col-md-4 control-label\">{{ 'agencies.sites.new.saito_meishou' | translate }}</label><div class=col-md-8><input id=title name=title type=text class=form-control ng-model=vm.site.title required></div></div><div class=form-group><label for=base_url class=\"col-md-4 control-label\">URL</label><div class=col-md-8><input id=base_url name=base_url type=url class=form-control ng-model=vm.site.base_url placeholder=\"https://\" required></div></div><div class=form-group><label for=site-company_name class=\"col-md-4 control-label\">{{ 'agencies.sites.new.kaishamei' | translate }}</label><div class=col-md-8><input id=site-company_name name=site-company_name type=text class=form-control placeholder=\"{{ 'agencies.sites.new.kabushikigaisha_yuugengaisha_nado' | translate }}\" ng-model=vm.site.company_name required></div></div><div class=form-group><label for=representative class=\"col-md-4 control-label\">{{ 'agencies.sites.new.kaisha_daihyou_na' | translate }}</label><div class=col-md-8><input id=representative name=representative type=text class=form-control ng-model=vm.site.representative></div></div><div class=form-group><label for=postal_code class=\"col-md-4 control-label\">{{ 'agencies.sites.new.yuubinbangou' | translate }}</label><div class=col-md-8><input id=postal_code name=postal_code type=text class=form-control placeholder=\"{{ 'agencies.sites.new.rei' | translate }}\" ng-model=vm.site.postal_code></div></div><div class=form-group><label for=address class=\"col-md-4 control-label\">{{ 'agencies.sites.new.juusho' | translate }}</label><div class=col-md-8><input id=address name=address type=text class=form-control placeholder=\"{{ 'agencies.sites.new.rei_juusho' | translate }}\" ng-model=vm.site.address></div></div><div class=form-group><label for=phone_number class=\"col-md-4 control-label\">{{ 'agencies.sites.new.denwabangou' | translate }}</label><div class=col-md-8><input id=phone_number name=phone_number type=text class=form-control ng-model=vm.site.phone_number></div></div><div class=form-group><label for=shopping_cart_asp class=\"col-md-4 control-label\">{{ 'agencies.sites.new.kaato_asp' | translate }}</label><div class=col-md-8><select id=shopping_cart_asp class=form-control ng-options=\"item.value as item.label | translate for item in vm.shopping_cart_asp_options\" ng-model=vm.site.shopping_cart_asp required></select></div></div><div class=form-group ng-if=\"vm.site.shopping_cart_asp && vm.showCartId()\"><label for=cart_id class=\"col-md-4 control-label\">{{ vm.id_name | translate }}</label><div class=col-md-8><input id=cart_id name=cart_id type=text required class=form-control ng-model=vm.site.cart_id></div></div><div class=form-group ng-if=\"!vm.site.is_demo && vm.site.shopping_cart_asp == 'other'\"><label for=invoice_calculation_type class=\"col-md-4 control-label\">{{ 'agencies.sites.new.kuuponkoodo_no_soushin' | translate }}</label><div class=col-md-8><label for=invoice_calculation_type><input id=invoice_calculation_type name=invoice_calculation_type type=checkbox ng-model=vm.site.invoice_calculation_type ng-false-value=\"'deemed'\" ng-true-value=\"'normal'\"> {{ 'agencies.sites.new.konbaajontagudekuuponkoodo_wo_soushin' | translate }}</label></div></div><div class=form-group><label for=is_operated_by_agency class=\"col-md-4 control-label\">{{ 'agencies.sites.new.itaku_unei' | translate }} <i class=\"glyphicon glyphicon-question-sign\" uib-tooltip-html=\"{{ 'agencies.sites.new.dairiten_youni_te' | translate: { service: ZcsOemService.getName() } }}\"></i></label><div class=col-md-8><input id=is_operated_by_agency type=checkbox ng-model=vm.site.is_operated_by_agency></div></div><div class=form-group ng-if=!vm.site.is_demo><label for=is_test class=\"col-md-4 control-label\">{{ 'agencies.sites.new.tesuto_yousaito' | translate }}</label><div class=col-md-8><input id=is_test type=checkbox ng-model=vm.site.is_test></div></div><div class=form-group><label for=region class=\"col-md-4 control-label\">{{ 'agencies.sites.new.region' | translate }}</label><div class=col-md-8><select id=region class=form-control ng-options=\"item.name as item.name | gmtNotation for item in vm.regions\" ng-model=vm.site.region required></select></div></div><div class=form-group><label for=sales_entity class=\"col-md-4 control-label\">{{ 'agencies.sites.new.salesEntity' | translate }}</label><div class=col-md-8><select id=sales_entity class=form-control ng-options=\"item.name as item.label for item in vm.salesEntities\" ng-model=vm.site.sales_entity ng-disabled=!vm.agency.is_direct_selling required></select></div></div><div class=form-group ng-if=\"vm.agency.sales_entity !== 'appier_jp' || ( vm.agency.is_direct_selling && vm.site.sales_entity !== null && vm.site.sales_entity !== undefined && vm.site.sales_entity !== 'appier_jp' )\"><label for=fixed_invoice_amount class=\"col-md-4 control-label\">{{ 'agencies.sites.new.fixedInvoiceAmount' | translate }}</label><div class=col-md-8><input id=fixed_invoice_amount name=fixed_invoice_amount type=number min=0 class=form-control ng-model=vm.site.fixed_invoice_amount required></div></div><div class=\"row text-center footer\"><button type=submit class=\"btn btn-primary\" ng-disabled=form.$invalid>{{ 'agencies.sites.new.hozon' | translate }}</button></div></form></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/agencies/sites_in_installation/sites_in_installation.html';
var html = "<div><header>{{$ctrl.agency.title}}</header><div class=\"container-fluid container-limited\"><div class=\"row margin-y-half\"><div class=col-sm-6></div><div class=col-sm-6><button class=\"btn btn-sm btn-default pull-right\" ng-csv=$ctrl.getCSV() csv-header=$ctrl.header add-bom=true charset=utf-16 field-separator=\\t filename=status_data.csv ng-disabled=\"!$ctrl.projects || $ctrl.projects.length === 0\"><i class=\"fa fa-download\"></i> {{ 'agencies.sitesInInstallation.purojekutosuteetasu_ichiran' | translate }}</button></div></div><div class=row><div class=col-sm-12><zcs-projects-in-installation projects=$ctrl.projects></zcs-projects-in-installation></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/agencies/sites_user_activity/sites_user_activity.html';
var html = "<div><header>{{$ctrl.agency.title}}</header><div class=\"container-fluid container-limited\"><div class=row><div class=col-sm-12><zcs-project-user-activity projects=$ctrl.projects></zcs-project-user-activity></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1311 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/agencies/users/agency_users.html';
var html = "<div class=\"container-fluid container-limited\"><div class=col-md-7><h2>{{ 'agencies.users.yuuzaa_ichiran' | translate }} <span class=\"badge pull-right\">{{vm.users.length}}</span></h2><div class=list><div ng-repeat=\"user in vm.users\" class=\"col-md-12 list-item\"><div class=list-item-avatar>{{user.email | limitTo:1}}</div><div class=list-item-body><div class=row><div class=col-md-3><label>{{ 'agencies.users.namae' | translate }}</label></div><div class=col-md-9>{{user.full_name}}</div></div><div class=row><div class=col-md-3><label>{{ 'agencies.users.meeru' | translate }}</label></div><div class=col-md-9>{{user.email}}</div></div></div><div class=list-item-action><i class=\"fa fa-ellipsis-h\"></i> <i class=\"fa fa-trash\" confirm-click=vm.removeUser(user) confirm-modal ng-if=\"user.email != vm.currentUser.email\" title=\"{{ 'agencies.users.sakujo' | translate }}\"></i></div></div></div></div><div class=\"col-md-4 col-md-offset-1 panel padding\"><svg class=\"svg-icon xl\" viewbox=\"0 0 20 20\"><path fill=none d=\"M13.388,9.624h-3.011v-3.01c0-0.208-0.168-0.377-0.376-0.377S9.624,6.405,9.624,6.613v3.01H6.613c-0.208,0-0.376,0.168-0.376,0.376s0.168,0.376,0.376,0.376h3.011v3.01c0,0.208,0.168,0.378,0.376,0.378s0.376-0.17,0.376-0.378v-3.01h3.011c0.207,0,0.377-0.168,0.377-0.376S13.595,9.624,13.388,9.624z M10,1.344c-4.781,0-8.656,3.875-8.656,8.656c0,4.781,3.875,8.656,8.656,8.656c4.781,0,8.656-3.875,8.656-8.656C18.656,5.219,14.781,1.344,10,1.344z M10,17.903c-4.365,0-7.904-3.538-7.904-7.903S5.635,2.096,10,2.096S17.903,5.635,17.903,10S14.365,17.903,10,17.903z\"></path></svg><h2 class=text-center>{{ 'agencies.users.shinkiyuuza_touroku' | translate }}</h2><p class=text-justify>{{ 'agencies.users.ko_no_dairiten' | translate }}<br>{{ 'agencies.users.namae_to_meeruadoresu' | translate }}<br>{{ 'agencies.users.shoutai_sareta_hito' | translate }}</p><form id=inviteUser name=form class=text-center ng-submit=vm.inviteUser(inviteUserEmail,inviteUserName)><input id=name name=name class=\"margin-y form-control text-center\" ng-model=vm.newUser.full_name placeholder=\"{{ 'agencies.users.namae' | translate }}\" required> <input id=email name=email type=email class=\"margin-y form-control text-center\" ng-model=vm.newUser.email placeholder=\"{{ 'agencies.users.meeruadoresu' | translate }}\" required> <button type=submit class=\"btn btn-primary\" ng-disabled=form.$invalid>{{ 'agencies.users.shoutai' | translate }}</button><div class=\"warning padding margin-y hide\" ng-class=\"{'show': vm.state.duplicateUser}\">{{ 'agencies.users.ko_no_meerusude' | translate }}</div></form></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/common/maintenance/maintenance.html';
var html = "<div class=maintenance><img src=/assets/img/logo-aideal.svg><h1>{{ 'common.maintenance.maintenanceInProgress' | translate }}</h1><p>{{ 'common.maintenance.description' | translate }}</p></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/common/pricing/pricing.html';
var html = "<div class=\"container-fluid pricing\"><div class=row><div class=\"col-md-push-1 col-md-10\"><section><h1>{{ 'common.pricing.usageAgreement' | translate }}</h1><p translate=common.pricing.usageAgreementDescription translate-value-service=\"<strong>{{ZcsOemService.getName()}}</strong>\"></p></section><section><h1>{{ 'common.pricing.usageFee' | translate }}</h1><div class=row><div class=\"col-md-5 col-md-offset-1\"><div class=price-box><div class=price-title>{{ 'common.pricing.performanceReward' | translate }}</div><div class=price-body><div class=price-body-title><strong translate=common.pricing.conversionAmount translate-value-amount=\"<span class='num'>4<span class='comma'>.</span>9</span>%\"></strong></div><div translate=common.pricing.conversionAmountDescripton translate-value-service=\"<strong>{{ZcsOemService.getName()}}</strong>\" class=body-desc></div></div><div class=price-fotter>{{ 'common.pricing.confirmEveryMonth' | translate }}<br>{{ 'common.pricing.nextMonthPayment' | translate }}</div></div><p class=p-desc>{{ 'common.pricing.performanceRewardNote' | translate: { service: ZcsOemService.getName() } }}</p></div><div class=col-md-5><div class=price-box><div class=price-title>{{ 'common.pricing.minimumCharge' | translate }}</div><div class=price-body><strong translate=common.pricing.chargeAmount translate-value-amount=\"{{ vm.currency.symbol }}<span class='num'>10<span class='comma'>,</span>000</span>{{ vm.currency.suffix || '円' }}\"></strong><div class=body-desc>{{ 'common.pricing.chargeDescription1' | translate: { amount: vm.currency.symbol + '10,000' + (vm.currency.suffix || '円') } }}<br class=hidden-xs>{{ 'common.pricing.chargeDescription2' | translate: { amount: '4.9%' } }}<br class=hidden-xs>{{ 'common.pricing.chargeDescription3' | translate }}</div></div><div class=price-fotter>{{ 'common.pricing.afterContractConcluded' | translate }}<br>{{ 'common.pricing.confirmEndMonth' | translate }} {{ 'common.pricing.nextMonthPayment' | translate }}</div></div><p class=p-desc>{{ 'common.pricing.chargeNote1' | translate }}<br class=hidden-xs>{{ 'common.pricing.chargeNote2' | translate }}</p></div></div></section><section><h1>{{ 'common.pricing.performanceRewardLimit' | translate }}</h1><div class=row><div class=col-md-6><p>{{ 'common.pricing.performanceRewardDescription1' | translate }} {{ 'common.pricing.performanceRewardDescription2' | translate: { service: ZcsOemService.getName(), amout: '1%' } }}</p><p class=p-desc>{{ 'common.pricing.performanceRewardNote1' | translate }}<br>{{ 'common.pricing.performanceRewardNote2' | translate }}<br>{{ 'common.pricing.performanceRewardNote3' | translate: { service: ZcsOemService.getName() } }}</p></div><div class=col-md-6><img src=/assets/img/price_201704_plan.svg class=pull-right></div></div></section><section><h1>{{ 'common.pricing.minimumUsagePeriod' | translate }}</h1><p><strong>{{ 'common.pricing.usagePeriodDuration' | translate: { days: '90' } }}</strong></p></section><section><h1>{{ 'common.pricing.numberOfCouponUsage' | translate }}</h1><p>{{ 'common.pricing.numberOfCouponUsageDescription' | translate: { service: ZcsOemService.getName() } }}<br>{{ 'common.pricing.numberOfCouponUsageAndroid' | translate: { service: ZcsOemService.getName() } }}</p></section></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/common/product_changes/product_changes.html';
var html = "<div class=product-changes><div class=product-changes__body><div class=\"product-changes__entry product-changes__empty\">{{ 'common.productChanges.noUpdate' | translate }}</div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/common/product_changes/product_changes_page.html';
var html = "<div class=\"container container-limited product-changes\"><div class=row><div class=col-xs-12><ng-include src=\"'/templates/zenclerk_s/common/product_changes/product_changes.html'\"></ng-include></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/behavior_visualizer/behavior_visualizer.html';
var html = "<div class=visualize-view><div class=visualize-wrapper><div class=visualize-area><div class=visualize-area-behavior style=\"width: {{$ctrl.normalizePosition($ctrl.scrollWidth)}}px; height: {{$ctrl.normalizePosition($ctrl.height)}}px;\"><div class=iframe-wrapper><iframe id=captureIframe class=capture-large ng-src={{::$ctrl.trustCaptureUrl($ctrl.captureUrl)}} style=\"width: {{$ctrl.normalizePosition($ctrl.scrollWidth)}}px; height: {{$ctrl.normalizePosition($ctrl.height)}}px;\"></iframe></div></div></div></div><div class=playback-controls><div class=row><div class=col-sm-9><div class=timelines><div class=timeline-wrapper ng-click=$ctrl.jumpToPosition($event)><div class=\"timeline timeline-raw\"><div class=timeline-progress style=\"left: {{$ctrl.normalizeTime($ctrl.time.currentPosition)}}%\"></div><div class=data><div class=event ng-class=\"::{'event-mouse':event.event.mouse, 'event-click':event.event.click, 'event-scroll':event.event.scroll, 'event-scroll-up':event.scroll.dY < 0, 'event-scroll-down':event.scroll.dY > 0, 'event-touch':event.event.touch }\" ng-repeat=\"event in $ctrl.behaviorData.data\" style=\"left: {{::$ctrl.normalizeTime(event.time)}}%\" uib-tooltip=\"{{::event.event | json}}\" tooltip-class=tooltip-text tooltip-append-to-body></div></div></div><div class=\"timeline timeline-particular\"><div class=data><div class=\"event event-{{::event.name}}\" ng-repeat=\"event in $ctrl.behaviorData.particular_events\" style=\"left: {{::$ctrl.normalizeTime(event.time)}}%\" uib-tooltip=\"<pre class='text-left text-small'>{{::event | json}}</pre>\" tooltip-class=tooltip-text tooltip-append-to-body></div></div></div><div class=\"timeline timeline-campaign\"><div class=data><div class=\"event event-campaign\" ng-repeat=\"event in $ctrl.behaviorData.campaign_events\" style=\"left: {{::$ctrl.normalizeTime(event.time)}}%\" uib-tooltip=\"<pre class='text-left text-small'>{{::event | json}}</pre>\" tooltip-class=tooltip-text tooltip-append-to-body></div></div></div><div class=\"timeline timeline-resize\"><div class=data><div class=\"event event-resize\" ng-repeat=\"event in $ctrl.behaviorData.resized\" style=\"left: {{::$ctrl.normalizeTime(event.time)}}%\" uib-tooltip=\"<pre class='text-left text-small'>height:{{::event.height}}\\nwidth:{{::event.width}}\\ndw:{{::event.dw}}\\ndh:{{::event.dh}}</pre>\" tooltip-class=tooltip-text tooltip-append-to-body></div></div></div></div></div></div><div class=col-sm-3><div><button class=\"btn btn-xs btn-default btn-play\" ng-click=$ctrl.togglePlay()><i class=fa ng-class=\"{'fa-pause': $ctrl.Behavior.current.isPlaying, 'fa-play': !$ctrl.Behavior.current.isPlaying}\"></i>&nbsp;</button> {{($ctrl.time.currentPosition - $ctrl.time.startPosition) | date: 'mm:ss'}} / {{($ctrl.time.endPosition - $ctrl.time.startPosition) | date: 'mm:ss'}}</div><div><div class=btn-group><button class=\"btn btn-xs btn-default\" ng-click=$ctrl.setSpeed(1) ng-class=\"{'selected': $ctrl.Behavior.current.speedFactor === 1}\">1x</button> <button class=\"btn btn-xs btn-default\" ng-click=$ctrl.setSpeed(2) ng-class=\"{'selected': $ctrl.Behavior.current.speedFactor === 2}\">2x</button> <button class=\"btn btn-xs btn-default\" ng-click=$ctrl.setSpeed(4) ng-class=\"{'selected': $ctrl.Behavior.current.speedFactor === 4}\">4x</button> <button class=\"btn btn-xs btn-default\" ng-click=$ctrl.setSpeed(8) ng-class=\"{'selected': $ctrl.Behavior.current.speedFactor === 8}\">8x</button> <button class=\"btn btn-xs btn-default\" ng-click=$ctrl.setSpeed(16) ng-class=\"{'selected': $ctrl.Behavior.current.speedFactor === 16}\">16x</button></div></div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1317 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/campaign/action_menu/campaign_action_menu.html';
var html = "<div class=campaign-action-menu><div><div class=\"btn-group pull-right\"><a ui-sref=\"zenclerkS.project.campaign.summary({apikey: $ctrl.project.apikey, campaignId: $ctrl.campaign.id})\" ng-if=$ctrl.canShowReportButton() class=\"btn btn-secondary\">{{ 'directives.campaign.actionMenu.report' | translate }}</a> <button class=\"btn btn-secondary\" ng-if=\"($ctrl.isActiveProject || $ctrl.isOemProject || $ctrl.isMasterUser) && $ctrl.campaign.current_status !== 'incomplete'\" ng-hide=\"!$ctrl.canShowReportButton() && !$ctrl.isAllowedLiteTemplate()\" ng-click=\"$ctrl.isMenuActive = !$ctrl.isMenuActive ; $event.stopPropagation()\" ng-class=\"{'active': $ctrl.isMenuActive}\"><i class=\"fa fa-cog\"></i></button></div></div><div class=dropdown-menu ng-class=\"{'active': $ctrl.isMenuActive}\"><a ng-if=\"($ctrl.campaign.current_status === 'active' || $ctrl.campaign.current_status === 'pending') && $ctrl.campaign.segment.name === 'zcs_segment_mail_only'\" ng-click=$ctrl.openMailMagUrlModal()><i class=\"fa fa-envelope\"></i>{{ 'directives.campaign.actionMenu.urlForEmailMagazine' | translate }}</a> <a ng-if=\"$ctrl.campaign.current_status !== 'terminated'\" ng-click=$ctrl.openPreviewLinkModal()><i class=\"fa fa-eye\"></i><span ng-if=$ctrl.project.is_demo translate=directives.campaign.actionMenu.demo></span>{{ 'directives.campaign.actionMenu.confirmPreviewOnSite' | translate }}</a> <a ng-if=\"$ctrl.campaign.current_status !== 'terminated'\" ui-sref=\"zenclerkS.project.campaign.edit({campaignId: $ctrl.campaign.id})\"><i class=\"fa fa-pencil\"></i>{{ 'directives.campaign.actionMenu.edit' | translate }}</a> <a ng-if=$ctrl.isAllowedLiteTemplate() ng-click=$ctrl.copyCampaign($ctrl.campaign)><i class=\"fa fa-clone\"></i>{{ 'directives.campaign.actionMenu.copy' | translate }}</a> <a confirm-click=$ctrl.toggleCampaignState() confirm-modal={{$ctrl.confirmToggleCampaignState}} ng-hide=\"$ctrl.campaign.current_status === 'blocked' && $ctrl.project.is_publish_limit_reached\" ng-if=\"$ctrl.campaign.current_status === 'blocked' || $ctrl.campaign.current_status === 'active'\"><span ng-if=\"$ctrl.campaign.status === 'activated'\"><i class=\"fa fa-pause\"></i>{{ 'directives.campaign.actionMenu.stopForAWhile' | translate }}</span> <span ng-if=\"$ctrl.campaign.status === 'blocked'\"><i class=\"fa fa-play\"></i>{{ 'directives.campaign.actionMenu.restart' | translate }}</span></a> <a confirm-click=$ctrl.removeCampaign($ctrl.campaign) confirm-modal={{$ctrl.confirmRemoveCampaign}} class=text-danger ng-if=\"$ctrl.campaign.current_status !== 'terminated'\"><i class=\"fa fa-trash-o\"></i>{{ 'directives.campaign.actionMenu.endTheCampaign' | translate }}</a></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1318 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/campaign/list/conversions.html';
var html = "<div class=campaign-list-conversions><div><div class=row><div class=col-md-4><h1>{{ 'directives.campaign.list.cvDetails' | translate }}</h1></div><div class=\"col-md-3 campaign-list-conversions__csvsexport\" ng-if=\"!ctrl.gettingConversions && $ctrl.conversions.length > 0\"><div pe-track=campaignListConversions.getCSV><button type=button class=\"btn btn-sm btn-default pull-right\" ng-disabled=\"$ctrl.conversions.length <= 0\" ng-csv=$ctrl.getCSV() csv-header=$ctrl.headerRow add-bom=true charset=utf-16 field-separator=\\t filename=conversion_details_report.csv><i class=\"fa fa-cloud-download\"></i> {{ 'directives.campaign.list.csvDownload' | translate }}</button></div></div></div></div><div ng-if=$ctrl.gettingConversions><div class=text-center><span class=spinner></span></div></div><div ng-if=\"!$ctrl.gettingConversions && $ctrl.conversions.length === 0\"><div class=row><div class=\"col-md-offset-2 col-md-8\"><div class=campaign-list-conversions-empty translate=directives.campaign.list.cvDataNoExist></div></div></div></div><div ng-if=\"!ctrl.gettingConversions && $ctrl.conversions.length > 0\"><div class=\"row margin-bottom\"><div class=col-md-7><table><thead><tr><th ng-repeat=\"header in $ctrl.headers\" ng-click=$ctrl.sortBy(header.field) ng-if=header.displayTitle ng-class=\"{ 'text-center': header.field === 'device', 'text-right': header.field === 'price' }\">{{header.title}} <span ng-show=\"$ctrl.sortCurrent == header.field\" class=fa ng-class=\"{ 'fa-caret-up': !$ctrl.sortReverse, 'fa-caret-down': $ctrl.sortReverse }\"></span></th></tr></thead><tbody><tr ng-repeat=\"conversion in $ctrl.pagedConversions | orderBy:$ctrl.sortCurrent:$ctrl.sortReverse | limitTo: $ctrl.pagination.itemsPerPage\"><td uib-tooltip=\"{{conversion.created_at | zcDate}}\" tooltip-append-to-body=true>{{conversion.created_at | zcDate:{smart: true, dateOnly: true} }}</td><td>{{conversion.id}}</td><td class=text-center><i uib-tooltip={{$ctrl.getDeviceName(conversion.device)}} class=fa ng-class=\"{ 'fa-laptop': conversion.device === 'pc', 'fa-mobile': conversion.device === 'sp', 'fa-tablet': conversion.device === 'tablet' }\"></i></td><td class=text-right>{{conversion.price | zcCurrency : $ctrl.currency.symbol: $ctrl.currency.fractionSize :$ctrl.currency.suffix}}</td></tr></tbody></table><div ng-if=\"$ctrl.pagination.itemsPerPage < $ctrl.conversions.length\"><ul uib-pagination class=\"pull-left pagination-sm\" total-items=$ctrl.conversions.length items-per-page=$ctrl.pagination.itemsPerPage max-size=$ctrl.pagination.maxSize force-ellipses=true ng-model=$ctrl.pagination.currentPage ng-change=$ctrl.pageChanged() previous-text=&lsaquo; next-text=&rsaquo; first-text=&laquo; last-text=&raquo;></ul></div></div><div class=space-divider></div><div class=col-md-4><div class=row><h2 class=chart-pie-title>{{ 'directives.campaign.list.cvDevicesPercentages' | translate }}</h2><div class=col-sm-12><zcs-chart-pie ng-if=$ctrl.chartData.devices chart-data=$ctrl.chartData.devices></zcs-chart-pie></div><div class=\"col-xs-12 text-center campaign-summary__counter\"><span ng-repeat=\"(device, deviceConversionCount) in $ctrl.conversionCountPerDevice\" uib-tooltip={{$ctrl.getDeviceName(device)}}><i class=fa ng-class=\"[$index, {'fa-laptop': device === 'pc', 'fa-mobile': device === 'sp', 'fa-tablet': device === 'tablet'}]\"></i> <span>{{$ctrl.getDevicePercentage(deviceConversionCount) | number: 0}}%</span></span></div><div class=\"col-xs-12 text-center padding-y\"><div class=campaign-summary__counter><div class=campaign-summary__legend><abbr uib-tooltip=\"{{ 'directives.campaign.list.customerUnitPriceTooltip' | translate }}\">{{ 'directives.campaign.list.customerUnitPrice' | translate }}</abbr></div><span>{{$ctrl.averageConversionPrice | zcCurrency : $ctrl.currency.symbol : $ctrl.currency.fractionSize : $ctrl.currency.suffix }}</span></div></div></div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1319 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/campaign/template_editor/campaign_template_dynamic_view.html';
var html = "<div ng-show=$ctrl.hasCssError class=campaign-template-error><h3>{{ 'directives.campaign.templateEditor.dynamicView.specifyCorrectRGBCode' | translate }}</h3></div><div ng-show=$ctrl.hasHtmlError class=campaign-template-error><h3>{{ 'directives.campaign.templateEditor.dynamicView.invalidHTML' | translate }}</h3></div><div ng-hide=\"$ctrl.hasHtmlError || $ctrl.hasCssError\"><div ng-hide=$ctrl.viewShow class=template-load><div class=spinner></div>{{ 'directives.campaign.templateEditor.dynamicView.loadingTemplate' | translate }}</div><div ng-show=$ctrl.view><div ng-hide=$ctrl.campaign.template.views.length><h3>{{ 'directives.campaign.templateEditor.dynamicView.errorOccurredWhenDisplayTemplate' | translate }}</h3></div><div ng-show=$ctrl.campaign.template.views.length><div class=\"{{template_view.class}} template-view\" ng-class=\"{'show': $ctrl.viewShow}\" ng-repeat=\"template_view in $ctrl.views\"><div class=template-view-head>{{ template_view.name | translate }}<div class=\"badge badge-info\" ng-if=\"template_view.name === '{{ $ctrl.offerView }}'\" ng-click=\"$ctrl.isOfferViewInstructionVisible = !$ctrl.isOfferViewInstructionVisible\" ng-class=\"{'active': $ctrl.isOfferViewInstructionVisible}\" uib-popover-html=\"'{{ $ctrl.offerViewInstruction }}'\" popover-placement=\"auto bottom\"><i class=\"fa fa-question\"></i></div><div class=\"badge badge-info\" ng-if=\"template_view.name === '{{ $ctrl.presentView }}'\" ng-click=\"$ctrl.isPresentViewInstructionVisible = !$ctrl.isPresentViewInstructionVisible\" ng-class=\"{'active': $ctrl.isPresentViewInstructionVisible}\" uib-popover-html=\"'{{ $ctrl.presentViewInstruction }}'\" popover-placement=\"auto bottom\"><i class=\"fa fa-question\"></i></div></div><div class=template-view-body><div id=zc-plugincontainer><div class=\"zc-wrapper zc-wrapper-campaign zc-wrapper-widget\" ng-bind-html=$ctrl.view></div></div><div class=clearfix></div></div></div><style ng-bind=\"$ctrl.css + $ctrl.campaign.custom_css\">\n      </style><div ng-bind-html=$ctrl.js></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1320 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/campaign/template_editor/campaign_template_editor.html';
var html = "<form name=templateForm><div class=campaign-template-items><div ng-repeat=\"item in $ctrl.allowedSettings\" ng-if=$ctrl.hasSetting(item)><div ng-hide=\"($ctrl.templateItems[item].name === 'show_incentive_text' || $ctrl.templateItems[item].name === 'countdown_lang') && !$ctrl.campaign.userPattern\">{{ $ctrl.templateItems[name] | json }} <label for={{$ctrl.templateItems[item].name}}>{{ $ctrl.templateItems[item].label | translate }}</label><zcs-campaign-template-item campaign=$ctrl.campaign item=$ctrl.templateItems[item]></zcs-campaign-template-item><p ng-if=$ctrl.templateItems[item].description ng-bind-html=\"$ctrl.templateItems[item].description | translate\"></p></div></div></div></form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1321 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/campaign/template_editor/campaign_template_item.html';
var html = "<div class=campaign-template-item><div ng-if=\"item.type === 'image'\" ng-controller=ZcsNewImageController ng-init=\"message = campaign.element.message; itemName = item.name\" flow-init=\"{target: '/upload'}\" flow-files-submitted=$flow.upload() flow-file-success=\"$file.msg = $message\" flow-drop flow-file-added=!!{png:1,gif:1,jpg:1,jpeg:1}[$file.getExtension()] flow-attrs=\"{accept:'image/*'}\" ng-style=style><img src=/assets/img/blank.png ng-src={{campaign.element.message[item.name]}} class=campaign-element-item-image><div class=text-center><button type=button class=\"btn btn-default btn-sm btn-default\" flow-btn><span class=\"hidden-sm hidden-xs\">{{ 'directives.campaign.templateEditor.item.uploadImage' | translate }}</span></button><div class=\"badge badge-info\" ng-click=\"vm.isUploadV5InstructionVisible = !vm.isUploadV5InstructionVisible\" ng-class=\"{'active': vm.isUploadV5InstructionVisible}\" uib-popover-html=\"'{{ vm.uploadV5Instruction }}'\" popover-placement=\"auto bottom\"><i class=\"fa fa-question\"></i></div><input type=hidden name=elements.{{item.name}} ng-model=campaign.element.message[item.name] ng-required=item.required></div><div class=clearfix></div></div><div ng-if=\"item.type === 'string' && item.name !== 'notice'\"><input class=form-control type=text name={{item.name}} placeholder=\"{{ item.placeholder | translate }}\" ng-required=item.required ng-model=campaign.element.message[item.name] ng-model-options=\"{debounce: 500}\" auto-fill-sync></div><div ng-if=\"item.name === 'notice'\"><input class=form-control type=text name={{item.name}} placeholder=\"{{ item.placeholder | translate }}\" ng-required=item.required ng-model=campaign.element.message[item.name] ng-model-options=\"{debounce: 500}\" maxlength=8 auto-fill-sync></div><div ng-if=\"item.type === 'color'\"><div class=\"input-group input-group-color\"><div class=input-group-addon pe-track=campaign.edit.template.colorBox pe-attrs=\"{color: campaign.element.message[item.name], name: item.name}\" ng-style=\"{'background-color': campaign.element.message[item.name], 'border-color': campaign.element.message[item.name]}\" style=width:35px></div><div class=form-control colorpicker=hex colorpicker-with-input=true pe-track=campaign.edit.template.colorText pe-attrs=\"{color: campaign.element.message[item.name], name: item.name}\" name={{item.name}} ng-model=campaign.element.message[item.name] ng-model-options=\"{debounce: 500}\" ng-required=item.required style=\"cursor: pointer\">{{campaign.element.message[item.name]}}</div></div></div><div ng-if=\"item.type === 'textarea'\"><textarea class=form-control ng-model=campaign.element.message[item.name] ng-required=item.required ng-model-options=\"{debounce: 500}\" ng-trim=false maxlength=240>\n    </textarea></div><div class=switch ng-if=\"item.type === 'boolean'\"><input type=checkbox name={{item.name}} id={{item.name}} class=switch-checkbox ng-model=campaign.element.message[item.name]> <label class=\"switch-label checkbox-inline\" for={{item.name}}></label></div><div ng-if=\"item.type === 'select' && item.name !== 'coupon_pattern' && item.name !== 'countdown_lang'\"><select class=form-control ng-options=\"option.value as option.label | translate for option in item.options\" ng-model=campaign.element.message[item.name]></select><div ng-if=\"item.name === 'badge_position' && campaign.element.message.badge_position !== 'right_top'\" class=\"row campaign-element-item-badge-position\"><div class=col-sm-6>{{ 'sharedModules.campaignsTemplate.badgeVerticalPosition.label' | translate }}<div class=input-group><input type=number min=0 ng-model=campaign.element.message.badge_vertical_position> <span class=input-group-addon>px</span></div></div><div class=col-sm-6>{{ 'sharedModules.campaignsTemplate.badgeHorizontalPosition.label' | translate }}<div class=input-group><input type=number min=0 ng-model=campaign.element.message.badge_horizontal_position> <span class=input-group-addon>px</span></div></div></div></div><div ng-if=\"item.name === 'coupon_pattern'\" class=row><div class=col-sm-3 ng-click=\"setPattern('empty')\"><div class=template-editor-coupon-pattern ng-class=\"{'active': campaign.element.message['coupon_pattern'] == 'empty'}\"><div class=template-editor-coupon-pattern-container ng-style=\"{'background-image':'url(/assets/img/editor/icon-empty-image.svg)'}\"></div></div></div><div ng-repeat=\"img in item.options\" class=col-sm-3 ng-click=setPattern(img.value)><div class=template-editor-coupon-pattern ng-class=\"{'active': campaign.element.message['coupon_pattern'] == img.value}\"><div class=template-editor-coupon-pattern-container ng-style=\"{'background-image': 'url(' + adminApp + 'assets/campaigns/coupon/giftcard/pattern_{{img.value}}_thumb.jpg)'}\"></div></div></div><div class=col-sm-3 ng-if=campaign.userPattern><div class=\"template-editor-coupon-pattern active\"><div class=template-editor-coupon-pattern-container ng-style=\"{'background-image':'url({{campaign.element.message['coupon_pattern']}})'}\"></div></div></div><div class=clearfix></div><div class=col-sm-12 ng-controller=ZcsNewImageController ng-init=\"message = campaign.element.message; itemName = item.name\" flow-init=\"{target: '/upload'}\" flow-files-submitted=$flow.upload() flow-file-success=\"$file.msg = $message\" flow-drop flow-file-added=!!{png:1,gif:1,jpg:1,jpeg:1}[$file.getExtension()] flow-attrs=\"{accept:'image/*'}\" ng-style=style><button class=\"btn btn-default btn-sm btn-default\" type=button flow-btn>{{ 'directives.campaign.templateEditor.item.uploadCouponImage' | translate }}</button><div class=\"badge badge-info\" ng-click=\"vm.isUploadGiftcardInstructionVisible = !vm.isUploadGiftcardInstructionVisible\" ng-class=\"{'active': vm.isUploadGiftcardInstructionVisible}\" uib-popover-html=\"'{{ vm.uploadGiftCardInstruction }}'\" popover-placement=\"auto bottom\"><i class=\"fa fa-question\"></i></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1322 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/campaign/view_card/campaign_view_card.html';
var html = "<div class=campaign-view-card><div class=campaign-view-card__avatar ng-style=$ctrl.coupon.style><div ng-hide=\"$ctrl.campaign.template_type === 'zcs_image'\"><span ng-if=\"($ctrl.campaign.incentives[0].discount_type || $ctrl.campaign.incentive_draft.discount_type) == 'percent'\">{{$ctrl.campaign.incentives[0].discount_percent || $ctrl.campaign.incentive_draft.discount_percent || 0 | number}}%OFF</span> <span ng-if=\"($ctrl.campaign.incentives[0].discount_type || $ctrl.campaign.incentive_draft.discount_type) == 'price'\">{{$ctrl.campaign.currency.symbol}}{{$ctrl.campaign.incentives[0].discount_price || $ctrl.campaign.incentive_draft.discount_price || 0 | number}}{{$ctrl.campaign.currency.suffix}}OFF</span> <span ng-if=\"$ctrl.campaign.incentives[0].is_free_shipping || $ctrl.campaign.incentive_draft.is_free_shipping\">{{ 'directives.campaign.viewCard.freeShipping' | translate }}</span></div><div class=campaign-view-card__code>{{$ctrl.campaign.incentives[0].coupon_code || $ctrl.campaign.incentive_draft.coupon_code || '-'}}</div></div><div class=\"campaign-view-card__info text-left\"><div class=campaign-view-card__title>{{ $ctrl.campaign.name || $translate.instant('directives.campaign.viewCard.noName') }}<br></div><div class=\"campaign-table-segment label label-default\" ng-if=\"$ctrl.campaign.segment.name !== 'zcs_segment_mail_only'\">{{ 'directives.campaign.viewCard.segment' | translate }} <strong>{{$ctrl.getSegmentLabel($ctrl.campaign.segment.name)}}</strong></div><a class=\"btn btn-sm\" ng-if=\"($ctrl.campaign.current_status === 'active' || $ctrl.campaign.current_status === 'pending') && $ctrl.campaign.segment.name === 'zcs_segment_mail_only'\" ng-click=$ctrl.openMailMagUrlModal($event)><i class=\"fa fa-envelope\"></i> {{ 'directives.campaign.viewCard.urlForEmailMagazine' | translate }}</a><div class=progress ng-if=!$ctrl.campaign.is_infinite><div class=progress-tooltip ng-if=\"$ctrl.campaign.current_status == 'active'\" uib-tooltip={{$ctrl.campaignProgress.toString()}} tooltip-placement=bottom></div><div class=progress-bar role=progressbar aria-valuenow={{$ctrl.campaignProgress.progress}} aria-valuemin=0 aria-valuemax=100 ng-if=\"$ctrl.campaign.current_status !== 'incomplete'\" ng-class=\"{ 'warning': $ctrl.isCampaignEndingSoon($ctrl.campaign) }\" ng-style=\"{ 'width': '{{$ctrl.campaignProgress.progress}}%' }\"></div></div><div class=\"row small\"><div class=col-sm-6><h4 ng-if=$ctrl.campaign.is_infinite>{{ 'directives.campaign.viewCard.start' | translate }}</h4><span tooltip-append-to-body=true uib-tooltip=\"{{$ctrl.campaign.start_at | zcDate}} {{$ctrl.campaign.region | gmtNotation}}\">{{$ctrl.campaign.start_at | zcDate:{smart: true, dateOnly: true} }}</span></div><div class=col-sm-6 ng-class=\"{ 'text-right': !$ctrl.campaign.is_infinite }\"><h4 ng-if=$ctrl.campaign.is_infinite>{{ 'directives.campaign.viewCard.end' | translate }}</h4><span tooltip-append-to-body=true uib-tooltip=\"{{$ctrl.campaign.end_at | zcDate}} {{$ctrl.campaign.region | gmtNotation}}\">{{$ctrl.campaign.is_infinite ? $translate.instant('directives.campaign.viewCard.noDeadline') : ($ctrl.campaign.end_at | zcDate:{smart: true, dateOnly: true})}}</span></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1323 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_aishipr.html';
var html = "<ng-include src=\"'/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_integration_brief.html'\"></ng-include><p class=\"config-lead margin-y\" zcs-hide-when-oem translate=directives.conversionTagChecker.conversionTagInstallationDetails translate-value-url=\"<a href='https://zenclerklite.zendesk.com/hc/ja/articles/217679148' target='_blank'> {{ 'directives.common.here' | translate }}</a>\"></p><code hljs hljs-language=html no-escape compile=true>\n<pre>&lt;script type=&quot;text/javascript&quot;&gt;\nvar {{vm.conversionTagPrefix}}_conversion_id = &quot;&lt;#{{ 'directives.conversionTagChecker.aishipr.receiptNumber' | translate }}&gt;&quot;;\nvar {{vm.conversionTagPrefix}}_conversion_price = &quot;&lt;#{{ 'directives.conversionTagChecker.aishipr.grandTotal' | translate }}&gt;&quot;;\nvar {{vm.conversionTagPrefix}}_conversion_items = [\n&lt;#{{ 'directives.conversionTagChecker.aishipr.repetition' | translate }}&gt;\n{ id: &quot;&lt;#{{ 'directives.conversionTagChecker.aishipr.productControlNumber' | translate }}&gt;&quot;, name:&quot;&lt;#{{ 'directives.conversionTagChecker.aishipr.itemNumber' | translate }}&gt;&quot;, price:&quot;&lt;#{{ 'directives.conversionTagChecker.aishipr.productUnitPrice' | translate }}&gt;&quot;, count:&quot;&lt;#{{ 'directives.conversionTagChecker.aishipr.productQuantity' | translate }}&gt;&quot; },\n&lt;#{{ 'directives.conversionTagChecker.aishipr.endOfRepetition' | translate }}&gt;\n];\n&lt;/script&gt;</pre>\n</code>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1324 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_checker.html';
var html = "<div id=installationConversionTag class=conversion-tag-checker><section class=text-center ng-if=vm.project.conversion_tag_confirmed_at><div class=\"alert alert-success\">{{ 'directives.conversionTagChecker.conversionTagInstalled' | translate }}</div><div class=\"btn btn-default margin-y\" ng-click=\"vm.showDetails = !vm.showDetails\" ng-if=\"!vm.showDetails && !vm.project.is_demo\"><i class=\"fa fa-caret-down\"></i> {{ 'directives.conversionTagChecker.checkTheDetails' | translate }}</div></section><div ng-if=\"!vm.project.conversion_tag_confirmed_at || vm.showDetails\"><h2 class=config-subtitle>{{ 'directives.conversionTagChecker.conversionTag' | translate }}</h2><div class=\"row setup-action\"><div class=col-xs-6 ng-if=vm.showReturn><a class=\"btn btn-default pull-left\" ng-if=\"['color_me_shop', 'shopify'].indexOf(vm.project.integrated_with) === -1\" ui-sref=zenclerkS.project.setup.trackingTag zcs-hide-when-oem>{{ 'directives.common.return' | translate }}</a> <a class=\"btn btn-default pull-left\" ng-if=\"['color_me_shop', 'shopify'].indexOf(vm.project.integrated_with) !== -1\" ui-sref=zenclerkS.project.setup.site zcs-hide-when-oem>{{ 'directives.common.return' | translate }}</a></div></div><div class=\"row text-center\" zcs-makerepeater-only><a class=\"btn btn-default\" target=_blank ng-if=\"vm.project.shopping_cart_asp === 'makeshop'\" href=\"http://manual.makeshop.jp/hc/ja/articles/33974006349081/\"><i class=\"fa fa-download\"></i> <span style=\"text-transform: none\">MakeRepeater</span> {{ 'directives.conversionTagChecker.manualForPurchasingAssistanceLinkage' | translate }}</a> <a class=\"btn btn-default\" target=_blank ng-if=\"vm.project.shopping_cart_asp === 'futureshop2'\" href=\"https://cvhelp.makerepeater.jp/【futureshop2】購入アシスト連携設定方法/\"><i class=\"fa fa-download\"></i> <span style=\"text-transform: none\">FutureShop2</span> {{ 'directives.conversionTagChecker.manualForPurchasingAssistanceLinkage' | translate }}</a></div><div ng-switch=vm.project.integrated_with class=\"well margin-y\"><div ng-switch-when=shopify><ng-include src=\"'/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_shopify.html'\"></ng-include></div><div ng-switch-when=vtex><div translate=directives.conversionTagChecker.vtex.instruction></div></div><div ng-switch-default class=\"well margin-y\"><div ng-switch=vm.project.shopping_cart_asp><div ng-switch-when=makeshop><ng-include src=\"'/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_makeshop.html'\"></ng-include></div><div ng-switch-when=aishipr><ng-include src=\"'/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_aishipr.html'\"></ng-include></div><div ng-switch-when=ecbeing><ng-include src=\"'/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_ecbeing.html'\"></ng-include></div><div ng-switch-when=ebisumart><ng-include src=\"'/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_ebisumart.html'\"></ng-include></div><div ng-switch-when=futureshop2><ng-include src=\"'/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_futureshop2.html'\"></ng-include></div><div ng-switch-when=shopserve><ng-include src=\"'/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_shopserve.html'\"></ng-include></div><div ng-switch-default><div ng-if=\"vm.project.invoice_calculation_type === 'normal'\"><ng-include src=\"'/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_other_normal.html'\"></ng-include></div><div ng-if=\"vm.project.invoice_calculation_type === 'deemed'\"><ng-include src=\"'/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_other_deemed.html'\"></ng-include></div></div></div></div></div><div ng-if=vm.project.conversion_tag_confirmed_at><div class=\"alert alert-success text-center\">{{ 'directives.conversionTagChecker.conversionTagInstalled' | translate }}</div></div><div ng-messages=vm.errors><div class=\"alert alert-danger\" ng-message=noConversions translate=directives.conversionTagChecker.noConversionMessage></div><div class=\"alert alert-danger\" ng-message=hasBadConversionIds translate=directives.conversionTagChecker.hasBadConversionIds></div><div class=\"alert alert-danger\" ng-message=hasBadConversionPrices translate=directives.conversionTagChecker.hasBadConversionPrices></div><div class=\"alert alert-danger\" ng-message=hasNoConversionPrice translate=directives.conversionTagChecker.hasNoConversionPrice></div><div class=\"alert alert-warning\" ng-message=hasBadConversionCouponCodes translate=directives.conversionTagChecker.hasBadConversionCouponCodes></div><div class=\"alert alert-warning\" ng-message=hasNoCouponCode ng-if=\"vm.project.invoice_calculation_type === 'normal'\">{{ 'directives.conversionTagChecker.hasNoCouponCode' | translate }}</div></div><div class=\"row setup-action\"><div class=\"col-xs-12 margin-y-half\" ng-if=vm.showReturn><button class=\"btn btn-primary btn-go-to-next pull-right\" ng-click=vm.goToNextStep() ng-if=!vm.project.is_demo>{{ 'directives.common.next' | translate }}</button></div></div><div ng-style=\"{visibility: vm.isLoading ? 'visible' : 'hidden'}\"><div class=text-center>{{ 'directives.conversionTagChecker.loadingConversionData' | translate }}</div><div class=spinner></div></div><table class=\"table config-table\" ng-if=\"vm.conversions.length > 0\"><tr><th>{{ 'directives.common.dateAndTimeOccurrence' | translate }}</th><th class=text-center>{{ 'directives.common.device' | translate }}</th><th>{{ 'directives.conversionTagChecker.urlAndSoOn' | translate }}</th></tr><tr ng-repeat=\"conversion in vm.conversions\"><td>{{conversion.created_at | zcDate : {smart:true} }}</td><td class=text-center>{{conversion.device | uppercase}}</td><td><div uib-tooltip={{conversion.url}}>{{conversion.url | limitTo:40}} <span ng-show=\"conversion.url.length > 40\">...</span></div><br><table class=\"table config-table table-bordered\"><tr><th>{{ 'directives.conversionTagChecker.conversionIdValue' | translate }}</th><td ng-class=\"{'bad-data': conversion.badConversionId}\">{{conversion.id}}</td></tr><tr><th>{{ 'directives.conversionTagChecker.conversionPriceValue' | translate }}</th><td ng-class=\"{'bad-data': conversion.badConversionPrice}\"><span class=pull-left style=color:lightgray>{{vm.currency.symbol}}</span> {{conversion.price}} <span class=pull-right style=color:lightgray>{{vm.currency.suffix}}</span></td></tr><tr ng-hide=\"vm.project.invoice_calculation_type === 'deemed'\"><th>{{ 'directives.conversionTagChecker.couponCode' | translate }}</th><td ng-class=\"{'bad-data': conversion.badConversionCouponCode}\">{{conversion.coupon_code}}</td></tr><tr ng-show=conversion.items.length><th>{{ 'directives.conversionTagChecker.productInfo' | translate }}</th><td><table class=\"table table-compact\"><thead><tr><th>id</th><th>{{ 'directives.conversionTagChecker.name' | translate }}</th><th>{{ 'directives.conversionTagChecker.price' | translate }}</th><th>{{ 'directives.conversionTagChecker.number' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"item in conversion.items\"><td>{{item.id || \"-\"}}</td><td>{{item.parsedName | limitTo:30}}</td><td>{{item.price || \"-\"}}</td><td>{{item.count || \"-\"}}</td></tr></tbody></table></td></tr></table></td></tr></table></div><div><div zcs-hide-when-production><a ng-click=vm.complete() ng-if=!vm.project.is_demo>{{ 'directives.conversionTagChecker.conversionTagInstallCompleteForTesting' | translate }}</a></div></div></div><zcs-notification-timezone project=vm.project></zcs-notification-timezone>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1325 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_ebisumart.html';
var html = "<p class=\"config-lead margin-y\" translate=directives.conversionTagChecker.ebisumart.note translate-value-code-start=\"<code>\" translate-value-code-end=\"</code>\"></p><p class=\"config-lead margin-y\" zcs-hide-when-oem translate=directives.conversionTagChecker.conversionTagInstallationDetails translate-value-url=\"<a href='https://zenclerklite.zendesk.com/hc/ja/articles/115003287768' target='_blank'> {{ 'directives.common.here' | translate }}</a>\"></p><code hljs hljs-language=html no-escape compile=true>\n<pre>&lt;script type=&quot;text/javascript&quot;&gt;\nvar {{vm.conversionTagPrefix}}_conversion_id = document.forms.HIDDEN_DATA_FORM.ORDER_DISP_NO.value;\nvar {{vm.conversionTagPrefix}}_conversion_price = document.forms.HIDDEN_DATA_FORM.GOKEI.value;\nvar {{vm.conversionTagPrefix}}_coupon_codes = [document.forms.HIDDEN_DATA_FORM.COUPON_CD.value];\nvar {{vm.conversionTagPrefix}}_conversion_items = [];\nvar item = {};\ndocument.getElementsByName(\"HIDDEN_DATA_FORM\")[0].childNodes.forEach(function(e) {\n  if(e.name === 'ITEM_NAME') { item.name = e.value }\n  else if(e.name === 'ITEM_CD') { item.id = e.value }\n  else if(e.name === 'ITEM_TEIKA') { item.price = parseInt(e.value) }\n  else if(e.name === 'ITEM_AMOUNT') { item.count = parseInt(e.value); {{vm.conversionTagPrefix}}_conversion_items.push(item); item = {}; }\n});\n&lt;/script&gt;</pre>\n</code>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1326 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_ecbeing.html';
var html = "<ng-include src=\"'/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_integration_brief.html'\"></ng-include><p class=\"config-lead margin-y\" zcs-hide-when-oem translate=directives.conversionTagChecker.conversionTagInstallationDetails translate-value-url=\"<a href='https://zenclerklite.zendesk.com/hc/ja/articles/217756388' target='_blank'> {{ 'directives.common.here' | translate }}</a>\"></p><code hljs hljs-language=html no-escape compile=true>\n<pre>&lt;script type=&quot;text/javascript&quot;&gt;\nvar {{vm.conversionTagPrefix}}_conversion_id = &quot;__%order_id%__&quot;;\nvar {{vm.conversionTagPrefix}}_conversion_price = &quot;__%order_total%__&quot;;\n&lt;/script&gt;</pre>\n</code>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1327 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_futureshop2.html';
var html = "<ng-include src=\"'/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_integration_brief.html'\"></ng-include><p class=\"config-lead margin-y\" zcs-hide-when-oem translate=directives.conversionTagChecker.conversionTagInstallationDetails translate-value-url=\"<a href='https://zenclerklite.zendesk.com/hc/ja/articles/218491537' target='_blank'> {{ 'directives.common.here' | translate }}</a>\"></p><p class=\"config-lead margin-y\" translate=directives.conversionTagChecker.futureshop2.usageNote1 translate-value-service=\"{{ vm.ZcsOemService.getName() }}\"></p><p translate=directives.conversionTagChecker.futureshop2.usageNote2></p><code hljs hljs-language=html no-escape compile=true>\n<pre>&lt;script type=&quot;text/javascript&quot;&gt;\nvar {{vm.conversionTagPrefix}}_conversion_id = \"$ORDER_ID$\";\nvar {{vm.conversionTagPrefix}}_conversion_price = \"$TOTAL_GOODS_AMOUNT$\";\nvar {{vm.conversionTagPrefix}}_conversion_items = []; </pre>\n</code><br>{{ 'directives.conversionTagChecker.futureshop2.usageNote3' | translate }} <code hljs hljs-language=html no-escape compile=true>\n<pre>\n{{vm.conversionTagPrefix}}_conversion_items.push({\n  id: \"$GOODS_NO$\",\n  name:　\"$GOODS_NAME$\",\n  price: \"$UNIT_PRICE$\",\n  count:　\"$BUY_COUNT$\"\n});</pre>\n</code><br>{{ 'directives.conversionTagChecker.futureshop2.usageNote4' | translate }} <code hljs hljs-language=html no-escape compile=true>\n<pre>\n&lt;/script&gt;</pre>\n</code><br>{{ 'directives.conversionTagChecker.futureshop2.usageNote5' | translate }}";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1328 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_integration_brief.html';
var html = "<p class=\"config-lead margin-y\" translate=directives.conversionTagChecker.integrationBrief translate-value-service=\"{{ vm.ZcsOemService.getName() }}\"></p>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1329 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_makeshop.html';
var html = "<div zcs-hide-when-oem><ng-include src=\"'/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_integration_brief.html'\"></ng-include><p class=\"config-lead margin-y\" zcs-hide-when-oem translate=directives.conversionTagChecker.conversionTagInstallationDetails translate-value-url=\"<a href='http://ms-manual.makeshop.jp/zenclerk/#step1' target='_blank'> {{ 'directives.common.here' | translate }}</a>\"></p><p class=\"config-lead margin-y\">{{ 'directives.conversionTagChecker.makeshop.managementNote' | translate }}<br><img src=/assets/tag-setup/makeshop-kanrigamen.png></p>{{ 'directives.conversionTagChecker.makeshop.startPart' | translate }} <code hljs hljs-language=html no-escape compile=true>\n  <pre>&lt;script type=&quot;text/javascript&quot;&gt;\n  var {{vm.conversionTagPrefix}}_conversion_id = &quot;[ORDER_NUM]&quot;;\n  var {{vm.conversionTagPrefix}}_conversion_price = [TOTAL_AMOUNT_TAX];\n  var {{vm.conversionTagPrefix}}_coupon_codes = [&quot;[COUPON_CODE]&quot;];\n  var {{vm.conversionTagPrefix}}_conversion_items = [];</pre>\n  </code><br>{{ 'directives.conversionTagChecker.makeshop.repeatPart' | translate }} <code hljs hljs-language=html no-escape compile=true>\n  <pre>{{vm.conversionTagPrefix}}_conversion_items.push({\n    id: &quot;[ITEM_CD_SYS]&quot;,\n    name: &quot;[ITEM_NAME_UTF8_256]&quot;,\n    url: &quot;[ITEM_URL]&quot;,\n    price: [ITEM_PRICE_TAX],\n    count: [ITEM_COUNT]\n  });</pre>\n  </code><br>{{ 'directives.conversionTagChecker.makeshop.endPart' | translate }} <code hljs hljs-language=html no-escape compile=true>\n  <pre>&lt;/script&gt;</pre>\n  </code></div><div zcs-makerepeater-only>{{ 'directives.conversionTagChecker.makeshop.installConversionTagBasedOnAboveManual' | translate }}<br>{{ 'directives.conversionTagChecker.makeshop.behaviorAfterInstallation' | translate }}</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_other_deemed.html';
var html = "<ng-include src=\"'/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_integration_brief.html'\"></ng-include><p class=\"config-lead margin-y\" zcs-hide-when-oem translate=directives.conversionTagChecker.conversionTagInstallationDetails translate-value-url=\"<a href='https://zenclerklite.zendesk.com/hc/ja/articles/218301157' target='_blank'> {{ 'directives.common.here' | translate }}</a>\"></p><code hljs hljs-language=html no-escape compile=true>\n<pre>&lt;script type=&quot;text/javascript&quot;&gt;\nvar {{vm.conversionTagPrefix}}_conversion_id = &quot;[{{ 'directives.conversionTagChecker.conversionId' | translate }}]&quot;;\nvar {{vm.conversionTagPrefix}}_conversion_price = &quot;[{{ 'directives.conversionTagChecker.conversionPrice' | translate }}]&quot;;\n&lt;/script&gt;</pre>\n</code><p class=config-lead>{{ 'directives.conversionTagChecker.otherDeemed.conversionUsageNote' | translate }}</p>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1331 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_other_normal.html';
var html = "<ng-include src=\"'/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_integration_brief.html'\"></ng-include><p class=\"config-lead margin-y\" zcs-hide-when-oem translate=directives.conversionTagChecker.conversionTagInstallationDetails translate-value-url=\"<a href='https://zenclerklite.zendesk.com/hc/ja/articles/218301157' target='_blank'> {{ 'directives.common.here' | translate }}</a>\"></p><code hljs hljs-language=html no-escape compile=true>\n<pre>&lt;script type=&quot;text/javascript&quot;&gt;\nvar {{vm.conversionTagPrefix}}_conversion_id = &quot;[{{ 'directives.conversionTagChecker.conversionId' | translate }}]&quot;;\nvar {{vm.conversionTagPrefix}}_conversion_price = &quot;[{{ 'directives.conversionTagChecker.conversionPrice' | translate }}]&quot;;\nvar {{vm.conversionTagPrefix}}_coupon_codes = [&quot;[{{ 'directives.conversionTagChecker.couponCode' | translate }}]&quot;];\n&lt;/script&gt;</pre>\n</code><p class=\"config-lead margin-y\">{{ 'directives.conversionTagChecker.otherNormal.conversionUsageNote' | translate }}</p>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1332 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_shopify.html';
var html = "<p class=\"config-lead margin-y\">{{ 'directives.conversionTagChecker.shopify.registerConversionTagBelow' | translate }}</p><p class=margin-y>{{ 'directives.conversionTagChecker.shopify.managementNote' | translate }}<br><br><img style=\"width: 100%; height: auto;\" src=/assets/tag-setup/shopify.jpg></p><code hljs hljs-language=html no-escape compile=true>\n<pre>&lt;script type=&quot;text/javascript&quot;&gt;\n  var zenclerk_conversion_id = '\\{\\{ order_number \\}\\}';\n  var zenclerk_conversion_price = '\\{\\{ total_price | money_without_currency \\}\\}';\n  var zenclerk_conversion_items = [];\n  {% for line_item in line_items %}\n  zenclerk_conversion_items.push({\n    id: '\\{\\{ line_item.sku \\}\\}',\n    price: '\\{\\{ line_item.line_price | money_without_currency \\}\\}',\n    count: `\\{\\{ line_item.quantity \\}\\}`,\n  });\n  {% endfor %}\n&lt;/script&gt;</pre>\n</code> <span class=margin-y style=\"display: block; margin-bottom: 0; font-size: .9em; color: #777; line-height: 1.8em;\" translate=directives.conversionTagChecker.conversionTagInstallationDetails translate-value-url=\"<a href='https://zenclerklite.zendesk.com/hc/ja/articles/218301157' target='_blank'> {{ 'directives.common.here' | translate }}</a>\"></span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1333 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_shopserve.html';
var html = "<ng-include src=\"'/templates/zenclerk_s/directives/conversion_tag_checker/conversion_tag_integration_brief.html'\"></ng-include><p class=\"config-lead margin-y\" zcs-hide-when-oem translate=directives.conversionTagChecker.conversionTagInstallationDetails translate-value-url=\"<a href='https://zenclerklite.zendesk.com/hc/ja/articles/218058397' target='_blank'> {{ 'directives.common.here' | translate }}</a>\"></p><code hljs hljs-language=html no-escape compile=true>\n<pre>&lt;script type=&quot;text/javascript&quot;&gt;\nvar {{vm.conversionTagPrefix}}_conversion_id = &quot;__ORD_NUM__&quot;;\nvar {{vm.conversionTagPrefix}}_conversion_price = &quot;__ORD_TOTAL__&quot;;\nvar {{vm.conversionTagPrefix}}_coupon_codes = [&quot;__COUPON_CODE__&quot;];\nvar {{vm.conversionTagPrefix}}_conversion_items = [];\nvar {{vm.conversionTagPrefix}}_items_str = &quot;__ITMS__&quot;.split(&quot;:&quot;);\nfor(var i=0; i &lt; {{vm.conversionTagPrefix}}_items_str.length; i++) {\n   var item_info = {{vm.conversionTagPrefix}}_items_str[i].split('/');\n\n   {{vm.conversionTagPrefix}}_conversion_items.push({\n       id: item_info[0],\n       price: item_info[2],\n       count: item_info[1]\n   });\n}\n&lt;/script&gt;</pre>\n</code>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1334 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/dashboard/active_campaigns_widget.html';
var html = "<div><ul class=list><li ng-repeat=\"campaign in $ctrl.campaigns\"><div class=row><div class=col-xs-8>{{campaign.name}}<br><small>{{campaign.start_at | zcDate}} - {{campaign.end_at | zcDate}}</small></div><div class=\"col-xs-4 text-right\"></div></div></li><li class=text-center><zcs-campaign-create-button project=$ctrl.project></zcs-campaign-create-button></li></ul></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1335 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/dashboard/conversion_chart_widget.html';
var html = "<div class=widget-conversion-chart><div class=\"chart chart-conversion\"><svg></svg></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1336 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/dashboard/cumulative_conversion_widget.html';
var html = "<div class=widget-cumulative-conversion><div class=\"chart chart-cumulative-conversion\"></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1337 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/dashboard/top_items_widget.html';
var html = "<div class=text-center ng-if=vm.isLoading><div class=spinner></div></div><div class=\"text-center padding-y\" ng-if=\"!vm.isLoading && (!vm.stats.items || vm.stats.items.length === 0)\" translate=directives.dashboard.topItemsWidget.noEnoughDataNote translate-value-url=\"<a href='{{ vm.conversionTagSettingPage }}'>{{ 'directives.dashboard.topItemsWidget.conversionTag' | translate }}</a>\"></div><div class=zcs-site-stats ng-if=vm.stats><ul class=list ng-if=vm.stats.items.length><li ng-repeat=\"item in vm.stats.items | limitTo:10\"><div class=row><div class=col-xs-8><div class=pull-left><a ng-href={{item.url}} target=_blank>{{item.name}}</a><br><small>{{item.price | zcCurrency: vm.currency.symbol:0:vm.currency.suffix}}</small></div></div><div class=\"col-xs-2 text-center\"><span>{{vm.min(item.monthly.conversion_ratio, 1) * 100 | number:1}}%</span><br><small>CVR</small></div><div class=col-xs-2><div class=\"counter pull-right\"><span uib-tooltip=\"{{ 'directives.dashboard.common.purchaseNumber' | translate: { count: item.monthly.conversion_count } }}\" tooltip-append-to-body=true>{{item.monthly.conversion_count}}</span> / <span uib-tooltip=\"{{ 'directives.dashboard.common.numberOfViews' | translate: { count: item.monthly.pv} }}\" tooltip-append-to-body=true>{{item.monthly.pv}}</span><div class=progress><div class=progress-bar role=progressbar aria-valuenow={{item.monthly.conversion_ratio}}*100 aria-valuemin=0 aria-valuemax=100 ng-style=\"{'width': item.monthly.conversion_ratio * 100 + '%'}\"><span class=sr-only>{{ 'directives.dashboard.topItemsWidget.progress' | translate: { percentage: '60%' } }}</span></div></div></div></div></div></li></ul></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1338 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/dashboard/top_pages_widget.html';
var html = "<div class=text-center ng-if=!vm.topPages><div class=spinner></div></div><div ng-show=vm.showNoDataOverlay class=no-data-overlay><i class=\"fa fa-lock\"></i><br>{{ 'directives.dashboard.common.noEnoughDataToDisplay' | translate }}</div><div ng-if=vm.topPages.length><ul class=list><li ng-repeat=\"page in vm.topPages | limitTo: 6\"><div class=row><div class=col-xs-8><a ng-href={{page.url}} title={{page.url}} class=romaji target=_blank>{{page.url | limitTo: 60}}</a></div><div class=\"col-xs-4 text-right\"><span class=difference uib-tooltip=\"{{ 'directives.dashboard.common.tooltipForNumberOfViews' | translate: { date: ( page.weeklyData[1].date | date:'MM/dd' ), value: page.weeklyData[1].value } }}\"><span ng-if=\"page.weeklyData[0].value > page.weeklyData[1].value\">+</span>{{page.weeklyData[0].value - page.weeklyData[1].value}} <img ng-if=\"page.weeklyData[0].value > page.weeklyData[1].value\" src=/assets/img/icon-rank-up.svg> <img ng-if=\"page.weeklyData[0].value == page.weeklyData[1].value\" src=/assets/img/icon-rank-equal.svg> <img ng-if=\"page.weeklyData[0].value < page.weeklyData[1].value\" src=/assets/img/icon-rank-down.svg></span> <span class=badge uib-tooltip=\"{{ 'directives.dashboard.common.tooltipForNumberOfViews' | translate: { date: ( page.weeklyData[0].date | date:'MM/dd' ), value: page.weeklyData[0].value } }}\" tooltip-append-to-body=true ng-class=\"{ 'badge-alert': page.weeklyData[0].value < page.weeklyData[1].value, 'badge-success': page.weeklyData[1].value < page.weeklyData[0].value }\">{{page.weeklyData[0].value}}</span></div></div></li></ul></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1339 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/dashboard/top_referrers_widget.html';
var html = "<div class=text-center ng-if=!vm.topReferrers><div class=spinner></div></div><div ng-show=vm.showNoDataOverlay class=no-data-overlay><i class=\"fa fa-lock\"></i><br><span translate=directives.dashboard.common.noEnoughDataToDisplay></span></div><div ng-if=vm.topReferrers.length><ul class=list><li ng-repeat=\"referrer in vm.topReferrers | limitTo: 6\"><div class=row><div class=col-xs-8><a ng-if=\"referrer.url && referrer.url !== 'null' && referrer.url !== 'undefined'\" ng-href={{referrer.url}} title={{referrer.url}} class=romaji target=_blank>{{referrer.url | limitTo: 60 }}</a> <span ng-if=\"!referrer.url || referrer.url === 'null' || referrer.url === 'undefined'\">{{ 'directives.dashboard.topReferrersWidget.directVisit' | translate }}</span></div><div class=\"col-xs-4 text-right\"><span class=difference uib-tooltip=\"{{ 'directives.dashboard.common.tooltipForNumberOfViews' | translate: { date: ( referrer.weeklyData[1].date | date:'MM/dd' ), value: referrer.weeklyData[1].value } }}\"><span ng-if=\"referrer.weeklyData[0].value > referrer.weeklyData[1].value\">+</span>{{referrer.weeklyData[0].value - referrer.weeklyData[1].value}} <img ng-if=\"referrer.weeklyData[0].value > referrer.weeklyData[1].value\" src=/assets/img/icon-rank-up.svg> <img ng-if=\"referrer.weeklyData[0].value == referrer.weeklyData[1].value\" src=/assets/img/icon-rank-equal.svg> <img ng-if=\"referrer.weeklyData[0].value < referrer.weeklyData[1].value\" src=/assets/img/icon-rank-down.svg></span> <span class=badge uib-tooltip=\"{{ 'directives.dashboard.common.tooltipForNumberOfViews' | translate: { date: ( referrer.weeklyData[0].date | date:'MM/dd' ), value: referrer.weeklyData[0].value } }}\" uib-tooltip-html tooltip-append-to-body=true ng-class=\"{ 'badge-alert': referrer.weeklyData[0].value < referrer.weeklyData[1].value, 'badge-success': referrer.weeklyData[1].value < referrer.weeklyData[0].value }\">{{referrer.weeklyData[0].value}}</span></div></div></li></ul></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1340 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/dashboard/widget.html';
var html = "<div class=\"panel widget\"><div class=\"panel-header widget-header\" ng-transclude=title></div><div class=\"panel-content widget-content\" ng-transclude=content></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1341 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/estimated_revenue/estimated_revenue.html';
var html = "<span class=campaign-estimated-revenue ng-if=\"vm.revenue >= vm.limit\">{{vm.revenue || 0 | zcCurrency:vm.currency.symbol:0:vm.currency.suffix}}</span> <span class=campaign-estimated-revenue ng-if=\"!vm.revenue || vm.revenue < vm.limit\" uib-tooltip=\"{{ 'directives.estimatedRevenue.noEnoughDataToPredictOrEmailIsForEmailNewsletterDelivery' | translate }}\"><small class=no-data-text>{{ 'directives.estimatedRevenue.cannotPredict' | translate }} <span class=\"badge badge-tooltip\"><i class=\"fa fa-question\"></i></span></small></span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1342 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/exclude_ip_editor/exclude_ip_editor.html';
var html = "<div class=container-fluid><div class=\"row exclude-ip-editor\"><div class=\"col-sm-10 col-sm-offset-1\"><div class=row><div class=\"col-sm-8 col-sm-offset-2 panel padding-y\"><section><h1 translate=directives.excludeIp.setExcludePurchaseFromCompany></h1><p translate=directives.excludeIp.purchaseInfoNote translate-value-service=\"{{ vm.ZcsOemService.getName() }}\" translate-value-target=\"{{ ['color_me_shop', 'shopify'].includes(vm.project.integrated_with) ? ( 'directives.excludeIp.campaignReport' | translate ) : ( 'directives.excludeIp.billingInfo' | translate ) }}\"></p><p translate=directives.excludeIp.toExcludeInHousePurchase></p><p class=padding-y><span class=text-warning translate=directives.excludeIp.globalIpIsBeingAccessedNote translate-value-ip={{vm.currentIp}}></span></p></section><section><h2>{{ 'directives.excludeIp.settingMethod' | translate }}</h2><p translate=directives.excludeIp.addExcludedIpNote></p></section></div></div><div class=\"col-sm-12 exclude-ip-box margin-y\" ng-if=\"vm.excludeIps.length > 0\"><div class=\"col-sm-5 col-sm-offset-2\">{{ 'directives.excludeIp.ipExample' | translate }}</div><div ng-repeat=\"excludeIp in vm.excludeIps\" class=\"exclude-ip-edit-wrapper row\"><zcs-exclude-ip-form project=vm.project exclude-ip=excludeIp on-destroy=vm.onDestroy(excludeIp) current-ip=vm.currentIp></zcs-exclude-ip-form></div></div><div class=\"col-sm-12 margin-y text-center\"><div class=\"btn btn-primary\" ng-click=vm.addExcludeIp()><i class=\"fa fa-plus\"></i> {{ 'directives.excludeIp.addExcludedIp' | translate }}</div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1343 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/exclude_ip_editor/exclude_ip_form.html';
var html = "<form name=excludeIpForm ng-submit=vm.saveExcludeIp()><div class=\"col-sm-5 col-sm-offset-2\"><input type=text class=form-control minlength=3 required placeholder={{vm.currentIp}} ng-model=vm.excludeIp.ip ng-pattern=\"/\\b(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\b/\"></div><div class=col-sm-4><span style=\"width: 50%\"><button ng-disabled=\"excludeIpForm.$invalid || !excludeIpForm.$dirty || vm.isSaving\" class=\"btn btn-primary\">{{ 'directives.common.save' | translate }}</button></span> <span style=\"width: 50%\"><div class=\"btn btn-danger\" confirm-click=vm.destroyExcludeIp() confirm-modal ng-disabled=vm.isDestroying>{{ 'directives.common.delete' | translate }}</div></span></div></form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1344 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/exclude_page_editor/exclude_page_editor.html';
var html = "<div class=container-fluid><div class=\"row page-type-editor\"><div class=col-sm-12><div class=row><div class=\"col-sm-10 col-sm-offset-1 panel padding-y\"><section><h1>{{ 'directives.excludePage.excludePageSetting' | translate }}</h1><p translate=directives.excludePage.usersWhoAccessedTheUrlOfThePageSpecifiedBelow></p><p translate=directives.excludePage.excludeLogicNote></p></section><section><h2>{{ 'directives.excludePage.directSettingMethod' | translate }}</h2><h2>{{ 'directives.excludePage.example' | translate }}</h2><p translate=directives.excludePage.toExcludeTheUrl translate-value-url=\"{{ vm.baseUrl }}\" translate-value-code-start=\"<code>\" translate-value-code-end=\"</code>\"></p><br><p translate=directives.excludePage.toExcludeGoogle translate-value-code-start=\"<code>\" translate-value-code-end=\"</code>\"></p></section><section><span><div class=\"btn pull-right\" ng-show=!showExcludeForm ng-click=\"showExcludeForm = !showExcludeForm\">{{ 'directives.campaign.actionMenu.edit' | translate }}</div><button class=\"btn btn-success pull-right\" form=submit-exclude-form ng-show=showExcludeForm ng-click=\"showExcludeForm = !showExcludeForm\" type=submit>{{ 'directives.common.save' | translate }}</button><h2>{{ 'directives.excludePage.conditions' | translate }}</h2><span translate=directives.excludePage.exclusionPercentageText translate-value-rate=\"{{ exclusionPercentage }}\" style=\"color: red; font-size: x-small\"></span></span><div ng-show=!showExcludeForm><div ng-if=\"vm.pageTypes.length > 0\" ng-repeat=\"pageType in vm.pageTypes\" ng-show=\"pageType.match_pattern.length > 0\">{{ 'directives.excludePage.pageUrlPath' | translate }} {{ 'directives.excludePage.' + pageType.match_type | translate }} <code>{{ pageType.match_pattern }}</code></div></div><div class=padding-y ng-show=showExcludeForm><zcs-exclude-page-form project=vm.project base-url=vm.baseUrl page-types=vm.pageTypes></zcs-exclude-page-form></div></section></div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1345 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/exclude_page_editor/exclude_page_form.html';
var html = "<form id=submit-exclude-form name=excludePageForm ng-submit=vm.savePageType()><div class=row ng-repeat=\"pageType in vm.pageTypes\"><div class=\"col-sm-2 base-url\">{{ 'directives.excludePage.pageUrlPath' | translate }}</div><div class=\"col-sm-2 form-group\"><select class=form-control ng-change=vm.pageTypeChanged(pageType) ng-model=pageType.match_type ng-options=\"type.name as type.label for type in vm.matchTypes\"></select></div><div class=col-sm-2><input type=text name=match_pattern class=form-control minlength=3 required ng-change=vm.pageTypeChanged(pageType) ng-model=pageType.match_pattern><p style=\"color: #ff5c79\" ng-if=\"pageType.match_type === 'prefix' && !pageType.match_pattern.startsWith('/') && pageType.match_pattern.length >= 3\">{{ 'directives.excludePage.urlMustStartWithSlash' | translate }}</p></div><div class=col-sm-4><span style=\"width: 25%\"><div class=\"btn btn-danger\" confirm-click=vm.destroyPageType(pageType) confirm-modal ng-disabled=vm.isDestroying><i class=\"fa fa-minus\"></i></div></span> <span ng-show=$last style=\"width: 25%\"><div class=\"btn btn-success\" ng-disabled=\"vm.pageTypes.length > vm.excludedPageTypeLimit\" ng-click=vm.addPageType()><i class=\"fa fa-plus\"></i></div></span></div></div></form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/help/launcher.html';
var html = "<div zcs-hide-when-oem class=help-launcher-wrapper><div class=\"help-launcher help-launcher--{{$ctrl.class}}\" pe-track=lite.help.toggle ng-click=\"$ctrl.toggleHelp = !$ctrl.toggleHelp\" ng-class=\"{'active': $ctrl.toggleHelp}\" ng-hide=$ctrl.hideMainHelp()><div class=help-launcher-container><i class=\"fa fa-question\"></i><div class=help-menu><a pe-track=lite.help.notifications ng-click=$ctrl.openProductChanges()><i class=\"fa fa-bell\"></i> {{ 'directives.common.notice' | translate }}<div class=help-menu-notification></div></a> <a pe-track=lite.help.support href=https://sites.google.com/appier.com/aideal-lite/home target=_blank><i class=\"fa fa-book\"></i> {{ 'directives.help.launcher.helpCenter' | translate }}</a></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/notification/notification-alert.html';
var html = "<div class=\"container container-limited\" ng-if=\"$ctrl.currentProject && !$ctrl.currentProject.is_oem && !$ctrl.isDisabled && $ctrl.notifications.length\"><div class=row><div class=col-sm-12><div ng-repeat=\"notification in $ctrl.notifications\" pe-track=notification.alert pe-attrs=\"{ notification: notification.key, state: $ctrl.$state.current.name }\"><div class=notification-alert ng-click=notification.linkAction() ng-class=notification.containerClass ng-show=$ctrl.isAllowedToShow(notification)><i ng-class=notification.iconClass></i><div ng-if=notification.html><span ng-bind-html=notification.html></span></div><div ng-if=notification.text>{{::notification.text}}</div><svg-embed ng-if=notification.allowDismiss ng-click=$ctrl.dismiss(notification) class=\"pull-right notification-alert__close\" url=\"'/assets/img/icon-close.svg'\"></svg-embed></div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1348 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/notification/notification-panel.html';
var html = "<div class=notification-panel pe-track=lite.pannel.toggle ng-class=\"{'notification-panel--active': $ctrl.isPanelActive}\"><div class=notification-panel__title>{{ 'directives.common.notice' | translate }} <a class=notification-panel__external-link ui-sref=zenclerkS.productChanges ng-click=$ctrl.togglePanel()><i class=\"fa fa-external-link\"></i></a><svg-embed ng-click=$ctrl.togglePanel() class=\"pull-right notification-panel__close\" url=\"'/assets/img/icon-close.svg'\"></svg-embed></div><div class=notification-panel__body><ng-include src=\"'/templates/zenclerk_s/common/product_changes/product_changes.html'\"></ng-include></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1349 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/notification/timezone.html';
var html = "<div ng-if=\"vm.isTimezoneDiff && vm.showAlert\" class=text-center ng-class=\"{'fixed-bottom': !vm.static}\"><div class=\"alert alert-dismissible inline-block\" ng-class=\"{'alert-warning': vm.status === 'warning', 'alert-danger': vm.status === 'danger'}\" role=alert><span class=\"fa fa-warning\"></span> <span translate=directives.notification.timezoneDifferenceWarning translate-value-timezone=\"{{ vm.project.region | gmtNotation }}\"></span> <button type=button class=\"btn btn-close btn-close--small\" data-dismiss=alert aria-label=Close ng-click=vm.hideAlert()></button></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/profile/profile.html';
var html = "<div class=profile><div class=row><ul class=\"nav nav-tabs nav-justified\"><li role=presentation ng-class=\"{'active': $ctrl.state.nav == 'info'}\" ng-click=\"$ctrl.nav('info')\"><a>{{ 'directives.profile.info' | translate }}</a></li><li zcs-hide-when-integrated=color_me_shop,shopify role=presentation ng-class=\"{'active': $ctrl.state.nav == 'password'}\" ng-click=\"$ctrl.nav('password')\"><a>{{ 'directives.profile.changePassword' | translate }}</a></li></ul></div><form ng-class=\"{'active': $ctrl.state.nav == 'info'}\" name=profile_info class=form-horizontal ng-submit=$ctrl.updateInfo($ctrl.user)><div class=form-group><label for=full_name class=\"col-sm-3 control-label\">{{ 'directives.common.fullName' | translate }}</label><div class=col-sm-9><input id=full_name type=text class=form-control ng-model=$ctrl.user.full_name ng-maxlength=80 required></div></div><div class=form-group><label for=coupon_code class=\"col-sm-3 control-label\">{{ 'directives.profile.email' | translate }}</label><div class=col-sm-9><input id=email type=email class=form-control ng-model=$ctrl.user.email ng-maxlength=80 required></div></div><div class=form-group><label for=department class=\"col-sm-3 control-label\">{{ 'directives.profile.companyName' | translate }}</label><div class=col-sm-9><input id=company_name type=text class=form-control ng-model=$ctrl.user.company_name ng-maxlength=80></div></div><div class=form-group><label for=department class=\"col-sm-3 control-label\">{{ 'directives.profile.department' | translate }}</label><div class=col-sm-9><input id=department type=text class=form-control ng-model=$ctrl.user.department ng-maxlength=80></div></div><div class=form-group><label for=position class=\"col-sm-3 control-label\">{{ 'directives.profile.position' | translate }}</label><div class=col-sm-9><input id=position type=text class=form-control ng-model=$ctrl.user.position ng-maxlength=80></div></div><div zcs-hide-when-oem class=form-group style=\"margin-top: 1em; padding-top: 1em;\"><label for=language class=\"col-sm-3 control-label\">{{ 'directives.profile.selectLanguage' | translate }}</label><div class=col-sm-9><select id=language class=form-control ng-options=\"'sharedModules.common.i18n.code.' + language | translate for language in $ctrl.availableLanguages\" ng-model=$ctrl.user.lang></select></div></div><div class=\"row text-center security-center-hint\">{{ 'directives.profile.securityCenterHint' | translate }}<a pe-track=lite.profile.securityCenter href=\"https://myaccount.appier.com/\" target=_blank rel=\"noopener noreferrer\">{{ 'directives.profile.securityCenterLink' | translate }} <i class=\"fa fa-external-link\"></i></a>{{ 'directives.profile.securityCenterHintSuffix' | translate }}</div><div class=\"row text-center footer\"><button type=submit class=\"btn btn-primary\" ng-disabled=profile_info.$invalid>{{ 'directives.profile.change' | translate }}</button></div></form><form ng-class=\"{'active': $ctrl.state.nav == 'password'}\" name=profile_password class=form-horizontal ng-submit=$ctrl.updatePassword($ctrl.user)><div class=form-group><input ng-show=false type=text autocomplete=username> <label for=user_current_password class=\"col-sm-4 control-label\">{{ 'directives.profile.currentPassword' | translate }}</label><div class=col-sm-8><input type=password name=user_current_password autocomplete=current-password class=form-control tabindex=1 ng-model=$ctrl.user.current_password required ng-minlength=8></div></div><div class=form-group><label for=user_password class=\"col-sm-4 control-label\" style=\"white-space: pre\" translate=directives.profile.password></label><div class=col-sm-8><input type=password name=user_password autocomplete=new-password class=form-control tabindex=1 ng-model=$ctrl.user.password required ng-minlength=8></div></div><div class=form-group><label for=user_password_confirmation class=\"col-sm-4 control-label\" style=\"white-space: pre\" translate=directives.profile.passwordConfirmation></label><div class=col-sm-8><input type=password name=user_password_confirmation autocomplete=new-password class=form-control tabindex=2 ng-model=$ctrl.user.password_confirmation required ng-minlength=8></div></div><div class=\"row text-center footer\"><button type=submit class=\"btn btn-primary\" ng-disabled=profile_password.$invalid>{{ 'directives.profile.change' | translate }}</button></div></form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/project/free_shipping_cost_editor/free_shipping_cost_editor.html';
var html = "<svg-embed ng-click=$ctrl.close() class=modal-close url=\"'/assets/img/icon-close.svg'\"></svg-embed><div class=\"campaign-edit-free-shipping text-center\"><div class=modal-header>{{ 'directives.freeShippingCostEditor.freeShippingAverageCostSetting' | translate }}</div><form ng-submit=$ctrl.setFreeShippingCost() class=\"modal-body text-left\" name=setFreeShippingCost><label>{{ 'directives.freeShippingCostEditor.freeShippingAverageCost' | translate }}</label> <input class=form-control type=number ng-required=true min=0 ng-model=$ctrl.freeShippingCost><br><span class=help-block ng-if=!$ctrl.project.free_shipping_cost>{{ 'directives.freeShippingCostEditor.defaultShippingAmount' | translate: { amount: $ctrl.currency.symbol + 500 + $ctrl.currency.suffix } }}</span><div class=modal-footer><button type=submit class=\"btn btn-primary\" pe-track=campaignSetFreeShippingModal.save ng-disabled=\"setFreeShippingCost.$invalid || !setFreeShippingCost.$dirty || $ctrl.isSaving\">{{ 'directives.freeShippingCostEditor.set' | translate }}</button> <button type=button class=\"btn btn-default\" ng-click=$ctrl.close() pe-track=campaignSetFreeShippingModal.cancel>{{ 'directives.freeShippingCostEditor.cancel' | translate }}</button></div></form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/project_user_activity/user_activity.html';
var html = "<div class=\"container-fluid project-user-activity\"><h2>{{ 'directives.projectUserActivity.contactActivity' | translate }} <span class=\"badge pull-right\">{{vm.projects.length}}</span></h2><div class=\"row project card list user-list\" ng-repeat=\"project in vm.projects\"><div class=col-sm-9><a ui-sref=\"zenclerkS.project.dashboard({apikey: project.apikey})\">{{project.title}}</a></div><div class=col-sm-3><div class=text-right><div class=\"btn btn-default\" ng-click=vm.toggleUserList(project)><i class=fa ng-class=\"{'fa-caret-down': !project._showUserList, 'fa-caret-up': project._showUserList}\"></i> {{ 'directives.projectUserActivity.userInformation' | translate }}</div></div></div><div class=col-sm-12><table class=table ng-show=project._showUserList><tr><th>{{ 'directives.common.fullName' | translate }}</th><th class=text-right>{{ 'directives.projectUserActivity.numberOfSessions' | translate }}</th><th class=text-right>{{ 'directives.projectUserActivity.readingTimeInMinutes' | translate }}</th><th class=text-right>{{ 'directives.projectUserActivity.lastViewed' | translate }}</th></tr><tr ng-repeat=\"user in project.users\"><td>{{user.full_name}}</td><td class=text-right>{{user.sessions.length}}</td><td class=text-right>{{user.combinedDwell | number:0}}</td><td class=text-right><span ng-if=user.lastViewed>{{user.lastViewed | zcDate}}</span> <span ng-if=!user.lastViewed>{{ 'directives.projectUserActivity.neverLoggedIn' | translate }}</span></td></tr></table></div><zcs-user-activity-graph project=project></zcs-user-activity-graph></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/project_user_activity/user_activity_graph.html';
var html = "<div><svg></svg><div class=activity-graph-tooltip><div class=activity-graph-tooltip-text></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/projects_in_installation/projects_in_installation.html';
var html = "<div class=\"container-fluid agency-projects-in-installation\"><h2>{{ 'directives.projectsInInstallation.siteDetailsForInstall' | translate }} <span class=\"badge pull-right\">{{$ctrl.projectsWithoutCampaign}}</span></h2><div class=row ng-if=\"$ctrl.projectsWithoutCampaign === 0\"><div class=\"col-sm-8 col-sm-offset-2\"><div class=\"alert alert-info\">{{ 'directives.projectsInInstallation.allSitesOfferCampaigns' | translate }}</div></div></div><div class=\"row project card list\" ng-repeat=\"project in $ctrl.projects | orderBy:'status'\" ng-if=\"project.status < 7\"><div class=col-sm-9><span class=\"label label-warning\" ng-if=project.is_test>TEST</span> <a ui-sref=\"zenclerkS.project.dashboard({apikey: project.apikey})\">{{project.title}} ({{project.apikey}})</a></div><div class=\"col-sm-3 text-right\"><span class=\"label label-success\" ng-if=\"project.status === 6\">{{ 'directives.projectsInInstallation.installCompleted' | translate }}</span> <span class=\"label label-danger\" ng-if=\"project.status < 6\">{{ 'directives.projectsInInstallation.installing' | translate }}</span></div><ul class=\"col-sm-12 step-selector\" ng-if=\"project.status < 6\"><li ng-repeat=\"(i, status) in $ctrl.statuses\" class=project-installation-status ng-class=\"{ 'before-active': project.status > i, 'active': project.status === i }\">{{status.name}}</li></ul></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1355 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/projects_without_campaign/projects_without_campaign.html';
var html = "<div class=\"container-fluid agency-projects-without-campaign\" ng-if=\"vm.projects.length > 0\"><h2>{{ 'directives.projectsWithoutCampaign.deliveryStatus' | translate }} <span class=\"badge pull-right\">{{vm.projects.length}}</span></h2><div class=\"row project card list\" ng-repeat=\"project in vm.projects\"><div class=col-sm-9><a ui-sref=\"zenclerkS.project.dashboard({apikey: project.apikey})\">{{project.title}}</a></div><div class=\"col-sm-3 text-right\"><div ng-if=project.activeCampaigns.length><span class=\"label label-success\">{{ 'directives.projectsWithoutCampaign.campaignInOperation' | translate }}</span></div><div ng-if=\"!project.activeCampaigns.length && project.lastEndedCampaign\">{{ 'directives.projectsWithoutCampaign.lastCampaignEndDate' | translate }} {{project.lastEndedCampaign.end_at | zcDate}}</div><div ng-if=\"!project.activeCampaigns.length && !project.lastEndedCampaign\">{{ 'directives.projectsWithoutCampaign.theCampaignIsNotRunning' | translate }}</div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/realtime/bar-chart.html';
var html = "<div class=realtime-bar-chart-container><svg class=realtime-bar-chart></svg></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/realtime_visitor_visualizer/realtime_visitor_visualizer.html';
var html = "<div class=realtime_visitor_visualizer><div class=\"container-fluid current-visitor-visualizer-wrapper\"><div class=\"col-md-12 text-center\"><div class=number-xl>{{$ctrl.sessions.length}}</div><small>{{ 'directives.realtime.visualizer.numberOfCurrentUser' | translate }}</small></div><div class=\"col-md-10 col-md-offset-1 current-visitor-visualizer d3\" ng-hide=$ctrl.hideUsers></div></div><div class=\"container-fluid current-visitor-segmentation\" ng-if=!$ctrl.hideSegments><div class=\"col-md-10 col-md-offset-1\"><div class=\"col-md-6 col-sm-offset-3\"><div class=\"title col-md-12\" translate=directives.realtime.visualizer.classificationUsingOnlyTags translate-value-service=\"{{ $ctrl.ZcsOemService.getName() }}\"></div><ul class=col-md-12><li ng-repeat=\"segment in $ctrl.segments\" ng-if=$ctrl.isEnabledSegment(segment)>{{$ctrl.getSegmentLabel(segment)}}<div class=segment-wrapper><div class=\"{{$ctrl.getSegmentClass(segment.name)}}-bg segment\" ng-style=\"{'width': $ctrl.percent2Em($ctrl.segmentCounts[segment.name]), 'height': $ctrl.percent2Em($ctrl.segmentCounts[segment.name])}\"></div></div><span class=number>{{$ctrl.segmentCounts[segment.name] | number: 1}}%</span></li></ul></div></div></div><section class=exited-visitor><div class=container-fluid><div class=row><div class=col-sm-12><small class=\"pull-right text-sm\" style=\"margin-top: -2.5em\" translate=directives.realtime.visualizer.withinHours translate-value-hours=24></small></div><div class=col-md-4><span class=number-xl><changing-number number=$ctrl.conversions.length></changing-number></span> <small>{{ 'directives.realtime.visualizer.usersLeftWithPurchased' | translate }}</small></div><div class=col-md-4><span class=number-xl>{{$ctrl.conversions.length/($ctrl.conversions.length+$ctrl.nonConversions.length)*100 | number:1}}%</span> <small>CVR</small></div><div class=col-md-4><span class=number-xl><changing-number number=$ctrl.nonConversions.length></changing-number></span> <small>{{ 'directives.realtime.visualizer.usersLeftWithoutPurchased' | translate }}</small></div></div></div></section></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/tracking_tag_checker/tracking_tag_checker.html';
var html = "<div id=installationTrackingTag class=tracking-tag-checker><section class=text-center ng-if=vm.project.tracking_tag_confirmed_at><div class=\"alert alert-success\">{{ 'directives.trackingTagChecker.trackingTagInstalled' | translate }}</div><div class=\"btn btn-default margin-y\" ng-click=vm.toggleDetails() ng-if=\"!vm.showDetails && !vm.project.is_demo\"><i class=\"fa fa-caret-down\"></i> {{ 'directives.trackingTagChecker.checkTheDetails' | translate }}</div></section><div ng-show=\"!vm.project.tracking_tag_confirmed_at || vm.showDetails\"><div class=\"row setup-action\" ng-if=vm.showReturn><div class=col-xs-6><a class=\"btn btn-default pull-left\" ui-sref=zenclerkS.project.setup.pricing zcs-hide-when-oem>{{ 'directives.common.return' | translate }}</a></div></div><h2 class=config-subtitle>{{ 'directives.trackingTagChecker.trackingTag' | translate }}</h2><div class=\"row text-center\" zcs-makerepeater-only><a class=\"btn btn-default\" target=_blank ng-if=\"vm.project.shopping_cart_asp === 'makeshop'\" href=\"http://manual.makeshop.jp/hc/ja/articles/33974006349081/\"><i class=\"fa fa-download\"></i> <span style=\"text-transform: none\">MakeRepeater</span>{{ 'directives.trackingTagChecker.manualForPurchasingAssistanceLinkage' | translate }}</a> <a class=\"btn btn-default\" target=_blank ng-if=\"vm.project.shopping_cart_asp === 'futureshop2'\" href=\"https://cvhelp.makerepeater.jp/【futureshop2】購入アシスト連携設定方法/\"><i class=\"fa fa-download\"></i> <span style=\"text-transform: none\">FutureShop2</span>{{ 'directives.trackingTagChecker.manualForPurchasingAssistanceLinkage' | translate }}</a></div><div class=\"well margin-y\" zcs-makerepeater-only><p class=config-lead translate=directives.trackingTagChecker.copyTheTrackingTagManual1 translate-value-code-start=\"<code>\" translate-value-code-end=\"</code>\"></p><p class=config-lead translate=directives.trackingTagChecker.tagInstallCompleteWhenTrafficGenerated></p><code hljs hljs-language=html no-escape compile=true>&lt;script type=&quot;text/javascript&quot; src=&quot;//{{vm.host}}/publish/{{vm.project.apikey}}.js&quot;&gt;&lt;/script&gt;</code></div><div ng-switch=vm.project.integrated_with class=\"well margin-y\"><div ng-switch-default class=\"well margin-y\" zcs-hide-when-oem><p class=config-lead translate=directives.trackingTagChecker.copyTheTrackingTagManual2 translate-value-code-start=\"<code>\" translate-value-code-end=\"</code>\"></p><p class=\"config-lead margin-y\" zcs-hide-when-oem translate=directives.trackingTagChecker.detailedInstallationMethod translate-value-url=\"<a href='https://zenclerklite.zendesk.com/hc/ja/articles/218301157' target='_blank'>{{ 'directives.common.here' | translate }}</a>\"></p><code hljs hljs-language=html no-escape compile=true>&lt;script type=&quot;text/javascript&quot; src=&quot;//{{vm.host}}/publish/{{vm.project.apikey}}.js&quot;&gt;&lt;/script&gt;</code></div><div ng-switch-when=vtex class=\"well margin-y\" zcs-hide-when-oem><div class=config-lead translate=directives.trackingTagChecker.vtexTrackingTagInstruction1></div><br><div class=config-lead translate=directives.trackingTagChecker.vtexTrackingTagInstruction2 translate-value-apikey={{vm.project.apikey}}></div><br><div class=config-lead translate=directives.trackingTagChecker.vtexTrackingTagInstruction3></div><br><code hljs hljs-language=html no-escape compile=true>\n(function(){\n  var aidealLiteTrackingTag = document.createElement(\"script\");\n  aidealLiteTrackingTag.type = \"text/javascript\";\n  aidealLiteTrackingTag.async = true;\n  aidealLiteTrackingTag.src = \"//{{vm.host}}/publish/{{vm.project.apikey}}.js\";\n  var script0 = document.getElementsByTagName(\"script\")[0];\n  script0.parentNode.insertBefore(aidealLiteTrackingTag, script0);\n})();\n        </code></div></div><div ng-if=!vm.hasTagErrors()><div class=\"alert alert-success text-center\">{{ 'directives.trackingTagChecker.trackingTagInstallIsComplete' | translate }}</div></div><div ng-messages=vm.errors><div ng-switch=vm.project.integrated_with class=\"alert alert-danger\" ng-message=noHistories>{{ 'directives.trackingTagChecker.trackingTagCouldNotBeConfirmed' | translate }}<div ng-switch-when=color_me_shop translate=directives.trackingTagChecker.pleaseVisitTheSite></div><div ng-switch-default translate=directives.trackingTagChecker.pleaseInstallATrackingTagToAccessTheSite></div></div><div class=\"alert alert-danger\" ng-message=notEnoughSamples><div ng-hide=\"vm.project.shopping_cart_asp === 'makeshop'\" translate=directives.trackingTagChecker.theTagWasFoundButNoEnoughData translate-value-histories=\"{{ vm.currentRequiredHistories }}\"></div></div><div class=\"alert alert-warning\" ng-message=notFoundPcOrTablet>{{ 'directives.trackingTagChecker.notFoundPcOrTablet' | translate }}</div><div class=\"alert alert-warning\" ng-message=notFoundSP>{{ 'directives.trackingTagChecker.notFoundSP' | translate }}</div></div><div class=\"row setup-action\"><div class=\"col-xs-12 margin-y-half\" ng-if=vm.showReturn><button class=\"btn btn-primary btn-go-to-next pull-right\" ng-click=vm.goToNextStep() ng-if=!vm.project.is_demo>{{ 'directives.trackingTagChecker.goToConversionTagSettings' | translate }}</button></div></div><div ng-style=\"{visibility: vm.isLoading ? 'visible' : 'hidden'}\"><div class=text-center>{{ 'directives.trackingTagChecker.loadingTrackingData' | translate }}</div><div class=spinner></div></div><div ng-hide=\"vm.histories.length === 0\"><table class=table><tr><th>{{ 'directives.trackingTagChecker.numberOfPVs' | translate }}</th><th>URL</th></tr><tr ng-repeat=\"url in vm.listUrls\"><td>{{url.count}}</td><td><a ng-href={{url.url}} target=blank>{{url.url | limitTo: 80}}</a> <span ng-show=\"history.url.length > 60\">...</span></td></tr></table></div><br><div class=row ng-hide=\"vm.histories.length === 0\"><div class=col-sm-12>{{ 'directives.trackingTagChecker.byDevice' | translate }}</div><div class=\"col-sm-6 device-graph\"><svg></svg></div><div class=col-sm-6>PC: <span ng-class=\"{'bad-data': vm.percentages.pc < 0.5}\">{{vm.percentages.pc | number: 1}}%</span><br>SP: <span ng-class=\"{'bad-data': vm.percentages.sp < 0.5}\">{{vm.percentages.sp | number: 1}}%</span><br>Tablet: <span ng-class=\"{'bad-data': vm.percentages.tablet < 0.5}\">{{vm.percentages.tablet | number: 1}}%</span></div></div><br><div ng-hide=\"vm.histories.length === 0\"><span translate=directives.trackingTagChecker.rawDataRecords translate-value-length=\"{{ vm.histories.length }}\"></span> <a ng-click=vm.toggleRaw()><i class=\"fa fa-caret-up\" ng-show=vm.showRaw></i> <i class=\"fa fa-caret-down\" ng-hide=vm.showRaw></i></a><table class=\"table config-table\" ng-show=vm.showRaw><tr><th>{{ 'directives.common.dateAndTimeOccurrence' | translate }}</th><th>{{ 'directives.common.device' | translate }}</th><th>URL</th></tr><tr ng-repeat=\"history in vm.histories\"><td>{{history.opened_at | zcDate : {smart:true} }}</td><td>{{history.device | uppercase}}</td><td><div uib-tooltip={{history.url}}>{{history.url | limitTo:60}} <span ng-show=\"history.url.length > 60\">...</span></div></td></tr></table></div></div><div class=text-left zcs-hide-when-production><a ng-click=vm.complete() ng-if=!vm.project.is_demo>{{ 'directives.trackingTagChecker.trackingTagInstallCompleteForTesting' | translate }}</a></div><div class=clearfix></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/zcs_invoice_note/zcs_invoice_note.html';
var html = "<div class=note><span translate=directives.zcsInvoiceNote.note1 translate-value-service={{$ctrl.ZcsOemService.getName()}} translate-value-value1=1万円 translate-value-value2=256万円 translate-value-value3=2万円 translate-value-value4=100万円 translate-value-value5=1万円 translate-value-value6=10円></span><br><br><span translate=directives.zcsInvoiceNote.note2 translate-value-service={{$ctrl.ZcsOemService.getName()}}></span><br><span zcs-hide-when-oem><span ng-if=$ctrl.isMinimumCharge translate=directives.zcsInvoiceNote.note3 translate-value-service={{$ctrl.ZcsOemService.getName()}} translate-value-value1=10,000円（税抜） translate-value-value2=1万円></span> <span ng-if=!$ctrl.isMinimumCharge translate=directives.zcsInvoiceNote.note4 translate-value-service={{$ctrl.ZcsOemService.getName()}} translate-value-value1=19,800円（税抜）></span> <span ng-if=$ctrl.isMinimumCharge translate=directives.zcsInvoiceNote.note5 translate-value-url=\"<a href='/pricing' target='_blank'>{{ 'directives.common.priceList' | translate }}</a>\"></span> <span ng-if=!$ctrl.isMinimumCharge translate=directives.zcsInvoiceNote.note5 translate-value-url=\"<a href='/pricingPre201704' target='_blank'>{{ 'directives.common.priceList' | translate }}</a>\"></span></span><br zcs-hide-when-oem><br><span translate=directives.zcsInvoiceNote.note6 translate-value-service={{$ctrl.ZcsOemService.getName()}}></span></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/zcs_maintenance/zcs_maintenance.html';
var html = "<div class=maintenance role=maintenance><div class=\"row col-md-6 col-md-offset-3\"><h1>{{ 'directives.zcsMaintenance.collectingData' | translate }}</h1><img src=/assets/img/maintenance.png zcs-hide-when-oem><p zcs-hide-when-oem translate=directives.zcsMaintenance.note translate-value-service=\"{{ vm.ZcsOemService.getName() }}\" translate-value-url=\"<a href='mailto:aideal-support@appier.com'>{{ 'directives.common.here' | translate }}</a>\"></p></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/directives/zcs_tag_unset/zcs_tag_unset.html';
var html = "<div class=tag-unset role=maintenance><div class=\"row col-md-6 col-md-offset-3\" ng-if=\"!vm.project.tracking_tag_confirmed_at && !vm.project.conversion_tag_confirmed_at\"><h1 translate=directives.zcsTagUnset.trackingDataNotConfirmed></h1><img src=/assets/img/maintenance.png zcs-hide-when-oem><p translate=directives.zcsTagUnset.checkTrackingTagFromHere translate-value-url=\"<a href='{{vm.trackingTagSettingPage}}'>{{ 'directives.common.here' | translate }}</a>\"></p></div><div class=\"row col-md-6 col-md-offset-3\" ng-if=\"vm.project.tracking_tag_confirmed_at && !vm.project.conversion_tag_confirmed_at\"><h1 translate=directives.zcsTagUnset.trackingDataNotConfirmed></h1><img src=/assets/img/maintenance.png zcs-hide-when-oem><p translate=directives.zcsTagUnset.noConversionTagIsInstalledOrNoConversionOccurred translate-value-url=\"<a href='{{vm.conversionTagSettingPage}}'>{{ 'directives.common.here' | translate }}</a>\"></p></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/home/home.html';
var html = "<div class=zcs-home><div class=\"container-fluid container-limited\"><div ng-if=\"!$ctrl.agencies.length && !$ctrl.projects.length\" class=\"text-center no-sites\"><p>{{ 'home.noSiteFound' | translate }}</p><p zcs-hide-when-oem translate=home.supportMessage translate-value-mail=\"<a href='mailto:aideal-support@appier.com'>aideal-support@appier.com</a>\"></p></div><div class=\"row margin-y\"><div class=col-xs-8><ul class=\"nav nav-bar\"><li ng-class=\"{'active': $ctrl.menu === 'all'}\"><a ng-click=\"$ctrl.selectType('all')\"><p>{{ 'home.all' | translate }}</p></a></li><li ng-class=\"{'active': $ctrl.menu === 'agencies'}\"><a ng-click=\"$ctrl.selectType('agencies')\">{{ 'home.agency' | translate }} <span class=badge>{{$ctrl.agencies.length}}</span></a></li><li ng-class=\"{'active': $ctrl.menu === 'projects'}\"><a ng-click=\"$ctrl.selectType('projects')\">{{ 'home.site' | translate }} <span class=badge>{{$ctrl.projects.length}}</span></a></li><li ng-class=\"{'active': $ctrl.menu === 'testProjects'}\"><a ng-click=\"$ctrl.selectType('testProjects')\">{{ 'home.test' | translate }} <span class=badge>{{$ctrl.testProjects.length}}</span></a></li><li ng-class=\"{'active': $ctrl.menu === 'demoProjects'}\"><a ng-click=\"$ctrl.selectType('demoProjects')\">{{ 'home.demo' | translate }} <span class=badge>{{$ctrl.demoProjects.length}}</span></a></li></ul></div><div class=col-xs-4><div class=input-group-search><input class=form-control placeholder=\"{{ 'home.filter' | translate }}\" ng-model=$ctrl.filter><div class=input-action-delete ng-if=\"$ctrl.filter.length > 0\" ng-click=\"$ctrl.filter = ''\"></div></div></div><div class=col-xs-12><label class=checkbox-inline><input type=checkbox ng-model=$ctrl.showNotInstalledOnly> {{ 'home.showNotInstalledOnly' | translate }}</label> <label class=checkbox-inline><input type=checkbox ng-model=$ctrl.showTerminatedOnly> {{ 'home.showTerminatedOnly' | translate }}</label></div></div><div class=row><div class=col-md-6 ng-repeat=\"item in $ctrl.items | filter:({_filterText: $ctrl.filter}) | filter:({_isInstalled: !$ctrl.showNotInstalledOnly}) | filter:({_isTerminated: $ctrl.showTerminatedOnly}) | orderBy:'-created_at':$ctrl.sortReverse | orderBy:'_isAgency' | limitTo: $ctrl.limit as itemsFiltered\"><div class=list-item ng-click=$ctrl.goTo(item) ng-class=\"{disabled: item.is_terminated, agency: item._isAgency}\"><div class=list-item-header><div class=list-item-avatar ng-class=\"$ctrl.getAgencyColor(item.agency_id || item.id)\">{{item.name || item.apikey | limitTo:2}}</div><div class=list-info><div class=list-item-label><div class=\"label label-warning\" ng-if=$ctrl.isNew(item.created_at) uib-tooltip=\"{{ 'home.createdAt' | translate: { date: (item.created_at | zcDate: { smart: true, dateOnly: true })} }}\" tooltip-placement=bottom>{{ 'home.new' | translate }}</div><div class=\"label label-danger\" ng-if=item.suspended_at>{{ 'home.suspended' | translate }}</div><div class=\"label label-default\" ng-if=\"item.apikey && !item.installed_at && !item.is_demo\">{{ 'home.settingInProgress' | translate }}</div><div class=\"label label-default\" ng-if=item.is_test>{{ 'home.test' | translate }}</div><div class=\"label label-default\" ng-if=item.is_demo>{{ 'home.demo' | translate }}</div></div>{{item.title | limitTo: 24}}<br><small><i class=\"fa fa-id-card-o\"></i> {{item.name || item.apikey | limitTo: 20}} <a ng-if=item.apikey href={{item.base_url}} target=_blank><br><i class=\"fa fa-external-link\"></i> {{item.base_url || 'no link'}}</a></small></div></div></div></div><div class=\"col-xs-12 text-center\"><div class=no-sites ng-if=!itemsFiltered.length>{{ 'home.noResult' | translate }}</div><div class=\"btn btn-default margin-y\" ng-if=\"$ctrl.limit == 50 && itemsFiltered.length > 49\" ng-click=\"$ctrl.limit=$ctrl.items.length\">{{ 'home.showAll' | translate }}</div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/layout/footer.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/layout/header.html';
var html = "<div class=modal-full ng-class=\"{'active': vm.state.profile}\"><div class=\"container-fluid container-limited\"><div class=\"col-md-6 col-md-offset-3 profile panel\"><close-button on-click=vm.toggleProfile()></close-button><zcs-profile></zcs-profile></div></div></div><nav class=\"header navbar-fixed-top\" zcs-hide-when-oem><div class=container-fluid><div class=col-xs-3><a class=logo ui-sref=zenclerkS.home()><img src=/assets/img/logo-aideal.svg></a></div><div ui-view=headerNavigation class=\"col-xs-6 navigation\"><ng-container ng-if=i18nHeader>{{ i18nHeader | translate }}</ng-container></div><div class=\"col-xs-3 text-right navigation-controls\"><div class=project-and-agency master-only><span class=\"badge badge-alert\" ng-if=vm.project.is_terminated>{{ 'layout.header.isTerminated' | translate }}</span> <a ui-sref=zenclerkS.home() ng-if=vm.project.title>{{vm.project.title | limitTo:15}}</a><br><a ui-sref=\"zenclerkS.agency.sites({agencyName: vm.agencyName})\">{{vm.agencyTitle | limitTo: 15}}</a></div><div class=profile ng-click=vm.toggleProfileMenu() ng-class=\"{'active': vm.state.profileMenu}\">{{vm.currentUser.email | limitTo:1}}</div><div class=\"profile-menu dropdown-menu\" ng-class=\"{'active': vm.state.profileMenu}\"><h1>{{vm.currentUser.full_name}}</h1><p>{{vm.currentUser.email}}</p><div ng-if=!!vm.project.title><h2>{{ 'layout.header.project' | translate }}</h2><p class=small>{{vm.project.title | limitTo:20}}</p></div><div class=navi-menu><a zcs-hide-when-oem ng-click=vm.toggleNotificationsPanel() pe-track=header.notifications>{{ 'layout.header.notification' | translate }}</a> <a ui-sref=privacy_policy pe-track=header.privacy_policy>{{ 'layout.header.privacyPolicy' | translate }}</a> <a ui-sref=terms_of_service pe-track=header.tos>{{ 'layout.header.termsOfService' | translate }}</a></div><div class=\"content profile-menu-action\"><a class=col-xs-6 ng-click=\"vm.toggleProfile(); vm.toggleProfileMenu()\" pe-track=header.profile><i class=\"fa fa-cog\"></i><br><small>{{ 'layout.header.edit' | translate }}</small></a> <a class=col-xs-6 ng-click=\"vm.logout(); vm.toggleProfileMenu()\" pe-track=header.logout><i class=\"fa fa-sign-out\"></i><br><small>{{ 'layout.header.logout' | translate }}</small></a></div></div></div></div><div class=container-fluid><div class=row><div class=col-md-12><zc-tos-notification tos-url=/tos/admin updated-at=2020/11/15 service-name=\"{{ ZcsOemService.getName(); }}\"></zc-tos-notification></div></div></div></nav><div class=\"container-fluid sub-navigation\" zcs-hide-when-oem><div class=row><div ui-view=subNavigation class=col-md-12></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/layout/layout.html';
var html = "<div class=dev-panel ng-click=\"vm.toggleDevMenu = !vm.toggleDevMenu\" ng-class=\"{'active': vm.toggleDevMenu}\" ng-if=\"vm.environment !=='production'\"><i class=\"fa fa-bars\"></i> {{vm.environment}} ({{vm.getCurrentRole()}}) <span ng-if=\"vm.environment === 'preprod'\">⚠️{{ 'layout.layout.preprodWarning' | translate }}⚠️</span><div class=dev-panel-menu><a ng-click=vm.toggleRole()>{{ 'layout.layout.switchRole' | translate }}</a> <a ng-click=vm.resetAllNotifications()>{{ 'layout.layout.resetNotification' | translate }}</a> <a ng-click=\"vm.setOemService('makerepeater')\" ng-if=!vm.oemService>{{ 'layout.layout.setOemView' | translate }}</a> <a ng-click=vm.setOemService(null) ng-if=vm.oemService>{{ 'layout.layout.setNormalView' | translate }}</a> <a ng-repeat=\"lang in vm.availableLanguage\" ng-if=\"vm.currentLanguage !== lang\" ng-click=vm.setLanguage(lang) translate=layout.layout.switchTo translate-value-lang=\"{{ 'lang.list.' + lang | translate }}\"></a></div></div><help-launcher class=float is-main=true></help-launcher><div zcs-hide-when-oem><zcs-notification-panel></zcs-notification-panel></div><div class=makerepeater-admin-banner ng-if=\"vm.currentUser && vm.currentUser.makerepeater_is_admin && vm.showMakerepeaterAdminBanner\">{{ 'layout.layout.viewingAsAdmin' | translate }} <i class=\"fa fa-remove\" ng-click=\"vm.showMakerepeaterAdminBanner = false\"></i></div><div ui-view=layout></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/layout/layout_header+main.html';
var html = "<div class=zenclerk-zcs-container ng-class=\"{'with-header': !ZcsOemService.get()}\"><div class=ui-view-container><div class=ui-view-page-content><zcs-header></zcs-header><zcs-main></zcs-main><zcs-footer></zcs-footer></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/layout/layout_main+sidebar-left.html';
var html = "<div class=\"zenclerk-zcs-container with-sidebar-left\"><div class=ui-view-container><div class=ui-view-page-content><zcs-sidebar></zcs-sidebar><zcs-main></zcs-main></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/layout/layout_main.html';
var html = "<div class=zenclerk-zcs-container><div class=ui-view-container><div class=ui-view-page-content><zcs-main></zcs-main></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/layout/layout_tos_header+main.html';
var html = "<div class=zenclerk-zcs-container ng-class=\"{'with-header': !ZcsOemService.get()}\"><div class=ui-view-container><div class=ui-view-page-content><nav class=\"header navbar-fixed-top\" zcs-hide-when-oem><div class=container-fluid><div class=col-xs-3><a class=logo ui-sref=zenclerkS.home()><img src=/assets/img/logo-aideal.svg></a></div><div class=\"col-xs-4 col-md-2 col-xs-push-5 col-md-push-7 text-right\" style=\"margin-top: 10px;\"><select class=form-control ng-model=vm.selectedLanguage ng-options=\"language.label for language in vm.languages\" ng-change=vm.selectLanguage(vm.selectedLanguage)></select></div></div></nav><zcs-main class=document-wrapper></zcs-main><zcs-footer></zcs-footer></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/layout/main.html';
var html = "<div class=main><div zcs-hide-when-oem><zcs-notification-alert project=project></zcs-notification-alert></div><div ui-view=mainContent autoscroll=true></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/layout/menu_setup.html';
var html = "<div class=sidebar-menu-setup><h2>{{ 'layout.menuSetup.initialSiteSettings' | translate }}</h2><nav><a ng-class=\"{active:vm.isActive('setupCompany')}\" ui-sref=\"zenclerkS.project.setup.company({apikey: vm.project.apikey})\"><i class=\"fa fa-list-alt\"></i> {{ 'layout.menuSetup.company' | translate }}</a> <a ng-class=\"{active:vm.isActive('setupSite')}\" ui-sref=\"zenclerkS.project.setup.site({apikey: vm.project.apikey})\"><i class=\"fa fa-list-alt\"></i> {{ 'layout.menuSetup.site' | translate }}</a> <a ng-class=\"{active:vm.isActive('setupTag')}\" ui-sref=\"zenclerkS.project.setup.tag({apikey: vm.project.apikey})\"><i class=\"fa fa-list-alt\"></i> {{ 'layout.menuSetup.tag' | translate }}</a></nav></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/layout/sidebar.html';
var html = "<div class=contain-fluid><div class=modal-full ng-class=\"{'active': vm.state.modal}\"><div class=\"container-fluid container-limited\"><div class=\"col-md-6 col-md-offset-3 profile panel\"><close-button on-click=vm.toggleModal()></close-button><zcs-profile></zcs-profile></div></div></div><div class=sidebar><a class=logo ui-sref=zenclerkS.home()><img src=/assets/img/logo-aideal-white.svg></a><div ui-view=sidebarContent class=sidebar-menu></div><div class=profile><a ng-click=vm.toggleModal() class=profile-username><i class=\"fa fa-street-view\"></i> {{vm.currentUser.full_name}}</a> <a ng-click=vm.logout() class=profile-logout><i class=\"fa fa-sign-out\"></i></a></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/setup/setup_user.html';
var html = "<div class=container-fluid><div class=row><div class=\"col-md-4 setup-illustration with-steps\"><img src=/assets/img/illustration-website-xl.svg></div><div class=\"col-md-8 setup-content with-steps\"><div class=\"col-md-10 col-md-offset-1\"><h1>{{ 'setup.setupUser.confirmUserInformation' | translate }}</h1><form ng-submit=vm.save() name=userInfo><div class=row><div class=col-md-6><div class=form-group><label for=full_name>{{ 'setup.setupUser.name' | translate }}</label> <input type=text id=userinfo_full_name class=form-control name=full_name ng-model=vm.user.full_name required></div></div></div><div class=row><div class=col-md-6><div class=form-group><label for=email>{{ 'setup.setupUser.email' | translate }}</label> <input type=email id=userinfo_email class=form-control name=email ng-model=vm.user.email required></div></div></div><div class=row><div class=col-md-6><div class=form-group><label for=company_name>{{ 'setup.setupUser.companyName' | translate }}</label> <input type=text id=userinfo_company_name class=form-control name=company ng-model=vm.user.company_name></div></div></div><div class=row><div class=col-md-6><div class=form-group><label for=department>{{ 'setup.setupUser.department' | translate }}</label> <input type=text id=userinfo_department class=form-control name=department ng-model=vm.user.department></div></div><div class=col-md-6><div class=form-group><label for=position>{{ 'setup.setupUser.position' | translate }}</label> <input type=text id=userinfo_position class=form-control name=position ng-model=vm.user.position></div></div></div><div class=row><div class=\"col-md-12 text-right\"><button id=userinfo_next_step class=\"btn btn-primary\" ng-disabled=userInfo.$invalid>{{ 'setup.setupUser.confirm' | translate }}</button></div></div></form></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/activity/navigation.html';
var html = "<a ng-class=\"{active:vm.isCategory('dashboard')}\" ui-sref=\"zenclerkS.project.dashboard({apikey: vm.project.apikey})\">{{ 'sites.activity.navigation.dasshuboodo' | translate }}</a> <a ng-class=\"{active: vm.isCategory('analytics')}\" ng-if=\"vm.project.agency_id === 5\" ui-sref=\"zenclerkS.project.analytics({apikey: vm.project.apikey})\">{{ 'sites.activity.navigation.anaritikusu' | translate }}</a> <a ng-class=\"{active:vm.isCategory('reports')}\" ui-sref=\"zenclerkS.project.report.show({apikey: vm.project.apikey, month: vm.thisMonth})\">{{ 'sites.activity.navigation.saito_uriage_no' | translate }}</a> <a ng-class=\"{active:vm.isCategory('activity')}\" ui-sref=\"zenclerkS.project.activity({apikey: vm.project.apikey})\">{{ 'sites.activity.navigation.riarutaimu' | translate }}</a> <a fully-supported-asp-only project=vm.project ng-class=\"{active:vm.isCategory('stats')}\" ui-sref=\"zenclerkS.project.stats({apikey: vm.project.apikey})\">{{ 'sites.activity.navigation.shouhin_no_hanbai' | translate }}</a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/activity/realtime/realtime.html';
var html = "<div class=activity><zc-realtime-visitor-visualizer project=project></zc-realtime-visitor-visualizer></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/analytics/analytics.html';
var html = "<div class=zcs-analytics><div class=\"container dashboard\"><div class=flex-row><widget class=flex-col-md-4><widget-title>{{ 'sites.analytics.analytics.houmon_sesshon_kazu' | translate }}</widget-title><widget-content><widget-conversion-chart project=$ctrl.project></widget-conversion-chart></widget-content></widget><widget class=flex-col-md-4><widget-title>{{ 'sites.analytics.analytics.kinou_no_akusesu' | translate }}</widget-title><widget-content><widget-top-referrers project=$ctrl.project></widget-top-referrers></widget-content></widget><widget class=flex-col-md-4><widget-title>{{ 'sites.analytics.analytics.kinou_no_yoku' | translate }}</widget-title><widget-content><widget-top-pages project=$ctrl.project></widget-top-pages></widget-content></widget></div><div class=flex-row fully-supported-asp-only><widget class=flex-col-md-6><widget-title>{{ 'sites.analytics.analytics.ritsu_ga_takai' | translate: { count: 5 } }}</widget-title><widget-content><widget-top-items project=$ctrl.project sort-order=desc></widget-top-items></widget-content></widget><widget class=flex-col-md-6><widget-title>{{ 'sites.analytics.analytics.ritsu_ga_hikui' | translate: { count: 5 } }}</widget-title><widget-content><widget-top-items project=$ctrl.project sort-order=asc></widget-top-items></widget-content></widget></div><div class=text-center><p>{{ 'sites.analytics.analytics.ga_ichibu_no' | translate: { service: $ctrl.ZcsOemService.getName() } }}</p></div></div></div><zcs-notification-timezone project=$ctrl.project></zcs-notification-timezone>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/campaign_navigation.html';
var html = "<a ng-class=\"{active:$ctrl.isCategory('campaigns')}\" ui-sref=\"zenclerkS.project.campaigns({apikey: $ctrl.project.apikey})\">{{ 'sites.campaigns.campaignNavigation.campaignReport' | translate }}</a> <a ng-class=\"{active:$ctrl.isCategory('incentives')}\" ui-sref=\"zenclerkS.project.incentives({apikey: $ctrl.project.apikey})\">{{ 'sites.campaigns.campaignNavigation.couponList' | translate }}</a> <a ng-class=\"{active:$ctrl.isCategory('integratedIncentives')}\" ui-sref=\"zenclerkS.project.integratedIncentives({apikey: $ctrl.project.apikey})\" ng-if=$ctrl.project.is_oem master-only><i class=\"fa fa-lock master-only\" aria-hidden=true></i> {{ 'sites.campaigns.campaignNavigation.makeShopApiIntegratedCouponList' | translate }}</a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/coupon/history.html';
var html = "<div class=\"container-fluid container-limited coupon-history padding-y\"><div><h1 ng-if=$ctrl.pastIncentive.length>{{ 'sites.campaigns.couponHistory.pastCoupon' | translate }} <span class=badge>{{$ctrl.pastIncentive.length}}</span></h1><table class=col-md-12><thead><tr><th>{{ 'sites.campaigns.couponHistory.couponType' | translate }}</th><th>{{ 'sites.campaigns.couponHistory.couponCode' | translate }}</th><th>{{ 'sites.campaigns.couponHistory.period' | translate }}</th><th>{{ 'sites.campaigns.couponHistory.condition' | translate }}</th></tr></thead><tbody ng-repeat=\"incentive in $ctrl.pastIncentive\"><td><span ng-if=\"incentive.discount_type === 'percent'\">{{incentive.discount_percent}}%OFF</span> <span ng-if=\"incentive.discount_type === 'price'\">{{$ctrl.currency.symbol}}{{incentive.discount_price}}{{$ctrl.currency.suffix}}OFF</span> <span ng-if=incentive.is_free_shipping>{{ 'sites.campaigns.couponHistory.freeShipping' | translate }}</span></td><td>{{incentive.coupon_code}}</td><td>{{incentive.start_at | zcDate}} - {{incentive.is_infinite ? ('sites.campaigns.couponHistory.noLimit' | translate) : (incentive.end_at | zcDate)}}<br><span ng-if=$ctrl.isAlmostEnded(plan.subPlans[1].incentive.end_at)>{{$ctrl.timeLimitTexts[0]}}</span> <span ng-if=$ctrl.isEnded(plan.subPlans[1].incentive.end_at)>{{$ctrl.timeLimitTexts[1]}}</span></td><td>{{incentive.minimum_price ? ('sites.campaigns.couponHistory.aboveAmount' | translate: { min: $ctrl.currency.symbol + incentive.minimum_price + $ctrl.currency.suffix }) : ('sites.campaigns.couponHistory.none' | translate)}}</td></tbody></table><div class=row><div class=\"col-md-12 note\"><div ng-if=\"$ctrl.project.invoice_calculation_type === 'normal'\"><h2>{{ 'sites.campaigns.couponHistory.notice' | translate }}</h2>{{ 'sites.campaigns.couponHistory.noticeDescription' | translate: { service: $ctrl.ZcsOemService.getName() } }}</div></div></div></div></div><zcs-notification-timezone project=$ctrl.project></zcs-notification-timezone>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/create_button/campaign_confirm_modal.html';
var html = "<svg-embed ng-click=$ctrl.close() class=modal-close url=\"'/assets/img/icon-close.svg'\"></svg-embed><div class=modal-body><div class=row><div class=col-xs-12><h1 class=modal-title>{{ 'sites.campaigns.createButton.draftCamapignExists' | translate }}<br>{{ 'sites.campaigns.createButton.editDraftCampaign' | translate }}</h1><div class=text-center><button class=\"btn btn-blank\" ng-click=$ctrl.createCampaign()>{{ 'sites.campaigns.createButton.createNewCampaign' | translate }}</button> <button class=\"btn btn-primary\" ng-click=$ctrl.editCampaign()>{{ 'sites.campaigns.createButton.editExistingCampaign' | translate }}</button></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/create_button/campaign_create_button.html';
var html = "<div class=\"btn btn-primary btn-shadow\" uib-tooltip={{$ctrl.getTooltipMessage()}} tooltip-placement=bottom tooltip-enable=!$ctrl.isAllowedToCreate() ng-disabled=!$ctrl.isAllowedToCreate() ng-click=$ctrl.confirmCampaign()><ng-transclude>{{ 'sites.campaigns.createButton.createCampaign' | translate }}</ng-transclude></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit.html';
var html = "<div class=campaign-edit ng-class=\"$ctrl.isOem ? 'with-step-top' : 'with-step-bottom'\"><div class=ui-view-campaign-edit-view ui-view name=campaignEditView></div><div class=\"navbar-fixed-bottom steps\" ng-class=\"$ctrl.isOem ? 'navbar-fixed-top' : 'navbar-fixed-bottom'\"><div class=\"col-xs-3 text-left\"><button class=\"btn btn-blank\" ng-click=$ctrl.exit()>{{ 'sites.campaigns.edit.campaignEdit.end' | translate }}</button></div><ul class=\"col-xs-6 stepper text-center\"><li ng-repeat=\"step in $ctrl.steps.items\" ng-class=$ctrl.getStepClass($index) ng-click=\"$ctrl.goToStep($index, 'stepper')\">{{step.label}}</li></ul><div class=\"col-xs-3 text-right\"><help-launcher class=block current-project=$ctrl.project></help-launcher><span ng-hide=$ctrl.isLastStep()><button class=\"btn btn-primary btn-shadow\" ng-disabled=!$ctrl.isEnabledStep($ctrl.steps.next) pe-track=campaign.template.goToStep ng-click=\"$ctrl.goToStep($ctrl.steps.next, 'button')\">{{ 'sites.campaigns.edit.campaignEdit.next' | translate }}</button></span> <span ng-show=$ctrl.isLastStep()><div class=\"btn btn-primary btn-shadow\" ng-disabled=\"!$ctrl.canBeLaunched() || !$ctrl.isAllowedToCreate()\" uib-tooltip={{$ctrl.getTooltipMessage()}} tooltip-placement=top tooltip-enable=!$ctrl.isAllowedToCreate() pe-track=campaign.template.saveOrLaunchButton ng-click=$ctrl.saveButtonClicked()>{{$ctrl.getSaveButtonText()}}</div></span></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_modal_conversion_price.html';
var html = "<svg-embed ng-click=$ctrl.close() class=modal-close url=\"'/assets/img/icon-close.svg'\"></svg-embed><div class=\"campaign-edit-modal-launch text-center\"><div class=modal-header>{{ 'sites.campaigns.edit.campaignEdit.modalConversionPrice.setByGrossProfitMarginAndAvgPrice' | translate }}</div><form ng-submit=$ctrl.setProfitAndConversion() class=\"modal-body text-left\" name=campaignEditConversionPrice><label>{{ 'sites.campaigns.edit.campaignEdit.modalConversionPrice.profitRate' | translate }}</label><select class=form-control ng-required=true ng-options=\"option.value as option.label for option in $ctrl.profitRateOptions\" ng-model=$ctrl.project.profit_percent></select><br><label>{{ 'sites.campaigns.edit.campaignEdit.modalConversionPrice.averagePrice' | translate }}</label><select class=form-control ng-required=true ng-options=\"option.value as option.label for option in $ctrl.averageConversionPriceOptions\" ng-model=$ctrl.project.average_conversion_price></select><br><span class=help-block>{{ 'sites.campaigns.edit.campaignEdit.modalConversionPrice.settingExplanation' | translate }}</span><div class=modal-footer><button type=submit class=\"btn btn-primary\" pe-track=campaignSetProfitAndConversionModal.save ng-disabled=\"campaignEditConversionPrice.$invalid || !campaignEditConversionPrice.$dirty || $ctrl.isSaving\">{{ 'sites.campaigns.edit.campaignEdit.modalConversionPrice.save' | translate }}</button> <button type=button class=\"btn btn-default\" ng-click=$ctrl.close() pe-track=campaignSetProfitAndConversionModal.cancel>{{ 'sites.campaigns.edit.campaignEdit.modalConversionPrice.cancel' | translate }}</button></div></form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_modal_exit.html';
var html = "<svg-embed ng-click=$ctrl.close() class=modal-close url=\"'/assets/img/icon-close.svg'\"></svg-embed><div class=modal-body><div class=row><div class=col-xs-12><h1 class=modal-title>{{ 'sites.campaigns.edit.campaignEdit.modalExit.notSavedYet' | translate }}<br>{{ 'sites.campaigns.edit.campaignEdit.modalExit.areYouSureToEnd' | translate }}</h1><div class=text-center><button class=\"btn btn-primary\" type=button ng-click=$ctrl.save() ng-disabled=$ctrl.campaign.isSaving><span>{{$ctrl.isNewCampaign() ? ('sites.campaigns.edit.campaignEdit.modalExit.saveAsDraft' | translate) : ('sites.campaigns.edit.campaignEdit.modalExit.save' | translate)}}</span></button> <button class=\"btn btn-blank\" type=button ng-click=$ctrl.exitWithoutSaving()>{{ 'sites.campaigns.edit.campaignEdit.modalExit.endWithoutSaving' | translate }}</button></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_modal_launch.html';
var html = "<svg-embed ng-click=$ctrl.close() class=modal-close url=\"'/assets/img/icon-close.svg'\"></svg-embed><div class=\"campaign-edit-modal-launch text-center\"><div class=modal-header>{{ 'sites.campaigns.edit.campaignEdit.modalLaunch.saveWithEditedContent' | translate }}</div><div class=modal-body><svg-embed url=\"'/assets/img/illustration-campaign-launch.svg'\"></svg-embed><p>{{ 'sites.campaigns.edit.campaignEdit.modalLaunch.campaignSettingsCanBeEditedLater' | translate }}</p><div ng-if=$ctrl.isIntegratedWithMakeshop class=\"alert alert-hint config-lead\"><ng-include src=\"'/templates/zenclerk_s/sites/campaigns/edit/instruction_makeshop_integration.html'\"></ng-include></div></div><div class=modal-footer><button class=\"btn btn-primary\" uib-tooltip={{$ctrl.getTooltipMessage()}} tooltip-placement=bottom tooltip-enable=!$ctrl.isAllowedToCreate() ng-disabled=\"$ctrl.campaign.isSaving || $ctrl.saveInProgressOrSucceeded || !$ctrl.isAllowedToCreate()\" ng-click=$ctrl.launch()>{{ 'sites.campaigns.edit.campaignEdit.modalLaunch.save' | translate }}</button> <button class=\"btn btn-link\" type=button ng-click=$ctrl.close()>{{ 'sites.campaigns.edit.campaignEdit.modalLaunch.cancel' | translate }}</button></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_step_confirm.html';
var html = "<div class=\"step-confirm container-fluid container-limited\"><h1>{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.newCampaignSettingsCompleted' | translate }}</h1><h2>{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.pleaseConfirmParameters' | translate }}</h2><div class=\"alert alert-warning col-xs-8 col-xs-offset-2\" ng-if=\"$ctrl.campaign.status !== 'incomplete' && $ctrl.campaignEdit.isModifiedSchedule() && !$ctrl.campaignEdit.isIntegratedWithMakeshop\">{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.beSureToSetCartSystemCouponWithSameEndDate' | translate }}</div><zcs-notification-timezone project=$ctrl.project status=danger static=true></zcs-notification-timezone><div class=step-confirm-steps><div class=row><div class=\"col-xs-8 col-xs-offset-2\"><div class=\"row step-confirm-step\"><svg-embed class=step-confirm-step-ok url=\"'/assets/img/icon-ok-circle.svg'\"></svg-embed><div class=col-xs-8><h3>{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.segment' | translate }}</h3>{{$ctrl.getSegmentLabel($ctrl.campaign.segment.name)}}</div><div class=\"col-xs-4 text-right\"><button class=\"btn btn-sm btn-blank\" ui-sref=\"zenclerkS.project.campaign.edit.segment({ apikey: $ctrl.project.apikey, campaignId: $ctrl.campaign.id })\">{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.edit' | translate }}</button></div></div><hr></div></div><div class=row><div class=\"col-xs-8 col-xs-offset-2\"><div class=\"row step-confirm-step\"><svg-embed class=step-confirm-step-ok ng-show=$ctrl.isCouponStepOk() url=\"'/assets/img/icon-ok-circle.svg'\"></svg-embed><svg-embed class=step-confirm-step-error ng-show=!$ctrl.isCouponStepOk() url=\"'/assets/img/icon-error-circle.svg'\"></svg-embed><div class=col-xs-4><h3>{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.couponType' | translate }}</h3><div ng-switch=$ctrl.incentive.discount_type><div ng-switch-when=price>{{$ctrl.currency.symbol}}{{$ctrl.incentive.discount_price}}{{$ctrl.currency.suffix}}OFF</div><div ng-switch-when=percent>{{$ctrl.incentive.discount_percent | number:0}}%OFF</div><div ng-switch-default><div ng-if=$ctrl.incentive.is_free_shipping>{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.freeShipping' | translate }}</div></div></div><div ng-if=$ctrl.incentive.has_price_limit><br><h3>{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.noPriceLimit' | translate }}</h3><span ng-if=$ctrl.incentive.minimum_price>{{$ctrl.currency.symbol}}{{$ctrl.incentive.minimum_price}}{{$ctrl.currency.suffix}}</span> <span ng-if=!$ctrl.incentive.minimum_price class=\"label label-danger\">{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.priceNotSet' | translate }}</span></div></div><div class=col-xs-4><h3>{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.couponCode' | translate }}</h3><div>{{$ctrl.incentive.coupon_code}}</div><div class=\"label label-danger\" ng-show=\"!$ctrl.campaignEdit.incentive.coupon_code && $ctrl.campaign.status === 'incomplete'\">{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.couponCodeNotSet' | translate }}</div><div class=\"label label-danger\" ng-show=\"$ctrl.campaignEdit.isCouponCodeInUse() && $ctrl.campaign.status === 'incomplete'\"><span ng-if=!$ctrl.campaignEdit.project.is_oem>{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.couponCodeInDeliveryDuplicated' | translate }}</span> <span ng-if=$ctrl.campaignEdit.project.is_oem>{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.issuedCouponCodeDuplicated' | translate }}</span></div><div ng-if=$ctrl.incentive.has_price_limit><br><h3>{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.tax' | translate }}</h3>{{$ctrl.incentive.is_price_limit_tax_included ? ('sites.campaigns.edit.campaignEdit.stepConfirm.priceWithTax' | translate) : ('sites.campaigns.edit.campaignEdit.stepConfirm.priceWithoutTax' | translate)}}</div></div><div class=\"col-xs-4 text-right\"><button class=\"btn btn-sm btn-blank\" ui-sref=\"zenclerkS.project.campaign.edit.coupon({ apikey: $ctrl.project.apikey, campaignId: $ctrl.campaign.id })\" ng-hide=\"$ctrl.campaign.status === 'activated'\">{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.edit' | translate }}</button></div></div><hr></div></div><div class=row><div class=\"col-xs-8 col-xs-offset-2\"><div class=\"row step-confirm-step\"><svg-embed class=step-confirm-step-ok url=\"'/assets/img/icon-ok-circle.svg'\"></svg-embed><div class=col-xs-8><h3>{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.deliveryMethod' | translate }}</h3><div ng-if=\"$ctrl.campaign.timing.name === 'all'\">{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.all' | translate }}</div><div ng-if=\"$ctrl.campaign.timing.name === 'ai'\">{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.ai' | translate }}</div></div><div class=\"col-xs-4 text-right\"><button class=\"btn btn-sm btn-blank\" ui-sref=\"zenclerkS.project.campaign.edit.delivery({ apikey: $ctrl.project.apikey, campaignId: $ctrl.campaign.id })\">{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.edit' | translate }}</button></div></div><hr></div></div><div class=row><div class=\"col-xs-8 col-xs-offset-2\"><div class=\"row step-confirm-step\"><svg-embed class=step-confirm-step-ok ng-show=$ctrl.campaignEdit.isScheduleValid() url=\"'/assets/img/icon-ok-circle.svg'\"></svg-embed><svg-embed class=step-confirm-step-error ng-hide=$ctrl.campaignEdit.isScheduleValid() url=\"'/assets/img/icon-error-circle.svg'\"></svg-embed><div class=col-xs-4><h3>{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.start' | translate }}</h3><div ng-if=$ctrl.campaign.start_at_obj.date>{{$ctrl.dateObjToDate($ctrl.campaign.start_at_obj) | zcDate}} {{$ctrl.project.region | gmtNotation}}</div></div><div class=col-xs-4><h3>{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.end' | translate }}</h3><div ng-if=\"$ctrl.campaign.end_at_obj.date && !$ctrl.campaign.is_infinite\">{{$ctrl.dateObjToDate($ctrl.campaign.end_at_obj) | zcDate}} {{$ctrl.project.region | gmtNotation}}</div><div ng-if=$ctrl.campaign.is_infinite>{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.infinite' | translate }}</div></div><div class=\"col-xs-4 text-right\"><button class=\"btn btn-sm btn-blank\" ui-sref=\"zenclerkS.project.campaign.edit.schedule({ apikey: $ctrl.project.apikey, campaignId: $ctrl.campaign.id })\">{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.edit' | translate }}</button></div></div><hr></div></div><div class=row><div class=\"col-xs-8 col-xs-offset-2\"><div class=\"row step-confirm-step\"><svg-embed class=step-confirm-step-ok url=\"'/assets/img/icon-ok-circle.svg'\"></svg-embed><div class=col-xs-8><h3>{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.design' | translate }}</h3><span ng-if=\"$ctrl.campaign.template_type === 'giftcard'\">{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.modernTemplate' | translate }}</span> <span ng-if=\"$ctrl.campaign.template_type === 'zcs_textonly'\">{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.textOnlyTemplate' | translate }}</span> <span ng-if=\"$ctrl.campaign.template_type === 'zcs_image'\">{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.imageTemplate' | translate }}</span></div><div class=\"col-xs-4 text-right\"><button class=\"btn btn-sm btn-blank\" ui-sref=\"zenclerkS.project.campaign.edit.design({ apikey: $ctrl.project.apikey, campaignId: $ctrl.campaign.id })\">{{ 'sites.campaigns.edit.campaignEdit.stepConfirm.edit' | translate }}</button></div></div></div></div><div class=row><div class=col-md-6><zcs-campaign-template-dynamic-view project=$ctrl.project campaign=$ctrl.campaign only-views=[0]></zcs-campaign-template-dynamic-view></div><div class=col-md-6><zcs-campaign-template-dynamic-view class=zcs-campaign-template-dynamic-view project=$ctrl.project campaign=$ctrl.campaign only-views=[1]></zcs-campaign-template-dynamic-view></div></div><div class=row zcs-makerepeater-only><div class=\"col-xs-12 text-center margin-y\"><button class=\"btn btn-primary btn-shadow\" ng-disabled=!$ctrl.campaignEdit.canBeLaunched() pe-track=campaign.edit.confirm.saveOrLaunchButton ng-click=$ctrl.campaignEdit.saveButtonClicked()>{{$ctrl.campaignEdit.getSaveButtonText()}}</button></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_step_coupon.html';
var html = "<div class=\"step-coupon container-fluid container-limited\"><form name=incentiveForm novalidate><h1>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.selectCouponForCampaign' | translate }}</h1><h2>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.setCouponConditions' | translate }}</h2><div class=\"row form margin-y\"><div class=\"col-xs-10 col-xs-offset-1\"><div class=row><div class=col-xs-12><h1>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.couponType' | translate }}</h1></div><div class=col-xs-4 ng-repeat=\"(key, type) in $ctrl.availableCoupons.type\"><button class=\"btn btn-option btn-lg\" ng-click=type.onSelect($ctrl.incentive) ng-disabled=\"$ctrl.campaign.status !== 'incomplete'\" ng-class=\"{'active': $ctrl.incentive.discount_type === key || ((!$ctrl.incentive.discount_type || $ctrl.incentive.discount_type === 'none') && $ctrl.incentive.is_free_shipping && key == 'free_shipping')}\">{{type.label.prefix || type.label.suffix}}<span ng-if=type.suffix>{{type.suffix}}</span></button><div class=help-block ng-if=\"key === 'free_shipping' && $ctrl.incentive.is_free_shipping\"><span ng-if=!$ctrl.project.free_shipping_cost>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.freeShippingAverageCostUnset' | translate }} <a ng-click=$ctrl.setFreeShippingCost()>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.set' | translate }}</a></span> <span ng-if=$ctrl.project.free_shipping_cost translate=sites.campaigns.edit.campaignEdit.stepCoupon.setFreeShippingWithAverageCost translate-value-cost=\"{{$ctrl.currency.symbol}}{{$ctrl.project.free_shipping_cost | number:0}}{{$ctrl.currency.suffix}}\"><a ng-click=$ctrl.setFreeShippingCost()>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.change' | translate }}</a></span></div></div></div><div class=\"row row--sub\" ng-if=\"$ctrl.incentive.discount_type === 'price' || $ctrl.incentive.discount_type === 'percent'\"><div class=col-xs-12><h1>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.offer' | translate }}</h1></div><div class=col-xs-6><h2>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.selectRecommendedPlan' | translate }}</h2><div class=row><div class=col-xs-4 ng-repeat=\"amount in $ctrl.availableCoupons.type[$ctrl.incentive.discount_type].amount\"><button class=\"btn btn-option\" ng-click=$ctrl.selectIncentiveDiscountAmount(amount) ng-disabled=\"$ctrl.campaign.status !== 'incomplete'\" ng-class=\"{'active': $ctrl.incentive['discount_' + $ctrl.incentive.discount_type] === amount && !$ctrl.incentive.custom }\">{{$ctrl.availableCoupons.type[$ctrl.incentive.discount_type].label.prefix}}{{amount}}{{$ctrl.availableCoupons.type[$ctrl.incentive.discount_type].label.suffix}}</button></div></div><span class=help-block>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.recommendedPlanDescription' | translate }} <a ng-click=$ctrl.setProfitAndConversion() pe-track=campaignEditCoupon.setProfitAndConversions>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.here' | translate }}</a> {{ 'sites.campaigns.edit.campaignEdit.stepCoupon.fromWhichCanBeSet' | translate }}</span></div><div class=col-xs-1><div class=or>or</div></div><div class=col-xs-5 ng-if=\"$ctrl.incentive.discount_type === 'price'\"><h2>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.enterPrice' | translate }}</h2><div class=row><div class=col-xs-12><div class=input-group><div ng-if=$ctrl.availableCoupons.type[$ctrl.incentive.discount_type].label.prefix class=input-group-addon>{{$ctrl.availableCoupons.type[$ctrl.incentive.discount_type].label.prefix}}</div><input type=number class=form-control name=discount_price min=0 ng-min=$ctrl.availableCoupons.type[$ctrl.incentive.discount_type].min ng-max=$ctrl.availableCoupons.type[$ctrl.incentive.discount_type].max ng-click=\"$ctrl.availableCoupons.selected.amount = ''\" ng-disabled=\"$ctrl.campaign.status !== 'incomplete'\" ng-required=\"$ctrl.availableCoupons.selected.amount === ''\" ng-model=$ctrl.incentive.discount_price><div ng-if=$ctrl.availableCoupons.type[$ctrl.incentive.discount_type].label.suffix class=input-group-addon>{{$ctrl.availableCoupons.type[$ctrl.incentive.discount_type].label.suffix}}</div></div><span class=help-block translate=sites.campaigns.edit.campaignEdit.stepCoupon.discountPriceRangeCanBeSet translate-value-range={{$ctrl.currency.symbol}}{{$ctrl.availableCoupons.type[$ctrl.incentive.discount_type].min}}-{{$ctrl.availableCoupons.type[$ctrl.incentive.discount_type].max}}{{$ctrl.currency.suffix}}></span></div></div></div><div class=col-xs-5 ng-if=\"$ctrl.incentive.discount_type === 'percent'\"><h2>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.enterPercent' | translate }}</h2><div class=row><div class=col-xs-12><div class=input-group><div ng-if=$ctrl.availableCoupons.type[$ctrl.incentive.discount_type].label.prefix class=input-group-addon>{{$ctrl.availableCoupons.type[$ctrl.incentive.discount_type].label.prefix}}</div><input type=number class=form-control name=discount_price step=1 min=0 ng-min=$ctrl.availableCoupons.type[$ctrl.incentive.discount_type].min ng-max=$ctrl.availableCoupons.type[$ctrl.incentive.discount_type].max ng-click=\"$ctrl.availableCoupons.selected.amount = ''\" ng-disabled=\"$ctrl.campaign.status !== 'incomplete'\" ng-required=\"$ctrl.availableCoupons.selected.amount === ''\" ng-model=$ctrl.incentive.discount_percent><div ng-if=$ctrl.availableCoupons.type[$ctrl.incentive.discount_type].label.suffix class=input-group-addon>{{$ctrl.availableCoupons.type[$ctrl.incentive.discount_type].label.suffix}}</div></div><span class=help-block translate=sites.campaigns.edit.campaignEdit.stepCoupon.discountPercentRangeCanBeSet translate-value-range={{$ctrl.availableCoupons.type[$ctrl.incentive.discount_type].min}}-{{$ctrl.availableCoupons.type[$ctrl.incentive.discount_type].max}}></span></div></div></div></div><div class=\"row padding-none\" ng-hide=\"(!$ctrl.incentive.discount_type && !$ctrl.incentive.is_free_shipping) || ($ctrl.incentive.discount_type === 'price' && !$ctrl.incentive.discount_price) || ($ctrl.incentive.discount_type === 'percent' && !$ctrl.incentive.discount_percent)\"><div class=col-xs-12><hr></div><div class=col-md-6><h1>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.priceLimit' | translate }}<div class=\"switch pull-right\"><input type=checkbox name=switch class=switch-checkbox ng-model=$ctrl.incentive.has_price_limit ng-disabled=$ctrl.incentive.used_in_campaigns_activated_before> <label class=switch-label ng-class=\"{'disabled' : $ctrl.incentive.used_in_campaigns_activated_before}\" for=myswitch ng-click=$ctrl.switchPriceLimit()><span class=switch-inner></span> <span class=switch-switch></span></label></div></h1></div></div><div class=\"row row--sub\" ng-hide=\"(!$ctrl.incentive.discount_type && !$ctrl.incentive.is_free_shipping) || ($ctrl.incentive.discount_type === 'price' && !$ctrl.incentive.discount_price) || ($ctrl.incentive.discount_type === 'percent' && !$ctrl.incentive.discount_percent) || !$ctrl.incentive.has_price_limit\"><div class=col-md-6 ng-if=!$ctrl.campaignEdit.isOem><h1>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.tax' | translate }}</h1><div class=row><div class=col-xs-6><button class=\"btn btn-option\" ng-click=\"$ctrl.incentive.is_price_limit_tax_included = true\" ng-disabled=\"$ctrl.campaign.status !== 'incomplete'\" ng-class=\"{'active': $ctrl.incentive.is_price_limit_tax_included }\">{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.priceWithTax' | translate }}</button> <span class=help-block>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.priceLimitPriceIsTaxIncluded' | translate }}</span></div><div class=col-xs-6><button class=\"btn btn-option\" ng-click=\"$ctrl.incentive.is_price_limit_tax_included = false\" ng-disabled=\"$ctrl.campaign.status !== 'incomplete'\" ng-class=\"{'active': $ctrl.incentive.is_price_limit_tax_included === false}\">{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.priceWithoutTax' | translate }}</button> <span class=help-block>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.priceLimitPriceIsTaxExcluded' | translate }}</span></div></div></div><div ng-if=$ctrl.campaignEdit.isOem><input type=hidden ng-model=$ctrl.incentive.is_price_limit_tax_included ng-init=\"$ctrl.incentive.is_price_limit_tax_included=user.userId = true\"></div><div ng-class=\"{'col-md-5 col-md-offset-1': !$ctrl.campaignEdit.isOem, 'col-md-6': $ctrl.campaignEdit.isOem}\" ng-show=\"$ctrl.incentive.has_price_limit && $ctrl.incentive.is_price_limit_tax_included !== undefined\"><h1>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.price' | translate }}</h1><div class=input-group><div ng-if=$ctrl.currency.symbol class=input-group-addon>{{$ctrl.currency.symbol}}</div><input type=number class=form-control name=discount_price ng-min=$ctrl.getMinimumPriceLimit(incentive.discount_price) step={{$ctrl.currencyStep*100}} placeholder=3000 ng-required=\"$ctrl.incentive.discount_type === 'price' || $ctrl.incentive.has_price_limit\" ng-model=$ctrl.incentive.minimum_price ng-model-options=\"{debounce: 200}\" ng-disabled=\"$ctrl.campaign.status !== 'incomplete' || !$ctrl.incentive.has_price_limit || $ctrl.incentive.used_in_campaigns_activated_before\" min=0 max=999999999><div class=input-group-addon><span ng-if=$ctrl.currency.suffix>{{$ctrl.currency.suffix}}</span> {{ 'sites.campaigns.edit.campaignEdit.stepCoupon.above' | translate }}</div></div><div class=help-block>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.couponConditionSetDescription' | translate }} <span ng-if=$ctrl.campaignEdit.isOem>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.priceWithoutTaxInParenthesis' | translate }}</span></div><div ng-messages=incentiveForm.$error><div class=\"label label-danger\" ng-message=min>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.enterPriceBiggerThanDiscount' | translate }}</div></div></div></div><div class=row ng-hide=\"(!$ctrl.incentive.discount_type && !$ctrl.incentive.is_free_shipping) || ($ctrl.incentive.discount_type === 'price' && !$ctrl.incentive.discount_price) || ($ctrl.incentive.discount_type === 'percent' && !$ctrl.incentive.discount_percent)\"><div class=col-xs-12><hr><h1>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.couponCode' | translate }}<div class=\"margin-x label label-danger\" ng-show=\"$ctrl.campaignEdit.isCouponCodeInUse() && $ctrl.campaign.status === 'incomplete'\"><span ng-if=!$ctrl.campaignEdit.project.is_oem>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.couponCodeInDeliveryDuplicated' | translate }}</span> <span ng-if=$ctrl.campaignEdit.project.is_oem>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.issuedCouponCodeDuplicated' | translate }}</span></div></h1></div><div class=col-xs-6><input type=text class=form-control name=coupon_code ng-minlength=$ctrl.availableCoupons.couponMinLength ng-maxlength=$ctrl.availableCoupons.couponMaxLength ng-model=$ctrl.incentive.coupon_code ng-model-options=\"{debounce: 200}\" ng-pattern=$ctrl.couponCodePattern ng-disabled=\"$ctrl.campaign.status !== 'incomplete' || $ctrl.incentive.used_in_campaigns_activated_before\" required><div class=help-block translate=sites.campaigns.edit.campaignEdit.stepCoupon.enterCouponCode translate-value-max={{$ctrl.availableCoupons.couponMaxLength}}></div><div class=\"label label-warning\" ng-if=\"$ctrl.incentive.coupon_code.length > 8\">{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.recommendedCouponCodeLength' | translate }}</div><div ng-messages=incentiveForm.$error><div class=\"label label-danger\" ng-message=pattern>{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.useAlphabeticOrDigitForCouponCode' | translate }}</div><div class=\"label label-danger\" ng-message=minlength translate=sites.campaigns.edit.campaignEdit.stepCoupon.couponCodeMinLength translate-value-min={{$ctrl.availableCoupons.couponMinLength}}></div><div class=\"label label-danger\" translate=sites.campaigns.edit.campaignEdit.stepCoupon.couponCodeMaxLength translate-value-max={{$ctrl.availableCoupons.couponMaxLength}}></div></div></div><div class=col-xs-6 zcs-hide-when-integrated=color_me_shop><div ng-if=\"$ctrl.project.shopping_cart_asp && $ctrl.project.shopping_cart_asp !== 'other' && !$ctrl.campaignEdit.isIntegratedWithMakeshop\" ng-switch=$ctrl.project.shopping_cart_asp class=\"alert alert-hint config-lead\"><div ng-switch-when=makeshop><ng-include src=\"'/templates/zenclerk_s/sites/campaigns/edit/instruction_makeshop.html'\"></ng-include></div><div ng-switch-when=ec_cube><ng-include src=\"'/templates/zenclerk_s/sites/campaigns/edit/instruction_ec_cube.html'\"></ng-include></div><div ng-switch-when=futureshop2><ng-include src=\"'/templates/zenclerk_s/sites/campaigns/edit/instruction_futureshop2.html'\"></ng-include></div><div ng-switch-when=shopserve><ng-include src=\"'/templates/zenclerk_s/sites/campaigns/edit/instruction_shopserve.html'\"></ng-include></div><div ng-switch-when=shopify><ng-include src=\"'/templates/zenclerk_s/sites/campaigns/edit/instruction_shopify.html'\"></ng-include></div></div><div ng-if=$ctrl.campaignEdit.isIntegratedWithMakeshop class=\"alert alert-hint config-lead\"><ng-include src=\"'/templates/zenclerk_s/sites/campaigns/edit/instruction_makeshop_integration.html'\"></ng-include></div></div></div></div></div></form><div class=row zcs-makerepeater-only><div class=\"col-xs-12 text-center margin-y\"><button class=\"btn btn-primary btn-shadow\" ng-disabled=!$ctrl.campaignEdit.isEnabledStep($ctrl.campaignEdit.steps.next) pe-track=campaign.edit.coupon.goToStep ng-click=\"$ctrl.campaignEdit.goToStep($ctrl.campaignEdit.steps.next, 'button')\">{{ 'sites.campaigns.edit.campaignEdit.stepCoupon.next' | translate }}</button></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_step_delivery.html';
var html = "<div class=\"step-delivery container-fluid container-limited\"><h1>{{ 'sites.campaigns.edit.campaignEdit.stepDelivery.selectDeliveryPlan' | translate }}</h1><h2>{{ 'sites.campaigns.edit.campaignEdit.stepDelivery.selectAllOrAiForSegment' | translate }}</h2><div class=row><div class=col-xs-6 ng-repeat=\"plan in $ctrl.timingPlans\"><div class=\"card card-interactive {{plan.class}}\" ng-class=\"{'selected': plan.name === $ctrl.campaign.timing.name, 'disabled': $ctrl.isDisabled(plan)}\" ng-click=$ctrl.selectTiming(plan)><div class=recommended-badge>{{ 'sites.campaigns.edit.campaignEdit.stepDelivery.recommend' | translate }}</div><div class=card-interactive-disabled-note>{{ 'sites.campaigns.edit.campaignEdit.stepDelivery.aiRecommendedForMailMagazineDelivery' | translate }}</div><div class=card-header>{{plan.label}}</div><div class=text-center><svg-embed url=plan.icon></svg-embed></div><div class=card-body>{{plan.description}}</div><div class=card-footer><div ng-if=\"plan.name === 'ai'\" class=custom-selector><i class=\"fa fa-caret-down\"></i><select name=sampling_range class=custom-selector-dropdown ng-model=$ctrl.samplingRange ng-change=$ctrl.selectSamplingRange() ng-options=\"liteSamplingRange.label as ( 'sites.campaigns.edit.campaignEdit.stepDelivery.deliveryAmount' | translate: { amount: ( 'sharedModules.commonApi.api.meta.lite_sampling_ranges.' + liteSamplingRange.label | translate ) } ) for liteSamplingRange in $ctrl.liteSamplingRanges\"></select></div></div></div></div></div><div class=row zcs-makerepeater-only><div class=\"col-xs-12 text-center margin-y\"><button class=\"btn btn-primary btn-shadow\" ng-disabled=!$ctrl.campaignEdit.isEnabledStep($ctrl.campaignEdit.steps.next) pe-track=campaign.edit.delivery.goToStep ng-click=\"$ctrl.campaignEdit.goToStep($ctrl.campaignEdit.steps.next, 'button')\">{{ 'sites.campaigns.edit.campaignEdit.stepDelivery.next' | translate }}</button></div></div><div class=\"row padding-y\"><div class=\"col-xs-12 note\"><h1>{{ 'sites.campaigns.edit.campaignEdit.stepDelivery.whyUseAi' | translate }}</h1>{{ 'sites.campaigns.edit.campaignEdit.stepDelivery.aiFeatureExplanation1' | translate: { service: $ctrl.ZcsOemService.getName() } }}<br>{{ 'sites.campaigns.edit.campaignEdit.stepDelivery.aiFeatureExplanation2' | translate }}</div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_step_design.html';
var html = "<div class=step-design><div class=template-editor-container ng-show=$ctrl.campaign.template_type><div class=col-xs-7><zcs-campaign-template-dynamic-view project=$ctrl.project campaign=$ctrl.campaign></zcs-campaign-template-dynamic-view></div><sidebar class=col-xs-5><div class=sidebar-header>{{ 'sites.campaigns.edit.campaignEdit.stepDesign.templateSetting' | translate }}</div><div class=sidebar-body><input type=hidden required ng-model=$ctrl.campaign.template><div class=row><div class=text-center ng-repeat=\"template in $ctrl.selectableTemplates\" ng-class=\"{true: 'col-xs-6', false: 'col-xs-4'}[$ctrl.selectableTemplates.length == 2]\"><div class=menu-item ng-class=\"{'active': $ctrl.campaign.template_type === template.template_type}\" ng-click=$ctrl.selectTemplate(template)><img ng-src={{template.img_url}}> <label>{{template.label | translate}}</label><div ng-if=$ctrl.isNewTemplate(template) class=new></div></div></div></div><zcs-campaign-template-editor campaign=$ctrl.campaign project=$ctrl.project></zcs-campaign-template-editor><div class=sidebar-footer zcs-makerepeater-only><button class=\"btn btn-primary btn-shadow\" ng-disabled=!$ctrl.campaignEdit.isEnabledStep($ctrl.campaignEdit.steps.next) pe-track=campaign.edit.design.goToStep ng-click=\"$ctrl.campaignEdit.goToStep($ctrl.campaignEdit.steps.next, 'button')\">{{ 'sites.campaigns.edit.campaignEdit.stepDesign.next' | translate }}</button></div></div></sidebar></div><div class=clearfix></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_step_schedule.html';
var html = "<div class=\"container-fluid container-limited step-schedule\"><div class=row><div class=col-md-12><h1>{{ 'sites.campaigns.edit.campaignEdit.stepSchedule.setDatetime' | translate }}</h1><h2>{{ 'sites.campaigns.edit.campaignEdit.stepSchedule.selectStartDatetimeAndEndDatetime' | translate }}</h2></div></div><zcs-notification-timezone project=$ctrl.project status=danger static=true></zcs-notification-timezone><div class=\"row step-schedule-select\"><div class=\"col-sm-10 col-sm-offset-1\"><div class=row><div class=\"col-md-6 text-left\"><h4>{{ 'sites.campaigns.edit.campaignEdit.stepSchedule.deliveryStartDatetime' | translate }}</h4></div><div class=\"col-md-6 text-right\" ng-hide=$ctrl.campaign.has_been_started><a class=\"btn btn-blank btn-sm\" ng-click=$ctrl.setToNow($ctrl.campaign.start_at_obj)>{{ 'sites.campaigns.edit.campaignEdit.stepSchedule.now' | translate }}</a> <a class=\"btn btn-blank btn-sm\" ng-click=$ctrl.setToBeginningOfNextMonth($ctrl.campaign.start_at_obj)>{{ 'sites.campaigns.edit.campaignEdit.stepSchedule.beginningOfNextMonth' | translate }}</a> <a class=\"btn btn-blank btn-sm\" ng-click=$ctrl.setToBeginningOfNextNextMonth($ctrl.campaign.start_at_obj)>{{ 'sites.campaigns.edit.campaignEdit.stepSchedule.beginningOfNextNextMonth' | translate }}</a></div></div><date-time-picker class=date-time-picker min={{$ctrl.minStart}} ng-hide=$ctrl.campaign.has_been_started ng-model=$ctrl.campaign.start_at_obj interval=\"$ctrl.campaignEdit.isOem ? 60 : 30\" is-required=true region=$ctrl.project.region></date-time-picker><div ng-hide=!$ctrl.campaign.has_been_started>{{$ctrl.campaign.start_at | zcDate}} {{$ctrl.project.region | gmtNotation}}</div><div class=\"label label-danger\" ng-show=$ctrl.isInvalidStart()>{{ 'sites.campaigns.edit.campaignEdit.stepSchedule.cannotStartCampaignBeforeToday' | translate }}</div><hr><div class=row><div class=\"col-md-6 text-left\"><h4>{{ 'sites.campaigns.edit.campaignEdit.stepSchedule.deliveryEndDatetime' | translate }}<div class=\"switch pull-right\" ng-if=\"$ctrl.campaignEdit.isIntegratedWithMakeshop && ['activated', 'blocked', 'terminated'].indexOf($ctrl.campaign.status) === -1\"><input type=checkbox name=switch class=switch-checkbox ng-model=$ctrl.incentive.is_infinite ng-true-value=false ng-false-value=true> <label class=switch-label for=myswitch ng-click=$ctrl.switchEndLimit()><span class=switch-inner></span> <span class=switch-switch></span></label></div></h4></div><div class=\"col-md-6 text-right\" ng-hide=\"$ctrl.campaign.is_infinite || $ctrl.incentive.is_infinite\"><a class=\"btn btn-blank btn-sm\" ng-click=$ctrl.setToEndOfMonth($ctrl.campaign.end_at_obj)>{{ 'sites.campaigns.edit.campaignEdit.stepSchedule.endOfMonth' | translate }}</a> <a class=\"btn btn-blank btn-sm\" ng-click=$ctrl.setToEndOfNextMonth($ctrl.campaign.end_at_obj)>{{ 'sites.campaigns.edit.campaignEdit.stepSchedule.endOfNextMonth' | translate }}</a> <a class=\"btn btn-blank btn-sm\" ng-click=$ctrl.setToEndOfNextNextMonth($ctrl.campaign.end_at_obj)>{{ 'sites.campaigns.edit.campaignEdit.stepSchedule.endOfNextNextMonth' | translate }}</a></div></div><date-time-picker class=date-time-picker ng-hide=\"$ctrl.campaign.is_infinite || $ctrl.incentive.is_infinite\" min={{$ctrl.minEnd}} ng-model=$ctrl.campaign.end_at_obj interval=\"$ctrl.campaignEdit.isOem ? 60 : 30\" is-required=true region=$ctrl.project.region></date-time-picker><div ng-if=\"$ctrl.campaign.is_infinite && ['activated', 'blocked', 'terminated'].indexOf($ctrl.campaign.status) >= 0\">{{ 'sites.campaigns.edit.campaignEdit.stepSchedule.infinite' | translate }}</div><div class=\"label label-danger\" ng-show=$ctrl.isInvalidEnd()>{{ 'sites.campaigns.edit.campaignEdit.stepSchedule.setEndDatetimeAfterStartDatetime' | translate }}</div></div></div><div class=row zcs-makerepeater-only><div class=\"col-xs-12 text-center margin-y\"><button class=\"btn btn-primary btn-shadow\" ng-disabled=!$ctrl.campaignEdit.isEnabledStep($ctrl.campaignEdit.steps.next) pe-track=campaign.edit.schedule.goToStep ng-click=\"$ctrl.campaignEdit.goToStep($ctrl.campaignEdit.steps.next, 'button')\">{{ 'sites.campaigns.edit.campaignEdit.stepSchedule.next' | translate }}</button></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/edit/campaign_edit_step_segment.html';
var html = "<div class=\"container-fluid container-limited step-segment\"><div class=row><div class=col-md-12><h1>{{ 'sites.campaigns.edit.campaignEdit.stepSegment.selectSegment' | translate }}</h1><h2>{{ 'sites.campaigns.edit.campaignEdit.stepSegment.selectCampaignDeliveryTarget' | translate }}</h2><div class=segment-campaign-proposals><h3 ng-if=\"$ctrl.proposals.length == 0\">{{ 'sites.campaigns.edit.campaignEdit.stepSegment.noSegmentAvailable' | translate }}</h3><div class=\"row segment-campaign-proposals\" ng-if=\"$ctrl.proposals.length >= 1\"><div class=\"alert alert-info\" ng-if=$ctrl.isActive()>{{ 'sites.campaigns.edit.campaignEdit.stepSegment.activeCampaignsCannotBeChangedToMailMagazine' | translate }}</div><div class=row ng-if=\"$ctrl.proposals.length >= 1\"><div class=col-xs-3 ng-repeat=\"segment in $ctrl.proposals\"><div class=\"card card-interactive {{segment.class}}\" ng-click=$ctrl.toggleSegment(segment) pe-track=campaign.edit.segmentSelection pe-attrs=\"{ label: segment.label }\" ng-class=\"{ selected: $ctrl.isCurrentSelected(segment), disabled: !$ctrl.isAllowedToSelect(segment), recommended: segment.class == 'zcs-segment-all' }\"><div class=recommended-badge>{{ 'sites.campaigns.edit.campaignEdit.stepSegment.recommend' | translate }}</div><div class=card-proposal-title ng-if=\"segment.name !== 'zcs_segment_cv_users'\" uib-tooltip={{segment.info}} tooltip-placement=bottom>{{segment.label}}<div class=\"badge badge-tooltip\"><i class=\"fa fa-question\"></i></div></div><div class=card-proposal-title ng-if=\"segment.name === 'zcs_segment_cv_users'\" uib-tooltip={{$ctrl.selectedCvSegmentProposal.info}} tooltip-placement=bottom>{{ 'sites.campaigns.edit.campaignEdit.stepSegment.purchase' | translate }}<div class=\"badge badge-tooltip\"><i class=\"fa fa-question\"></i></div></div><div class=\"text-center margin-y\"><svg-embed class=margin-y url=segment.icon></svg-embed><div ng-if=\"segment.name === 'zcs_segment_cv_users'\" class=custom-selector><i class=\"fa fa-caret-down\"></i><select name=cvSegmentFilter class=custom-selector-dropdown ng-change=$ctrl.toggleSegment($ctrl.selectedCvSegmentProposal) ng-model=$ctrl.selectedCvSegmentProposal ng-options=\"proposal as proposal.label for proposal in $ctrl.allCvSegmentProposals\"></select></div></div><small>{{ 'sites.campaigns.edit.campaignEdit.stepSegment.estimatedCouponCirculationAmount' | translate }}</small><div ng-if=\"segment.name !== 'zcs_segment_mail_only'\"><div class=\"card-proposal-number number-xl\"><zcs-estimated-revenue ng-if=\"segment.name !== 'zcs_segment_cv_users'\" revenue=segment.stats.estimatedMonthlyCouponRevenue project=$ctrl.project></zcs-estimated-revenue><zcs-estimated-revenue ng-if=\"segment.name === 'zcs_segment_cv_users'\" revenue=$ctrl.selectedCvSegmentProposal.stats.estimatedMonthlyCouponRevenue project=$ctrl.project></zcs-estimated-revenue></div></div><div ng-if=\"segment.name === 'zcs_segment_mail_only'\"><div class=\"card-proposal-number number-xl\"><span class=campaign-estimated-revenue>-</span></div></div></div></div></div></div></div></div></div><div class=\"note padding-y text-center\" zcs-makerepeater-only><span translate=sites.campaigns.edit.campaignEdit.stepSegment.descriptionOfCookieBasedTracking translate-value-service={{$ctrl.ZcsOemService.getName()}}></span></div><div class=row zcs-makerepeater-only><div class=\"col-xs-12 text-center margin-y\"><button class=\"btn btn-primary btn-shadow\" ng-disabled=!$ctrl.campaignEdit.isEnabledStep($ctrl.campaignEdit.steps.next) pe-track=campaign.edit.segment.goToStep ng-click=\"$ctrl.campaignEdit.goToStep($ctrl.campaignEdit.steps.next, 'button')\">{{ 'sites.campaigns.edit.campaignEdit.stepSegment.next' | translate }}</button></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/edit/instruction_ec_cube.html';
var html = "<ng-container translate=sites.campaigns.edit.instruction.ecCube translate-value-link=\"<a href='http://www.ec-cube.net/products/detail.php?product_id=470' target='_blank'>{{ 'sites.campaigns.edit.instruction.ecCubeLink' | translate }}</a>\"></ng-container>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/edit/instruction_futureshop2.html';
var html = "<span translate=sites.campaigns.edit.instruction.futureshop2></span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/edit/instruction_makeshop.html';
var html = "<ng-container translate=sites.campaigns.edit.instruction.makeshop translate-value-service={{$ctrl.ZcsOemService.getName()}} translate-value-link=\"<a href='http://ms-manual.makeshop.jp/coupon/' target='_blank'>{{ 'sites.campaigns.edit.instruction.here' | translate }}</a>\"></ng-container>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/edit/instruction_makeshop_integration.html';
var html = "<span translate=sites.campaigns.edit.instruction.makeshopIntegration translate-value-service={{$ctrl.ZcsOemService.getName()}}></span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/edit/instruction_shopify.html';
var html = "<ng-container translate=sites.campaigns.edit.instruction.shopify translate-value-service={{$ctrl.ZcsOemService.getName()}} translate-value-link=\"<a href='https://help.shopify.com/ja/manual/promoting-marketing/discount-codes' target='_blank'>{{ 'sites.campaigns.edit.instruction.here' | translate }}</a>\"></ng-container>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/edit/instruction_shopserve.html';
var html = "<span translate=sites.campaigns.edit.instruction.shopserve></span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/integrated_coupon/list.html';
var html = "<div class=\"container-fluid container-limited coupon-history padding-y\"><h1>{{ 'sites.campaigns.integratedCouponList.makeshopApiIntegratedCoupon' | translate }} <span class=badge>{{$ctrl.coupons.length}}</span></h1><table class=col-md-12><thead><tr><th>{{ 'sites.campaigns.integratedCouponList.couponType' | translate }}</th><th>{{ 'sites.campaigns.integratedCouponList.couponCode' | translate }}</th><th>{{ 'sites.campaigns.integratedCouponList.period' | translate }}</th><th>{{ 'sites.campaigns.integratedCouponList.condition' | translate }}</th></tr></thead><tbody ng-repeat=\"coupon in $ctrl.coupons\"><td><span ng-if=\"coupon.type === '1'\">{{$ctrl.currency.symbol}}{{coupon.type_value}}{{$ctrl.currency.suffix}}OFF</span> <span ng-if=\"coupon.type === '2'\">{{coupon.type_value}}%OFF</span> <span ng-if=\"coupon.type === '3'\">{{ 'sites.campaigns.integratedCouponList.freeShipping' | translate }}</span></td><td>{{coupon.code}}</td><td>{{coupon.start_date}} - {{coupon.end_date}}</td><td>{{coupon.minimum_purchase ? ('sites.campaigns.integratedCouponList.aboveAmount' | translate: { min: $ctrl.currency.symbol + coupon.minimum_purchase + $ctrl.currency.suffix }) : ('sites.campaigns.integratedCouponList.none' | translate)}}</td></tbody></table><div class=row><div class=\"col-md-12 note\"><h2>{{ 'sites.campaigns.integratedCouponList.aboutThisPage' | translate }}</h2>{{ 'sites.campaigns.integratedCouponList.makeshopApiObtainedCouponList' | translate }}<h2>{{ 'sites.campaigns.integratedCouponList.notice' | translate }}</h2>{{ 'sites.campaigns.integratedCouponList.makeshopCouponPolicy1' | translate }}<br>{{ 'sites.campaigns.integratedCouponList.makeshopCouponPolicy2' | translate }}</div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/list/campaigns_list.html';
var html = "<div class=\"row campaigns-empty\" ng-if=\"$ctrl.pagedCampaigns.length == 0\"><div class=col-sm-12><p>{{ 'sites.campaigns.list.campaignsList.campaignNotAvailable' | translate }}</p></div></div><zcs-campaigns-list-item ng-repeat=\"campaign in $ctrl.pagedCampaigns\" project=$ctrl.project campaign=campaign filters=$ctrl.filters show-stats=$ctrl.showStats on-update=onUpdate() on-remove=removeCampaign(campaign)></zcs-campaigns-list-item><zcs-notification-timezone project=$ctrl.project></zcs-notification-timezone>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/list/item.html';
var html = "<div class=\"row campaigns-list-item\"><div class=\"card {{$ctrl.campaign.status}} {{$ctrl.campaign.current_status}} col-sm-12\"><div class=row><div class=\"campaigns-list-item__blocked col-sm-10\" ng-if=\"$ctrl.campaign.current_status === 'blocked'\"><span ng-if=\"!$ctrl.project.is_publish_limit_reached || !$ctrl.campaign.auto_restart\">{{ 'sites.campaigns.list.item.campaignsPaused' | translate }}</span> <span ng-if=\"$ctrl.project.is_publish_limit_reached && $ctrl.campaign.auto_restart\">{{ 'sites.campaigns.list.item.campaignsPausedUntilNextMonthReason' | translate }}</span></div><div class=col-sm-5><campaign-view-card project=$ctrl.project campaign=$ctrl.campaign></campaign-view-card></div><div class=\"col-sm-5 campaigns-list-item__data\"><div class=campaigns-list-item__nodata ng-if=\"$ctrl.campaign.current_status === 'incomplete'\"><div class=row><div class=col-sm-6><button class=\"btn btn-primary\" ui-sref=\"zenclerkS.project.campaign.edit({campaignId: $ctrl.campaign.id})\"><i class=\"fa fa-pencil\"></i> {{ 'sites.campaigns.list.item.edit' | translate }}</button></div><div class=col-sm-6><button confirm-click=$ctrl.removeCampaign($ctrl.campaign) confirm-modal class=\"btn btn-danger\"><i class=\"fa fa-trash-o\"></i> {{ 'sites.campaigns.list.item.delete' | translate }}</button></div></div></div><div class=campaigns-list-item__nodata ng-if=\"$ctrl.campaign.current_status === 'pending'\">{{ 'sites.campaigns.list.item.campaignNotStartedYet' | translate }}</div><div class=row><div class=col-sm-4><div class=chart><zcs-chart-single-bar class=chart-tertiary ng-if=$ctrl.chartData.delivery chart-data=$ctrl.chartData.delivery chart-legend=false></zcs-chart-single-bar></div><span>{{ $ctrl.totalDeliveryCount | number:0 }}</span><div class=campaigns-list-item__legend>{{ 'sites.campaigns.list.item.couponDeliveryCount' | translate }}</div></div><div class=col-sm-4><div class=chart><zcs-chart-single-bar ng-if=$ctrl.chartData.conversion chart-data=$ctrl.chartData.conversion chart-legend=false></zcs-chart-single-bar></div><div ng-if=\"$ctrl.project.invoice_calculation_type === 'normal'\"><span>{{ $ctrl.totalConversionCount | number:0 }}</span><div class=campaigns-list-item__legend tooltip-placement=bottom>{{ 'sites.campaigns.list.item.couponUsedCount' | translate }}</div></div><div ng-if=\"$ctrl.project.invoice_calculation_type === 'deemed'\"><span>{{ $ctrl.totalConversionCount | number:0 }}</span><div class=campaigns-list-item__legend uib-tooltip=\"{{ 'sites.campaigns.list.item.cvUserTooltip' | translate }}\" tooltip-placement=bottom>{{ 'sites.campaigns.list.item.cvUsersCount' | translate }}</div></div></div><div class=\"col-sm-4 campaigns-list-item__counter\" uib-tooltip=\"{{ $ctrl.totalConversionPercentage | number:1 }}% {{ 'sites.campaigns.list.item.cvRate' | translate }} | {{ $ctrl.averageConversionPrice | zcCurrency : $ctrl.currency.symbol:0:$ctrl.currency.suffix }} {{ 'sites.campaigns.list.item.avgCvPrice' | translate }}\" tooltip-placement=bottom><span>{{ $ctrl.totalConversionPrice | zcCurrency : $ctrl.currency.symbol:$ctrl.currency.fractionSize:$ctrl.currency.suffix }}</span><div class=campaigns-list-item__legend>{{ 'sites.campaigns.list.item.totalCvAmount' | translate }}</div></div></div></div><div class=\"col-sm-2 campaigns-list-item__action\"><campaign-action-menu class=pull-right project=$ctrl.project campaign=$ctrl.campaign on-click=$ctrl.toggleMenu()></campaign-action-menu></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/list/list.html';
var html = "<div class=\"container container-limited campaigns\"><div class=\"row margin-y\"><div class=col-sm-8><ul class=\"nav nav-bar\"><li ng-if=\"vm.isActiveProject || vm.isOemProject || vm.isMasterUser\" ui-sref=zenclerkS.project.campaigns.active ui-sref-active-eq=active><a>{{ 'sites.campaigns.list.list.active' | translate }}</a></li><li ui-sref=zenclerkS.project.campaigns.draft ui-sref-active-eq=active ng-if=\"(vm.isActiveProject || vm.isOemProject || vm.isMasterUser) && vm.incompleteCampaigns.length > 0\"><a>{{ 'sites.campaigns.list.list.draft' | translate }} <span class=badge>{{vm.incompleteCampaigns.length}}</span></a></li><li ui-sref=zenclerkS.project.campaigns.finished ui-sref-active-eq=active><a>{{ 'sites.campaigns.list.list.past' | translate }}</a></li></ul></div><div ng-if=\"vm.isActiveProject || vm.isOemProject || vm.isMasterUser\" class=col-sm-4><zcs-campaign-create-button class=pull-right project=vm.project></zcs-campaign-create-button></div></div><p ng-if=\"vm.excludeIps.length === 0\" class=text-center><span class=text-warning><ng-container ng-if=\"['color_me_shop'].includes(vm.project.integrated_with)\" translate=sites.campaigns.list.list.testConversionsIncludedInCampaignReport></ng-container><ng-container ng-if=\"!['color_me_shop'].includes(vm.project.integrated_with)\" translate=sites.campaigns.list.list.testConversionsIncludedInInvoice></ng-container><a ui-sref=\"zenclerkS.project.excludeIps({apikey: vm.project.apikey})\">{{ 'sites.campaigns.list.list.clickHereForSetting' | translate }}</a></span></p><ui-view name=campaignsList></ui-view><div class=row><div class=\"note col-md-12\"><p>{{ 'sites.campaigns.list.list.cvCountDifferenceReason1' | translate }}<br>{{ 'sites.campaigns.list.list.cvCountDifferenceReason2' | translate: { service: vm.ZcsOemService.getName() } }}</p><br><p zcs-shopping-cart-asp-only=makeshop,futureshop2>{{ 'sites.campaigns.list.list.trackingAccuracyExplanation1' | translate: { service: vm.ZcsOemService.getName() } }}<br>{{ 'sites.campaigns.list.list.trackingAccuracyExplanation2' | translate }}</p></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/mail_mag_url_modal.html';
var html = "<svg-embed ng-click=$ctrl.close() class=modal-close url=\"'/assets/img/icon-close.svg'\"></svg-embed><div class=\"campaign-edit-modal-launch text-center\"><div class=modal-header>{{ 'sites.campaigns.mailMagUrlModal.urlForMailMag' | translate }}</div><div class=modal-body><p translate=sites.campaigns.mailMagUrlModal.parameterInstruction></p><p zcs-hide-when-oem translate=sites.campaigns.mailMagUrlModal.supportedBrowserInstruction></p><h2 class=\"padding-y-half padding-top\">{{ 'sites.campaigns.mailMagUrlModal.landingPage' | translate }}</h2><input class=form-control type=url ng-model=$ctrl.landingPage placeholder=\"http://\"><h2 class=padding-y-half>{{ 'sites.campaigns.mailMagUrlModal.urlForMailMag' | translate }}</h2><div class=\"alert alert-hint margin-none\">{{$ctrl.getLandingPageUrlWithParameter()}}</div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/preview_link_modal.html';
var html = "<svg-embed ng-click=$ctrl.close() class=modal-close url=\"'/assets/img/icon-close.svg'\"></svg-embed><div class=\"campaign-edit-modal-launch text-center\"><div class=modal-header>{{ 'sites.campaigns.previewLinkModal.previewOnSiteToConfirm' | translate }}</div><div class=modal-body><div>{{ 'sites.campaigns.previewLinkModal.canPreviewWithBelowUrl' | translate }}</div><div class=preview-link><a href={{$ctrl.previewUrl}} target=_blank>{{$ctrl.previewUrl}}</a></div><div class=\"alert alert-info\">{{ 'sites.campaigns.previewLinkModal.useChromeSecretMode' | translate }}</div><div class=text-center><img src=/assets/chrome-secret-window.png></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/campaigns/show/summary.html';
var html = "<div class=campaign-summary><div class=campaign-summary__header><div class=\"container-fluid container-limited\"><div class=row><svg-embed ui-sref=zenclerkS.project.campaigns class=campaign-summary__back url=\"'/assets/icons/arrow-left-circle.svg'\"></svg-embed><div class=col-sm-5><campaign-view-card project=$ctrl.project campaign=$ctrl.campaign></campaign-view-card></div><div class=col-sm-7><div class=\"campaign-summary__counter text-right\"><div class=campaign-summary__legend>{{ 'sites.campaigns.show.summary.monthlyTotalConversions' | translate }}</div><ul class=campaign-summary__nav><li ng-repeat=\"dataOfMonth in $ctrl.monthlyConversionChartData\" ng-click=$ctrl.goToPeriod(dataOfMonth.x) ng-style=\"{height: $ctrl.getMonthlyConversionPercentage(dataOfMonth.y) + '%'}\" ng-class=\"{active: $ctrl.isCurrentMonth(dataOfMonth.x)}\" uib-tooltip=\"{{dataOfMonth.x | zcDate:{format: 'yyyy年M月'} }} {{ dataOfMonth.y | zcCurrency : $ctrl.currency.symbol: $ctrl.currency.fractionSize :$ctrl.currency.suffix }}\" tooltip-placement=bottom></li></ul><nav class=\"clearfix pull-right\"><ul class=\"pagination pagination-sm\"><li ng-class=\"{disabled: !$ctrl.hasPrevMonth()}\" tooltip-enable={{$ctrl.hasReachedTheEnd()}} uib-tooltip=\"{{ 'sites.campaigns.show.summary.noDataBefore' | translate: { day: $ctrl.firstDataDayInJapanese } }}\"><a ng-click=\"$ctrl.goToPeriod($ctrl.filters.month, 'prev')\"><span>&lsaquo;</span></a></li><li class=active><a href=#>{{ $ctrl.filters.month | date: ('sharedModules.dateTimeFormats.yearMonth' | translate) }}</a></li><li ng-class=\"{disabled: !$ctrl.hasNextMonth()}\"><a ng-click=\"$ctrl.goToPeriod($ctrl.filters.month, 'next')\"><span>&rsaquo;</span></a></li></ul></nav></div></div><div class=campaign-summary__action><campaign-action-menu project=$ctrl.project campaign=$ctrl.campaign></campaign-action-menu></div></div></div></div><div class=campaign-summary__stats><div class=\"container-fluid container-limited\"><div class=row><div zcs-hide-when-integrated=color_me_shop,shopify class=\"col-md-4 campaign-summary__summary\"><div ng-if=\"$ctrl.campaign.current_status === 'active'\"><h1>{{ 'sites.campaigns.show.summary.campaignsInDelivery' | translate }}</h1><p ng-if=$ctrl.isCampaignStartedToday()><span>{{ 'sites.campaigns.show.summary.campaignsInDelivery' | translate }}</span></p><p ng-if=!$ctrl.isCampaignStartedToday()><span ng-if=$ctrl.isCampaignEndingSoon($ctrl.campaign) translate=sites.campaigns.show.summary.createCampaignInstruction translate-value-status={{$ctrl.campaignProgress.toString()}}></span></p></div><div ng-if=\"$ctrl.campaign.current_status === 'terminated'\"><h1>{{ 'sites.campaigns.show.summary.campaignEnd' | translate }}</h1><p>{{ 'sites.campaigns.show.summary.createCampaignByInheritingSettings' | translate }}</p></div><div ng-if=\"$ctrl.campaign.current_status === 'terminated' || $ctrl.isCampaignEndingSoon($ctrl.campaign)\"><div class=\"btn btn-primary\" ng-show=\"$ctrl.project.profit_percent && $ctrl.project.average_conversion_price && $ctrl.isAllowedLiteTemplate()\" ng-click=$ctrl.copyCampaign()>{{ 'sites.campaigns.show.summary.campaignCopy' | translate }}</div></div><div ng-if=\"$ctrl.campaign.current_status === 'blocked'\"><h1>{{ 'sites.campaigns.show.summary.campaignBlock' | translate }}</h1><p><a confirm-modal=\"{{ 'sites.campaigns.show.summary.okToRestartCampaign' | translate }}\" confirm-click=$ctrl.resumeCampaign() class=\"btn btn-primary\"><i class=\"fa fa-play\"></i> {{ 'sites.campaigns.show.summary.restart' | translate }}</a></p></div><div zcs-hide-when-integrated=color_me_shop,shopify><h2 translate=sites.campaigns.show.summary.conversionPriceOfMonth translate-value-month=\"{{ $ctrl.filters.month | date: ('sharedModules.dateTimeFormats.yearMonth' | translate) }}\"></h2><table><tbody><tr><th>{{ 'sites.campaigns.show.summary.totalConversionPrice' | translate }}</th><td class=text-right><span class=unit>{{ $ctrl.campaignStats.conversionPrice | zcCurrency : $ctrl.currency.symbol: $ctrl.currency.fractionSize :$ctrl.currency.suffix }}</span></td></tr><tr><th><abbr uib-tooltip=\"{{ 'sites.campaigns.show.summary.salesCostTooltip' | translate: { percent: ($ctrl.project.profit_percent | number: 0) } }}\">{{ 'sites.campaigns.show.summary.salesCost' | translate }}</abbr></th><td class=text-right><span class=unit>{{ -$ctrl.campaignStats.salesCost | zcCurrency : $ctrl.currency.symbol: $ctrl.currency.fractionSize :$ctrl.currency.suffix }}</span></td></tr><tr><th><abbr uib-tooltip=\"{{ 'sites.campaigns.show.summary.totalDiscountBasedOnDeliveredCoupon' | translate }}\">{{ 'sites.campaigns.show.summary.couponCost' | translate }}</abbr> <span class=\"badge badge-info\" ng-if=$ctrl.campaign.incentives[0].is_free_shipping ng-click=$ctrl.setFreeShippingCost() uib-tooltip=\"{{ 'sites.campaigns.show.summary.freeShippingCostTooltip' | translate: { cost: $ctrl.currency.symbol + ($ctrl.project.free_shipping_cost || $ctrl.defaultFreeShippingCost | number:0) + $ctrl.currency.suffix } }}\" tooltip-append-to-body=true><i class=\"fa fa-icon\">*</i></span></th><td class=text-right><span class=unit>{{ -$ctrl.campaignStats.couponCost | zcCurrency : $ctrl.currency.symbol: $ctrl.currency.fractionSize :$ctrl.currency.suffix }}</span></td></tr></tbody></table></div></div><div class=\"col-md-{{ ['color_me_shop', 'shopify'].includes($ctrl.project.integrated_with) ? 12 : 8 }} campaign-summary__chart\"><div class=row><div class=col-xs-4><h1>{{ 'sites.campaigns.show.summary.couponDeliveryStatus' | translate}}</h1></div><div class=col-xs-3><div class=\"campaign-summary__counter text-right\"><div class=campaign-summary__legend>{{ 'sites.campaigns.show.summary.couponDeliveryCount' | translate}}</div><span class=zc-tertiary>{{$ctrl.campaignStats.deliveryCount | number: 0}}</span></div></div><div class=col-xs-2><div class=\"campaign-summary__counter text-right\"><div class=campaign-summary__legend>{{ 'sites.campaigns.show.summary.cvCount' | translate}}</div><span class=zc-primary>{{$ctrl.campaignStats.conversionCount}}</span></div></div><div class=col-xs-3><div class=\"campaign-summary__counter text-right\"><div class=campaign-summary__legend>{{ $ctrl.filters.month | date: ('sharedModules.dateTimeFormats.yearMonth' | translate) }}{{ 'sites.campaigns.show.summary.totalConversionPrice' | translate }}</div><span class=zc-primary>{{$ctrl.campaignStats.conversionPrice | zcCurrency : $ctrl.currency.symbol: $ctrl.currency.fractionSize :$ctrl.currency.suffix }}</span></div></div></div><div class=row><div class=col-xs-12><div class=\"btn-group small\"><a class=\"btn btn-secondary\" ng-class=\"{active: $ctrl.filters.main_chart === 'conversionPrice'}\" ng-click=\"$ctrl.setSelectedChart('conversionPrice')\">{{ 'sites.campaigns.show.summary.dailyConversionPrice' | translate}}</a> <a class=\"btn btn-secondary\" ng-class=\"{active: $ctrl.filters.main_chart === 'conversionPriceCumulative'}\" ng-click=\"$ctrl.setSelectedChart('conversionPriceCumulative')\">{{ 'sites.campaigns.show.summary.cumulativeConversionPrice' | translate}}</a> <a class=\"btn btn-secondary\" ng-class=\"{active: $ctrl.filters.main_chart === 'conversions'}\" ng-click=\"$ctrl.setSelectedChart('conversions')\">{{ 'sites.campaigns.show.summary.couponDeliveryCVCount' | translate}}</a></div></div></div><zcs-chart-stacked-bar ng-if=$ctrl.mainChartData dimension=$ctrl.filters.dimension chart-data=$ctrl.mainChartData></zcs-chart-stacked-bar></div></div><div class=\"row campaign-summary__data\"><div class=\"col-md-2 col-md-offset-2\"><div class=campaign-summary__counter><div class=campaign-summary__legend>{{ 'sites.campaigns.show.summary.overallSessionCount' | translate}}</div><span>{{$ctrl.segmentStats.sessionCount | number: 0}}</span><div class=campaign-summary_progress>{{$ctrl.getProgression()}}</div></div></div><div class=col-md-2><div class=campaign-summary__counter><div class=campaign-summary__legend>{{ 'sites.campaigns.show.summary.couponDeliveryCount' | translate}}</div><span>{{$ctrl.campaignStats.deliveryCount | number: 0}}</span></div></div><div class=col-md-2><div class=campaign-summary__counter><div class=campaign-summary__legend>{{ 'sites.campaigns.show.summary.couponViaCVCount' | translate}}</div><span>{{$ctrl.campaignStats.conversionCount | number: 0}}</span></div></div><div class=col-md-2><div class=campaign-summary__counter><div class=campaign-summary__legend><abbr uib-tooltip=\"{{ 'sites.campaigns.show.summary.couponViaCvCountTooltip' | translate}}\">{{ 'sites.campaigns.show.summary.couponDeliveryCVRate' | translate}}</abbr></div><span>{{$ctrl.campaignStats.conversionPercent | number: 1}}%</span></div></div></div></div></div><div class=\"container-fluid container-limited\"><div><zcs-campaign-list-conversions campaign=$ctrl.campaign start-at=$ctrl.startAt end-at=$ctrl.currentEnd project=$ctrl.project></zcs-campaign-list-conversions></div><div class=row><div class=col-md-12><h1>{{ 'sites.campaigns.show.summary.template' | translate}}</h1></div><zcs-campaign-template-dynamic-view class=col-md-6 campaign=$ctrl.campaign project=$ctrl.project only-views=[0]></zcs-campaign-template-dynamic-view><zcs-campaign-template-dynamic-view class=col-md-6 campaign=$ctrl.campaign project=$ctrl.project only-views=[1]></zcs-campaign-template-dynamic-view></div><div class=\"row margin-y\"><zcs-campaign-template-dynamic-view class=col-md-12 campaign=$ctrl.campaign project=$ctrl.project only-views=[2]></zcs-campaign-template-dynamic-view></div></div></div><zcs-notification-timezone project=$ctrl.project></zcs-notification-timezone>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/dashboard/dashboard-main.html';
var html = "<div class=\"container container-limited dashboard-main\"><div class=\"row widget-list\"></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/dashboard/dashboard.html';
var html = "<div class=\"container dashboard\"><zcs-dashboard-main project=project></zcs-dashboard-main><zcs-notification-timezone project=project></zcs-notification-timezone></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/dashboard/navigation.html';
var html = "<a ng-class=\"{active: vm.isCategory('dashboardNew')}\" ui-sref=\"zenclerkS.project.dashboardNew({apikey: vm.project.apikey, force_mode: undefined})\">{{ 'sites.dashboard.navigation.dasshuboodo' | translate }}</a> <a ng-class=\"{active: vm.isCategory('analytics')}\" ui-sref=\"zenclerkS.project.dashboardNewAnalytics({apikey: vm.project.apikey})\">{{ 'sites.dashboard.navigation.anaritikusu' | translate }}</a> <a ui-sref=\"zenclerkS.project.dashboardNew({apikey: vm.project.apikey, force_mode: 'setup_done_active_campaign'})\">{{ 'sites.dashboard.navigation.dounyuu_kanryou_haishinchuu' | translate }}</a> <a ui-sref=\"zenclerkS.project.dashboardNew({apikey: vm.project.apikey, force_mode: 'no_active_campaigns'})\">{{ 'sites.dashboard.navigation.dounyuu_kanryou_haishinchuu_dehanai' | translate }}</a> <a ui-sref=\"zenclerkS.project.dashboardNew({apikey: vm.project.apikey, force_mode: 'no_first_campaign'})\">{{ 'sites.dashboard.navigation.dounyuu_kanryou_ichidomohaishin' | translate }}</a> <a ui-sref=\"zenclerkS.project.dashboardNew({apikey: vm.project.apikey, force_mode: 'tag_setup_unfinished'})\">{{ 'sites.dashboard.navigation.tagu_settei_kanryou_sitenai' | translate }}</a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/dashboard/set-tag-button.html';
var html = "<div class=\"btn btn-primary btn-shadow set-tag-button\" ng-click=$ctrl.goToTagSetupPage()><ng-transclude>{{ 'sites.dashboard.setTagButton.tagu_settei' | translate }}</ng-transclude></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-campaign-list-title.html';
var html = "<div class=\"container no-padding\"><div class=\"row no-padding\"><div class=\"col-sm-12 no-padding left\"><h1 class=\"pull-left no-padding\">{{ 'sites.dashboard.widgets.dashboardWidgetCampaignListTitle.haishin_uchi_no' | translate }}</h1><zcs-campaign-create-button class=pull-right project=$ctrl.project></zcs-campaign-create-button></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-campaign-list.html';
var html = "<div class=\"container no-padding\"><div class=\"row no-padding\"><div class=col-sm-12><zcs-campaigns-list project=$ctrl.project filters=$ctrl.filters></zcs-campaigns-list></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-create-first-campaign.html';
var html = "<div class=\"padding-x padding-y\"><div class=row><div class=col-sm-7><h1 class=text-left>{{ 'sites.dashboard.widgets.dashboardWidgetCreateFirstCampaign.heyoukoso' | translate: { service: $ctrl.ZcsOemService.getName(), } }}</h1><p class=padding-bottom translate=sites.dashboard.widgets.dashboardWidgetCreateFirstCampaign.tagu_settei_ga translate-value-br=\"<br>\">></p><div class=padding-y-half><zcs-campaign-create-button project=$ctrl.project></zcs-campaign-create-button></div></div><div class=\"col-sm-5 text-right\"><svg-embed url=\"'/assets/img/illustration-new-campaign.svg'\"></svg-embed></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-no-active-campaign.html';
var html = "<div class=\"padding-x padding-y\"><div class=row><div class=col-sm-7><h1 class=text-left>{{ 'sites.dashboard.widgets.dashboardWidgetNoActiveCampaign.genzai_kyanpeen_ga' | translate }}</h1><p class=padding-bottom>{{ 'sites.dashboard.widgets.dashboardWidgetNoActiveCampaign.jinkouchinou_ni_yoru' | translate }}</p><div class=padding-y-half><zcs-campaign-create-button project=$ctrl.project></zcs-campaign-create-button></div></div><div class=\"col-sm-5 text-right\"><svg-embed url=\"'/assets/img/illustration-new-campaign.svg'\"></svg-embed></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-realtime.html';
var html = "<no-data-overlay custom-message=\"{{ 'sites.dashboard.widgets.dashboardWidgetRealtime.noSiteVisitsWithinTheLastXMinutes' | translate: { minutes: $ctrl.showDataMinutes } }}\" ng-if=$ctrl.showNoDataOverlay></no-data-overlay><div><h2 class=\"pull-left no-padding\">{{ 'sites.dashboard.widgets.dashboardWidgetRealtime.riarutaimu' | translate }}</h2><p class=\"pull-right widget__time\">{{ 'sites.dashboard.widgets.dashboardWidgetRealtime.saigo_no_fun' | translate: { minutes: $ctrl.showDataMinutes } }}</p></div><div class=clear-both></div><div class=\"text-center continue-realtime padding-y\" ng-if=$ctrl.isPaused><div><h1>{{ 'sites.dashboard.widgets.dashboardWidgetRealtime.riarutaimu_wo_saikai' | translate }}</h1><p translate=sites.dashboard.widgets.dashboardWidgetRealtime.fun_ijou_keika translate-value-minutes=\"{{ $ctrl.showDataMinutes }}\" translate-value-br=\"<br>\"></p></div><div class=padding-y><a ng-click=$ctrl.continueRealtime() class=play-button><i class=\"fa fa-play\"></i></a></div></div><div class=\"row widget__data\"><div class=col-sm-4><div class=\"widget__number zc-primary\">{{ $ctrl.historyCount | number: 0 }}</div><div class=widget__legend>{{ 'sites.dashboard.widgets.dashboardWidgetRealtime.peejibyuu_kazu' | translate }}</div></div><div class=col-sm-4><div class=widget__number>{{ $ctrl.sessionCount | number:0 }}</div><div class=widget__legend>{{ 'sites.dashboard.widgets.dashboardWidgetRealtime.houmonsha_kazu' | translate }}</div></div><div class=col-sm-4><div class=widget__number>{{ $ctrl.conversionCount | number:0 }}</div><div class=widget__legend>{{ 'sites.dashboard.widgets.dashboardWidgetRealtime.konbaajon' | translate }}</div></div></div><div class=row><div class=col-sm-12><div class=\"padding-y spinner-wrapper\" ng-if=$ctrl.isLoading><div class=spinner></div></div><zcs-realtime-bar-chart ng-if=!$ctrl.isLoading redraw-pie-chart=$ctrl.redrawPieChart is-paused=\"$ctrl.isPaused || $ctrl.showNoDataOverlay\" show-data-minutes=$ctrl.showDataMinutes data=$ctrl.historiesByBucket project=$ctrl.project></zcs-realtime-bar-chart></div></div><div class=\"row zcs-chart-pie widget__data\" style=\"display: table;\"><div class=\"col-sm-3 no-padding\" style=\"font-weight: 300; font-size: 0.7em;\"><zcs-chart-pie ng-if=$ctrl.chartDataDevices redraw-pie-chart=$ctrl.redrawPieChart chart-options=\"{ margin: { top: 30, left: 0, right: 0, }, }\" chart-data=$ctrl.chartDataDevices></zcs-chart-pie></div><div class=\"col-sm-9 chart-labels\"><table><tr><td ng-repeat=\"(deviceIndex, device) in $ctrl.chartDataDevices\"><div style=\"font-size: 1em;\" class=widget__number ng-class=\"{ 'zc-primary': deviceIndex === 0, 'zc-secondary': deviceIndex === 1, 'zc-tertiary': deviceIndex >= 2, }\">{{device.value | number:0}}%</div><div class=widget__legend>{{device.label}}</div></td></tr></table></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1413 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-site-status.html';
var html = "<div class=padding-y ng-show=$ctrl.isLoading><div class=row><div class=col-sm-12><div class=spinner></div></div></div></div><div ng-hide=$ctrl.isLoading><div ng-show=\"!$ctrl.hasActiveCampaigns && !$ctrl.hasActiveCampaignsThisMonth\" class=\"no-active-campaigns gray-box\"><span translate=sites.dashboard.widgets.dashboardWidgetSiteStatus.tougetsu_kyanpeen_haishin translate-value-br=\"<br>\"></span><div class=\"text-center padding-y\"><zcs-campaign-create-button project=$ctrl.project>{{ 'sites.dashboard.widgets.dashboardWidgetSiteStatus.shinki_kyanpeen_wo' | translate }}</zcs-campaign-create-button></div></div><div><h2 class=\"pull-left no-padding\">{{ 'sites.dashboard.widgets.dashboardWidgetSiteStatus.kongetsu_no_kyanpeen' | translate }}</h2><p class=\"pull-right widget__time\">{{ $ctrl.currentMonth }}</p></div><div class=clear-both></div><p class=campaign-status-message ng-if=$ctrl.stats.isInvoiceLimitReached translate=sites.dashboard.widgets.dashboardWidgetSiteStatus.no_seikyuu_kingaku translate-value-month=\"{{ $ctrl.currentMonth }}\" translate-value-br=\"<br>\"></p><p class=campaign-status-message ng-show=\"!$ctrl.hasActiveCampaigns && $ctrl.hasActiveCampaignsThisMonth\">{{ 'sites.dashboard.widgets.dashboardWidgetSiteStatus.genzai_kyanpeen_haishin' | translate }}<br><zcs-campaign-create-button project=$ctrl.project>{{ 'sites.dashboard.widgets.dashboardWidgetSiteStatus.shinki_kyanpeen_wo' | translate }}</zcs-campaign-create-button></p><div><div class=row><div class=\"col-sm-3 widget__data invoice-price-tax-excluded\"><div class=\"widget__number zc-primary\">{{$ctrl.stats.totalFeeTaxExcluded | zcCurrency: $ctrl.currency.symbol:$ctrl.currency.fractionSize:$ctrl.currency.suffix}}</div><div class=widget__legend>{{$ctrl.legends.totalFeeTaxExcluded | zcCurrency: $ctrl.currency.symbol:$ctrl.currency.fractionSize:$ctrl.currency.suffix}}</div></div><div ng-if=!$ctrl.project.fixed_invoice_amount class=\"col-sm-3 widget__data max-invoice-price\"><div class=\"widget__number zc-secondary\">{{$ctrl.stats.maxInvoicePrice | zcCurrency: $ctrl.currency.symbol:$ctrl.currency.fractionSize:$ctrl.currency.suffix}}</div><div class=widget__legend>{{$ctrl.legends.maxInvoicePrice | zcCurrency: $ctrl.currency.symbol:$ctrl.currency.fractionSize:$ctrl.currency.suffix}}</div></div><div class=\"col-sm-3 widget__data total-conversion-price\"><div class=widget__number>{{$ctrl.stats.totalConversionPrice | zcCurrency: $ctrl.currency.symbol:$ctrl.currency.fractionSize:$ctrl.currency.suffix}}</div><div class=widget__legend>{{$ctrl.legends.totalConversionPrice | zcCurrency: $ctrl.currency.symbol:$ctrl.currency.fractionSize:$ctrl.currency.suffix}}</div></div></div><div class=\"row chart-tertiary-wrapper\"><div class=\"col-sm-12 no-padding\"><zcs-chart-single-line class=chart-tertiary ng-if=$ctrl.chartInvoiceData domain-values=$ctrl.domainValues chart-data=$ctrl.chartInvoiceData project=$ctrl.project></zcs-chart-single-line></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-tag-setup.html';
var html = "<div class=fat-padding><div class=row><div class=col-sm-8><h1 class=text-left>{{ 'sites.dashboard.widgets.dashboardWidgetTagSetup.tagu_settei_ga' | translate }}</h1><p translate=sites.dashboard.widgets.dashboardWidgetTagSetup.ko_no_tagugamausuyasukurooru translate-value=\"<br>\"></p><zcs-set-tag-button project=$ctrl.project></zcs-set-tag-button></div><div class=\"col-sm-4 text-right\"><svg-embed url=\"'/assets/img/illustration-tag-setting.svg'\"></svg-embed></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-test.html';
var html = "TestWidget for {{$ctrl.project.title}} ({{$ctrl.project.apikey}})";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1416 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/interest_widget/interest_widget_navigation.html';
var html = "<a ui-sref=\"zenclerkS.project.interestWidget.results({apikey: vm.project.apikey})\" ui-sref-active=active>{{ 'sites.interestWidget.interestWidgetNavigation.haishin_kekka' | translate }}</a> <a ui-sref=\"zenclerkS.project.interestWidget.settings({apikey: vm.project.apikey})\" ui-sref-active=active>{{ 'sites.interestWidget.interestWidgetNavigation.settei' | translate }}</a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/interest_widget/interest_widget_results.html';
var html = "<div class=\"container-fluid sub-navigation-command\"><div class=col-md-12><zc-month-chooser min-date=$ctrl.minIwDate></zc-month-chooser></div></div><div class=\"container container-limited interest-widget-results\"><div ng-if=\"$ctrl.totalDeliveryCount === 0\" class=row><div class=col-sm-12><div class=\"container card padding-y-half\"><p>{{ 'sites.interestWidget.interestWidgetResults.hyouji_surutame_ni' | translate }}</p></div></div></div><div ng-show=\"$ctrl.totalDeliveryCount > 0\" class=row><div class=\"col-sm-12 margin-y-half\"><div class=\"container card card-numbers padding-y-half\"><div class=row><div class=col-sm-12><h1 class=padding-y-half>{{ 'sites.interestWidget.interestWidgetResults.haishin_kekka' | translate: { month: ($ctrl.startAt | zcDate: { format: 'yyyy/MM' }), } }}</h1><div class=subtext>{{ 'sites.interestWidget.interestWidgetResults.chokki_yuuzaa_wo' | translate }} <span ng-if=$ctrl.device>{{ 'sites.interestWidget.interestWidgetResults.yuuzaa_nomi' | translate: { device: $ctrl.device, } }}</span></div><div class=\"row hidden\"><div class=\"col-sm-8 col-sm-offset-2\"><zc-timerange-chooser start-at=$ctrl.startAt end-at=$ctrl.endAt min-date=$ctrl.minDate max-date=$ctrl.maxDate on-change=\"$ctrl.timerangeChanged(min, max)\"></zc-timerange-chooser></div></div></div></div><div class=row><div class=\"col-sm-4 number-box\"><h3>{{ 'sites.interestWidget.interestWidgetResults.haishin_kazu' | translate }}</h3><div class=number>{{ 'sites.interestWidget.interestWidgetResults.hito' | translate: { count: ($ctrl.totalDeliveryCount | number: 0), } }}</div></div><div class=\"col-sm-4 number-box\"><h3>{{ 'sites.interestWidget.interestWidgetResults.haishin_ritsu' | translate }}</h3><div class=number>{{ $ctrl.totalDeliveryPercentage | number: 2 }}%</div></div><div class=\"col-sm-4 number-box\"><h3>{{ 'sites.interestWidget.interestWidgetResults.riyou_yuuzaano_uriage' | translate }}</h3><div class=number>{{ $ctrl.totalUserConversion | zcCurrency: $ctrl.currency.symbol:0:$ctrl.currency.suffix }}</div></div></div></div></div><div class=col-sm-6><div class=\"container card card-graph\"><h2>{{ 'sites.interestWidget.interestWidgetResults.hyouji_sesshon_kazu_jissoku' | translate }}</h2><div class=delivery-graph><svg></svg></div></div></div><div class=col-sm-6><div class=\"container card card-graph card-graph-cumulative-conversion-graph\"><h2>{{ 'sites.interestWidget.interestWidgetResults.riyou_yuuzaano_ruiseki' | translate }}</h2><div class=cumulative-conversion-graph><svg></svg></div></div></div><div class=col-sm-6><div class=\"container card card-graph\"><h2>{{ 'sites.interestWidget.interestWidgetResults.riyou_yuuzaanokaatobotankurikku_ritsu' | translate }}</h2><div class=row><div class=\"col-sm-4 col-sm-offset-2\"><div class=text-sm>{{ 'sites.interestWidget.interestWidgetResults.haishin_yuuzaa' | translate }}</div><div class=number><span class=\"box box-color-target\"></span> {{ $ctrl.averageIwCartButtonClickPercentage | number:2 }}%</div></div><div class=col-sm-4><div class=text-sm>{{ 'sites.interestWidget.interestWidgetResults.saito_zentai' | translate }}</div><div class=number><span class=\"box box-color-all\"></span> {{ $ctrl.averageNoIwCartButtonClickPercentage | number:2 }}%</div></div></div><div class=cart-button-click-rate-graph><svg></svg></div></div></div><div class=col-sm-6><div class=\"container card card-graph\"><h2>{{ 'sites.interestWidget.interestWidgetResults.riyou_yuuzaanokonbaajon_ritsu' | translate }}</h2><div class=\"col-sm-4 col-sm-offset-2\"><div class=text-sm>{{ 'sites.interestWidget.interestWidgetResults.haishin_yuuzaa' | translate }}</div><div class=number><span class=\"box box-color-target\"></span> {{ $ctrl.averageIwConversionPercentage | number:2 }}%</div></div><div class=col-sm-4><div class=text-sm>{{ 'sites.interestWidget.interestWidgetResults.saito_zentai' | translate }}</div><div class=number><span class=\"box box-color-all\"></span> {{ $ctrl.averageNoIwConversionPercentage | number:2 }}%</div></div><div class=conversion-rate-graph><svg></svg></div></div></div></div><div class=zcd3-tooltip></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/interest_widget/interest_widget_settings.html';
var html = "<div class=\"container container-limited\"><div class=\"row margin-y-half\"><div class=\"list-group list-group-horizontal text-center\" ng-if=\"$ctrl.campaignPC && $ctrl.campaignSP\"><div class=list-group-item ng-class=\"{'active': $ctrl.currentView === 'pc'}\" ng-click=\"$ctrl.selectView('pc')\">{{ 'sites.interestWidget.interestWidgetSettings.deviceView' | translate: { device: 'PC' } }}</div><div class=list-group-item ng-class=\"{'active': $ctrl.currentView === 'sp'}\" ng-click=\"$ctrl.selectView('sp')\">{{ 'sites.interestWidget.interestWidgetSettings.deviceView' | translate: { device: 'SP' } }}</div></div><div class=\"col-sm-8 padding\" ng-if=$ctrl.campaign><zcs-campaign-template-dynamic-view class=\"interest-template-view {{$ctrl.currentView}}\" project=$ctrl.project campaign=$ctrl.campaign only-views=[0]></zcs-campaign-template-dynamic-view></div><div class=\"col-sm-4 panel padding\"><h2>{{ 'sites.interestWidget.interestWidgetSettings.haishin' | translate }}</h2><div class=\"list-group list-group-horizontal\" ng-if=\"$ctrl.campaign.interest_widget.status !== 'disable'\"><div class=list-group-item ng-class=\"{'active': $ctrl.campaign.interest_widget.status === 'enable'}\" ng-click=\"$ctrl.changeIwStatus('enable')\">{{ 'sites.interestWidget.interestWidgetSettings.haishin_uchi' | translate }}</div><div class=list-group-item ng-class=\"{'active': $ctrl.campaign.interest_widget.status === 'preview'}\" ng-click=\"$ctrl.changeIwStatus('preview')\">{{ 'sites.interestWidget.interestWidgetSettings.haishin_teishi' | translate }}</div></div><div ng-if=\"$ctrl.campaign.interest_widget.status === 'disable'\"><div class=\"alert alert-danger\">{{ 'sites.interestWidget.interestWidgetSettings.ga_mukou_ni' | translate }}</div></div><zcs-campaign-template-editor is-interest-widget-settings-page=true campaign=$ctrl.campaign project=$ctrl.project is-disabled=$ctrl.isSaving></zcs-campaign-template-editor><div class=text-center><button class=\"btn btn-secondary\" ng-disabled=$ctrl.isSaving ng-click=$ctrl.saveCampaign()>{{ 'sites.interestWidget.interestWidgetSettings.hozon' | translate }}</button></div><div ng-if=!$ctrl.campaign>{{ 'sites.interestWidget.interestWidgetSettings.ga_mukou_ni' | translate }}</div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1419 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/invoices/edit/index.html';
var html = "<header>{{ 'sites.invoices.edit.index.go_seikyuu_shuusei' | translate }}</header><div class=\"container-fluid container-limited\"><div ng-if=vm.showCreateView><form id=inviteUser name=form class=text-center><h2 class=text-center>{{ 'sites.invoices.edit.index.shinki_seikyuu_shuusei' | translate }}</h2><div class=form-group><div class=row><label for=adjustment_name class=\"col-md-3 text-right\">{{ 'sites.invoices.edit.index.kingaku_chousei_himoku' | translate }}</label><div class=col-md-9><select type=number class=form-control id=adjustment_name ng-model=vm.newAdjustment.adjustment_name required ng-options=\"adjustment_name.name as adjustment_name.title for adjustment_name in vm.adjustmentNameOptions\"></select></div></div></div><div class=form-group><div class=row><label class=\"col-md-3 text-right\" for=title>{{ 'sites.invoices.edit.index.himoku_na' | translate }}</label><div class=col-md-9><input type=text class=form-control id=title placeholder=\"{{ 'sites.invoices.edit.index.settei_hi' | translate }}\" ng-model=vm.newAdjustment.title ng-maxlength=50 required> <span class=\"help-block text-left\">{{ 'sites.invoices.edit.index.seikyuu_peeji_no' | translate }}</span></div></div></div><div class=form-group ng-if=\"vm.newAdjustment.adjustment_name === 'monthly_percent_discount'\"><div class=row><label for=percent class=\"col-md-3 text-right\">{{ 'sites.invoices.edit.index.chousei_wariai' | translate }}</label><div class=col-md-9><input type=number class=form-control id=percent placeholder=20 min=0 max=100 step=0.1 ng-model=vm.newAdjustment.percent required></div></div></div><div class=form-group ng-if=\"vm.newAdjustment.adjustment_name !== 'monthly_percent_discount'\"><div class=row><label for=price class=\"col-md-3 text-right\">{{ 'sites.invoices.edit.index.chousei_kingaku' | translate }}</label><div class=col-md-9><input type=number class=form-control id=price placeholder=10000 min=0 ng-model=vm.newAdjustment.price required></div></div></div><div class=form-group><div class=row><label for=adjustment_type class=\"col-md-3 text-right\">{{ 'sites.invoices.edit.index.chousei_no_futan' | translate }}</label><div class=col-md-9><select type=number class=form-control id=adjustment_type ng-model=vm.newAdjustment.adjustment_type required ng-options=\"name as option for (name,option) in vm.discountTypeOptions\"></select></div></div></div><div class=form-group><div class=row><label for=description class=\"col-md-3 text-right\">{{ 'sites.invoices.edit.index.bikou_shanai_kanri' | translate }}</label><div class=col-md-9><textarea class=form-control id=description placeholder=\"{{ 'sites.invoices.edit.index.reiseminaa_tokuten_no' | translate }}\" ng-model=vm.newAdjustment.description required>\n            </textarea></div></div></div><button type=submit class=\"btn btn-primary\" ng-disabled=form.$invalid confirm-click=vm.createInvoiceAdjustment() confirm-modal=\"{{ 'sites.invoices.edit.index.tsukutte_mo_yoroshiidesuka' | translate }}\">{{ 'sites.invoices.edit.index.sakusei' | translate }}</button></form></div><div><h2>{{ 'sites.invoices.edit.index.shuusei_ichiran' | translate }}</h2><div class=list><div class=list-item><table class=table><tr><th>{{ 'sites.invoices.edit.index.kingaku_chousei_himoku' | translate }}</th><th>{{ 'sites.invoices.edit.index.himoku_na' | translate }}</th><th>{{ 'sites.invoices.edit.index.chousei_kingaku_wariai' | translate }}</th><th>{{ 'sites.invoices.edit.index.futan_wariai' | translate }}</th><th>{{ 'sites.invoices.edit.index.bikouran' | translate }}</th><th>{{ 'sites.invoices.edit.index.sakuseinichiji' | translate }}</th><th></th></tr><tr ng-repeat=\"adjustment in vm.adjustments | orderBy:'-id'\"><td>{{adjustment.adjustment_name}}</td><td>{{adjustment.title}}</td><td ng-if=\"adjustment.adjustment_name !== 'monthly_percent_discount'\">{{adjustment.price}}</td><td ng-if=\"adjustment.adjustment_name === 'monthly_percent_discount'\">{{adjustment.percent}}%</td><td>{{adjustment.adjustment_type}}</td><td>{{adjustment.description}}</td><td>{{ adjustment.created_at | zcDate: { format: 'yyyy/MM/dd HH:mm Z' } }}</td><td><i ng-if=adjustment.id class=\"fa fa-trash\" confirm-click=vm.removeInvoiceAdjustment(adjustment.id) confirm-modal=\"{{ 'sites.invoices.edit.index.hontouni_sakujo_shitemoyoroshiidesuka' | translate }}\" title=\"{{ 'sites.invoices.edit.index.sakujo' | translate }}\"></i></td></tr></table></div></div></div></div><zcs-notification-timezone project=vm.project></zcs-notification-timezone>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/invoices/list/invoices_list.html';
var html = "<div class=\"container-fluid container-limited padding-y\"><div ng-repeat=\"invoice in vm.invoices | orderBy: '-month'\" class=list-item ui-sref=\"zenclerkS.project.invoices.show({apikey: vm.project.apikey, term: invoice.month})\" ng-init=\"currency = vm.currencies[vm.project.invoice_currency || 'jpy'];\"><div class=list-item-header><span style=\"flex: 3 3 65%\">{{ 'sites.invoices.list.invoicesList.seikyuu_fun' | translate: { month: invoice.month } }} <span ng-if=!invoice.is_finalized>{{ 'sites.invoices.list.invoicesList.sokuhou' | translate }}</span></span> <span ng-if=\"vm.project.sales_entity === 'appier_jp'\" style=\"flex: 2 2 auto; text-align: right\">{{ invoice.invoice_price | zcCurrency : currency.symbol : currency.fractionSize : currency.suffix }}</span> <span ng-if=\"vm.project.sales_entity !== 'appier_jp'\" style=\"flex: 2 2 auto; text-align: right\">{{ invoice.invoice_price_tax_excluded | zcCurrency : currency.symbol : 0 : currency.suffix }}</span> <a class=list-item-action style=\"flex: 1 1 5%; text-align: right\">{{ 'sites.invoices.list.invoicesList.shousai' | translate }}</a></div></div><div class=invoice><div class=\"invoice-container no-invoice\" ng-if=\"vm.invoices.length === 0\">{{ 'sites.invoices.list.invoicesList.seikyuu_ga_arimasen' | translate }}</div></div></div><zcs-notification-timezone project=vm.project></zcs-notification-timezone>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/invoices/navigation.html';
var html = "<a ng-class=\"{active:vm.isCategory('invoices')}\" ui-sref=\"zenclerkS.project.invoices.list({ apikey: vm.project.apikey })\">{{ 'sites.invoices.navigation.seikyuu' | translate }}</a> <a master-only ng-class=\"{active:vm.isCategory('invoicesEdit')}\" ui-sref=\"zenclerkS.project.invoices.edit({ apikey: vm.project.apikey, term: vm.$stateParams.term })\" ng-if=vm.$stateParams.term>{{ 'sites.invoices.navigation.henshuu' | translate }} <i class=\"fa fa-lock master-only\"></i></a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/invoices/show/invoice.html';
var html = "<div class=\"container-fluid sub-navigation-command\"><div class=col-md-12><zc-month-chooser state-param=term min-date=vm.project.created_at></zc-month-chooser></div></div><div class=invoice><div class=\"container-fluid container-limited padding-y\"><div class=\"invoice-container no-invoice\" ng-if=vm.isTerminated><h1>{{ 'sites.invoices.show.invoice.kara_kaiyaku_ni' | translate: { date: (vm.project.terminated_at | zcDate: { dateOnly: true }) } }}</h1></div><div class=\"invoice-container no-invoice\" ng-if=\"vm.isTerminated || !vm.hasInvoiceData\"><h1>{{ 'sites.invoices.show.invoice.seikyuu_ga_arimasen' | translate }}</h1></div><div class=invoice-container ng-if=\"!vm.isTerminated && vm.hasInvoiceData\"><div class=\"row invoice-header\"><div class=col-md-6><img class=logo src=/assets/img/logo-aideal.svg zcs-hide-when-oem></div><div class=\"col-md-6 text-right\"><label ng-if=vm.invoice.is_finalized>{{ 'sites.invoices.show.invoice.seikyuu' | translate }}</label> <label ng-if=!vm.invoice.is_finalized>{{ 'sites.invoices.show.invoice.sokuhou_seikyuu' | translate }}</label> <small>{{ vm.currentMonth }}</small></div></div><div class=\"row invoice-amount\"><div class=\"col-md-7 invoice-price\"><label ng-if=vm.invoice.is_finalized>{{ 'sites.invoices.show.invoice.seikyuu_kingaku' | translate }}</label> <label ng-if=!vm.invoice.is_finalized>{{ 'sites.invoices.show.invoice.sokuhou_seikyuu_kingaku' | translate }}</label> <span ng-if=\"vm.project.sales_entity === 'appier_jp'\" class=number-xl>{{ vm.invoice.invoice_price || 0 | zcCurrency: vm.invoiceCurrency.symbol : vm.invoiceCurrency.fractionSize : vm.invoiceCurrency.suffix }}</span> <span ng-if=\"vm.project.sales_entity !== 'appier_jp'\" class=number-xl>{{ vm.invoice.invoice_price_tax_excluded || 0 | zcCurrency: vm.invoiceCurrency.symbol : 0 : vm.invoiceCurrency.suffix }}</span></div><div ng-if=!vm.isFixedPrice class=\"col-md-5 invoice-max\"><label>{{ 'sites.invoices.show.invoice.zeinuki_seikyuu_jougen' | translate }}</label> <span class=number-xl>{{ vm.invoice.max_invoice || 0 | zcCurrency: vm.invoiceCurrency.symbol : vm.invoiceCurrency.fractionSize : vm.invoiceCurrency.suffix }}</span><div class=sub><label ng-if=vm.new_client>{{ 'sites.invoices.show.invoice.kongetsu_no_saito' | translate }}</label> <label ng-if=!vm.new_client>{{ 'sites.invoices.show.invoice.zengetsu_no_saito' | translate }}</label> <span class=number-xl>{{ vm.invoice.monthly_total_conversion || 0 | zcCurrency: vm.invoiceCurrency.symbol : vm.invoiceCurrency.fractionSize : vm.invoiceCurrency.suffix }}</span></div></div></div><div ng-if=\"vm.invoice.invoice_calculation_type == 'normal'\"><zcs-invoice invoice=vm.invoice currency=vm.invoiceCurrency></zcs-invoice></div><div ng-if=\"vm.invoice.invoice_calculation_type == 'deemed' && vm.invoice.deemed_percent\"><zcs-old-deemed-invoice invoice=vm.invoice currency=vm.invoiceCurrency></zcs-old-deemed-invoice></div><div ng-if=\"vm.invoice.invoice_calculation_type == 'deemed' && !vm.invoice.deemed_percent\"><zcs-deemed-invoice invoice=vm.invoice currency=vm.invoiceCurrency></zcs-deemed-invoice></div><div><table class=table><tr><th>{{ 'sites.invoices.show.invoice.meimoku' | translate }}</th><th>{{ 'sites.invoices.show.invoice.kingaku' | translate }}</th></tr><tr><td>{{ 'sites.invoices.show.invoice.kyanpeen_houshuu_goukeigaku' | translate }}</td><td class=text-right>{{ vm.invoice.sum_details_invoice_price || 0 | zcCurrency: vm.invoiceCurrency.symbol : 0 : vm.invoiceCurrency.suffix }}</td></tr><tr ng-if=vm.invoice.percent_discount><td>{{ 'sites.invoices.show.invoice.teiritsu_waribiki_kingaku' | translate: { percentage: vm.invoice.discount_percent } }}</td><td class=text-right>{{ -vm.invoice.percent_discount || 0 | zcCurrency: vm.invoiceCurrency.symbol : 0 : vm.invoiceCurrency.suffix }}</td></tr><tr ng-repeat=\"adjustment in vm.invoice.adjustments\" ng-if=\"adjustment.price !== null\"><td>{{ adjustment.title }}</td><td class=text-right>{{ adjustment.price || 0 | zcCurrency: vm.invoiceCurrency.symbol : 0 : vm.invoiceCurrency.suffix }}</td></tr><tr ng-if=vm.invoice.rounding_discount><td>{{ 'sites.invoices.show.invoice.jougen_oyobi_hasuu' | translate }}</td><td class=text-right>{{ -vm.invoice.rounding_discount || 0 | zcCurrency: vm.invoiceCurrency.symbol : 0 : vm.invoiceCurrency.suffix }}</td></tr><tr ng-if=\"vm.project.sales_entity === 'appier_jp'\"><td>{{ 'sites.invoices.show.invoice.zeinukikagaku' | translate }}</td><td class=text-right>{{ vm.invoice.invoice_price_tax_excluded || 0 | zcCurrency: vm.invoiceCurrency.symbol : vm.invoiceCurrency.fractionSize : vm.invoiceCurrency.suffix }}</td></tr><tr ng-if=\"vm.project.sales_entity === 'appier_jp'\"><td>{{ 'sites.invoices.show.invoice.shouhizei' | translate }}</td><td class=text-right>{{ vm.invoice.consumption_tax || 0 | zcCurrency: vm.invoiceCurrency.symbol : vm.invoiceCurrency.fractionSize : vm.invoiceCurrency.suffix }}</td></tr><tr><td>{{ 'sites.invoices.show.invoice.goukei' | translate }}</td><td ng-if=\"vm.project.sales_entity === 'appier_jp'\" class=text-right>{{ vm.invoice.invoice_price || 0 | zcCurrency: vm.invoiceCurrency.symbol : vm.invoiceCurrency.fractionSize : vm.invoiceCurrency.suffix }}</td><td ng-if=\"vm.project.sales_entity !== 'appier_jp'\" class=text-right>{{ vm.invoice.invoice_price_tax_excluded || 0 | zcCurrency: vm.invoiceCurrency.symbol : 0 : vm.invoiceCurrency.suffix }}</td></tr></table></div><zcs-invoice-note ng-if=!vm.isFixedPrice month=vm.invoiceMonth></zcs-invoice-note></div></div></div><zcs-notification-timezone project=vm.project></zcs-notification-timezone>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1423 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/invoices/show/zcs_deemed_invoice.html';
var html = "<table class=table><tr><th>{{ 'sites.invoices.show.zcsDeemedInvoice.kyanpeentaitoru' | translate }}</th><th>{{ 'sites.invoices.show.zcsDeemedInvoice.haishin_kazu' | translate }}</th><th>{{ 'sites.invoices.show.zcsDeemedInvoice.cv_kazu' | translate }}</th><th>{{ 'sites.invoices.show.zcsDeemedInvoice.kessai_kingaku' | translate }}</th><th>{{ 'sites.invoices.show.zcsDeemedInvoice.ryouritsu' | translate }}</th><th>{{ 'sites.invoices.show.zcsDeemedInvoice.seikyuu_kingaku' | translate }}</th></tr><tr ng-repeat=\"detail in vm.invoice.details\"><td>{{ detail.name }}</td><td>{{ detail.campaign_count }}</td><td>{{ detail.conversion_count }}</td><td>{{ detail.total_conversion_price || 0 | zcCurrency : vm.currency.symbol : vm.currency.fractionSize : vm.currency.suffix }}</td><td>x{{ vm.invoice.fee_rate * 100 }}%</td><td class=text-right>{{ detail.invoice || 0 | zcCurrency : vm.currency.symbol : vm.currency.fractionSize : vm.currency.suffix }}</td></tr></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/invoices/show/zcs_invoice.html';
var html = "<table class=table><tr><th class=text-left>{{ 'sites.invoices.show.zcsInvoice.kuuponkoodo' | translate }}</th><th class=text-left>{{ 'sites.invoices.show.zcsInvoice.debaisu' | translate }}</th><th class=text-left>{{ 'sites.invoices.show.zcsInvoice.riyou_kaisuu' | translate }}</th><th class=text-left>{{ 'sites.invoices.show.zcsInvoice.kessai_kingaku' | translate }}</th><th class=text-left>{{ 'sites.invoices.show.zcsInvoice.ryouritsu' | translate }}</th><th class=text-right>{{ 'sites.invoices.show.zcsInvoice.seikyuu_kingaku' | translate }}</th></tr><tr ng-repeat=\"result in vm.invoice.details\"><td class=text-left>{{ result._id }}</td><td class=text-left><span ng-if=\"result.device == 'pc'\">PC</span> <span ng-if=\"result.device == 'other'\">{{ 'sites.invoices.show.zcsInvoice.otherThan' | translate: { device: 'PC' } }}</span></td><td class=text-left>{{ result.conversion_count }}</td><td class=text-left>{{ result.total_conversion_price || 0 | zcCurrency: vm.currency.symbol : vm.currency.fractionSize : vm.currency.suffix }}</td><td class=text-left>x{{ vm.invoice.fee_rate * 100 }}%</td><td class=text-right>{{ result.invoice || 0 | zcCurrency: vm.currency.symbol : vm.currency.fractionSize : vm.currency.suffix }}</td></tr></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/invoices/show/zcs_old_deemed_invoice.html';
var html = "<table class=table><tr><th>{{ 'sites.invoices.show.zcsOldDeemedInvoice.kyanpeentaitoru' | translate }}</th><th>{{ 'sites.invoices.show.zcsOldDeemedInvoice.haishin_kazu' | translate }}</th><th>{{ 'sites.invoices.show.zcsOldDeemedInvoice.cv_kazu' | translate }}</th><th>{{ 'sites.invoices.show.zcsOldDeemedInvoice.kessai_kingaku' | translate }}</th><th>{{ 'sites.invoices.show.zcsOldDeemedInvoice.minashikuupon_shiyouritsu' | translate }}</th><th>{{ 'sites.invoices.show.zcsOldDeemedInvoice.ryouritsu' | translate }}</th><th>{{ 'sites.invoices.show.zcsOldDeemedInvoice.seikyuu_kingaku' | translate }}</th></tr><tr ng-repeat=\"detail in vm.invoice.details\"><td>{{ detail.name }}</td><td>{{ detail.campaign_count }}</td><td>{{ detail.conversion_count }}</td><td>{{ detail.total_conversion_price || 0 | zcCurrency: vm.currency.symbol : vm.currency.fractionSize : vm.currency.suffix }}</td><td>x60%</td><td>x{{vm.invoice.fee_rate * 100}}%</td><td class=text-right>{{ detail.invoice || 0 | zcCurrency: vm.currency.symbol : vm.currency.fractionSize : vm.currency.suffix }}</td></tr></table>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/list.html';
var html = "<div class=project-list><header>{{ 'sites.list.purojekuto_ichiran' | translate }}</header><div class=container><zcs-project-list projects=vm.projects></zcs-project-list></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/reports/show/report_show.html';
var html = "<div class=\"container-fluid sub-navigation-command\"><div class=col-md-12><zc-month-chooser min-date=vm.project.created_at></zc-month-chooser></div></div><zcs-monthly-report project=vm.project month=vm.month invoices=vm.invoices></zcs-monthly-report><zcs-notification-timezone project=vm.project></zcs-notification-timezone>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/reports/show/zcs_monthly_report.html';
var html = "<div class=\"container-fluid report-charts\"><div class=\"panel padding\"><div class=text-center ng-if=vm.today>{{ 'sites.reports.show.zcsMonthlyReport.no_jiten' | translate: { date: vm.today } }}<br></div><div class=\"row text-center report-totals-numbers\" ng-if=vm.zcTotalConversion><div class=\"{{ !['color_me_shop', 'shopify'].includes(vm.project.integrated_with) ? 'col-md-2 col-md-offset-1' : 'col-md-12' }}\"><span class=number-xl>{{ vm.zcTotalConversion | zcCurrency: vm.currency.symbol:0:vm.currency.suffix }}</span><br><span class=number-label>({{ 'sites.reports.show.zcsMonthlyReport.saito_zentai_no' | translate: { percentage: (vm.zcTotalConversionPercentage | number: 1), } }})<br>{{ 'sites.reports.show.zcsMonthlyReport.kuupon_keiyu_uriage' | translate: { service: vm.ZcsOemService.getName(), } }}</span></div><div zcs-hide-when-integrated=color_me_shop,shopify class=col-md-2><span class=number-xl>{{ -vm.costOfGoods | zcCurrency: vm.currency.symbol:0:vm.currency.suffix }}</span><br><span class=number-label>{{ 'sites.reports.show.zcsMonthlyReport.arariritsu_no_baai' | translate: { rate: vm.profitPercent, } }}</span></div><div zcs-hide-when-integrated=color_me_shop,shopify class=col-md-2><span class=number-xl>{{ -vm.campaignInvoicePrice || 0 | zcCurrency: vm.currency.symbol:0:vm.currency.suffix }}</span><br><span class=number-label>{{ 'sites.reports.show.zcsMonthlyReport.seikyuu_kingaku' | translate: { service: vm.ZcsOemService.getName(), } }}</span><br><span class=\"number-label text-small\">({{ 'sites.reports.show.zcsMonthlyReport.kyanpeen_houshuu_ni' | translate }})</span></div><div ng-if=\"vm.project.invoice_calculation_type === 'deemed'\" zcs-hide-when-integrated=color_me_shop,shopify class=col-md-2><span class=number-xl>{{ -vm.couponCost || 0 | zcCurrency: vm.currency.symbol : 0 : vm.currency.suffix }}</span><br><span class=number-label>{{ 'sites.reports.show.zcsMonthlyReport.kuuponkosuto' | translate }}</span><br><span class=\"number-label text-small\">({{ 'sites.reports.show.zcsMonthlyReport.kuupon_no_shiyou' | translate }})</span></div><div ng-if=\"vm.project.invoice_calculation_type === 'normal'\" zcs-hide-when-integrated=color_me_shop,shopify class=col-md-2><span class=number-xl>{{ -vm.couponCost || 0 | zcCurrency: vm.currency.symbol : 0 : vm.currency.suffix }}</span><br><span class=number-label>{{ 'sites.reports.show.zcsMonthlyReport.kuuponkosuto' | translate }}</span></div><div zcs-hide-when-integrated=color_me_shop,shopify class=col-md-2><span class=number-xl>{{ vm.residualProfit | zcCurrency: vm.currency.symbol : 0 : vm.currency.suffix }}</span><br><span class=number-label>{{ 'sites.reports.show.zcsMonthlyReport.zanson_rieki' | translate }}</span><br><span class=\"number-label text-small\">({{ 'sites.reports.show.zcsMonthlyReport.arari_riyouryou_kuuponkosuto' | translate: { service: vm.ZcsOemService.getName(), } }})</span></div></div><div class=row><h2 class=text-center>{{ 'sites.reports.show.zcsMonthlyReport.uriage_shinchoku' | translate }}</h2><widget-cumulative-conversion project=vm.project month=vm.month></widget-cumulative-conversion></div></div><div class=row><div class=col-sm-6><div class=\"panel padding\"><h2>{{ 'sites.reports.show.zcsMonthlyReport.uriage_hiritsu' | translate }}</h2><div class=\"chart chart-relative-conversion\"></div></div></div><div class=col-sm-6><div class=\"panel padding\"><h2>{{ 'sites.reports.show.zcsMonthlyReport.uriage' | translate }}</h2><div class=\"chart chart-daily-conversion\"></div></div></div></div><div class=row><div class=col-sm-6><div class=\"panel padding\"><h2>{{ 'sites.reports.show.zcsMonthlyReport.debaisu_betsubai_ri' | translate }}</h2><div class=\"chart chart-conversion-per-device\"></div></div></div><div class=col-sm-6 ng-hide=\"vm.revenueData.length <= 0\"><div class=\"panel padding\"><h2>{{ 'sites.reports.show.zcsMonthlyReport.debaisu_betsukuupon_riyou' | translate }}</h2><div class=\"chart chart-coupon-usage-per-device\"></div><p ng-if=vm.noCouponConversions>{{ 'sites.reports.show.zcsMonthlyReport.no_conversions' | translate }}</p></div></div><div class=col-sm-6 ng-hide=\"vm.revenueData.length > 0\"><div class=\"panel padding\"><h2>{{ 'sites.reports.show.zcsMonthlyReport.same_session_conversion' | translate }}</h2><div class=\"chart chart-same-session-cv\"></div></div></div></div><div class=text-center><p>{{ 'sites.reports.show.zcsMonthlyReport.ga_ichibu_no' | translate: { service: vm.ZcsOemService.getName(), } }}</p></div></div><zcs-notification-timezone project=vm.project></zcs-notification-timezone>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1429 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/settings/navigation.html';
var html = "<a ui-sref=\"zenclerkS.project.settings({apikey: vm.project.apikey})\" ui-sref-active=active>{{ 'sites.settings.navigation.saito_settei' | translate }}</a> <a ui-sref=\"zenclerkS.project.billings({apikey: vm.project.apikey})\" ui-sref-active=active>{{ 'sites.settings.navigation.keiyaku_jouhou' | translate }}</a> <a zcs-hide-when-integrated=color_me_shop,shopify ui-sref=\"zenclerkS.project.users({apikey: vm.project.apikey})\" ui-sref-active=active>{{ 'sites.settings.navigation.yuuzaa_kanri' | translate }} <span class=\"badge badge-needs-action pull-right\" uib-tooltip=\"{{ 'sites.settings.navigation.ko_no_saito' | translate }}\" tooltip-placement=right tooltip-append-to-body=true ng-if=\"!vm.project.is_operated_by_agency && vm.projectUsers && vm.projectUsers.length == 0\">1</span></a> <a ng-if=\"vm.project.integrated_with === 'shopify'\" ui-sref=\"zenclerkS.project.tags.conversion({apikey: vm.project.apikey})\" ui-sref-active=active>{{ 'sites.settings.navigation.tagu' | translate }} <span class=\"badge badge-needs-action pull-right\" uib-tooltip=\"{{ 'sites.settings.navigation.tagu_settei_ga' | translate }}\" tooltip-placement=right tooltip-append-to-body=true ng-if=vm.tagTasksLeft>{{ vm.tagTasksLeft }}</span></a> <a ng-if=\"vm.project.integrated_with !== 'shopify'\" zcs-hide-when-integrated=color_me_shop ui-sref=\"zenclerkS.project.tags.tracking({apikey: vm.project.apikey})\" ui-sref-active=active>{{ 'sites.settings.navigation.tagu' | translate }} <span class=\"badge badge-needs-action pull-right\" uib-tooltip=\"{{ 'sites.settings.navigation.tagu_settei_ga' | translate }}\" tooltip-placement=right tooltip-append-to-body=true ng-if=vm.tagTasksLeft>{{ vm.tagTasksLeft }}</span></a> <a ui-sref=\"zenclerkS.project.excludePages({apikey: vm.project.apikey})\" ui-sref-active=active>{{ 'sites.settings.navigation.haishin_jogai_peeji' | translate }}</a> <a ui-sref=\"zenclerkS.project.excludeIps({apikey: vm.project.apikey})\" ui-sref-active=active>{{ 'sites.settings.navigation.shanai_kara_no' | translate }}</a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/settings/project_billings.html';
var html = "<div class=\"container-fluid container-limited\"><div class=\"col-md-10 col-md-offset-1 panel\"><form ng-submit=vm.saveProject(vm.project) name=siteSettings><section style=\"padding-bottom: 0\"><h1>{{ 'sites.settings.projectBillings.keiyaku_jouhou' | translate }}</h1><div class=row><div class=col-md-6><label>{{ 'sites.settings.projectBillings.saito_sakusei_hi' | translate }}</label> {{ vm.project.created_at | zcDate : { dateOnly: true } }}</div><div class=col-md-6><label>{{ 'sites.settings.projectBillings.keiyaku_hi' | translate }}</label> {{ vm.project.contracted_at | zcDate : { dateOnly: true } }}</div></div><div class=row><div class=col-md-6><div class=form-group><label for=company_name>{{ 'sites.settings.projectBillings.kaishamei' | translate }}</label> <input class=form-control placeholder=\"{{ 'sites.settings.projectBillings.kabushikigaisha_yuugengaisha_nado' | translate }}\" id=company_name name=company_name ng-model=vm.project.company_name required></div></div><div class=col-md-6><div class=form-group><label for=representative>{{ 'sites.settings.projectBillings.kaisha_daihyou_na' | translate }}</label> <input class=form-control id=representative name=representative ng-model=vm.project.representative required></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=address>{{ 'sites.settings.projectBillings.juusho' | translate }}</label> <input class=form-control placeholder=\"{{ 'sites.settings.projectBillings.rei_toukyouto_shina' | translate }}\" id=address name=address ng-model=vm.project.address required></div></div></div><div class=row><div class=col-md-3><div class=form-group><label for=postal_code>{{ 'sites.settings.projectBillings.yuubinbangou' | translate }}</label> <input class=form-control placeholder=\"{{ 'sites.settings.projectBillings.rei_postal_code' | translate }}\" id=postal_code name=postal_code ng-model=vm.project.postal_code required></div></div><div class=col-md-9><div class=form-group><label for=phone_number>{{ 'sites.settings.projectBillings.denwabangou' | translate }}</label> <input class=form-control id=phone_number name=phone_number ng-model=vm.project.phone_number required></div></div></div><div class=row ng-if=vm.project.is_direct_selling><div class=col-md-6><div class=form-group><label for=person_in_charge>{{ 'sites.settings.projectBillings.tantousha_shimei_furuneemu' | translate }}</label> <input class=form-control id=person_in_charge name=person_in_charge ng-model=vm.project.person_in_charge required></div></div><div class=col-md-6><div class=form-group><label for=person_in_charge_email>{{ 'sites.settings.projectBillings.tantousha_meeruadoresu' | translate }}</label> <input type=email class=form-control id=person_in_charge_email name=person_in_charge_email ng-model=vm.project.person_in_charge_email required></div></div></div></section><section ng-if=vm.project.is_direct_selling><h1>{{ 'sites.settings.projectBillings.seikyuu_saki_jouhou' | translate }}</h1><div class=row><div class=col-md-12><div class=form-group><zc-sync-contract-info-button source=vm.project></zc-sync-contract-info-button></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=billing_company_name>{{ 'sites.settings.projectBillings.kaishamei' | translate }}</label> <input class=form-control placeholder=\"{{ 'sites.settings.projectBillings.kabushikigaisha_yuugengaisha_nado' | translate }}\" id=billing_company_name name=billing_company_name ng-model=vm.project.billing_company_name required></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=billing_address>{{ 'sites.settings.projectBillings.juusho' | translate }}</label> <input class=form-control placeholder=\"{{ 'sites.settings.projectBillings.rei_toukyouto_shina' | translate }}\" id=billing_address name=billing_address ng-model=vm.project.billing_address required></div></div></div><div class=row><div class=col-md-3><div class=form-group><label for=billing_postal_code>{{ 'sites.settings.projectBillings.yuubinbangou' | translate }}</label> <input class=form-control placeholder=\"{{ 'sites.settings.projectBillings.rei_postal_code' | translate }}\" id=billing_postal_code name=billing_postal_code ng-model=vm.project.billing_postal_code required></div></div><div class=col-md-9><div class=form-group><label for=billing_phone_number>{{ 'sites.settings.projectBillings.denwabangou' | translate }}</label> <input class=form-control id=billing_phone_number name=billing_phone_number ng-model=vm.project.billing_phone_number required></div></div></div><hr><div class=row><div class=col-md-12><div class=form-group><h1 style=\"padding: 0 0 1em 0;\">{{ 'sites.settings.projectBillings.seikyuu_tantousha_jouhou' | translate }}</h1><zc-billing-representatives representatives=vm.project.billing_representatives></zc-billing-representatives></div></div></div></section><div class=\"row text-center footer\"><button type=submit class=\"btn btn-primary\" pe-track=siteSettings.save ng-disabled=siteSettings.$invalid>{{ 'sites.settings.projectBillings.hozon' | translate }}</button></div></form></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/settings/project_settings.html';
var html = "<div class=\"container-fluid container-limited\"><div class=\"col-md-10 col-md-offset-1 panel\"><form ng-submit=vm.saveProject(vm.project) name=siteSettings><section><h1>{{ 'sites.settings.projectSettings.saito' | translate }}</h1><div class=row><div class=col-md-12><div class=form-group><label for=base_url>URL</label> <input type=url class=form-control name=base_url ng-model=vm.project.base_url required></div></div></div><div class=row><div class=col-md-4><label for=site_logo_image_id>{{ 'sites.settings.projectSettings.rogo' | translate }}</label><div class=\"form-group divider\"><div ng-controller=SiteLogoImageController flow-init=\"{target: '/upload'}\" flow-files-submitted=$flow.upload() flow-file-success=\"$file.msg = $message\" flow-drop flow-file-added=!!{png:1,gif:1,jpg:1,jpeg:1}[$file.getExtension()] flow-attrs=\"{accept:'image/*'}\" ng-style=style><img ng-src={{vm.project.site_logo_image_url}} class=\"img-responsive site-logo-image\"><div><button type=button class=\"btn btn-default btn-sm btn-default margin-y\" flow-btn><i class=\"glyphicon glyphicon-upload\"></i> {{ 'sites.settings.projectSettings.appuroodo' | translate }}</button><input type=file style=\"visibility:hidden; position:absolute;\"> <input type=hidden name=site_logo_image_id ng-model=vm.project.site_logo_image_id><div class=help-block translate=sites.settings.projectSettings.yoko_nakaguro_tate translate-value-br=\"<br>\" translate-value-height1=40 translate-value-height2=30 translate-value-height3=60 translate-value-width1=180 translate-value-width2=100 translate-value-width3=200></div></div></div></div></div><div class=col-md-8><div class=row><div class=col-md-12><div class=form-group><label for=base_url>{{ 'sites.settings.projectSettings.arariritsu' | translate }}</label><select class=form-control ng-options=\"item.value as item.label for item in vm.profitRateOptions\" ng-model=vm.project.profit_percent></select></div></div><div class=col-md-12><div class=form-group><label>{{ 'sites.settings.projectSettings.heikin_tanka_haishin' | translate }}</label><div class=input-group><input class=form-control type=number min=0 ng-model=vm.project.average_conversion_price> <span class=input-group-addon>{{ vm.currency.suffix || vm.currency.symbol }}</span></div><p class=help-block ng-if=vm.avgPayment><span class=help-block>{{ 'sites.settings.projectSettings.sankou_heikin_tanka' | translate: { amount: (vm.avgPayment | zcCurrency: vm.currency.symbol:0:vm.currency.suffix) } }}</span></p><p class=help-block><span class=help-block>{{ 'sites.settings.projectSettings.nyuuryoku_sareta_arariritsu' | translate }}</span></p></div></div><div class=col-md-12><label>{{ 'sites.settings.projectSettings.souryoumuryou_no_heikin' | translate }}</label><div class=input-group><input class=form-control type=number min=0 ng-model=vm.project.free_shipping_cost> <span class=input-group-addon>{{ vm.currency.suffix || vm.currency.symbol }}</span></div></div><div class=col-md-12><p class=help-block><span class=help-block>{{ 'sites.settings.projectSettings.nyuuryoku_sareta_souryoumuryou' | translate }}</span></p></div><div zcs-hide-when-oem class=col-md-12><div class=form-group><label for=base_url>{{ 'sites.settings.projectSettings.region' | translate }}</label><select class=form-control ng-options=\"item.name as item.name | gmtNotation for item in vm.regions\" ng-model=vm.project.region disabled></select></div></div><div zcs-hide-when-oem class=col-md-12><div class=form-group><label for=base_url>{{ 'sites.settings.projectSettings.currency' | translate }}</label><select class=form-control ng-options=\"currency.name as currency.name | humanizeCurrency for currency in vm.dashboardCurrencies\" ng-model=vm.project.currency ng-disabled=!vm.canEditCurrencies() required></select></div></div><div zcs-hide-when-oem class=col-md-12><div class=form-group><label for=base_url>{{ 'sites.settings.projectSettings.invoiceCurrency' | translate }}</label><select class=form-control ng-options=\"currency as currency | humanizeCurrency for currency in [vm.project] | billable_currencies | unique\" ng-model=vm.project.invoice_currency ng-disabled=!vm.canEditCurrencies() required></select></div></div></div></div></div></section><div class=\"row text-center footer\"><button type=submit class=\"btn btn-primary\" pe-track=siteSettings.save ng-disabled=\"siteSettings.$invalid || !siteSettings.$dirty || vm.isSaving\">{{ 'sites.settings.projectSettings.hozon' | translate }}</button></div></form></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/setup/setup.html';
var html = "<div class=site-setup><div class=\"navbar-fixed-top steps\" ng-class=\"{'mr-margin': !vm.ZcsOemService.get()}\"><div class=col-md-1><a class=\"btn btn-close\" ui-sref=zenclerkS.project.dashboard(vm.project) master-only></a></div><ul class=\"step-selector col-md-10\"><li ng-repeat=\"state in vm.states\" ng-class=\"{'active': vm.isActiveState(state), 'before-active': vm.isPreviousState(state), 'disabled': vm.isDisabledState(state)}\" ng-click=vm.goToState(state)>{{state.label}}</li></ul></div><div class=ui-view-site-setup-view ui-view name=siteSetupView></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/setup/setup_company.html';
var html = "<div class=container-fluid><div class=row><div class=\"col-xs-2 col-md-4 setup-illustration with-steps\"><img src=/assets/img/illustration-shop-xl.png></div><div class=\"col-xs-10 col-md-8 setup-content with-steps\"><div class=\"col-md-10 col-md-offset-1\"><form ng-submit=vm.save() name=companyInfo><section><h1>{{ 'sites.setup.setupCompany.kaishajouhou_kakunin' | translate }}</h1><p>{{ 'sites.setup.setupCompany.kaki_no_jouhou' | translate }}</p><div class=row><div class=col-md-6><div class=form-group><label for=company_name>{{ 'sites.setup.setupCompany.kaishamei_kabushikigaisha_nado' | translate }}</label> <input class=form-control placeholder=\"{{ 'sites.setup.setupCompany.kabushikigaisha_yuugengaisha_nado' | translate }}\" id=company_name name=company_name ng-model=vm.project.company_name required></div></div><div class=col-md-6><div class=form-group><label for=representative>{{ 'sites.setup.setupCompany.kaisha_daihyou_na' | translate }}</label> <input class=form-control id=representative name=representative ng-model=vm.project.representative required></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=address>{{ 'sites.setup.setupCompany.juusho' | translate }}</label> <input class=form-control placeholder=\"{{ 'sites.setup.setupCompany.rei_toukyouto_shina' | translate }}\" id=address name=address ng-model=vm.project.address required></div></div></div><div class=row><div class=col-md-3><div class=form-group><label for=postal_code>{{ 'sites.setup.setupCompany.yuubinbangou' | translate }}</label> <input class=form-control placeholder=\"{{ 'sites.setup.setupCompany.rei_zip' | translate }}\" id=postal_code name=postal_code ng-model=vm.project.postal_code required></div></div><div class=col-md-9><div class=form-group><label for=phone_number>{{ 'sites.setup.setupCompany.denwabangou' | translate }}</label> <input class=form-control id=phone_number name=phone_number ng-model=vm.project.phone_number required></div></div></div><div class=row ng-if=vm.project.is_direct_selling><div class=col-md-6><div class=form-group><label for=person_in_charge>{{ 'sites.setup.setupCompany.tantousha_shimei_furuneemu' | translate }}</label> <input class=form-control id=person_in_charge name=person_in_charge ng-model=vm.project.person_in_charge required></div></div><div class=col-md-6><div class=form-group><label for=person_in_charge_email>{{ 'sites.setup.setupCompany.tantousha_meeruadoresu' | translate }}</label> <input type=email class=form-control id=person_in_charge_email name=person_in_charge_email ng-model=vm.project.person_in_charge_email required></div></div></div></section><section ng-if=vm.project.is_direct_selling><hr><h1 style=\"padding: 1.3em 0 1em 0\">{{ 'sites.setup.setupCompany.seikyuu_saki_jouhou' | translate }}</h1><div class=row><div class=col-md-12><div class=form-group><zc-sync-contract-info-button source=vm.project></zc-sync-contract-info-button></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=billing_company_name>{{ 'sites.setup.setupCompany.kaishamei' | translate }}</label> <input class=form-control placeholder=\"{{ 'sites.setup.setupCompany.kabushikigaisha_yuugengaisha_nado' | translate }}\" id=billing_company_name name=billing_company_name ng-model=vm.project.billing_company_name required></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=billing_address>{{ 'sites.setup.setupCompany.juusho' | translate }}</label> <input class=form-control placeholder=\"{{ 'sites.setup.setupCompany.rei_toukyouto_shina' | translate }}\" id=billing_address name=billing_address ng-model=vm.project.billing_address required></div></div></div><div class=row><div class=col-md-3><div class=form-group><label for=billing_postal_code>{{ 'sites.setup.setupCompany.yuubinbangou' | translate }}</label> <input class=form-control placeholder=\"{{ 'sites.setup.setupCompany.rei_zip' | translate }}\" id=billing_postal_code name=billing_postal_code ng-model=vm.project.billing_postal_code required></div></div><div class=col-md-9><div class=form-group><label for=billing_phone_number>{{ 'sites.setup.setupCompany.denwabangou' | translate }}</label> <input class=form-control id=billing_phone_number name=billing_phone_number ng-model=vm.project.billing_phone_number required></div></div></div></section><section ng-if=vm.project.is_direct_selling><hr><h1 style=\"padding: 1.3em 0 1em 0\">{{ 'sites.setup.setupCompany.seikyuu_tantousha_jouhou' | translate }}</h1><div class=row style=\"padding-bottom: 5px;\"><div class=col-md-12><div class=form-group><zc-billing-representatives representatives=vm.project.billing_representatives></zc-billing-representatives></div></div></div></section><section ng-if=!vm.isOem><hr><h1 style=\"padding: 1.3em 0 1em 0\">{{ 'sites.setup.setupCompany.doui_jouhou' | translate }}</h1><div class=row><div class=col-md-12><div class=form-group><label for=company_check><input type=checkbox ng-disabled=vm.project.companyinfo_confirmed_at id=company_check name=company_check ng-model=vm.project.company_check required> {{ 'sites.setup.setupCompany.[_han_shakai' | translate }}</label></div></div></div></section><div class=\"row setup-action\"><div class=\"col-xs-push-6 col-xs-6\"><button id=companyinfo_next_step class=\"btn btn-primary pull-right\" ng-disabled=companyInfo.$invalid>{{ 'sites.setup.setupCompany.kaishajouhou_wo_kakunin' | translate }}</button></div></div></form></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/setup/setup_complete.html';
var html = "<div class=container-fluid><div class=row><div class=\"col-xs-2 col-md-4 setup-illustration with-steps\"><img src=/assets/img/illustration-success-xl.png></div><div class=\"col-xs-10 col-md-8 setup-content with-steps\"><div class=\"col-md-10 col-md-offset-1\"><h1>{{ 'sites.setup.setupComplete.ijou_de_shokisettei' | translate }}</h1><p translate=sites.setup.setupComplete.koremade_no_suteppu translate-value-br=\"<br>\"></p><div class=\"row setup-action\"><div class=col-xs-6><div ng-switch on=vm.project.integrated_with><div ng-switch-when=color_me_shop><button class=\"btn btn-default pull-left\" ui-sref=zenclerkS.project.setup.site>{{ 'sites.setup.setupComplete.modoru' | translate }}</button></div><div ng-switch-default><button class=\"btn btn-default pull-left\" ui-sref=zenclerkS.project.setup.conversionTag>{{ 'sites.setup.setupComplete.modoru' | translate }}</button></div></div></div><div class=col-xs-6><button class=\"btn btn-primary pull-right\" ui-sref=zenclerkS.project.dashboard>{{ 'sites.setup.setupComplete.dasshuboodo_e_susumu' | translate }}</button></div></div></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/setup/setup_conversion_tag.html';
var html = "<div class=container-fluid><div class=row><div class=\"col-xs-2 col-md-4 setup-illustration with-steps\"><img src=/assets/img/illustration-conversion-xl.png></div><div class=\"col-xs-10 col-md-8 setup-content with-steps\"><div class=\"col-md-10 col-md-offset-1\"><h1>{{ 'sites.setup.setupConversionTag.konbaajontagu_no_setchi' | translate }}</h1><p>{{ 'sites.setup.setupConversionTag.ko_no_tagugayuuzaano' | translate }} <span zcs-hide-when-integrated=color_me_shop,shopify>{{ 'sites.setup.setupConversionTag.mata,kuuponkoodo_soushin_no' | translate }}</span></p><zcs-conversion-tag-checker project=vm.project show-return=true on-complete=vm.onComplete()></zcs-conversion-tag-checker></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1436 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/setup/setup_pricing.html';
var html = "<div class=\"setup-content container-fluid confirmation\"><div class=row><div><div class=col-md-12><h1 class=confirmation_title>{{ 'sites.setup.setupPricing.ryoukin_puran_no' | translate: { service: ZcsOemService.getName(), } }}</h1><form ng-submit=vm.save() name=companyInfo><div><ng-include src=\"'/templates/zenclerk_s/common/pricing/pricing.html'\"></ng-include></div><div class=\"row options\"><div class=\"col-md-6 col-md-push-3\"><div class=form-group><label for=pricing_confirmation_1><input type=checkbox id=pricing_confirmation_1 ng-model=vm.project.pricing_confirmation_1 ng-disabled=vm.project.pricing_confirmed_at required> {{ 'sites.setup.setupPricing.no_riyouryoukin_no' | translate: { service: ZcsOemService.getName(), } }}</label></div><div class=form-group><label for=pricing_confirmation_2><input type=checkbox id=pricing_confirmation_2 ng-model=vm.project.pricing_confirmation_2 ng-disabled=vm.project.pricing_confirmed_at required> {{ 'sites.setup.setupPricing.saitei_riyou_tesuuryou' | translate }}</label></div></div></div><div class=text-center><button id=confirmation_next_step class=\"btn btn-primary\" style=text-transform:none; ng-disabled=companyInfo.$invalid ng-if=!vm.project.pricing_confirmed_at>{{ 'sites.setup.setupPricing.no_riyou_wo' | translate: { service: ZcsOemService.getName(), } }}</button> <button id=confirmation_next_step class=\"btn btn-primary\" style=text-transform:none; ng-disabled=companyInfo.$invalid ng-if=vm.project.pricing_confirmed_at>{{ 'sites.setup.setupPricing.tsugi_e_susumu' | translate }}</button></div></form></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/setup/setup_site.html';
var html = "<div class=container-fluid><div class=row><div class=\"col-xs-2 col-md-4 setup-illustration with-steps\"><img src=/assets/img/illustration-website-xl.png></div><div class=\"col-xs-10 col-md-8 setup-content with-steps\"><div class=\"note col-md-10 col-md-offset-1\" zcs-shopping-cart-asp-only=makeshop,futureshop2 translate=sites.setup.setupSite.dehatorakkingu_no_seido translate-value-service={{ZcsOemService.getName()}} translate-value-br=\"<br>\"></div><div class=\"col-md-10 col-md-offset-1\"><h1>{{ 'sites.setup.setupSite.saito_jouhou_kakunin' | translate }}</h1><form ng-submit=vm.save() name=companyInfo><div class=row><div class=col-md-12><div class=form-group><label for=title>{{ 'sites.setup.setupSite.saito_na' | translate }}</label> <input type=text id=siteinfo_title class=form-control name=title ng-model=vm.project.title required></div></div></div><div class=row><div class=col-md-12><div class=form-group><label for=base_url>{{ 'sites.setup.setupSite.topPageUrl' | translate }}</label> <input type=url id=siteinfo_base_url class=form-control name=base_url ng-model=vm.project.base_url required></div></div></div><div class=row zcs-hide-when-oem><div class=col-md-12><div class=form-group><p>{{ 'sites.setup.setupSite.no_uede_saitorogo_wo' | translate: { service: ZcsOemService.getName(), } }}</p><label class=radio-inline for=can_use_site_logo_true><input type=radio id=can_use_site_logo_true name=can_use_site_logo class=form-control ng-value=true ng-model=vm.project.can_use_site_logo ng-required=!vm.isOemService> {{ 'sites.setup.setupSite.keisai_ka' | translate }}</label> <label class=radio-inline for=can_use_site_logo_false><input type=radio id=can_use_site_logo_false name=can_use_site_logo class=form-control ng-value=false ng-model=vm.project.can_use_site_logo ng-required=!vm.isOemService> {{ 'sites.setup.setupSite.keisai_fuka' | translate }}</label></div></div></div><div class=\"row setup-action\"><div class=col-xs-6><a class=\"btn btn-default pull-left\" ui-sref=zenclerkS.project.setup.company zcs-hide-when-oem>{{ 'sites.setup.setupSite.modoru' | translate }}</a></div><div class=col-xs-6><button id=siteinfo_next_step class=\"btn btn-primary pull-right\" ng-disabled=siteInfo.$invalid>{{ 'sites.setup.setupSite.saito_jouhou_wo' | translate }}</button></div></div></form></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/setup/setup_tracking_tag.html';
var html = "<div class=container-fluid><div class=row><div class=\"col-xs-2 col-md-4 setup-illustration with-steps\"><img src=/assets/img/illustration-tracking-xl.png></div><div class=\"col-xs-10 col-md-8 setup-content with-steps\"><div class=\"col-md-10 col-md-offset-1\"><h1>{{ 'sites.setup.setupTrackingTag.torakkingutagu_no_setchi' | translate }}</h1><p>{{ 'sites.setup.setupTrackingTag.ko_no_tagugamausuyasukurooru' | translate }}</p><zcs-tracking-tag-checker project=vm.project show-return=true on-complete=vm.onComplete()></zcs-tracking-tag-checker></div></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/site_navigation.html';
var html = "<a ui-sref=\"zenclerkS.project.dashboard({apikey: $ctrl.project.apikey})\" ng-class=\"{active: $ctrl.isGroup('activity')}\" ng-if=\"!$ctrl.project.is_terminated || $ctrl.isMaster\">{{ 'sites.siteNavigation.akutibiti' | translate }}</a> <a ng-class=\"{active: $ctrl.isGroup('terminated')}\" ui-sref=\"zenclerkS.project.terminated({apikey: $ctrl.project.apikey})\" ng-if=$ctrl.project.is_terminated>{{ 'sites.siteNavigation.saabisu_riyou_saikai' | translate }}</a> <a ng-class=\"{active: $ctrl.isGroup('campaigns')}\" ui-sref=\"zenclerkS.project.campaigns({apikey: $ctrl.project.apikey})\">{{ 'sites.siteNavigation.kyanpeen' | translate }}</a> <a ng-class=\"{active: $ctrl.isGroup('interestWidget')}\" ui-sref=\"zenclerkS.project.interestWidget.results({apikey: $ctrl.project.apikey})\" ng-if=\"(!$ctrl.project.is_terminated || $ctrl.isMaster) && $ctrl.hasInterestWidgets && ($ctrl.project.iw_contracted_at || $ctrl.project.iw_trial_started_at)\">Interest Widget</a> <a zcs-hide-when-integrated=color_me_shop,shopify ng-class=\"{active: $ctrl.isGroup('invoices')}\" ui-sref=\"zenclerkS.project.invoices.list({apikey: $ctrl.project.apikey})\">{{ 'sites.siteNavigation.seikyuu' | translate }}</a> <a ng-class=\"{active: $ctrl.isGroup('settings')}\" ui-sref=\"zenclerkS.project.settings({apikey: $ctrl.project.apikey})\" ng-if=\"!$ctrl.project.is_terminated || $ctrl.isMaster\">{{ 'sites.siteNavigation.settei' | translate }} <span class=\"badge badge-needs-action pull-right\" ng-if=\"$ctrl.notification.setting > 0\"></span></a>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/stats/list.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1441 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/stats/site_stats_show.html';
var html = "<div class=\"col-md-8 item-stats\"><div class=\"list padding-y\"><div ng-if=!vm.sortedItems.length>{{ 'sites.stats.siteStatsShow.shouhin_no_hanbai' | translate: { service: ZcsOemService.getName() } }}</div><div ng-repeat=\"item in vm.sortedItems\" class=list-item ng-style=\"{'transform': 'translateY('+vm.css.listItemTranslation+'px)'}\"><div class=list-item-header><div class=list-item-title><h2><a href=\"{{ item.url }}\" target=_blank>{{ item.name }}</a></h2><small ng-class=\"{'highlight': vm.sortField == 'price'}\">{{ 'sites.stats.siteStatsShow.price_amount' | translate: { amount: (item.price | zcCurrency: vm.currency.symbol:0:vm.currency.suffix) } }}</small> <small><i class=\"fa fa-tag\"></i> {{ item.id }}</small></div></div><div class=item-stats><table><tr class=item-stat-daily><td><h3>{{ 'sites.stats.siteStatsShow.zenjitsu' | translate }}</h3></td><td>{{ item.daily.pv }}</td><td>{{ item.daily.conversion_count }}</td><td>{{ item.daily.conversion_amount }}</td><td>{{ item.daily.conversion_price | zcCurrency: vm.currency.symbol:0:vm.currency.suffix }}</td><td>{{ item.daily.conversion_ratio * 100 | number: 2 }}%</td><td>{{ item.daily.sales_ratio * 100 | number:2 }}%</td></tr><tr class=item-stat-legend><td></td><td>{{ 'sites.stats.siteStatsShow.akusesu_kazu' | translate }}</td><td>{{ 'sites.stats.siteStatsShow.kaisuu' | translate }}</td><td>{{ 'sites.stats.siteStatsShow.hanbai_suuryou' | translate }}</td><td>{{ 'sites.stats.siteStatsShow.kingaku' | translate }}</td><td>{{ 'sites.stats.siteStatsShow.ritsu' | translate }}</td><td>{{ 'sites.stats.siteStatsShow.uriage_kouseihi' | translate }}</td></tr><tr class=item-stat-monthly><td><h3>{{ 'sites.stats.siteStatsShow.gekkan' | translate }}</h3></td><td ng-class=\"{'highlight': vm.sortField == 'monthly.pv'}\">{{ item.monthly.pv }}</td><td ng-class=\"{'highlight': vm.sortField == 'monthly.conversion_count'}\">{{ item.monthly.conversion_count }}</td><td ng-class=\"{'highlight': vm.sortField == 'monthly.conversion_amount'}\">{{ item.monthly.conversion_amount }}</td><td ng-class=\"{'highlight': vm.sortField == 'monthly.conversion_price'}\">{{ item.monthly.conversion_price | zcCurrency: vm.currency.symbol:0:vm.currency.suffix }}</td><td ng-class=\"{'highlight': vm.sortField == 'monthly.conversion_ratio'}\">{{ item.monthly.conversion_ratio * 100 | number: 2 }}%</td><td ng-class=\"{'highlight': vm.sortField == 'monthly.sales_ratio'}\">{{ item.monthly.sales_ratio * 100 | number: 2 }}%</td></tr></table></div><div class=clearfix></div></div></div></div><sidebar class=col-md-4><div class=sidebar-body><h2>{{ 'sites.stats.siteStatsShow.shuukei_hi' | translate }}</h2><span ng-if=vm.stats>{{ vm.summarize_at | zcDate : { smart: true, dateOnly: true } }}</span> <span ng-if=!vm.stats>{{ 'sites.stats.siteStatsShow.shuukei_hi_shuukei' | translate }}</span><h2>{{ 'sites.stats.siteStatsShow.firuta' | translate }}</h2><div class=\"input-group search\"><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text id=filter name=filter ng-model=vm.filterText ng-model-options=\"{ debounce: 300, blur: 0 }\" ng-change=vm.sortItems()></div><h2>{{ 'sites.stats.siteStatsShow.sooto' | translate }}</h2><select class=form-control ng-model=vm.sortField ng-change=vm.sortItems() ng-options=\"field.value as field.label for field in vm.sortFields\"></select></div></sidebar><zcs-notification-timezone project=vm.project></zcs-notification-timezone>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/tags/site_tags.html';
var html = "<div class=\"container container-limited\"><div class=row><div class=col-md-3><ul class=\"nav nav-stacked padding-y\"><li zcs-hide-when-integrated=shopify role=presentation ui-sref=zenclerkS.project.tags.tracking ui-sref-active-eq=active><a>{{ 'sites.tags.siteTags.torakkingutagu' | translate }} <span class=\"badge badge-needs-action pull-right\" ng-if=!vm.project.tracking_tag_confirmed_at>1</span></a></li><li role=presentation ui-sref=zenclerkS.project.tags.conversion ui-sref-active-eq=active><a>{{ 'sites.tags.siteTags.konbaajontagu' | translate }} <span class=\"badge badge-needs-action pull-right\" ng-if=!vm.project.conversion_tag_confirmed_at>1</span></a></li></ul></div><div class=\"col-md-9 panel padding-y\"><ui-view name=tagView></ui-view></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/terminated/terminated.html';
var html = "<div class=container-fluid><div class=terminated><h1>{{ 'sites.terminated.terminated.you' | translate: { name: $ctrl.project.title } }}</h1></div><div class=text-center ng-if=$ctrl.project.is_terminated>{{ 'sites.terminated.terminated.yori_kaiyaku_sareteimasu' | translate: { date: $ctrl.terminatedDate } }}<br>{{ 'sites.terminated.terminated.saabisu_wo_saikai' | translate }}</div><div class=text-center ng-if=!$ctrl.project.is_terminated>{{ 'sites.terminated.terminated.saabisu_wo_go' | translate }}</div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/sites/users/list.html';
var html = "<div class=col-md-1></div><div class=col-md-6><div class=\"list padding-y\"><div class=\"list-item list-new\" ng-class={active:vm.state.addUser}><div><div class=list-item-header>{{ 'sites.users.list.shinkiyuuza_touroku' | translate }}</div><div class=list-item-body><p class=\"text-justify padding-y\">{{ 'sites.users.list.kanri_gamen_wo' | translate }}<br>{{ 'sites.users.list.namae_to_meeruadoresu' | translate }}<br>{{ 'sites.users.list.shoutai_sareta_hito' | translate }}</p><form id=inviteUser name=form ng-submit=vm.inviteUser() class=text-center><input id=name name=name class=\"margin-y form-control\" ng-model=vm.newUser.full_name placeholder=\"{{ 'sites.users.list.namae' | translate }}\" required> <input id=email name=email type=email class=\"margin-y form-control\" ng-model=vm.newUser.email placeholder=\"{{ 'sites.users.list.meeruadoresu' | translate }}\" required> <button type=button class=\"btn btn-default pull-left\" ng-click=vm.toggleNew()>{{ 'sites.users.list.kyanseru' | translate }}</button> <button type=submit class=\"btn btn-primary pull-right\" ng-disabled=form.$invalid>{{ 'sites.users.list.shoutai' | translate }}</button><div class=\"warning padding margin-y hide\" ng-class=\"{'show': vm.state.duplicateUser}\">{{ 'sites.users.list.ko_no_meerusude' | translate }}</div></form><div class=clearfix></div></div></div></div><div ng-repeat=\"user in vm.users | filter: filter | orderBy: 'full_name'\" class=list-item ng-style=\"{'transform': 'translateY('+vm.css.listItemTranslation+'px)'}\"><div class=list-item-header><div class=list-item-avatar>{{user.email | limitTo:1}}</div><div class=list-item-title><h2>{{user.full_name}}</h2><small><i class=\"fa fa-envelope-o\"></i> {{user.email}}</small></div><div class=list-item-action><i class=\"fa fa-ellipsis-h\"></i> <i class=\"fa fa-trash\" confirm-click=vm.removeUser(user) confirm-modal ng-if=\"user.email != vm.currentUser.email\" title=\"{{ 'sites.users.list.sakujo' | translate }}\"></i></div></div></div></div></div><div class=col-md-1></div><sidebar class=col-md-4><div class=sidebar-body><a class=\"btn btn-primary\" ng-click=vm.toggleNew()>{{ 'sites.users.list.shinkiyuuza_touroku' | translate }}</a><h2>{{ 'sites.users.list.firuta' | translate }}</h2><div class=\"input-group search\"><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text id=filter name=filter ng-model=filter></div><h2>{{ 'sites.users.list.taipu' | translate }}</h2>{{ 'sites.users.list.akutibu' | translate }} <span class=\"badge pull-right\">{{vm.users.length}}</span><br>{{ 'sites.users.list.hitsujiroguin' | translate }} <span class=\"badge pull-right\">0</span></div></sidebar>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/users/invitation/accept.html';
var html = "<div class=\"panel padding-y col-md-4 col-md-offset-4\"><h1 class=text-center>{{ 'users.invitation.akaunto_wo_sakusei' | translate }}</h1><form name=form ng-submit=vm.submit()><div class=form-group><label for=user_full_name class=placeholder-hidden>{{ 'users.invitation.name' | translate }}</label> <input type=text class=form-control id=user_full_name ng-model=vm.user.full_name required></div><div class=form-group><label for=user_email class=placeholder-hidden>{{ 'users.invitation.email' | translate }}</label> <input type=email class=form-control id=user_email ng-model=vm.user.email required></div><div class=form-group><label for=user_password class=placeholder-hidden>{{ 'users.invitation.password' | translate }}</label> <input type=password class=form-control id=user_password placeholder=\"{{ 'users.invitation.password' | translate }}\" ng-model=vm.user.password required ng-minlength=8></div><div class=form-group><label for=user_password_confirmation class=placeholder-hidden>{{ 'users.invitation.passwordConfirmation' | translate }}</label> <input type=password class=form-control id=user_password_confirmation placeholder=\"{{ 'users.invitation.passwordConfirmation' | translate }}\" ng-model=vm.user.password_confirmation required ng-minlength=8></div><div class=form-group><input id=isAgreeToTosAndPrivacyPolicy ng-model=vm.isAgreeToTosAndPrivacyPolicy type=checkbox required> <label for=isAgreeToTosAndPrivacyPolicy translate=users.invitation.agree_to_tos_and_privacy_policy translate-value-terms-of-service=\"<a href='/tos/admin?lang={{vm.selectedLanguage}}' target='_blank'>{{ 'users.invitation.tos' | translate }}</a>\" translate-value-privacy-policy=\"<a href='/privacy_policy?lang={{vm.selectedLanguage}}' target='_blank'>{{ 'users.invitation.privacy_policy' | translate }}</a>\"></label></div><div class=\"form-group text-center\"><button type=submit class=\"btn btn-primary\" ng-disabled=form.$invalid>{{ 'users.invitation.akaunto_wo_sakusei' | translate }}</button></div></form><hr><div class=\"lang text-center\"><a ng-click=\"vm.setLanguage('en')\">English</a> <a ng-click=\"vm.setLanguage('ja')\">日本語</a></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1446 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/users/reset_password/reset_password.html';
var html = "<div class=\"panel padding-y col-md-4 col-md-offset-4\"><h1 class=\"text-center margin-y\">{{ 'users.resetPassword.enterPassword' | translate }}</h1><form name=form ng-submit=$ctrl.submit($ctrl.user)><div class=form-group><label for=user_password class=placeholder-hidden>{{ 'users.resetPassword.password' | translate }}</label> <input type=password class=form-control id=user_password placeholder=\"{{ 'users.resetPassword.password' | translate }}\" ng-model=$ctrl.user.password required ng-minlength=8></div><div class=form-group><label for=user_password_confirmation class=placeholder-hidden>{{ 'users.resetPassword.passwordConfirmation' | translate }}</label> <input type=password class=form-control id=user_password_confirmation placeholder=\"{{ 'users.resetPassword.passwordConfirmation' | translate }}\" ng-model=$ctrl.user.password_confirmation required ng-minlength=8></div><div class=\"form-group text-center\"><button type=submit class=\"btn btn-primary\" ng-disabled=form.$invalid>{{ 'users.resetPassword.resetPassword' | translate }}</button></div></form><div class=\"lang text-center\"><a ng-click=\"$ctrl.setLanguage('en')\">English</a> <a ng-click=\"$ctrl.setLanguage('ja')\">日本語</a></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

var path = '/templates/zenclerk_s/users/sign_in/sign_in.html';
var html = "<div class=sign_in><div class=\"container container-limited\" zcs-hide-when-oem><div class=row><div class=\"login-body col-md-6 col-md-offset-3\"><img class=logo src=/assets/img/logo-aideal.svg><form name=form class=\"form account-form\" ng-submit=$ctrl.login($ctrl.user) ng-show=\"!$ctrl.enableAuth0 && !$ctrl.showForgot && !$ctrl.showShopifyLogin\"><div class=\"form-group login-email\"><label for=login_email class=placeholder-hidden>{{ 'users.signIn.email' | translate }}</label> <input auto-fill-sync id=login_email type=email name=email autocomplete=email class=form-control placeholder=\"{{ 'users.signIn.email' | translate }}\" ng-model=$ctrl.user.email required></div><hr><div class=\"form-group login-password\"><label for=login_password class=placeholder-hidden>{{ 'users.signIn.password' | translate }}</label> <input auto-fill-sync id=login_password type=password autocomplete=current-password name=password class=form-control placeholder=\"{{ 'users.signIn.password' | translate }}\" ng-model=$ctrl.user.password required ng-minlength=8></div><div class=\"form-group login-remember\"><small>{{ 'users.signIn.rememberMe' | translate }}</small><div class=switch><input type=checkbox name=switch class=switch-checkbox id=remember ng-model=$ctrl.user.remember_me> <label class=\"switch-label checkbox-inline\" for=remember></label></div></div><div class=\"form-group login-button\"><button class=\"btn btn-primary btn-login\" id=login_button type=submit pe-track=users.users.signIn.loginButton ng-disabled=form.$invalid>{{ 'users.signIn.login' | translate }}</button></div><div class=row><div class=\"col-md-6 forgot-link login-forgot text-center\"><a ng-click=$ctrl.toggleForgot() ng-show=!$ctrl.showForgot>{{ 'users.signIn.forgotPassword' | translate }}</a></div><div ng-if=$ctrl.loginUrlForColorMeShop class=\"col-md-6 tos-link text-center\"><a href=\"{{ $ctrl.loginUrlForColorMeShop }}\">{{ 'users.signIn.colorMeShopLogin' | translate }}</a></div></div><div class=row><div class=\"col-md-6 tos-link text-center\"><a ng-click=$ctrl.toggleShopifyLogin()>{{ 'users.signIn.shopifyLogin' | translate }}</a></div></div></form><form ng-if=\"$ctrl.enableAuth0 && !$ctrl.showShopifyLogin\" name=formAuth0 class=\"form account-form\"><div class=row><div class=\"col-md-12 forgot-link login-forgot text-center\"><a ng-click=$ctrl.loginWithAuth0()>{{ 'users.signIn.loginWithEmailAndPassword' | translate }}</a></div></div><div class=row><div ng-if=$ctrl.loginUrlForColorMeShop class=\"col-md-12 tos-link text-center\"><a href=\"{{ $ctrl.loginUrlForColorMeShop }}\">{{ 'users.signIn.colorMeShopLogin' | translate }}</a></div></div><div class=row><div class=\"col-md-12 tos-link text-center\"><a ng-click=$ctrl.toggleShopifyLogin()>{{ 'users.signIn.shopifyLogin' | translate }}</a></div></div></form><form name=formShopify class=\"form account-form\" ng-submit=$ctrl.shopifyLogin() ng-show=$ctrl.showShopifyLogin><div class=form-group><label for=shopifyShopInput class=placeholder-hidden>{{ 'users.signIn.shopifyLogin' | translate }}</label> <input id=shopifyShopInput placeholder=\"{{ 'users.signIn.shop' | translate }}\" ng-model=$ctrl.shopifyShopName ng-minlength=4 required style=\"text-align: right\"> <span><b>{{ $ctrl.shopifyShopDomain }}</b></span></div><hr><div class=\"form-group login-button\"><button class=\"btn btn-primary\" id=shopifyShopLoginButton type=button ng-click=$ctrl.shopifyLogin() ng-disabled=formShopify.$invalid>{{ 'users.signIn.login' | translate }}</button></div><div class=\"forgot-link login-forgot\"><a ng-click=$ctrl.toggleShopifyLogin() ng-show=$ctrl.showShopifyLogin>{{ 'users.signIn.backToLogin' | translate }}</a></div></form><form name=formForgot class=\"form forgot-form\" ng-submit=$ctrl.forgot($ctrl.user.email) ng-show=$ctrl.showForgot><div class=\"form-group login-email\"><label for=user_email class=placeholder-hidden>{{ 'users.signIn.email' | translate }}</label> <input auto-fill-sync type=email class=form-control id=password_forgot_email placeholder=\"{{ 'users.signIn.email' | translate }}\" ng-model=$ctrl.user.email required></div><hr><div class=\"form-group login-button\"><button class=\"btn btn-primary\" id=password_forgot_button type=button pe-track=users.users.signIn.forgotPasswordButton ng-click=$ctrl.forgot($ctrl.user.email) ng-disabled=\"$ctrl.formForgot.$invalid || $ctrl.forgotHasBeenSubmitted\">{{ 'users.signIn.sendRecoveryLink' | translate }}</button></div><div class=\"forgot-link login-forgot\"><a ng-click=$ctrl.toggleForgot() ng-show=$ctrl.showForgot>{{ 'users.signIn.backToLogin' | translate }}</a></div></form></div></div><div class=\"lang text-center\"><a ng-click=\"$ctrl.setLanguage('en')\">English</a> <a ng-click=\"$ctrl.setLanguage('ja')\">日本語</a></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./services/access_stats.service": 215,
	"./services/access_stats.service.js": 215,
	"./services/agency_project.service": 216,
	"./services/agency_project.service.js": 216,
	"./services/agency_user.service": 217,
	"./services/agency_user.service.js": 217,
	"./services/analytics.service": 218,
	"./services/analytics.service.js": 218,
	"./services/behavior.service": 219,
	"./services/behavior.service.js": 219,
	"./services/campaign.service": 220,
	"./services/campaign.service.js": 220,
	"./services/campaign_element_creator.service": 221,
	"./services/campaign_element_creator.service.js": 221,
	"./services/campaign_name.service": 222,
	"./services/campaign_name.service.js": 222,
	"./services/color_me_shop.service": 223,
	"./services/color_me_shop.service.js": 223,
	"./services/dashboard_data.service": 224,
	"./services/dashboard_data.service.js": 224,
	"./services/device_name.service": 225,
	"./services/device_name.service.js": 225,
	"./services/devise.service": 226,
	"./services/devise.service.js": 226,
	"./services/estimator.service": 227,
	"./services/estimator.service.js": 227,
	"./services/feature_notification.service": 228,
	"./services/feature_notification.service.js": 228,
	"./services/incentive.service": 229,
	"./services/incentive.service.js": 229,
	"./services/invoice.service": 230,
	"./services/invoice.service.js": 230,
	"./services/invoice_adjustment.service": 231,
	"./services/invoice_adjustment.service.js": 231,
	"./services/layout.service": 232,
	"./services/layout.service.js": 232,
	"./services/makeshop_api.service": 233,
	"./services/makeshop_api.service.js": 233,
	"./services/project_user.service": 234,
	"./services/project_user.service.js": 234,
	"./services/segment.service": 235,
	"./services/segment.service.js": 235,
	"./services/shopify.service": 236,
	"./services/shopify.service.js": 236,
	"./services/state_before_action_runner.service": 237,
	"./services/state_before_action_runner.service.js": 237,
	"./services/timing.service": 238,
	"./services/timing.service.js": 238,
	"./services/zcs_daily_diff_stats.service": 239,
	"./services/zcs_daily_diff_stats.service.js": 239,
	"./services/zcs_image.service": 240,
	"./services/zcs_image.service.js": 240,
	"./services/zcs_makerepeater_oem.service": 241,
	"./services/zcs_makerepeater_oem.service.js": 241,
	"./services/zcs_oem.service": 242,
	"./services/zcs_oem.service.js": 242,
	"./services/zcs_project.service": 243,
	"./services/zcs_project.service.js": 243,
	"./zenclerk_s/agencies/campaigns/agency_campaigns.html": 1300,
	"./zenclerk_s/agencies/home/agency_home.component": 244,
	"./zenclerk_s/agencies/home/agency_home.component.js": 244,
	"./zenclerk_s/agencies/home/agency_home.html": 1301,
	"./zenclerk_s/agencies/home/agency_home.scss": 899,
	"./zenclerk_s/agencies/invoices/agency_invoice_show.controller": 245,
	"./zenclerk_s/agencies/invoices/agency_invoice_show.controller.js": 245,
	"./zenclerk_s/agencies/invoices/agency_invoices_list.controller": 246,
	"./zenclerk_s/agencies/invoices/agency_invoices_list.controller.js": 246,
	"./zenclerk_s/agencies/invoices/list.html": 1302,
	"./zenclerk_s/agencies/invoices/show.html": 1303,
	"./zenclerk_s/agencies/invoices/show.scss": 900,
	"./zenclerk_s/agencies/settings/agency_settings.controller": 247,
	"./zenclerk_s/agencies/settings/agency_settings.controller.js": 247,
	"./zenclerk_s/agencies/settings/agency_settings.html": 1304,
	"./zenclerk_s/agencies/sidebar.html": 1305,
	"./zenclerk_s/agencies/sites/agency_create_site.controller": 248,
	"./zenclerk_s/agencies/sites/agency_create_site.controller.js": 248,
	"./zenclerk_s/agencies/sites/agency_project_table.component": 249,
	"./zenclerk_s/agencies/sites/agency_project_table.component.js": 249,
	"./zenclerk_s/agencies/sites/agency_project_table.html": 1306,
	"./zenclerk_s/agencies/sites/agency_project_table.scss": 901,
	"./zenclerk_s/agencies/sites/agency_site_list.component": 250,
	"./zenclerk_s/agencies/sites/agency_site_list.component.js": 250,
	"./zenclerk_s/agencies/sites/agency_site_list.html": 1307,
	"./zenclerk_s/agencies/sites/new.html": 1308,
	"./zenclerk_s/agencies/sites_in_installation/sites_in_installation.component": 251,
	"./zenclerk_s/agencies/sites_in_installation/sites_in_installation.component.js": 251,
	"./zenclerk_s/agencies/sites_in_installation/sites_in_installation.html": 1309,
	"./zenclerk_s/agencies/sites_in_installation/sites_in_installation.scss": 902,
	"./zenclerk_s/agencies/sites_user_activity/sites_user_activity.component": 252,
	"./zenclerk_s/agencies/sites_user_activity/sites_user_activity.component.js": 252,
	"./zenclerk_s/agencies/sites_user_activity/sites_user_activity.html": 1310,
	"./zenclerk_s/agencies/users/agency_users.controller": 253,
	"./zenclerk_s/agencies/users/agency_users.controller.js": 253,
	"./zenclerk_s/agencies/users/agency_users.html": 1311,
	"./zenclerk_s/agencies/zcs_agency_sidebar.directive": 254,
	"./zenclerk_s/agencies/zcs_agency_sidebar.directive.js": 254,
	"./zenclerk_s/common/maintenance/maintenance.html": 1312,
	"./zenclerk_s/common/pricing/pricing.html": 1313,
	"./zenclerk_s/common/pricing/pricing.scss": 903,
	"./zenclerk_s/common/product_changes/product_changes.html": 1314,
	"./zenclerk_s/common/product_changes/product_changes.scss": 904,
	"./zenclerk_s/common/product_changes/product_changes_page.html": 1315,
	"./zenclerk_s/directives/agency-project-only/agency_project_only.directive": 255,
	"./zenclerk_s/directives/agency-project-only/agency_project_only.directive.js": 255,
	"./zenclerk_s/directives/agency-project-only/agency_project_only.scss": 905,
	"./zenclerk_s/directives/agency_only/agency_only.directive": 256,
	"./zenclerk_s/directives/agency_only/agency_only.directive.js": 256,
	"./zenclerk_s/directives/behavior_visualizer/behavior_visualizer": 257,
	"./zenclerk_s/directives/behavior_visualizer/behavior_visualizer.html": 1316,
	"./zenclerk_s/directives/behavior_visualizer/behavior_visualizer.js": 257,
	"./zenclerk_s/directives/behavior_visualizer/behavior_visualizer.scss": 906,
	"./zenclerk_s/directives/campaign/action_menu/campaign_action_menu": 258,
	"./zenclerk_s/directives/campaign/action_menu/campaign_action_menu.html": 1317,
	"./zenclerk_s/directives/campaign/action_menu/campaign_action_menu.js": 258,
	"./zenclerk_s/directives/campaign/action_menu/campaign_action_menu.scss": 907,
	"./zenclerk_s/directives/campaign/list/conversions": 259,
	"./zenclerk_s/directives/campaign/list/conversions.html": 1318,
	"./zenclerk_s/directives/campaign/list/conversions.js": 259,
	"./zenclerk_s/directives/campaign/list/conversions.scss": 908,
	"./zenclerk_s/directives/campaign/template_editor/campaign_template_dynamic_view": 260,
	"./zenclerk_s/directives/campaign/template_editor/campaign_template_dynamic_view.html": 1319,
	"./zenclerk_s/directives/campaign/template_editor/campaign_template_dynamic_view.js": 260,
	"./zenclerk_s/directives/campaign/template_editor/campaign_template_dynamic_view.scss": 909,
	"./zenclerk_s/directives/campaign/template_editor/campaign_template_editor": 261,
	"./zenclerk_s/directives/campaign/template_editor/campaign_template_editor.html": 1320,
	"./zenclerk_s/directives/campaign/template_editor/campaign_template_editor.js": 261,
	"./zenclerk_s/directives/campaign/template_editor/campaign_template_editor.scss": 910,
	"./zenclerk_s/directives/campaign/template_editor/campaign_template_item.directive": 262,
	"./zenclerk_s/directives/campaign/template_editor/campaign_template_item.directive.js": 262,
	"./zenclerk_s/directives/campaign/template_editor/campaign_template_item.html": 1321,
	"./zenclerk_s/directives/campaign/template_editor/new_image.controller": 263,
	"./zenclerk_s/directives/campaign/template_editor/new_image.controller.js": 263,
	"./zenclerk_s/directives/campaign/view_card/campaign_view_card": 264,
	"./zenclerk_s/directives/campaign/view_card/campaign_view_card.html": 1322,
	"./zenclerk_s/directives/campaign/view_card/campaign_view_card.js": 264,
	"./zenclerk_s/directives/campaign/view_card/campaign_view_card.scss": 911,
	"./zenclerk_s/directives/changing_number/changing_number": 265,
	"./zenclerk_s/directives/changing_number/changing_number.js": 265,
	"./zenclerk_s/directives/charts/chart.scss": 912,
	"./zenclerk_s/directives/charts/chart_area": 266,
	"./zenclerk_s/directives/charts/chart_area.js": 266,
	"./zenclerk_s/directives/charts/chart_pie": 267,
	"./zenclerk_s/directives/charts/chart_pie.js": 267,
	"./zenclerk_s/directives/charts/chart_single_bar": 268,
	"./zenclerk_s/directives/charts/chart_single_bar.js": 268,
	"./zenclerk_s/directives/charts/chart_single_line": 269,
	"./zenclerk_s/directives/charts/chart_single_line.js": 269,
	"./zenclerk_s/directives/charts/chart_stacked_bar": 270,
	"./zenclerk_s/directives/charts/chart_stacked_bar.js": 270,
	"./zenclerk_s/directives/components/close_button": 271,
	"./zenclerk_s/directives/components/close_button.js": 271,
	"./zenclerk_s/directives/conversion_tag_checker/conversion_tag_aishipr.html": 1323,
	"./zenclerk_s/directives/conversion_tag_checker/conversion_tag_checker": 272,
	"./zenclerk_s/directives/conversion_tag_checker/conversion_tag_checker.html": 1324,
	"./zenclerk_s/directives/conversion_tag_checker/conversion_tag_checker.js": 272,
	"./zenclerk_s/directives/conversion_tag_checker/conversion_tag_checker.scss": 913,
	"./zenclerk_s/directives/conversion_tag_checker/conversion_tag_ebisumart.html": 1325,
	"./zenclerk_s/directives/conversion_tag_checker/conversion_tag_ecbeing.html": 1326,
	"./zenclerk_s/directives/conversion_tag_checker/conversion_tag_futureshop2.html": 1327,
	"./zenclerk_s/directives/conversion_tag_checker/conversion_tag_integration_brief.html": 1328,
	"./zenclerk_s/directives/conversion_tag_checker/conversion_tag_makeshop.html": 1329,
	"./zenclerk_s/directives/conversion_tag_checker/conversion_tag_other_deemed.html": 1330,
	"./zenclerk_s/directives/conversion_tag_checker/conversion_tag_other_normal.html": 1331,
	"./zenclerk_s/directives/conversion_tag_checker/conversion_tag_shopify.html": 1332,
	"./zenclerk_s/directives/conversion_tag_checker/conversion_tag_shopserve.html": 1333,
	"./zenclerk_s/directives/dashboard/active_campaigns_widget": 273,
	"./zenclerk_s/directives/dashboard/active_campaigns_widget.html": 1334,
	"./zenclerk_s/directives/dashboard/active_campaigns_widget.js": 273,
	"./zenclerk_s/directives/dashboard/conversion_chart_widget": 274,
	"./zenclerk_s/directives/dashboard/conversion_chart_widget.html": 1335,
	"./zenclerk_s/directives/dashboard/conversion_chart_widget.js": 274,
	"./zenclerk_s/directives/dashboard/conversion_chart_widget.scss": 914,
	"./zenclerk_s/directives/dashboard/cumulative_conversion_widget": 275,
	"./zenclerk_s/directives/dashboard/cumulative_conversion_widget.html": 1336,
	"./zenclerk_s/directives/dashboard/cumulative_conversion_widget.js": 275,
	"./zenclerk_s/directives/dashboard/cumulative_conversion_widget.scss": 915,
	"./zenclerk_s/directives/dashboard/top_items_widget": 276,
	"./zenclerk_s/directives/dashboard/top_items_widget.html": 1337,
	"./zenclerk_s/directives/dashboard/top_items_widget.js": 276,
	"./zenclerk_s/directives/dashboard/top_pages_widget": 277,
	"./zenclerk_s/directives/dashboard/top_pages_widget.html": 1338,
	"./zenclerk_s/directives/dashboard/top_pages_widget.js": 277,
	"./zenclerk_s/directives/dashboard/top_referrers_widget": 278,
	"./zenclerk_s/directives/dashboard/top_referrers_widget.html": 1339,
	"./zenclerk_s/directives/dashboard/top_referrers_widget.js": 278,
	"./zenclerk_s/directives/dashboard/widget": 279,
	"./zenclerk_s/directives/dashboard/widget.html": 1340,
	"./zenclerk_s/directives/dashboard/widget.js": 279,
	"./zenclerk_s/directives/dashboard/widget.scss": 916,
	"./zenclerk_s/directives/estimated_revenue/estimated_revenue": 280,
	"./zenclerk_s/directives/estimated_revenue/estimated_revenue.html": 1341,
	"./zenclerk_s/directives/estimated_revenue/estimated_revenue.js": 280,
	"./zenclerk_s/directives/estimated_revenue/estimated_revenue.scss": 917,
	"./zenclerk_s/directives/exclude_ip_editor/exclude_ip_editor": 281,
	"./zenclerk_s/directives/exclude_ip_editor/exclude_ip_editor.html": 1342,
	"./zenclerk_s/directives/exclude_ip_editor/exclude_ip_editor.js": 281,
	"./zenclerk_s/directives/exclude_ip_editor/exclude_ip_editor.scss": 918,
	"./zenclerk_s/directives/exclude_ip_editor/exclude_ip_form": 282,
	"./zenclerk_s/directives/exclude_ip_editor/exclude_ip_form.html": 1343,
	"./zenclerk_s/directives/exclude_ip_editor/exclude_ip_form.js": 282,
	"./zenclerk_s/directives/exclude_page_editor/exclude_page_editor": 283,
	"./zenclerk_s/directives/exclude_page_editor/exclude_page_editor.html": 1344,
	"./zenclerk_s/directives/exclude_page_editor/exclude_page_editor.js": 283,
	"./zenclerk_s/directives/exclude_page_editor/exclude_page_editor.scss": 919,
	"./zenclerk_s/directives/exclude_page_editor/exclude_page_form": 284,
	"./zenclerk_s/directives/exclude_page_editor/exclude_page_form.html": 1345,
	"./zenclerk_s/directives/exclude_page_editor/exclude_page_form.js": 284,
	"./zenclerk_s/directives/fully_supported_asp_only/fully_supported_asp_only.directive": 285,
	"./zenclerk_s/directives/fully_supported_asp_only/fully_supported_asp_only.directive.js": 285,
	"./zenclerk_s/directives/help/launcher": 286,
	"./zenclerk_s/directives/help/launcher.html": 1346,
	"./zenclerk_s/directives/help/launcher.js": 286,
	"./zenclerk_s/directives/help/launcher.scss": 920,
	"./zenclerk_s/directives/hide_when_production/hide_when_production": 287,
	"./zenclerk_s/directives/hide_when_production/hide_when_production.js": 287,
	"./zenclerk_s/directives/makerepeater_only/makerepeater_only.directive": 288,
	"./zenclerk_s/directives/makerepeater_only/makerepeater_only.directive.js": 288,
	"./zenclerk_s/directives/master_only/master_only.directive": 289,
	"./zenclerk_s/directives/master_only/master_only.directive.js": 289,
	"./zenclerk_s/directives/notification/notification-alert": 290,
	"./zenclerk_s/directives/notification/notification-alert.html": 1347,
	"./zenclerk_s/directives/notification/notification-alert.js": 290,
	"./zenclerk_s/directives/notification/notification-panel": 291,
	"./zenclerk_s/directives/notification/notification-panel.html": 1348,
	"./zenclerk_s/directives/notification/notification-panel.js": 291,
	"./zenclerk_s/directives/notification/notification.scss": 921,
	"./zenclerk_s/directives/notification/timezone": 292,
	"./zenclerk_s/directives/notification/timezone.html": 1349,
	"./zenclerk_s/directives/notification/timezone.js": 292,
	"./zenclerk_s/directives/profile/profile.html": 1350,
	"./zenclerk_s/directives/profile/profile.scss": 922,
	"./zenclerk_s/directives/profile/zcs_profile.directive": 293,
	"./zenclerk_s/directives/profile/zcs_profile.directive.js": 293,
	"./zenclerk_s/directives/project/free_shipping_cost_editor/free_shipping_cost_editor.controller": 294,
	"./zenclerk_s/directives/project/free_shipping_cost_editor/free_shipping_cost_editor.controller.js": 294,
	"./zenclerk_s/directives/project/free_shipping_cost_editor/free_shipping_cost_editor.html": 1351,
	"./zenclerk_s/directives/project_user_activity/user_activity.directive": 295,
	"./zenclerk_s/directives/project_user_activity/user_activity.directive.js": 295,
	"./zenclerk_s/directives/project_user_activity/user_activity.html": 1352,
	"./zenclerk_s/directives/project_user_activity/user_activity.scss": 923,
	"./zenclerk_s/directives/project_user_activity/user_activity_graph.directive": 296,
	"./zenclerk_s/directives/project_user_activity/user_activity_graph.directive.js": 296,
	"./zenclerk_s/directives/project_user_activity/user_activity_graph.html": 1353,
	"./zenclerk_s/directives/projects_in_installation/projects_in_installation.component": 297,
	"./zenclerk_s/directives/projects_in_installation/projects_in_installation.component.js": 297,
	"./zenclerk_s/directives/projects_in_installation/projects_in_installation.html": 1354,
	"./zenclerk_s/directives/projects_in_installation/projects_in_installation.scss": 924,
	"./zenclerk_s/directives/projects_without_campaign/projects_without_campaign.directive": 298,
	"./zenclerk_s/directives/projects_without_campaign/projects_without_campaign.directive.js": 298,
	"./zenclerk_s/directives/projects_without_campaign/projects_without_campaign.html": 1355,
	"./zenclerk_s/directives/realtime/bar-chart": 299,
	"./zenclerk_s/directives/realtime/bar-chart.html": 1356,
	"./zenclerk_s/directives/realtime/bar-chart.js": 299,
	"./zenclerk_s/directives/realtime/bar-chart.scss": 925,
	"./zenclerk_s/directives/realtime_visitor_visualizer/realtime_visitor_visualizer": 300,
	"./zenclerk_s/directives/realtime_visitor_visualizer/realtime_visitor_visualizer.html": 1357,
	"./zenclerk_s/directives/realtime_visitor_visualizer/realtime_visitor_visualizer.js": 300,
	"./zenclerk_s/directives/realtime_visitor_visualizer/realtime_visitor_visualizer.scss": 926,
	"./zenclerk_s/directives/service_name/service_name": 301,
	"./zenclerk_s/directives/service_name/service_name.js": 301,
	"./zenclerk_s/directives/svg_embed/svg_embed": 302,
	"./zenclerk_s/directives/svg_embed/svg_embed.js": 302,
	"./zenclerk_s/directives/tracking_tag_checker/tracking_tag_checker": 303,
	"./zenclerk_s/directives/tracking_tag_checker/tracking_tag_checker.html": 1358,
	"./zenclerk_s/directives/tracking_tag_checker/tracking_tag_checker.js": 303,
	"./zenclerk_s/directives/tracking_tag_checker/tracking_tag_checker.scss": 927,
	"./zenclerk_s/directives/zcs_hide_when_integrated/zcs_hide_when_integrated.directive": 304,
	"./zenclerk_s/directives/zcs_hide_when_integrated/zcs_hide_when_integrated.directive.js": 304,
	"./zenclerk_s/directives/zcs_hide_when_integrated/zcs_hide_when_integrated.scss": 928,
	"./zenclerk_s/directives/zcs_hide_when_oem/zcs_hide_when_oem.directive": 305,
	"./zenclerk_s/directives/zcs_hide_when_oem/zcs_hide_when_oem.directive.js": 305,
	"./zenclerk_s/directives/zcs_invoice_note/zcs_invoice_note": 306,
	"./zenclerk_s/directives/zcs_invoice_note/zcs_invoice_note.html": 1359,
	"./zenclerk_s/directives/zcs_invoice_note/zcs_invoice_note.js": 306,
	"./zenclerk_s/directives/zcs_maintenance/zcs_maintenance": 307,
	"./zenclerk_s/directives/zcs_maintenance/zcs_maintenance.html": 1360,
	"./zenclerk_s/directives/zcs_maintenance/zcs_maintenance.js": 307,
	"./zenclerk_s/directives/zcs_maintenance/zcs_maintenance.scss": 929,
	"./zenclerk_s/directives/zcs_tag_unset/zcs_tag_unset": 308,
	"./zenclerk_s/directives/zcs_tag_unset/zcs_tag_unset.html": 1361,
	"./zenclerk_s/directives/zcs_tag_unset/zcs_tag_unset.js": 308,
	"./zenclerk_s/directives/zcs_tag_unset/zcs_tag_unset.scss": 930,
	"./zenclerk_s/home/home.controller": 309,
	"./zenclerk_s/home/home.controller.js": 309,
	"./zenclerk_s/home/home.html": 1362,
	"./zenclerk_s/home/home.scss": 931,
	"./zenclerk_s/index": 113,
	"./zenclerk_s/index.js": 113,
	"./zenclerk_s/layout/footer": 310,
	"./zenclerk_s/layout/footer.html": 1363,
	"./zenclerk_s/layout/footer.js": 310,
	"./zenclerk_s/layout/footer.scss": 932,
	"./zenclerk_s/layout/header": 311,
	"./zenclerk_s/layout/header.html": 1364,
	"./zenclerk_s/layout/header.js": 311,
	"./zenclerk_s/layout/layout.directive": 312,
	"./zenclerk_s/layout/layout.directive.js": 312,
	"./zenclerk_s/layout/layout.html": 1365,
	"./zenclerk_s/layout/layout.scss": 933,
	"./zenclerk_s/layout/layout_header+main.html": 1366,
	"./zenclerk_s/layout/layout_main+sidebar-left.html": 1367,
	"./zenclerk_s/layout/layout_main.html": 1368,
	"./zenclerk_s/layout/layout_tos_header+main.html": 1369,
	"./zenclerk_s/layout/layout_tos_header+main.scss": 934,
	"./zenclerk_s/layout/main": 313,
	"./zenclerk_s/layout/main.html": 1370,
	"./zenclerk_s/layout/main.js": 313,
	"./zenclerk_s/layout/menu_setup.directive": 314,
	"./zenclerk_s/layout/menu_setup.directive.js": 314,
	"./zenclerk_s/layout/menu_setup.html": 1371,
	"./zenclerk_s/layout/menu_setup.scss": 935,
	"./zenclerk_s/layout/sidebar.directive": 315,
	"./zenclerk_s/layout/sidebar.directive.js": 315,
	"./zenclerk_s/layout/sidebar.html": 1372,
	"./zenclerk_s/routes": 316,
	"./zenclerk_s/routes.js": 316,
	"./zenclerk_s/setup/setup_user.controller": 317,
	"./zenclerk_s/setup/setup_user.controller.js": 317,
	"./zenclerk_s/setup/setup_user.html": 1373,
	"./zenclerk_s/sites/activity/navigation.html": 1374,
	"./zenclerk_s/sites/activity/realtime/realtime.html": 1375,
	"./zenclerk_s/sites/activity/realtime/realtime.scss": 936,
	"./zenclerk_s/sites/analytics/analytics.component": 318,
	"./zenclerk_s/sites/analytics/analytics.component.js": 318,
	"./zenclerk_s/sites/analytics/analytics.html": 1376,
	"./zenclerk_s/sites/analytics/analytics.scss": 937,
	"./zenclerk_s/sites/campaigns/campaign_navigation.controller": 319,
	"./zenclerk_s/sites/campaigns/campaign_navigation.controller.js": 319,
	"./zenclerk_s/sites/campaigns/campaign_navigation.html": 1377,
	"./zenclerk_s/sites/campaigns/coupon/history": 320,
	"./zenclerk_s/sites/campaigns/coupon/history.html": 1378,
	"./zenclerk_s/sites/campaigns/coupon/history.js": 320,
	"./zenclerk_s/sites/campaigns/coupon/history.scss": 938,
	"./zenclerk_s/sites/campaigns/create_button/campaign_confirm_modal.controller": 321,
	"./zenclerk_s/sites/campaigns/create_button/campaign_confirm_modal.controller.js": 321,
	"./zenclerk_s/sites/campaigns/create_button/campaign_confirm_modal.html": 1379,
	"./zenclerk_s/sites/campaigns/create_button/campaign_create_button.directive": 322,
	"./zenclerk_s/sites/campaigns/create_button/campaign_create_button.directive.js": 322,
	"./zenclerk_s/sites/campaigns/create_button/campaign_create_button.html": 1380,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit": 323,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit.html": 1381,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit.js": 323,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit.scss": 939,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_modal_conversion_price.controller": 324,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_modal_conversion_price.controller.js": 324,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_modal_conversion_price.html": 1382,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_modal_exit.controller": 325,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_modal_exit.controller.js": 325,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_modal_exit.html": 1383,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_modal_launch.controller": 326,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_modal_launch.controller.js": 326,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_modal_launch.html": 1384,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_modal_launch.scss": 940,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_confirm": 327,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_confirm.html": 1385,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_confirm.js": 327,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_confirm.scss": 941,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_coupon": 328,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_coupon.html": 1386,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_coupon.js": 328,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_coupon.scss": 942,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_delivery": 329,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_delivery.html": 1387,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_delivery.js": 329,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_delivery.scss": 943,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_design": 330,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_design.html": 1388,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_design.js": 330,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_design.scss": 944,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_schedule": 331,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_schedule.html": 1389,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_schedule.js": 331,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_schedule.scss": 945,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_segment": 332,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_segment.html": 1390,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_segment.js": 332,
	"./zenclerk_s/sites/campaigns/edit/campaign_edit_step_segment.scss": 946,
	"./zenclerk_s/sites/campaigns/edit/instruction_ec_cube.html": 1391,
	"./zenclerk_s/sites/campaigns/edit/instruction_futureshop2.html": 1392,
	"./zenclerk_s/sites/campaigns/edit/instruction_makeshop.html": 1393,
	"./zenclerk_s/sites/campaigns/edit/instruction_makeshop_integration.html": 1394,
	"./zenclerk_s/sites/campaigns/edit/instruction_shopify.html": 1395,
	"./zenclerk_s/sites/campaigns/edit/instruction_shopserve.html": 1396,
	"./zenclerk_s/sites/campaigns/integrated_coupon/list": 333,
	"./zenclerk_s/sites/campaigns/integrated_coupon/list.html": 1397,
	"./zenclerk_s/sites/campaigns/integrated_coupon/list.js": 333,
	"./zenclerk_s/sites/campaigns/list/campaigns_list.controller": 334,
	"./zenclerk_s/sites/campaigns/list/campaigns_list.controller.js": 334,
	"./zenclerk_s/sites/campaigns/list/campaigns_list.directive": 335,
	"./zenclerk_s/sites/campaigns/list/campaigns_list.directive.js": 335,
	"./zenclerk_s/sites/campaigns/list/campaigns_list.html": 1398,
	"./zenclerk_s/sites/campaigns/list/item.directive": 336,
	"./zenclerk_s/sites/campaigns/list/item.directive.js": 336,
	"./zenclerk_s/sites/campaigns/list/item.html": 1399,
	"./zenclerk_s/sites/campaigns/list/item.scss": 947,
	"./zenclerk_s/sites/campaigns/list/list.html": 1400,
	"./zenclerk_s/sites/campaigns/list/list.scss": 948,
	"./zenclerk_s/sites/campaigns/mail_mag_url_modal.controller": 337,
	"./zenclerk_s/sites/campaigns/mail_mag_url_modal.controller.js": 337,
	"./zenclerk_s/sites/campaigns/mail_mag_url_modal.html": 1401,
	"./zenclerk_s/sites/campaigns/preview_link_modal.controller": 338,
	"./zenclerk_s/sites/campaigns/preview_link_modal.controller.js": 338,
	"./zenclerk_s/sites/campaigns/preview_link_modal.html": 1402,
	"./zenclerk_s/sites/campaigns/preview_link_modal.scss": 949,
	"./zenclerk_s/sites/campaigns/show/summary.component": 339,
	"./zenclerk_s/sites/campaigns/show/summary.component.js": 339,
	"./zenclerk_s/sites/campaigns/show/summary.html": 1403,
	"./zenclerk_s/sites/campaigns/show/summary.scss": 950,
	"./zenclerk_s/sites/dashboard/dashboard-main.component": 340,
	"./zenclerk_s/sites/dashboard/dashboard-main.component.js": 340,
	"./zenclerk_s/sites/dashboard/dashboard-main.html": 1404,
	"./zenclerk_s/sites/dashboard/dashboard.html": 1405,
	"./zenclerk_s/sites/dashboard/dashboard.scss": 951,
	"./zenclerk_s/sites/dashboard/navigation.html": 1406,
	"./zenclerk_s/sites/dashboard/no-data-overlay.component": 341,
	"./zenclerk_s/sites/dashboard/no-data-overlay.component.js": 341,
	"./zenclerk_s/sites/dashboard/no-data-overlay.scss": 952,
	"./zenclerk_s/sites/dashboard/set-tag-button": 342,
	"./zenclerk_s/sites/dashboard/set-tag-button.css": 895,
	"./zenclerk_s/sites/dashboard/set-tag-button.html": 1407,
	"./zenclerk_s/sites/dashboard/set-tag-button.js": 342,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-campaign-list-title.component": 343,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-campaign-list-title.component.js": 343,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-campaign-list-title.html": 1408,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-campaign-list.component": 344,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-campaign-list.component.js": 344,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-campaign-list.html": 1409,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-create-first-campaign.component": 345,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-create-first-campaign.component.js": 345,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-create-first-campaign.html": 1410,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-no-active-campaign.component": 346,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-no-active-campaign.component.js": 346,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-no-active-campaign.html": 1411,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-realtime.component": 347,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-realtime.component.js": 347,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-realtime.html": 1412,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-site-status.component": 348,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-site-status.component.js": 348,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-site-status.html": 1413,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-tag-setup.component": 349,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-tag-setup.component.js": 349,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-tag-setup.html": 1414,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-test.component": 350,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-test.component.js": 350,
	"./zenclerk_s/sites/dashboard/widgets/dashboard-widget-test.html": 1415,
	"./zenclerk_s/sites/interest_widget/interest_widget_navigation.controller": 351,
	"./zenclerk_s/sites/interest_widget/interest_widget_navigation.controller.js": 351,
	"./zenclerk_s/sites/interest_widget/interest_widget_navigation.html": 1416,
	"./zenclerk_s/sites/interest_widget/interest_widget_results": 352,
	"./zenclerk_s/sites/interest_widget/interest_widget_results.html": 1417,
	"./zenclerk_s/sites/interest_widget/interest_widget_results.js": 352,
	"./zenclerk_s/sites/interest_widget/interest_widget_results.scss": 953,
	"./zenclerk_s/sites/interest_widget/interest_widget_settings": 353,
	"./zenclerk_s/sites/interest_widget/interest_widget_settings.html": 1418,
	"./zenclerk_s/sites/interest_widget/interest_widget_settings.js": 353,
	"./zenclerk_s/sites/interest_widget/interest_widget_settings.scss": 954,
	"./zenclerk_s/sites/invoices/edit/index.html": 1419,
	"./zenclerk_s/sites/invoices/edit/invoice_edit.controller": 354,
	"./zenclerk_s/sites/invoices/edit/invoice_edit.controller.js": 354,
	"./zenclerk_s/sites/invoices/list/invoices.controller": 355,
	"./zenclerk_s/sites/invoices/list/invoices.controller.js": 355,
	"./zenclerk_s/sites/invoices/list/invoices_list.html": 1420,
	"./zenclerk_s/sites/invoices/navigation.html": 1421,
	"./zenclerk_s/sites/invoices/show/invoice.html": 1422,
	"./zenclerk_s/sites/invoices/show/invoice.scss": 955,
	"./zenclerk_s/sites/invoices/show/invoice_show.controller": 356,
	"./zenclerk_s/sites/invoices/show/invoice_show.controller.js": 356,
	"./zenclerk_s/sites/invoices/show/zcs_deemed_invoice.directive": 357,
	"./zenclerk_s/sites/invoices/show/zcs_deemed_invoice.directive.js": 357,
	"./zenclerk_s/sites/invoices/show/zcs_deemed_invoice.html": 1423,
	"./zenclerk_s/sites/invoices/show/zcs_invoice.directive": 358,
	"./zenclerk_s/sites/invoices/show/zcs_invoice.directive.js": 358,
	"./zenclerk_s/sites/invoices/show/zcs_invoice.html": 1424,
	"./zenclerk_s/sites/invoices/show/zcs_old_deemed_invoice.directive": 359,
	"./zenclerk_s/sites/invoices/show/zcs_old_deemed_invoice.directive.js": 359,
	"./zenclerk_s/sites/invoices/show/zcs_old_deemed_invoice.html": 1425,
	"./zenclerk_s/sites/list.html": 1426,
	"./zenclerk_s/sites/reports/show/report_show.controller": 360,
	"./zenclerk_s/sites/reports/show/report_show.controller.js": 360,
	"./zenclerk_s/sites/reports/show/report_show.html": 1427,
	"./zenclerk_s/sites/reports/show/report_show.scss": 956,
	"./zenclerk_s/sites/reports/show/zcs_monthly_report.directive": 361,
	"./zenclerk_s/sites/reports/show/zcs_monthly_report.directive.js": 361,
	"./zenclerk_s/sites/reports/show/zcs_monthly_report.html": 1428,
	"./zenclerk_s/sites/settings/navigation.html": 1429,
	"./zenclerk_s/sites/settings/project_billings": 362,
	"./zenclerk_s/sites/settings/project_billings.html": 1430,
	"./zenclerk_s/sites/settings/project_billings.js": 362,
	"./zenclerk_s/sites/settings/project_settings": 363,
	"./zenclerk_s/sites/settings/project_settings.html": 1431,
	"./zenclerk_s/sites/settings/project_settings.js": 363,
	"./zenclerk_s/sites/settings/project_settings.scss": 957,
	"./zenclerk_s/sites/settings/site_logo_image.controller": 364,
	"./zenclerk_s/sites/settings/site_logo_image.controller.js": 364,
	"./zenclerk_s/sites/setup/setup.controller": 365,
	"./zenclerk_s/sites/setup/setup.controller.js": 365,
	"./zenclerk_s/sites/setup/setup.html": 1432,
	"./zenclerk_s/sites/setup/setup.scss": 958,
	"./zenclerk_s/sites/setup/setup_company.controller": 366,
	"./zenclerk_s/sites/setup/setup_company.controller.js": 366,
	"./zenclerk_s/sites/setup/setup_company.html": 1433,
	"./zenclerk_s/sites/setup/setup_complete.html": 1434,
	"./zenclerk_s/sites/setup/setup_conversion_tag.controller": 367,
	"./zenclerk_s/sites/setup/setup_conversion_tag.controller.js": 367,
	"./zenclerk_s/sites/setup/setup_conversion_tag.html": 1435,
	"./zenclerk_s/sites/setup/setup_pricing.controller": 368,
	"./zenclerk_s/sites/setup/setup_pricing.controller.js": 368,
	"./zenclerk_s/sites/setup/setup_pricing.html": 1436,
	"./zenclerk_s/sites/setup/setup_pricing.scss": 959,
	"./zenclerk_s/sites/setup/setup_site.controller": 369,
	"./zenclerk_s/sites/setup/setup_site.controller.js": 369,
	"./zenclerk_s/sites/setup/setup_site.html": 1437,
	"./zenclerk_s/sites/setup/setup_tracking_tag.controller": 370,
	"./zenclerk_s/sites/setup/setup_tracking_tag.controller.js": 370,
	"./zenclerk_s/sites/setup/setup_tracking_tag.html": 1438,
	"./zenclerk_s/sites/site_navigation.controller": 371,
	"./zenclerk_s/sites/site_navigation.controller.js": 371,
	"./zenclerk_s/sites/site_navigation.html": 1439,
	"./zenclerk_s/sites/stats/list.html": 1440,
	"./zenclerk_s/sites/stats/player.directive": 372,
	"./zenclerk_s/sites/stats/player.directive.js": 372,
	"./zenclerk_s/sites/stats/site_stats_show.controller": 373,
	"./zenclerk_s/sites/stats/site_stats_show.controller.js": 373,
	"./zenclerk_s/sites/stats/site_stats_show.html": 1441,
	"./zenclerk_s/sites/stats/site_stats_show.scss": 960,
	"./zenclerk_s/sites/tags/site_tags.controller": 374,
	"./zenclerk_s/sites/tags/site_tags.controller.js": 374,
	"./zenclerk_s/sites/tags/site_tags.html": 1442,
	"./zenclerk_s/sites/terminated/terminated.component": 375,
	"./zenclerk_s/sites/terminated/terminated.component.js": 375,
	"./zenclerk_s/sites/terminated/terminated.html": 1443,
	"./zenclerk_s/sites/terminated/terminated.scss": 961,
	"./zenclerk_s/sites/users/list.html": 1444,
	"./zenclerk_s/sites/users/project_user.controller": 376,
	"./zenclerk_s/sites/users/project_user.controller.js": 376,
	"./zenclerk_s/users/invitation/accept.html": 1445,
	"./zenclerk_s/users/invitation/accept_invitation.controller": 377,
	"./zenclerk_s/users/invitation/accept_invitation.controller.js": 377,
	"./zenclerk_s/users/reset_password/reset_password.controller": 378,
	"./zenclerk_s/users/reset_password/reset_password.controller.js": 378,
	"./zenclerk_s/users/reset_password/reset_password.html": 1446,
	"./zenclerk_s/users/sign_in/sign_in.html": 1447,
	"./zenclerk_s/users/sign_in/sign_in.scss": 962,
	"./zenclerk_s/users/sign_in/users_sign_in.controller": 379,
	"./zenclerk_s/users/sign_in/users_sign_in.controller.js": 379
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1453;

/***/ }),
/* 1454 */,
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(559);


/***/ })
]),[1455]);


// WEBPACK FOOTER //
// zenclerk_s.bundle.js